module.exports = {
	"10200411": [
		[
			"2000-02-02",
			3.54
		],
		[
			"2001-07-18",
			7.09
		],
		[
			"2002-05-29",
			4.43
		],
		[
			"2003-08-14",
			8.86
		],
		[
			"2004-01-15",
			10.63
		],
		[
			"2005-06-28",
			6.64
		],
		[
			"2006-03-13",
			7.09
		],
		[
			"2007-02-14",
			5.98
		],
		[
			"2008-07-10",
			7.79
		],
		[
			"2013-06-24",
			8.41
		],
		[
			"2014-06-12",
			12.09
		],
		[
			"2015-03-19",
			5.93
		],
		[
			"2010-04-12",
			5.4
		],
		[
			"2011-12-09",
			9.7
		],
		[
			"2012-06-22",
			10.76
		]
	],
	"10200691": [
		[
			"2000-02-23",
			27.46
		],
		[
			"2001-03-13",
			54.91
		],
		[
			"2002-05-02",
			56.24
		],
		[
			"2003-04-10",
			31.44
		],
		[
			"2004-01-08",
			59.79
		],
		[
			"2005-06-28",
			53.14
		],
		[
			"2006-02-24",
			45.17
		],
		[
			"2007-01-04",
			41.89
		],
		[
			"2008-07-08",
			41.23
		],
		[
			"2013-06-10",
			81.49
		],
		[
			"2014-04-09",
			77.5
		],
		[
			"2015-04-23",
			110.27
		],
		[
			"2010-06-11",
			62.44
		],
		[
			"2011-11-14",
			79.71
		],
		[
			"2012-11-16",
			63.77
		]
	],
	"10200710": [
		[
			"2000-05-24",
			0.44
		],
		[
			"2001-07-23",
			0.44
		],
		[
			"2002-06-17",
			0.44
		],
		[
			"2004-04-28",
			0.44
		],
		[
			"2005-07-11",
			0.44
		],
		[
			"2006-10-27",
			0.84
		],
		[
			"2008-03-27",
			0.44
		],
		[
			"2013-09-16",
			1.33
		],
		[
			"2014-08-14",
			0.13
		],
		[
			"2015-05-13",
			1.33
		],
		[
			"2010-12-10",
			0.13
		],
		[
			"2011-02-14",
			0.13
		],
		[
			"2012-04-20",
			0.13
		]
	],
	"10201026": [
		[
			"2000-02-23",
			22.59
		],
		[
			"2001-03-13",
			8.41
		],
		[
			"2002-03-08",
			10.63
		],
		[
			"2003-04-02",
			10.19
		],
		[
			"2004-01-07",
			13.29
		],
		[
			"2005-04-01",
			19.49
		],
		[
			"2006-02-22",
			21.7
		],
		[
			"2007-02-13",
			19.88
		],
		[
			"2008-03-26",
			10.63
		],
		[
			"2013-09-27",
			11.51
		],
		[
			"2014-03-10",
			7.17
		],
		[
			"2015-05-06",
			20.64
		],
		[
			"2009-07-20",
			12.71
		],
		[
			"2011-01-31",
			14.97
		],
		[
			"2012-11-16",
			11.03
		]
	],
	"10201117": [
		[
			"2000-02-29",
			53.14
		],
		[
			"2001-08-08",
			54.47
		],
		[
			"2002-03-08",
			54.47
		],
		[
			"2003-12-11",
			58.01
		],
		[
			"2004-01-21",
			57.13
		],
		[
			"2005-07-15",
			61.11
		],
		[
			"2006-03-13",
			63.33
		],
		[
			"2007-01-03",
			67.76
		],
		[
			"2008-03-26",
			62.44
		],
		[
			"2010-09-07",
			61.22
		],
		[
			"2011-05-05",
			54.22
		],
		[
			"2012-10-08",
			61.82
		],
		[
			"2013-04-29",
			60.72
		],
		[
			"2014-11-26",
			64.02
		],
		[
			"2015-05-11",
			66.02
		],
		[
			"2013-06-10",
			62
		],
		[
			"2014-06-12",
			61.56
		],
		[
			"2015-03-19",
			65.54
		],
		[
			"2009-07-20",
			60.23
		],
		[
			"2011-01-31",
			56.24
		],
		[
			"2012-06-22",
			60.23
		]
	],
	"10201282": [
		[
			"2000-08-07",
			22.94
		],
		[
			"2001-04-26",
			19.04
		],
		[
			"2002-09-24",
			35.87
		],
		[
			"2003-08-18",
			46.94
		],
		[
			"2004-01-23",
			52.26
		],
		[
			"2005-07-06",
			37.64
		],
		[
			"2007-01-10",
			32.15
		],
		[
			"2013-04-15",
			51.37
		],
		[
			"2014-03-10",
			57.13
		],
		[
			"2015-05-13",
			47.39
		],
		[
			"2016-03-17",
			66.43
		],
		[
			"2006-03-23",
			31.44
		],
		[
			"2008-07-15",
			7.93
		],
		[
			"2009-05-15",
			35.52
		],
		[
			"2011-01-28",
			81.93
		],
		[
			"2012-03-30",
			69.97
		]
	],
	"10201312": [
		[
			"2000-11-03",
			75.29
		],
		[
			"2001-07-23",
			81.93
		],
		[
			"2002-09-25",
			119.57
		],
		[
			"2003-03-27",
			54.03
		],
		[
			"2004-03-05",
			11.96
		],
		[
			"2005-07-11",
			25.24
		],
		[
			"2007-01-10",
			50.49
		],
		[
			"2013-06-28",
			102.3
		],
		[
			"2013-08-09",
			107.17
		],
		[
			"2014-02-03",
			94.77
		],
		[
			"2015-03-16",
			67.31
		],
		[
			"2006-03-22",
			84.59
		],
		[
			"2008-07-14",
			89.01
		],
		[
			"2009-11-06",
			74.84
		],
		[
			"2011-01-28",
			58.01
		],
		[
			"2012-03-19",
			82.37
		]
	],
	"10201415": [
		[
			"2001-10-16",
			84.63
		],
		[
			"2001-04-10",
			88.53
		],
		[
			"2002-04-16",
			89.93
		],
		[
			"2002-10-15",
			87.23
		],
		[
			"2000-10-17",
			75.33
		],
		[
			"2000-04-12",
			78.23
		],
		[
			"2004-10-19",
			77.53
		],
		[
			"2004-04-06",
			18.31
		],
		[
			"2005-04-11",
			77.53
		],
		[
			"2005-10-26",
			67.72
		],
		[
			"2006-04-04",
			72.23
		],
		[
			"2006-11-07",
			68.22
		],
		[
			"2007-10-22",
			56.72
		],
		[
			"2010-10-11",
			73.07
		],
		[
			"2011-04-26",
			74.4
		],
		[
			"2011-10-10",
			75.73
		],
		[
			"2012-04-24",
			76.61
		],
		[
			"2012-10-22",
			77.06
		],
		[
			"2013-04-08",
			77.94
		],
		[
			"2013-10-28",
			79.27
		],
		[
			"2014-04-14",
			80.16
		],
		[
			"2014-10-29",
			79.71
		],
		[
			"2015-04-07",
			79.71
		],
		[
			"2015-10-06",
			77.06
		],
		[
			"2013-04-15",
			77.06
		],
		[
			"2014-03-27",
			81.93
		],
		[
			"2008-04-14",
			72.23
		],
		[
			"2010-07-02",
			73.07
		],
		[
			"2011-02-14",
			35.38
		],
		[
			"2012-04-20",
			76.17
		]
	],
	"10201518": [
		[
			"2000-05-25",
			65.54
		],
		[
			"2001-04-23",
			46.94
		],
		[
			"2002-06-19",
			46.94
		],
		[
			"2003-11-24",
			63.77
		],
		[
			"2005-03-21",
			65.54
		],
		[
			"2004-03-16",
			77.06
		],
		[
			"2006-02-16",
			80.6
		],
		[
			"2007-02-26",
			33.75
		],
		[
			"2008-07-07",
			43.18
		],
		[
			"2013-09-09",
			66.43
		],
		[
			"2014-05-08",
			72.63
		],
		[
			"2015-10-15",
			73.96
		],
		[
			"2009-11-06",
			34.32
		],
		[
			"2011-10-10",
			23.47
		],
		[
			"2012-06-18",
			86.36
		]
	],
	"10201531": [
		[
			"2005-05-19",
			86.36
		],
		[
			"2000-01-14",
			49.12
		],
		[
			"2001-03-13",
			53.62
		],
		[
			"2001-09-20",
			59.82
		],
		[
			"2002-02-25",
			68.62
		],
		[
			"2002-09-09",
			66.02
		],
		[
			"2003-05-13",
			64.62
		],
		[
			"2003-09-25",
			70.42
		],
		[
			"2004-02-26",
			71.33
		],
		[
			"2004-10-04",
			76.63
		],
		[
			"2005-04-25",
			75.33
		],
		[
			"2006-02-14",
			79.73
		],
		[
			"2006-08-31",
			90.34
		],
		[
			"2006-07-24",
			86.33
		],
		[
			"2007-01-10",
			91.23
		],
		[
			"2007-02-02",
			90.33
		],
		[
			"2008-07-15",
			98.76
		],
		[
			"2013-04-15",
			115.14
		],
		[
			"2013-08-28",
			137.29
		],
		[
			"2014-02-24",
			115.14
		],
		[
			"2015-03-16",
			15.19
		],
		[
			"2007-10-01",
			91.63
		],
		[
			"2008-06-23",
			87.23
		],
		[
			"2010-01-29",
			105.4
		],
		[
			"2010-03-19",
			112.49
		],
		[
			"2011-04-01",
			118.24
		],
		[
			"2012-06-01",
			108.5
		]
	],
	"10202201": [
		[
			"2014-08-18",
			19.62
		],
		[
			"2015-05-20",
			27.68
		],
		[
			"2012-11-09",
			22.41
		]
	],
	"10202330": [
		[
			"2010-09-07",
			6
		],
		[
			"2011-05-05",
			56.42
		],
		[
			"2012-10-08",
			13.1
		],
		[
			"2013-04-29",
			26.01
		],
		[
			"2014-11-26",
			40.01
		],
		[
			"2015-10-05",
			1
		]
	],
	"10202341": [
		[
			"2010-09-07",
			31.71
		],
		[
			"2011-05-05",
			25.51
		],
		[
			"2012-10-08",
			15.51
		],
		[
			"2013-04-29",
			62.62
		],
		[
			"2014-11-26",
			0.5
		],
		[
			"2015-05-11",
			38.01
		]
	],
	"10202663": [
		[
			"2010-09-07",
			69.42
		],
		[
			"2011-05-05",
			66.92
		],
		[
			"2012-10-08",
			68.12
		],
		[
			"2013-04-29",
			67.42
		],
		[
			"2014-11-26",
			45.02
		],
		[
			"2015-05-11",
			61.02
		]
	],
	"10202675": [
		[
			"2010-09-07",
			28.81
		],
		[
			"2011-05-05",
			30.21
		],
		[
			"2012-10-08",
			33.41
		],
		[
			"2013-04-29",
			30.21
		],
		[
			"2014-11-26",
			38.01
		],
		[
			"2015-05-11",
			35.01
		]
	],
	"10202791": [
		[
			"2000-02-28",
			77.5
		],
		[
			"2001-04-20",
			89.46
		],
		[
			"2002-06-19",
			122.67
		],
		[
			"2003-03-21",
			102.3
		],
		[
			"2004-01-26",
			100.97
		],
		[
			"2005-05-17",
			104.07
		],
		[
			"2007-02-26",
			107.17
		],
		[
			"2008-07-07",
			87.24
		],
		[
			"2013-08-30",
			101.86
		],
		[
			"2014-03-17",
			102.74
		],
		[
			"2015-03-12",
			89.01
		],
		[
			"2016-02-29",
			84.14
		],
		[
			"2006-03-30",
			116.91
		],
		[
			"2009-07-27",
			81.49
		],
		[
			"2011-05-23",
			94.33
		],
		[
			"2012-04-23",
			96.54
		],
		[
			"2013-03-01",
			103.63
		]
	],
	"10202808": [
		[
			"2000-02-28",
			30.56
		],
		[
			"2001-04-20",
			30.56
		],
		[
			"2002-10-07",
			28.79
		],
		[
			"2003-03-21",
			32.33
		],
		[
			"2004-01-21",
			26.13
		],
		[
			"2005-03-22",
			20.81
		],
		[
			"2005-09-26",
			22.14
		],
		[
			"2007-02-13",
			20.02
		],
		[
			"2008-07-01",
			26.08
		],
		[
			"2013-08-26",
			34.99
		],
		[
			"2014-02-24",
			33.75
		],
		[
			"2014-07-04",
			35.12
		],
		[
			"2015-06-10",
			35.03
		],
		[
			"2006-03-30",
			21.26
		],
		[
			"2009-03-20",
			28.48
		],
		[
			"2011-01-17",
			30.11
		],
		[
			"2012-01-23",
			36.45
		],
		[
			"2012-03-30",
			35.16
		],
		[
			"2013-03-01",
			34.99
		]
	],
	"10202810": [
		[
			"2000-10-31",
			117.36
		],
		[
			"2001-08-03",
			111.16
		],
		[
			"2002-10-08",
			142.6
		],
		[
			"2003-11-07",
			117.8
		],
		[
			"2004-06-16",
			126.66
		],
		[
			"2005-07-12",
			148.36
		],
		[
			"2006-10-27",
			116.47
		],
		[
			"2008-07-01",
			116.03
		],
		[
			"2014-03-24",
			165.63
		],
		[
			"2015-04-09",
			176.26
		],
		[
			"2009-05-25",
			78.83
		],
		[
			"2011-04-15",
			92.11
		],
		[
			"2012-04-23",
			88.13
		],
		[
			"2013-03-11",
			122.23
		]
	],
	"10202821": [
		[
			"2000-05-24",
			92.56
		],
		[
			"2002-06-17",
			105.4
		],
		[
			"2003-04-01",
			83.7
		],
		[
			"2004-03-05",
			93
		],
		[
			"2005-05-17",
			79.27
		],
		[
			"2006-11-07",
			100.97
		],
		[
			"2007-06-18",
			105.4
		],
		[
			"2008-03-27",
			107.61
		],
		[
			"2013-06-28",
			134.19
		],
		[
			"2013-08-09",
			146.14
		],
		[
			"2014-02-03",
			141.27
		],
		[
			"2015-03-26",
			80.6
		],
		[
			"2016-03-17",
			101.86
		],
		[
			"2006-03-22",
			81.49
		],
		[
			"2009-03-16",
			123.11
		],
		[
			"2011-01-14",
			131.53
		],
		[
			"2012-03-05",
			170.06
		]
	],
	"10203187": [
		[
			"2000-06-27",
			67.76
		],
		[
			"2001-08-03",
			58.01
		],
		[
			"2002-06-19",
			64.21
		],
		[
			"2003-05-06",
			65.99
		],
		[
			"2004-05-24",
			58.46
		],
		[
			"2005-05-17",
			64.66
		],
		[
			"2006-10-05",
			71.3
		],
		[
			"2007-01-15",
			65.54
		],
		[
			"2008-10-15",
			54.03
		],
		[
			"2013-04-22",
			59.79
		],
		[
			"2014-03-17",
			60.23
		],
		[
			"2015-03-12",
			58.46
		],
		[
			"2009-08-17",
			49.16
		],
		[
			"2011-11-07",
			53.59
		]
	],
	"10203199": [
		[
			"2000-06-26",
			60.67
		],
		[
			"2001-08-03",
			57.13
		],
		[
			"2002-10-07",
			49.16
		],
		[
			"2003-05-06",
			50.49
		],
		[
			"2004-05-24",
			53.59
		],
		[
			"2005-07-05",
			57.13
		],
		[
			"2005-09-21",
			57.57
		],
		[
			"2006-03-30",
			54.47
		],
		[
			"2007-01-03",
			51.37
		],
		[
			"2008-07-01",
			52.7
		],
		[
			"2014-02-26",
			40.34
		],
		[
			"2015-03-12",
			45.61
		],
		[
			"2009-05-25",
			64.21
		],
		[
			"2011-01-17",
			46.5
		],
		[
			"2012-10-26",
			41.54
		],
		[
			"2013-03-11",
			41.81
		]
	],
	"10203217": [
		[
			"2000-02-21",
			36.31
		],
		[
			"2001-04-27",
			36.31
		],
		[
			"2002-05-02",
			41.19
		],
		[
			"2003-04-01",
			39.86
		],
		[
			"2004-01-22",
			41.63
		],
		[
			"2005-06-16",
			38.53
		],
		[
			"2006-03-16",
			36.76
		],
		[
			"2007-01-04",
			41.63
		],
		[
			"2008-07-04",
			39.59
		],
		[
			"2011-12-12",
			35.47
		],
		[
			"2013-07-12",
			38.71
		],
		[
			"2014-08-12",
			35.74
		],
		[
			"2015-06-15",
			37.86
		],
		[
			"2005-12-02",
			36.91
		],
		[
			"2006-12-14",
			36.91
		],
		[
			"2007-02-02",
			36.01
		],
		[
			"2007-09-20",
			42.92
		],
		[
			"2008-07-11",
			36.41
		],
		[
			"2008-09-24",
			38.51
		],
		[
			"2009-05-05",
			39.71
		],
		[
			"2010-06-07",
			37.29
		],
		[
			"2011-02-04",
			38.48
		],
		[
			"2012-05-07",
			37.95
		],
		[
			"2012-09-10",
			39.28
		]
	],
	"10203230": [
		[
			"2000-02-03",
			52.26
		],
		[
			"2001-03-15",
			70.41
		],
		[
			"2002-03-21",
			82.81
		],
		[
			"2003-03-28",
			82.37
		],
		[
			"2004-01-16",
			49.16
		],
		[
			"2005-03-29",
			76.17
		],
		[
			"2006-02-21",
			23.03
		],
		[
			"2007-01-02",
			38.31
		],
		[
			"2008-06-04",
			81.04
		],
		[
			"2008-07-11",
			82.81
		],
		[
			"2010-04-12",
			77.94
		],
		[
			"2012-10-17",
			44.73
		],
		[
			"2013-08-27",
			79.71
		],
		[
			"2014-05-22",
			42.51
		],
		[
			"2015-06-15",
			77.5
		],
		[
			"2010-02-18",
			56.69
		],
		[
			"2011-02-04",
			72.19
		]
	],
	"10203254": [
		[
			"2000-02-24",
			62.44
		],
		[
			"2001-03-20",
			59.79
		],
		[
			"2002-03-13",
			62.44
		],
		[
			"2003-03-25",
			62
		],
		[
			"2004-01-09",
			60.23
		],
		[
			"2005-03-30",
			60.67
		],
		[
			"2006-02-22",
			62
		],
		[
			"2007-03-07",
			62.89
		],
		[
			"2008-07-03",
			65.1
		],
		[
			"2011-06-22",
			61.11
		],
		[
			"2012-05-25",
			61.55
		],
		[
			"2013-05-13",
			63.77
		],
		[
			"2014-05-14",
			59.34
		],
		[
			"2015-05-11",
			61.55
		],
		[
			"2013-07-12",
			61.56
		],
		[
			"2014-05-22",
			59.79
		],
		[
			"2015-08-10",
			58.01
		],
		[
			"2010-03-09",
			58.45
		],
		[
			"2010-06-07",
			61.11
		],
		[
			"2011-03-11",
			60.67
		],
		[
			"2012-05-07",
			61.11
		],
		[
			"2012-09-10",
			55.36
		]
	],
	"10203266": [
		[
			"2000-02-24",
			24.36
		],
		[
			"2001-03-20",
			16.83
		],
		[
			"2002-03-13",
			29.23
		],
		[
			"2003-03-25",
			17.71
		],
		[
			"2004-01-09",
			25.24
		],
		[
			"2005-03-30",
			26.13
		],
		[
			"2006-02-22",
			22.59
		],
		[
			"2007-01-17",
			20.46
		],
		[
			"2007-05-08",
			20.59
		],
		[
			"2008-02-07",
			27.24
		],
		[
			"2011-06-22",
			24.05
		],
		[
			"2014-05-14",
			29.45
		],
		[
			"2014-05-14",
			29.45
		],
		[
			"2015-05-11",
			29.14
		],
		[
			"2010-03-09",
			30.47
		]
	],
	"10203436": [
		[
			"2001-03-14",
			52.26
		],
		[
			"2002-05-24",
			56.24
		],
		[
			"2003-02-26",
			53.14
		],
		[
			"2004-01-08",
			61.11
		],
		[
			"2005-06-21",
			59.79
		],
		[
			"2008-09-29",
			63.77
		],
		[
			"2013-12-17",
			62.44
		],
		[
			"2014-09-30",
			69.97
		],
		[
			"2015-04-23",
			62.44
		],
		[
			"2006-03-20",
			63.77
		],
		[
			"2010-09-13",
			56.24
		],
		[
			"2011-02-18",
			56.24
		],
		[
			"2012-09-17",
			59.79
		]
	],
	"10203588": [
		[
			"2000-12-18",
			23.91
		],
		[
			"2001-09-12",
			23.91
		],
		[
			"2002-11-05",
			23.47
		],
		[
			"2003-02-25",
			23.91
		],
		[
			"2004-05-17",
			23.91
		],
		[
			"2005-07-11",
			26.57
		],
		[
			"2007-02-21",
			25.29
		],
		[
			"2008-07-02",
			10.81
		],
		[
			"2013-06-07",
			9.39
		],
		[
			"2014-08-14",
			9.3
		],
		[
			"2015-06-10",
			8.19
		],
		[
			"2010-10-01",
			9.48
		],
		[
			"2011-04-01",
			7.93
		],
		[
			"2012-12-03",
			9.39
		]
	],
	"10203862": [
		[
			"2013-04-22",
			115.59
		],
		[
			"2014-03-24",
			95.66
		],
		[
			"2015-04-09",
			114.7
		],
		[
			"2010-07-02",
			65.54
		],
		[
			"2011-05-23",
			93.89
		],
		[
			"2012-12-03",
			111.6
		]
	],
	"10204003": [
		[
			"2010-09-07",
			25.31
		],
		[
			"2011-05-05",
			18.91
		],
		[
			"2013-04-29",
			14
		],
		[
			"2014-11-26",
			4.2
		],
		[
			"2015-05-11",
			11
		]
	],
	"10205561": [
		[
			"2000-11-30",
			0.89
		],
		[
			"2001-06-28",
			0.44
		],
		[
			"2002-11-06",
			0.44
		],
		[
			"2004-06-15",
			0.44
		],
		[
			"2005-07-08",
			0.44
		],
		[
			"2006-08-07",
			0.44
		],
		[
			"2007-02-21",
			0.44
		],
		[
			"2008-07-14",
			0.44
		],
		[
			"2013-09-16",
			1.33
		],
		[
			"2014-03-27",
			1.33
		],
		[
			"2015-03-16",
			0.4
		],
		[
			"2009-03-27",
			1.33
		],
		[
			"2011-04-01",
			0.13
		],
		[
			"2012-12-03",
			0.13
		]
	],
	"10300570": [
		[
			"2000-11-23",
			16.83
		],
		[
			"2001-06-08",
			12.4
		],
		[
			"2003-11-06",
			10.19
		],
		[
			"2004-05-25",
			9.74
		],
		[
			"2005-07-20",
			8.41
		],
		[
			"2006-10-05",
			8.41
		],
		[
			"2007-02-13",
			10.63
		],
		[
			"2008-03-26",
			13.42
		],
		[
			"2014-03-06",
			7.13
		],
		[
			"2015-03-23",
			6.78
		],
		[
			"2009-03-20",
			9.79
		],
		[
			"2011-01-21",
			10.27
		],
		[
			"2012-04-27",
			7.71
		],
		[
			"2012-10-26",
			7.31
		],
		[
			"2013-03-15",
			7
		]
	],
	"10301574": [
		[
			"2000-06-26",
			28.34
		],
		[
			"2001-04-20",
			28.79
		],
		[
			"2002-09-26",
			32.33
		],
		[
			"2003-11-04",
			32.33
		],
		[
			"2004-01-26",
			34.99
		],
		[
			"2005-07-28",
			32.77
		],
		[
			"2007-01-03",
			31
		],
		[
			"2013-06-05",
			27.01
		],
		[
			"2014-03-06",
			27.68
		],
		[
			"2015-03-23",
			25.51
		],
		[
			"2006-03-29",
			33.66
		],
		[
			"2008-07-09",
			28.43
		],
		[
			"2009-07-27",
			28.83
		],
		[
			"2011-11-07",
			29.1
		],
		[
			"2012-04-27",
			28.83
		],
		[
			"2012-11-19",
			27.01
		]
	],
	"10303650": [
		[
			"2003-11-10",
			0.89
		],
		[
			"2002-07-24",
			2.21
		],
		[
			"2002-07-30",
			1.11
		],
		[
			"2007-11-08",
			4.38
		],
		[
			"2013-09-20",
			6.6
		],
		[
			"2014-08-27",
			21.35
		],
		[
			"2015-06-01",
			7
		],
		[
			"2010-08-30",
			9.57
		],
		[
			"2011-11-07",
			5.31
		],
		[
			"2012-11-19",
			8.15
		]
	],
	"10306237": [
		[
			"2004-07-23",
			43.84
		],
		[
			"2004-10-28",
			48.71
		],
		[
			"2005-04-06",
			44.29
		],
		[
			"2006-03-31",
			36.31
		],
		[
			"2006-10-25",
			1
		],
		[
			"2007-04-03",
			41.19
		],
		[
			"2007-06-18",
			42.47
		],
		[
			"2007-10-23",
			41.19
		],
		[
			"2013-06-07",
			33.66
		],
		[
			"2014-03-27",
			34.94
		],
		[
			"2015-05-11",
			38.66
		],
		[
			"2008-04-02",
			33.21
		],
		[
			"2008-10-31",
			37.64
		],
		[
			"2009-03-31",
			36.31
		],
		[
			"2009-10-30",
			42.96
		],
		[
			"2010-03-30",
			36.31
		],
		[
			"2010-10-20",
			38.97
		],
		[
			"2011-04-05",
			30.11
		],
		[
			"2011-10-04",
			38.97
		],
		[
			"2012-03-29",
			30.56
		],
		[
			"2012-10-29",
			34.1
		],
		[
			"2013-03-26",
			31.89
		],
		[
			"2013-10-28",
			32.33
		],
		[
			"2014-03-27",
			31.89
		],
		[
			"2014-10-29",
			32.33
		],
		[
			"2015-03-11",
			34.1
		],
		[
			"2015-10-26",
			38.53
		],
		[
			"2008-07-21",
			39.95
		],
		[
			"2011-01-14",
			26.31
		],
		[
			"2012-11-09",
			36.36
		]
	],
	"10307217": [
		[
			"2000-05-24",
			73.13
		],
		[
			"2001-05-16",
			95.73
		],
		[
			"2006-05-09",
			13
		],
		[
			"2007-01-08",
			42.47
		],
		[
			"2013-09-23",
			110.27
		],
		[
			"2014-04-07",
			87.24
		],
		[
			"2015-04-15",
			77.06
		],
		[
			"2010-06-28",
			12.71
		],
		[
			"2011-11-02",
			31
		]
	],
	"10307229": [
		[
			"2000-05-24",
			24.21
		],
		[
			"2001-05-16",
			24.71
		],
		[
			"2006-05-09",
			17.31
		],
		[
			"2008-09-16",
			8.1
		],
		[
			"2013-09-23",
			23.91
		],
		[
			"2014-04-07",
			11.87
		],
		[
			"2015-04-15",
			18.82
		],
		[
			"2010-06-28",
			27.63
		],
		[
			"2011-11-02",
			14.97
		]
	],
	"10403048": [
		[
			"2000-05-25",
			60.67
		],
		[
			"2001-06-25",
			56.69
		],
		[
			"2002-08-16",
			52.7
		],
		[
			"2003-08-20",
			50.04
		],
		[
			"2004-03-16",
			52.7
		],
		[
			"2005-07-07",
			48.71
		],
		[
			"2006-05-12",
			50.93
		],
		[
			"2007-10-11",
			51.37
		],
		[
			"2008-03-27",
			53.14
		],
		[
			"2013-04-29",
			68.64
		],
		[
			"2015-10-15",
			5.85
		],
		[
			"2009-03-16",
			66.43
		],
		[
			"2011-02-14",
			60.23
		],
		[
			"2012-06-25",
			65.1
		]
	],
	"10403127": [
		[
			"2001-06-25",
			14.17
		],
		[
			"2003-08-20",
			40.74
		],
		[
			"2003-11-03",
			31.89
		],
		[
			"2004-02-10",
			45.61
		],
		[
			"2005-07-12",
			51.37
		],
		[
			"2006-01-13",
			33.41
		],
		[
			"2006-08-29",
			33.21
		],
		[
			"2007-02-26",
			32.55
		],
		[
			"2007-01-30",
			39.31
		],
		[
			"2007-07-30",
			47.82
		],
		[
			"2008-07-21",
			61.11
		],
		[
			"2012-03-07",
			33.43
		],
		[
			"2014-04-28",
			38.57
		],
		[
			"2015-06-01",
			82.81
		],
		[
			"2008-06-19",
			50.02
		],
		[
			"2008-11-04",
			51.42
		],
		[
			"2009-04-08",
			39.41
		],
		[
			"2012-06-04",
			34.76
		]
	],
	"10403474": [
		[
			"2000-05-31",
			48.32
		],
		[
			"2000-07-31",
			46.02
		],
		[
			"2000-10-11",
			46.42
		],
		[
			"2000-12-28",
			45.42
		],
		[
			"2003-12-10",
			47.42
		],
		[
			"2004-03-02",
			50.22
		],
		[
			"2004-07-01",
			43.22
		],
		[
			"2004-12-15",
			49.52
		],
		[
			"2004-09-29",
			47.32
		],
		[
			"2003-08-27",
			48.22
		],
		[
			"2005-10-21",
			2.25
		],
		[
			"2005-09-14",
			1.18
		],
		[
			"2005-07-12",
			1.22
		],
		[
			"2006-08-22",
			49.22
		],
		[
			"2006-05-09",
			51.82
		],
		[
			"2006-11-28",
			55.42
		],
		[
			"2007-05-14",
			58.9
		],
		[
			"2014-04-28",
			1.33
		],
		[
			"2015-03-09",
			44.06
		],
		[
			"2008-02-19",
			39.01
		],
		[
			"2008-05-06",
			54.32
		],
		[
			"2008-08-12",
			47.42
		],
		[
			"2008-11-11",
			54.92
		],
		[
			"2011-08-24",
			56.32
		],
		[
			"2011-05-10",
			61.12
		],
		[
			"2011-02-08",
			55.02
		],
		[
			"2010-11-10",
			58.52
		],
		[
			"2010-08-18",
			58.42
		],
		[
			"2010-05-18",
			56.32
		],
		[
			"2010-02-10",
			60.22
		],
		[
			"2009-11-16",
			43.92
		],
		[
			"2009-05-12",
			53.62
		],
		[
			"2009-03-02",
			37.21
		],
		[
			"2012-02-13",
			57.12
		],
		[
			"2012-05-09",
			55.02
		],
		[
			"2012-08-29",
			58.02
		],
		[
			"2014-06-03",
			20.81
		],
		[
			"2014-08-20",
			56.72
		],
		[
			"2014-11-05",
			42.31
		],
		[
			"2008-09-08",
			55.8
		],
		[
			"2009-08-10",
			52.7
		],
		[
			"2011-10-10",
			48.27
		]
	],
	"10403528": [
		[
			"2000-07-31",
			21.71
		],
		[
			"2004-07-01",
			20.51
		],
		[
			"2006-05-08",
			22.19
		],
		[
			"2008-09-08",
			23.21
		],
		[
			"2014-04-28",
			20.42
		],
		[
			"2013-05-24",
			19.4
		],
		[
			"2015-03-09",
			20.19
		],
		[
			"2009-08-10",
			20.59
		],
		[
			"2011-10-10",
			20.81
		],
		[
			"2012-06-25",
			19.97
		]
	],
	"10403590": [
		[
			"2000-03-08",
			29.71
		],
		[
			"2000-07-17",
			29.11
		],
		[
			"2000-11-22",
			27.71
		],
		[
			"2002-04-09",
			30.51
		],
		[
			"2001-04-30",
			29.01
		],
		[
			"2001-07-03",
			29.11
		],
		[
			"2001-11-19",
			29.71
		],
		[
			"2002-04-15",
			29.23
		],
		[
			"2003-04-24",
			30.21
		],
		[
			"2003-07-16",
			28.71
		],
		[
			"2004-04-27",
			30.71
		],
		[
			"2004-07-13",
			29.81
		],
		[
			"2004-11-23",
			32.91
		],
		[
			"2005-11-07",
			33.61
		],
		[
			"2005-04-27",
			31.61
		],
		[
			"2005-07-26",
			35.11
		],
		[
			"2006-05-08",
			31.13
		],
		[
			"2006-04-11",
			29.61
		],
		[
			"2006-07-10",
			31.11
		],
		[
			"2006-11-21",
			31.01
		],
		[
			"2007-04-23",
			30.31
		],
		[
			"2007-07-10",
			30.41
		],
		[
			"2007-11-19",
			28.41
		],
		[
			"2008-07-14",
			32.11
		],
		[
			"2008-11-20",
			31.11
		],
		[
			"2010-11-15",
			29.09
		],
		[
			"2011-04-18",
			30.6
		],
		[
			"2011-07-18",
			30.78
		],
		[
			"2011-11-22",
			33.17
		],
		[
			"2012-04-03",
			32.24
		],
		[
			"2012-07-17",
			33.96
		],
		[
			"2012-11-26",
			29.85
		],
		[
			"2013-04-02",
			30.29
		],
		[
			"2013-07-15",
			32.15
		],
		[
			"2013-11-18",
			31.88
		],
		[
			"2014-05-05",
			31.71
		],
		[
			"2014-07-21",
			32.86
		],
		[
			"2014-12-15",
			30.91
		],
		[
			"2015-04-21",
			31.44
		],
		[
			"2015-07-28",
			33.21
		],
		[
			"2015-11-24",
			31.13
		],
		[
			"2008-04-28",
			30.71
		],
		[
			"2009-04-27",
			29.11
		],
		[
			"2009-07-01",
			28.91
		],
		[
			"2009-11-24",
			29.51
		],
		[
			"2010-04-27",
			29.61
		],
		[
			"2010-07-26",
			32.24
		],
		[
			"2007-04-23",
			32.42
		]
	],
	"10403814": [
		[
			"2000-11-14",
			8.41
		],
		[
			"2000-10-26",
			8.9
		],
		[
			"2000-04-17",
			7.7
		],
		[
			"2001-12-27",
			9.3
		],
		[
			"2001-03-28",
			8.5
		],
		[
			"2002-04-02",
			7.6
		],
		[
			"2002-12-02",
			9.1
		],
		[
			"2003-04-30",
			10.4
		],
		[
			"2004-10-26",
			7.97
		],
		[
			"2004-04-27",
			9.3
		],
		[
			"2006-04-06",
			7.5
		],
		[
			"2006-05-22",
			9.21
		],
		[
			"2009-03-24",
			8.41
		],
		[
			"2010-12-15",
			7.7
		],
		[
			"2011-03-28",
			11.2
		],
		[
			"2011-11-23",
			6.6
		],
		[
			"2013-04-02",
			8.2
		],
		[
			"2013-11-27",
			7.9
		],
		[
			"2014-12-03",
			7.75
		],
		[
			"2015-09-17",
			7.97
		],
		[
			"2007-12-07",
			5.9
		],
		[
			"2008-03-18",
			9.5
		],
		[
			"2012-03-26",
			7.6
		],
		[
			"2000-11-14",
			8.41
		],
		[
			"2001-12-27",
			9.3
		],
		[
			"2004-10-26",
			7.97
		],
		[
			"2007-10-08",
			8.59
		],
		[
			"2008-10-20",
			9.12
		],
		[
			"2010-09-17",
			7.48
		]
	],
	"10403978": [
		[
			"2000-04-27",
			31.01
		],
		[
			"2000-11-13",
			30.51
		],
		[
			"2001-04-23",
			31.51
		],
		[
			"2001-11-13",
			33.21
		],
		[
			"2002-03-06",
			33.81
		],
		[
			"2002-10-16",
			32.77
		],
		[
			"2002-11-19",
			33.31
		],
		[
			"2003-03-12",
			30.61
		],
		[
			"2003-11-26",
			32.01
		],
		[
			"2005-03-08",
			35.11
		],
		[
			"2005-11-09",
			32.31
		],
		[
			"2006-03-15",
			32.21
		],
		[
			"2006-05-15",
			34.45
		],
		[
			"2006-11-20",
			33.61
		],
		[
			"2004-03-03",
			20.91
		],
		[
			"2004-11-09",
			36.61
		],
		[
			"2007-03-13",
			34.91
		],
		[
			"2007-11-21",
			16.51
		],
		[
			"2008-11-18",
			35.91
		],
		[
			"2010-11-22",
			34.63
		],
		[
			"2011-03-23",
			32.81
		],
		[
			"2012-03-05",
			33.12
		],
		[
			"2012-11-13",
			30.69
		],
		[
			"2013-03-05",
			32.28
		],
		[
			"2013-11-13",
			19.84
		],
		[
			"2014-04-08",
			32.1
		],
		[
			"2014-12-01",
			28.78
		],
		[
			"2015-03-18",
			27.46
		],
		[
			"2015-11-17",
			30.91
		],
		[
			"2008-03-05",
			34.41
		],
		[
			"2009-03-18",
			34.81
		],
		[
			"2009-11-23",
			33.41
		],
		[
			"2010-03-09",
			34.81
		]
	],
	"10404338": [
		[
			"2000-10-02",
			3.3
		],
		[
			"2000-05-15",
			3.7
		],
		[
			"2001-05-21",
			3.6
		],
		[
			"2001-10-10",
			4
		],
		[
			"2002-06-10",
			3.8
		],
		[
			"2002-10-16",
			3.2
		],
		[
			"2003-05-14",
			3
		],
		[
			"2003-10-15",
			3.1
		],
		[
			"2005-05-12",
			2.8
		],
		[
			"2006-05-24",
			3.3
		],
		[
			"2007-05-23",
			4.1
		],
		[
			"2004-05-19",
			2.8
		],
		[
			"2004-09-27",
			2.9
		],
		[
			"2006-10-16",
			3.2
		],
		[
			"2007-10-17",
			2.9
		],
		[
			"2008-10-22",
			3.4
		],
		[
			"2010-11-10",
			3.5
		],
		[
			"2011-05-11",
			3.45
		],
		[
			"2011-10-26",
			3.67
		],
		[
			"2012-05-09",
			2.92
		],
		[
			"2012-10-08",
			3.63
		],
		[
			"2013-10-15",
			3.72
		],
		[
			"2014-05-14",
			3.72
		],
		[
			"2014-10-15",
			3.14
		],
		[
			"2015-06-17",
			3.28
		],
		[
			"2015-10-27",
			3.59
		],
		[
			"2008-05-14",
			16.21
		],
		[
			"2009-05-13",
			4.9
		],
		[
			"2009-10-21",
			3.3
		],
		[
			"2010-06-09",
			3.14
		]
	],
	"10404491": [
		[
			"2000-03-27",
			0.5
		],
		[
			"2000-12-04",
			0.5
		],
		[
			"2001-03-12",
			1
		],
		[
			"2001-06-25",
			0.89
		],
		[
			"2001-09-24",
			1
		],
		[
			"2001-12-10",
			1
		],
		[
			"2002-03-11",
			1
		],
		[
			"2002-06-17",
			1
		],
		[
			"2002-09-16",
			1
		],
		[
			"2002-12-02",
			2
		],
		[
			"2003-03-10",
			2
		],
		[
			"2003-04-07",
			2
		],
		[
			"2003-05-05",
			2
		],
		[
			"2004-01-12",
			2
		],
		[
			"2004-02-02",
			2
		],
		[
			"2004-05-10",
			2
		],
		[
			"2004-09-06",
			2
		],
		[
			"2004-10-04",
			0.3
		],
		[
			"2004-12-13",
			2
		],
		[
			"2005-03-07",
			2
		],
		[
			"2005-06-20",
			2
		],
		[
			"2005-09-12",
			0.5
		],
		[
			"2005-11-21",
			0.5
		],
		[
			"2005-12-12",
			0.5
		],
		[
			"2006-09-26",
			0.5
		],
		[
			"2010-02-09",
			0.5
		],
		[
			"2010-05-17",
			0.5
		],
		[
			"2010-10-11",
			0.5
		],
		[
			"2010-11-02",
			0.5
		],
		[
			"2011-05-16",
			0.4
		],
		[
			"2011-09-12",
			0.5
		],
		[
			"2011-11-14",
			0.5
		],
		[
			"2012-02-13",
			0.5
		],
		[
			"2012-05-21",
			0.5
		],
		[
			"2012-09-17",
			0.5
		],
		[
			"2012-11-12",
			0.5
		],
		[
			"2013-02-18",
			0.5
		],
		[
			"2013-05-13",
			0.65
		],
		[
			"2013-09-16",
			0.2
		],
		[
			"2014-02-10",
			0.5
		],
		[
			"2014-05-12",
			0.5
		],
		[
			"2014-09-15",
			0.5
		],
		[
			"2014-11-10",
			0.5
		],
		[
			"2015-05-18",
			0.5
		],
		[
			"2015-09-14",
			2.7
		],
		[
			"2015-12-14",
			0.5
		],
		[
			"2007-10-15",
			0.18
		],
		[
			"2008-08-04",
			0.5
		],
		[
			"2008-09-08",
			0.5
		],
		[
			"2008-11-03",
			0.5
		],
		[
			"2009-02-02",
			0.5
		],
		[
			"2009-05-11",
			0.5
		],
		[
			"2009-09-14",
			0.5
		],
		[
			"2009-11-09",
			0.5
		],
		[
			"2008-09-23",
			0.44
		]
	],
	"10406426": [
		[
			"2006-07-05",
			13.46
		],
		[
			"2007-01-31",
			7.7
		],
		[
			"2007-07-26",
			9
		],
		[
			"2008-10-08",
			4.12
		],
		[
			"2011-01-13",
			14.62
		],
		[
			"2013-08-20",
			9.3
		],
		[
			"2014-10-06",
			9.25
		],
		[
			"2015-08-17",
			7.39
		],
		[
			"2013-09-27",
			8.86
		],
		[
			"2014-08-13",
			8.06
		],
		[
			"2015-05-06",
			9.48
		],
		[
			"2008-05-26",
			15.31
		],
		[
			"2008-10-08",
			11.6
		],
		[
			"2009-04-14",
			10.8
		],
		[
			"2009-07-24",
			11.74
		],
		[
			"2011-11-25",
			7.93
		],
		[
			"2012-12-14",
			6.51
		]
	],
	"10407121": [
		[
			"2000-11-09",
			76.63
		],
		[
			"2001-11-15",
			69.72
		],
		[
			"2001-04-03",
			70.63
		],
		[
			"2003-11-05",
			75.73
		],
		[
			"2002-03-27",
			76.23
		],
		[
			"2002-11-20",
			73.13
		],
		[
			"2003-11-20",
			67.82
		],
		[
			"2003-04-02",
			73.33
		],
		[
			"2004-04-28",
			69.72
		],
		[
			"2004-12-02",
			68.12
		],
		[
			"2005-04-21",
			73.03
		],
		[
			"2005-11-14",
			71.23
		],
		[
			"2006-10-09",
			77.06
		],
		[
			"2006-04-11",
			72.03
		],
		[
			"2006-11-22",
			71.33
		],
		[
			"2007-05-14",
			76.17
		],
		[
			"2007-04-05",
			62.62
		],
		[
			"2010-06-02",
			93.23
		],
		[
			"2010-11-10",
			79.43
		],
		[
			"2011-09-28",
			76.73
		],
		[
			"2011-05-05",
			74.23
		],
		[
			"2012-10-08",
			83.33
		],
		[
			"2012-05-14",
			74.03
		],
		[
			"2013-04-29",
			75.73
		],
		[
			"2013-10-15",
			79.63
		],
		[
			"2015-10-05",
			75.03
		],
		[
			"2015-05-11",
			70.02
		],
		[
			"2007-11-08",
			76.13
		],
		[
			"2008-04-16",
			73.53
		],
		[
			"2008-11-17",
			76.83
		],
		[
			"2009-04-20",
			78.03
		],
		[
			"2009-11-04",
			65.32
		],
		[
			"2008-10-08",
			63.77
		]
	],
	"10407194": [
		[
			"2006-10-18",
			7.04
		],
		[
			"2007-04-27",
			8.24
		],
		[
			"2008-01-11",
			13.55
		],
		[
			"2013-10-16",
			7.09
		],
		[
			"2014-07-31",
			7.62
		],
		[
			"2015-10-13",
			7.09
		],
		[
			"2009-12-07",
			5.89
		]
	],
	"10407200": [
		[
			"2000-09-27",
			8
		],
		[
			"2000-04-04",
			10.3
		],
		[
			"2007-03-22",
			7.35
		],
		[
			"2008-01-11",
			6.2
		],
		[
			"2013-10-16",
			5.76
		],
		[
			"2014-07-31",
			1.33
		],
		[
			"2015-10-13",
			5.27
		],
		[
			"2006-11-29",
			7.22
		],
		[
			"2010-10-25",
			5.67
		],
		[
			"2011-11-24",
			5.85
		]
	],
	"10407212": [
		[
			"2000-09-27",
			13
		],
		[
			"2000-04-04",
			12.3
		],
		[
			"2002-04-15",
			13
		],
		[
			"2001-12-11",
			12
		],
		[
			"2001-04-10",
			12
		],
		[
			"2002-12-11",
			11
		],
		[
			"2003-06-24",
			5.2
		],
		[
			"2004-12-14",
			12
		],
		[
			"2004-06-01",
			12
		],
		[
			"2005-12-15",
			11.3
		],
		[
			"2005-03-15",
			12
		],
		[
			"2007-03-22",
			14.84
		],
		[
			"2006-12-12",
			11.7
		],
		[
			"2006-06-19",
			13
		],
		[
			"2008-01-11",
			16.87
		],
		[
			"2010-12-20",
			13.9
		],
		[
			"2010-06-01",
			14.61
		],
		[
			"2011-12-01",
			13.1
		],
		[
			"2011-06-16",
			14
		],
		[
			"2012-12-13",
			13
		],
		[
			"2012-05-31",
			12.8
		],
		[
			"2013-12-10",
			14.41
		],
		[
			"2013-06-25",
			13.4
		],
		[
			"2014-12-16",
			10
		],
		[
			"2014-06-24",
			14
		],
		[
			"2015-12-14",
			12.3
		],
		[
			"2015-06-18",
			13
		],
		[
			"2008-07-21",
			16.11
		],
		[
			"2007-12-17",
			14.91
		],
		[
			"2007-05-23",
			13.7
		],
		[
			"2008-12-22",
			11.8
		],
		[
			"2009-06-16",
			14.81
		],
		[
			"2009-12-15",
			12.3
		],
		[
			"2006-11-29",
			12.27
		]
	],
	"10407297": [
		[
			"2000-05-08",
			24.01
		],
		[
			"2001-07-17",
			20.81
		],
		[
			"2000-10-11",
			21.21
		],
		[
			"2001-06-25",
			21.91
		],
		[
			"2001-10-29",
			21.31
		],
		[
			"2002-05-07",
			22.71
		],
		[
			"2002-10-21",
			21.31
		],
		[
			"2003-05-13",
			21.21
		],
		[
			"2003-10-22",
			20.31
		],
		[
			"2004-10-27",
			21.51
		],
		[
			"2004-10-12",
			20.81
		],
		[
			"2004-05-26",
			19.31
		],
		[
			"2005-05-09",
			21.01
		],
		[
			"2005-10-04",
			20.91
		],
		[
			"2006-05-10",
			20.91
		],
		[
			"2006-10-30",
			21.01
		],
		[
			"2007-05-07",
			19.31
		],
		[
			"2007-10-29",
			19.71
		],
		[
			"2008-10-14",
			20.51
		],
		[
			"2010-10-25",
			20.42
		],
		[
			"2011-05-03",
			20.55
		],
		[
			"2011-10-24",
			19.66
		],
		[
			"2012-05-08",
			19.09
		],
		[
			"2012-10-10",
			17.89
		],
		[
			"2013-10-08",
			17.67
		],
		[
			"2014-05-12",
			18.12
		],
		[
			"2014-10-27",
			18.2
		],
		[
			"2015-07-01",
			18.96
		],
		[
			"2015-10-14",
			18.78
		],
		[
			"2014-12-04",
			18.69
		],
		[
			"2008-05-07",
			21.91
		],
		[
			"2009-05-11",
			20.31
		],
		[
			"2009-10-27",
			19.31
		],
		[
			"2010-05-18",
			19.31
		],
		[
			"2007-10-16",
			21.43
		],
		[
			"2008-09-25",
			24
		],
		[
			"2011-05-26",
			20.9
		],
		[
			"2011-10-07",
			20.28
		]
	],
	"10407339": [
		[
			"2000-08-30",
			9.3
		],
		[
			"2000-03-27",
			11.2
		],
		[
			"2000-11-20",
			11.2
		],
		[
			"2002-07-18",
			7.97
		],
		[
			"2002-11-04",
			7.97
		],
		[
			"2001-03-12",
			11.21
		],
		[
			"2001-05-07",
			13.11
		],
		[
			"2001-09-24",
			8.31
		],
		[
			"2001-11-19",
			8.71
		],
		[
			"2002-03-11",
			9.41
		],
		[
			"2002-06-17",
			11.11
		],
		[
			"2002-08-19",
			8.11
		],
		[
			"2002-09-16",
			10.61
		],
		[
			"2002-10-14",
			9.51
		],
		[
			"2002-11-18",
			10.21
		],
		[
			"2002-12-02",
			6.9
		],
		[
			"2003-01-13",
			6.7
		],
		[
			"2003-02-10",
			21.82
		],
		[
			"2003-03-10",
			11.21
		],
		[
			"2003-04-07",
			7.71
		],
		[
			"2003-05-05",
			6.51
		],
		[
			"2003-06-23",
			6.4
		],
		[
			"2003-09-08",
			6.2
		],
		[
			"2003-10-06",
			6.2
		],
		[
			"2003-11-03",
			4.9
		],
		[
			"2003-12-01",
			5.2
		],
		[
			"2003-08-11",
			7.01
		],
		[
			"2003-05-14",
			7.09
		],
		[
			"2004-10-11",
			4.87
		],
		[
			"2004-01-12",
			4.9
		],
		[
			"2004-02-02",
			6
		],
		[
			"2004-03-08",
			4.6
		],
		[
			"2004-04-19",
			5.5
		],
		[
			"2004-05-10",
			4.9
		],
		[
			"2004-06-14",
			5.5
		],
		[
			"2004-07-12",
			5
		],
		[
			"2004-08-09",
			4.8
		],
		[
			"2004-09-06",
			4.7
		],
		[
			"2004-10-04",
			4.8
		],
		[
			"2004-11-15",
			3.7
		],
		[
			"2004-12-13",
			4.4
		],
		[
			"2005-01-10",
			5.5
		],
		[
			"2005-02-21",
			11.3
		],
		[
			"2005-03-07",
			6.3
		],
		[
			"2005-04-18",
			4.6
		],
		[
			"2005-05-02",
			4.6
		],
		[
			"2005-06-20",
			4.1
		],
		[
			"2005-07-11",
			4.4
		],
		[
			"2005-08-22",
			7.4
		],
		[
			"2005-09-12",
			4.3
		],
		[
			"2007-01-15",
			9
		],
		[
			"2007-02-26",
			5.9
		],
		[
			"2007-03-19",
			12.3
		],
		[
			"2007-04-16",
			12.8
		],
		[
			"2007-05-21",
			8.3
		],
		[
			"2007-06-25",
			5.4
		],
		[
			"2006-01-09",
			14.51
		],
		[
			"2006-02-20",
			4.8
		],
		[
			"2006-03-13",
			5.1
		],
		[
			"2006-04-03",
			6.4
		],
		[
			"2006-05-08",
			4.7
		],
		[
			"2006-06-26",
			4.7
		],
		[
			"2006-07-17",
			4.8
		],
		[
			"2006-08-14",
			4.8
		],
		[
			"2006-09-25",
			5.2
		],
		[
			"2006-10-24",
			5.2
		],
		[
			"2006-11-20",
			6.3
		],
		[
			"2006-12-04",
			13.3
		],
		[
			"2010-01-11",
			13
		],
		[
			"2010-02-09",
			9.5
		],
		[
			"2010-03-08",
			16.91
		],
		[
			"2010-04-12",
			7.5
		],
		[
			"2010-05-17",
			5.2
		],
		[
			"2010-06-14",
			11.1
		],
		[
			"2010-07-12",
			4.8
		],
		[
			"2010-08-09",
			5.2
		],
		[
			"2010-09-20",
			5
		],
		[
			"2010-11-02",
			20.41
		],
		[
			"2010-12-13",
			11.2
		],
		[
			"2011-01-17",
			9.2
		],
		[
			"2011-02-14",
			7.2
		],
		[
			"2011-03-21",
			6.5
		],
		[
			"2011-04-11",
			6
		],
		[
			"2011-05-16",
			5.8
		],
		[
			"2011-06-14",
			5.4
		],
		[
			"2011-07-11",
			7.4
		],
		[
			"2011-08-08",
			5.1
		],
		[
			"2011-09-12",
			4.8
		],
		[
			"2011-10-10",
			4.2
		],
		[
			"2011-11-14",
			4
		],
		[
			"2011-12-12",
			4.3
		],
		[
			"2012-01-09",
			9.2
		],
		[
			"2012-02-13",
			4.6
		],
		[
			"2012-03-12",
			5.5
		],
		[
			"2012-04-10",
			7.2
		],
		[
			"2012-05-21",
			8.8
		],
		[
			"2012-06-18",
			3.9
		],
		[
			"2012-07-09",
			3.9
		],
		[
			"2012-08-13",
			5.9
		],
		[
			"2012-09-17",
			3.7
		],
		[
			"2012-10-15",
			3.9
		],
		[
			"2012-11-12",
			3.9
		],
		[
			"2012-12-10",
			3.5
		],
		[
			"2013-01-14",
			3.7
		],
		[
			"2013-02-18",
			4.4
		],
		[
			"2013-03-11",
			4.3
		],
		[
			"2013-04-15",
			10.3
		],
		[
			"2013-05-13",
			4.2
		],
		[
			"2013-06-17",
			7.4
		],
		[
			"2013-07-15",
			4.2
		],
		[
			"2013-08-12",
			4.1
		],
		[
			"2013-09-16",
			8.2
		],
		[
			"2013-10-14",
			3.8
		],
		[
			"2013-11-11",
			3.9
		],
		[
			"2013-12-09",
			4
		],
		[
			"2014-01-13",
			5.3
		],
		[
			"2014-02-10",
			3.8
		],
		[
			"2014-03-17",
			3.7
		],
		[
			"2014-04-14",
			7.9
		],
		[
			"2014-05-12",
			3.5
		],
		[
			"2014-06-10",
			3.4
		],
		[
			"2014-07-14",
			4.1
		],
		[
			"2014-08-11",
			3.7
		],
		[
			"2014-09-15",
			3.8
		],
		[
			"2014-10-13",
			3.5
		],
		[
			"2014-11-10",
			3.4
		],
		[
			"2014-12-15",
			3.3
		],
		[
			"2015-01-12",
			14.31
		],
		[
			"2015-02-09",
			7.4
		],
		[
			"2015-02-23",
			3.8
		],
		[
			"2015-03-16",
			4
		],
		[
			"2015-04-13",
			5.9
		],
		[
			"2015-05-18",
			3.3
		],
		[
			"2015-06-08",
			4.4
		],
		[
			"2015-07-01",
			4.2
		],
		[
			"2015-07-08",
			4.2
		],
		[
			"2015-07-13",
			5.5
		],
		[
			"2015-08-10",
			4.1
		],
		[
			"2015-09-14",
			4.2
		],
		[
			"2015-10-12",
			4.5
		],
		[
			"2015-11-09",
			4
		],
		[
			"2015-12-14",
			4.4
		],
		[
			"2007-07-23",
			13.9
		],
		[
			"2007-08-13",
			13.6
		],
		[
			"2007-09-10",
			5.5
		],
		[
			"2007-10-15",
			5.7
		],
		[
			"2007-11-19",
			6.7
		],
		[
			"2007-12-10",
			5.9
		],
		[
			"2008-01-14",
			6.3
		],
		[
			"2008-02-18",
			7.5
		],
		[
			"2008-03-03",
			7
		],
		[
			"2008-04-21",
			7.7
		],
		[
			"2008-05-26",
			6.7
		],
		[
			"2008-06-16",
			7
		],
		[
			"2008-07-14",
			7
		],
		[
			"2008-08-04",
			7
		],
		[
			"2008-09-08",
			8.3
		],
		[
			"2008-10-06",
			6.8
		],
		[
			"2008-11-03",
			5.6
		],
		[
			"2008-12-08",
			6.9
		],
		[
			"2009-01-12",
			7.6
		],
		[
			"2009-02-02",
			6.7
		],
		[
			"2009-03-09",
			7.6
		],
		[
			"2009-04-06",
			7.2
		],
		[
			"2009-05-11",
			6.4
		],
		[
			"2009-06-15",
			6
		],
		[
			"2009-07-13",
			7.3
		],
		[
			"2009-08-10",
			5.3
		],
		[
			"2009-09-14",
			5.3
		],
		[
			"2009-10-12",
			5.3
		],
		[
			"2009-11-09",
			5.4
		],
		[
			"2009-12-14",
			4.6
		],
		[
			"2003-05-14",
			7.09
		],
		[
			"2007-10-09",
			7.31
		],
		[
			"2008-09-23",
			6.86
		]
	],
	"10407340": [
		[
			"2000-11-07",
			9.74
		],
		[
			"2000-03-27",
			12.4
		],
		[
			"2000-11-20",
			9
		],
		[
			"2002-07-18",
			11.96
		],
		[
			"2002-11-04",
			8.86
		],
		[
			"2001-03-12",
			9.91
		],
		[
			"2001-05-07",
			11.81
		],
		[
			"2001-09-24",
			8.71
		],
		[
			"2001-11-19",
			8.11
		],
		[
			"2002-03-11",
			13.11
		],
		[
			"2002-06-17",
			12.11
		],
		[
			"2002-08-19",
			9.71
		],
		[
			"2002-09-16",
			8.51
		],
		[
			"2002-10-14",
			8.21
		],
		[
			"2002-11-18",
			8.11
		],
		[
			"2002-12-02",
			9.41
		],
		[
			"2003-01-13",
			9.71
		],
		[
			"2003-02-10",
			11.51
		],
		[
			"2003-03-10",
			10.71
		],
		[
			"2003-04-07",
			10.31
		],
		[
			"2003-05-05",
			9.91
		],
		[
			"2003-06-23",
			8.61
		],
		[
			"2003-07-14",
			8.91
		],
		[
			"2003-08-11",
			7.91
		],
		[
			"2003-09-08",
			7.61
		],
		[
			"2003-10-06",
			7.01
		],
		[
			"2003-11-03",
			7.21
		],
		[
			"2003-12-01",
			7.01
		],
		[
			"2004-10-11",
			6.64
		],
		[
			"2004-01-12",
			6.5
		],
		[
			"2004-03-08",
			7.3
		],
		[
			"2004-04-19",
			8.2
		],
		[
			"2004-05-10",
			7.8
		],
		[
			"2004-06-14",
			7.8
		],
		[
			"2004-07-12",
			7.5
		],
		[
			"2004-08-09",
			7.3
		],
		[
			"2004-09-06",
			6.9
		],
		[
			"2004-10-04",
			6.7
		],
		[
			"2004-11-15",
			6.4
		],
		[
			"2004-12-13",
			6.3
		],
		[
			"2005-01-10",
			7
		],
		[
			"2005-02-21",
			7.7
		],
		[
			"2005-03-07",
			8.7
		],
		[
			"2005-04-18",
			8.5
		],
		[
			"2005-05-09",
			8.7
		],
		[
			"2005-06-20",
			8.4
		],
		[
			"2005-07-11",
			8.3
		],
		[
			"2005-08-22",
			7.9
		],
		[
			"2005-09-12",
			7.9
		],
		[
			"2005-10-24",
			7.2
		],
		[
			"2005-11-21",
			6.8
		],
		[
			"2005-12-12",
			6.8
		],
		[
			"2006-01-09",
			6.5
		],
		[
			"2006-02-20",
			6.9
		],
		[
			"2006-03-13",
			7.3
		],
		[
			"2006-04-03",
			9.2
		],
		[
			"2006-05-08",
			7.9
		],
		[
			"2006-06-26",
			7.9
		],
		[
			"2006-07-17",
			8.1
		],
		[
			"2006-08-14",
			7.6
		],
		[
			"2006-09-25",
			7.6
		],
		[
			"2006-10-24",
			7.5
		],
		[
			"2006-11-20",
			6.9
		],
		[
			"2006-12-04",
			6.8
		],
		[
			"2007-01-15",
			6.8
		],
		[
			"2007-02-26",
			7.7
		],
		[
			"2007-03-19",
			8.3
		],
		[
			"2007-04-16",
			8.5
		],
		[
			"2007-05-21",
			8.3
		],
		[
			"2007-06-25",
			7.8
		],
		[
			"2010-01-11",
			7.8
		],
		[
			"2010-02-09",
			8
		],
		[
			"2010-03-08",
			9.3
		],
		[
			"2010-04-12",
			8.9
		],
		[
			"2010-05-17",
			8
		],
		[
			"2010-06-14",
			8.4
		],
		[
			"2010-07-12",
			8.4
		],
		[
			"2010-08-09",
			7.9
		],
		[
			"2010-09-20",
			7.7
		],
		[
			"2010-10-11",
			7.3
		],
		[
			"2010-11-02",
			7.9
		],
		[
			"2010-12-13",
			7.7
		],
		[
			"2011-01-17",
			10.7
		],
		[
			"2011-02-14",
			11.2
		],
		[
			"2011-03-21",
			11
		],
		[
			"2011-04-11",
			9.7
		],
		[
			"2011-05-16",
			8.8
		],
		[
			"2011-06-14",
			8.4
		],
		[
			"2011-07-11",
			8
		],
		[
			"2011-08-08",
			7.9
		],
		[
			"2011-09-12",
			8.7
		],
		[
			"2011-10-10",
			8.7
		],
		[
			"2011-11-14",
			8.6
		],
		[
			"2011-12-12",
			8.7
		],
		[
			"2012-01-09",
			9.9
		],
		[
			"2012-02-13",
			10.1
		],
		[
			"2012-03-12",
			10.5
		],
		[
			"2012-04-10",
			10
		],
		[
			"2012-05-21",
			9.8
		],
		[
			"2012-06-18",
			9.3
		],
		[
			"2012-07-09",
			9.4
		],
		[
			"2012-08-13",
			8.8
		],
		[
			"2012-09-17",
			8.7
		],
		[
			"2012-10-15",
			8.9
		],
		[
			"2012-11-12",
			8.4
		],
		[
			"2012-12-10",
			7.4
		],
		[
			"2013-01-14",
			9.3
		],
		[
			"2013-02-18",
			9.8
		],
		[
			"2013-03-11",
			10.8
		],
		[
			"2013-04-15",
			10.9
		],
		[
			"2013-05-13",
			10.4
		],
		[
			"2013-06-17",
			9.7
		],
		[
			"2013-07-15",
			9.5
		],
		[
			"2013-08-12",
			9.3
		],
		[
			"2013-09-16",
			8.8
		],
		[
			"2013-10-14",
			8.2
		],
		[
			"2013-11-11",
			8.5
		],
		[
			"2013-12-09",
			8.6
		],
		[
			"2014-01-13",
			8.5
		],
		[
			"2014-02-10",
			8.8
		],
		[
			"2014-03-17",
			8.3
		],
		[
			"2014-04-14",
			8.3
		],
		[
			"2014-05-12",
			7.9
		],
		[
			"2014-06-10",
			7.7
		],
		[
			"2014-07-14",
			7.4
		],
		[
			"2014-08-11",
			7.3
		],
		[
			"2014-09-15",
			7.8
		],
		[
			"2014-10-13",
			7.8
		],
		[
			"2014-11-10",
			7.9
		],
		[
			"2014-12-15",
			7.6
		],
		[
			"2015-01-12",
			8.8
		],
		[
			"2015-02-09",
			8.7
		],
		[
			"2015-02-23",
			9.3
		],
		[
			"2015-03-16",
			10.6
		],
		[
			"2015-04-13",
			9.4
		],
		[
			"2015-05-18",
			8.5
		],
		[
			"2015-06-08",
			9.4
		],
		[
			"2015-07-01",
			9.1
		],
		[
			"2015-07-08",
			8.7
		],
		[
			"2015-07-13",
			9.1
		],
		[
			"2015-08-10",
			8.5
		],
		[
			"2015-09-14",
			8
		],
		[
			"2015-10-12",
			8.5
		],
		[
			"2015-11-09",
			7.9
		],
		[
			"2015-12-14",
			8.2
		],
		[
			"2007-07-23",
			7.5
		],
		[
			"2007-08-13",
			7.3
		],
		[
			"2007-09-10",
			7.1
		],
		[
			"2007-10-15",
			7.6
		],
		[
			"2007-11-19",
			8.6
		],
		[
			"2007-12-10",
			8.9
		],
		[
			"2008-01-14",
			9.4
		],
		[
			"2008-02-18",
			10.4
		],
		[
			"2008-03-03",
			10.2
		],
		[
			"2008-04-21",
			11.6
		],
		[
			"2008-05-26",
			11.2
		],
		[
			"2008-06-16",
			11.1
		],
		[
			"2008-07-14",
			10.9
		],
		[
			"2008-08-04",
			10.5
		],
		[
			"2008-09-08",
			10
		],
		[
			"2008-10-06",
			9.4
		],
		[
			"2008-11-03",
			9.1
		],
		[
			"2008-12-08",
			9.1
		],
		[
			"2009-01-12",
			9.3
		],
		[
			"2009-02-02",
			9.9
		],
		[
			"2009-03-09",
			10.4
		],
		[
			"2009-04-06",
			10.9
		],
		[
			"2009-05-11",
			10.9
		],
		[
			"2009-06-15",
			10
		],
		[
			"2009-07-13",
			9.5
		],
		[
			"2009-08-10",
			8.8
		],
		[
			"2009-09-14",
			8.4
		],
		[
			"2009-10-12",
			8.3
		],
		[
			"2009-11-09",
			7.7
		],
		[
			"2009-12-14",
			7.3
		],
		[
			"2007-10-09",
			7.93
		],
		[
			"2008-09-23",
			10.14
		]
	],
	"10407388": [
		[
			"2000-05-23",
			19.31
		],
		[
			"2000-08-29",
			19.93
		],
		[
			"2000-12-04",
			18.16
		],
		[
			"2000-10-31",
			20.11
		],
		[
			"2001-05-21",
			19.49
		],
		[
			"2001-05-16",
			19.49
		],
		[
			"2001-05-14",
			20.31
		],
		[
			"2001-10-04",
			8.41
		],
		[
			"2001-10-04",
			16.21
		],
		[
			"2002-05-15",
			18.81
		],
		[
			"2002-10-24",
			14.91
		],
		[
			"2003-05-19",
			17.27
		],
		[
			"2003-05-08",
			16.51
		],
		[
			"2003-11-13",
			14.11
		],
		[
			"2004-05-10",
			12.9
		],
		[
			"2004-10-06",
			13.29
		],
		[
			"2004-11-09",
			12.4
		],
		[
			"2004-10-25",
			14
		],
		[
			"2005-10-17",
			14.61
		],
		[
			"2005-04-19",
			15.61
		],
		[
			"2006-04-11",
			12.8
		],
		[
			"2006-10-23",
			12.8
		],
		[
			"2007-05-07",
			14.84
		],
		[
			"2010-05-10",
			12.5
		],
		[
			"2010-10-25",
			10
		],
		[
			"2011-04-05",
			12.5
		],
		[
			"2011-10-12",
			11
		],
		[
			"2012-04-23",
			11.8
		],
		[
			"2012-09-24",
			10.7
		],
		[
			"2013-05-27",
			12.5
		],
		[
			"2013-09-23",
			11.2
		],
		[
			"2014-05-26",
			9.4
		],
		[
			"2014-11-24",
			9.3
		],
		[
			"2015-04-15",
			12.8
		],
		[
			"2015-10-26",
			10.1
		],
		[
			"2007-10-22",
			13.1
		],
		[
			"2008-04-14",
			16.71
		],
		[
			"2008-10-27",
			17.11
		],
		[
			"2009-05-18",
			15.21
		],
		[
			"2009-10-20",
			12.53
		],
		[
			"2006-03-27",
			15.06
		],
		[
			"2008-10-06",
			15.77
		]
	],
	"10407390": [
		[
			"2000-05-23",
			2
		],
		[
			"2000-10-24",
			0.44
		],
		[
			"2000-10-31",
			2
		],
		[
			"2001-05-14",
			2
		],
		[
			"2001-10-04",
			2
		],
		[
			"2002-10-24",
			2
		],
		[
			"2002-05-15",
			2
		],
		[
			"2003-05-07",
			2
		],
		[
			"2003-11-12",
			2
		],
		[
			"2004-05-10",
			2
		],
		[
			"2004-10-06",
			0.44
		],
		[
			"2004-10-25",
			2
		],
		[
			"2005-10-24",
			0.44
		],
		[
			"2005-04-19",
			2
		],
		[
			"2005-09-26",
			2
		],
		[
			"2006-04-11",
			2
		],
		[
			"2006-10-24",
			2
		],
		[
			"2007-05-07",
			0.44
		],
		[
			"2010-05-10",
			1
		],
		[
			"2010-10-25",
			1
		],
		[
			"2011-04-05",
			1
		],
		[
			"2011-10-12",
			1
		],
		[
			"2012-04-24",
			2
		],
		[
			"2012-09-24",
			2
		],
		[
			"2013-05-28",
			2
		],
		[
			"2013-09-24",
			2
		],
		[
			"2014-05-27",
			2
		],
		[
			"2014-11-25",
			2
		],
		[
			"2015-04-15",
			2
		],
		[
			"2015-10-27",
			2
		],
		[
			"2007-11-19",
			4
		],
		[
			"2008-04-14",
			4
		],
		[
			"2008-11-04",
			2
		],
		[
			"2009-05-12",
			1
		],
		[
			"2009-10-20",
			1
		],
		[
			"2006-03-27",
			0.44
		],
		[
			"2008-10-06",
			0.44
		]
	],
	"10407406": [
		[
			"2000-05-23",
			2
		],
		[
			"2000-08-29",
			4.43
		],
		[
			"2000-12-04",
			3.54
		],
		[
			"2000-10-31",
			4
		],
		[
			"2001-05-14",
			4.7
		],
		[
			"2001-12-11",
			3.1
		],
		[
			"2001-10-04",
			2.6
		],
		[
			"2002-05-15",
			3.5
		],
		[
			"2002-10-24",
			2
		],
		[
			"2003-05-19",
			2.21
		],
		[
			"2003-05-08",
			2.2
		],
		[
			"2003-11-13",
			2
		],
		[
			"2004-05-11",
			2
		],
		[
			"2004-10-26",
			2
		],
		[
			"2005-09-27",
			3.1
		],
		[
			"2005-04-20",
			3
		],
		[
			"2006-04-12",
			2
		],
		[
			"2006-10-23",
			2.1
		],
		[
			"2007-05-07",
			2.17
		],
		[
			"2010-05-10",
			2.7
		],
		[
			"2010-10-25",
			1.7
		],
		[
			"2011-04-05",
			2.5
		],
		[
			"2011-10-12",
			1.7
		],
		[
			"2012-04-24",
			2.8
		],
		[
			"2012-09-25",
			2.1
		],
		[
			"2013-05-28",
			2.6
		],
		[
			"2013-09-24",
			2
		],
		[
			"2014-05-27",
			2
		],
		[
			"2014-11-25",
			2
		],
		[
			"2015-04-14",
			2.9
		],
		[
			"2015-10-27",
			2
		],
		[
			"2007-10-22",
			4
		],
		[
			"2008-04-14",
			4
		],
		[
			"2008-10-27",
			3.7
		],
		[
			"2009-05-12",
			2.4
		],
		[
			"2009-10-20",
			2.13
		],
		[
			"2006-03-27",
			1.77
		],
		[
			"2008-10-06",
			3.59
		]
	],
	"10407418": [
		[
			"2000-05-23",
			21.61
		],
		[
			"2000-08-29",
			23.47
		],
		[
			"2000-12-04",
			20.81
		],
		[
			"2000-10-31",
			23.21
		],
		[
			"2001-05-14",
			22.81
		],
		[
			"2001-12-11",
			20.81
		],
		[
			"2001-10-04",
			18.21
		],
		[
			"2002-05-15",
			23.61
		],
		[
			"2002-10-24",
			20.41
		],
		[
			"2003-05-19",
			22.14
		],
		[
			"2003-05-08",
			21.31
		],
		[
			"2003-11-13",
			20.21
		],
		[
			"2004-05-11",
			25.81
		],
		[
			"2004-10-06",
			19.93
		],
		[
			"2004-10-26",
			20.01
		],
		[
			"2005-04-20",
			22.11
		],
		[
			"2005-09-27",
			19.21
		],
		[
			"2006-04-12",
			23.71
		],
		[
			"2006-10-24",
			22.31
		],
		[
			"2007-05-07",
			24.18
		],
		[
			"2010-05-10",
			19.51
		],
		[
			"2010-10-25",
			17.11
		],
		[
			"2011-10-12",
			19.71
		],
		[
			"2012-04-23",
			19.31
		],
		[
			"2012-09-24",
			19.21
		],
		[
			"2013-05-27",
			18.71
		],
		[
			"2013-09-23",
			18.51
		],
		[
			"2014-05-26",
			18.01
		],
		[
			"2014-11-24",
			17.61
		],
		[
			"2015-04-15",
			16.91
		],
		[
			"2015-10-26",
			16.21
		],
		[
			"2007-10-22",
			19.41
		],
		[
			"2008-04-14",
			21.11
		],
		[
			"2008-10-27",
			22.41
		],
		[
			"2009-05-12",
			19.51
		],
		[
			"2009-10-20",
			17.38
		],
		[
			"2008-10-06",
			21.79
		]
	],
	"10407431": [
		[
			"2002-03-18",
			15.71
		],
		[
			"2002-10-16",
			14.11
		],
		[
			"2013-10-16",
			14.17
		],
		[
			"2014-11-12",
			13.42
		],
		[
			"2015-10-13",
			10.85
		],
		[
			"2007-10-08",
			16.47
		],
		[
			"2008-11-12",
			13.24
		],
		[
			"2010-06-14",
			14.66
		]
	],
	"10407467": [
		[
			"2000-04-17",
			31.41
		],
		[
			"2000-10-26",
			33.71
		],
		[
			"2001-03-28",
			27.71
		],
		[
			"2002-04-02",
			28.91
		],
		[
			"2002-12-02",
			31.41
		],
		[
			"2003-04-30",
			29.71
		],
		[
			"2004-04-27",
			29.41
		],
		[
			"2005-05-25",
			27.81
		],
		[
			"2006-11-30",
			29.27
		],
		[
			"2007-04-17",
			28.21
		],
		[
			"2008-01-11",
			27.72
		],
		[
			"2013-04-24",
			24.71
		],
		[
			"2014-04-10",
			24.49
		],
		[
			"2015-09-17",
			22.81
		],
		[
			"2010-04-01",
			24.67
		],
		[
			"2011-05-12",
			22.59
		],
		[
			"2012-08-27",
			22.81
		]
	],
	"10407479": [
		[
			"2000-04-17",
			5
		],
		[
			"2000-10-26",
			5.2
		],
		[
			"2001-03-28",
			5.6
		],
		[
			"2002-04-02",
			6.1
		],
		[
			"2002-12-01",
			5.8
		],
		[
			"2003-04-30",
			5.7
		],
		[
			"2004-04-27",
			6.2
		],
		[
			"2005-05-24",
			6.9
		],
		[
			"2006-04-06",
			6.8
		],
		[
			"2006-11-30",
			5.36
		],
		[
			"2007-03-28",
			7.26
		],
		[
			"2008-08-28",
			6.07
		],
		[
			"2009-03-24",
			3
		],
		[
			"2010-12-15",
			6.3
		],
		[
			"2011-03-28",
			16.41
		],
		[
			"2011-11-23",
			5
		],
		[
			"2014-12-03",
			5.76
		],
		[
			"2015-09-17",
			6.42
		],
		[
			"2007-12-07",
			5.8
		],
		[
			"2008-03-18",
			8.2
		],
		[
			"2010-03-29",
			6.7
		],
		[
			"2010-08-24",
			6
		],
		[
			"2010-09-17",
			6.16
		],
		[
			"2011-10-27",
			5.49
		],
		[
			"2012-08-27",
			5.4
		]
	],
	"10407522": [
		[
			"2001-10-16",
			89.43
		],
		[
			"2001-04-10",
			76.63
		],
		[
			"2002-04-15",
			90.73
		],
		[
			"2002-10-29",
			88.13
		],
		[
			"2003-10-21",
			83.23
		],
		[
			"2003-04-15",
			56.72
		],
		[
			"2002-10-15",
			93.43
		],
		[
			"2000-10-17",
			76.53
		],
		[
			"2000-04-12",
			78.43
		],
		[
			"2004-10-20",
			84.63
		],
		[
			"2004-04-06",
			77.93
		],
		[
			"2005-04-11",
			83.23
		],
		[
			"2005-10-26",
			86.33
		],
		[
			"2006-04-05",
			79.23
		],
		[
			"2006-11-06",
			83.23
		],
		[
			"2007-04-17",
			79.73
		],
		[
			"2007-10-23",
			78.43
		],
		[
			"2010-10-12",
			68.64
		],
		[
			"2011-04-27",
			72.19
		],
		[
			"2011-10-11",
			70.41
		],
		[
			"2012-04-24",
			69.96
		],
		[
			"2012-10-23",
			67.75
		],
		[
			"2013-04-09",
			66.86
		],
		[
			"2013-10-29",
			65.98
		],
		[
			"2014-04-15",
			63.32
		],
		[
			"2014-10-29",
			62.88
		],
		[
			"2015-04-08",
			61.55
		],
		[
			"2015-10-07",
			63.32
		],
		[
			"2008-10-21",
			77.93
		],
		[
			"2008-04-15",
			77.03
		],
		[
			"2009-04-07",
			75.73
		],
		[
			"2009-10-20",
			68.62
		],
		[
			"2010-04-27",
			73.03
		],
		[
			"2008-09-08",
			79.27
		]
	],
	"10407649": [
		[
			"2001-10-15",
			76.13
		],
		[
			"2001-04-09",
			75.33
		],
		[
			"2002-04-16",
			76.63
		],
		[
			"2002-04-08",
			71.74
		],
		[
			"2003-10-20",
			68.22
		],
		[
			"2003-04-14",
			69.52
		],
		[
			"2002-10-14",
			74.83
		],
		[
			"2000-10-17",
			74.23
		],
		[
			"2000-04-12",
			74.03
		],
		[
			"2004-10-18",
			67.32
		],
		[
			"2004-04-05",
			66.02
		],
		[
			"2005-04-11",
			66.02
		],
		[
			"2005-10-25",
			68.22
		],
		[
			"2006-04-04",
			69.52
		],
		[
			"2006-11-06",
			66.82
		],
		[
			"2007-04-16",
			71.73
		],
		[
			"2007-10-22",
			72.63
		],
		[
			"2010-10-11",
			87.24
		],
		[
			"2011-04-26",
			86.8
		],
		[
			"2011-10-10",
			85.02
		],
		[
			"2012-04-23",
			85.47
		],
		[
			"2012-10-22",
			77.5
		],
		[
			"2013-10-28",
			95.65
		],
		[
			"2014-04-14",
			84.58
		],
		[
			"2014-10-28",
			78.83
		],
		[
			"2015-04-07",
			81.48
		],
		[
			"2015-10-06",
			81.48
		],
		[
			"2008-10-20",
			85.93
		],
		[
			"2008-04-14",
			72.63
		],
		[
			"2009-04-06",
			87.73
		],
		[
			"2010-04-26",
			90.73
		],
		[
			"2007-12-03",
			83.26
		],
		[
			"2008-08-29",
			85.47
		]
	],
	"10407777": [
		[
			"2000-05-24",
			8
		],
		[
			"2000-11-16",
			10
		],
		[
			"2001-03-15",
			8.3
		],
		[
			"2001-11-08",
			7.8
		],
		[
			"2002-05-16",
			7.2
		],
		[
			"2006-12-06",
			11.29
		],
		[
			"2007-01-26",
			9.57
		],
		[
			"2007-03-28",
			8.28
		],
		[
			"2008-03-25",
			9.88
		],
		[
			"2013-11-28",
			7.88
		],
		[
			"2014-08-04",
			9.65
		],
		[
			"2015-11-26",
			9.88
		],
		[
			"2016-01-21",
			7.97
		],
		[
			"2010-04-29",
			7.57
		]
	],
	"10408216": [
		[
			"2000-09-27",
			14
		],
		[
			"2002-04-15",
			15.01
		],
		[
			"2000-04-04",
			15.01
		],
		[
			"2001-12-11",
			14
		],
		[
			"2001-04-10",
			15.01
		],
		[
			"2002-12-11",
			14
		],
		[
			"2003-06-24",
			5.2
		],
		[
			"2005-12-15",
			14.41
		],
		[
			"2005-03-15",
			15.01
		],
		[
			"2006-12-12",
			15.41
		],
		[
			"2006-06-19",
			14
		],
		[
			"2010-12-20",
			15.21
		],
		[
			"2010-06-01",
			14.51
		],
		[
			"2011-12-01",
			15.31
		],
		[
			"2011-06-16",
			15.51
		],
		[
			"2012-12-13",
			14.81
		],
		[
			"2012-05-31",
			14.91
		],
		[
			"2013-12-10",
			17.71
		],
		[
			"2013-06-25",
			15.51
		],
		[
			"2014-12-16",
			16.01
		],
		[
			"2014-06-24",
			16.01
		],
		[
			"2015-12-14",
			15.01
		],
		[
			"2015-06-18",
			15.01
		],
		[
			"2008-07-21",
			15.21
		],
		[
			"2007-12-17",
			15.01
		],
		[
			"2007-05-23",
			14.81
		],
		[
			"2008-12-22",
			14.91
		],
		[
			"2009-06-16",
			15.21
		],
		[
			"2009-12-15",
			14.41
		],
		[
			"2007-10-16",
			15.72
		]
	],
	"10408230": [
		[
			"2015-10-13",
			10.58
		],
		[
			"2007-10-08",
			8.55
		],
		[
			"2008-08-28",
			9.52
		],
		[
			"2010-06-14",
			10.23
		],
		[
			"2011-11-24",
			10.05
		]
	],
	"10408241": [
		[
			"2002-10-16",
			6.1
		],
		[
			"2002-03-18",
			6.2
		],
		[
			"2003-11-12",
			6
		],
		[
			"2003-05-26",
			6.3
		],
		[
			"2004-12-08",
			6.9
		],
		[
			"2004-05-12",
			6.2
		],
		[
			"2005-06-07",
			5
		],
		[
			"2006-11-21",
			6.7
		],
		[
			"2006-05-22",
			6.5
		],
		[
			"2010-05-05",
			6.5
		],
		[
			"2011-11-21",
			7.2
		],
		[
			"2011-05-16",
			9.9
		],
		[
			"2012-11-08",
			8.3
		],
		[
			"2012-05-16",
			8
		],
		[
			"2013-11-25",
			9.3
		],
		[
			"2013-05-08",
			9.7
		],
		[
			"2014-11-18",
			8.6
		],
		[
			"2014-05-19",
			8.5
		],
		[
			"2015-12-17",
			8.8
		],
		[
			"2015-05-05",
			8.3
		],
		[
			"2014-11-12",
			8.86
		],
		[
			"2015-10-13",
			7.79
		],
		[
			"2008-05-27",
			3
		],
		[
			"2007-11-13",
			7
		],
		[
			"2007-05-09",
			5.8
		],
		[
			"2008-11-04",
			7.1
		],
		[
			"2009-05-04",
			7.1
		],
		[
			"2009-12-14",
			7.9
		],
		[
			"2007-10-08",
			8.15
		],
		[
			"2008-08-28",
			7.13
		],
		[
			"2010-06-14",
			7.22
		],
		[
			"2011-11-24",
			7.57
		]
	],
	"10408381": [
		[
			"2000-05-12",
			39.11
		],
		[
			"2000-11-28",
			39.41
		],
		[
			"2000-10-16",
			43.62
		],
		[
			"2001-05-30",
			41.01
		],
		[
			"2002-05-06",
			43.02
		],
		[
			"2002-11-18",
			39.86
		],
		[
			"2002-10-22",
			41.01
		],
		[
			"2003-05-20",
			41.61
		],
		[
			"2003-11-04",
			43.84
		],
		[
			"2003-10-13",
			44.72
		],
		[
			"2004-03-24",
			41.19
		],
		[
			"2004-05-18",
			43.82
		],
		[
			"2004-10-26",
			43.22
		],
		[
			"2005-03-14",
			41.61
		],
		[
			"2005-04-11",
			42.07
		],
		[
			"2005-10-24",
			43.92
		],
		[
			"2006-03-27",
			40.21
		],
		[
			"2006-09-26",
			46.92
		],
		[
			"2007-03-19",
			47.82
		],
		[
			"2007-04-23",
			50.93
		],
		[
			"2007-09-11",
			46.92
		],
		[
			"2008-10-06",
			44.02
		],
		[
			"2010-12-13",
			37.9
		],
		[
			"2011-04-18",
			37.9
		],
		[
			"2011-10-19",
			37.81
		],
		[
			"2012-04-30",
			38.12
		],
		[
			"2012-10-24",
			37.68
		],
		[
			"2013-04-22",
			45.17
		],
		[
			"2013-10-16",
			37.24
		],
		[
			"2014-03-18",
			41.18
		],
		[
			"2014-10-08",
			38.26
		],
		[
			"2015-04-27",
			44.73
		],
		[
			"2015-10-19",
			40.38
		],
		[
			"2014-08-12",
			41.63
		],
		[
			"2008-03-31",
			52.22
		],
		[
			"2009-04-27",
			39.71
		],
		[
			"2009-10-07",
			37.51
		],
		[
			"2010-04-12",
			36.71
		]
	],
	"10408411": [
		[
			"2000-05-03",
			55.32
		],
		[
			"2000-10-04",
			54.42
		],
		[
			"2001-10-17",
			54.92
		],
		[
			"2001-04-11",
			54.02
		],
		[
			"2005-04-04",
			54.92
		],
		[
			"2005-10-12",
			55.32
		],
		[
			"2006-04-26",
			54.02
		],
		[
			"2006-10-11",
			56.22
		],
		[
			"2004-04-26",
			56.22
		],
		[
			"2004-10-13",
			54.92
		],
		[
			"2007-04-18",
			57.52
		],
		[
			"2007-05-14",
			57.57
		],
		[
			"2008-10-08",
			59.82
		],
		[
			"2011-04-06",
			61.11
		],
		[
			"2011-10-19",
			60.67
		],
		[
			"2012-05-14",
			61.55
		],
		[
			"2012-12-05",
			59.78
		],
		[
			"2013-04-23",
			58.45
		],
		[
			"2013-10-23",
			57.57
		],
		[
			"2014-04-02",
			60.67
		],
		[
			"2014-03-18",
			62.52
		],
		[
			"2014-10-22",
			57.57
		],
		[
			"2015-04-21",
			59.34
		],
		[
			"2015-04-21",
			60.32
		],
		[
			"2015-10-28",
			58.9
		],
		[
			"2008-04-08",
			62.42
		],
		[
			"2007-10-10",
			57.52
		],
		[
			"2009-04-29",
			61.52
		],
		[
			"2009-10-28",
			59.32
		],
		[
			"2010-04-14",
			58.92
		]
	],
	"10408782": [
		[
			"2000-03-24",
			9.7
		],
		[
			"2000-11-13",
			9.6
		],
		[
			"2001-03-15",
			9.1
		],
		[
			"2001-11-28",
			8.9
		],
		[
			"2003-04-16",
			7.1
		],
		[
			"2003-11-19",
			8.6
		],
		[
			"2002-11-20",
			8.4
		],
		[
			"2002-04-03",
			9.3
		],
		[
			"2004-04-28",
			7.2
		],
		[
			"2004-11-29",
			8.6
		],
		[
			"2002-11-18",
			8.41
		],
		[
			"2004-10-04",
			7.97
		],
		[
			"2004-12-20",
			7.09
		],
		[
			"2004-12-27",
			6.64
		],
		[
			"2005-10-17",
			9.3
		],
		[
			"2005-11-15",
			9
		],
		[
			"2006-04-24",
			6.64
		],
		[
			"2005-05-10",
			7.2
		],
		[
			"2006-11-22",
			8.3
		],
		[
			"2007-05-07",
			8.9
		],
		[
			"2007-04-17",
			8.9
		],
		[
			"2008-11-19",
			8.8
		],
		[
			"2010-11-23",
			6.2
		],
		[
			"2011-04-27",
			4.7
		],
		[
			"2011-11-29",
			6.8
		],
		[
			"2012-04-25",
			6.9
		],
		[
			"2012-12-11",
			7.8
		],
		[
			"2013-04-24",
			6.3
		],
		[
			"2013-11-26",
			5.6
		],
		[
			"2014-04-23",
			4.4
		],
		[
			"2014-12-09",
			2.8
		],
		[
			"2015-05-04",
			4.2
		],
		[
			"2007-11-27",
			8.3
		],
		[
			"2008-04-15",
			9.8
		],
		[
			"2009-04-22",
			8.2
		],
		[
			"2009-11-23",
			6.3
		],
		[
			"2010-04-14",
			4.4
		],
		[
			"2008-09-23",
			7.66
		]
	],
	"10409014": [
		[
			"2000-07-06",
			18.16
		],
		[
			"2001-05-03",
			16.83
		],
		[
			"2002-07-02",
			17.71
		],
		[
			"2003-04-28",
			17.71
		],
		[
			"2005-02-01",
			15.94
		],
		[
			"2004-01-29",
			19.93
		],
		[
			"2006-01-19",
			18.6
		],
		[
			"2007-01-16",
			19.66
		],
		[
			"2008-01-09",
			18.33
		],
		[
			"2013-04-24",
			19.44
		],
		[
			"2014-02-20",
			15.68
		],
		[
			"2015-06-18",
			18.87
		],
		[
			"2016-01-25",
			15.06
		],
		[
			"2000-04-19",
			18.6
		],
		[
			"2009-10-09",
			17.27
		],
		[
			"2011-02-07",
			18.42
		],
		[
			"2012-06-25",
			17.18
		]
	],
	"10409038": [
		[
			"2000-03-30",
			52.26
		],
		[
			"2001-05-04",
			51.37
		],
		[
			"2002-07-02",
			50.49
		],
		[
			"2003-04-28",
			53.14
		],
		[
			"2005-02-01",
			50.93
		],
		[
			"2004-02-05",
			53.14
		],
		[
			"2006-01-19",
			54.91
		],
		[
			"2007-01-26",
			54.91
		],
		[
			"2008-03-28",
			56.69
		],
		[
			"2013-04-24",
			53.14
		],
		[
			"2014-08-11",
			47.83
		],
		[
			"2015-03-05",
			52.7
		],
		[
			"2016-03-07",
			53.14
		],
		[
			"2009-07-16",
			58.46
		],
		[
			"2010-05-03",
			53.59
		],
		[
			"2011-03-14",
			52.26
		],
		[
			"2012-06-25",
			51.81
		]
	],
	"10409051": [
		[
			"2000-08-23",
			18.6
		],
		[
			"2001-08-02",
			19.49
		],
		[
			"2002-10-09",
			19.49
		],
		[
			"2003-07-02",
			19.93
		],
		[
			"2005-01-31",
			19.49
		],
		[
			"2004-03-12",
			18.6
		],
		[
			"2007-01-24",
			16.21
		],
		[
			"2008-04-29",
			17.18
		],
		[
			"2014-08-04",
			12.71
		],
		[
			"2015-02-09",
			13.02
		],
		[
			"2016-01-20",
			13.73
		],
		[
			"2006-03-31",
			18.6
		],
		[
			"2010-03-04",
			14.75
		],
		[
			"2011-02-17",
			14.61
		],
		[
			"2012-05-31",
			13.64
		],
		[
			"2013-03-07",
			13.95
		]
	],
	"10409063": [
		[
			"2000-08-31",
			47.83
		],
		[
			"2001-07-31",
			47.83
		],
		[
			"2003-10-17",
			52.26
		],
		[
			"2005-01-31",
			50.04
		],
		[
			"2004-03-10",
			54.47
		],
		[
			"2007-01-16",
			49.6
		],
		[
			"2008-01-10",
			50.04
		],
		[
			"2015-12-18",
			37.73
		],
		[
			"2016-01-20",
			44.29
		],
		[
			"2006-03-31",
			51.37
		]
	],
	"10409087": [
		[
			"2000-10-02",
			17.01
		],
		[
			"2000-05-15",
			17.41
		],
		[
			"2001-05-21",
			17.11
		],
		[
			"2002-06-10",
			18.01
		],
		[
			"2002-10-16",
			19.71
		],
		[
			"2003-05-14",
			19.31
		],
		[
			"2003-10-15",
			20.41
		],
		[
			"2005-05-12",
			20.71
		],
		[
			"2007-05-08",
			22.14
		],
		[
			"2001-10-10",
			18.91
		],
		[
			"2008-01-14",
			22.9
		],
		[
			"2008-07-29",
			22.01
		],
		[
			"2013-08-02",
			22.59
		],
		[
			"2014-12-04",
			22.23
		],
		[
			"2015-11-12",
			20.81
		],
		[
			"2010-05-03",
			22.19
		],
		[
			"2011-06-20",
			23.29
		],
		[
			"2011-10-27",
			23.03
		]
	],
	"10409105": [
		[
			"2000-04-12",
			71.73
		],
		[
			"2000-07-19",
			72.63
		],
		[
			"2000-11-08",
			69.52
		],
		[
			"2001-04-04",
			71.73
		],
		[
			"2001-07-25",
			75.33
		],
		[
			"2001-11-14",
			75.33
		],
		[
			"2002-04-17",
			79.23
		],
		[
			"2002-07-17",
			77.53
		],
		[
			"2002-11-20",
			77.53
		],
		[
			"2003-04-23",
			71.33
		],
		[
			"2003-07-23",
			69.92
		],
		[
			"2003-11-19",
			68.22
		],
		[
			"2004-12-08",
			68.62
		],
		[
			"2004-07-14",
			67.32
		],
		[
			"2004-04-14",
			68.62
		],
		[
			"2005-04-26",
			67.32
		],
		[
			"2005-07-06",
			68.62
		],
		[
			"2005-11-16",
			67.72
		],
		[
			"2006-03-29",
			66.82
		],
		[
			"2006-07-12",
			66.82
		],
		[
			"2006-11-15",
			68.62
		],
		[
			"2007-05-09",
			68.62
		],
		[
			"2007-07-18",
			67.72
		],
		[
			"2007-11-14",
			66.82
		],
		[
			"2008-07-23",
			73.03
		],
		[
			"2008-11-12",
			75.33
		],
		[
			"2008-01-14",
			81.04
		],
		[
			"2008-07-24",
			75.73
		],
		[
			"2010-11-17",
			68.64
		],
		[
			"2011-04-19",
			70.86
		],
		[
			"2011-07-06",
			69.96
		],
		[
			"2011-11-02",
			73.96
		],
		[
			"2012-04-25",
			69.08
		],
		[
			"2012-07-18",
			67.75
		],
		[
			"2012-11-21",
			69.96
		],
		[
			"2013-07-31",
			69.08
		],
		[
			"2014-01-08",
			69.52
		],
		[
			"2014-03-05",
			68.19
		],
		[
			"2014-08-13",
			68.19
		],
		[
			"2014-12-10",
			64.65
		],
		[
			"2015-04-22",
			67.31
		],
		[
			"2015-07-08",
			66.42
		],
		[
			"2015-11-25",
			58.45
		],
		[
			"2008-04-09",
			73.53
		],
		[
			"2009-04-15",
			72.63
		],
		[
			"2009-07-08",
			73.03
		],
		[
			"2009-11-11",
			68.22
		],
		[
			"2010-04-07",
			68.62
		],
		[
			"2010-07-14",
			69.96
		],
		[
			"2007-01-25",
			64.21
		]
	],
	"10409129": [
		[
			"2000-04-10",
			56.22
		],
		[
			"2000-11-06",
			70.86
		],
		[
			"2001-07-16",
			80.13
		],
		[
			"2002-11-14",
			74.84
		],
		[
			"2001-11-27",
			79.73
		],
		[
			"2002-07-16",
			89.43
		],
		[
			"2002-11-12",
			81.03
		],
		[
			"2003-07-22",
			77.93
		],
		[
			"2003-11-18",
			74.43
		],
		[
			"2004-11-08",
			69.92
		],
		[
			"2005-04-13",
			66.82
		],
		[
			"2005-11-08",
			71.73
		],
		[
			"2006-04-10",
			67.72
		],
		[
			"2006-07-19",
			72.23
		],
		[
			"2006-11-22",
			71.73
		],
		[
			"2004-04-13",
			71.33
		],
		[
			"2004-07-12",
			70.83
		],
		[
			"2007-01-11",
			71.3
		],
		[
			"2007-05-08",
			68.62
		],
		[
			"2007-11-27",
			66.42
		],
		[
			"2008-07-21",
			80.63
		],
		[
			"2008-11-11",
			85.43
		],
		[
			"2008-01-14",
			46.06
		],
		[
			"2008-07-24",
			83.7
		],
		[
			"2010-11-09",
			75.29
		],
		[
			"2011-04-04",
			79.71
		],
		[
			"2011-07-04",
			80.6
		],
		[
			"2011-11-08",
			79.27
		],
		[
			"2012-04-10",
			73.51
		],
		[
			"2012-07-23",
			71.3
		],
		[
			"2012-11-14",
			69.96
		],
		[
			"2013-04-03",
			71.74
		],
		[
			"2013-07-17",
			79.27
		],
		[
			"2013-11-20",
			76.61
		],
		[
			"2014-03-12",
			75.73
		],
		[
			"2014-07-16",
			68.19
		],
		[
			"2014-11-26",
			64.21
		],
		[
			"2015-04-28",
			74.4
		],
		[
			"2015-07-29",
			78.83
		],
		[
			"2015-11-18",
			74.4
		],
		[
			"2008-04-07",
			70.42
		],
		[
			"2009-04-28",
			77.93
		],
		[
			"2009-07-15",
			80.13
		],
		[
			"2009-11-10",
			80.13
		],
		[
			"2010-04-06",
			73.93
		],
		[
			"2010-07-13",
			73.96
		]
	],
	"10409142": [
		[
			"2008-09-18",
			20.81
		],
		[
			"2014-06-27",
			13.06
		],
		[
			"2015-02-09",
			16.7
		],
		[
			"2011-02-17",
			19.88
		],
		[
			"2012-08-27",
			15.01
		],
		[
			"2013-03-22",
			16.21
		]
	],
	"10409154": [
		[
			"2000-03-16",
			22.71
		],
		[
			"2000-04-03",
			22.91
		],
		[
			"2000-11-15",
			22.61
		],
		[
			"2001-03-13",
			22.01
		],
		[
			"2001-11-19",
			23.41
		],
		[
			"2003-03-18",
			20.91
		],
		[
			"2003-11-18",
			22.21
		],
		[
			"2002-03-19",
			20.91
		],
		[
			"2002-11-26",
			22.51
		],
		[
			"2005-03-09",
			22.41
		],
		[
			"2005-11-08",
			22.21
		],
		[
			"2006-02-07",
			25.24
		],
		[
			"2006-11-22",
			24.31
		],
		[
			"2004-03-08",
			22.51
		],
		[
			"2004-11-17",
			23.61
		],
		[
			"2007-01-24",
			24.67
		],
		[
			"2007-11-26",
			21.81
		],
		[
			"2008-11-11",
			22.41
		],
		[
			"2008-01-14",
			23.6
		],
		[
			"2010-11-23",
			23.25
		],
		[
			"2011-03-14",
			23.29
		],
		[
			"2011-11-16",
			22.28
		],
		[
			"2012-03-07",
			22.68
		],
		[
			"2012-11-28",
			21.52
		],
		[
			"2013-03-11",
			20.73
		],
		[
			"2013-11-06",
			20.42
		],
		[
			"2014-03-11",
			20.11
		],
		[
			"2014-11-10",
			20.64
		],
		[
			"2015-03-24",
			19.36
		],
		[
			"2015-11-16",
			20.15
		],
		[
			"2013-06-18",
			21.26
		],
		[
			"2014-07-31",
			22.05
		],
		[
			"2015-03-05",
			20.28
		],
		[
			"2006-03-28",
			21.41
		],
		[
			"2008-03-10",
			23.31
		],
		[
			"2009-03-23",
			22.11
		],
		[
			"2009-11-24",
			22.21
		],
		[
			"2010-03-16",
			21.21
		],
		[
			"2010-04-22",
			21.74
		],
		[
			"2011-06-10",
			22.72
		],
		[
			"2012-08-28",
			21.52
		]
	],
	"10409270": [
		[
			"2005-08-08",
			17.91
		],
		[
			"2005-12-13",
			17.11
		],
		[
			"2006-02-07",
			19.93
		],
		[
			"2006-04-11",
			17.11
		],
		[
			"2006-08-29",
			18.01
		],
		[
			"2007-01-18",
			44.29
		],
		[
			"2007-12-04",
			16.31
		],
		[
			"2008-08-18",
			17.51
		],
		[
			"2008-12-08",
			17.11
		],
		[
			"2008-04-04",
			7.53
		],
		[
			"2010-08-16",
			18.03
		],
		[
			"2010-12-14",
			17.27
		],
		[
			"2011-04-18",
			16.92
		],
		[
			"2011-08-22",
			15.95
		],
		[
			"2011-12-07",
			17.58
		],
		[
			"2012-04-02",
			17.32
		],
		[
			"2012-08-21",
			15.5
		],
		[
			"2012-12-11",
			15.64
		],
		[
			"2013-04-03",
			15.19
		],
		[
			"2013-08-05",
			16.39
		],
		[
			"2013-12-16",
			14.62
		],
		[
			"2014-04-02",
			14.71
		],
		[
			"2014-08-25",
			13.9
		],
		[
			"2014-12-09",
			14.88
		],
		[
			"2015-04-27",
			14.62
		],
		[
			"2015-08-31",
			15.64
		],
		[
			"2015-12-09",
			14.84
		],
		[
			"2014-04-10",
			16.16
		],
		[
			"2015-03-05",
			15.19
		],
		[
			"2008-04-02",
			0.2
		],
		[
			"2009-04-28",
			15.41
		],
		[
			"2009-08-12",
			16.41
		],
		[
			"2009-12-08",
			17.91
		],
		[
			"2010-04-12",
			73.53
		],
		[
			"2010-04-22",
			16.16
		],
		[
			"2011-04-28",
			16.56
		],
		[
			"2012-06-25",
			17.45
		],
		[
			"2013-03-28",
			15.72
		]
	],
	"10409312": [
		[
			"2000-10-02",
			32.61
		],
		[
			"2000-05-15",
			34.21
		],
		[
			"2001-05-21",
			34.51
		],
		[
			"2001-12-18",
			32.33
		],
		[
			"2003-11-18",
			38.09
		],
		[
			"2004-10-18",
			35.87
		],
		[
			"2005-05-12",
			35.61
		],
		[
			"2005-10-10",
			35.91
		],
		[
			"2006-05-24",
			35.61
		],
		[
			"2006-10-16",
			38.21
		],
		[
			"2004-09-27",
			37.51
		],
		[
			"2007-05-23",
			36.01
		],
		[
			"2008-10-22",
			38.31
		],
		[
			"2010-11-10",
			38.21
		],
		[
			"2011-05-11",
			34.94
		],
		[
			"2011-10-26",
			36.35
		],
		[
			"2012-05-09",
			37.42
		],
		[
			"2012-10-08",
			37.95
		],
		[
			"2013-10-15",
			36.13
		],
		[
			"2014-05-14",
			37.42
		],
		[
			"2014-10-15",
			34.58
		],
		[
			"2015-06-17",
			37.37
		],
		[
			"2015-10-27",
			35.87
		],
		[
			"2014-12-04",
			37.11
		],
		[
			"2008-05-14",
			36.71
		],
		[
			"2009-05-13",
			35.91
		],
		[
			"2009-10-21",
			37.51
		],
		[
			"2010-06-09",
			34.58
		],
		[
			"2007-10-16",
			37.73
		],
		[
			"2008-10-21",
			38.17
		],
		[
			"2010-06-07",
			36.71
		]
	],
	"10409324": [
		[
			"2002-05-14",
			43.92
		],
		[
			"2006-07-11",
			42.72
		],
		[
			"2006-12-06",
			45.17
		],
		[
			"2000-04-03",
			41.81
		],
		[
			"2000-10-25",
			42.82
		],
		[
			"2001-04-04",
			43.12
		],
		[
			"2001-11-28",
			42.01
		],
		[
			"2002-04-02",
			43.92
		],
		[
			"2002-11-19",
			43.52
		],
		[
			"2003-04-30",
			46.62
		],
		[
			"2003-11-25",
			43.92
		],
		[
			"2007-04-17",
			45.17
		],
		[
			"2007-03-12",
			45.22
		],
		[
			"2007-07-11",
			44.72
		],
		[
			"2007-11-12",
			42.92
		],
		[
			"2008-07-15",
			49.12
		],
		[
			"2008-11-10",
			50.52
		],
		[
			"2008-06-12",
			50.49
		],
		[
			"2010-11-16",
			47.39
		],
		[
			"2011-03-15",
			49.6
		],
		[
			"2011-07-27",
			48.71
		],
		[
			"2011-11-09",
			48.27
		],
		[
			"2012-03-12",
			48.27
		],
		[
			"2012-07-16",
			48.27
		],
		[
			"2012-11-20",
			45.17
		],
		[
			"2013-03-25",
			46.06
		],
		[
			"2013-07-29",
			47.83
		],
		[
			"2013-11-12",
			46.5
		],
		[
			"2014-04-07",
			47.83
		],
		[
			"2014-07-22",
			47.83
		],
		[
			"2014-11-17",
			47.83
		],
		[
			"2015-03-16",
			46.06
		],
		[
			"2015-06-08",
			50.49
		],
		[
			"2015-11-03",
			46.5
		],
		[
			"2014-08-11",
			45.17
		],
		[
			"2015-11-12",
			43.75
		],
		[
			"2008-03-04",
			44.72
		],
		[
			"2009-03-17",
			46.92
		],
		[
			"2009-07-06",
			46.52
		],
		[
			"2009-11-16",
			47.42
		],
		[
			"2010-03-08",
			45.62
		],
		[
			"2010-07-13",
			45.62
		],
		[
			"2008-07-29",
			49.16
		],
		[
			"2010-05-03",
			48.71
		],
		[
			"2012-08-28",
			43.67
		]
	],
	"10409336": [
		[
			"2002-04-02",
			33.21
		],
		[
			"2006-12-06",
			35.21
		],
		[
			"2007-03-12",
			35.81
		],
		[
			"2007-07-11",
			36.41
		],
		[
			"2007-11-12",
			32.81
		],
		[
			"2008-07-15",
			34.91
		],
		[
			"2008-11-10",
			36.91
		],
		[
			"2010-11-16",
			33.39
		],
		[
			"2011-03-15",
			33.03
		],
		[
			"2011-07-27",
			33.12
		],
		[
			"2011-11-09",
			32.64
		],
		[
			"2012-03-12",
			34.1
		],
		[
			"2012-07-16",
			35.11
		],
		[
			"2012-11-20",
			32.77
		],
		[
			"2013-03-25",
			35.11
		],
		[
			"2013-07-29",
			33.3
		],
		[
			"2013-11-12",
			35.82
		],
		[
			"2014-04-07",
			33.74
		],
		[
			"2014-07-22",
			33.34
		],
		[
			"2014-11-17",
			33.79
		],
		[
			"2015-03-16",
			33.7
		],
		[
			"2015-06-08",
			35.16
		],
		[
			"2015-11-03",
			34.01
		],
		[
			"2008-03-04",
			34.21
		],
		[
			"2009-03-17",
			32.81
		],
		[
			"2009-07-06",
			33.01
		],
		[
			"2009-11-16",
			32.31
		],
		[
			"2010-03-08",
			31.61
		],
		[
			"2010-07-13",
			31.48
		]
	],
	"10409348": [
		[
			"2002-04-02",
			24.71
		],
		[
			"2006-11-03",
			25.69
		],
		[
			"2007-01-24",
			26.53
		],
		[
			"2007-03-12",
			26.81
		],
		[
			"2007-07-11",
			27.01
		],
		[
			"2007-11-12",
			24.61
		],
		[
			"2008-07-15",
			26.01
		],
		[
			"2008-11-10",
			26.11
		],
		[
			"2008-04-29",
			26.88
		],
		[
			"2010-11-16",
			25.95
		],
		[
			"2011-03-15",
			25.46
		],
		[
			"2011-07-27",
			25.38
		],
		[
			"2011-11-09",
			25.02
		],
		[
			"2012-03-12",
			26.84
		],
		[
			"2012-07-16",
			28.7
		],
		[
			"2012-11-20",
			26.57
		],
		[
			"2013-03-25",
			25.95
		],
		[
			"2013-07-29",
			27.01
		],
		[
			"2013-11-12",
			27.77
		],
		[
			"2014-04-07",
			27.28
		],
		[
			"2014-07-22",
			25.82
		],
		[
			"2014-11-17",
			26.22
		],
		[
			"2015-03-16",
			27.19
		],
		[
			"2015-06-08",
			26.39
		],
		[
			"2015-11-03",
			27.06
		],
		[
			"2008-03-04",
			25.51
		],
		[
			"2009-03-17",
			26.61
		],
		[
			"2009-07-06",
			24.51
		],
		[
			"2009-11-16",
			23.91
		],
		[
			"2010-03-08",
			24.91
		],
		[
			"2010-07-13",
			25.33
		]
	],
	"10409385": [
		[
			"2000-03-20",
			9
		],
		[
			"2000-11-13",
			8.41
		],
		[
			"2000-07-18",
			9.5
		],
		[
			"2000-11-07",
			9.2
		],
		[
			"2001-01-30",
			8.6
		],
		[
			"2001-03-12",
			8.7
		],
		[
			"2001-07-12",
			9.6
		],
		[
			"2001-11-12",
			8.8
		],
		[
			"2002-03-05",
			9.7
		],
		[
			"2003-03-10",
			9.2
		],
		[
			"2003-07-14",
			9.3
		],
		[
			"2003-11-24",
			9
		],
		[
			"2005-04-05",
			8.7
		],
		[
			"2004-03-02",
			8.7
		],
		[
			"2004-07-06",
			7.8
		],
		[
			"2004-11-22",
			9.9
		],
		[
			"2005-07-05",
			8.7
		],
		[
			"2005-11-03",
			8.1
		],
		[
			"2006-04-10",
			8.86
		],
		[
			"2006-03-13",
			8.2
		],
		[
			"2006-07-11",
			7.9
		],
		[
			"2006-11-29",
			8.3
		],
		[
			"2007-03-12",
			8.3
		],
		[
			"2007-07-11",
			7.6
		],
		[
			"2007-11-12",
			7.4
		],
		[
			"2008-07-15",
			8.6
		],
		[
			"2008-11-10",
			8.6
		],
		[
			"2010-11-16",
			9.47
		],
		[
			"2011-03-15",
			10.14
		],
		[
			"2011-07-27",
			9.47
		],
		[
			"2011-11-09",
			8.81
		],
		[
			"2012-03-12",
			8.54
		],
		[
			"2012-07-16",
			9.52
		],
		[
			"2012-11-20",
			8.1
		],
		[
			"2013-03-25",
			8.37
		],
		[
			"2013-07-29",
			8.77
		],
		[
			"2013-11-12",
			8.37
		],
		[
			"2014-04-07",
			7.61
		],
		[
			"2014-07-22",
			7.92
		],
		[
			"2014-11-17",
			7.92
		],
		[
			"2015-03-16",
			8.06
		],
		[
			"2015-06-08",
			8.32
		],
		[
			"2015-11-03",
			8.77
		],
		[
			"2008-03-04",
			8.3
		],
		[
			"2009-03-17",
			8.9
		],
		[
			"2009-07-06",
			8.7
		],
		[
			"2009-11-16",
			8.5
		],
		[
			"2010-03-08",
			8.8
		],
		[
			"2010-07-13",
			8.41
		],
		[
			"2008-09-12",
			7.26
		]
	],
	"10409397": [
		[
			"2000-03-20",
			6.6
		],
		[
			"2000-11-13",
			3.99
		],
		[
			"2000-07-18",
			4.5
		],
		[
			"2000-11-07",
			5.1
		],
		[
			"2001-03-12",
			7.4
		],
		[
			"2001-07-12",
			7.4
		],
		[
			"2001-11-12",
			7.2
		],
		[
			"2002-03-05",
			8.9
		],
		[
			"2003-03-10",
			10.8
		],
		[
			"2003-07-14",
			6.9
		],
		[
			"2003-11-24",
			7.5
		],
		[
			"2005-04-05",
			9.9
		],
		[
			"2004-03-02",
			9
		],
		[
			"2004-07-06",
			4.9
		],
		[
			"2004-11-22",
			7.7
		],
		[
			"2005-07-05",
			7.1
		],
		[
			"2005-11-03",
			4.3
		],
		[
			"2006-03-13",
			6.6
		],
		[
			"2006-07-11",
			7.2
		],
		[
			"2007-03-12",
			7
		],
		[
			"2007-07-11",
			8.8
		],
		[
			"2007-04-17",
			8.24
		],
		[
			"2007-11-12",
			4.7
		],
		[
			"2008-07-15",
			5.8
		],
		[
			"2008-11-10",
			4.4
		],
		[
			"2010-11-16",
			9.34
		],
		[
			"2011-03-15",
			11.64
		],
		[
			"2011-07-27",
			10.05
		],
		[
			"2011-11-09",
			9.12
		],
		[
			"2012-03-12",
			13.24
		],
		[
			"2012-07-16",
			14.44
		],
		[
			"2012-11-20",
			12
		],
		[
			"2013-03-25",
			12.35
		],
		[
			"2013-07-29",
			12.26
		],
		[
			"2013-11-12",
			8.77
		],
		[
			"2014-04-07",
			11.33
		],
		[
			"2014-07-22",
			11.16
		],
		[
			"2014-11-17",
			8.68
		],
		[
			"2015-03-16",
			10.31
		],
		[
			"2015-06-08",
			12.04
		],
		[
			"2015-11-03",
			9.25
		],
		[
			"2014-08-11",
			12.44
		],
		[
			"2015-11-12",
			10.19
		],
		[
			"2008-03-04",
			6.7
		],
		[
			"2009-03-17",
			5.7
		],
		[
			"2009-07-06",
			6.2
		],
		[
			"2010-03-08",
			8.2
		],
		[
			"2010-07-13",
			10.31
		],
		[
			"2008-09-12",
			1.33
		],
		[
			"2011-03-14",
			11.82
		],
		[
			"2012-08-28",
			12.4
		]
	],
	"10409403": [
		[
			"2002-08-23",
			16.83
		],
		[
			"2004-02-05",
			26.57
		],
		[
			"2005-09-30",
			17.27
		],
		[
			"2006-01-30",
			20.37
		],
		[
			"2007-01-11",
			32.9
		],
		[
			"2008-04-04",
			18.16
		],
		[
			"2014-12-03",
			4.43
		],
		[
			"2015-09-17",
			5.49
		],
		[
			"2010-11-17",
			8.41
		],
		[
			"2011-05-12",
			5.85
		]
	],
	"10409415": [
		[
			"2000-05-23",
			72.63
		],
		[
			"2001-06-01",
			65.99
		],
		[
			"2002-06-18",
			65.99
		],
		[
			"2003-05-28",
			60.67
		],
		[
			"2005-02-01",
			58.46
		],
		[
			"2004-02-04",
			59.79
		],
		[
			"2006-01-18",
			59.34
		],
		[
			"2007-01-11",
			66.43
		],
		[
			"2008-06-06",
			60.67
		],
		[
			"2014-06-27",
			80.16
		],
		[
			"2015-02-24",
			77.94
		],
		[
			"2016-01-21",
			93
		],
		[
			"2010-03-18",
			60.23
		],
		[
			"2011-03-14",
			62
		],
		[
			"2012-06-25",
			69.09
		],
		[
			"2013-03-28",
			72.19
		]
	],
	"10409488": [
		[
			"2000-07-10",
			36.76
		],
		[
			"2001-05-04",
			36.31
		],
		[
			"2002-05-06",
			27.01
		],
		[
			"2003-06-10",
			33.66
		],
		[
			"2005-03-02",
			33.21
		],
		[
			"2004-02-04",
			36.31
		],
		[
			"2006-01-24",
			36.31
		],
		[
			"2007-01-24",
			35.21
		],
		[
			"2008-04-04",
			35.34
		],
		[
			"2014-04-10",
			32.06
		],
		[
			"2015-03-05",
			30.6
		],
		[
			"2016-01-21",
			30.56
		],
		[
			"2010-03-29",
			32.24
		],
		[
			"2011-06-10",
			32.42
		],
		[
			"2012-04-19",
			29.1
		],
		[
			"2013-03-28",
			29.58
		]
	],
	"10409580": [
		[
			"2000-05-23",
			31.44
		],
		[
			"2001-05-10",
			25.24
		],
		[
			"2002-06-18",
			30.11
		],
		[
			"2003-04-28",
			32.33
		],
		[
			"2005-03-02",
			28.79
		],
		[
			"2004-02-03",
			28.34
		],
		[
			"2006-02-09",
			31.89
		],
		[
			"2007-01-18",
			26.75
		],
		[
			"2008-06-06",
			26.22
		],
		[
			"2013-07-18",
			14.17
		],
		[
			"2015-11-17",
			11.2
		],
		[
			"2010-04-15",
			12.93
		],
		[
			"2011-10-27",
			14.97
		]
	],
	"10409609": [
		[
			"2000-04-10",
			10.63
		],
		[
			"2001-05-04",
			12.4
		],
		[
			"2002-05-06",
			14.17
		],
		[
			"2003-10-17",
			9.74
		],
		[
			"2004-02-04",
			17.27
		],
		[
			"2005-03-11",
			12.4
		],
		[
			"2006-01-16",
			12.4
		],
		[
			"2007-01-26",
			17.09
		],
		[
			"2008-04-02",
			13.02
		],
		[
			"2013-05-03",
			6.55
		],
		[
			"2014-04-03",
			7.53
		],
		[
			"2015-11-17",
			4.07
		],
		[
			"2010-03-11",
			12.4
		],
		[
			"2011-05-12",
			9.43
		],
		[
			"2012-03-15",
			8.06
		]
	],
	"10409610": [
		[
			"2000-04-10",
			21.7
		],
		[
			"2001-05-04",
			22.14
		],
		[
			"2002-05-06",
			19.04
		],
		[
			"2003-04-28",
			19.49
		],
		[
			"2005-03-02",
			18.6
		],
		[
			"2004-01-29",
			19.93
		],
		[
			"2006-01-16",
			15.06
		],
		[
			"2007-01-25",
			18.82
		],
		[
			"2008-04-02",
			19.13
		],
		[
			"2014-10-23",
			15.15
		],
		[
			"2015-12-10",
			15.19
		],
		[
			"2010-03-11",
			17.18
		],
		[
			"2011-04-08",
			16.92
		],
		[
			"2012-03-15",
			16.74
		],
		[
			"2013-03-04",
			16.16
		]
	],
	"10409622": [
		[
			"2004-02-06",
			17.71
		],
		[
			"2005-03-11",
			15.94
		],
		[
			"2006-01-24",
			17.71
		],
		[
			"2007-01-18",
			16.39
		],
		[
			"2008-06-06",
			15.19
		],
		[
			"2013-11-28",
			12.71
		],
		[
			"2014-02-20",
			12.4
		],
		[
			"2015-12-10",
			12.53
		],
		[
			"2016-01-25",
			12.4
		],
		[
			"2010-11-17",
			13.73
		]
	],
	"10409646": [
		[
			"2000-03-30",
			15.94
		],
		[
			"2001-05-03",
			21.26
		],
		[
			"2002-07-09",
			19.49
		],
		[
			"2003-05-28",
			22.59
		],
		[
			"2004-02-04",
			23.91
		],
		[
			"2005-03-11",
			25.24
		],
		[
			"2007-02-07",
			23.69
		],
		[
			"2007-04-17",
			20.06
		],
		[
			"2008-04-04",
			25.11
		],
		[
			"2015-04-16",
			18.25
		],
		[
			"2010-04-29",
			14.79
		],
		[
			"2011-04-28",
			18.56
		],
		[
			"2013-03-04",
			22.01
		]
	],
	"10409658": [
		[
			"2000-07-10",
			45.61
		],
		[
			"2001-05-03",
			45.17
		],
		[
			"2002-05-06",
			46.5
		],
		[
			"2003-05-28",
			52.26
		],
		[
			"2004-02-03",
			54.91
		],
		[
			"2005-06-20",
			50.04
		],
		[
			"2006-01-16",
			57.13
		],
		[
			"2007-01-05",
			32.46
		],
		[
			"2008-03-31",
			41.01
		],
		[
			"2014-04-10",
			35.52
		],
		[
			"2015-04-16",
			29.05
		],
		[
			"2016-01-27",
			31.89
		],
		[
			"2009-08-27",
			42.03
		],
		[
			"2011-03-31",
			37.64
		],
		[
			"2012-04-26",
			39.55
		],
		[
			"2013-03-04",
			35.07
		]
	],
	"10409671": [
		[
			"2000-08-23",
			5.31
		],
		[
			"2001-05-10",
			4.43
		],
		[
			"2002-08-23",
			4.87
		],
		[
			"2003-06-10",
			4.43
		],
		[
			"2005-02-28",
			4.87
		],
		[
			"2004-02-06",
			5.31
		],
		[
			"2006-01-25",
			5.31
		],
		[
			"2007-01-24",
			6.02
		],
		[
			"2008-03-19",
			9.74
		],
		[
			"2014-10-23",
			4.43
		],
		[
			"2015-11-24",
			3.99
		],
		[
			"2016-01-20",
			3.94
		],
		[
			"2009-03-13",
			6.86
		],
		[
			"2011-02-17",
			4.3
		],
		[
			"2012-04-26",
			4.21
		],
		[
			"2013-03-22",
			3.76
		]
	],
	"10409683": [
		[
			"2006-10-18",
			76.17
		],
		[
			"2008-03-31",
			80.16
		],
		[
			"2013-05-03",
			79.71
		],
		[
			"2015-04-16",
			81.04
		],
		[
			"2010-04-22",
			75.73
		],
		[
			"2011-07-21",
			77.94
		],
		[
			"2012-04-19",
			79.27
		]
	],
	"10409695": [
		[
			"2000-08-31",
			9.3
		],
		[
			"2001-08-01",
			10.19
		],
		[
			"2002-10-09",
			6.2
		],
		[
			"2003-07-02",
			7.97
		],
		[
			"2005-02-28",
			37.2
		],
		[
			"2004-03-12",
			12.4
		],
		[
			"2006-01-25",
			3.54
		],
		[
			"2007-01-24",
			10.81
		],
		[
			"2008-04-29",
			26.97
		],
		[
			"2013-08-02",
			8.41
		],
		[
			"2014-08-04",
			15.15
		],
		[
			"2015-02-09",
			22.1
		],
		[
			"2016-01-20",
			9.3
		],
		[
			"2010-05-31",
			12.75
		],
		[
			"2011-09-12",
			7.4
		],
		[
			"2012-11-22",
			3.85
		]
	],
	"10409701": [
		[
			"2000-05-23",
			37.2
		],
		[
			"2001-08-01",
			38.09
		],
		[
			"2002-06-18",
			40.3
		],
		[
			"2003-07-03",
			37.64
		],
		[
			"2003-10-17",
			37.64
		],
		[
			"2005-02-28",
			34.1
		],
		[
			"2004-03-12",
			37.2
		],
		[
			"2006-02-06",
			37.2
		],
		[
			"2007-01-11",
			36.85
		],
		[
			"2008-04-29",
			39.46
		],
		[
			"2014-06-27",
			30.38
		],
		[
			"2015-02-24",
			30.38
		],
		[
			"2010-03-04",
			32.55
		],
		[
			"2011-10-27",
			33.04
		],
		[
			"2012-11-22",
			31.49
		],
		[
			"2013-03-07",
			32.77
		]
	],
	"10409865": [
		[
			"2000-04-10",
			17.71
		],
		[
			"2001-07-16",
			17.27
		],
		[
			"2002-07-02",
			17.71
		],
		[
			"2003-06-10",
			14.61
		],
		[
			"2005-03-10",
			15.06
		],
		[
			"2004-02-02",
			16.39
		],
		[
			"2006-01-24",
			14.61
		],
		[
			"2007-01-09",
			15.1
		],
		[
			"2008-01-09",
			21.39
		],
		[
			"2013-06-18",
			13.33
		],
		[
			"2014-04-03",
			13.24
		],
		[
			"2015-04-16",
			13.64
		],
		[
			"2016-01-21",
			10.63
		],
		[
			"2009-12-07",
			25.51
		],
		[
			"2011-04-08",
			19.13
		],
		[
			"2012-03-22",
			17.36
		]
	],
	"10409919": [
		[
			"2000-07-13",
			43.4
		],
		[
			"2001-07-30",
			41.19
		],
		[
			"2002-08-22",
			36.31
		],
		[
			"2003-06-11",
			42.07
		],
		[
			"2005-03-09",
			53.59
		],
		[
			"2004-02-03",
			67.31
		],
		[
			"2006-01-18",
			56.24
		],
		[
			"2007-01-26",
			63.77
		],
		[
			"2008-04-02",
			62.44
		],
		[
			"2013-05-03",
			60.67
		],
		[
			"2014-04-03",
			54.47
		],
		[
			"2015-03-09",
			54.47
		],
		[
			"2010-04-15",
			46.06
		],
		[
			"2011-05-12",
			47.83
		],
		[
			"2012-03-29",
			65.1
		]
	],
	"10409920": [
		[
			"2001-07-26",
			14.61
		],
		[
			"2006-04-05",
			17.27
		],
		[
			"2007-01-05",
			12.31
		],
		[
			"2008-03-25",
			14.35
		],
		[
			"2015-04-16",
			4.83
		],
		[
			"2000-04-19",
			11.96
		],
		[
			"2009-08-27",
			7.57
		],
		[
			"2011-05-20",
			6.55
		]
	],
	"10409956": [
		[
			"2000-07-18",
			23.91
		],
		[
			"2001-07-26",
			17.71
		],
		[
			"2002-08-22",
			20.37
		],
		[
			"2005-03-07",
			23.47
		],
		[
			"2004-02-03",
			27.46
		],
		[
			"2006-01-19",
			27.01
		],
		[
			"2007-01-09",
			29.54
		],
		[
			"2008-03-18",
			26
		],
		[
			"2014-07-14",
			39.41
		],
		[
			"2015-02-18",
			34.81
		],
		[
			"2003-07-01",
			19.04
		],
		[
			"2009-03-13",
			20.06
		],
		[
			"2009-08-06",
			16.56
		],
		[
			"2011-02-17",
			20.55
		],
		[
			"2012-03-22",
			23.65
		],
		[
			"2013-03-07",
			25.86
		]
	],
	"10409968": [
		[
			"2000-07-18",
			24.36
		],
		[
			"2001-07-26",
			14.17
		],
		[
			"2002-08-22",
			13.73
		],
		[
			"2005-03-10",
			23.91
		],
		[
			"2004-02-12",
			52.26
		],
		[
			"2006-03-03",
			26.13
		],
		[
			"2007-01-09",
			39.81
		],
		[
			"2008-03-18",
			42.29
		],
		[
			"2015-02-18",
			30.2
		],
		[
			"2003-07-01",
			6.2
		],
		[
			"2010-03-04",
			42.82
		],
		[
			"2011-03-10",
			40.08
		],
		[
			"2012-03-22",
			39.86
		],
		[
			"2013-03-07",
			42.07
		]
	],
	"10409993": [
		[
			"2003-06-11",
			13.29
		],
		[
			"2005-03-07",
			13.29
		],
		[
			"2004-02-02",
			13.73
		],
		[
			"2006-02-06",
			15.06
		],
		[
			"2007-01-23",
			17.01
		],
		[
			"2008-01-28",
			16.96
		],
		[
			"2015-06-18",
			11.07
		],
		[
			"2011-07-21",
			11.82
		],
		[
			"2012-12-06",
			11.12
		]
	],
	"10410004": [
		[
			"2004-02-02",
			13.73
		],
		[
			"2006-01-18",
			16.83
		],
		[
			"2007-01-25",
			14.39
		],
		[
			"2008-08-25",
			11.47
		],
		[
			"2015-12-10",
			10.94
		],
		[
			"2010-03-25",
			10.41
		]
	],
	"10410030": [
		[
			"2004-02-05",
			11.51
		],
		[
			"2005-06-20",
			10.63
		],
		[
			"2006-02-23",
			12.84
		],
		[
			"2007-04-27",
			11.25
		],
		[
			"2008-03-31",
			16.21
		],
		[
			"2013-06-25",
			8.68
		],
		[
			"2015-09-17",
			8.68
		],
		[
			"2000-04-19",
			11.07
		],
		[
			"2010-11-17",
			10.58
		],
		[
			"2011-10-27",
			8.24
		],
		[
			"2012-11-22",
			8.77
		]
	],
	"10410041": [
		[
			"2000-07-13",
			31.44
		],
		[
			"2001-07-30",
			26.57
		],
		[
			"2002-08-19",
			23.91
		],
		[
			"2003-06-11",
			23.47
		],
		[
			"2005-03-10",
			23.47
		],
		[
			"2004-02-05",
			26.57
		],
		[
			"2006-03-09",
			27.9
		],
		[
			"2007-01-25",
			44.29
		],
		[
			"2008-04-04",
			36.76
		],
		[
			"2013-06-25",
			21.43
		],
		[
			"2015-08-12",
			20.46
		],
		[
			"2016-01-25",
			26.57
		],
		[
			"2011-12-23",
			19
		],
		[
			"2012-11-22",
			22.14
		]
	],
	"10410053": [
		[
			"2000-04-10",
			24.8
		],
		[
			"2001-06-27",
			26.13
		],
		[
			"2002-06-18",
			25.69
		],
		[
			"2003-10-20",
			28.34
		],
		[
			"2005-03-10",
			20.37
		],
		[
			"2004-02-11",
			19.04
		],
		[
			"2006-01-24",
			25.24
		],
		[
			"2007-01-11",
			21.79
		],
		[
			"2008-04-07",
			25.15
		],
		[
			"2014-08-11",
			14.35
		],
		[
			"2015-03-05",
			20.19
		],
		[
			"2010-03-29",
			18.82
		],
		[
			"2011-04-28",
			21.83
		],
		[
			"2012-03-29",
			22.14
		],
		[
			"2013-03-28",
			16.87
		]
	],
	"10410077": [
		[
			"2001-06-27",
			1.33
		],
		[
			"2003-07-24",
			0.44
		],
		[
			"2005-03-03",
			0.44
		],
		[
			"2004-02-11",
			1.77
		],
		[
			"2006-02-20",
			0.44
		],
		[
			"2007-01-05",
			0.44
		],
		[
			"2008-03-19",
			1.73
		],
		[
			"2013-07-19",
			84.14
		],
		[
			"2014-07-31",
			1.33
		],
		[
			"2015-10-28",
			0.13
		],
		[
			"2016-01-21",
			0.44
		],
		[
			"2010-09-17",
			0.35
		],
		[
			"2011-03-10",
			0.27
		],
		[
			"2012-06-11",
			0.31
		]
	],
	"10410089": [
		[
			"2001-06-27",
			11.07
		],
		[
			"2002-08-19",
			8.41
		],
		[
			"2004-02-12",
			8.86
		],
		[
			"2005-06-20",
			9.74
		],
		[
			"2006-03-03",
			11.07
		],
		[
			"2007-01-23",
			9.43
		],
		[
			"2008-03-31",
			7.04
		],
		[
			"2015-11-17",
			5.23
		],
		[
			"2000-04-19",
			8.86
		],
		[
			"2010-09-16",
			6.86
		]
	],
	"10410090": [
		[
			"2000-08-23",
			15.94
		],
		[
			"2001-06-01",
			16.39
		],
		[
			"2002-08-19",
			12.84
		],
		[
			"2003-06-11",
			14.17
		],
		[
			"2005-03-08",
			19.93
		],
		[
			"2004-02-05",
			25.69
		],
		[
			"2006-02-06",
			19.49
		],
		[
			"2007-01-25",
			22.05
		],
		[
			"2008-05-29",
			14.88
		],
		[
			"2014-02-20",
			12.36
		],
		[
			"2015-06-18",
			11.34
		],
		[
			"2016-01-25",
			12.4
		],
		[
			"2010-06-10",
			13.2
		],
		[
			"2011-05-20",
			12.49
		],
		[
			"2012-06-11",
			12.44
		],
		[
			"2013-03-08",
			11.2
		]
	],
	"10410132": [
		[
			"2000-11-10",
			30.11
		],
		[
			"2001-08-02",
			26.13
		],
		[
			"2003-07-24",
			16.83
		],
		[
			"2004-06-18",
			13.73
		],
		[
			"2005-07-19",
			18.6
		],
		[
			"2007-03-28",
			25.46
		],
		[
			"2008-03-19",
			19.97
		],
		[
			"2014-07-14",
			17.18
		],
		[
			"2015-02-18",
			17.36
		],
		[
			"2006-03-31",
			37.2
		],
		[
			"2010-09-02",
			17.23
		],
		[
			"2011-03-10",
			17.71
		],
		[
			"2012-06-11",
			17.71
		],
		[
			"2013-03-08",
			16.7
		]
	],
	"10410193": [
		[
			"2005-03-03",
			18.16
		],
		[
			"2004-07-05",
			20.81
		],
		[
			"2006-01-30",
			20.37
		],
		[
			"2007-01-26",
			19.4
		],
		[
			"2008-04-02",
			18.42
		],
		[
			"2008-06-06",
			19.57
		],
		[
			"2014-02-20",
			15.01
		],
		[
			"2015-03-09",
			15.1
		],
		[
			"2016-01-25",
			15.5
		],
		[
			"2009-09-25",
			16.08
		],
		[
			"2011-02-07",
			15.72
		],
		[
			"2012-04-19",
			16.12
		],
		[
			"2013-03-08",
			15.32
		]
	],
	"10410211": [
		[
			"2004-07-05",
			12.4
		],
		[
			"2005-03-09",
			17.71
		],
		[
			"2006-03-09",
			23.03
		],
		[
			"2007-01-23",
			26.84
		],
		[
			"2008-03-31",
			25.86
		],
		[
			"2015-11-17",
			10.81
		],
		[
			"2010-09-24",
			17.45
		],
		[
			"2011-10-07",
			8.99
		],
		[
			"2012-12-21",
			17.32
		]
	],
	"10410235": [
		[
			"2006-11-30",
			16.56
		],
		[
			"2007-03-28",
			16.52
		],
		[
			"2008-10-21",
			12.84
		],
		[
			"2013-07-19",
			11.07
		],
		[
			"2014-07-14",
			12.27
		],
		[
			"2015-02-18",
			10.01
		],
		[
			"2009-08-06",
			2.92
		],
		[
			"2011-07-21",
			12.22
		]
	],
	"10410247": [
		[
			"2006-11-30",
			17.49
		],
		[
			"2007-03-29",
			16.47
		],
		[
			"2008-10-21",
			16.25
		],
		[
			"2015-10-28",
			10.98
		],
		[
			"2010-09-02",
			13.55
		],
		[
			"2011-12-16",
			12.93
		]
	],
	"10421361": [
		[
			"2014-06-24",
			3.8
		],
		[
			"2014-10-21",
			4.4
		],
		[
			"2015-06-10",
			7.2
		],
		[
			"2015-08-26",
			4.7
		],
		[
			"2003-08-13",
			3
		],
		[
			"2005-11-16",
			1.7
		],
		[
			"2006-10-18",
			3.5
		],
		[
			"2007-03-20",
			5.3
		],
		[
			"2006-12-06",
			2
		],
		[
			"2007-11-06",
			4.5
		],
		[
			"2008-06-24",
			8.1
		],
		[
			"2008-10-28",
			6.5
		],
		[
			"2009-10-31",
			8.9
		],
		[
			"2009-11-17",
			3
		],
		[
			"2010-11-09",
			4.6
		],
		[
			"2011-05-11",
			8.9
		],
		[
			"2011-09-28",
			5.5
		],
		[
			"2012-05-08",
			7.3
		],
		[
			"2012-10-24",
			3.2
		]
	],
	"10421373": [
		[
			"2003-05-13",
			31.44
		],
		[
			"2004-10-06",
			33.21
		],
		[
			"2014-10-21",
			29.31
		],
		[
			"2015-06-10",
			27.71
		],
		[
			"2015-08-26",
			23.71
		],
		[
			"2003-08-13",
			22.61
		],
		[
			"2004-05-11",
			32.01
		],
		[
			"2005-11-16",
			22.91
		],
		[
			"2006-12-06",
			30.61
		],
		[
			"2007-03-20",
			32.81
		],
		[
			"2007-11-06",
			32.41
		],
		[
			"2008-06-24",
			31.51
		],
		[
			"2008-10-29",
			30.51
		],
		[
			"2009-03-31",
			32.21
		],
		[
			"2010-04-14",
			31.31
		],
		[
			"2010-11-09",
			30.81
		],
		[
			"2011-05-11",
			29.91
		],
		[
			"2011-08-28",
			31.51
		],
		[
			"2012-05-08",
			30.81
		],
		[
			"2012-10-24",
			30.51
		]
	],
	"10421397": [
		[
			"2003-05-13",
			36.31
		],
		[
			"2004-10-07",
			33.21
		],
		[
			"2014-06-24",
			24.91
		],
		[
			"2014-10-21",
			24.01
		],
		[
			"2015-06-10",
			24.21
		],
		[
			"2015-08-26",
			24.11
		],
		[
			"2003-08-13",
			36.21
		],
		[
			"2004-05-11",
			36.21
		],
		[
			"2005-11-23",
			34.11
		],
		[
			"2006-10-18",
			31.01
		],
		[
			"2007-03-21",
			32.61
		],
		[
			"2007-11-06",
			32.51
		],
		[
			"2008-06-25",
			29.21
		],
		[
			"2008-10-28",
			28.91
		],
		[
			"2009-03-31",
			29.51
		],
		[
			"2009-11-17",
			28.01
		],
		[
			"2010-04-13",
			27.51
		],
		[
			"2011-07-27",
			27.51
		],
		[
			"2011-09-27",
			28.71
		],
		[
			"2012-05-09",
			27.21
		],
		[
			"2012-10-23",
			27.71
		]
	],
	"10421403": [
		[
			"2014-10-21",
			2.8
		],
		[
			"2015-06-10",
			4.6
		],
		[
			"2015-08-26",
			4.7
		],
		[
			"2003-08-20",
			3.3
		],
		[
			"2005-11-23",
			1.4
		],
		[
			"2006-12-06",
			1.2
		],
		[
			"2007-03-21",
			4.6
		],
		[
			"2007-11-07",
			3
		],
		[
			"2006-06-24",
			109.04
		],
		[
			"2008-10-29",
			4.2
		],
		[
			"2009-03-31",
			3
		],
		[
			"2010-04-14",
			3.2
		],
		[
			"2010-11-09",
			1.5
		],
		[
			"2011-05-10",
			4.3
		],
		[
			"2011-09-28",
			3.8
		],
		[
			"2012-05-09",
			6.6
		],
		[
			"2012-10-24",
			4
		]
	],
	"10421415": [
		[
			"2003-05-15",
			238.26
		],
		[
			"2014-06-24",
			154.05
		],
		[
			"2014-10-21",
			2.2
		],
		[
			"2015-06-10",
			144.05
		],
		[
			"2015-08-26",
			114.04
		],
		[
			"2003-08-20",
			231.08
		],
		[
			"2003-10-30",
			225.08
		],
		[
			"2004-12-08",
			183.06
		],
		[
			"2005-11-23",
			164.06
		],
		[
			"2006-10-18",
			115.04
		],
		[
			"2007-03-21",
			6
		],
		[
			"2007-11-06",
			85.03
		],
		[
			"2008-06-25",
			5.3
		],
		[
			"2008-10-28",
			130.05
		],
		[
			"2009-04-01",
			99.24
		],
		[
			"2009-11-18",
			157.06
		],
		[
			"2010-04-13",
			159.06
		],
		[
			"2010-11-10",
			25.81
		],
		[
			"2011-05-10",
			186.07
		],
		[
			"2011-09-27",
			169.06
		],
		[
			"2012-05-08",
			178.06
		],
		[
			"2012-10-23",
			180.06
		]
	],
	"10421427": [
		[
			"2003-05-15",
			27.9
		],
		[
			"2014-06-24",
			21.31
		],
		[
			"2014-10-21",
			25.01
		],
		[
			"2015-06-10",
			23.51
		],
		[
			"2015-08-26",
			25.41
		],
		[
			"2003-08-20",
			26.21
		],
		[
			"2004-12-08",
			15.71
		],
		[
			"2005-11-23",
			9.3
		],
		[
			"2006-10-18",
			14.11
		],
		[
			"2007-03-21",
			18.01
		],
		[
			"2007-11-07",
			20.71
		],
		[
			"2008-06-25",
			30.11
		],
		[
			"2008-10-29",
			27.71
		],
		[
			"2009-11-18",
			54.32
		],
		[
			"2010-04-13",
			33.51
		],
		[
			"2009-04-01",
			31.21
		],
		[
			"2010-11-10",
			17.11
		],
		[
			"2011-05-10",
			38.21
		],
		[
			"2011-09-27",
			23.71
		],
		[
			"2012-05-08",
			27.31
		],
		[
			"2012-10-23",
			26.81
		]
	],
	"10421439": [
		[
			"2003-05-13",
			16.83
		],
		[
			"2004-10-07",
			0.89
		],
		[
			"2014-06-24",
			0.7
		],
		[
			"2014-10-21",
			173.06
		],
		[
			"2015-06-10",
			25.31
		],
		[
			"2015-08-26",
			10.1
		],
		[
			"2003-08-20",
			2.4
		],
		[
			"2005-11-16",
			1.4
		],
		[
			"2006-10-18",
			9.6
		],
		[
			"2007-03-20",
			7.2
		],
		[
			"2007-11-06",
			16.81
		],
		[
			"2008-06-24",
			34.21
		],
		[
			"2008-10-28",
			30.31
		],
		[
			"2009-04-01",
			52.72
		],
		[
			"2009-11-17",
			21.21
		],
		[
			"2010-04-13",
			23.01
		],
		[
			"2010-11-10",
			162.06
		],
		[
			"2011-05-10",
			26.31
		],
		[
			"2011-09-27",
			13.5
		],
		[
			"2012-05-09",
			15.81
		],
		[
			"2012-10-23",
			3.1
		]
	],
	"10424120": [
		[
			"2011-11-15",
			0.2
		],
		[
			"2012-03-05",
			0.2
		],
		[
			"2012-11-13",
			0.2
		],
		[
			"2013-03-05",
			0.2
		],
		[
			"2013-11-13",
			0.2
		],
		[
			"2014-04-08",
			0.2
		],
		[
			"2014-12-01",
			0.2
		],
		[
			"2015-03-18",
			0.89
		]
	],
	"10424167": [
		[
			"2011-11-15",
			0.2
		],
		[
			"2012-03-05",
			0.2
		],
		[
			"2012-11-13",
			0.2
		],
		[
			"2013-03-05",
			0.2
		],
		[
			"2013-11-13",
			0.2
		],
		[
			"2014-04-08",
			0.2
		],
		[
			"2015-03-18",
			0.89
		]
	],
	"10424210": [
		[
			"2011-11-30",
			0.2
		],
		[
			"2012-03-05",
			0.2
		],
		[
			"2012-11-13",
			0.2
		],
		[
			"2013-03-05",
			0.2
		],
		[
			"2013-11-13",
			0.2
		],
		[
			"2014-04-08",
			0.2
		],
		[
			"2014-12-01",
			0.2
		],
		[
			"2015-03-18",
			0.89
		]
	],
	"11002268": [
		[
			"2000-02-28",
			44.73
		],
		[
			"2001-07-23",
			48.27
		],
		[
			"2002-09-26",
			50.04
		],
		[
			"2003-04-11",
			47.83
		],
		[
			"2004-02-10",
			50.04
		],
		[
			"2005-04-22",
			52.7
		],
		[
			"2006-08-29",
			46.94
		],
		[
			"2006-11-07",
			46.94
		],
		[
			"2008-03-20",
			60.23
		],
		[
			"2013-04-26",
			54.03
		],
		[
			"2014-03-24",
			50.04
		],
		[
			"2015-03-26",
			50.93
		],
		[
			"2016-02-29",
			44.29
		],
		[
			"2009-05-15",
			50.04
		],
		[
			"2011-01-21",
			45.61
		],
		[
			"2012-05-11",
			54.03
		],
		[
			"2012-10-19",
			49.6
		]
	],
	"11005154": [
		[
			"2000-02-24",
			77.06
		],
		[
			"2001-07-12",
			81.49
		],
		[
			"2002-08-26",
			85.91
		],
		[
			"2003-08-14",
			88.13
		],
		[
			"2003-06-03",
			81.03
		],
		[
			"2004-03-25",
			85.43
		],
		[
			"2004-01-15",
			101.86
		],
		[
			"2005-06-28",
			99.2
		],
		[
			"2005-05-13",
			92.13
		],
		[
			"2006-03-13",
			97.43
		],
		[
			"2006-06-19",
			89.43
		],
		[
			"2008-09-16",
			86.36
		],
		[
			"2010-06-09",
			75.29
		],
		[
			"2011-08-16",
			91.22
		],
		[
			"2012-07-16",
			76.61
		],
		[
			"2013-11-05",
			85.02
		],
		[
			"2014-05-19",
			75.73
		],
		[
			"2015-08-24",
			85.91
		],
		[
			"2013-04-19",
			59.34
		],
		[
			"2013-08-27",
			84.14
		],
		[
			"2014-08-13",
			80.6
		],
		[
			"2008-09-23",
			88.13
		],
		[
			"2011-06-06",
			81.93
		],
		[
			"2012-08-24",
			73.07
		]
	],
	"11006936": [
		[
			"2000-02-25",
			40.74
		],
		[
			"2001-06-07",
			22.59
		],
		[
			"2002-08-26",
			17.27
		],
		[
			"2003-08-13",
			17.27
		],
		[
			"2004-01-22",
			31.89
		],
		[
			"2005-06-16",
			22.59
		],
		[
			"2006-02-24",
			31
		],
		[
			"2007-03-08",
			22.67
		],
		[
			"2008-03-28",
			25.6
		],
		[
			"2008-09-29",
			10.36
		],
		[
			"2013-09-18",
			9.3
		],
		[
			"2015-11-19",
			8.46
		],
		[
			"2010-04-16",
			13.77
		],
		[
			"2010-09-10",
			11.56
		],
		[
			"2011-05-27",
			12
		],
		[
			"2011-09-23",
			9.03
		],
		[
			"2012-03-23",
			25.64
		]
	],
	"11006985": [
		[
			"2000-02-02",
			0.44
		],
		[
			"2001-03-21",
			0.44
		],
		[
			"2002-03-12",
			0.44
		],
		[
			"2003-08-12",
			2.66
		],
		[
			"2004-01-20",
			4.87
		],
		[
			"2005-06-21",
			4.43
		],
		[
			"2006-02-17",
			3.1
		],
		[
			"2007-03-07",
			1.51
		],
		[
			"2008-07-11",
			0.44
		],
		[
			"2013-09-18",
			6.64
		],
		[
			"2014-04-09",
			3.85
		],
		[
			"2015-09-07",
			2.26
		],
		[
			"2016-01-26",
			5.31
		],
		[
			"2010-09-13",
			58.9
		],
		[
			"2011-03-11",
			1.06
		],
		[
			"2012-03-23",
			0.93
		]
	],
	"11007023": [
		[
			"2000-11-29",
			80.6
		],
		[
			"2001-03-22",
			73.51
		],
		[
			"2002-03-19",
			95.66
		],
		[
			"2004-01-27",
			108.06
		],
		[
			"2005-06-29",
			93
		],
		[
			"2006-03-07",
			138.17
		],
		[
			"2007-03-19",
			120.01
		],
		[
			"2007-02-23",
			117.36
		],
		[
			"2008-01-24",
			116.47
		],
		[
			"2008-09-29",
			94.33
		],
		[
			"2013-10-10",
			70.86
		],
		[
			"2015-08-10",
			52.26
		],
		[
			"2016-01-26",
			79.71
		],
		[
			"2011-05-27",
			85.47
		],
		[
			"2011-09-23",
			73.51
		],
		[
			"2012-08-24",
			69.09
		]
	],
	"11050020": [
		[
			"2000-02-03",
			3.54
		],
		[
			"2001-03-22",
			14.17
		],
		[
			"2002-03-12",
			5.76
		],
		[
			"2003-08-14",
			4.87
		],
		[
			"2004-01-20",
			5.76
		],
		[
			"2005-03-29",
			3.99
		],
		[
			"2006-03-06",
			10.63
		],
		[
			"2007-03-07",
			2.08
		],
		[
			"2008-07-10",
			5.14
		],
		[
			"2013-09-19",
			5.58
		],
		[
			"2015-08-10",
			2.21
		],
		[
			"2016-01-27",
			4.07
		],
		[
			"2010-04-16",
			4.65
		],
		[
			"2010-09-10",
			0.13
		]
	],
	"11050093": [
		[
			"2000-02-29",
			62.89
		],
		[
			"2001-04-19",
			72.19
		],
		[
			"2002-03-19",
			86.36
		],
		[
			"2004-01-15",
			77.94
		],
		[
			"2005-07-15",
			77.5
		],
		[
			"2006-03-06",
			58.9
		],
		[
			"2007-01-08",
			52.7
		],
		[
			"2008-07-08",
			70.86
		],
		[
			"2013-09-19",
			29.63
		],
		[
			"2014-04-09",
			44.29
		],
		[
			"2015-05-20",
			74.84
		],
		[
			"2011-11-14",
			53.59
		],
		[
			"2012-11-23",
			25.02
		]
	],
	"16000614": [
		[
			"2000-08-17",
			1.77
		],
		[
			"2001-06-26",
			1.77
		],
		[
			"2002-08-14",
			0.44
		],
		[
			"2003-08-21",
			0.89
		],
		[
			"2004-02-09",
			0.44
		],
		[
			"2005-07-01",
			0.44
		],
		[
			"2006-08-15",
			0.44
		],
		[
			"2007-01-12",
			0.44
		],
		[
			"2008-03-20",
			2.97
		],
		[
			"2014-05-15",
			14.22
		],
		[
			"2015-05-07",
			12
		],
		[
			"2009-03-23",
			12.4
		],
		[
			"2011-05-30",
			14.92
		],
		[
			"2012-06-15",
			19.97
		]
	],
	"16000651": [
		[
			"2000-08-17",
			16.39
		],
		[
			"2001-06-26",
			16.83
		],
		[
			"2002-08-14",
			15.06
		],
		[
			"2003-08-21",
			17.27
		],
		[
			"2004-02-09",
			13.29
		],
		[
			"2005-07-01",
			8.86
		],
		[
			"2006-08-15",
			10.27
		],
		[
			"2007-01-12",
			12.27
		],
		[
			"2008-03-20",
			6.91
		],
		[
			"2013-06-14",
			6.91
		],
		[
			"2014-05-15",
			10.94
		],
		[
			"2015-05-07",
			8.64
		],
		[
			"2009-03-23",
			15.23
		],
		[
			"2011-04-15",
			6.24
		],
		[
			"2012-04-16",
			11.43
		]
	],
	"16000997": [
		[
			"2008-09-15",
			138.17
		],
		[
			"2013-06-14",
			100.53
		],
		[
			"2014-05-15",
			103.63
		],
		[
			"2015-04-20",
			100.09
		],
		[
			"2009-03-23",
			124.44
		],
		[
			"2011-04-15",
			122.23
		],
		[
			"2012-04-16",
			111.16
		]
	],
	"16001606": [
		[
			"2012-11-26",
			100.53
		],
		[
			"2013-11-20",
			98.76
		],
		[
			"2014-08-19",
			90.78
		],
		[
			"2000-09-06",
			85.47
		],
		[
			"2000-09-19",
			88.57
		],
		[
			"2000-10-04",
			85.03
		],
		[
			"2000-11-06",
			85.91
		],
		[
			"2000-12-04",
			89.46
		],
		[
			"2001-01-10",
			88.57
		],
		[
			"2001-02-07",
			84.59
		],
		[
			"2001-03-05",
			85.91
		],
		[
			"2001-04-10",
			87.69
		],
		[
			"2001-06-05",
			80.6
		],
		[
			"2001-07-04",
			92.11
		],
		[
			"2001-08-21",
			94.77
		],
		[
			"2004-10-20",
			30.11
		],
		[
			"2005-11-16",
			75.29
		],
		[
			"2006-10-12",
			79.71
		],
		[
			"2014-10-06",
			110.27
		],
		[
			"2015-09-07",
			106.73
		],
		[
			"2016-01-26",
			106.29
		],
		[
			"2008-04-25",
			94.33
		],
		[
			"2010-02-09",
			105.84
		],
		[
			"2010-07-05",
			97.86
		],
		[
			"2011-02-17",
			109.39
		],
		[
			"2012-03-06",
			109.83
		]
	],
	"16001813": [
		[
			"2001-10-15",
			86.8
		],
		[
			"2003-11-10",
			21.83
		],
		[
			"2002-10-17",
			21.04
		],
		[
			"2004-11-09",
			19.93
		],
		[
			"2004-10-09",
			19.93
		],
		[
			"2005-11-04",
			20.37
		],
		[
			"2006-10-10",
			19.13
		],
		[
			"2007-10-11",
			19.26
		],
		[
			"2008-10-22",
			22.23
		],
		[
			"2009-10-30",
			22.54
		],
		[
			"2010-10-29",
			22.14
		],
		[
			"2011-10-21",
			22.14
		],
		[
			"2012-10-18",
			13.29
		],
		[
			"2013-11-04",
			12.84
		],
		[
			"2014-11-24",
			15.94
		],
		[
			"2015-11-23",
			20.37
		]
	],
	"16003706": [
		[
			"2007-03-20",
			14.39
		],
		[
			"2013-04-26",
			22.72
		],
		[
			"2014-03-10",
			27.1
		],
		[
			"2015-03-26",
			18.25
		],
		[
			"2008-12-17",
			9.7
		],
		[
			"2008-07-09",
			10.72
		],
		[
			"2009-07-20",
			20.02
		],
		[
			"2011-01-31",
			12
		],
		[
			"2012-06-15",
			33.52
		]
	],
	"16003998": [
		[
			"2008-09-18",
			28.65
		],
		[
			"2013-05-27",
			25.82
		],
		[
			"2015-02-11",
			23.96
		],
		[
			"2016-01-27",
			23.03
		],
		[
			"2009-08-17",
			24.67
		],
		[
			"2011-11-04",
			22.67
		]
	],
	"20002129": [
		[
			"2000-11-29",
			128.43
		],
		[
			"2001-04-06",
			119.57
		],
		[
			"2001-10-23",
			112.49
		],
		[
			"2002-10-31",
			108.06
		],
		[
			"2002-09-18",
			110.27
		],
		[
			"2003-04-24",
			101.86
		],
		[
			"2004-04-08",
			93
		],
		[
			"2004-06-01",
			84.14
		],
		[
			"2005-08-11",
			84.14
		],
		[
			"2005-08-31",
			84.14
		],
		[
			"2006-05-24",
			75.29
		],
		[
			"2007-06-29",
			79.71
		],
		[
			"2008-04-25",
			66.43
		],
		[
			"2015-07-22",
			60.23
		],
		[
			"2009-06-16",
			79.71
		],
		[
			"2010-04-14",
			106.29
		],
		[
			"2003-10-15",
			77.06
		],
		[
			"2011-06-15",
			93
		],
		[
			"2012-11-29",
			79.71
		]
	],
	"20060208": [
		[
			"2000-11-21",
			2.21
		],
		[
			"2003-06-13",
			2.21
		],
		[
			"2004-03-11",
			13.51
		],
		[
			"2005-07-07",
			2.21
		],
		[
			"2006-04-18",
			7.53
		],
		[
			"2007-06-21",
			2.21
		],
		[
			"2008-04-04",
			2.21
		],
		[
			"2013-06-27",
			2.21
		],
		[
			"2014-05-15",
			2.21
		],
		[
			"2015-07-02",
			2.97
		],
		[
			"2016-04-14",
			39.86
		],
		[
			"2009-06-17",
			2.21
		],
		[
			"2010-04-06",
			9.3
		],
		[
			"2011-05-12",
			5.76
		],
		[
			"2012-06-21",
			2.21
		]
	],
	"20101120": [
		[
			"2001-11-06",
			110.27
		],
		[
			"2002-11-06",
			84.14
		],
		[
			"2004-07-06",
			89.01
		],
		[
			"2005-07-19",
			106.29
		],
		[
			"2006-10-17",
			84.14
		],
		[
			"2007-06-20",
			88.57
		],
		[
			"2008-12-04",
			88.57
		],
		[
			"2013-09-10",
			199.29
		],
		[
			"2014-07-01",
			220.99
		],
		[
			"2015-08-06",
			271.03
		],
		[
			"2009-10-05",
			106.29
		],
		[
			"2010-09-07",
			137.29
		],
		[
			"2011-05-11",
			141.71
		],
		[
			"2012-10-17",
			181.57
		]
	],
	"20102082": [
		[
			"2000-11-16",
			2.21
		],
		[
			"2001-06-20",
			2.21
		],
		[
			"2003-04-30",
			2.21
		],
		[
			"2004-04-08",
			2.21
		],
		[
			"2005-08-11",
			2.21
		],
		[
			"2006-05-31",
			2.21
		],
		[
			"2007-07-27",
			2.21
		],
		[
			"2008-04-25",
			2.21
		],
		[
			"2013-07-22",
			2.21
		],
		[
			"2014-07-10",
			1.33
		],
		[
			"2015-10-15",
			2.61
		],
		[
			"2009-10-22",
			2.21
		],
		[
			"2010-04-14",
			2.21
		],
		[
			"2011-06-15",
			2.21
		],
		[
			"2012-08-01",
			2.21
		]
	],
	"20103037": [
		[
			"2000-10-19",
			2.21
		],
		[
			"2001-03-29",
			2.21
		],
		[
			"2002-08-21",
			8.81
		],
		[
			"2003-03-28",
			5.93
		],
		[
			"2004-02-26",
			2.92
		],
		[
			"2005-07-22",
			2.21
		],
		[
			"2006-05-22",
			5.76
		],
		[
			"2007-06-28",
			4.34
		],
		[
			"2008-04-11",
			3.23
		],
		[
			"2013-07-03",
			13.29
		],
		[
			"2014-06-25",
			19.93
		],
		[
			"2015-07-15",
			14.92
		],
		[
			"2009-07-06",
			10.63
		],
		[
			"2010-04-07",
			17.71
		],
		[
			"2011-03-31",
			12.84
		],
		[
			"2012-07-05",
			14.17
		]
	],
	"20103062": [
		[
			"2002-07-03",
			34.14
		],
		[
			"2002-08-28",
			26.75
		],
		[
			"2003-04-02",
			28.65
		],
		[
			"2004-03-12",
			79.27
		],
		[
			"2005-07-08",
			33.66
		],
		[
			"2006-04-10",
			75.29
		],
		[
			"2007-07-20",
			38.09
		],
		[
			"2013-07-02",
			163.86
		],
		[
			"2014-06-24",
			75.29
		],
		[
			"2015-07-14",
			40.52
		],
		[
			"2009-07-06",
			53.14
		],
		[
			"2010-07-15",
			70.86
		],
		[
			"2008-04-03",
			115.14
		],
		[
			"2011-04-04",
			70.86
		],
		[
			"2012-05-23",
			97.43
		]
	],
	"20103074": [
		[
			"2000-11-16",
			23.03
		],
		[
			"2001-06-20",
			29.41
		],
		[
			"2002-08-28",
			18.56
		],
		[
			"2003-04-04",
			29.41
		],
		[
			"2004-03-19",
			6.24
		],
		[
			"2005-07-01",
			19.49
		],
		[
			"2006-04-10",
			2.21
		],
		[
			"2007-07-20",
			13.29
		],
		[
			"2008-04-03",
			15.06
		],
		[
			"2013-07-02",
			27.9
		],
		[
			"2014-06-25",
			30.56
		],
		[
			"2015-07-14",
			29.76
		],
		[
			"2009-07-06",
			21.26
		],
		[
			"2010-07-15",
			19.49
		],
		[
			"2011-08-24",
			29.23
		],
		[
			"2012-06-26",
			19.93
		]
	],
	"20103165": [
		[
			"2000-10-19",
			2.21
		],
		[
			"2001-06-26",
			2.21
		],
		[
			"2002-05-15",
			2.21
		],
		[
			"2003-04-30",
			2.21
		],
		[
			"2004-04-16",
			2.21
		],
		[
			"2005-07-22",
			2.21
		],
		[
			"2006-04-13",
			2.21
		],
		[
			"2007-06-28",
			2.21
		],
		[
			"2008-04-11",
			2.21
		],
		[
			"2013-07-03",
			2.21
		],
		[
			"2014-07-03",
			1.33
		],
		[
			"2015-07-15",
			1.33
		],
		[
			"2009-07-13",
			2.21
		],
		[
			"2010-06-16",
			2.21
		],
		[
			"2011-03-31",
			2.21
		],
		[
			"2012-05-30",
			2.21
		]
	],
	"20103177": [
		[
			"2000-10-19",
			2.21
		],
		[
			"2001-06-26",
			2.21
		],
		[
			"2002-05-15",
			2.21
		],
		[
			"2003-04-30",
			2.21
		],
		[
			"2004-04-16",
			1.73
		],
		[
			"2005-07-22",
			2.21
		],
		[
			"2006-04-13",
			2.21
		],
		[
			"2007-06-28",
			2.21
		],
		[
			"2008-04-11",
			2.21
		],
		[
			"2013-07-03",
			2.21
		],
		[
			"2014-07-03",
			25.07
		],
		[
			"2015-07-15",
			1.33
		],
		[
			"2009-07-13",
			2.21
		],
		[
			"2010-06-17",
			2.21
		],
		[
			"2010-09-09",
			2.21
		],
		[
			"2011-03-31",
			2.21
		],
		[
			"2012-05-30",
			2.21
		]
	],
	"20104030": [
		[
			"2000-11-07",
			2.21
		],
		[
			"2001-06-20",
			2.21
		],
		[
			"2002-06-24",
			2.21
		],
		[
			"2003-06-27",
			2.21
		],
		[
			"2004-03-25",
			2.21
		],
		[
			"2005-07-14",
			2.21
		],
		[
			"2006-10-19",
			2.21
		],
		[
			"2007-06-29",
			2.21
		],
		[
			"2008-03-27",
			2.21
		],
		[
			"2013-07-23",
			27.46
		],
		[
			"2014-07-24",
			1.33
		],
		[
			"2015-10-15",
			1.33
		],
		[
			"2009-05-26",
			2.21
		],
		[
			"2010-05-06",
			2.21
		],
		[
			"2011-07-20",
			2.21
		],
		[
			"2012-11-06",
			2.21
		]
	],
	"20104042": [
		[
			"2003-03-28",
			51.37
		],
		[
			"2006-05-31",
			57.57
		],
		[
			"2007-06-04",
			38.09
		],
		[
			"2013-07-18",
			48.71
		],
		[
			"2014-07-08",
			51.37
		],
		[
			"2015-09-22",
			45.17
		],
		[
			"2009-10-07",
			42.96
		],
		[
			"2008-04-29",
			48.71
		],
		[
			"2010-07-14",
			42.07
		],
		[
			"2010-10-14",
			41.63
		],
		[
			"2011-04-27",
			42.51
		],
		[
			"2012-11-13",
			38.09
		]
	],
	"20104054": [
		[
			"2000-11-15",
			53.14
		],
		[
			"2001-02-20",
			53.14
		],
		[
			"2001-10-24",
			59.34
		],
		[
			"2002-08-28",
			68.2
		],
		[
			"2002-09-18",
			67.76
		],
		[
			"2003-03-28",
			67.76
		],
		[
			"2003-10-13",
			61.56
		],
		[
			"2004-02-27",
			56.69
		],
		[
			"2004-06-01",
			60.23
		],
		[
			"2005-08-11",
			62
		],
		[
			"2005-09-01",
			66.43
		],
		[
			"2006-05-31",
			62
		],
		[
			"2007-06-04",
			48.71
		],
		[
			"2008-04-29",
			48.71
		],
		[
			"2013-07-18",
			57.57
		],
		[
			"2014-07-08",
			56.69
		],
		[
			"2015-09-22",
			42.87
		],
		[
			"2009-10-21",
			48.71
		],
		[
			"2010-07-14",
			57.57
		],
		[
			"2011-04-27",
			57.57
		],
		[
			"2012-11-06",
			57.57
		]
	],
	"20104224": [
		[
			"2000-11-07",
			2.21
		],
		[
			"2001-04-11",
			2.21
		],
		[
			"2002-06-24",
			2.21
		],
		[
			"2003-06-27",
			2.21
		],
		[
			"2004-03-25",
			2.21
		],
		[
			"2005-07-14",
			2.21
		],
		[
			"2006-11-17",
			79.71
		],
		[
			"2007-05-16",
			2.21
		],
		[
			"2008-03-27",
			2.21
		],
		[
			"2013-07-24",
			2.21
		],
		[
			"2014-07-24",
			1.33
		],
		[
			"2015-11-03",
			1.33
		],
		[
			"2009-06-16",
			2.21
		],
		[
			"2010-05-06",
			2.21
		],
		[
			"2011-07-20",
			2.21
		],
		[
			"2012-08-01",
			2.21
		]
	],
	"20104303": [
		[
			"2000-11-21",
			36.31
		],
		[
			"2001-10-25",
			45.17
		],
		[
			"2002-07-17",
			95.21
		],
		[
			"2002-08-28",
			93
		],
		[
			"2002-09-18",
			94.77
		],
		[
			"2003-06-25",
			85.91
		],
		[
			"2003-10-13",
			67.31
		],
		[
			"2004-03-11",
			75.29
		],
		[
			"2004-06-03",
			56.24
		],
		[
			"2005-07-07",
			57.57
		],
		[
			"2005-09-01",
			66.43
		],
		[
			"2006-04-18",
			66.43
		],
		[
			"2007-06-22",
			93
		],
		[
			"2008-04-10",
			124
		],
		[
			"2013-07-16",
			75.29
		],
		[
			"2014-06-26",
			64.21
		],
		[
			"2015-06-30",
			69.09
		],
		[
			"2009-06-30",
			53.14
		],
		[
			"2010-04-07",
			75.29
		],
		[
			"2011-07-14",
			62
		],
		[
			"2012-06-26",
			62
		]
	],
	"20104315": [
		[
			"2000-11-08",
			121.79
		],
		[
			"2002-07-17",
			123.56
		],
		[
			"2003-04-02",
			92.56
		],
		[
			"2004-03-12",
			57.13
		],
		[
			"2005-07-08",
			79.71
		],
		[
			"2006-04-12",
			93
		],
		[
			"2007-06-22",
			110.71
		],
		[
			"2008-04-04",
			97.43
		],
		[
			"2013-07-17",
			128.43
		],
		[
			"2014-05-15",
			114.7
		],
		[
			"2015-07-14",
			146.59
		],
		[
			"2009-06-29",
			110.71
		],
		[
			"2010-06-09",
			88.57
		],
		[
			"2011-04-05",
			110.71
		],
		[
			"2012-06-21",
			115.14
		]
	],
	"20104327": [
		[
			"2000-11-15",
			50.04
		],
		[
			"2001-10-25",
			61.11
		],
		[
			"2002-05-15",
			49.6
		],
		[
			"2002-08-28",
			47.83
		],
		[
			"2002-09-18",
			58.01
		],
		[
			"2003-05-22",
			35.12
		],
		[
			"2003-10-13",
			50.49
		],
		[
			"2004-04-16",
			42.91
		],
		[
			"2004-06-03",
			14.53
		],
		[
			"2005-09-01",
			57.57
		],
		[
			"2005-11-03",
			30.56
		],
		[
			"2006-04-13",
			53.14
		],
		[
			"2007-06-21",
			48.71
		],
		[
			"2008-04-03",
			53.14
		],
		[
			"2013-07-16",
			2.21
		],
		[
			"2014-05-06",
			7.97
		],
		[
			"2015-06-30",
			8.77
		],
		[
			"2009-06-17",
			27.9
		],
		[
			"2010-04-06",
			2.21
		],
		[
			"2011-07-14",
			35.43
		],
		[
			"2012-05-30",
			39.86
		]
	],
	"20104546": [
		[
			"2000-02-14",
			14
		],
		[
			"2000-06-15",
			13
		],
		[
			"2001-03-26",
			15.01
		],
		[
			"2001-06-28",
			14
		],
		[
			"2001-11-06",
			15.01
		],
		[
			"2002-02-25",
			13
		],
		[
			"2002-07-22",
			13
		],
		[
			"2002-10-10",
			13
		],
		[
			"2004-09-29",
			13.8
		],
		[
			"2004-03-23",
			13
		],
		[
			"2005-10-24",
			14.11
		],
		[
			"2010-04-27",
			13.5
		],
		[
			"2010-11-16",
			13
		],
		[
			"2011-03-29",
			12.8
		],
		[
			"2011-11-22",
			13.3
		],
		[
			"2012-10-17",
			12.9
		],
		[
			"2012-05-07",
			12.2
		],
		[
			"2013-04-03",
			12.2
		],
		[
			"2013-12-10",
			12.9
		],
		[
			"2014-09-08",
			12.4
		],
		[
			"2014-05-27",
			12.3
		],
		[
			"2015-03-09",
			12.3
		],
		[
			"2015-09-08",
			12.2
		],
		[
			"2006-09-14",
			13.5
		],
		[
			"2007-03-21",
			13.2
		],
		[
			"2007-09-17",
			13.6
		],
		[
			"2008-04-16",
			13.3
		],
		[
			"2008-09-15",
			13.8
		],
		[
			"2009-04-09",
			13.4
		],
		[
			"2009-10-27",
			13.8
		]
	],
	"20161517": [
		[
			"2000-11-21",
			6.2
		],
		[
			"2003-06-25",
			17.67
		],
		[
			"2004-07-01",
			10.85
		],
		[
			"2006-06-13",
			20.37
		],
		[
			"2013-07-16",
			17.27
		],
		[
			"2014-07-01",
			20.37
		],
		[
			"2015-06-30",
			19.62
		],
		[
			"2009-10-22",
			9.3
		],
		[
			"2010-07-21",
			12.84
		],
		[
			"2011-07-07",
			19.49
		],
		[
			"2012-08-10",
			16.83
		]
	],
	"20751011": [
		[
			"2000-03-07",
			28.81
		],
		[
			"2000-09-19",
			28.61
		],
		[
			"2001-03-06",
			28.31
		],
		[
			"2001-09-18",
			28.71
		],
		[
			"2002-03-05",
			30.61
		],
		[
			"2002-09-17",
			28.71
		],
		[
			"2003-03-03",
			28.91
		],
		[
			"2003-09-16",
			28.21
		],
		[
			"2004-03-30",
			32.31
		],
		[
			"2004-09-28",
			29.91
		],
		[
			"2005-04-12",
			31.81
		],
		[
			"2005-09-27",
			27.11
		],
		[
			"2010-09-27",
			28.11
		],
		[
			"2011-03-21",
			30.81
		],
		[
			"2011-09-19",
			28.91
		],
		[
			"2012-03-26",
			29.31
		],
		[
			"2012-09-18",
			28.11
		],
		[
			"2013-03-19",
			28.01
		],
		[
			"2013-09-24",
			27.01
		],
		[
			"2014-03-11",
			26.61
		],
		[
			"2014-09-29",
			26.01
		],
		[
			"2015-03-10",
			28.81
		],
		[
			"2015-09-15",
			27.51
		],
		[
			"2006-04-26",
			31.01
		],
		[
			"2006-10-23",
			28.71
		],
		[
			"2007-03-28",
			33.81
		],
		[
			"2007-10-08",
			33.81
		],
		[
			"2008-03-04",
			32.51
		],
		[
			"2008-10-20",
			28.31
		],
		[
			"2009-03-16",
			30.31
		],
		[
			"2009-09-21",
			27.31
		],
		[
			"2010-03-16",
			29.21
		]
	],
	"20752349": [
		[
			"2000-10-24",
			32.01
		],
		[
			"2000-03-28",
			32.91
		],
		[
			"2001-10-23",
			28.21
		],
		[
			"2001-03-27",
			34.11
		],
		[
			"2002-10-22",
			35.61
		],
		[
			"2002-03-26",
			33.41
		],
		[
			"2003-03-25",
			31.81
		],
		[
			"2003-10-28",
			28.51
		],
		[
			"2004-03-23",
			33.31
		],
		[
			"2004-09-21",
			31.11
		],
		[
			"2005-04-05",
			33.01
		],
		[
			"2005-09-20",
			28.71
		],
		[
			"2010-09-13",
			28.81
		],
		[
			"2011-03-15",
			31.21
		],
		[
			"2011-09-12",
			25.21
		],
		[
			"2012-03-19",
			27.61
		],
		[
			"2012-09-17",
			27.71
		],
		[
			"2013-03-26",
			26.01
		],
		[
			"2013-09-17",
			25.71
		],
		[
			"2014-03-05",
			28.01
		],
		[
			"2014-09-15",
			26.61
		],
		[
			"2015-03-04",
			25.81
		],
		[
			"2015-09-01",
			27.81
		],
		[
			"2006-04-25",
			30.61
		],
		[
			"2006-10-16",
			30.11
		],
		[
			"2007-03-19",
			32.01
		],
		[
			"2007-10-22",
			32.21
		],
		[
			"2008-03-03",
			30.81
		],
		[
			"2008-10-13",
			29.81
		],
		[
			"2009-03-02",
			30.01
		],
		[
			"2009-09-14",
			31.71
		],
		[
			"2010-03-01",
			30.31
		]
	],
	"20753019": [
		[
			"2000-03-07",
			20.51
		],
		[
			"2000-09-19",
			17.31
		],
		[
			"2001-03-06",
			20.61
		],
		[
			"2001-09-18",
			19.51
		],
		[
			"2002-03-05",
			18.71
		],
		[
			"2002-09-17",
			20.41
		],
		[
			"2003-03-03",
			21.41
		],
		[
			"2003-09-16",
			18.41
		],
		[
			"2004-03-30",
			24.01
		],
		[
			"2004-09-28",
			21.01
		],
		[
			"2005-04-12",
			23.51
		],
		[
			"2005-09-27",
			17.91
		],
		[
			"2006-10-23",
			19.81
		],
		[
			"2006-04-26",
			23.51
		],
		[
			"2010-09-27",
			19.41
		],
		[
			"2011-03-21",
			23.81
		],
		[
			"2011-09-19",
			18.71
		],
		[
			"2012-03-26",
			20.41
		],
		[
			"2012-09-18",
			19.51
		],
		[
			"2013-03-19",
			24.51
		],
		[
			"2013-09-24",
			19.71
		],
		[
			"2014-03-11",
			24.01
		],
		[
			"2014-09-29",
			21.21
		],
		[
			"2015-03-10",
			27.91
		],
		[
			"2015-09-15",
			21.01
		],
		[
			"2007-03-28",
			23.01
		],
		[
			"2007-10-08",
			23.31
		],
		[
			"2008-03-04",
			20.21
		],
		[
			"2008-10-20",
			19.41
		],
		[
			"2009-03-16",
			22.71
		],
		[
			"2009-09-21",
			20.41
		],
		[
			"2010-03-16",
			24.91
		]
	],
	"20780369": [
		[
			"2000-03-06",
			39.01
		],
		[
			"2001-04-02",
			37.01
		],
		[
			"2002-04-04",
			36.01
		],
		[
			"2010-03-18",
			30.01
		],
		[
			"2012-03-27",
			31.01
		],
		[
			"2014-04-08",
			28.01
		],
		[
			"2015-03-05",
			27.01
		],
		[
			"2006-04-26",
			31.01
		],
		[
			"2007-03-12",
			35.01
		],
		[
			"2008-03-05",
			31.01
		],
		[
			"2004-04-19",
			35.01
		],
		[
			"2003-04-04",
			34.01
		],
		[
			"2005-03-21",
			36.01
		],
		[
			"2009-03-25",
			32.01
		],
		[
			"2011-03-07",
			30.01
		]
	],
	"20780370": [
		[
			"2000-10-24",
			5
		],
		[
			"2001-10-09",
			5
		],
		[
			"2010-09-23",
			2
		],
		[
			"2012-09-25",
			1
		],
		[
			"2013-10-18",
			1
		],
		[
			"2014-09-08",
			2
		],
		[
			"2015-09-01",
			2
		],
		[
			"2006-09-28",
			1
		],
		[
			"2007-09-17",
			3
		],
		[
			"2008-09-29",
			2
		],
		[
			"2004-09-14",
			3
		],
		[
			"2003-09-10",
			5
		],
		[
			"2005-09-29",
			3
		],
		[
			"2009-09-23",
			2
		],
		[
			"2002-09-20",
			4
		],
		[
			"2011-09-09",
			1
		]
	],
	"20781052": [
		[
			"2002-04-05",
			23.01
		],
		[
			"2000-10-27",
			24.01
		],
		[
			"2001-10-10",
			22.01
		],
		[
			"2001-04-10",
			33.01
		],
		[
			"2005-09-13",
			11
		],
		[
			"2005-04-06",
			14
		],
		[
			"2010-03-30",
			5.6
		],
		[
			"2010-10-26",
			6
		],
		[
			"2011-05-23",
			9
		],
		[
			"2011-11-02",
			6.2
		],
		[
			"2012-04-03",
			6.7
		],
		[
			"2012-10-30",
			8
		],
		[
			"2013-04-03",
			7.2
		],
		[
			"2013-10-30",
			11
		],
		[
			"2014-05-13",
			13
		],
		[
			"2014-11-13",
			9.5
		],
		[
			"2015-04-21",
			12
		],
		[
			"2015-11-16",
			11
		],
		[
			"2006-05-19",
			9
		],
		[
			"2006-09-28",
			8
		],
		[
			"2007-10-10",
			14
		],
		[
			"2007-04-11",
			8
		],
		[
			"2008-04-03",
			17.01
		],
		[
			"2008-09-17",
			16.01
		],
		[
			"2002-10-22",
			13
		],
		[
			"2003-10-08",
			8
		],
		[
			"2004-03-31",
			6
		],
		[
			"2004-09-21",
			12
		],
		[
			"2003-04-02",
			22.01
		]
	],
	"20781246": [
		[
			"2000-03-23",
			31.01
		],
		[
			"2001-04-24",
			32.01
		],
		[
			"2002-03-20",
			34.99
		],
		[
			"2010-03-09",
			25.01
		],
		[
			"2010-08-09",
			22.01
		],
		[
			"2010-11-11",
			25.01
		],
		[
			"2012-10-10",
			21.01
		],
		[
			"2012-03-20",
			22.01
		],
		[
			"2013-11-11",
			21.01
		],
		[
			"2013-08-06",
			21.01
		],
		[
			"2013-03-12",
			21.01
		],
		[
			"2013-02-19",
			21.01
		],
		[
			"2014-10-27",
			19.01
		],
		[
			"2014-07-14",
			20.01
		],
		[
			"2014-04-09",
			21.01
		],
		[
			"2014-02-19",
			21.01
		],
		[
			"2015-10-16",
			18.01
		],
		[
			"2015-06-18",
			22.01
		],
		[
			"2015-03-11",
			21.01
		],
		[
			"2015-02-13",
			21.01
		],
		[
			"2006-04-19",
			27.01
		],
		[
			"2007-03-14",
			27.01
		],
		[
			"2008-04-21",
			27.01
		],
		[
			"2009-03-23",
			28.01
		],
		[
			"2009-06-05",
			27.01
		]
	],
	"20781532": [
		[
			"2000-05-09",
			1.5
		],
		[
			"2000-08-29",
			0.8
		],
		[
			"2001-05-08",
			2.9
		],
		[
			"2001-09-25",
			1.6
		],
		[
			"2002-08-20",
			1.3
		],
		[
			"2002-05-21",
			0.1
		],
		[
			"2003-05-20",
			2.7
		],
		[
			"2004-03-10",
			1.1
		],
		[
			"2004-09-15",
			0.9
		],
		[
			"2005-03-09",
			0.6
		],
		[
			"2005-09-13",
			0.6
		],
		[
			"2010-09-28",
			1.4
		],
		[
			"2011-03-28",
			2.1
		],
		[
			"2011-09-26",
			2.2
		],
		[
			"2012-04-25",
			1.6
		],
		[
			"2012-10-17",
			1.8
		],
		[
			"2013-04-09",
			0.5
		],
		[
			"2013-10-08",
			1.6
		],
		[
			"2014-03-26",
			1.6
		],
		[
			"2014-10-28",
			0.6
		],
		[
			"2015-03-25",
			1.8
		],
		[
			"2015-10-27",
			2
		],
		[
			"2006-03-08",
			0.7
		],
		[
			"2006-09-13",
			0.6
		],
		[
			"2007-03-14",
			0.5
		],
		[
			"2007-09-12",
			0.5
		],
		[
			"2008-03-12",
			1.2
		],
		[
			"2008-09-10",
			1.8
		],
		[
			"2009-03-10",
			0.5
		],
		[
			"2009-10-14",
			1.1
		],
		[
			"2010-03-09",
			1.2
		]
	],
	"20781878": [
		[
			"2005-09-13",
			0.5
		],
		[
			"2011-09-20",
			2
		],
		[
			"2012-03-27",
			0.5
		],
		[
			"2013-09-17",
			0.8
		],
		[
			"2014-04-01",
			2.4
		],
		[
			"2015-03-23",
			5.3
		],
		[
			"2006-03-08",
			0.5
		],
		[
			"2007-10-24",
			2.4
		],
		[
			"2008-11-04",
			0.9
		],
		[
			"2009-03-10",
			0.5
		],
		[
			"2009-09-22",
			4.3
		],
		[
			"2010-03-16",
			4.8
		]
	],
	"20782317": [
		[
			"2000-04-10",
			19.01
		],
		[
			"2001-04-09",
			13
		],
		[
			"2004-04-02",
			14
		],
		[
			"2005-04-13",
			12
		],
		[
			"2003-04-10",
			6
		],
		[
			"2006-04-24",
			14
		],
		[
			"2010-04-12",
			10
		],
		[
			"2015-04-13",
			10
		],
		[
			"2014-04-04",
			8
		],
		[
			"2013-04-11",
			6
		],
		[
			"2012-04-26",
			6
		],
		[
			"2007-04-10",
			16.01
		],
		[
			"2008-04-25",
			8
		],
		[
			"2009-03-20",
			11
		]
	],
	"20782925": [
		[
			"2003-04-04",
			38.48
		],
		[
			"2004-03-19",
			37.55
		],
		[
			"2000-11-06",
			101.86
		],
		[
			"2001-03-27",
			54.47
		],
		[
			"2002-01-15",
			59.79
		],
		[
			"2005-11-03",
			66.43
		],
		[
			"2006-04-10",
			25.24
		],
		[
			"2007-07-20",
			27.9
		],
		[
			"2010-03-29",
			18.01
		],
		[
			"2011-05-25",
			24.01
		],
		[
			"2012-04-04",
			24.01
		],
		[
			"2013-04-05",
			27.01
		],
		[
			"2014-05-13",
			30.01
		],
		[
			"2015-04-23",
			32.01
		],
		[
			"2013-07-02",
			26.13
		],
		[
			"2014-06-26",
			28.34
		],
		[
			"2015-07-14",
			28.92
		],
		[
			"2009-07-06",
			35.43
		],
		[
			"2008-04-03",
			23.91
		],
		[
			"2010-07-15",
			26.57
		],
		[
			"2010-09-09",
			24.8
		],
		[
			"2011-08-24",
			23.91
		],
		[
			"2012-07-05",
			25.69
		]
	],
	"20790302": [
		[
			"2000-05-16",
			44.02
		],
		[
			"2000-11-13",
			37.01
		],
		[
			"2001-05-10",
			42.01
		],
		[
			"2001-09-24",
			36.01
		],
		[
			"2002-04-16",
			42.01
		],
		[
			"2002-09-26",
			41.01
		],
		[
			"2003-05-13",
			37.01
		],
		[
			"2003-11-12",
			35.01
		],
		[
			"2004-03-16",
			44.02
		],
		[
			"2004-11-09",
			37.01
		],
		[
			"2005-04-20",
			42.01
		],
		[
			"2006-10-04",
			34.01
		],
		[
			"2006-05-03",
			40.01
		],
		[
			"2010-09-30",
			26.01
		],
		[
			"2011-05-19",
			36.01
		],
		[
			"2011-09-27",
			33.01
		],
		[
			"2012-03-01",
			44.02
		],
		[
			"2012-04-25",
			38.01
		],
		[
			"2012-11-22",
			29.01
		],
		[
			"2013-05-23",
			37.01
		],
		[
			"2013-12-03",
			33.01
		],
		[
			"2014-05-28",
			32.01
		],
		[
			"2014-10-30",
			30.01
		],
		[
			"2015-05-28",
			40.01
		],
		[
			"2015-11-03",
			31.01
		],
		[
			"2007-05-23",
			39.01
		],
		[
			"2007-09-25",
			42.01
		],
		[
			"2008-04-23",
			42.01
		],
		[
			"2008-10-02",
			36.01
		],
		[
			"2009-05-05",
			39.01
		],
		[
			"2009-09-23",
			31.01
		],
		[
			"2010-04-13",
			51.02
		]
	],
	"20790624": [
		[
			"2000-03-07",
			27.21
		],
		[
			"2000-09-19",
			27.61
		],
		[
			"2001-03-06",
			25.91
		],
		[
			"2001-09-18",
			27.31
		],
		[
			"2002-03-05",
			28.61
		],
		[
			"2002-09-17",
			28.01
		],
		[
			"2003-03-03",
			26.61
		],
		[
			"2003-09-16",
			27.71
		],
		[
			"2004-03-30",
			28.81
		],
		[
			"2004-09-28",
			29.41
		],
		[
			"2005-04-12",
			29.21
		],
		[
			"2005-09-27",
			27.11
		],
		[
			"2006-04-26",
			28.01
		],
		[
			"2006-10-23",
			28.01
		],
		[
			"2010-09-27",
			28.41
		],
		[
			"2011-03-21",
			29.01
		],
		[
			"2011-09-19",
			28.91
		],
		[
			"2012-03-26",
			27.61
		],
		[
			"2012-09-18",
			28.41
		],
		[
			"2013-03-19",
			27.71
		],
		[
			"2013-09-24",
			27.91
		],
		[
			"2014-03-11",
			29.21
		],
		[
			"2014-09-29",
			28.81
		],
		[
			"2015-03-10",
			29.91
		],
		[
			"2015-09-15",
			29.11
		],
		[
			"2007-03-28",
			28.41
		],
		[
			"2007-10-08",
			27.51
		],
		[
			"2008-03-04",
			29.01
		],
		[
			"2008-10-20",
			29.01
		],
		[
			"2009-03-16",
			29.11
		],
		[
			"2009-09-21",
			29.31
		],
		[
			"2010-03-16",
			28.81
		]
	],
	"20791215": [
		[
			"2000-10-24",
			21.81
		],
		[
			"2000-03-28",
			13
		],
		[
			"2001-10-23",
			18.81
		],
		[
			"2001-03-27",
			12.9
		],
		[
			"2002-10-22",
			13.7
		],
		[
			"2002-03-26",
			12.5
		],
		[
			"2010-09-13",
			14.61
		],
		[
			"2011-03-15",
			12.7
		],
		[
			"2011-09-12",
			17.01
		],
		[
			"2012-03-19",
			10.7
		],
		[
			"2012-09-17",
			13.1
		],
		[
			"2013-03-26",
			11.1
		],
		[
			"2013-09-17",
			14.41
		],
		[
			"2014-03-05",
			11.9
		],
		[
			"2014-09-15",
			15.61
		],
		[
			"2015-03-04",
			11.1
		],
		[
			"2015-09-01",
			16.51
		],
		[
			"2003-03-25",
			11.2
		],
		[
			"2003-10-28",
			19.91
		],
		[
			"2004-03-23",
			14.11
		],
		[
			"2004-09-21",
			17.81
		],
		[
			"2005-04-05",
			12.6
		],
		[
			"2005-09-20",
			16.01
		],
		[
			"2006-04-25",
			12.9
		],
		[
			"2007-03-19",
			12.9
		],
		[
			"2007-10-22",
			12.4
		],
		[
			"2008-03-03",
			12.7
		],
		[
			"2008-10-13",
			16.61
		],
		[
			"2009-03-02",
			14
		],
		[
			"2009-09-14",
			18.81
		],
		[
			"2010-03-01",
			12.2
		]
	],
	"20791318": [
		[
			"2000-10-24",
			27.21
		],
		[
			"2000-03-28",
			27.91
		],
		[
			"2001-10-23",
			25.91
		],
		[
			"2001-03-27",
			28.31
		],
		[
			"2002-10-22",
			25.41
		],
		[
			"2002-03-26",
			28.21
		],
		[
			"2003-03-25",
			23.61
		],
		[
			"2003-10-28",
			25.11
		],
		[
			"2004-03-23",
			26.91
		],
		[
			"2004-09-21",
			25.01
		],
		[
			"2005-04-05",
			26.41
		],
		[
			"2005-09-20",
			24.01
		],
		[
			"2010-09-13",
			24.01
		],
		[
			"2011-03-15",
			24.91
		],
		[
			"2011-09-12",
			23.71
		],
		[
			"2012-03-19",
			23.41
		],
		[
			"2012-09-17",
			23.61
		],
		[
			"2013-03-26",
			24.41
		],
		[
			"2013-09-17",
			23.41
		],
		[
			"2014-03-05",
			24.61
		],
		[
			"2014-09-15",
			24.11
		],
		[
			"2015-03-04",
			26.71
		],
		[
			"2015-09-01",
			25.01
		],
		[
			"2006-04-25",
			27.21
		],
		[
			"2006-10-16",
			24.31
		],
		[
			"2007-03-19",
			26.21
		],
		[
			"2007-10-22",
			24.31
		],
		[
			"2008-03-03",
			24.31
		],
		[
			"2008-10-13",
			22.21
		],
		[
			"2009-03-02",
			25.11
		],
		[
			"2009-09-14",
			26.71
		],
		[
			"2010-03-01",
			25.71
		]
	],
	"20791410": [
		[
			"2000-10-24",
			47.22
		],
		[
			"2000-03-28",
			44.62
		],
		[
			"2001-10-23",
			46.72
		],
		[
			"2001-03-27",
			46.72
		],
		[
			"2002-10-22",
			43.72
		],
		[
			"2002-03-26",
			45.52
		],
		[
			"2003-03-25",
			41.31
		],
		[
			"2003-10-28",
			44.02
		],
		[
			"2004-03-23",
			44.82
		],
		[
			"2004-09-21",
			46.22
		],
		[
			"2010-09-13",
			43.32
		],
		[
			"2011-03-15",
			43.02
		],
		[
			"2011-09-12",
			43.02
		],
		[
			"2012-03-19",
			41.01
		],
		[
			"2012-09-17",
			44.02
		],
		[
			"2013-03-26",
			43.02
		],
		[
			"2013-09-17",
			41.21
		],
		[
			"2014-03-05",
			43.52
		],
		[
			"2014-09-15",
			42.72
		],
		[
			"2015-03-04",
			43.72
		],
		[
			"2015-09-01",
			44.32
		],
		[
			"2005-04-05",
			45.62
		],
		[
			"2005-09-20",
			44.22
		],
		[
			"2006-04-25",
			44.42
		],
		[
			"2006-10-16",
			44.62
		],
		[
			"2007-03-19",
			43.82
		],
		[
			"2007-10-22",
			41.21
		],
		[
			"2008-03-03",
			44.62
		],
		[
			"2008-10-13",
			42.21
		],
		[
			"2009-03-02",
			42.21
		],
		[
			"2009-09-14",
			46.12
		],
		[
			"2010-03-01",
			41.61
		]
	],
	"21000049": [
		[
			"2000-11-15",
			55.36
		],
		[
			"2001-03-29",
			35.61
		],
		[
			"2002-08-07",
			36.85
		],
		[
			"2003-03-28",
			35.07
		],
		[
			"2004-04-16",
			40.08
		],
		[
			"2005-11-03",
			44.29
		],
		[
			"2006-04-13",
			34.54
		],
		[
			"2007-07-27",
			48.71
		],
		[
			"2008-04-10",
			32.33
		],
		[
			"2013-06-26",
			31.89
		],
		[
			"2014-06-25",
			31.44
		],
		[
			"2015-07-02",
			34.59
		],
		[
			"2009-06-16",
			31
		],
		[
			"2010-04-07",
			26.57
		],
		[
			"2011-07-07",
			31
		],
		[
			"2012-07-05",
			37.64
		]
	],
	"21000086": [
		[
			"2002-10-23",
			2.21
		],
		[
			"2003-10-29",
			2.21
		],
		[
			"2004-07-07",
			2.21
		],
		[
			"2005-07-20",
			2.21
		],
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-06-18",
			2.21
		],
		[
			"2008-12-02",
			2.21
		],
		[
			"2013-07-30",
			2.21
		],
		[
			"2014-05-22",
			2.21
		],
		[
			"2015-07-21",
			1.33
		],
		[
			"2009-09-18",
			2.21
		],
		[
			"2010-06-24",
			2.21
		],
		[
			"2011-04-26",
			2.21
		],
		[
			"2012-07-25",
			2.21
		]
	],
	"21000153": [
		[
			"2000-11-09",
			15.06
		],
		[
			"2001-03-29",
			7.88
		],
		[
			"2002-08-07",
			2.21
		],
		[
			"2003-03-28",
			7
		],
		[
			"2004-02-26",
			21.35
		],
		[
			"2005-11-17",
			10.63
		],
		[
			"2005-07-22",
			5.31
		],
		[
			"2007-06-28",
			2.21
		],
		[
			"2008-04-17",
			2.21
		],
		[
			"2013-07-16",
			2.21
		],
		[
			"2014-06-26",
			2.83
		],
		[
			"2015-10-15",
			5.49
		],
		[
			"2009-07-29",
			16.83
		],
		[
			"2006-05-29",
			2.21
		],
		[
			"2010-07-22",
			2.21
		],
		[
			"2011-05-18",
			2.21
		],
		[
			"2012-08-10",
			3.19
		]
	],
	"21000268": [
		[
			"2000-07-11",
			2.21
		],
		[
			"2001-02-15",
			4.25
		],
		[
			"2002-05-22",
			2.21
		],
		[
			"2002-08-21",
			2.21
		],
		[
			"2003-03-21",
			2.21
		],
		[
			"2004-02-27",
			5.05
		],
		[
			"2005-07-21",
			2.21
		],
		[
			"2007-05-30",
			4.87
		],
		[
			"2008-08-25",
			2.21
		],
		[
			"2013-10-29",
			2.21
		],
		[
			"2014-07-23",
			1.33
		],
		[
			"2015-10-28",
			3.99
		],
		[
			"2009-07-09",
			2.21
		],
		[
			"2010-06-17",
			2.21
		],
		[
			"2006-05-24",
			6.64
		],
		[
			"2008-04-29",
			2.21
		],
		[
			"2011-07-05",
			2.21
		],
		[
			"2012-08-14",
			2.21
		]
	],
	"21000300": [
		[
			"2000-09-19",
			16.83
		],
		[
			"2001-03-01",
			54.03
		],
		[
			"2002-05-16",
			40.48
		],
		[
			"2003-07-04",
			2.21
		],
		[
			"2004-03-26",
			187.33
		],
		[
			"2005-07-21",
			79.71
		],
		[
			"2006-04-19",
			101.86
		],
		[
			"2007-06-04",
			128.43
		],
		[
			"2013-07-22",
			39.41
		],
		[
			"2014-07-08",
			29.41
		],
		[
			"2015-09-23",
			34.68
		],
		[
			"2009-08-17",
			4.38
		],
		[
			"2008-05-14",
			23.03
		],
		[
			"2010-07-29",
			2.21
		],
		[
			"2011-10-05",
			15.5
		],
		[
			"2012-09-12",
			20.81
		]
	],
	"21000347": [
		[
			"2000-09-19",
			113.37
		],
		[
			"2001-04-05",
			109.83
		],
		[
			"2002-05-16",
			2.21
		],
		[
			"2003-04-24",
			102.3
		],
		[
			"2004-04-08",
			90.79
		],
		[
			"2005-08-11",
			84.14
		],
		[
			"2006-05-29",
			88.57
		],
		[
			"2007-05-30",
			97.43
		],
		[
			"2008-04-29",
			79.71
		],
		[
			"2013-07-22",
			84.14
		],
		[
			"2014-07-10",
			94.77
		],
		[
			"2015-10-15",
			80.6
		],
		[
			"2009-07-09",
			75.29
		],
		[
			"2010-04-14",
			2.21
		],
		[
			"2011-06-15",
			75.29
		],
		[
			"2012-08-01",
			79.71
		]
	],
	"21000426": [
		[
			"2000-09-19",
			2.21
		],
		[
			"2001-02-15",
			2.21
		],
		[
			"2002-08-21",
			2.21
		],
		[
			"2003-04-24",
			2.21
		],
		[
			"2004-04-08",
			2.21
		],
		[
			"2005-08-11",
			2.21
		],
		[
			"2005-11-10",
			2.21
		],
		[
			"2007-05-30",
			2.21
		],
		[
			"2013-07-22",
			2.21
		],
		[
			"2014-07-16",
			1.33
		],
		[
			"2015-10-28",
			1.33
		],
		[
			"2009-08-17",
			2.21
		],
		[
			"2006-05-29",
			2.21
		],
		[
			"2008-03-27",
			4.34
		],
		[
			"2008-05-14",
			2.21
		],
		[
			"2010-07-27",
			2.21
		],
		[
			"2011-08-24",
			2.21
		],
		[
			"2012-05-24",
			2.21
		]
	],
	"21000440": [
		[
			"2000-11-09",
			2.21
		],
		[
			"2001-10-18",
			3.23
		],
		[
			"2002-05-22",
			2.21
		],
		[
			"2003-07-04",
			2.21
		],
		[
			"2004-03-26",
			2.21
		],
		[
			"2005-07-21",
			2.3
		],
		[
			"2006-04-19",
			2.21
		],
		[
			"2007-07-12",
			2.21
		],
		[
			"2008-04-18",
			2.21
		],
		[
			"2013-07-23",
			2.21
		],
		[
			"2014-08-20",
			1.33
		],
		[
			"2015-10-22",
			13.2
		],
		[
			"2009-07-29",
			2.21
		],
		[
			"2010-09-09",
			2.21
		],
		[
			"2011-07-27",
			2.21
		],
		[
			"2012-08-15",
			2.21
		]
	],
	"21000610": [
		[
			"2000-06-07",
			13.29
		],
		[
			"2001-04-11",
			14.44
		],
		[
			"2002-06-24",
			33.75
		],
		[
			"2003-06-27",
			33.88
		],
		[
			"2004-03-25",
			29.14
		],
		[
			"2005-07-14",
			25.24
		],
		[
			"2006-10-19",
			23.47
		],
		[
			"2007-06-29",
			25.69
		],
		[
			"2008-03-27",
			35.43
		],
		[
			"2013-07-23",
			7.53
		],
		[
			"2014-07-24",
			12.05
		],
		[
			"2015-10-28",
			18.2
		],
		[
			"2009-08-17",
			29.23
		],
		[
			"2010-05-06",
			26.57
		],
		[
			"2011-07-20",
			17.71
		]
	],
	"21001352": [
		[
			"2000-11-09",
			26.13
		],
		[
			"2001-06-27",
			26.22
		],
		[
			"2002-05-22",
			28.34
		],
		[
			"2003-07-04",
			28.87
		],
		[
			"2004-03-26",
			31.13
		],
		[
			"2005-07-21",
			28.34
		],
		[
			"2006-04-19",
			27.01
		],
		[
			"2007-07-19",
			25.24
		],
		[
			"2013-07-23",
			23.91
		],
		[
			"2014-10-16",
			15.19
		],
		[
			"2015-10-22",
			8.86
		],
		[
			"2009-07-29",
			23.03
		],
		[
			"2010-06-22",
			27.01
		],
		[
			"2008-05-14",
			25.69
		],
		[
			"2011-04-27",
			29.23
		],
		[
			"2012-11-29",
			21.7
		]
	],
	"21001698": [
		[
			"2000-11-21",
			2.21
		],
		[
			"2002-07-03",
			5.23
		],
		[
			"2003-06-25",
			4.47
		],
		[
			"2004-03-11",
			4.47
		],
		[
			"2005-07-07",
			2.21
		],
		[
			"2006-04-18",
			2.26
		],
		[
			"2007-06-22",
			2.21
		],
		[
			"2013-06-27",
			2.21
		],
		[
			"2014-07-03",
			3.72
		],
		[
			"2015-07-14",
			1.33
		],
		[
			"2009-06-30",
			5.76
		],
		[
			"2008-04-04",
			5.76
		],
		[
			"2010-07-15",
			3.01
		],
		[
			"2011-07-14",
			7.97
		],
		[
			"2012-05-23",
			5.31
		]
	],
	"21001728": [
		[
			"2000-11-08",
			2.21
		],
		[
			"2001-02-27",
			2.21
		],
		[
			"2002-07-03",
			2.21
		],
		[
			"2003-06-13",
			2.21
		],
		[
			"2004-03-11",
			2.21
		],
		[
			"2005-07-07",
			2.21
		],
		[
			"2006-04-12",
			2.21
		],
		[
			"2007-06-21",
			2.21
		],
		[
			"2013-06-26",
			2.21
		],
		[
			"2014-06-25",
			1.33
		],
		[
			"2015-07-02",
			1.33
		],
		[
			"2009-06-29",
			2.21
		],
		[
			"2008-04-10",
			2.21
		],
		[
			"2010-07-27",
			2.21
		],
		[
			"2011-05-12",
			2.21
		],
		[
			"2012-08-10",
			2.21
		]
	],
	"21001730": [
		[
			"2000-11-08",
			84.14
		],
		[
			"2001-02-27",
			85.03
		],
		[
			"2003-06-13",
			80.6
		],
		[
			"2004-03-11",
			76.17
		],
		[
			"2005-07-07",
			84.14
		],
		[
			"2006-04-12",
			79.71
		],
		[
			"2007-06-21",
			79.71
		],
		[
			"2008-04-10",
			43.84
		],
		[
			"2013-06-26",
			110.71
		],
		[
			"2014-07-03",
			104.96
		],
		[
			"2015-07-02",
			82.37
		],
		[
			"2009-06-17",
			79.71
		],
		[
			"2010-07-27",
			128.43
		],
		[
			"2011-05-12",
			101.86
		],
		[
			"2012-06-26",
			155
		]
	],
	"21001765": [
		[
			"2000-10-19",
			34.54
		],
		[
			"2001-03-01",
			65.54
		],
		[
			"2002-05-15",
			49.16
		],
		[
			"2003-04-30",
			39.37
		],
		[
			"2004-02-26",
			43.49
		],
		[
			"2005-07-22",
			48.71
		],
		[
			"2007-06-28",
			79.71
		],
		[
			"2013-07-03",
			70.86
		],
		[
			"2014-06-24",
			79.71
		],
		[
			"2015-07-15",
			75.29
		],
		[
			"2009-07-13",
			75.29
		],
		[
			"2006-05-22",
			62
		],
		[
			"2008-04-11",
			66.43
		],
		[
			"2010-07-14",
			70.86
		],
		[
			"2011-04-04",
			62
		],
		[
			"2012-08-03",
			75.29
		]
	],
	"21001777": [
		[
			"2000-10-19",
			19.93
		],
		[
			"2001-03-01",
			14.61
		],
		[
			"2002-05-15",
			12.84
		],
		[
			"2003-04-30",
			12.67
		],
		[
			"2004-02-26",
			15.32
		],
		[
			"2005-07-22",
			15.06
		],
		[
			"2006-05-22",
			15.06
		],
		[
			"2007-06-28",
			10.63
		],
		[
			"2008-04-11",
			5.76
		],
		[
			"2013-07-03",
			16.39
		],
		[
			"2014-06-24",
			13.73
		],
		[
			"2015-07-15",
			9.34
		],
		[
			"2009-07-13",
			25.24
		],
		[
			"2010-06-16",
			15.5
		],
		[
			"2011-04-04",
			7.53
		],
		[
			"2012-08-03",
			19.49
		]
	],
	"21001789": [
		[
			"2001-11-07",
			2.21
		],
		[
			"2002-11-12",
			2.21
		],
		[
			"2004-09-20",
			2.21
		],
		[
			"2005-07-25",
			2.21
		],
		[
			"2006-10-25",
			2.21
		],
		[
			"2007-07-03",
			2.21
		],
		[
			"2008-12-09",
			2.21
		],
		[
			"2013-07-31",
			2.21
		],
		[
			"2014-08-12",
			1.33
		],
		[
			"2015-09-29",
			1.33
		],
		[
			"2009-10-01",
			2.21
		],
		[
			"2010-09-06",
			2.21
		],
		[
			"2011-09-13",
			2.21
		],
		[
			"2012-09-04",
			2.21
		]
	],
	"21001790": [
		[
			"2001-11-16",
			13.29
		],
		[
			"2004-09-29",
			11.91
		],
		[
			"2005-07-26",
			22.59
		],
		[
			"2006-09-18",
			24.36
		],
		[
			"2007-07-10",
			27.46
		],
		[
			"2013-07-08",
			31.89
		],
		[
			"2014-08-07",
			31.13
		],
		[
			"2015-07-21",
			30.38
		],
		[
			"2009-09-22",
			25.69
		],
		[
			"2010-10-18",
			32.33
		],
		[
			"2011-05-03",
			34.99
		],
		[
			"2012-09-06",
			33.21
		]
	],
	"21150011": [
		[
			"2001-11-14",
			6.33
		],
		[
			"2002-10-22",
			3.45
		],
		[
			"2003-03-12",
			3.81
		],
		[
			"2004-06-28",
			2.21
		],
		[
			"2005-07-06",
			2.97
		],
		[
			"2006-09-25",
			3.45
		],
		[
			"2007-06-25",
			2.61
		],
		[
			"2008-12-05",
			6.2
		],
		[
			"2013-07-02",
			5.76
		],
		[
			"2014-06-17",
			3.99
		],
		[
			"2015-08-11",
			3.63
		],
		[
			"2009-10-19",
			5.31
		],
		[
			"2010-07-28",
			3.59
		],
		[
			"2011-03-30",
			6.2
		],
		[
			"2012-06-14",
			5.31
		]
	],
	"21150023": [
		[
			"2001-11-15",
			2.21
		],
		[
			"2002-10-09",
			2.21
		],
		[
			"2003-04-08",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-07-12",
			2.21
		],
		[
			"2006-10-02",
			2.21
		],
		[
			"2007-06-27",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-09-19",
			2.21
		],
		[
			"2014-07-03",
			1.33
		],
		[
			"2015-08-04",
			1.86
		],
		[
			"2009-10-19",
			2.21
		],
		[
			"2010-10-26",
			2.88
		],
		[
			"2011-05-25",
			2.21
		],
		[
			"2012-10-10",
			2.21
		]
	],
	"21150035": [
		[
			"2001-11-13",
			2.21
		],
		[
			"2002-10-08",
			2.57
		],
		[
			"2003-10-01",
			2.21
		],
		[
			"2004-07-05",
			2.21
		],
		[
			"2005-07-18",
			2.21
		],
		[
			"2006-09-27",
			2.21
		],
		[
			"2007-06-26",
			2.21
		],
		[
			"2008-12-03",
			2.21
		],
		[
			"2013-09-17",
			4.87
		],
		[
			"2014-07-15",
			1.33
		],
		[
			"2015-08-04",
			1.33
		],
		[
			"2009-10-20",
			2.21
		],
		[
			"2010-09-21",
			2.21
		],
		[
			"2011-04-20",
			2.21
		],
		[
			"2012-07-31",
			2.21
		]
	],
	"21161501": [
		[
			"2000-11-14",
			175.37
		],
		[
			"2001-06-12",
			161.2
		],
		[
			"2002-07-30",
			120.9
		],
		[
			"2003-03-13",
			68.64
		],
		[
			"2003-06-26",
			100.97
		],
		[
			"2004-05-06",
			60.67
		],
		[
			"2005-07-28",
			66.43
		],
		[
			"2006-11-17",
			2.21
		],
		[
			"2007-05-16",
			62
		],
		[
			"2008-03-26",
			70.86
		],
		[
			"2013-07-25",
			34.54
		],
		[
			"2014-08-20",
			14.53
		],
		[
			"2015-11-03",
			16.47
		],
		[
			"2009-08-18",
			37.64
		],
		[
			"2010-07-29",
			39.86
		],
		[
			"2011-05-19",
			88.57
		],
		[
			"2012-06-28",
			36.31
		]
	],
	"21171403": [
		[
			"2000-11-20",
			54.91
		],
		[
			"2001-06-12",
			56.69
		],
		[
			"2001-10-24",
			51.37
		],
		[
			"2002-07-30",
			49.6
		],
		[
			"2002-09-17",
			46.94
		],
		[
			"2003-03-13",
			50.49
		],
		[
			"2003-06-26",
			48.71
		],
		[
			"2003-10-14",
			47.39
		],
		[
			"2004-06-02",
			42.34
		],
		[
			"2004-05-06",
			55.36
		],
		[
			"2005-07-28",
			48.71
		],
		[
			"2005-08-31",
			48.71
		],
		[
			"2006-10-27",
			48.71
		],
		[
			"2007-05-16",
			48.71
		],
		[
			"2008-03-20",
			42.07
		],
		[
			"2013-07-25",
			48.71
		],
		[
			"2013-08-19",
			48.71
		],
		[
			"2014-10-16",
			50.49
		],
		[
			"2015-10-07",
			46.06
		],
		[
			"2009-09-30",
			48.71
		],
		[
			"2010-09-02",
			44.29
		],
		[
			"2011-07-12",
			53.14
		],
		[
			"2012-07-18",
			53.14
		]
	],
	"21172810": [
		[
			"2013-07-24",
			2.21
		],
		[
			"2000-11-14",
			2.21
		],
		[
			"2001-06-12",
			2.21
		],
		[
			"2002-07-30",
			2.21
		],
		[
			"2003-03-13",
			2.21
		],
		[
			"2003-06-26",
			2.21
		],
		[
			"2004-05-06",
			2.21
		],
		[
			"2005-07-28",
			2.21
		],
		[
			"2005-11-10",
			2.21
		],
		[
			"2006-10-26",
			2.21
		],
		[
			"2007-05-24",
			2.21
		],
		[
			"2008-03-26",
			2.21
		],
		[
			"2014-08-20",
			1.33
		],
		[
			"2015-10-08",
			5.8
		]
	],
	"21173709": [
		[
			"2000-11-20",
			2.21
		],
		[
			"2001-06-19",
			2.21
		],
		[
			"2002-07-30",
			2.21
		],
		[
			"2003-03-13",
			2.21
		],
		[
			"2003-06-26",
			2.21
		],
		[
			"2004-05-06",
			2.21
		],
		[
			"2005-07-28",
			2.21
		],
		[
			"2006-10-27",
			2.21
		],
		[
			"2008-03-11",
			2.21
		],
		[
			"2007-05-16",
			2.21
		],
		[
			"2013-08-22",
			2.52
		],
		[
			"2014-10-28",
			1.33
		],
		[
			"2015-11-03",
			1.33
		],
		[
			"2009-09-29",
			2.21
		],
		[
			"2010-09-02",
			2.48
		],
		[
			"2011-04-28",
			2.21
		],
		[
			"2012-06-28",
			2.21
		]
	],
	"21175603": [
		[
			"2000-11-14",
			2.79
		],
		[
			"2001-06-19",
			2.21
		],
		[
			"2002-07-30",
			2.21
		],
		[
			"2003-06-26",
			2.21
		],
		[
			"2004-05-06",
			2.21
		],
		[
			"2005-07-28",
			2.21
		],
		[
			"2006-10-26",
			2.21
		],
		[
			"2007-05-24",
			2.21
		],
		[
			"2008-04-17",
			2.21
		],
		[
			"2013-07-26",
			2.21
		],
		[
			"2014-07-01",
			1.33
		],
		[
			"2015-10-08",
			1.33
		],
		[
			"2009-11-11",
			2.21
		],
		[
			"2010-08-26",
			2.21
		],
		[
			"2011-08-31",
			2.21
		],
		[
			"2012-07-18",
			2.21
		]
	],
	"21175706": [
		[
			"2003-08-07",
			26.26
		],
		[
			"2004-05-17",
			30.42
		],
		[
			"2005-07-28",
			15.5
		],
		[
			"2006-10-26",
			10.19
		],
		[
			"2007-05-29",
			8.41
		],
		[
			"2008-02-28",
			39.41
		],
		[
			"2005-08-02",
			36.09
		],
		[
			"2009-02-03",
			14.48
		],
		[
			"2006-11-27",
			12.09
		],
		[
			"2007-11-26",
			14.08
		],
		[
			"2013-07-26",
			5.76
		],
		[
			"2014-08-19",
			14.57
		],
		[
			"2015-10-08",
			27.41
		],
		[
			"2009-06-24",
			16.08
		],
		[
			"2005-11-07",
			10.05
		],
		[
			"2010-09-02",
			6.42
		],
		[
			"2010-11-15",
			5.27
		],
		[
			"2009-05-18",
			13.29
		],
		[
			"2009-10-07",
			8.86
		],
		[
			"2010-07-30",
			6.64
		],
		[
			"2011-11-08",
			5.67
		],
		[
			"2011-06-29",
			5.31
		],
		[
			"2012-07-18",
			6.64
		]
	],
	"21175809": [
		[
			"2001-07-18",
			2.21
		],
		[
			"2002-07-30",
			2.21
		],
		[
			"2003-07-17",
			2.21
		],
		[
			"2004-05-06",
			2.21
		],
		[
			"2005-07-28",
			2.21
		],
		[
			"2006-10-26",
			2.21
		],
		[
			"2007-05-24",
			2.21
		],
		[
			"2013-07-26",
			2.21
		],
		[
			"2014-08-19",
			1.33
		],
		[
			"2015-10-08",
			1.33
		],
		[
			"2009-09-29",
			2.21
		],
		[
			"2008-03-26",
			3.14
		],
		[
			"2010-07-30",
			2.21
		],
		[
			"2011-06-29",
			2.21
		],
		[
			"2012-05-24",
			2.21
		]
	],
	"21176103": [
		[
			"2006-10-27",
			2.21
		],
		[
			"2007-05-24",
			2.39
		],
		[
			"2008-03-26",
			2.21
		],
		[
			"2013-07-26",
			2.21
		],
		[
			"2014-08-19",
			4.34
		],
		[
			"2015-10-08",
			3.14
		],
		[
			"2009-09-29",
			2.21
		],
		[
			"2010-07-30",
			2.21
		],
		[
			"2011-06-29",
			2.21
		],
		[
			"2012-05-24",
			2.21
		]
	],
	"21184008": [
		[
			"2002-07-31",
			36.45
		],
		[
			"2004-04-15",
			41.76
		],
		[
			"2005-10-20",
			34.99
		],
		[
			"2007-06-05",
			29.67
		],
		[
			"2007-08-31",
			32.33
		],
		[
			"2013-09-03",
			32.33
		],
		[
			"2014-07-15",
			33.57
		],
		[
			"2015-12-03",
			46.06
		],
		[
			"2009-05-12",
			30.56
		],
		[
			"2009-09-17",
			14.17
		],
		[
			"2010-04-21",
			29.67
		],
		[
			"2011-05-04",
			31.44
		],
		[
			"2012-08-15",
			32.77
		]
	],
	"21184306": [
		[
			"2002-07-31",
			25.55
		],
		[
			"2003-07-17",
			25.64
		],
		[
			"2004-04-15",
			28.52
		],
		[
			"2005-07-29",
			25.69
		],
		[
			"2006-11-24",
			24.8
		],
		[
			"2007-05-24",
			23.03
		],
		[
			"2013-09-03",
			25.24
		],
		[
			"2014-11-19",
			25.02
		],
		[
			"2015-10-27",
			24.76
		],
		[
			"2008-04-17",
			25.24
		],
		[
			"2009-05-18",
			23.91
		],
		[
			"2010-08-26",
			20.81
		],
		[
			"2011-08-31",
			24.8
		],
		[
			"2012-08-15",
			26.57
		]
	],
	"21190707": [
		[
			"2006-11-15",
			13.73
		],
		[
			"2013-09-03",
			17.71
		],
		[
			"2014-08-14",
			19.88
		],
		[
			"2015-10-07",
			19.04
		],
		[
			"2009-10-15",
			17.27
		],
		[
			"2010-10-06",
			18.6
		],
		[
			"2011-04-07",
			18.16
		],
		[
			"2012-07-19",
			18.16
		]
	],
	"22520156": [
		[
			"2001-07-12",
			13.55
		],
		[
			"2003-10-31",
			12.93
		],
		[
			"2004-07-23",
			10.72
		],
		[
			"2005-10-21",
			14.17
		],
		[
			"2007-06-14",
			6.64
		],
		[
			"2013-06-25",
			9.3
		],
		[
			"2014-08-13",
			10.54
		],
		[
			"2015-07-16",
			11.69
		],
		[
			"2009-10-14",
			11.51
		],
		[
			"2008-05-07",
			7.09
		],
		[
			"2010-09-22",
			11.51
		],
		[
			"2011-09-15",
			11.51
		],
		[
			"2012-08-04",
			11.96
		]
	],
	"22520223": [
		[
			"2001-07-19",
			73.96
		],
		[
			"2003-10-31",
			73.96
		],
		[
			"2004-07-15",
			70.86
		],
		[
			"2005-10-21",
			75.29
		],
		[
			"2006-12-07",
			66.43
		],
		[
			"2007-06-14",
			70.86
		],
		[
			"2008-05-07",
			79.71
		],
		[
			"2013-06-25",
			86.8
		],
		[
			"2014-08-13",
			68.64
		],
		[
			"2015-07-16",
			76.61
		],
		[
			"2009-10-14",
			70.86
		],
		[
			"2010-10-06",
			75.29
		],
		[
			"2011-09-15",
			53.14
		],
		[
			"2012-08-04",
			75.29
		]
	],
	"23002785": [
		[
			"2010-11-24",
			20.61
		],
		[
			"2011-11-10",
			21.71
		],
		[
			"2013-12-03",
			19.51
		],
		[
			"2014-09-10",
			18.11
		],
		[
			"2015-09-09",
			16.01
		],
		[
			"2000-11-06",
			24.01
		],
		[
			"2001-10-24",
			25.01
		],
		[
			"2002-11-06",
			23.01
		],
		[
			"2004-09-28",
			24.11
		],
		[
			"2003-10-28",
			23.81
		],
		[
			"2005-10-12",
			24.81
		],
		[
			"2006-09-07",
			24.21
		],
		[
			"2007-09-13",
			24.21
		],
		[
			"2006-02-28",
			24.21
		],
		[
			"2006-05-02",
			23.91
		],
		[
			"2006-08-29",
			24.31
		],
		[
			"2006-11-13",
			23.31
		],
		[
			"2007-03-20",
			23.31
		],
		[
			"2007-06-25",
			24.01
		],
		[
			"2007-11-06",
			23.01
		]
	],
	"23006456": [
		[
			"2001-11-07",
			4.3
		],
		[
			"2005-10-25",
			4.4
		],
		[
			"2004-03-22",
			4.6
		],
		[
			"2011-11-29",
			5.5
		],
		[
			"2012-10-22",
			5.4
		],
		[
			"2013-12-12",
			5.8
		],
		[
			"2014-08-28",
			4.8
		],
		[
			"2015-09-10",
			3.5
		],
		[
			"2006-09-11",
			3.7
		],
		[
			"2008-09-16",
			3.9
		],
		[
			"2009-11-09",
			5.9
		]
	],
	"23007114": [
		[
			"2001-11-07",
			6.6
		],
		[
			"2011-11-23",
			5.4
		],
		[
			"2012-10-24",
			4.5
		],
		[
			"2013-12-04",
			4.9
		],
		[
			"2014-09-30",
			4.8
		],
		[
			"2015-09-15",
			4.7
		],
		[
			"2006-04-06",
			5.5
		],
		[
			"2008-09-25",
			5.4
		],
		[
			"2009-10-01",
			5.7
		]
	],
	"23061870": [
		[
			"2001-10-24",
			3.37
		],
		[
			"2002-09-18",
			2.21
		],
		[
			"2002-11-29",
			2.21
		],
		[
			"2003-04-17",
			2.35
		],
		[
			"2003-10-15",
			2.21
		],
		[
			"2004-03-18",
			2.92
		],
		[
			"2004-06-01",
			2.21
		],
		[
			"2005-09-01",
			2.21
		],
		[
			"2005-07-15",
			2.21
		],
		[
			"2004-08-09",
			0.9
		],
		[
			"2006-06-12",
			2.21
		],
		[
			"2007-06-04",
			11.51
		],
		[
			"2008-04-28",
			6.2
		],
		[
			"2010-07-08",
			1
		],
		[
			"2011-07-07",
			1
		],
		[
			"2012-08-22",
			1
		],
		[
			"2013-06-19",
			2.3
		],
		[
			"2014-08-11",
			1
		],
		[
			"2015-05-20",
			4.3
		],
		[
			"2013-07-18",
			10.63
		],
		[
			"2014-07-22",
			1.33
		],
		[
			"2015-09-09",
			2.17
		],
		[
			"2006-08-01",
			1
		],
		[
			"2007-07-03",
			5.8
		],
		[
			"2009-07-06",
			1
		],
		[
			"2009-08-26",
			5.76
		],
		[
			"2010-07-22",
			2.21
		],
		[
			"2011-05-20",
			3.23
		],
		[
			"2012-08-02",
			2.21
		]
	],
	"23061881": [
		[
			"2002-11-29",
			2.21
		],
		[
			"2003-04-17",
			2.21
		],
		[
			"2004-03-18",
			3.01
		],
		[
			"2005-11-10",
			2.21
		],
		[
			"2007-06-04",
			2.21
		],
		[
			"2008-04-28",
			2.21
		],
		[
			"2010-07-08",
			9.5
		],
		[
			"2011-07-07",
			9.3
		],
		[
			"2012-08-22",
			9.9
		],
		[
			"2013-06-19",
			10.2
		],
		[
			"2014-08-11",
			8.6
		],
		[
			"2015-05-20",
			8.2
		],
		[
			"2013-07-18",
			4.07
		],
		[
			"2014-07-22",
			7.93
		],
		[
			"2015-09-09",
			8.81
		],
		[
			"2006-08-01",
			1.4
		],
		[
			"2007-07-03",
			9.5
		],
		[
			"2009-07-06",
			9.5
		],
		[
			"2009-08-26",
			8.86
		],
		[
			"2006-06-12",
			2.21
		],
		[
			"2010-07-22",
			8.86
		],
		[
			"2011-05-20",
			8.86
		],
		[
			"2012-08-02",
			9.74
		]
	],
	"23062850": [
		[
			"2000-01-27",
			10.63
		],
		[
			"2001-03-01",
			14.17
		],
		[
			"2002-06-19",
			13.68
		],
		[
			"2003-03-21",
			9.08
		],
		[
			"2004-03-18",
			6.91
		],
		[
			"2005-07-15",
			2.21
		],
		[
			"2006-06-09",
			9.3
		],
		[
			"2007-07-12",
			11.07
		],
		[
			"2008-04-28",
			2.21
		],
		[
			"2013-09-16",
			8.86
		],
		[
			"2014-07-16",
			9.34
		],
		[
			"2015-07-29",
			10.01
		],
		[
			"2009-08-26",
			11.07
		],
		[
			"2010-07-21",
			9.74
		],
		[
			"2011-05-18",
			9.3
		],
		[
			"2012-09-12",
			7.97
		]
	],
	"23062861": [
		[
			"2000-01-27",
			12.84
		],
		[
			"2001-03-01",
			9.74
		],
		[
			"2002-06-19",
			2.21
		],
		[
			"2003-03-21",
			2.21
		],
		[
			"2004-03-18",
			2.21
		],
		[
			"2005-07-15",
			9.3
		],
		[
			"2006-06-09",
			2.21
		],
		[
			"2007-07-12",
			2.21
		],
		[
			"2013-09-16",
			2.21
		],
		[
			"2014-07-23",
			1.33
		],
		[
			"2015-07-29",
			20.46
		],
		[
			"2009-08-26",
			2.21
		],
		[
			"2008-04-28",
			10.63
		],
		[
			"2010-07-21",
			2.21
		],
		[
			"2011-05-18",
			2.21
		],
		[
			"2012-09-12",
			2.21
		]
	],
	"23063075": [
		[
			"2001-11-28",
			26.93
		],
		[
			"2002-11-13",
			26
		],
		[
			"2003-11-05",
			25.64
		],
		[
			"2004-09-22",
			19.88
		],
		[
			"2005-07-05",
			22.59
		],
		[
			"2006-09-20",
			28.79
		],
		[
			"2007-07-11",
			36.76
		],
		[
			"2008-12-08",
			23.91
		],
		[
			"2013-10-08",
			22.59
		],
		[
			"2014-06-24",
			26.57
		],
		[
			"2015-09-29",
			25.29
		],
		[
			"2009-08-11",
			20.81
		],
		[
			"2010-08-10",
			18.6
		],
		[
			"2011-04-06",
			19.49
		],
		[
			"2012-08-28",
			19.93
		]
	],
	"23160925": [
		[
			"2000-05-09",
			9
		],
		[
			"2000-10-30",
			10
		],
		[
			"2001-05-28",
			10
		],
		[
			"2001-11-06",
			9
		],
		[
			"2002-04-22",
			8
		],
		[
			"2002-11-07",
			8
		],
		[
			"2003-05-06",
			10
		],
		[
			"2003-10-28",
			2
		],
		[
			"2003-10-29",
			9
		],
		[
			"2003-10-30",
			10
		],
		[
			"2003-10-31",
			11
		],
		[
			"2003-11-03",
			11
		],
		[
			"2003-11-13",
			11
		],
		[
			"2004-05-05",
			11
		],
		[
			"2004-10-20",
			14
		],
		[
			"2005-10-20",
			16.01
		],
		[
			"2006-08-28",
			19.01
		],
		[
			"2006-09-11",
			16.01
		],
		[
			"2006-10-09",
			19.01
		],
		[
			"2006-10-23",
			15.01
		],
		[
			"2006-11-06",
			18.01
		],
		[
			"2006-11-20",
			16.01
		],
		[
			"2006-11-24",
			14
		],
		[
			"2006-05-11",
			15.01
		],
		[
			"2010-10-05",
			11
		],
		[
			"2011-05-09",
			14
		],
		[
			"2011-11-10",
			14
		],
		[
			"2012-05-08",
			15.01
		],
		[
			"2012-10-29",
			12
		],
		[
			"2013-05-08",
			16.01
		],
		[
			"2013-11-11",
			17.01
		],
		[
			"2014-05-15",
			14
		],
		[
			"2014-11-06",
			12
		],
		[
			"2015-04-23",
			12
		],
		[
			"2015-10-20",
			12
		],
		[
			"2007-06-06",
			11
		],
		[
			"2007-10-22",
			11
		],
		[
			"2008-04-17",
			12
		],
		[
			"2008-10-20",
			15.01
		],
		[
			"2009-05-06",
			9
		],
		[
			"2009-10-15",
			14
		],
		[
			"2010-04-07",
			13
		]
	],
	"23160949": [
		[
			"2000-05-11",
			24.01
		],
		[
			"2000-11-07",
			25.01
		],
		[
			"2001-05-30",
			24.01
		],
		[
			"2001-11-08",
			23.01
		],
		[
			"2002-04-25",
			24.01
		],
		[
			"2002-10-28",
			28.01
		],
		[
			"2003-05-07",
			29.01
		],
		[
			"2003-10-31",
			22.01
		],
		[
			"2003-11-10",
			27.01
		],
		[
			"2003-11-18",
			7
		],
		[
			"2003-11-19",
			12
		],
		[
			"2003-11-20",
			26.01
		],
		[
			"2003-11-24",
			27.01
		],
		[
			"2004-05-06",
			28.01
		],
		[
			"2004-10-21",
			27.01
		],
		[
			"2005-10-21",
			28.01
		],
		[
			"2006-08-28",
			27.01
		],
		[
			"2006-09-11",
			28.01
		],
		[
			"2006-10-09",
			27.01
		],
		[
			"2006-10-23",
			28.01
		],
		[
			"2006-11-06",
			27.01
		],
		[
			"2006-11-07",
			27.01
		],
		[
			"2006-11-20",
			25.01
		],
		[
			"2006-05-08",
			25.01
		],
		[
			"2010-10-07",
			31.01
		],
		[
			"2011-05-11",
			32.01
		],
		[
			"2011-11-07",
			32.01
		],
		[
			"2012-05-23",
			28.01
		],
		[
			"2012-11-07",
			28.01
		],
		[
			"2013-04-22",
			25.01
		],
		[
			"2013-11-13",
			27.01
		],
		[
			"2014-05-12",
			27.01
		],
		[
			"2014-10-28",
			27.01
		],
		[
			"2015-05-20",
			26.01
		],
		[
			"2015-10-29",
			24.01
		],
		[
			"2007-06-01",
			25.01
		],
		[
			"2007-10-29",
			27.01
		],
		[
			"2008-04-14",
			32.01
		],
		[
			"2008-10-23",
			41.01
		],
		[
			"2009-05-15",
			31.01
		],
		[
			"2009-10-12",
			32.01
		],
		[
			"2010-03-29",
			27.01
		]
	],
	"23161437": [
		[
			"2001-11-06",
			86.03
		],
		[
			"2002-04-22",
			78.03
		],
		[
			"2002-11-07",
			132.05
		],
		[
			"2003-05-06",
			110.04
		],
		[
			"2003-11-13",
			115.04
		],
		[
			"2004-05-05",
			107.04
		],
		[
			"2004-10-20",
			135.05
		],
		[
			"2005-05-18",
			110.04
		],
		[
			"2005-11-24",
			120.04
		],
		[
			"2006-11-24",
			76.03
		],
		[
			"2006-05-11",
			141.05
		],
		[
			"2010-10-05",
			106.04
		],
		[
			"2011-05-09",
			100.04
		],
		[
			"2011-11-10",
			147.05
		],
		[
			"2012-05-08",
			127.05
		],
		[
			"2012-10-29",
			121.04
		],
		[
			"2013-05-08",
			113.04
		],
		[
			"2013-11-11",
			128.05
		],
		[
			"2014-05-15",
			128.05
		],
		[
			"2014-11-06",
			113.04
		],
		[
			"2015-04-23",
			101.04
		],
		[
			"2015-10-20",
			131.05
		],
		[
			"2007-06-06",
			83.03
		],
		[
			"2007-10-22",
			67.02
		],
		[
			"2008-04-17",
			39.01
		],
		[
			"2008-10-21",
			57.02
		],
		[
			"2009-05-06",
			30.01
		],
		[
			"2009-10-15",
			32.01
		],
		[
			"2010-04-07",
			98.03
		]
	],
	"23163227": [
		[
			"2000-01-25",
			2.94
		],
		[
			"2000-03-24",
			2.96
		],
		[
			"2000-05-18",
			2.97
		],
		[
			"2000-07-19",
			3.33
		],
		[
			"2000-10-16",
			3.6
		],
		[
			"2000-11-29",
			3.6
		],
		[
			"2001-07-23",
			3.1
		],
		[
			"2001-03-19",
			3.15
		],
		[
			"2001-05-28",
			3.1
		],
		[
			"2001-09-24",
			3.06
		],
		[
			"2001-11-26",
			3.03
		],
		[
			"2001-01-22",
			3.05
		],
		[
			"2002-01-21",
			2.6
		],
		[
			"2002-09-24",
			4
		],
		[
			"2002-03-27",
			2.5
		],
		[
			"2002-05-28",
			2.8
		],
		[
			"2002-07-25",
			3.7
		],
		[
			"2002-11-20",
			2.9
		],
		[
			"2003-07-29",
			3.5
		],
		[
			"2003-03-25",
			3.1
		],
		[
			"2003-09-23",
			4.2
		],
		[
			"2003-05-13",
			3
		],
		[
			"2003-12-01",
			4.1
		],
		[
			"2003-01-21",
			3
		],
		[
			"2004-01-28",
			4
		],
		[
			"2004-01-28",
			4
		],
		[
			"2013-12-03",
			5
		],
		[
			"2014-03-05",
			4
		],
		[
			"2014-09-02",
			3
		],
		[
			"2015-03-09",
			3
		],
		[
			"2015-09-29",
			3
		],
		[
			"2008-04-22",
			3
		],
		[
			"2004-02-07",
			4
		],
		[
			"2004-10-14",
			3
		],
		[
			"2004-04-27",
			3
		],
		[
			"2005-05-25",
			3
		],
		[
			"2005-07-27",
			3
		],
		[
			"2005-11-30",
			3
		],
		[
			"2006-08-07",
			3
		],
		[
			"2006-09-25",
			3
		],
		[
			"2006-03-27",
			2
		],
		[
			"2006-11-29",
			3
		],
		[
			"2007-08-02",
			3
		],
		[
			"2007-04-05",
			3
		],
		[
			"2007-02-06",
			2
		],
		[
			"2007-05-24",
			2
		],
		[
			"2008-06-04",
			3
		],
		[
			"2008-10-08",
			0.2
		],
		[
			"2008-03-19",
			3
		],
		[
			"2009-06-03",
			0.2
		],
		[
			"2009-11-11",
			3
		],
		[
			"2009-08-19",
			3
		],
		[
			"2009-09-01",
			3.5
		],
		[
			"2010-09-01",
			3.8
		],
		[
			"2010-03-03",
			3.2
		]
	],
	"23163239": [
		[
			"2000-01-25",
			2.73
		],
		[
			"2000-03-24",
			2.82
		],
		[
			"2000-05-18",
			2.98
		],
		[
			"2000-07-19",
			3.08
		],
		[
			"2000-10-16",
			3.2
		],
		[
			"2000-11-29",
			3.2
		],
		[
			"2001-07-23",
			3
		],
		[
			"2001-03-19",
			2.82
		],
		[
			"2001-05-28",
			3.1
		],
		[
			"2001-09-24",
			2.97
		],
		[
			"2001-11-26",
			3.04
		],
		[
			"2001-01-22",
			2.86
		],
		[
			"2002-01-21",
			2.7
		],
		[
			"2002-09-24",
			2.8
		],
		[
			"2002-03-27",
			2.7
		],
		[
			"2002-05-28",
			2.8
		],
		[
			"2002-07-25",
			3.7
		],
		[
			"2002-11-20",
			3.1
		],
		[
			"2003-07-29",
			3.3
		],
		[
			"2003-03-25",
			3.2
		],
		[
			"2003-09-23",
			3.5
		],
		[
			"2003-05-13",
			3
		],
		[
			"2003-12-01",
			3.9
		],
		[
			"2003-01-21",
			3
		],
		[
			"2004-01-28",
			3
		],
		[
			"2004-01-28",
			3.1
		],
		[
			"2013-12-03",
			6
		],
		[
			"2014-03-04",
			4
		],
		[
			"2014-09-02",
			4
		],
		[
			"2015-03-04",
			4
		],
		[
			"2015-09-24",
			4
		],
		[
			"2008-04-22",
			4
		],
		[
			"2008-10-14",
			4
		],
		[
			"2004-02-07",
			4
		],
		[
			"2004-10-14",
			3
		],
		[
			"2004-04-27",
			4
		],
		[
			"2005-06-01",
			3
		],
		[
			"2005-07-27",
			4
		],
		[
			"2005-11-30",
			4
		],
		[
			"2006-08-07",
			3
		],
		[
			"2006-09-25",
			4
		],
		[
			"2006-03-27",
			3
		],
		[
			"2006-11-29",
			4
		],
		[
			"2007-08-02",
			4
		],
		[
			"2007-02-06",
			3
		],
		[
			"2007-05-24",
			4
		],
		[
			"2009-06-03",
			0.2
		],
		[
			"2009-11-11",
			3
		],
		[
			"2009-08-19",
			4
		],
		[
			"2009-09-01",
			4.1
		],
		[
			"2010-09-01",
			4.2
		],
		[
			"2010-03-03",
			4.1
		],
		[
			"2010-06-10",
			4.3
		]
	],
	"23163495": [
		[
			"2000-04-11",
			16.01
		],
		[
			"2000-02-25",
			15.01
		],
		[
			"2000-10-17",
			10
		],
		[
			"2001-10-16",
			12
		],
		[
			"2001-04-10",
			13
		],
		[
			"2001-02-20",
			13
		],
		[
			"2004-04-26",
			15.01
		],
		[
			"2003-03-24",
			16.01
		],
		[
			"2003-10-27",
			15.01
		],
		[
			"2002-06-18",
			14
		],
		[
			"2002-08-14",
			16.01
		],
		[
			"2002-10-07",
			17.01
		],
		[
			"2004-10-25",
			18.01
		],
		[
			"2012-03-29",
			14
		],
		[
			"2012-10-09",
			12
		],
		[
			"2013-03-28",
			16.01
		],
		[
			"2013-11-25",
			13
		],
		[
			"2014-03-26",
			13
		],
		[
			"2014-09-22",
			14
		],
		[
			"2015-10-27",
			15.01
		],
		[
			"2007-03-07",
			13
		],
		[
			"2007-10-17",
			15.01
		],
		[
			"2008-03-05",
			16.01
		],
		[
			"2008-10-31",
			10
		],
		[
			"2009-03-30",
			15.01
		],
		[
			"2009-10-06",
			12
		],
		[
			"2010-03-17",
			15.01
		]
	],
	"24170070": [
		[
			"2000-05-15",
			54.02
		],
		[
			"2000-10-09",
			52.02
		],
		[
			"2001-05-21",
			51.02
		],
		[
			"2001-10-09",
			52.02
		],
		[
			"2001-10-23",
			54.03
		],
		[
			"2002-05-06",
			50.02
		],
		[
			"2002-09-17",
			50.04
		],
		[
			"2002-10-21",
			49.02
		],
		[
			"2003-05-14",
			44.02
		],
		[
			"2003-10-14",
			47.83
		],
		[
			"2003-11-13",
			46.02
		],
		[
			"2004-02-25",
			45.02
		],
		[
			"2004-04-08",
			46.02
		],
		[
			"2004-04-26",
			47.02
		],
		[
			"2004-05-26",
			47.02
		],
		[
			"2004-06-22",
			46.02
		],
		[
			"2004-06-02",
			41.05
		],
		[
			"2004-07-28",
			47.02
		],
		[
			"2004-08-26",
			46.02
		],
		[
			"2004-09-28",
			45.02
		],
		[
			"2004-10-18",
			52.02
		],
		[
			"2004-11-10",
			56.02
		],
		[
			"2004-12-09",
			69.02
		],
		[
			"2005-08-30",
			48.71
		],
		[
			"2005-01-25",
			52.02
		],
		[
			"2005-02-17",
			48.02
		],
		[
			"2005-03-10",
			49.02
		],
		[
			"2005-04-13",
			46.02
		],
		[
			"2005-04-21",
			47.02
		],
		[
			"2005-10-25",
			40.01
		],
		[
			"2005-11-14",
			45.02
		],
		[
			"2005-12-08",
			47.02
		],
		[
			"2006-07-18",
			46.02
		],
		[
			"2006-08-08",
			50.02
		],
		[
			"2006-09-28",
			46.02
		],
		[
			"2006-10-18",
			44.02
		],
		[
			"2006-11-14",
			45.02
		],
		[
			"2006-12-12",
			46.02
		],
		[
			"2006-01-18",
			48.02
		],
		[
			"2006-02-15",
			47.02
		],
		[
			"2006-03-09",
			46.02
		],
		[
			"2006-04-25",
			48.02
		],
		[
			"2006-05-04",
			46.02
		],
		[
			"2006-05-24",
			46.02
		],
		[
			"2006-06-26",
			47.02
		],
		[
			"2010-07-06",
			47.02
		],
		[
			"2010-08-03",
			46.02
		],
		[
			"2010-09-01",
			45.02
		],
		[
			"2010-10-04",
			46.02
		],
		[
			"2010-10-06",
			46.02
		],
		[
			"2010-11-04",
			45.02
		],
		[
			"2010-12-07",
			46.02
		],
		[
			"2011-01-10",
			44.02
		],
		[
			"2011-02-07",
			44.02
		],
		[
			"2011-02-28",
			45.02
		],
		[
			"2011-04-04",
			44.02
		],
		[
			"2011-04-27",
			43.02
		],
		[
			"2011-05-10",
			48.02
		],
		[
			"2011-06-09",
			46.02
		],
		[
			"2011-07-05",
			44.02
		],
		[
			"2011-08-02",
			44.02
		],
		[
			"2011-09-05",
			40.01
		],
		[
			"2011-09-29",
			43.02
		],
		[
			"2011-10-04",
			43.02
		],
		[
			"2011-11-03",
			45.02
		],
		[
			"2011-11-30",
			43.02
		],
		[
			"2012-01-09",
			44.02
		],
		[
			"2012-02-14",
			46.02
		],
		[
			"2012-03-06",
			46.02
		],
		[
			"2012-04-11",
			45.02
		],
		[
			"2012-04-18",
			46.02
		],
		[
			"2012-05-08",
			45.02
		],
		[
			"2012-06-14",
			43.02
		],
		[
			"2012-07-04",
			43.02
		],
		[
			"2012-08-08",
			45.02
		],
		[
			"2012-09-06",
			44.02
		],
		[
			"2012-10-16",
			43.02
		],
		[
			"2012-11-15",
			43.02
		],
		[
			"2012-12-04",
			42.01
		],
		[
			"2013-01-14",
			44.02
		],
		[
			"2013-02-06",
			46.02
		],
		[
			"2013-03-06",
			47.02
		],
		[
			"2013-04-03",
			49.02
		],
		[
			"2013-05-13",
			46.02
		],
		[
			"2013-06-06",
			44.02
		],
		[
			"2013-07-01",
			46.02
		],
		[
			"2013-08-13",
			46.02
		],
		[
			"2013-09-03",
			45.02
		],
		[
			"2013-10-08",
			44.02
		],
		[
			"2013-11-05",
			43.02
		],
		[
			"2013-12-06",
			45.02
		],
		[
			"2014-01-08",
			46.02
		],
		[
			"2014-02-03",
			46.02
		],
		[
			"2014-03-05",
			46.02
		],
		[
			"2014-04-07",
			46.02
		],
		[
			"2014-05-07",
			42.01
		],
		[
			"2014-06-02",
			43.02
		],
		[
			"2014-07-01",
			42.01
		],
		[
			"2014-08-06",
			46.02
		],
		[
			"2014-09-18",
			47.02
		],
		[
			"2015-05-27",
			48.02
		],
		[
			"2015-06-17",
			47.02
		],
		[
			"2015-07-14",
			44.02
		],
		[
			"2015-11-04",
			44.02
		],
		[
			"2015-12-15",
			48.02
		],
		[
			"2007-01-18",
			49.02
		],
		[
			"2007-02-08",
			48.02
		],
		[
			"2007-03-12",
			46.02
		],
		[
			"2007-04-10",
			46.02
		],
		[
			"2007-05-24",
			48.02
		],
		[
			"2007-06-12",
			48.02
		],
		[
			"2007-07-19",
			47.02
		],
		[
			"2007-08-14",
			45.02
		],
		[
			"2007-09-20",
			46.02
		],
		[
			"2007-10-11",
			44.02
		],
		[
			"2007-10-25",
			48.02
		],
		[
			"2007-11-08",
			46.02
		],
		[
			"2007-12-03",
			45.02
		],
		[
			"2008-05-06",
			45.02
		],
		[
			"2008-06-12",
			46.02
		],
		[
			"2008-01-10",
			48.02
		],
		[
			"2008-02-07",
			44.02
		],
		[
			"2008-03-04",
			46.02
		],
		[
			"2008-04-08",
			44.02
		],
		[
			"2008-04-15",
			43.02
		],
		[
			"2008-08-06",
			45.02
		],
		[
			"2008-09-02",
			44.02
		],
		[
			"2008-10-08",
			42.01
		],
		[
			"2008-11-11",
			44.02
		],
		[
			"2008-12-03",
			46.02
		],
		[
			"2009-01-05",
			46.02
		],
		[
			"2009-02-03",
			45.02
		],
		[
			"2009-03-05",
			42.01
		],
		[
			"2009-04-08",
			47.02
		],
		[
			"2009-05-04",
			46.02
		],
		[
			"2009-05-06",
			45.02
		],
		[
			"2009-06-03",
			46.02
		],
		[
			"2009-07-13",
			44.02
		],
		[
			"2009-08-04",
			42.01
		],
		[
			"2009-09-09",
			45.02
		],
		[
			"2009-09-28",
			43.02
		],
		[
			"2009-10-08",
			43.02
		],
		[
			"2009-11-03",
			42.01
		],
		[
			"2009-12-03",
			47.02
		],
		[
			"2010-01-11",
			45.02
		],
		[
			"2010-03-02",
			42.01
		],
		[
			"2010-04-08",
			45.02
		],
		[
			"2010-04-26",
			49.02
		],
		[
			"2010-05-03",
			46.02
		],
		[
			"2010-06-08",
			45.02
		],
		[
			"2012-11-13",
			44.29
		]
	],
	"24170148": [
		[
			"2000-05-15",
			27.01
		],
		[
			"2000-10-24",
			24.01
		],
		[
			"2001-05-21",
			24.01
		],
		[
			"2001-10-09",
			24.01
		],
		[
			"2002-06-06",
			25.01
		],
		[
			"2002-11-04",
			26.01
		],
		[
			"2003-05-14",
			26.01
		],
		[
			"2003-11-10",
			25.01
		],
		[
			"2004-04-26",
			23.01
		],
		[
			"2004-11-10",
			20.01
		],
		[
			"2005-04-21",
			26.01
		],
		[
			"2006-09-28",
			23.01
		],
		[
			"2006-05-04",
			25.01
		],
		[
			"2010-10-06",
			24.01
		],
		[
			"2011-04-27",
			23.01
		],
		[
			"2011-09-29",
			24.01
		],
		[
			"2012-03-27",
			24.01
		],
		[
			"2012-11-08",
			24.01
		],
		[
			"2013-04-18",
			23.01
		],
		[
			"2013-10-08",
			24.01
		],
		[
			"2013-12-03",
			23.01
		],
		[
			"2014-05-08",
			24.01
		],
		[
			"2014-10-13",
			23.01
		],
		[
			"2015-04-15",
			25.01
		],
		[
			"2015-10-14",
			22.01
		],
		[
			"2007-05-24",
			25.01
		],
		[
			"2007-10-11",
			25.01
		],
		[
			"2008-04-15",
			24.01
		],
		[
			"2008-10-08",
			24.01
		],
		[
			"2009-05-12",
			22.01
		],
		[
			"2009-09-28",
			24.01
		],
		[
			"2010-04-26",
			27.01
		]
	],
	"24170150": [
		[
			"2000-07-12",
			22.59
		],
		[
			"2000-11-20",
			21.7
		],
		[
			"2001-07-04",
			20.64
		],
		[
			"2002-04-05",
			30.42
		],
		[
			"2003-07-03",
			19.71
		],
		[
			"2004-02-06",
			33.66
		],
		[
			"2004-06-17",
			18.95
		],
		[
			"2005-10-07",
			22.14
		],
		[
			"2006-07-24",
			21.7
		],
		[
			"2008-03-11",
			31
		],
		[
			"2007-05-25",
			23.03
		],
		[
			"2008-08-08",
			20.81
		],
		[
			"2013-05-28",
			23.91
		],
		[
			"2014-04-15",
			19.93
		],
		[
			"2015-03-18",
			25.73
		],
		[
			"2015-10-05",
			21.43
		],
		[
			"2016-02-17",
			30.11
		],
		[
			"2009-07-14",
			15.5
		],
		[
			"2010-06-22",
			22.59
		],
		[
			"2003-02-28",
			31.97
		],
		[
			"2011-04-28",
			21.7
		],
		[
			"2012-04-26",
			22.14
		]
	],
	"24170173": [
		[
			"2003-06-10",
			40.01
		],
		[
			"2003-06-12",
			39.01
		],
		[
			"2003-06-13",
			39.01
		],
		[
			"2003-06-15",
			39.01
		],
		[
			"2003-06-18",
			40.01
		],
		[
			"2003-06-20",
			39.01
		],
		[
			"2003-06-23",
			39.01
		],
		[
			"2003-06-30",
			39.01
		],
		[
			"2003-06-25",
			39.01
		],
		[
			"2003-06-27",
			39.01
		],
		[
			"2003-10-24",
			38.01
		],
		[
			"2004-07-01",
			41.01
		],
		[
			"2004-10-01",
			40.01
		],
		[
			"2006-03-23",
			38.01
		],
		[
			"2006-04-04",
			38.01
		],
		[
			"2006-04-25",
			38.01
		],
		[
			"2006-08-21",
			38.01
		],
		[
			"2007-05-24",
			40.01
		],
		[
			"2007-10-11",
			39.01
		],
		[
			"2008-04-15",
			38.01
		],
		[
			"2008-10-08",
			38.01
		],
		[
			"2009-04-22",
			37.01
		],
		[
			"2009-09-28",
			37.01
		],
		[
			"2010-04-26",
			37.01
		],
		[
			"2010-10-06",
			37.01
		],
		[
			"2011-04-27",
			36.01
		],
		[
			"2011-09-29",
			37.01
		],
		[
			"2012-03-27",
			36.01
		],
		[
			"2012-11-08",
			37.01
		],
		[
			"2013-04-18",
			35.01
		],
		[
			"2013-10-08",
			38.01
		],
		[
			"2013-12-03",
			34.01
		],
		[
			"2014-05-08",
			35.01
		],
		[
			"2014-10-13",
			35.01
		],
		[
			"2015-04-15",
			36.01
		],
		[
			"2015-10-14",
			34.01
		]
	],
	"24180026": [
		[
			"2000-07-12",
			26.57
		],
		[
			"2000-11-22",
			26.13
		],
		[
			"2001-07-04",
			24.27
		],
		[
			"2002-04-05",
			27.59
		],
		[
			"2003-07-03",
			23.78
		],
		[
			"2004-01-22",
			36.18
		],
		[
			"2005-10-07",
			26.13
		],
		[
			"2006-07-24",
			25.24
		],
		[
			"2008-03-06",
			29.23
		],
		[
			"2007-05-25",
			24.8
		],
		[
			"2008-08-08",
			25.24
		],
		[
			"2013-05-28",
			30.11
		],
		[
			"2014-01-28",
			29.67
		],
		[
			"2015-03-18",
			25.51
		],
		[
			"2016-01-28",
			29.67
		],
		[
			"2009-07-14",
			24.8
		],
		[
			"2010-05-12",
			26.13
		],
		[
			"2003-02-28",
			29.05
		],
		[
			"2011-04-07",
			26.57
		],
		[
			"2012-04-26",
			24.36
		]
	],
	"24180063": [
		[
			"2000-07-12",
			24.36
		],
		[
			"2001-07-17",
			23.52
		],
		[
			"2002-08-14",
			24.18
		],
		[
			"2003-07-03",
			23.43
		],
		[
			"2004-01-22",
			32.15
		],
		[
			"2005-10-14",
			39.86
		],
		[
			"2007-05-25",
			24.36
		],
		[
			"2008-03-06",
			41.19
		],
		[
			"2008-08-26",
			25.24
		],
		[
			"2013-08-22",
			26.57
		],
		[
			"2014-09-23",
			22.14
		],
		[
			"2015-10-05",
			26.13
		],
		[
			"2009-09-30",
			28.34
		],
		[
			"2010-10-13",
			38.53
		],
		[
			"2011-05-19",
			30.11
		],
		[
			"2012-08-08",
			24.36
		]
	],
	"24180087": [
		[
			"2000-07-12",
			28.79
		],
		[
			"2000-11-20",
			28.79
		],
		[
			"2001-07-04",
			27.5
		],
		[
			"2001-10-23",
			29.18
		],
		[
			"2002-04-05",
			30.34
		],
		[
			"2002-09-17",
			32.28
		],
		[
			"2003-07-03",
			27.55
		],
		[
			"2003-10-14",
			38.44
		],
		[
			"2004-01-22",
			43.71
		],
		[
			"2004-06-02",
			24.62
		],
		[
			"2005-08-30",
			31.44
		],
		[
			"2005-10-07",
			30.56
		],
		[
			"2006-07-24",
			28.34
		],
		[
			"2008-03-06",
			31.44
		],
		[
			"2007-05-25",
			27.9
		],
		[
			"2008-08-08",
			29.23
		],
		[
			"2013-05-27",
			30.11
		],
		[
			"2014-01-28",
			33.21
		],
		[
			"2015-03-18",
			30.96
		],
		[
			"2016-01-28",
			34.1
		],
		[
			"2009-07-14",
			27.46
		],
		[
			"2010-05-12",
			31
		],
		[
			"2003-02-25",
			27.9
		],
		[
			"2011-04-07",
			29.67
		],
		[
			"2012-04-26",
			28.34
		]
	],
	"24180166": [
		[
			"2006-11-24",
			29.23
		],
		[
			"2007-05-24",
			24.36
		],
		[
			"2008-03-05",
			26.57
		],
		[
			"2008-08-19",
			24.36
		],
		[
			"2013-05-28",
			29.67
		],
		[
			"2014-01-28",
			24.36
		],
		[
			"2015-03-18",
			28.65
		],
		[
			"2016-02-17",
			29.23
		],
		[
			"2010-05-04",
			26.71
		],
		[
			"2009-05-04",
			25.91
		],
		[
			"2010-10-12",
			25.81
		],
		[
			"2013-05-21",
			29.21
		],
		[
			"2014-05-20",
			24.81
		],
		[
			"2009-09-10",
			23.91
		],
		[
			"2010-05-12",
			26.57
		],
		[
			"2011-04-28",
			23.47
		],
		[
			"2012-04-26",
			23.91
		]
	],
	"24180403": [
		[
			"2000-05-16",
			31.44
		],
		[
			"2000-08-23",
			26.01
		],
		[
			"2000-11-22",
			2.61
		],
		[
			"2000-09-04",
			14.79
		],
		[
			"2001-06-21",
			29.49
		],
		[
			"2001-08-29",
			24.01
		],
		[
			"2002-01-16",
			32.33
		],
		[
			"2002-10-31",
			31.93
		],
		[
			"2003-02-25",
			31.84
		],
		[
			"2003-09-02",
			25.01
		],
		[
			"2003-07-11",
			29.67
		],
		[
			"2004-01-13",
			33.26
		],
		[
			"2002-10-10",
			26.01
		],
		[
			"2004-08-12",
			27.01
		],
		[
			"2011-08-29",
			29.01
		],
		[
			"2013-08-21",
			27.01
		],
		[
			"2013-12-12",
			27.01
		],
		[
			"2014-09-22",
			25.01
		],
		[
			"2015-08-10",
			25.01
		],
		[
			"2005-08-17",
			28.01
		],
		[
			"2006-08-29",
			28.01
		],
		[
			"2008-08-28",
			29.01
		],
		[
			"2009-08-24",
			27.01
		],
		[
			"2010-08-23",
			27.01
		],
		[
			"2012-06-05",
			27.01
		]
	],
	"24180439": [
		[
			"2000-07-13",
			11.51
		],
		[
			"2000-11-22",
			11.07
		],
		[
			"2000-09-04",
			13.29
		],
		[
			"2001-06-21",
			14.08
		],
		[
			"2002-01-16",
			12.89
		],
		[
			"2003-02-25",
			11.96
		],
		[
			"2003-07-11",
			11.07
		],
		[
			"2004-01-13",
			10.19
		],
		[
			"2004-04-29",
			10.98
		],
		[
			"2010-10-06",
			12
		],
		[
			"2011-05-04",
			11
		],
		[
			"2011-10-13",
			11
		],
		[
			"2012-05-14",
			11
		],
		[
			"2012-10-08",
			11
		],
		[
			"2013-06-18",
			13
		],
		[
			"2013-10-08",
			11
		],
		[
			"2014-08-11",
			12
		],
		[
			"2014-10-06",
			11
		],
		[
			"2015-08-18",
			10
		],
		[
			"2015-10-01",
			11
		],
		[
			"2008-10-22",
			11
		],
		[
			"2009-05-27",
			12
		],
		[
			"2009-10-21",
			11
		],
		[
			"2010-05-04",
			12
		]
	],
	"24180452": [
		[
			"2000-02-03",
			6.63
		],
		[
			"2000-03-28",
			6.95
		],
		[
			"2000-05-30",
			6.2
		],
		[
			"2000-07-19",
			6.33
		],
		[
			"2000-11-30",
			6.74
		],
		[
			"2000-10-10",
			7.31
		],
		[
			"2001-03-29",
			7.21
		],
		[
			"2001-05-31",
			5.5
		],
		[
			"2001-11-27",
			5.91
		],
		[
			"2001-01-30",
			7.43
		],
		[
			"2002-03-26",
			6.3
		],
		[
			"2002-09-25",
			5.3
		],
		[
			"2002-11-28",
			5.7
		],
		[
			"2003-08-05",
			7.1
		],
		[
			"2003-03-27",
			6.5
		],
		[
			"2003-09-29",
			6
		],
		[
			"2003-05-15",
			6.5
		],
		[
			"2003-12-01",
			7.8
		],
		[
			"2004-01-29",
			8
		],
		[
			"2004-01-29",
			7.5
		],
		[
			"2013-12-03",
			7
		],
		[
			"2014-03-04",
			6
		],
		[
			"2014-09-02",
			2
		],
		[
			"2015-03-05",
			6
		],
		[
			"2015-09-24",
			7
		],
		[
			"2008-04-22",
			6
		],
		[
			"2008-10-14",
			5
		],
		[
			"2004-10-14",
			5
		],
		[
			"2004-04-27",
			7
		],
		[
			"2005-07-27",
			6
		],
		[
			"2005-11-30",
			6
		],
		[
			"2006-08-07",
			6
		],
		[
			"2006-08-26",
			6
		],
		[
			"2006-11-30",
			6
		],
		[
			"2007-08-02",
			6
		],
		[
			"2007-10-04",
			6
		],
		[
			"2007-04-05",
			6
		],
		[
			"2007-02-06",
			6
		],
		[
			"2007-05-24",
			6
		],
		[
			"2009-09-01",
			6
		],
		[
			"2009-06-03",
			6
		]
	],
	"24180762": [
		[
			"2000-12-12",
			3.1
		],
		[
			"2001-05-15",
			41.01
		],
		[
			"2002-05-08",
			42.01
		],
		[
			"2003-05-19",
			36.01
		],
		[
			"2004-05-27",
			43.02
		],
		[
			"2005-05-23",
			40.01
		],
		[
			"2014-10-28",
			31.58
		],
		[
			"2015-10-27",
			35.16
		],
		[
			"2006-05-16",
			39.01
		],
		[
			"2007-06-13",
			41.01
		]
	],
	"24180853": [
		[
			"2003-07-10",
			45.17
		],
		[
			"2003-08-07",
			46.5
		],
		[
			"2004-05-17",
			38.97
		],
		[
			"2005-10-06",
			44.29
		],
		[
			"2006-10-26",
			42.07
		],
		[
			"2008-02-28",
			44.29
		],
		[
			"2007-05-29",
			44.29
		],
		[
			"2013-08-22",
			41.63
		],
		[
			"2014-09-01",
			41.63
		],
		[
			"2015-12-03",
			44.02
		],
		[
			"2009-05-19",
			31
		],
		[
			"2009-10-07",
			43.84
		],
		[
			"2010-10-13",
			43.84
		],
		[
			"2011-04-28",
			43.4
		],
		[
			"2012-11-07",
			42.51
		]
	],
	"24180865": [
		[
			"2003-07-10",
			38.66
		],
		[
			"2003-08-07",
			38.93
		],
		[
			"2004-05-17",
			15.77
		],
		[
			"2005-10-06",
			37.64
		],
		[
			"2006-10-26",
			35.43
		],
		[
			"2008-02-28",
			32.33
		],
		[
			"2007-05-29",
			31
		],
		[
			"2013-08-22",
			35.43
		],
		[
			"2014-10-16",
			33.39
		],
		[
			"2015-10-07",
			33.7
		],
		[
			"2009-05-19",
			31
		],
		[
			"2009-10-07",
			35.87
		],
		[
			"2010-05-12",
			34.1
		],
		[
			"2011-03-29",
			26.57
		],
		[
			"2012-08-08",
			32.33
		]
	],
	"24180919": [
		[
			"2006-10-27",
			19.49
		],
		[
			"2008-03-05",
			21.7
		],
		[
			"2007-09-27",
			16.39
		],
		[
			"2013-05-28",
			16.83
		],
		[
			"2014-04-15",
			19.04
		],
		[
			"2015-03-19",
			23.69
		],
		[
			"2016-02-17",
			22.59
		],
		[
			"2009-09-10",
			20.37
		],
		[
			"2010-04-21",
			23.03
		],
		[
			"2008-08-15",
			20.37
		],
		[
			"2011-05-04",
			19.93
		],
		[
			"2012-07-21",
			21.26
		]
	],
	"24180920": [
		[
			"2006-10-27",
			16.39
		],
		[
			"2007-09-27",
			20.37
		],
		[
			"2008-03-05",
			17.71
		],
		[
			"2013-05-28",
			16.83
		],
		[
			"2014-01-28",
			18.16
		],
		[
			"2015-03-19",
			19.97
		],
		[
			"2016-02-17",
			22.14
		],
		[
			"2009-08-18",
			17.71
		],
		[
			"2010-04-21",
			19.93
		],
		[
			"2008-08-19",
			18.6
		],
		[
			"2011-05-04",
			19.04
		],
		[
			"2012-07-21",
			16.83
		]
	],
	"24180968": [
		[
			"2002-08-14",
			15.59
		],
		[
			"2004-04-15",
			17.36
		],
		[
			"2005-10-20",
			16.39
		],
		[
			"2007-06-05",
			17.27
		],
		[
			"2007-08-31",
			17.27
		],
		[
			"2013-09-05",
			13.73
		],
		[
			"2014-07-14",
			19
		],
		[
			"2015-12-03",
			16.52
		],
		[
			"2009-05-12",
			14.61
		],
		[
			"2009-09-17",
			7.09
		],
		[
			"2010-04-21",
			14.61
		],
		[
			"2011-05-04",
			13.29
		],
		[
			"2012-08-08",
			15.06
		]
	],
	"24190032": [
		[
			"2002-05-06",
			15.01
		],
		[
			"2002-11-04",
			15.01
		],
		[
			"2003-05-26",
			15.01
		],
		[
			"2003-11-17",
			16.01
		],
		[
			"2004-05-06",
			16.01
		],
		[
			"2004-11-16",
			22.01
		],
		[
			"2005-11-11",
			16.01
		],
		[
			"2006-11-13",
			16.01
		],
		[
			"2006-06-08",
			15.01
		],
		[
			"2010-10-07",
			16.01
		],
		[
			"2011-06-08",
			16.01
		],
		[
			"2011-11-08",
			16.01
		],
		[
			"2012-05-30",
			16.01
		],
		[
			"2012-11-07",
			16.01
		],
		[
			"2013-05-27",
			17.01
		],
		[
			"2013-10-30",
			16.01
		],
		[
			"2014-06-10",
			15.01
		],
		[
			"2014-11-12",
			18.01
		],
		[
			"2015-10-20",
			15.01
		],
		[
			"2007-05-29",
			16.01
		],
		[
			"2007-10-04",
			15.01
		],
		[
			"2008-05-09",
			15.01
		],
		[
			"2008-11-06",
			16.01
		],
		[
			"2009-05-18",
			15.01
		],
		[
			"2009-10-21",
			16.01
		],
		[
			"2010-06-01",
			16.01
		]
	],
	"24190068": [
		[
			"2000-05-22",
			15.01
		],
		[
			"2000-11-20",
			14
		],
		[
			"2001-05-31",
			15.01
		],
		[
			"2001-11-12",
			14
		],
		[
			"2002-05-08",
			13
		],
		[
			"2002-11-07",
			13
		],
		[
			"2003-05-20",
			14
		],
		[
			"2003-10-29",
			13
		],
		[
			"2004-03-17",
			14
		],
		[
			"2004-11-17",
			17.01
		],
		[
			"2005-02-03",
			18.01
		],
		[
			"2005-04-28",
			16.01
		],
		[
			"2006-11-23",
			15.01
		],
		[
			"2010-10-19",
			15.01
		],
		[
			"2011-05-18",
			14
		],
		[
			"2011-11-16",
			15.01
		],
		[
			"2012-05-15",
			15.01
		],
		[
			"2012-11-26",
			15.01
		],
		[
			"2013-05-28",
			13
		],
		[
			"2013-11-21",
			16.01
		],
		[
			"2014-05-27",
			15.01
		],
		[
			"2014-11-27",
			15.01
		],
		[
			"2015-05-28",
			15.01
		],
		[
			"2015-10-26",
			14
		],
		[
			"2007-05-24",
			17.01
		],
		[
			"2007-11-07",
			16.01
		],
		[
			"2008-04-21",
			18.01
		],
		[
			"2008-09-30",
			15.01
		],
		[
			"2009-05-12",
			16.01
		],
		[
			"2009-09-29",
			16.01
		],
		[
			"2010-05-20",
			17.01
		]
	],
	"24190123": [
		[
			"2000-03-29",
			19.01
		],
		[
			"2001-05-30",
			18.01
		],
		[
			"2001-10-22",
			18.01
		],
		[
			"2002-05-06",
			16.01
		],
		[
			"2002-11-04",
			18.01
		],
		[
			"2003-05-26",
			19.01
		],
		[
			"2003-11-17",
			18.01
		],
		[
			"2004-05-06",
			18.01
		],
		[
			"2004-08-02",
			19.01
		],
		[
			"2004-08-04",
			19.01
		],
		[
			"2004-08-09",
			19.01
		],
		[
			"2004-08-11",
			19.01
		],
		[
			"2004-08-16",
			17.01
		],
		[
			"2004-08-18",
			16.01
		],
		[
			"2004-08-23",
			19.01
		],
		[
			"2004-08-25",
			18.01
		],
		[
			"2004-11-16",
			18.01
		],
		[
			"2005-11-11",
			15.01
		],
		[
			"2006-11-13",
			16.01
		],
		[
			"2006-06-08",
			16.01
		],
		[
			"2010-10-07",
			16.01
		],
		[
			"2011-06-08",
			18.01
		],
		[
			"2011-11-08",
			16.01
		],
		[
			"2012-05-30",
			16.01
		],
		[
			"2012-11-07",
			16.01
		],
		[
			"2013-05-27",
			15.01
		],
		[
			"2013-10-30",
			16.01
		],
		[
			"2014-06-10",
			15.01
		],
		[
			"2014-11-12",
			16.01
		],
		[
			"2015-05-27",
			18.01
		],
		[
			"2015-10-20",
			15.01
		],
		[
			"2007-05-29",
			17.01
		],
		[
			"2007-10-04",
			18.01
		],
		[
			"2008-05-09",
			16.01
		],
		[
			"2008-11-06",
			17.01
		],
		[
			"2009-05-18",
			17.01
		],
		[
			"2009-10-21",
			15.01
		],
		[
			"2010-06-01",
			17.01
		]
	],
	"24190147": [
		[
			"2000-03-29",
			1
		],
		[
			"2000-11-21",
			1
		],
		[
			"2001-05-30",
			1
		],
		[
			"2001-07-26",
			16.01
		],
		[
			"2001-10-22",
			1
		],
		[
			"2002-05-06",
			2
		],
		[
			"2002-11-04",
			3
		],
		[
			"2003-05-26",
			2
		],
		[
			"2003-11-17",
			1
		],
		[
			"2004-05-06",
			1
		],
		[
			"2004-11-16",
			1
		],
		[
			"2005-11-11",
			2
		],
		[
			"2006-11-13",
			1
		],
		[
			"2006-06-08",
			1
		],
		[
			"2010-10-07",
			2
		],
		[
			"2011-06-08",
			1
		],
		[
			"2011-11-08",
			1
		],
		[
			"2012-05-30",
			1
		],
		[
			"2012-11-07",
			1
		],
		[
			"2013-05-27",
			1
		],
		[
			"2013-10-30",
			4
		],
		[
			"2014-06-10",
			1
		],
		[
			"2014-11-12",
			2
		],
		[
			"2015-05-27",
			2
		],
		[
			"2015-10-20",
			2
		],
		[
			"2007-05-29",
			1
		],
		[
			"2007-10-04",
			1
		],
		[
			"2008-05-09",
			1
		],
		[
			"2008-11-06",
			1
		],
		[
			"2009-05-18",
			1
		],
		[
			"2009-10-21",
			1
		],
		[
			"2010-06-01",
			1
		]
	],
	"24190251": [
		[
			"2002-05-06",
			15.01
		],
		[
			"2003-05-26",
			15.01
		],
		[
			"2003-11-17",
			15.01
		],
		[
			"2004-05-06",
			15.01
		],
		[
			"2004-11-16",
			15.01
		],
		[
			"2005-11-11",
			15.01
		],
		[
			"2006-11-13",
			15.01
		],
		[
			"2006-06-08",
			15.01
		],
		[
			"2010-10-07",
			14
		],
		[
			"2011-06-08",
			14
		],
		[
			"2011-11-08",
			14
		],
		[
			"2012-05-30",
			14
		],
		[
			"2012-11-07",
			14
		],
		[
			"2013-05-27",
			14
		],
		[
			"2013-10-30",
			14
		],
		[
			"2014-06-10",
			14
		],
		[
			"2014-11-12",
			15.01
		],
		[
			"2015-05-27",
			14
		],
		[
			"2015-10-20",
			13
		],
		[
			"2007-05-29",
			15.01
		],
		[
			"2007-10-04",
			15.01
		],
		[
			"2008-05-09",
			15.01
		],
		[
			"2008-11-06",
			15.01
		],
		[
			"2009-05-18",
			14
		],
		[
			"2009-10-21",
			15.01
		],
		[
			"2010-06-01",
			17.01
		]
	],
	"26490742": [
		[
			"2000-03-29",
			10.4
		],
		[
			"2000-11-07",
			11.5
		],
		[
			"2001-11-28",
			8.7
		],
		[
			"2001-04-24",
			10
		],
		[
			"2002-04-30",
			9.1
		],
		[
			"2003-10-02",
			6.8
		],
		[
			"2003-03-31",
			8.4
		],
		[
			"2004-02-05",
			5
		],
		[
			"2004-12-14",
			4.6
		],
		[
			"2004-10-12",
			7.4
		],
		[
			"2005-05-04",
			8
		],
		[
			"2005-11-08",
			4.7
		],
		[
			"2005-08-10",
			7.6
		],
		[
			"2005-08-17",
			8.3
		],
		[
			"2010-03-03",
			4.6
		],
		[
			"2010-10-21",
			3.8
		],
		[
			"2011-02-15",
			3.8
		],
		[
			"2011-11-03",
			5.8
		],
		[
			"2012-03-06",
			5
		],
		[
			"2012-10-31",
			6.2
		],
		[
			"2013-03-19",
			6.3
		],
		[
			"2013-10-15",
			7.5
		],
		[
			"2014-04-07",
			7.2
		],
		[
			"2014-10-01",
			5.6
		],
		[
			"2015-02-02",
			7.1
		],
		[
			"2006-03-07",
			5.2
		],
		[
			"2006-11-07",
			8
		],
		[
			"2007-10-02",
			7.8
		],
		[
			"2007-02-15",
			6.6
		],
		[
			"2008-02-06",
			7.1
		],
		[
			"2008-10-14",
			7.6
		],
		[
			"2009-11-10",
			4.7
		],
		[
			"2009-02-18",
			5
		]
	],
	"26490766": [
		[
			"2004-01-28",
			3.8
		],
		[
			"2004-03-10",
			2.5
		],
		[
			"2004-06-07",
			1.3
		],
		[
			"2004-04-26",
			1.8
		],
		[
			"2004-02-18",
			3.2
		],
		[
			"2004-11-30",
			0.5
		],
		[
			"2004-09-13",
			0.5
		],
		[
			"2005-02-01",
			0.5
		],
		[
			"2005-11-08",
			1
		],
		[
			"2010-03-03",
			1
		],
		[
			"2010-10-21",
			1
		],
		[
			"2011-02-15",
			1.2
		],
		[
			"2011-10-27",
			1.8
		],
		[
			"2012-03-06",
			1.6
		],
		[
			"2012-10-31",
			2.3
		],
		[
			"2013-03-26",
			1.8
		],
		[
			"2013-10-29",
			2.6
		],
		[
			"2014-10-01",
			1
		],
		[
			"2014-04-07",
			1
		],
		[
			"2015-02-02",
			1
		],
		[
			"2006-03-08",
			1
		],
		[
			"2006-09-14",
			1
		],
		[
			"2007-10-02",
			1
		],
		[
			"2007-02-14",
			1
		],
		[
			"2008-02-13",
			1
		],
		[
			"2008-11-26",
			1
		],
		[
			"2008-11-06",
			1
		],
		[
			"2008-10-16",
			1
		],
		[
			"2009-11-10",
			1
		],
		[
			"2009-02-04",
			1
		]
	],
	"26490997": [
		[
			"2000-04-11",
			59.62
		],
		[
			"2000-10-25",
			48.52
		],
		[
			"2001-11-13",
			52.12
		],
		[
			"2001-05-16",
			62.32
		],
		[
			"2002-11-26",
			55.72
		],
		[
			"2002-06-05",
			53.92
		],
		[
			"2003-09-23",
			55.02
		],
		[
			"2003-04-02",
			50.22
		],
		[
			"2004-02-04",
			50.22
		],
		[
			"2004-09-27",
			52.02
		],
		[
			"2005-01-31",
			47.62
		],
		[
			"2005-10-10",
			45.62
		],
		[
			"2010-02-23",
			36.31
		],
		[
			"2010-10-05",
			34.51
		],
		[
			"2011-02-08",
			43.92
		],
		[
			"2011-10-05",
			48.92
		],
		[
			"2012-03-15",
			43.62
		],
		[
			"2012-09-20",
			39.51
		],
		[
			"2012-12-05",
			47.32
		],
		[
			"2013-02-28",
			35.31
		],
		[
			"2013-10-09",
			35.61
		],
		[
			"2014-10-28",
			31.91
		],
		[
			"2014-04-09",
			34.91
		],
		[
			"2015-05-20",
			13.6
		],
		[
			"2006-02-13",
			43.92
		],
		[
			"2006-09-25",
			40.51
		],
		[
			"2007-02-19",
			42.31
		],
		[
			"2007-10-30",
			44.62
		],
		[
			"2009-10-13",
			38.51
		]
	],
	"26491448": [
		[
			"2000-05-31",
			2.8
		],
		[
			"2000-11-08",
			3.5
		],
		[
			"2001-05-30",
			1.9
		],
		[
			"2001-11-14",
			3.6
		],
		[
			"2002-04-24",
			2.3
		],
		[
			"2003-09-18",
			3.4
		],
		[
			"2003-05-14",
			2.9
		],
		[
			"2004-03-03",
			2.5
		],
		[
			"2004-10-18",
			2.7
		],
		[
			"2005-03-10",
			2.9
		],
		[
			"2005-10-17",
			2.7
		],
		[
			"2010-11-09",
			2.8
		],
		[
			"2011-03-03",
			2.7
		],
		[
			"2011-10-27",
			1.1
		],
		[
			"2012-04-02",
			2.2
		],
		[
			"2012-10-11",
			1.9
		],
		[
			"2013-04-16",
			1.3
		],
		[
			"2013-11-25",
			1.4
		],
		[
			"2014-03-17",
			1
		],
		[
			"2014-10-20",
			1
		],
		[
			"2015-03-11",
			1
		],
		[
			"2006-03-14",
			2.5
		],
		[
			"2006-10-16",
			2.3
		],
		[
			"2007-10-22",
			2.1
		],
		[
			"2007-03-06",
			2
		],
		[
			"2008-03-13",
			1.9
		],
		[
			"2008-10-13",
			2.9
		],
		[
			"2009-10-21",
			2.7
		],
		[
			"2009-03-03",
			3.1
		]
	],
	"26492064": [
		[
			"2000-04-05",
			0.6
		],
		[
			"2000-10-17",
			1.2
		],
		[
			"2001-10-16",
			0.9
		],
		[
			"2001-03-20",
			0.8
		],
		[
			"2002-10-15",
			1
		],
		[
			"2003-05-27",
			5.2
		],
		[
			"2003-09-01",
			1.8
		],
		[
			"2004-05-12",
			1.7
		],
		[
			"2004-10-26",
			1.2
		],
		[
			"2005-05-18",
			2
		],
		[
			"2005-10-04",
			1
		],
		[
			"2010-09-08",
			0.9
		],
		[
			"2011-03-07",
			0.8
		],
		[
			"2011-09-13",
			0.5
		],
		[
			"2012-04-11",
			0.5
		],
		[
			"2012-09-11",
			0.5
		],
		[
			"2013-04-24",
			0.5
		],
		[
			"2013-10-23",
			1
		],
		[
			"2014-04-09",
			0.7
		],
		[
			"2014-10-29",
			0.7
		],
		[
			"2015-03-24",
			1.2
		],
		[
			"2015-10-28",
			2.7
		],
		[
			"2006-03-22",
			0.5
		],
		[
			"2006-09-27",
			0.5
		],
		[
			"2007-09-26",
			0.5
		],
		[
			"2008-04-09",
			0.5
		],
		[
			"2008-12-17",
			0.5
		],
		[
			"2009-03-25",
			0.7
		],
		[
			"2009-09-23",
			0.5
		],
		[
			"2010-03-22",
			0.6
		]
	],
	"26495028": [
		[
			"2000-07-10",
			18.6
		],
		[
			"2001-06-27",
			17.54
		],
		[
			"2002-04-18",
			20.33
		],
		[
			"2003-02-26",
			20.02
		],
		[
			"2003-08-18",
			17.71
		],
		[
			"2006-10-19",
			21.7
		],
		[
			"2007-07-12",
			21.7
		],
		[
			"2008-05-19",
			21.26
		],
		[
			"2010-04-07",
			19.91
		],
		[
			"2014-02-04",
			16.83
		],
		[
			"2015-03-19",
			19.49
		],
		[
			"2007-07-26",
			19.71
		],
		[
			"2009-12-17",
			21.31
		],
		[
			"2009-09-17",
			31.89
		],
		[
			"2010-06-21",
			18.16
		],
		[
			"2011-05-18",
			17.71
		],
		[
			"2012-04-25",
			17.27
		],
		[
			"2013-04-04",
			17.71
		]
	],
	"26500012": [
		[
			"2000-11-29",
			15.5
		],
		[
			"2000-08-30",
			17.01
		],
		[
			"2001-07-10",
			11.16
		],
		[
			"2001-11-09",
			17.89
		],
		[
			"2002-03-22",
			19.22
		],
		[
			"2003-07-24",
			16.83
		],
		[
			"2004-02-13",
			16.74
		],
		[
			"2004-07-23",
			10.72
		],
		[
			"2005-09-30",
			15.94
		],
		[
			"2006-11-23",
			18.6
		],
		[
			"2007-06-15",
			16.83
		],
		[
			"2008-05-07",
			16.83
		],
		[
			"2008-08-07",
			17.27
		],
		[
			"2013-05-27",
			26.57
		],
		[
			"2014-04-15",
			14.17
		],
		[
			"2015-02-25",
			17.14
		],
		[
			"2016-01-28",
			15.94
		],
		[
			"2009-10-15",
			18.16
		],
		[
			"2010-09-22",
			15.94
		],
		[
			"2011-07-28",
			16.39
		],
		[
			"2012-06-27",
			15.94
		]
	],
	"26500036": [
		[
			"2000-08-31",
			38.97
		],
		[
			"2001-07-11",
			39.68
		],
		[
			"2002-03-26",
			38.62
		],
		[
			"2003-07-18",
			43.58
		],
		[
			"2004-02-13",
			53.59
		],
		[
			"2004-07-30",
			38.93
		],
		[
			"2005-10-20",
			43.4
		],
		[
			"2006-11-23",
			43.84
		],
		[
			"2007-06-14",
			43.84
		],
		[
			"2008-05-08",
			41.19
		],
		[
			"2014-04-29",
			37.2
		],
		[
			"2015-02-12",
			37.2
		],
		[
			"2016-01-26",
			38.97
		],
		[
			"2009-10-14",
			43.84
		],
		[
			"2008-08-14",
			44.29
		],
		[
			"2010-09-15",
			41.63
		],
		[
			"2011-06-16",
			40.74
		],
		[
			"2012-07-12",
			42.51
		]
	],
	"26500115": [
		[
			"2000-09-01",
			14.97
		],
		[
			"2001-11-09",
			14.88
		],
		[
			"2002-03-26",
			39.33
		],
		[
			"2003-07-23",
			14.53
		],
		[
			"2004-01-23",
			32.55
		],
		[
			"2004-07-30",
			12.62
		],
		[
			"2006-10-24",
			15.5
		],
		[
			"2007-06-14",
			17.27
		],
		[
			"2008-05-08",
			15.94
		],
		[
			"2013-05-27",
			16.39
		],
		[
			"2014-04-15",
			10.63
		],
		[
			"2015-02-12",
			19.09
		],
		[
			"2016-01-26",
			18.6
		],
		[
			"2009-10-14",
			16.83
		],
		[
			"2005-09-30",
			30.56
		],
		[
			"2008-08-14",
			16.83
		],
		[
			"2010-09-15",
			16.83
		],
		[
			"2011-06-16",
			15.5
		],
		[
			"2012-07-12",
			17.27
		]
	],
	"26500139": [
		[
			"2000-11-29",
			16.39
		],
		[
			"2000-08-31",
			17.49
		],
		[
			"2001-07-10",
			13.29
		],
		[
			"2001-10-23",
			16.3
		],
		[
			"2002-03-22",
			16.74
		],
		[
			"2002-09-17",
			18.33
		],
		[
			"2003-07-24",
			15.37
		],
		[
			"2003-10-14",
			33.61
		],
		[
			"2004-02-13",
			19.53
		],
		[
			"2004-06-02",
			13.33
		],
		[
			"2004-06-18",
			15.19
		],
		[
			"2005-08-30",
			19.49
		],
		[
			"2006-11-23",
			31
		],
		[
			"2007-06-15",
			17.71
		],
		[
			"2008-05-07",
			16.39
		],
		[
			"2013-05-27",
			16.39
		],
		[
			"2014-02-04",
			15.5
		],
		[
			"2015-02-25",
			17.4
		],
		[
			"2016-01-28",
			19.04
		],
		[
			"2009-10-15",
			25.69
		],
		[
			"2005-09-30",
			17.27
		],
		[
			"2008-08-07",
			16.83
		],
		[
			"2010-09-22",
			19.49
		],
		[
			"2011-07-28",
			16.83
		],
		[
			"2012-06-27",
			16.83
		]
	],
	"26500140": [
		[
			"2000-08-31",
			31
		],
		[
			"2001-07-10",
			31.75
		],
		[
			"2001-10-23",
			30.78
		],
		[
			"2002-03-22",
			29.8
		],
		[
			"2002-09-17",
			29.98
		],
		[
			"2003-07-18",
			30.78
		],
		[
			"2003-10-14",
			29.67
		],
		[
			"2004-01-23",
			31.35
		],
		[
			"2004-06-18",
			24.14
		],
		[
			"2004-06-02",
			24.98
		],
		[
			"2005-08-30",
			29.23
		],
		[
			"2005-10-20",
			30.56
		],
		[
			"2006-11-23",
			31.44
		],
		[
			"2007-06-15",
			28.79
		],
		[
			"2008-05-08",
			28.79
		],
		[
			"2008-08-07",
			29.23
		],
		[
			"2013-05-27",
			29.23
		],
		[
			"2014-02-04",
			27.01
		],
		[
			"2015-02-25",
			30.65
		],
		[
			"2016-01-28",
			29.67
		],
		[
			"2009-10-14",
			30.11
		],
		[
			"2010-09-22",
			28.34
		],
		[
			"2011-07-28",
			28.34
		],
		[
			"2012-07-21",
			29.23
		]
	],
	"26501302": [
		[
			"2000-05-16",
			20.01
		],
		[
			"2000-11-21",
			17.01
		],
		[
			"2002-05-07",
			20.01
		],
		[
			"2002-11-06",
			16.01
		],
		[
			"2003-05-19",
			19.01
		],
		[
			"2003-11-17",
			17.01
		],
		[
			"2004-05-11",
			18.01
		],
		[
			"2004-11-16",
			16.01
		],
		[
			"2006-11-15",
			15.01
		],
		[
			"2006-05-31",
			17.01
		],
		[
			"2010-09-23",
			16.01
		],
		[
			"2011-05-23",
			16.01
		],
		[
			"2011-10-26",
			14
		],
		[
			"2012-03-29",
			17.01
		],
		[
			"2012-11-08",
			14
		],
		[
			"2013-04-29",
			17.01
		],
		[
			"2013-11-13",
			15.01
		],
		[
			"2014-05-06",
			15.01
		],
		[
			"2014-11-13",
			14
		],
		[
			"2015-05-20",
			17.01
		],
		[
			"2015-10-21",
			12
		],
		[
			"2007-05-30",
			17.01
		],
		[
			"2007-11-15",
			16.01
		],
		[
			"2008-05-14",
			18.01
		],
		[
			"2008-11-11",
			16.01
		],
		[
			"2009-05-14",
			17.01
		],
		[
			"2009-10-21",
			15.01
		],
		[
			"2010-03-24",
			18.01
		]
	],
	"26501405": [
		[
			"2000-05-16",
			31.01
		],
		[
			"2000-11-21",
			27.01
		],
		[
			"2001-05-28",
			29.01
		],
		[
			"2001-10-18",
			26.01
		],
		[
			"2002-05-07",
			30.01
		],
		[
			"2002-11-06",
			27.01
		],
		[
			"2003-05-19",
			30.01
		],
		[
			"2003-11-17",
			30.01
		],
		[
			"2004-05-11",
			30.01
		],
		[
			"2004-11-16",
			24.01
		],
		[
			"2006-11-15",
			23.01
		],
		[
			"2006-05-31",
			28.01
		],
		[
			"2010-09-23",
			30.01
		],
		[
			"2011-05-23",
			23.01
		],
		[
			"2011-10-26",
			25.01
		],
		[
			"2012-03-29",
			26.01
		],
		[
			"2012-11-08",
			25.01
		],
		[
			"2013-04-29",
			25.01
		],
		[
			"2013-11-13",
			23.01
		],
		[
			"2014-05-06",
			23.01
		],
		[
			"2014-11-13",
			23.01
		],
		[
			"2015-05-20",
			15.01
		],
		[
			"2015-10-21",
			17.01
		],
		[
			"2007-05-30",
			26.01
		],
		[
			"2007-11-15",
			6
		],
		[
			"2008-05-14",
			32.01
		],
		[
			"2008-11-11",
			27.01
		],
		[
			"2009-05-14",
			27.01
		],
		[
			"2009-10-21",
			22.01
		],
		[
			"2010-03-24",
			27.01
		]
	],
	"26501417": [
		[
			"2000-05-16",
			28.01
		],
		[
			"2000-11-21",
			19.01
		],
		[
			"2001-05-28",
			25.01
		],
		[
			"2001-10-18",
			19.01
		],
		[
			"2002-04-04",
			25.01
		],
		[
			"2002-05-07",
			30.01
		],
		[
			"2002-11-06",
			27.01
		],
		[
			"2003-05-19",
			29.01
		],
		[
			"2003-11-17",
			16.01
		],
		[
			"2004-05-11",
			28.01
		],
		[
			"2004-11-16",
			15.01
		],
		[
			"2006-11-15",
			14
		],
		[
			"2006-05-31",
			21.01
		],
		[
			"2010-09-23",
			19.01
		],
		[
			"2011-06-27",
			22.01
		],
		[
			"2011-10-26",
			14
		],
		[
			"2012-03-29",
			19.01
		],
		[
			"2012-11-08",
			16.01
		],
		[
			"2013-04-29",
			24.01
		],
		[
			"2013-11-13",
			19.01
		],
		[
			"2014-05-06",
			19.01
		],
		[
			"2014-11-13",
			16.01
		],
		[
			"2015-05-20",
			25.01
		],
		[
			"2015-10-21",
			15.01
		],
		[
			"2007-05-30",
			23.01
		],
		[
			"2007-11-15",
			17.01
		],
		[
			"2008-05-14",
			27.01
		],
		[
			"2008-11-11",
			16.01
		],
		[
			"2009-05-14",
			20.01
		],
		[
			"2009-10-21",
			15.01
		],
		[
			"2010-03-24",
			21.01
		]
	],
	"26501429": [
		[
			"2000-05-16",
			19.01
		],
		[
			"2000-11-21",
			18.01
		],
		[
			"2001-05-28",
			21.01
		],
		[
			"2001-10-18",
			18.01
		],
		[
			"2002-05-07",
			19.01
		],
		[
			"2002-11-06",
			17.01
		],
		[
			"2003-05-19",
			19.01
		],
		[
			"2003-11-17",
			18.01
		],
		[
			"2004-05-11",
			20.01
		],
		[
			"2004-11-16",
			20.01
		],
		[
			"2006-11-15",
			17.01
		],
		[
			"2006-05-31",
			18.01
		],
		[
			"2010-09-23",
			17.01
		],
		[
			"2011-05-23",
			18.01
		],
		[
			"2011-10-26",
			17.01
		],
		[
			"2012-03-29",
			19.01
		],
		[
			"2012-11-08",
			15.01
		],
		[
			"2013-04-29",
			18.01
		],
		[
			"2013-11-13",
			18.01
		],
		[
			"2014-05-06",
			18.01
		],
		[
			"2014-11-13",
			17.01
		],
		[
			"2015-05-20",
			21.01
		],
		[
			"2015-10-21",
			17.01
		],
		[
			"2007-05-30",
			19.01
		],
		[
			"2007-11-15",
			16.01
		],
		[
			"2008-05-14",
			18.01
		],
		[
			"2008-11-11",
			18.01
		],
		[
			"2009-05-14",
			17.01
		],
		[
			"2009-10-21",
			15.01
		],
		[
			"2010-03-24",
			19.01
		]
	],
	"26501430": [
		[
			"2000-05-16",
			48.02
		],
		[
			"2000-11-21",
			36.01
		],
		[
			"2001-05-28",
			49.02
		],
		[
			"2001-10-18",
			38.01
		],
		[
			"2002-05-07",
			65.02
		],
		[
			"2002-11-06",
			25.01
		],
		[
			"2003-05-19",
			44.02
		],
		[
			"2003-11-17",
			37.01
		],
		[
			"2004-05-11",
			40.01
		],
		[
			"2004-11-16",
			31.01
		],
		[
			"2006-11-15",
			32.01
		],
		[
			"2006-05-31",
			45.02
		],
		[
			"2010-09-23",
			26.01
		],
		[
			"2011-03-03",
			41.01
		],
		[
			"2011-05-23",
			25.01
		],
		[
			"2011-10-26",
			19.01
		],
		[
			"2012-03-29",
			31.01
		],
		[
			"2012-11-08",
			27.01
		],
		[
			"2013-04-29",
			42.01
		],
		[
			"2013-11-13",
			25.01
		],
		[
			"2014-05-06",
			22.01
		],
		[
			"2014-11-13",
			18.01
		],
		[
			"2015-05-20",
			45.02
		],
		[
			"2015-10-21",
			44.02
		],
		[
			"2007-05-30",
			53.02
		],
		[
			"2007-11-15",
			48.02
		],
		[
			"2008-05-14",
			50.02
		],
		[
			"2008-11-11",
			34.01
		],
		[
			"2009-05-14",
			33.01
		],
		[
			"2009-10-21",
			24.01
		],
		[
			"2010-03-24",
			43.02
		]
	],
	"26501454": [
		[
			"2000-05-16",
			19.01
		],
		[
			"2000-11-21",
			20.01
		],
		[
			"2002-05-07",
			18.01
		],
		[
			"2002-11-06",
			14
		],
		[
			"2003-05-19",
			18.01
		],
		[
			"2003-11-17",
			20.01
		],
		[
			"2004-05-11",
			19.01
		],
		[
			"2004-11-16",
			19.01
		],
		[
			"2006-11-15",
			19.01
		],
		[
			"2006-05-31",
			19.01
		],
		[
			"2010-09-23",
			20.01
		],
		[
			"2011-05-23",
			18.01
		],
		[
			"2011-10-26",
			20.01
		],
		[
			"2012-03-29",
			19.01
		],
		[
			"2012-11-08",
			21.01
		],
		[
			"2013-04-29",
			20.01
		],
		[
			"2013-11-13",
			20.01
		],
		[
			"2014-05-06",
			20.01
		],
		[
			"2014-11-13",
			21.01
		],
		[
			"2015-05-20",
			19.01
		],
		[
			"2015-10-21",
			19.01
		],
		[
			"2007-05-30",
			19.01
		],
		[
			"2007-11-15",
			18.01
		],
		[
			"2008-05-14",
			19.01
		],
		[
			"2008-11-11",
			19.01
		],
		[
			"2009-05-14",
			19.01
		],
		[
			"2009-10-21",
			20.01
		],
		[
			"2010-03-24",
			19.01
		]
	],
	"26501480": [
		[
			"2002-05-07",
			1
		],
		[
			"2002-11-06",
			1
		],
		[
			"2003-05-19",
			1
		],
		[
			"2003-11-17",
			1
		],
		[
			"2004-05-11",
			1
		],
		[
			"2004-11-16",
			1
		],
		[
			"2006-11-15",
			1
		],
		[
			"2006-05-31",
			1
		],
		[
			"2010-09-23",
			1
		],
		[
			"2011-05-23",
			1
		],
		[
			"2011-10-26",
			1
		],
		[
			"2012-01-12",
			1
		],
		[
			"2012-03-29",
			1
		],
		[
			"2012-11-08",
			1
		],
		[
			"2013-04-29",
			1
		],
		[
			"2013-11-13",
			5
		],
		[
			"2014-05-12",
			1
		],
		[
			"2014-11-13",
			1
		],
		[
			"2015-05-20",
			1
		],
		[
			"2015-10-21",
			1
		],
		[
			"2007-05-30",
			1
		],
		[
			"2007-11-15",
			1
		],
		[
			"2008-04-07",
			1
		],
		[
			"2008-11-11",
			1
		],
		[
			"2009-05-14",
			1
		],
		[
			"2009-10-21",
			1
		],
		[
			"2010-03-24",
			1
		]
	],
	"26501491": [
		[
			"2000-05-16",
			10
		],
		[
			"2000-11-21",
			10
		],
		[
			"2001-05-28",
			10
		],
		[
			"2001-10-18",
			12
		],
		[
			"2002-05-07",
			10
		],
		[
			"2002-05-16",
			10
		],
		[
			"2002-11-06",
			10
		],
		[
			"2003-05-19",
			11
		],
		[
			"2003-11-17",
			10
		],
		[
			"2004-05-11",
			10
		],
		[
			"2004-11-16",
			10
		],
		[
			"2006-11-15",
			9
		],
		[
			"2006-05-31",
			10
		],
		[
			"2010-09-23",
			9
		],
		[
			"2011-05-23",
			8
		],
		[
			"2011-10-26",
			8
		],
		[
			"2012-03-29",
			9
		],
		[
			"2012-11-08",
			9
		],
		[
			"2013-04-29",
			8
		],
		[
			"2013-11-13",
			9
		],
		[
			"2014-05-06",
			9
		],
		[
			"2014-11-13",
			8
		],
		[
			"2015-05-20",
			8
		],
		[
			"2015-10-21",
			7
		],
		[
			"2007-05-30",
			9
		],
		[
			"2007-11-15",
			29.01
		],
		[
			"2008-05-14",
			10
		],
		[
			"2008-11-11",
			9
		],
		[
			"2009-05-14",
			9
		],
		[
			"2009-10-21",
			8
		],
		[
			"2010-03-24",
			9
		]
	],
	"26501818": [
		[
			"2000-10-11",
			10
		],
		[
			"2000-05-23",
			11
		],
		[
			"2002-06-03",
			11
		],
		[
			"2002-11-05",
			12
		],
		[
			"2003-05-19",
			10
		],
		[
			"2003-11-12",
			12
		],
		[
			"2004-04-28",
			11
		],
		[
			"2004-11-15",
			12
		],
		[
			"2005-04-19",
			11
		],
		[
			"2006-11-16",
			11
		],
		[
			"2006-06-07",
			11
		],
		[
			"2010-09-27",
			11
		],
		[
			"2011-05-31",
			11
		],
		[
			"2011-10-25",
			12
		],
		[
			"2012-05-15",
			11
		],
		[
			"2012-11-07",
			11
		],
		[
			"2013-04-25",
			11
		],
		[
			"2013-11-11",
			13
		],
		[
			"2014-04-29",
			10
		],
		[
			"2014-11-10",
			11
		],
		[
			"2015-03-24",
			9
		],
		[
			"2015-10-07",
			10
		],
		[
			"2007-05-29",
			11
		],
		[
			"2007-11-14",
			10
		],
		[
			"2008-05-15",
			11
		],
		[
			"2008-11-06",
			11
		],
		[
			"2009-05-18",
			11
		],
		[
			"2009-10-21",
			12
		],
		[
			"2010-04-28",
			11
		]
	],
	"26501820": [
		[
			"2000-05-23",
			33.01
		],
		[
			"2002-12-04",
			33.01
		],
		[
			"2003-05-19",
			26.01
		],
		[
			"2003-11-12",
			30.01
		],
		[
			"2004-04-28",
			28.01
		],
		[
			"2004-11-15",
			32.01
		],
		[
			"2005-04-19",
			28.01
		],
		[
			"2006-11-16",
			28.01
		],
		[
			"2006-06-07",
			28.01
		],
		[
			"2010-09-27",
			29.01
		],
		[
			"2011-05-31",
			30.01
		],
		[
			"2011-10-25",
			26.01
		],
		[
			"2012-05-15",
			30.01
		],
		[
			"2012-11-07",
			29.01
		],
		[
			"2013-04-25",
			31.01
		],
		[
			"2013-11-11",
			32.01
		],
		[
			"2014-04-29",
			28.01
		],
		[
			"2014-11-10",
			28.01
		],
		[
			"2015-03-24",
			27.01
		],
		[
			"2015-10-07",
			30.01
		],
		[
			"2007-05-29",
			30.01
		],
		[
			"2007-11-14",
			29.01
		],
		[
			"2008-05-15",
			29.01
		],
		[
			"2008-11-06",
			28.01
		],
		[
			"2009-05-18",
			29.01
		],
		[
			"2009-10-21",
			28.01
		],
		[
			"2010-04-28",
			32.01
		]
	],
	"26502173": [
		[
			"2000-05-16",
			46.02
		],
		[
			"2000-11-13",
			43.02
		],
		[
			"2001-05-10",
			47.02
		],
		[
			"2001-09-24",
			46.02
		],
		[
			"2002-04-16",
			48.02
		],
		[
			"2002-09-26",
			46.02
		],
		[
			"2003-05-13",
			44.02
		],
		[
			"2003-11-12",
			42.01
		],
		[
			"2004-03-16",
			49.02
		],
		[
			"2004-11-09",
			47.02
		],
		[
			"2005-04-20",
			48.02
		],
		[
			"2006-10-04",
			45.02
		],
		[
			"2006-05-03",
			43.02
		],
		[
			"2010-09-30",
			46.02
		],
		[
			"2011-05-19",
			43.02
		],
		[
			"2011-09-27",
			43.02
		],
		[
			"2012-04-25",
			43.02
		],
		[
			"2012-11-22",
			39.01
		],
		[
			"2013-05-23",
			45.02
		],
		[
			"2013-12-03",
			42.01
		],
		[
			"2014-05-28",
			41.01
		],
		[
			"2014-10-30",
			39.01
		],
		[
			"2015-05-28",
			46.02
		],
		[
			"2015-11-03",
			31.01
		],
		[
			"2007-05-23",
			48.02
		],
		[
			"2007-09-25",
			47.02
		],
		[
			"2008-04-23",
			48.02
		],
		[
			"2008-10-02",
			45.02
		],
		[
			"2009-05-05",
			46.02
		],
		[
			"2009-09-23",
			44.02
		],
		[
			"2010-04-13",
			50.02
		]
	],
	"26502185": [
		[
			"2000-05-16",
			37.01
		],
		[
			"2000-11-13",
			35.01
		],
		[
			"2001-07-11",
			47.02
		],
		[
			"2001-09-24",
			47.02
		],
		[
			"2002-04-16",
			37.01
		],
		[
			"2002-09-26",
			30.01
		],
		[
			"2003-05-13",
			41.01
		],
		[
			"2003-11-12",
			31.01
		],
		[
			"2004-03-16",
			42.01
		],
		[
			"2004-11-09",
			49.02
		],
		[
			"2005-04-20",
			39.01
		],
		[
			"2006-10-04",
			25.01
		],
		[
			"2006-05-03",
			37.01
		],
		[
			"2010-09-30",
			42.01
		],
		[
			"2011-05-19",
			36.01
		],
		[
			"2011-09-27",
			37.01
		],
		[
			"2012-04-25",
			33.01
		],
		[
			"2012-11-22",
			34.01
		],
		[
			"2013-05-23",
			37.01
		],
		[
			"2013-12-03",
			35.01
		],
		[
			"2014-05-28",
			31.01
		],
		[
			"2014-10-30",
			31.01
		],
		[
			"2015-05-28",
			23.01
		],
		[
			"2015-11-03",
			26.01
		],
		[
			"2007-05-23",
			32.01
		],
		[
			"2007-09-25",
			27.01
		],
		[
			"2008-04-23",
			34.01
		],
		[
			"2008-10-02",
			45.02
		],
		[
			"2009-05-05",
			31.01
		],
		[
			"2009-09-23",
			38.01
		],
		[
			"2010-04-13",
			39.01
		]
	],
	"26502264": [
		[
			"2001-05-08",
			10
		],
		[
			"2001-09-24",
			9
		],
		[
			"2002-04-16",
			9
		],
		[
			"2002-10-01",
			9
		],
		[
			"2003-05-13",
			9
		],
		[
			"2003-11-11",
			8
		],
		[
			"2004-03-16",
			9
		],
		[
			"2004-11-09",
			8
		],
		[
			"2005-04-25",
			8
		],
		[
			"2006-10-04",
			9
		],
		[
			"2006-05-02",
			9
		],
		[
			"2010-09-28",
			8
		],
		[
			"2011-05-17",
			7
		],
		[
			"2011-09-27",
			7
		],
		[
			"2012-05-03",
			7
		],
		[
			"2012-10-29",
			7
		],
		[
			"2013-04-25",
			8
		],
		[
			"2013-10-24",
			9
		],
		[
			"2014-04-24",
			7
		],
		[
			"2014-10-23",
			8
		],
		[
			"2015-04-14",
			7
		],
		[
			"2015-10-13",
			8
		],
		[
			"2007-05-23",
			9
		],
		[
			"2007-09-26",
			9
		],
		[
			"2008-04-23",
			10
		],
		[
			"2008-09-30",
			8
		],
		[
			"2009-04-23",
			8
		],
		[
			"2009-09-29",
			8
		],
		[
			"2010-04-13",
			11
		]
	],
	"26502392": [
		[
			"2000-10-23",
			1
		],
		[
			"2001-03-26",
			1
		],
		[
			"2002-03-18",
			1
		],
		[
			"2001-10-19",
			1
		],
		[
			"2010-09-21",
			1
		],
		[
			"2012-09-21",
			1
		],
		[
			"2012-03-20",
			1
		],
		[
			"2013-09-18",
			1
		],
		[
			"2013-03-15",
			1
		],
		[
			"2014-09-16",
			1
		],
		[
			"2014-03-17",
			1
		],
		[
			"2015-09-21",
			1
		],
		[
			"2015-03-23",
			1
		],
		[
			"2006-09-18",
			1
		],
		[
			"2006-04-27",
			1
		],
		[
			"2007-09-21",
			1
		],
		[
			"2008-03-10",
			1
		],
		[
			"2008-09-24",
			1
		],
		[
			"2009-03-04",
			1
		],
		[
			"2009-09-14",
			1
		]
	],
	"26502884": [
		[
			"2000-05-22",
			30.01
		],
		[
			"2000-11-15",
			29.01
		],
		[
			"2001-05-07",
			24.01
		],
		[
			"2001-10-15",
			24.01
		],
		[
			"2002-04-15",
			24.01
		],
		[
			"2002-09-24",
			23.01
		],
		[
			"2003-05-12",
			20.01
		],
		[
			"2003-11-03",
			20.01
		],
		[
			"2004-03-15",
			20.01
		],
		[
			"2004-11-08",
			28.01
		],
		[
			"2005-04-26",
			18.01
		],
		[
			"2006-09-27",
			17.01
		],
		[
			"2006-05-18",
			17.01
		],
		[
			"2010-09-28",
			12
		],
		[
			"2011-05-18",
			12
		],
		[
			"2011-09-28",
			12
		],
		[
			"2012-03-28",
			12
		],
		[
			"2012-11-22",
			12
		],
		[
			"2013-06-05",
			11
		],
		[
			"2013-11-21",
			13
		],
		[
			"2014-05-22",
			12
		],
		[
			"2014-11-18",
			11
		],
		[
			"2015-06-09",
			12
		],
		[
			"2015-10-20",
			11
		],
		[
			"2007-05-15",
			16.01
		],
		[
			"2007-09-24",
			17.01
		],
		[
			"2008-04-22",
			15.01
		],
		[
			"2008-09-29",
			15.01
		],
		[
			"2009-04-20",
			12
		],
		[
			"2009-09-24",
			13
		],
		[
			"2010-04-15",
			21.01
		]
	],
	"26502896": [
		[
			"2000-05-22",
			5
		],
		[
			"2000-11-15",
			5
		],
		[
			"2001-05-07",
			5
		],
		[
			"2001-10-15",
			4
		],
		[
			"2002-04-15",
			5
		],
		[
			"2002-09-24",
			4
		],
		[
			"2003-05-12",
			4
		],
		[
			"2003-11-03",
			4
		],
		[
			"2004-03-15",
			6
		],
		[
			"2004-11-08",
			4
		],
		[
			"2005-04-26",
			5
		],
		[
			"2006-09-27",
			4
		],
		[
			"2006-05-18",
			5
		],
		[
			"2010-09-28",
			4
		],
		[
			"2011-05-18",
			3
		],
		[
			"2011-09-28",
			3
		],
		[
			"2012-03-28",
			4
		],
		[
			"2012-11-22",
			3
		],
		[
			"2013-06-05",
			4
		],
		[
			"2013-11-21",
			8
		],
		[
			"2014-05-22",
			4
		],
		[
			"2014-11-18",
			5
		],
		[
			"2015-06-09",
			5
		],
		[
			"2015-10-20",
			4
		],
		[
			"2007-05-15",
			4
		],
		[
			"2008-04-22",
			5
		],
		[
			"2008-09-29",
			4
		],
		[
			"2009-04-20",
			4
		],
		[
			"2009-09-24",
			3
		],
		[
			"2010-04-15",
			5
		]
	],
	"26502902": [
		[
			"2000-11-15",
			12
		],
		[
			"2001-05-07",
			10
		],
		[
			"2001-10-15",
			13
		],
		[
			"2002-04-15",
			13
		],
		[
			"2003-05-12",
			13
		],
		[
			"2003-11-03",
			14
		],
		[
			"2004-03-15",
			12
		],
		[
			"2004-11-08",
			11
		],
		[
			"2005-04-26",
			12
		],
		[
			"2006-09-27",
			14
		],
		[
			"2006-05-18",
			14
		],
		[
			"2010-09-28",
			9
		],
		[
			"2011-05-18",
			12
		],
		[
			"2011-09-28",
			14
		],
		[
			"2012-03-28",
			12
		],
		[
			"2012-11-22",
			13
		],
		[
			"2013-06-05",
			11
		],
		[
			"2013-11-21",
			14
		],
		[
			"2014-05-22",
			11
		],
		[
			"2014-11-18",
			9
		],
		[
			"2015-06-09",
			13
		],
		[
			"2015-10-20",
			12
		],
		[
			"2007-05-15",
			11
		],
		[
			"2007-09-24",
			15.01
		],
		[
			"2008-04-22",
			14
		],
		[
			"2008-09-29",
			15.01
		],
		[
			"2009-04-20",
			13
		],
		[
			"2009-09-24",
			13
		],
		[
			"2010-04-15",
			14
		]
	],
	"26502926": [
		[
			"2000-05-23",
			8
		],
		[
			"2000-11-16",
			8
		],
		[
			"2001-05-08",
			9
		],
		[
			"2001-10-15",
			8
		],
		[
			"2002-04-15",
			8
		],
		[
			"2002-09-24",
			8
		],
		[
			"2003-05-12",
			8
		],
		[
			"2003-11-03",
			8
		],
		[
			"2004-03-15",
			9
		],
		[
			"2004-11-08",
			8
		],
		[
			"2005-04-26",
			9
		],
		[
			"2006-09-27",
			8
		],
		[
			"2006-05-18",
			9
		],
		[
			"2010-09-30",
			8
		],
		[
			"2011-05-18",
			7
		],
		[
			"2011-09-28",
			6
		],
		[
			"2012-03-28",
			7
		],
		[
			"2012-11-22",
			6
		],
		[
			"2013-06-05",
			7
		],
		[
			"2013-11-21",
			10
		],
		[
			"2014-05-22",
			8
		],
		[
			"2014-11-18",
			7
		],
		[
			"2015-06-09",
			7
		],
		[
			"2015-10-20",
			6
		],
		[
			"2007-05-15",
			8
		],
		[
			"2007-09-24",
			10
		],
		[
			"2008-04-22",
			8
		],
		[
			"2008-09-29",
			8
		],
		[
			"2009-04-20",
			8
		],
		[
			"2009-09-24",
			6
		],
		[
			"2010-04-15",
			9
		]
	],
	"26503153": [
		[
			"2001-10-12",
			16.01
		],
		[
			"2002-03-18",
			18
		],
		[
			"2000-03-22",
			15.99
		],
		[
			"2001-03-29",
			13.02
		],
		[
			"2010-09-01",
			11
		],
		[
			"2010-03-03",
			9
		],
		[
			"2012-09-06",
			11
		],
		[
			"2012-03-21",
			11
		],
		[
			"2013-09-23",
			9
		],
		[
			"2013-03-11",
			8
		],
		[
			"2014-09-03",
			10
		],
		[
			"2014-03-24",
			13
		],
		[
			"2015-09-07",
			12
		],
		[
			"2015-03-09",
			9
		],
		[
			"2009-03-24",
			12
		],
		[
			"2009-09-14",
			7
		]
	],
	"26503219": [
		[
			"2000-05-23",
			36.01
		],
		[
			"2002-06-06",
			33.01
		],
		[
			"2003-05-20",
			32.01
		],
		[
			"2003-11-11",
			29.01
		],
		[
			"2004-04-28",
			33.01
		],
		[
			"2004-11-08",
			31.01
		],
		[
			"2005-04-19",
			34.01
		],
		[
			"2006-10-05",
			29.01
		],
		[
			"2006-05-08",
			33.01
		],
		[
			"2010-09-29",
			30.01
		],
		[
			"2011-05-17",
			30.01
		],
		[
			"2011-10-26",
			27.01
		],
		[
			"2012-05-15",
			30.01
		],
		[
			"2012-11-29",
			27.01
		],
		[
			"2013-04-29",
			33.01
		],
		[
			"2013-12-04",
			29.01
		],
		[
			"2014-04-23",
			31.01
		],
		[
			"2014-05-13",
			15.01
		],
		[
			"2014-10-22",
			29.01
		],
		[
			"2015-03-25",
			38.01
		],
		[
			"2015-10-26",
			28.01
		],
		[
			"2007-05-23",
			32.01
		],
		[
			"2007-10-17",
			32.01
		],
		[
			"2008-04-21",
			35.01
		],
		[
			"2008-10-01",
			28.01
		],
		[
			"2009-04-21",
			33.01
		],
		[
			"2009-10-06",
			29.01
		],
		[
			"2010-03-22",
			34.01
		]
	],
	"26504212": [
		[
			"2000-05-16",
			46.02
		],
		[
			"2000-11-13",
			34.01
		],
		[
			"2001-05-10",
			39.01
		],
		[
			"2001-09-24",
			33.01
		],
		[
			"2002-04-16",
			39.01
		],
		[
			"2002-09-26",
			39.01
		],
		[
			"2003-05-13",
			39.01
		],
		[
			"2003-11-12",
			31.01
		],
		[
			"2004-03-16",
			39.01
		],
		[
			"2004-11-09",
			33.01
		],
		[
			"2005-04-20",
			38.01
		],
		[
			"2006-10-04",
			31.01
		],
		[
			"2006-05-03",
			34.01
		],
		[
			"2010-09-30",
			35.01
		],
		[
			"2011-05-19",
			38.01
		],
		[
			"2011-09-27",
			33.01
		],
		[
			"2011-10-13",
			33.01
		],
		[
			"2012-04-25",
			40.01
		],
		[
			"2012-05-21",
			43.02
		],
		[
			"2013-05-16",
			43.02
		],
		[
			"2013-07-15",
			49.02
		],
		[
			"2014-06-02",
			36.01
		],
		[
			"2014-08-07",
			34.01
		],
		[
			"2015-02-09",
			35.01
		],
		[
			"2015-05-28",
			44.02
		],
		[
			"2015-11-03",
			33.01
		],
		[
			"2007-05-23",
			38.01
		],
		[
			"2007-09-25",
			36.01
		],
		[
			"2008-04-23",
			36.01
		],
		[
			"2008-10-14",
			34.01
		],
		[
			"2009-05-05",
			36.01
		],
		[
			"2009-09-23",
			31.01
		],
		[
			"2010-04-13",
			39.01
		]
	],
	"26504261": [
		[
			"2000-05-16",
			42.01
		],
		[
			"2001-07-11",
			46.02
		],
		[
			"2003-11-12",
			41.01
		],
		[
			"2004-03-16",
			47.02
		],
		[
			"2004-11-09",
			44.02
		],
		[
			"2005-04-20",
			41.01
		],
		[
			"2006-10-04",
			41.01
		],
		[
			"2006-05-03",
			41.01
		],
		[
			"2010-09-30",
			44.02
		],
		[
			"2011-05-19",
			38.01
		],
		[
			"2011-09-27",
			41.01
		],
		[
			"2012-04-25",
			41.01
		],
		[
			"2012-11-22",
			37.01
		],
		[
			"2013-05-23",
			42.01
		],
		[
			"2013-06-04",
			43.02
		],
		[
			"2013-12-03",
			40.01
		],
		[
			"2014-05-28",
			40.01
		],
		[
			"2014-10-30",
			38.01
		],
		[
			"2015-05-28",
			39.01
		],
		[
			"2015-11-03",
			40.01
		],
		[
			"2007-05-23",
			40.01
		],
		[
			"2007-09-25",
			39.01
		],
		[
			"2008-06-04",
			38.01
		],
		[
			"2008-10-02",
			42.01
		],
		[
			"2009-05-05",
			43.02
		],
		[
			"2009-09-23",
			41.01
		],
		[
			"2010-05-04",
			47.02
		]
	],
	"26504327": [
		[
			"2000-03-29",
			52.02
		],
		[
			"2000-09-28",
			51.02
		],
		[
			"2001-05-09",
			51.02
		],
		[
			"2003-03-18",
			53.02
		],
		[
			"2003-11-11",
			51.02
		],
		[
			"2004-03-17",
			49.02
		],
		[
			"2004-11-18",
			48.02
		],
		[
			"2005-04-19",
			48.02
		],
		[
			"2006-09-26",
			44.02
		],
		[
			"2006-05-08",
			34.01
		],
		[
			"2010-09-29",
			33.01
		],
		[
			"2011-05-16",
			33.01
		],
		[
			"2011-10-06",
			31.01
		],
		[
			"2012-04-26",
			39.01
		],
		[
			"2012-10-11",
			36.01
		],
		[
			"2013-04-24",
			38.01
		],
		[
			"2013-10-08",
			37.01
		],
		[
			"2014-04-22",
			32.01
		],
		[
			"2014-07-08",
			35.01
		],
		[
			"2014-08-13",
			36.01
		],
		[
			"2014-09-23",
			36.01
		],
		[
			"2014-10-13",
			37.01
		],
		[
			"2014-10-29",
			29.01
		],
		[
			"2014-11-04",
			35.01
		],
		[
			"2014-12-03",
			36.01
		],
		[
			"2015-01-08",
			37.01
		],
		[
			"2015-02-09",
			38.01
		],
		[
			"2015-03-03",
			34.01
		],
		[
			"2015-04-07",
			37.01
		],
		[
			"2015-05-11",
			39.01
		],
		[
			"2015-06-08",
			39.01
		],
		[
			"2015-07-13",
			38.01
		],
		[
			"2015-08-04",
			38.01
		],
		[
			"2015-09-22",
			37.01
		],
		[
			"2015-10-26",
			36.01
		],
		[
			"2015-11-05",
			37.01
		],
		[
			"2015-12-02",
			37.01
		],
		[
			"2007-05-14",
			37.01
		],
		[
			"2007-10-17",
			34.01
		],
		[
			"2008-04-21",
			34.01
		],
		[
			"2008-10-01",
			35.01
		],
		[
			"2009-04-21",
			40.01
		],
		[
			"2009-09-22",
			33.01
		],
		[
			"2010-03-23",
			38.01
		]
	],
	"26504339": [
		[
			"2000-03-29",
			25.01
		],
		[
			"2000-09-28",
			26.01
		],
		[
			"2001-05-09",
			25.01
		],
		[
			"2001-09-25",
			27.01
		],
		[
			"2002-04-17",
			24.01
		],
		[
			"2003-03-18",
			23.01
		],
		[
			"2003-11-11",
			25.01
		],
		[
			"2004-03-17",
			26.01
		],
		[
			"2004-11-18",
			25.01
		],
		[
			"2005-04-19",
			25.01
		],
		[
			"2006-09-26",
			24.01
		],
		[
			"2006-05-08",
			24.01
		],
		[
			"2010-09-29",
			25.01
		],
		[
			"2011-05-16",
			24.01
		],
		[
			"2011-10-06",
			25.01
		],
		[
			"2012-04-26",
			26.01
		],
		[
			"2012-10-11",
			25.01
		],
		[
			"2013-04-24",
			25.01
		],
		[
			"2013-10-08",
			25.01
		],
		[
			"2014-04-22",
			25.01
		],
		[
			"2014-10-29",
			24.01
		],
		[
			"2015-05-11",
			25.01
		],
		[
			"2015-10-26",
			25.01
		],
		[
			"2007-05-14",
			25.01
		],
		[
			"2007-10-17",
			24.01
		],
		[
			"2008-04-21",
			24.01
		],
		[
			"2008-10-01",
			25.01
		],
		[
			"2009-04-21",
			25.01
		],
		[
			"2009-09-22",
			25.01
		],
		[
			"2010-03-23",
			28.01
		]
	],
	"26504352": [
		[
			"2000-03-29",
			18.01
		],
		[
			"2000-09-28",
			17.01
		],
		[
			"2001-05-09",
			17.01
		],
		[
			"2001-09-25",
			16.01
		],
		[
			"2002-04-17",
			18.01
		],
		[
			"2002-09-30",
			18.01
		],
		[
			"2003-03-18",
			17.01
		],
		[
			"2003-11-11",
			15.01
		],
		[
			"2004-03-17",
			18.01
		],
		[
			"2004-11-18",
			11
		],
		[
			"2005-04-19",
			18.01
		],
		[
			"2006-09-26",
			15.01
		],
		[
			"2006-05-08",
			18.01
		],
		[
			"2010-09-29",
			15.01
		],
		[
			"2011-05-16",
			18.01
		],
		[
			"2011-10-06",
			18.01
		],
		[
			"2012-04-26",
			18.01
		],
		[
			"2012-10-11",
			13
		],
		[
			"2013-04-24",
			17.01
		],
		[
			"2013-10-08",
			17.01
		],
		[
			"2014-04-22",
			15.01
		],
		[
			"2014-10-29",
			12
		],
		[
			"2015-05-11",
			19.01
		],
		[
			"2015-10-26",
			14
		],
		[
			"2007-05-14",
			19.01
		],
		[
			"2007-10-17",
			17.01
		],
		[
			"2008-04-21",
			17.01
		],
		[
			"2008-10-01",
			19.01
		],
		[
			"2009-04-21",
			18.01
		],
		[
			"2009-09-22",
			13
		],
		[
			"2010-03-23",
			18.01
		]
	],
	"26504388": [
		[
			"2000-03-29",
			18.01
		],
		[
			"2000-09-28",
			16.01
		],
		[
			"2001-05-09",
			18.01
		],
		[
			"2001-09-25",
			17.01
		],
		[
			"2002-04-17",
			20.01
		],
		[
			"2002-09-30",
			18.01
		],
		[
			"2003-03-18",
			18.01
		],
		[
			"2003-11-11",
			15.01
		],
		[
			"2004-03-17",
			16.01
		],
		[
			"2004-11-18",
			18.01
		],
		[
			"2005-04-19",
			20.01
		],
		[
			"2006-09-26",
			17.01
		],
		[
			"2006-05-08",
			17.01
		],
		[
			"2010-09-29",
			16.01
		],
		[
			"2011-11-18",
			21.01
		],
		[
			"2012-04-26",
			19.01
		],
		[
			"2012-10-11",
			17.01
		],
		[
			"2013-04-24",
			17.01
		],
		[
			"2013-10-08",
			19.01
		],
		[
			"2014-04-22",
			17.01
		],
		[
			"2014-10-29",
			16.01
		],
		[
			"2015-05-11",
			19.01
		],
		[
			"2015-10-26",
			16.01
		],
		[
			"2007-05-14",
			19.01
		],
		[
			"2007-10-17",
			19.01
		],
		[
			"2008-04-21",
			21.01
		],
		[
			"2008-10-01",
			19.01
		],
		[
			"2009-04-21",
			16.01
		],
		[
			"2009-09-22",
			17.01
		],
		[
			"2010-03-23",
			17.01
		]
	],
	"26504613": [
		[
			"2000-05-16",
			61.02
		],
		[
			"2000-11-14",
			60.02
		],
		[
			"2001-05-08",
			59.02
		],
		[
			"2001-09-24",
			60.02
		],
		[
			"2002-04-16",
			58.02
		],
		[
			"2002-10-01",
			57.02
		],
		[
			"2003-05-13",
			56.02
		],
		[
			"2003-11-11",
			57.02
		],
		[
			"2004-03-16",
			59.02
		],
		[
			"2004-11-09",
			61.02
		],
		[
			"2005-04-25",
			55.02
		],
		[
			"2006-10-04",
			54.02
		],
		[
			"2006-05-02",
			57.02
		],
		[
			"2010-09-28",
			52.02
		],
		[
			"2011-05-17",
			52.02
		],
		[
			"2011-09-27",
			51.02
		],
		[
			"2012-05-03",
			50.02
		],
		[
			"2012-10-29",
			49.02
		],
		[
			"2013-04-25",
			52.02
		],
		[
			"2013-10-24",
			49.02
		],
		[
			"2014-04-24",
			48.02
		],
		[
			"2014-10-23",
			30.01
		],
		[
			"2015-04-14",
			50.02
		],
		[
			"2015-10-13",
			52.02
		],
		[
			"2007-05-23",
			56.02
		],
		[
			"2007-09-26",
			55.02
		],
		[
			"2008-04-23",
			56.02
		],
		[
			"2008-09-30",
			53.02
		],
		[
			"2009-04-23",
			50.02
		],
		[
			"2009-09-29",
			52.02
		],
		[
			"2010-04-13",
			56.02
		]
	],
	"26504625": [
		[
			"2000-05-16",
			39.01
		],
		[
			"2000-11-14",
			42.01
		],
		[
			"2001-05-08",
			39.01
		],
		[
			"2001-09-24",
			39.01
		],
		[
			"2002-04-16",
			37.01
		],
		[
			"2002-10-01",
			43.02
		],
		[
			"2003-05-13",
			39.01
		],
		[
			"2003-11-11",
			41.01
		],
		[
			"2004-03-16",
			39.01
		],
		[
			"2004-11-09",
			44.02
		],
		[
			"2005-04-25",
			40.01
		],
		[
			"2006-10-04",
			38.01
		],
		[
			"2006-05-02",
			41.01
		],
		[
			"2010-09-28",
			41.01
		],
		[
			"2011-05-17",
			37.01
		],
		[
			"2011-09-27",
			38.01
		],
		[
			"2012-05-03",
			36.01
		],
		[
			"2012-10-29",
			37.01
		],
		[
			"2013-04-25",
			38.01
		],
		[
			"2013-10-24",
			35.01
		],
		[
			"2014-04-24",
			36.01
		],
		[
			"2014-10-23",
			36.01
		],
		[
			"2015-04-14",
			35.01
		],
		[
			"2015-10-13",
			37.01
		],
		[
			"2007-05-23",
			40.01
		],
		[
			"2007-09-26",
			40.01
		],
		[
			"2008-04-23",
			39.01
		],
		[
			"2008-09-30",
			39.01
		],
		[
			"2009-04-23",
			38.01
		],
		[
			"2009-09-29",
			39.01
		],
		[
			"2010-04-13",
			40.01
		]
	],
	"26504820": [
		[
			"2000-05-23",
			18.01
		],
		[
			"2000-11-22",
			17.01
		],
		[
			"2001-05-29",
			15.01
		],
		[
			"2001-10-16",
			22.01
		],
		[
			"2002-06-03",
			23.01
		],
		[
			"2002-11-05",
			22.01
		],
		[
			"2003-05-19",
			22.01
		],
		[
			"2003-11-12",
			20.01
		],
		[
			"2004-04-28",
			21.01
		],
		[
			"2004-11-15",
			3
		],
		[
			"2005-04-19",
			26.01
		],
		[
			"2006-11-16",
			22.01
		],
		[
			"2006-06-07",
			6
		],
		[
			"2010-09-16",
			3
		],
		[
			"2010-09-27",
			2
		],
		[
			"2011-05-31",
			29.01
		],
		[
			"2011-10-25",
			13
		],
		[
			"2012-05-15",
			16.01
		],
		[
			"2012-11-07",
			27.01
		],
		[
			"2013-04-25",
			21.01
		],
		[
			"2013-11-11",
			30.01
		],
		[
			"2014-04-29",
			13
		],
		[
			"2014-11-10",
			30.01
		],
		[
			"2015-03-24",
			27.01
		],
		[
			"2015-10-07",
			20.01
		],
		[
			"2007-05-29",
			25.01
		],
		[
			"2007-11-14",
			18.01
		],
		[
			"2008-05-15",
			24.01
		],
		[
			"2008-11-06",
			27.01
		],
		[
			"2009-05-18",
			25.01
		],
		[
			"2009-10-21",
			14
		],
		[
			"2010-04-28",
			21.01
		]
	],
	"26504868": [
		[
			"2000-05-23",
			12
		],
		[
			"2000-11-22",
			19.01
		],
		[
			"2001-05-29",
			18.01
		],
		[
			"2001-10-16",
			22.01
		],
		[
			"2002-06-03",
			11
		],
		[
			"2002-11-05",
			13
		],
		[
			"2003-05-19",
			15.01
		],
		[
			"2003-11-12",
			17.01
		],
		[
			"2004-04-28",
			19.01
		],
		[
			"2004-11-15",
			20.01
		],
		[
			"2005-04-19",
			13
		],
		[
			"2006-11-16",
			16.01
		],
		[
			"2006-06-07",
			19.01
		],
		[
			"2010-09-27",
			17.01
		],
		[
			"2011-05-31",
			23.01
		],
		[
			"2011-10-25",
			22.01
		],
		[
			"2012-05-15",
			16.01
		],
		[
			"2012-11-07",
			21.01
		],
		[
			"2013-04-25",
			14
		],
		[
			"2013-11-11",
			20.01
		],
		[
			"2014-04-29",
			20.01
		],
		[
			"2014-11-10",
			20.01
		],
		[
			"2015-03-24",
			17.01
		],
		[
			"2015-10-07",
			19.01
		],
		[
			"2007-05-29",
			17.01
		],
		[
			"2007-11-14",
			16.01
		],
		[
			"2008-05-15",
			9
		],
		[
			"2008-11-06",
			17.01
		],
		[
			"2009-05-18",
			16.01
		],
		[
			"2009-10-21",
			22.01
		],
		[
			"2010-04-28",
			25.01
		]
	],
	"26504870": [
		[
			"2000-05-23",
			26.01
		],
		[
			"2000-11-22",
			17.01
		],
		[
			"2001-05-29",
			25.01
		],
		[
			"2001-10-16",
			22.01
		],
		[
			"2002-06-03",
			27.01
		],
		[
			"2002-11-05",
			23.01
		],
		[
			"2003-05-19",
			19.01
		],
		[
			"2003-11-12",
			17.01
		],
		[
			"2004-04-28",
			21.01
		],
		[
			"2004-11-15",
			16.01
		],
		[
			"2005-04-19",
			26.01
		],
		[
			"2006-11-16",
			19.01
		],
		[
			"2006-06-07",
			23.01
		],
		[
			"2010-09-27",
			22.01
		],
		[
			"2011-05-31",
			24.01
		],
		[
			"2011-10-25",
			22.01
		],
		[
			"2012-05-15",
			26.01
		],
		[
			"2012-11-07",
			23.01
		],
		[
			"2013-04-25",
			30.01
		],
		[
			"2013-11-11",
			28.01
		],
		[
			"2014-04-29",
			24.01
		],
		[
			"2014-11-10",
			23.01
		],
		[
			"2015-03-24",
			29.01
		],
		[
			"2015-10-07",
			22.01
		],
		[
			"2007-05-29",
			20.01
		],
		[
			"2007-11-14",
			24.01
		],
		[
			"2008-05-15",
			31.01
		],
		[
			"2008-11-06",
			19.01
		],
		[
			"2009-05-18",
			24.01
		],
		[
			"2009-10-21",
			19.01
		],
		[
			"2010-04-28",
			32.01
		]
	],
	"26525033": [
		[
			"2000-11-08",
			2.21
		],
		[
			"2002-07-17",
			2.21
		],
		[
			"2003-04-02",
			2.21
		],
		[
			"2004-03-12",
			2.21
		],
		[
			"2005-07-08",
			2.21
		],
		[
			"2006-04-12",
			2.21
		],
		[
			"2006-11-07",
			2.21
		],
		[
			"2007-06-22",
			2.21
		],
		[
			"2008-04-04",
			2.21
		],
		[
			"2013-06-27",
			2.21
		],
		[
			"2014-05-15",
			2.21
		],
		[
			"2015-07-14",
			1.33
		],
		[
			"2009-06-29",
			2.21
		],
		[
			"2010-06-09",
			2.21
		],
		[
			"2011-04-05",
			2.21
		],
		[
			"2012-06-21",
			2.21
		]
	],
	"26525045": [
		[
			"2000-07-11",
			2.21
		],
		[
			"2001-02-15",
			2.21
		],
		[
			"2001-10-25",
			19
		],
		[
			"2002-05-22",
			2.21
		],
		[
			"2002-08-21",
			5
		],
		[
			"2002-09-18",
			3.99
		],
		[
			"2003-03-21",
			17.14
		],
		[
			"2003-10-13",
			3.9
		],
		[
			"2004-02-27",
			2.21
		],
		[
			"2004-06-01",
			2.21
		],
		[
			"2006-05-24",
			2.21
		],
		[
			"2013-10-29",
			2.21
		],
		[
			"2015-10-28",
			2.88
		]
	],
	"26525057": [
		[
			"2000-07-11",
			2.21
		],
		[
			"2001-02-15",
			2.21
		],
		[
			"2002-05-22",
			2.21
		],
		[
			"2002-08-21",
			2.21
		],
		[
			"2003-03-21",
			2.21
		],
		[
			"2004-02-27",
			2.21
		],
		[
			"2005-07-21",
			2.21
		],
		[
			"2007-05-30",
			2.21
		],
		[
			"2008-08-25",
			2.3
		],
		[
			"2013-10-29",
			2.21
		],
		[
			"2014-07-23",
			1.33
		],
		[
			"2015-10-28",
			3.9
		],
		[
			"2009-07-09",
			2.3
		],
		[
			"2010-06-17",
			2.21
		],
		[
			"2006-05-24",
			2.21
		],
		[
			"2008-04-29",
			2.21
		],
		[
			"2011-07-05",
			2.21
		],
		[
			"2012-08-14",
			2.21
		]
	],
	"26525094": [
		[
			"2002-11-29",
			32.95
		],
		[
			"2003-04-17",
			31.44
		],
		[
			"2004-03-18",
			25.11
		],
		[
			"2005-07-15",
			17.27
		],
		[
			"2007-06-04",
			20.37
		],
		[
			"2013-07-18",
			16.39
		],
		[
			"2014-07-22",
			16.25
		],
		[
			"2015-09-09",
			18.29
		],
		[
			"2009-08-26",
			18.6
		],
		[
			"2006-06-12",
			26.13
		],
		[
			"2008-04-28",
			25.24
		],
		[
			"2010-07-22",
			23.03
		],
		[
			"2011-05-20",
			30.56
		],
		[
			"2012-08-02",
			27.01
		]
	],
	"26525112": [
		[
			"2010-08-05",
			4.4
		],
		[
			"2011-08-15",
			5.1
		],
		[
			"2012-08-15",
			3.6
		],
		[
			"2013-08-15",
			3.8
		],
		[
			"2014-08-20",
			6.2
		],
		[
			"2015-08-20",
			7.7
		],
		[
			"2006-08-10",
			4.1
		],
		[
			"2007-08-01",
			3.5
		],
		[
			"2008-08-04",
			5.7
		]
	],
	"26531021": [
		[
			"2001-11-14",
			26.88
		],
		[
			"2002-10-22",
			12.89
		],
		[
			"2003-03-12",
			9.3
		],
		[
			"2004-06-28",
			2.7
		],
		[
			"2005-07-06",
			21.26
		],
		[
			"2006-09-25",
			16.39
		],
		[
			"2007-06-25",
			13.73
		],
		[
			"2013-07-02",
			10.63
		],
		[
			"2014-06-24",
			21.48
		],
		[
			"2015-08-11",
			12.53
		],
		[
			"2011-04-18",
			8.41
		],
		[
			"2012-06-14",
			5.76
		]
	],
	"26531033": [
		[
			"2001-11-14",
			17.27
		],
		[
			"2002-10-22",
			8.64
		],
		[
			"2003-03-12",
			13.02
		],
		[
			"2004-06-28",
			7.71
		],
		[
			"2005-07-06",
			9.3
		],
		[
			"2006-09-25",
			8.86
		],
		[
			"2007-06-25",
			4.87
		],
		[
			"2013-07-02",
			7.09
		],
		[
			"2014-06-20",
			5.05
		],
		[
			"2015-08-11",
			7
		],
		[
			"2011-04-18",
			6.64
		],
		[
			"2012-06-14",
			5.76
		]
	],
	"26531045": [
		[
			"2001-11-14",
			9.88
		],
		[
			"2002-10-22",
			27.9
		],
		[
			"2003-03-12",
			19.04
		],
		[
			"2004-06-28",
			12.62
		],
		[
			"2005-07-06",
			9.3
		],
		[
			"2006-09-25",
			9.3
		],
		[
			"2007-06-25",
			14.17
		],
		[
			"2013-07-02",
			30.11
		],
		[
			"2014-06-20",
			21.43
		],
		[
			"2015-08-11",
			21.79
		],
		[
			"2011-04-18",
			19.04
		],
		[
			"2012-06-14",
			18.16
		]
	],
	"26531057": [
		[
			"2001-11-15",
			2.21
		],
		[
			"2002-10-09",
			2.21
		],
		[
			"2003-04-08",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-07-12",
			2.21
		],
		[
			"2006-10-02",
			2.21
		],
		[
			"2007-06-27",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-09-19",
			2.21
		],
		[
			"2014-07-03",
			1.51
		],
		[
			"2015-08-04",
			2.04
		],
		[
			"2009-10-19",
			2.21
		],
		[
			"2010-10-26",
			2.21
		],
		[
			"2011-05-25",
			4.87
		],
		[
			"2012-10-10",
			2.88
		]
	],
	"26531069": [
		[
			"2001-11-15",
			2.21
		],
		[
			"2002-10-09",
			2.21
		],
		[
			"2003-04-08",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-07-12",
			2.21
		],
		[
			"2006-10-02",
			2.21
		],
		[
			"2007-06-27",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-09-19",
			2.21
		],
		[
			"2014-07-03",
			1.33
		],
		[
			"2015-08-04",
			1.33
		],
		[
			"2009-10-19",
			2.21
		],
		[
			"2010-10-26",
			2.21
		],
		[
			"2011-05-25",
			2.21
		],
		[
			"2012-10-10",
			2.21
		]
	],
	"26531070": [
		[
			"2001-11-15",
			2.21
		],
		[
			"2002-10-09",
			2.21
		],
		[
			"2003-04-08",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-07-12",
			2.21
		],
		[
			"2006-10-02",
			2.21
		],
		[
			"2007-06-27",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-09-19",
			2.21
		],
		[
			"2014-07-03",
			1.33
		],
		[
			"2015-08-04",
			2.21
		],
		[
			"2009-10-19",
			2.21
		],
		[
			"2010-10-26",
			2.21
		],
		[
			"2011-05-25",
			2.21
		],
		[
			"2012-10-10",
			2.21
		]
	],
	"26531082": [
		[
			"2001-11-15",
			2.21
		],
		[
			"2002-10-09",
			2.21
		],
		[
			"2003-04-08",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-07-12",
			2.21
		],
		[
			"2006-10-02",
			2.21
		],
		[
			"2007-06-27",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-09-19",
			2.21
		],
		[
			"2014-07-03",
			2.79
		],
		[
			"2015-08-04",
			1.33
		],
		[
			"2009-10-19",
			2.21
		],
		[
			"2010-10-26",
			2.21
		],
		[
			"2011-05-25",
			2.21
		],
		[
			"2012-10-10",
			2.21
		]
	],
	"26531094": [
		[
			"2001-11-13",
			15.32
		],
		[
			"2002-10-08",
			28.74
		],
		[
			"2003-10-01",
			48.71
		],
		[
			"2004-07-05",
			16.52
		],
		[
			"2005-07-18",
			42.96
		],
		[
			"2006-09-27",
			70.86
		],
		[
			"2007-06-26",
			27.9
		],
		[
			"2008-12-03",
			75.29
		],
		[
			"2013-09-17",
			163.86
		],
		[
			"2014-07-15",
			66.87
		],
		[
			"2015-08-04",
			130.2
		],
		[
			"2009-10-20",
			84.14
		],
		[
			"2011-04-20",
			57.57
		],
		[
			"2012-07-31",
			84.14
		]
	],
	"26531100": [
		[
			"2001-11-13",
			89.46
		],
		[
			"2002-10-08",
			75.29
		],
		[
			"2003-10-01",
			110.27
		],
		[
			"2004-07-05",
			79.27
		],
		[
			"2005-07-18",
			141.71
		],
		[
			"2006-09-27",
			163.86
		],
		[
			"2007-06-26",
			163.86
		],
		[
			"2013-09-17",
			225.86
		],
		[
			"2014-07-15",
			193.53
		],
		[
			"2015-08-04",
			182.9
		],
		[
			"2011-04-20",
			168.29
		],
		[
			"2012-07-31",
			155
		]
	],
	"26531112": [
		[
			"2001-11-13",
			189.54
		],
		[
			"2002-10-08",
			105.4
		],
		[
			"2003-10-01",
			152.34
		],
		[
			"2004-07-05",
			155
		],
		[
			"2005-07-18",
			150.57
		],
		[
			"2006-09-27",
			217
		],
		[
			"2007-06-26",
			256.86
		],
		[
			"2013-09-17",
			190.43
		],
		[
			"2014-07-15",
			174.93
		],
		[
			"2015-08-04",
			135.07
		],
		[
			"2009-10-20",
			172.71
		],
		[
			"2008-12-03",
			243.57
		],
		[
			"2011-04-20",
			221.43
		],
		[
			"2012-07-31",
			208.14
		]
	],
	"26531124": [
		[
			"2001-11-13",
			175.37
		],
		[
			"2002-10-08",
			133.74
		],
		[
			"2003-10-01",
			152.79
		],
		[
			"2005-07-18",
			70.86
		],
		[
			"2006-09-27",
			88.57
		],
		[
			"2007-06-26",
			186
		],
		[
			"2013-09-17",
			48.71
		],
		[
			"2014-07-15",
			27.68
		],
		[
			"2015-08-04",
			14.61
		],
		[
			"2011-04-20",
			137.29
		],
		[
			"2012-07-31",
			43.4
		]
	],
	"26540174": [
		[
			"2001-11-28",
			174.93
		],
		[
			"2002-11-13",
			202.39
		],
		[
			"2003-11-05",
			238.26
		],
		[
			"2004-09-22",
			158.1
		],
		[
			"2005-07-05",
			181.57
		],
		[
			"2006-09-20",
			97.43
		],
		[
			"2007-07-11",
			88.57
		],
		[
			"2008-12-08",
			32.33
		],
		[
			"2013-10-08",
			75.29
		],
		[
			"2014-06-24",
			189.1
		],
		[
			"2015-09-29",
			116.03
		],
		[
			"2009-08-11",
			13.29
		],
		[
			"2010-08-10",
			39.41
		],
		[
			"2011-04-14",
			84.14
		],
		[
			"2012-08-28",
			75.29
		]
	],
	"26540186": [
		[
			"2001-11-28",
			2.21
		],
		[
			"2002-11-13",
			4.25
		],
		[
			"2003-11-05",
			2.21
		],
		[
			"2004-09-22",
			2.21
		],
		[
			"2005-07-05",
			2.21
		],
		[
			"2006-09-20",
			3.41
		],
		[
			"2007-07-11",
			2.21
		],
		[
			"2008-12-08",
			2.21
		],
		[
			"2013-10-08",
			2.21
		],
		[
			"2014-06-24",
			1.33
		],
		[
			"2015-09-29",
			2.39
		],
		[
			"2009-08-11",
			2.21
		],
		[
			"2010-08-10",
			2.21
		],
		[
			"2011-04-14",
			2.21
		],
		[
			"2012-08-28",
			2.21
		]
	],
	"26540198": [
		[
			"2001-11-28",
			53.59
		],
		[
			"2002-11-13",
			58.9
		],
		[
			"2003-11-05",
			52.26
		],
		[
			"2004-09-22",
			47.92
		],
		[
			"2005-07-05",
			53.14
		],
		[
			"2006-09-20",
			57.57
		],
		[
			"2007-07-11",
			53.14
		],
		[
			"2008-12-08",
			48.71
		],
		[
			"2013-10-08",
			44.29
		],
		[
			"2014-06-24",
			29.1
		],
		[
			"2015-09-29",
			34.81
		],
		[
			"2009-08-11",
			44.29
		],
		[
			"2010-08-10",
			44.29
		],
		[
			"2011-04-14",
			53.14
		],
		[
			"2012-08-28",
			48.71
		]
	],
	"26540204": [
		[
			"2001-11-28",
			55.8
		],
		[
			"2002-11-13",
			58.9
		],
		[
			"2003-11-05",
			61.56
		],
		[
			"2004-09-22",
			57.17
		],
		[
			"2005-07-05",
			62
		],
		[
			"2006-09-20",
			57.57
		],
		[
			"2007-07-11",
			53.14
		],
		[
			"2008-12-08",
			57.57
		],
		[
			"2013-10-08",
			48.71
		],
		[
			"2014-06-24",
			47.83
		],
		[
			"2015-09-29",
			53.14
		],
		[
			"2009-08-11",
			57.57
		],
		[
			"2010-08-10",
			53.14
		],
		[
			"2011-04-14",
			53.14
		],
		[
			"2012-08-28",
			53.14
		]
	],
	"26540216": [
		[
			"2002-10-23",
			2.21
		],
		[
			"2003-10-29",
			2.21
		],
		[
			"2004-07-07",
			2.21
		],
		[
			"2005-07-20",
			2.21
		],
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-06-18",
			2.21
		],
		[
			"2008-12-02",
			2.21
		],
		[
			"2013-07-30",
			2.21
		],
		[
			"2014-05-22",
			2.21
		],
		[
			"2015-07-21",
			1.33
		],
		[
			"2009-09-18",
			2.21
		],
		[
			"2011-04-26",
			2.21
		]
	],
	"26540228": [
		[
			"2002-10-23",
			120.01
		],
		[
			"2003-10-29",
			35.78
		],
		[
			"2004-07-07",
			5.49
		],
		[
			"2005-07-20",
			2.7
		],
		[
			"2006-08-09",
			10.19
		],
		[
			"2007-06-18",
			16.39
		],
		[
			"2008-12-02",
			16.83
		],
		[
			"2013-07-30",
			17.71
		],
		[
			"2014-05-22",
			10.63
		],
		[
			"2015-07-21",
			4.61
		],
		[
			"2010-06-24",
			2.21
		],
		[
			"2011-04-26",
			21.7
		],
		[
			"2012-07-25",
			9.3
		]
	],
	"26540230": [
		[
			"2002-10-23",
			6.55
		],
		[
			"2003-10-29",
			16.43
		],
		[
			"2004-07-07",
			11.16
		],
		[
			"2005-07-20",
			2.21
		],
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-06-18",
			2.21
		],
		[
			"2008-12-02",
			11.96
		],
		[
			"2013-07-30",
			2.21
		],
		[
			"2014-05-22",
			2.21
		],
		[
			"2015-07-21",
			1.33
		],
		[
			"2009-09-18",
			2.21
		],
		[
			"2010-06-24",
			2.21
		],
		[
			"2010-09-06",
			2.21
		],
		[
			"2011-04-26",
			24.36
		]
	],
	"26540241": [
		[
			"2002-10-23",
			2.21
		],
		[
			"2003-10-29",
			2.21
		],
		[
			"2004-07-07",
			2.21
		],
		[
			"2005-07-20",
			2.21
		],
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-06-18",
			2.21
		],
		[
			"2008-12-02",
			2.21
		],
		[
			"2013-07-30",
			2.21
		],
		[
			"2014-05-22",
			2.21
		],
		[
			"2015-07-21",
			1.33
		],
		[
			"2009-09-18",
			2.21
		],
		[
			"2010-06-24",
			2.21
		],
		[
			"2011-04-26",
			2.21
		],
		[
			"2012-07-25",
			2.21
		]
	],
	"26540502": [
		[
			"2002-11-06",
			46.06
		],
		[
			"2004-07-06",
			160.31
		],
		[
			"2005-07-19",
			101.86
		],
		[
			"2007-06-20",
			110.71
		],
		[
			"2008-12-04",
			44.29
		],
		[
			"2015-08-06",
			19
		],
		[
			"2011-05-11",
			84.14
		]
	],
	"26540514": [
		[
			"2001-11-06",
			159.87
		],
		[
			"2002-11-06",
			147.47
		],
		[
			"2004-07-06",
			148.8
		],
		[
			"2005-07-19",
			110.71
		],
		[
			"2006-10-17",
			106.29
		],
		[
			"2007-06-20",
			115.14
		],
		[
			"2013-09-10",
			110.71
		],
		[
			"2014-07-01",
			126.66
		],
		[
			"2015-08-06",
			113.81
		],
		[
			"2009-10-05",
			101.86
		],
		[
			"2008-12-04",
			101.86
		],
		[
			"2010-09-07",
			97.43
		],
		[
			"2011-05-11",
			88.57
		],
		[
			"2012-10-17",
			84.14
		]
	],
	"26540526": [
		[
			"2001-11-06",
			56.69
		],
		[
			"2002-11-06",
			45.17
		],
		[
			"2004-07-06",
			69.09
		],
		[
			"2005-07-19",
			57.57
		],
		[
			"2006-10-17",
			44.29
		],
		[
			"2007-06-20",
			39.41
		],
		[
			"2008-12-04",
			32.77
		],
		[
			"2013-09-10",
			62
		],
		[
			"2014-07-01",
			96.99
		],
		[
			"2015-08-06",
			69.97
		],
		[
			"2009-10-05",
			44.29
		],
		[
			"2010-09-07",
			53.14
		],
		[
			"2011-05-11",
			48.71
		],
		[
			"2012-10-17",
			75.29
		]
	],
	"26541129": [
		[
			"2001-11-07",
			104.51
		],
		[
			"2002-11-12",
			112.49
		],
		[
			"2004-09-20",
			95.79
		],
		[
			"2005-07-25",
			84.14
		],
		[
			"2006-10-25",
			124
		],
		[
			"2007-07-03",
			115.14
		],
		[
			"2013-07-31",
			84.14
		],
		[
			"2015-09-29",
			167.4
		],
		[
			"2009-10-01",
			177.14
		],
		[
			"2010-09-06",
			124
		],
		[
			"2011-09-13",
			97.43
		],
		[
			"2012-09-04",
			97.43
		]
	],
	"26541130": [
		[
			"2001-11-07",
			121.34
		],
		[
			"2002-11-12",
			123.56
		],
		[
			"2004-09-20",
			124
		],
		[
			"2005-07-25",
			101.86
		],
		[
			"2006-10-25",
			115.14
		],
		[
			"2007-07-03",
			115.14
		],
		[
			"2008-12-09",
			141.71
		],
		[
			"2013-07-31",
			93
		],
		[
			"2014-08-12",
			148.36
		],
		[
			"2015-09-29",
			176.7
		],
		[
			"2009-10-01",
			230.29
		],
		[
			"2010-09-06",
			137.29
		],
		[
			"2011-09-13",
			119.57
		],
		[
			"2012-09-04",
			150.57
		]
	],
	"26541142": [
		[
			"2001-11-07",
			111.6
		],
		[
			"2002-11-12",
			116.03
		],
		[
			"2004-09-20",
			101.41
		],
		[
			"2005-07-25",
			119.57
		],
		[
			"2006-10-25",
			110.71
		],
		[
			"2007-07-03",
			124
		],
		[
			"2008-12-09",
			106.29
		],
		[
			"2013-07-31",
			97.43
		],
		[
			"2014-08-12",
			119.57
		],
		[
			"2015-09-29",
			121.34
		],
		[
			"2009-10-01",
			168.29
		],
		[
			"2010-09-06",
			19.49
		],
		[
			"2011-09-13",
			128.43
		],
		[
			"2012-09-04",
			141.71
		]
	],
	"26541154": [
		[
			"2001-11-07",
			29.63
		],
		[
			"2002-11-12",
			26.13
		],
		[
			"2004-09-20",
			38.48
		],
		[
			"2005-07-25",
			44.29
		],
		[
			"2006-10-25",
			33.66
		],
		[
			"2007-07-03",
			34.54
		],
		[
			"2008-12-09",
			32.33
		],
		[
			"2013-07-31",
			39.41
		],
		[
			"2014-08-12",
			31.75
		],
		[
			"2015-09-29",
			19.62
		],
		[
			"2009-10-01",
			39.86
		],
		[
			"2010-09-06",
			155
		],
		[
			"2011-09-13",
			19.93
		],
		[
			"2012-09-04",
			43.84
		]
	],
	"26541178": [
		[
			"2001-11-16",
			30.03
		],
		[
			"2004-09-29",
			23.12
		],
		[
			"2005-07-26",
			13.73
		],
		[
			"2006-09-18",
			18.16
		],
		[
			"2007-07-10",
			11.51
		],
		[
			"2013-07-08",
			27.46
		],
		[
			"2015-07-21",
			39.33
		],
		[
			"2009-09-22",
			48.71
		],
		[
			"2010-10-18",
			19.93
		],
		[
			"2011-05-03",
			15.06
		],
		[
			"2012-09-06",
			38.09
		]
	],
	"26541180": [
		[
			"2001-11-16",
			38.22
		],
		[
			"2004-09-29",
			36.14
		],
		[
			"2005-07-26",
			66.43
		],
		[
			"2006-09-18",
			32.77
		],
		[
			"2007-07-10",
			62
		],
		[
			"2013-07-08",
			29.67
		],
		[
			"2014-08-07",
			23.34
		],
		[
			"2015-07-21",
			21.39
		],
		[
			"2010-10-18",
			34.1
		],
		[
			"2011-05-03",
			42.07
		],
		[
			"2012-09-06",
			34.99
		]
	],
	"26541191": [
		[
			"2001-11-16",
			10.23
		],
		[
			"2004-09-29",
			3.9
		],
		[
			"2005-07-26",
			7.09
		],
		[
			"2006-09-18",
			9.3
		],
		[
			"2007-07-10",
			10.63
		],
		[
			"2013-07-08",
			11.51
		],
		[
			"2014-08-07",
			18.11
		],
		[
			"2015-07-21",
			14.7
		],
		[
			"2009-09-22",
			13.29
		],
		[
			"2010-10-18",
			11.07
		],
		[
			"2011-05-03",
			8.41
		],
		[
			"2012-09-06",
			17.71
		]
	],
	"26541208": [
		[
			"2001-11-16",
			25.02
		],
		[
			"2004-09-29",
			20.28
		],
		[
			"2005-07-26",
			32.33
		],
		[
			"2006-09-18",
			62
		],
		[
			"2007-07-10",
			31.89
		],
		[
			"2013-07-08",
			44.29
		],
		[
			"2014-08-07",
			38
		],
		[
			"2015-07-21",
			43.36
		],
		[
			"2009-09-22",
			41.63
		],
		[
			"2010-10-18",
			39.86
		],
		[
			"2011-05-03",
			38.09
		],
		[
			"2012-09-06",
			42.96
		]
	],
	"26541233": [
		[
			"2004-10-12",
			8.81
		],
		[
			"2006-10-23",
			5.31
		],
		[
			"2007-06-19",
			3.5
		],
		[
			"2013-06-27",
			2.92
		],
		[
			"2014-06-12",
			6.73
		],
		[
			"2015-08-11",
			4.69
		],
		[
			"2009-09-07",
			2.21
		],
		[
			"2010-06-15",
			3.68
		],
		[
			"2011-03-28",
			4.87
		],
		[
			"2012-06-12",
			2.21
		]
	],
	"26541245": [
		[
			"2004-10-12",
			7.4
		],
		[
			"2006-10-23",
			8.41
		],
		[
			"2007-06-19",
			3.32
		],
		[
			"2013-06-27",
			2.21
		],
		[
			"2014-06-12",
			1.9
		],
		[
			"2015-08-11",
			7.4
		],
		[
			"2009-09-07",
			11.96
		],
		[
			"2010-06-15",
			3.28
		],
		[
			"2011-03-28",
			2.21
		],
		[
			"2012-06-12",
			2.21
		]
	],
	"26541269": [
		[
			"2004-10-12",
			7.66
		],
		[
			"2006-10-23",
			10.19
		],
		[
			"2007-06-19",
			8.41
		],
		[
			"2013-06-27",
			5.76
		],
		[
			"2014-06-12",
			5.62
		],
		[
			"2015-08-11",
			4.74
		],
		[
			"2009-09-07",
			8.41
		],
		[
			"2010-06-15",
			10.19
		],
		[
			"2011-03-28",
			4.87
		],
		[
			"2012-06-12",
			5.76
		]
	],
	"26541294": [
		[
			"2004-10-12",
			6.51
		],
		[
			"2006-10-23",
			2.21
		],
		[
			"2007-06-19",
			7.97
		],
		[
			"2013-06-27",
			5.76
		],
		[
			"2014-06-12",
			8.06
		],
		[
			"2015-08-11",
			6.69
		],
		[
			"2009-09-07",
			8.86
		],
		[
			"2010-06-15",
			9.3
		],
		[
			"2011-03-28",
			7.09
		],
		[
			"2012-06-12",
			6.64
		]
	],
	"30000075": [
		[
			"2007-01-09",
			1.33
		],
		[
			"2008-04-09",
			1.33
		],
		[
			"2007-10-16",
			1.33
		],
		[
			"2014-01-16",
			1.33
		],
		[
			"2015-01-06",
			0.18
		],
		[
			"2016-01-19",
			0.13
		],
		[
			"2009-07-17",
			1.33
		],
		[
			"2010-08-02",
			1.33
		],
		[
			"2010-12-22",
			0.13
		],
		[
			"2012-01-20",
			0.13
		],
		[
			"2013-02-18",
			0.13
		]
	],
	"30100458": [
		[
			"2007-02-15",
			1.33
		],
		[
			"2007-10-31",
			1.33
		],
		[
			"2008-06-12",
			1.33
		],
		[
			"2013-04-23",
			1.33
		],
		[
			"2015-09-18",
			0.13
		],
		[
			"2010-02-03",
			1.33
		],
		[
			"2010-12-15",
			0.13
		],
		[
			"2012-01-23",
			0.13
		]
	],
	"30302055": [
		[
			"2007-02-20",
			24.4
		],
		[
			"2007-10-31",
			22.72
		],
		[
			"2008-08-01",
			21.3
		],
		[
			"2013-07-25",
			20.37
		],
		[
			"2014-09-17",
			21.48
		],
		[
			"2015-09-17",
			20.86
		],
		[
			"2010-07-27",
			21.79
		],
		[
			"2011-06-29",
			21.04
		],
		[
			"2012-12-05",
			21.26
		]
	],
	"30302079": [
		[
			"2007-02-20",
			31
		],
		[
			"2008-05-29",
			14.57
		],
		[
			"2013-07-25",
			25.24
		],
		[
			"2014-09-24",
			26.44
		],
		[
			"2015-12-16",
			26.08
		],
		[
			"2010-09-01",
			25.91
		],
		[
			"2011-12-14",
			22.36
		],
		[
			"2012-12-17",
			23.47
		]
	],
	"30302584": [
		[
			"2000-11-23",
			14.61
		],
		[
			"2001-01-08",
			17.27
		],
		[
			"2001-11-08",
			11.07
		],
		[
			"2002-01-28",
			13.29
		],
		[
			"2002-09-09",
			16.83
		],
		[
			"2003-04-28",
			12.4
		],
		[
			"2003-12-09",
			15.5
		],
		[
			"2004-02-26",
			10.5
		],
		[
			"2004-08-06",
			13.73
		],
		[
			"2005-01-10",
			13.06
		],
		[
			"2005-10-12",
			12
		],
		[
			"2006-05-22",
			11.87
		],
		[
			"2007-01-09",
			12.62
		],
		[
			"2007-10-09",
			14.04
		],
		[
			"2008-03-19",
			11.91
		],
		[
			"2013-05-14",
			12
		],
		[
			"2015-01-05",
			11.6
		],
		[
			"2016-01-19",
			9.74
		],
		[
			"2009-07-29",
			11.29
		],
		[
			"2010-08-02",
			12.89
		],
		[
			"2011-11-14",
			13.2
		],
		[
			"2012-09-17",
			12.18
		]
	],
	"30302626": [
		[
			"2000-02-08",
			1.73
		],
		[
			"2000-08-15",
			1.33
		],
		[
			"2001-01-05",
			1.33
		],
		[
			"2001-11-09",
			1.33
		],
		[
			"2002-01-25",
			1.33
		],
		[
			"2002-09-06",
			1.73
		],
		[
			"2003-06-18",
			1.33
		],
		[
			"2003-11-28",
			1.33
		],
		[
			"2004-02-27",
			2.44
		],
		[
			"2004-08-02",
			1.33
		],
		[
			"2005-01-17",
			2.04
		],
		[
			"2005-10-20",
			1.33
		],
		[
			"2006-08-16",
			1.33
		],
		[
			"2007-01-10",
			1.33
		],
		[
			"2007-09-20",
			1.33
		],
		[
			"2008-03-12",
			1.33
		],
		[
			"2013-04-30",
			1.33
		],
		[
			"2014-12-19",
			0.13
		],
		[
			"2015-09-07",
			0.13
		],
		[
			"2009-07-14",
			0.49
		],
		[
			"2010-07-26",
			1.33
		],
		[
			"2011-02-21",
			2.44
		],
		[
			"2011-12-01",
			0.13
		],
		[
			"2012-09-27",
			0.13
		]
	],
	"30302640": [
		[
			"2000-01-24",
			35.87
		],
		[
			"2000-10-12",
			31.44
		],
		[
			"2001-03-30",
			19.49
		],
		[
			"2001-11-14",
			32.77
		],
		[
			"2002-06-28",
			34.1
		],
		[
			"2003-07-04",
			29.23
		],
		[
			"2004-02-05",
			16.39
		],
		[
			"2004-10-20",
			21.57
		],
		[
			"2005-04-29",
			16.21
		],
		[
			"2007-01-15",
			11.78
		],
		[
			"2005-12-20",
			25.38
		],
		[
			"2007-11-27",
			22.81
		],
		[
			"2008-07-10",
			22.32
		],
		[
			"2013-07-10",
			24
		],
		[
			"2015-09-29",
			23.29
		],
		[
			"2003-01-27",
			28.79
		],
		[
			"2009-11-04",
			19.44
		],
		[
			"2010-09-17",
			20.11
		],
		[
			"2011-05-30",
			22.32
		],
		[
			"2012-11-27",
			23.07
		]
	],
	"30302699": [
		[
			"2003-06-25",
			1.33
		],
		[
			"2003-11-28",
			1.33
		],
		[
			"2004-03-01",
			1.33
		],
		[
			"2004-08-04",
			1.33
		],
		[
			"2005-01-17",
			1.37
		],
		[
			"2005-10-11",
			1.33
		],
		[
			"2006-08-16",
			1.33
		],
		[
			"2007-05-10",
			1.33
		],
		[
			"2007-10-01",
			1.33
		],
		[
			"2008-03-14",
			1.33
		],
		[
			"2013-04-30",
			1.33
		],
		[
			"2015-09-07",
			0.13
		],
		[
			"2010-11-05",
			1.33
		],
		[
			"2011-11-15",
			0.13
		],
		[
			"2012-09-27",
			0.13
		]
	],
	"30302742": [
		[
			"2003-07-04",
			1.99
		],
		[
			"2004-02-13",
			6.2
		],
		[
			"2004-09-15",
			5.27
		],
		[
			"2005-07-26",
			1.33
		],
		[
			"2006-10-06",
			1.33
		],
		[
			"2007-01-08",
			4.03
		],
		[
			"2008-01-14",
			3.19
		],
		[
			"2013-05-21",
			2.66
		],
		[
			"2014-01-27",
			1.59
		],
		[
			"2015-09-16",
			1.33
		],
		[
			"2005-11-30",
			7
		],
		[
			"2009-11-06",
			1.37
		],
		[
			"2010-09-17",
			0.93
		],
		[
			"2011-05-17",
			5.71
		],
		[
			"2012-09-25",
			0.4
		]
	],
	"30302778": [
		[
			"2007-01-04",
			1.33
		],
		[
			"2008-06-12",
			2.04
		],
		[
			"2013-04-23",
			1.33
		],
		[
			"2014-12-19",
			1.33
		],
		[
			"2015-03-13",
			1.33
		],
		[
			"2007-10-12",
			1.33
		],
		[
			"2010-02-02",
			0.13
		],
		[
			"2010-12-15",
			0.18
		],
		[
			"2012-01-23",
			0.27
		]
	],
	"30302810": [
		[
			"2003-06-27",
			113.37
		],
		[
			"2004-02-13",
			105.4
		],
		[
			"2004-09-17",
			95.66
		],
		[
			"2005-04-21",
			70.41
		],
		[
			"2006-09-07",
			93.89
		],
		[
			"2007-01-16",
			98.31
		],
		[
			"2007-10-12",
			113.37
		],
		[
			"2008-06-12",
			104.07
		],
		[
			"2013-07-05",
			159.43
		],
		[
			"2015-03-13",
			121.34
		],
		[
			"2005-12-02",
			93.89
		],
		[
			"2010-07-14",
			135.96
		],
		[
			"2011-02-21",
			143.49
		],
		[
			"2011-09-07",
			178.91
		],
		[
			"2012-12-14",
			158.1
		]
	],
	"30302821": [
		[
			"2003-06-25",
			30.56
		],
		[
			"2003-12-08",
			1.33
		],
		[
			"2004-03-02",
			7.88
		],
		[
			"2004-08-04",
			1.33
		],
		[
			"2005-01-17",
			1.33
		],
		[
			"2005-10-20",
			1.33
		],
		[
			"2006-08-16",
			1.33
		],
		[
			"2007-01-10",
			1.33
		],
		[
			"2007-10-08",
			1.33
		],
		[
			"2008-03-14",
			3.28
		],
		[
			"2013-04-30",
			7.26
		],
		[
			"2015-01-09",
			17.76
		],
		[
			"2009-07-14",
			0.62
		],
		[
			"2010-07-26",
			1.33
		],
		[
			"2011-02-21",
			15.81
		],
		[
			"2011-12-01",
			0.13
		],
		[
			"2012-09-27",
			0.84
		]
	],
	"30302857": [
		[
			"2003-06-27",
			10.19
		],
		[
			"2003-12-08",
			11.51
		],
		[
			"2004-02-27",
			10.19
		],
		[
			"2004-08-04",
			9.3
		],
		[
			"2005-01-18",
			11.29
		],
		[
			"2005-10-11",
			11.78
		],
		[
			"2006-08-14",
			10.27
		],
		[
			"2007-01-10",
			11.38
		],
		[
			"2007-10-08",
			11.16
		],
		[
			"2008-03-12",
			11.25
		],
		[
			"2014-01-16",
			4.92
		],
		[
			"2015-01-09",
			3.72
		],
		[
			"2016-01-19",
			4.43
		],
		[
			"2009-07-17",
			16.34
		],
		[
			"2010-07-26",
			14.39
		],
		[
			"2011-01-03",
			12.44
		],
		[
			"2012-01-20",
			5.18
		],
		[
			"2013-02-18",
			5
		]
	],
	"31040020": [
		[
			"2007-06-14",
			17.01
		],
		[
			"2013-05-27",
			14.66
		],
		[
			"2015-09-07",
			13.64
		],
		[
			"2010-09-02",
			20.86
		],
		[
			"2011-12-08",
			16.43
		],
		[
			"2012-12-19",
			22.14
		]
	],
	"31040032": [
		[
			"2007-06-19",
			45.61
		],
		[
			"2008-05-27",
			52.26
		],
		[
			"2013-07-11",
			40.3
		],
		[
			"2014-09-30",
			46.5
		],
		[
			"2015-09-14",
			32.82
		],
		[
			"2010-08-05",
			39.95
		],
		[
			"2012-10-31",
			40.34
		]
	],
	"31040093": [
		[
			"2007-06-19",
			49.16
		],
		[
			"2008-05-27",
			48.71
		],
		[
			"2013-07-11",
			48.71
		],
		[
			"2014-12-09",
			51.81
		],
		[
			"2015-09-15",
			50.04
		],
		[
			"2010-08-05",
			50.04
		],
		[
			"2011-06-21",
			50.93
		],
		[
			"2012-10-31",
			49.6
		]
	],
	"31040100": [
		[
			"2007-11-28",
			7.35
		],
		[
			"2007-06-19",
			9.57
		],
		[
			"2008-08-20",
			8.37
		],
		[
			"2013-05-27",
			10.54
		],
		[
			"2014-12-09",
			11.2
		],
		[
			"2015-09-15",
			13.02
		],
		[
			"2010-02-04",
			3.63
		],
		[
			"2011-02-23",
			9.83
		],
		[
			"2011-12-08",
			10.19
		],
		[
			"2012-12-19",
			2.48
		]
	],
	"32032006": [
		[
			"2007-01-16",
			19.84
		],
		[
			"2007-10-29",
			22.01
		],
		[
			"2008-08-21",
			17.09
		],
		[
			"2014-09-18",
			16.3
		],
		[
			"2015-12-11",
			13.51
		],
		[
			"2010-01-11",
			17.14
		],
		[
			"2011-01-18",
			20.37
		],
		[
			"2012-07-02",
			17.09
		]
	],
	"32032018": [
		[
			"2007-01-12",
			12.62
		],
		[
			"2007-10-16",
			10.41
		],
		[
			"2008-06-09",
			9.96
		],
		[
			"2014-09-23",
			6.95
		],
		[
			"2015-09-18",
			3.85
		],
		[
			"2009-12-04",
			10.89
		],
		[
			"2010-08-30",
			8.15
		],
		[
			"2011-06-16",
			7.93
		],
		[
			"2012-12-03",
			0.93
		]
	],
	"32032080": [
		[
			"2007-01-04",
			1.33
		],
		[
			"2007-10-24",
			1.33
		],
		[
			"2008-06-09",
			1.33
		],
		[
			"2013-04-23",
			1.33
		],
		[
			"2015-08-28",
			0.13
		],
		[
			"2009-12-04",
			1.33
		],
		[
			"2010-12-13",
			0.13
		],
		[
			"2010-08-30",
			0.13
		],
		[
			"2012-01-11",
			1.33
		]
	],
	"32032110": [
		[
			"2007-01-12",
			23.21
		],
		[
			"2007-10-26",
			15.99
		],
		[
			"2008-06-09",
			22.94
		],
		[
			"2013-07-01",
			30.56
		],
		[
			"2014-06-03",
			28.39
		],
		[
			"2015-08-28",
			24.27
		],
		[
			"2009-07-16",
			23.87
		],
		[
			"2010-08-31",
			23.91
		],
		[
			"2011-09-26",
			23.83
		],
		[
			"2012-09-24",
			27.59
		]
	],
	"32032171": [
		[
			"2007-01-12",
			104.07
		],
		[
			"2007-10-24",
			104.07
		],
		[
			"2008-06-09",
			91.23
		],
		[
			"2013-05-08",
			71.3
		],
		[
			"2014-01-10",
			72.19
		],
		[
			"2015-08-28",
			69.09
		],
		[
			"2009-12-04",
			74.84
		],
		[
			"2010-08-30",
			72.63
		],
		[
			"2011-06-16",
			76.61
		],
		[
			"2012-09-17",
			72.63
		]
	],
	"32032201": [
		[
			"2007-01-12",
			12.44
		],
		[
			"2007-10-24",
			11.91
		],
		[
			"2008-07-23",
			9.34
		],
		[
			"2013-11-19",
			11.6
		],
		[
			"2014-08-20",
			9.08
		],
		[
			"2015-09-29",
			7.4
		],
		[
			"2010-09-02",
			9.12
		],
		[
			"2011-12-19",
			3.1
		],
		[
			"2012-12-04",
			10.1
		]
	],
	"32032225": [
		[
			"2007-01-15",
			3.28
		],
		[
			"2007-10-29",
			4.83
		],
		[
			"2008-06-11",
			3.28
		],
		[
			"2014-01-06",
			3.06
		],
		[
			"2015-08-28",
			4.96
		],
		[
			"2010-01-11",
			2.61
		],
		[
			"2010-12-13",
			2.83
		],
		[
			"2012-01-11",
			2.75
		],
		[
			"2013-02-13",
			3.45
		]
	],
	"32032250": [
		[
			"2007-01-24",
			19.71
		],
		[
			"2007-10-29",
			20.5
		],
		[
			"2008-08-21",
			21.97
		],
		[
			"2013-07-05",
			19.93
		],
		[
			"2014-08-28",
			19.75
		],
		[
			"2015-09-14",
			18.38
		],
		[
			"2010-01-27",
			21.26
		],
		[
			"2011-01-18",
			19.26
		],
		[
			"2012-07-02",
			19.26
		]
	],
	"32502643": [
		[
			"2000-02-07",
			76.61
		],
		[
			"2000-08-16",
			72.63
		],
		[
			"2001-01-04",
			72.63
		],
		[
			"2001-07-16",
			62.44
		],
		[
			"2002-01-22",
			62.89
		],
		[
			"2002-09-05",
			66.43
		],
		[
			"2003-04-15",
			98.31
		],
		[
			"2004-01-13",
			59.34
		],
		[
			"2004-09-07",
			68.2
		],
		[
			"2004-12-16",
			61.11
		],
		[
			"2005-10-17",
			67.76
		],
		[
			"2006-09-07",
			90.34
		],
		[
			"2007-01-09",
			88.57
		],
		[
			"2008-05-21",
			91.67
		],
		[
			"2013-06-17",
			89.9
		],
		[
			"2013-09-19",
			101.86
		],
		[
			"2015-08-20",
			138.17
		],
		[
			"2016-01-06",
			146.14
		],
		[
			"2007-10-16",
			120.46
		],
		[
			"2009-07-29",
			86.8
		],
		[
			"2010-11-05",
			94.77
		],
		[
			"2011-05-24",
			101.41
		],
		[
			"2012-07-02",
			111.16
		]
	],
	"34608448": [
		[
			"2008-05-27",
			17.94
		],
		[
			"2008-07-31",
			19.53
		],
		[
			"2010-06-01",
			20.41
		],
		[
			"2010-10-28",
			20.11
		],
		[
			"2011-03-15",
			20.91
		],
		[
			"2011-08-23",
			30.61
		],
		[
			"2011-11-07",
			24.31
		],
		[
			"2012-03-13",
			26.01
		],
		[
			"2012-06-12",
			24.71
		],
		[
			"2012-09-25",
			25.31
		],
		[
			"2012-11-14",
			28.61
		],
		[
			"2013-04-09",
			26.41
		],
		[
			"2013-06-18",
			26.11
		],
		[
			"2013-09-24",
			28.91
		],
		[
			"2013-12-11",
			37.71
		],
		[
			"2013-07-11",
			25.11
		],
		[
			"2014-09-01",
			43.53
		],
		[
			"2015-09-15",
			29.85
		],
		[
			"2009-12-17",
			23.96
		],
		[
			"2010-08-27",
			20.46
		],
		[
			"2011-06-21",
			29.61
		],
		[
			"2012-10-31",
			22.14
		]
	],
	"34709010": [
		[
			"2007-02-15",
			27.46
		],
		[
			"2008-05-29",
			24.49
		],
		[
			"2010-06-30",
			27.11
		],
		[
			"2010-09-28",
			26.21
		],
		[
			"2010-12-07",
			22.01
		],
		[
			"2011-04-01",
			24.01
		],
		[
			"2011-08-05",
			24.01
		],
		[
			"2011-10-04",
			24.01
		],
		[
			"2011-12-19",
			21.01
		],
		[
			"2012-03-16",
			77.03
		],
		[
			"2012-06-27",
			24.01
		],
		[
			"2012-09-26",
			25.01
		],
		[
			"2012-12-17",
			21.01
		],
		[
			"2013-05-27",
			24.14
		],
		[
			"2014-09-24",
			21.3
		],
		[
			"2015-09-17",
			22.5
		],
		[
			"2010-07-13",
			31.18
		],
		[
			"2011-02-23",
			19.97
		],
		[
			"2012-12-10",
			26.93
		]
	],
	"36411450": [
		[
			"2000-02-08",
			49.16
		],
		[
			"2000-08-16",
			55.8
		],
		[
			"2001-01-08",
			51.81
		],
		[
			"2001-10-31",
			65.54
		],
		[
			"2002-01-28",
			56.69
		],
		[
			"2002-09-10",
			60.67
		],
		[
			"2003-04-29",
			42.51
		],
		[
			"2003-12-09",
			32.33
		],
		[
			"2004-02-27",
			20.19
		],
		[
			"2004-08-06",
			19.49
		],
		[
			"2005-01-14",
			20.28
		],
		[
			"2005-10-12",
			42.82
		],
		[
			"2006-05-22",
			36.23
		],
		[
			"2007-01-05",
			37.78
		],
		[
			"2007-10-09",
			43.67
		],
		[
			"2008-03-19",
			41.85
		],
		[
			"2013-05-14",
			25.2
		],
		[
			"2014-09-26",
			15.68
		],
		[
			"2015-10-01",
			36.8
		],
		[
			"2009-07-15",
			49.16
		],
		[
			"2010-08-02",
			30.2
		],
		[
			"2011-06-15",
			45.61
		],
		[
			"2012-09-21",
			27.55
		]
	],
	"36411589": [
		[
			"2007-01-05",
			10.94
		],
		[
			"2007-10-26",
			10.81
		],
		[
			"2008-08-01",
			10.01
		],
		[
			"2013-04-12",
			7.97
		],
		[
			"2014-02-05",
			9.12
		],
		[
			"2015-01-06",
			7.44
		],
		[
			"2009-07-15",
			7.97
		],
		[
			"2010-08-31",
			7.09
		],
		[
			"2011-03-22",
			7.71
		],
		[
			"2012-07-06",
			8.28
		]
	],
	"36411607": [
		[
			"2007-01-05",
			13.55
		],
		[
			"2007-10-26",
			15.63
		],
		[
			"2008-08-01",
			15.9
		],
		[
			"2013-04-12",
			17.18
		],
		[
			"2014-02-05",
			14.48
		],
		[
			"2015-06-30",
			11.69
		],
		[
			"2009-07-15",
			15.32
		],
		[
			"2010-08-31",
			15.41
		],
		[
			"2011-03-22",
			15.99
		],
		[
			"2012-07-06",
			16.25
		]
	],
	"36462068": [
		[
			"2007-01-09",
			1.33
		],
		[
			"2008-04-09",
			1.33
		],
		[
			"2007-10-26",
			1.77
		],
		[
			"2013-05-14",
			1.33
		],
		[
			"2015-06-30",
			1.11
		],
		[
			"2009-07-29",
			1.33
		],
		[
			"2010-07-28",
			1.33
		],
		[
			"2011-06-15",
			1.33
		],
		[
			"2012-09-17",
			0.66
		]
	],
	"36462408": [
		[
			"2007-11-28",
			17.05
		],
		[
			"2007-06-05",
			16.83
		],
		[
			"2008-08-20",
			16.39
		],
		[
			"2013-11-22",
			14.92
		],
		[
			"2014-09-26",
			15.72
		],
		[
			"2015-09-18",
			13.29
		],
		[
			"2010-02-04",
			16.3
		],
		[
			"2011-12-08",
			14.92
		],
		[
			"2012-12-14",
			15.19
		]
	],
	"36462615": [
		[
			"2000-06-06",
			1.2
		],
		[
			"2000-02-07",
			1.1
		],
		[
			"2009-09-16",
			1
		],
		[
			"2009-03-24",
			1
		],
		[
			"2008-09-16",
			1
		],
		[
			"2008-03-11",
			1
		],
		[
			"2007-09-11",
			1
		],
		[
			"2007-03-20",
			1
		],
		[
			"2006-09-26",
			1
		],
		[
			"2006-03-29",
			1
		],
		[
			"2005-09-20",
			1
		],
		[
			"2005-03-15",
			1
		],
		[
			"2004-09-27",
			1
		],
		[
			"2004-03-29",
			2
		],
		[
			"2003-09-18",
			1.3
		],
		[
			"2003-03-10",
			1.2
		],
		[
			"2002-11-13",
			1.1
		],
		[
			"2002-08-14",
			1.2
		],
		[
			"2002-05-22",
			1
		],
		[
			"2002-03-12",
			1
		],
		[
			"2001-10-31",
			1.2
		],
		[
			"2001-08-15",
			1
		],
		[
			"2001-05-16",
			2.6
		],
		[
			"2001-01-30",
			1
		],
		[
			"2000-11-08",
			1
		],
		[
			"2000-08-15",
			1
		],
		[
			"2011-09-27",
			1
		],
		[
			"2011-03-14",
			1
		],
		[
			"2010-09-08",
			1
		],
		[
			"2010-03-23",
			1
		],
		[
			"2014-03-25",
			1
		],
		[
			"2014-09-30",
			1
		],
		[
			"2013-09-17",
			1
		],
		[
			"2013-03-18",
			1
		],
		[
			"2012-09-18",
			1
		],
		[
			"2012-03-26",
			1
		],
		[
			"2015-09-09",
			1
		],
		[
			"2015-03-10",
			1
		]
	],
	"36462767": [
		[
			"2007-01-18",
			1.33
		],
		[
			"2008-01-14",
			1.33
		],
		[
			"2013-05-21",
			1.33
		],
		[
			"2015-09-16",
			0.13
		],
		[
			"2009-11-06",
			1.33
		],
		[
			"2010-08-27",
			0.13
		],
		[
			"2011-05-17",
			0.13
		],
		[
			"2012-09-25",
			0.44
		]
	],
	"36462780": [
		[
			"2007-01-18",
			1.33
		],
		[
			"2008-01-14",
			11.25
		],
		[
			"2014-11-18",
			2.26
		],
		[
			"2015-10-15",
			0.8
		],
		[
			"2010-07-14",
			10.67
		],
		[
			"2011-11-16",
			4.92
		],
		[
			"2012-12-11",
			1.46
		]
	],
	"36485779": [
		[
			"2000-01-27",
			1.33
		],
		[
			"2000-11-20",
			1.33
		],
		[
			"2001-03-21",
			1.33
		],
		[
			"2001-11-15",
			1.33
		],
		[
			"2002-07-16",
			1.33
		],
		[
			"2003-07-02",
			1.77
		],
		[
			"2004-03-02",
			1.33
		],
		[
			"2004-09-15",
			1.33
		],
		[
			"2005-04-28",
			1.33
		],
		[
			"2007-01-08",
			1.33
		],
		[
			"2007-11-27",
			1.33
		],
		[
			"2008-07-14",
			1.33
		],
		[
			"2013-09-23",
			1.33
		],
		[
			"2014-12-18",
			0.13
		],
		[
			"2015-04-17",
			0.13
		],
		[
			"2016-01-21",
			0.13
		],
		[
			"2003-02-07",
			1.33
		],
		[
			"2005-11-30",
			1.55
		],
		[
			"2009-11-04",
			1.33
		],
		[
			"2010-09-17",
			0.13
		],
		[
			"2011-05-30",
			0.13
		],
		[
			"2012-02-15",
			0.13
		],
		[
			"2013-02-13",
			0.13
		]
	],
	"36487491": [
		[
			"2003-07-02",
			13.73
		],
		[
			"2004-05-25",
			14.17
		],
		[
			"2004-09-15",
			14.7
		],
		[
			"2005-04-28",
			13.55
		],
		[
			"2007-01-08",
			9.65
		],
		[
			"2007-11-27",
			10.81
		],
		[
			"2008-07-14",
			10.27
		],
		[
			"2014-07-16",
			8.64
		],
		[
			"2015-03-02",
			9.61
		],
		[
			"2016-01-21",
			9.3
		],
		[
			"2005-09-23",
			12.71
		],
		[
			"2009-11-10",
			10.72
		],
		[
			"2010-11-23",
			9.74
		],
		[
			"2011-05-30",
			12.05
		],
		[
			"2012-05-30",
			10.67
		],
		[
			"2013-02-13",
			10.41
		]
	],
	"40061334": [
		[
			"2000-05-05",
			4.43
		],
		[
			"2000-09-14",
			4.43
		],
		[
			"2001-07-09",
			4.43
		],
		[
			"2001-10-09",
			4.43
		],
		[
			"2002-04-08",
			6.64
		],
		[
			"2002-07-09",
			8.41
		],
		[
			"2003-05-14",
			4.43
		],
		[
			"2003-07-14",
			4.43
		],
		[
			"2004-09-29",
			4.43
		],
		[
			"2005-05-31",
			7.53
		],
		[
			"2006-05-23",
			4.43
		],
		[
			"2007-05-07",
			4.43
		],
		[
			"2008-04-02",
			6.64
		],
		[
			"2008-06-26",
			6.64
		],
		[
			"2013-11-07",
			1.33
		],
		[
			"2014-07-31",
			1.33
		],
		[
			"2015-12-03",
			1.33
		],
		[
			"2009-09-15",
			4.43
		],
		[
			"2010-05-05",
			4.43
		],
		[
			"2011-04-12",
			4.43
		]
	],
	"40061383": [
		[
			"2000-06-08",
			52.7
		],
		[
			"2000-09-28",
			42.07
		],
		[
			"2001-06-05",
			44.29
		],
		[
			"2001-11-15",
			36.31
		],
		[
			"2002-04-03",
			47.39
		],
		[
			"2003-09-04",
			44.29
		],
		[
			"2004-05-19",
			36.76
		],
		[
			"2005-07-20",
			39.86
		],
		[
			"2006-08-02",
			38.53
		],
		[
			"2007-04-24",
			39.86
		],
		[
			"2008-03-03",
			41.19
		],
		[
			"2013-12-05",
			14.3
		],
		[
			"2014-07-30",
			26.75
		],
		[
			"2015-12-02",
			25.91
		],
		[
			"2009-10-06",
			40.3
		],
		[
			"2010-06-14",
			32.77
		],
		[
			"2011-04-12",
			29.67
		]
	],
	"40070130": [
		[
			"2000-05-04",
			50.93
		],
		[
			"2000-08-09",
			48.71
		],
		[
			"2001-05-30",
			45.17
		],
		[
			"2001-10-09",
			46.94
		],
		[
			"2002-04-08",
			44.73
		],
		[
			"2002-07-09",
			47.39
		],
		[
			"2004-09-27",
			50.93
		],
		[
			"2005-05-31",
			51.81
		],
		[
			"2006-06-27",
			46.94
		],
		[
			"2007-05-02",
			41.63
		],
		[
			"2008-03-04",
			38.97
		],
		[
			"2013-12-11",
			32.86
		],
		[
			"2014-07-29",
			39.33
		],
		[
			"2015-12-02",
			33.97
		],
		[
			"2003-07-15",
			45.17
		],
		[
			"2009-11-10",
			38.97
		],
		[
			"2010-07-20",
			40.3
		],
		[
			"2011-04-18",
			34.99
		]
	],
	"40071005": [
		[
			"2006-08-01",
			84.59
		],
		[
			"2007-06-19",
			94.33
		],
		[
			"2008-09-22",
			74.4
		],
		[
			"2013-12-04",
			64.66
		],
		[
			"2014-08-06",
			58.01
		],
		[
			"2015-11-23",
			75.29
		],
		[
			"2009-07-16",
			77.06
		],
		[
			"2010-07-20",
			68.2
		],
		[
			"2011-04-18",
			71.74
		]
	],
	"40100066": [
		[
			"2007-10-22",
			51.37
		],
		[
			"2008-06-19",
			45.17
		],
		[
			"2013-11-29",
			36.54
		],
		[
			"2014-08-22",
			37.07
		],
		[
			"2015-04-30",
			35.61
		],
		[
			"2009-10-13",
			43.4
		],
		[
			"2011-04-19",
			42.51
		]
	],
	"40100091": [
		[
			"2000-04-20",
			43.4
		],
		[
			"2000-10-05",
			44.29
		],
		[
			"2001-07-02",
			39.86
		],
		[
			"2002-07-19",
			38.09
		],
		[
			"2002-04-09",
			34.99
		],
		[
			"2003-04-01",
			35.87
		],
		[
			"2003-09-04",
			34.99
		],
		[
			"2004-06-14",
			31
		],
		[
			"2004-09-23",
			31
		],
		[
			"2005-04-20",
			34.1
		],
		[
			"2006-05-09",
			31.89
		],
		[
			"2007-03-26",
			30.56
		],
		[
			"2008-03-17",
			33.66
		],
		[
			"2013-10-29",
			26.7
		],
		[
			"2014-07-16",
			24.31
		],
		[
			"2015-04-29",
			24.93
		],
		[
			"2009-08-05",
			29.67
		],
		[
			"2010-05-05",
			27.9
		],
		[
			"2011-04-05",
			31.44
		]
	],
	"40200061": [
		[
			"2006-08-01",
			20.81
		],
		[
			"2007-06-28",
			42.51
		],
		[
			"2008-06-19",
			37.2
		],
		[
			"2013-11-19",
			32.06
		],
		[
			"2014-08-21",
			30.69
		],
		[
			"2015-10-20",
			20.33
		],
		[
			"2009-11-10",
			29.67
		],
		[
			"2011-04-20",
			30.56
		]
	],
	"40200504": [
		[
			"2006-11-30",
			70.02
		],
		[
			"2007-06-05",
			72.03
		],
		[
			"2008-05-05",
			122.04
		],
		[
			"2009-04-21",
			91.03
		],
		[
			"2010-03-02",
			107.04
		],
		[
			"2000-06-05",
			124.89
		],
		[
			"2000-09-28",
			178.91
		],
		[
			"2001-07-05",
			100.09
		],
		[
			"2002-07-19",
			91.23
		],
		[
			"2003-09-02",
			99.64
		],
		[
			"2004-07-22",
			61.56
		],
		[
			"2004-09-23",
			62
		],
		[
			"2005-09-13",
			97.87
		],
		[
			"2007-05-21",
			81.93
		],
		[
			"2008-06-25",
			101.86
		],
		[
			"2011-01-25",
			118.04
		],
		[
			"2012-01-03",
			92.03
		],
		[
			"2013-01-23",
			84.03
		],
		[
			"2014-01-14",
			49.02
		],
		[
			"2015-06-01",
			68.02
		],
		[
			"2014-10-09",
			22.81
		],
		[
			"2009-11-16",
			103.63
		],
		[
			"2010-06-14",
			94.33
		]
	],
	"40200905": [
		[
			"2000-04-07",
			27.46
		],
		[
			"2000-09-22",
			27.01
		],
		[
			"2001-04-20",
			22.14
		],
		[
			"2002-04-25",
			26.13
		],
		[
			"2003-05-20",
			36.31
		],
		[
			"2004-06-29",
			24.8
		],
		[
			"2004-07-15",
			26.13
		],
		[
			"2005-05-13",
			23.47
		],
		[
			"2006-06-13",
			20.81
		],
		[
			"2007-06-11",
			17.71
		],
		[
			"2008-04-17",
			20.37
		],
		[
			"2013-11-04",
			24.09
		],
		[
			"2014-08-19",
			20.68
		],
		[
			"2015-10-21",
			19.09
		],
		[
			"2009-07-29",
			30.56
		],
		[
			"2010-07-21",
			27.46
		],
		[
			"2011-05-02",
			23.03
		]
	],
	"40200929": [
		[
			"2000-04-07",
			23.47
		],
		[
			"2000-10-13",
			17.27
		],
		[
			"2001-04-20",
			16.83
		],
		[
			"2001-10-10",
			27.01
		],
		[
			"2002-06-03",
			17.27
		],
		[
			"2003-05-27",
			18.6
		],
		[
			"2004-07-12",
			10.63
		],
		[
			"2004-07-28",
			11.51
		],
		[
			"2005-08-02",
			13.29
		],
		[
			"2006-06-13",
			18.6
		],
		[
			"2007-06-28",
			11.07
		],
		[
			"2008-06-19",
			7.97
		],
		[
			"2014-08-20",
			9.12
		],
		[
			"2015-10-22",
			12.13
		],
		[
			"2009-10-13",
			13.29
		],
		[
			"2010-07-21",
			9.74
		],
		[
			"2011-05-02",
			11.96
		]
	],
	"40406015": [
		[
			"2004-09-22",
			46.5
		],
		[
			"2005-05-04",
			47.39
		],
		[
			"2006-05-10",
			42.96
		],
		[
			"2006-06-23",
			45.61
		],
		[
			"2007-04-10",
			47.83
		],
		[
			"2008-04-23",
			41.63
		],
		[
			"2013-08-19",
			38.97
		],
		[
			"2014-07-02",
			32.64
		],
		[
			"2015-06-23",
			32.73
		],
		[
			"2009-09-14",
			34.1
		],
		[
			"2010-07-06",
			32.33
		],
		[
			"2011-04-05",
			36.76
		]
	],
	"40507014": [
		[
			"2005-07-20",
			9.3
		],
		[
			"2005-09-08",
			9.3
		],
		[
			"2006-10-16",
			4.43
		],
		[
			"2006-09-13",
			5.76
		],
		[
			"2007-07-02",
			7.53
		],
		[
			"2007-06-06",
			9.74
		],
		[
			"2008-04-23",
			47.39
		],
		[
			"2013-10-16",
			1.33
		],
		[
			"2014-09-09",
			13.91
		],
		[
			"2015-11-13",
			9.21
		],
		[
			"2009-10-06",
			4.43
		],
		[
			"2010-07-22",
			4.43
		],
		[
			"2011-05-09",
			21.7
		]
	],
	"40606107": [
		[
			"2000-05-05",
			58.46
		],
		[
			"2000-08-10",
			62
		],
		[
			"2001-07-24",
			65.54
		],
		[
			"2002-04-03",
			48.71
		],
		[
			"2002-07-09",
			56.24
		],
		[
			"2003-05-14",
			53.59
		],
		[
			"2003-07-14",
			50.04
		],
		[
			"2004-07-22",
			52.26
		],
		[
			"2004-09-29",
			51.81
		],
		[
			"2005-05-31",
			69.09
		],
		[
			"2006-05-10",
			52.7
		],
		[
			"2007-03-22",
			51.81
		],
		[
			"2008-03-10",
			57.13
		],
		[
			"2013-12-06",
			45.61
		],
		[
			"2014-10-09",
			49.16
		],
		[
			"2015-12-01",
			39.15
		],
		[
			"2009-07-06",
			60.67
		],
		[
			"2010-08-05",
			51.81
		],
		[
			"2011-06-10",
			49.16
		]
	],
	"40607010": [
		[
			"2004-12-21",
			4.43
		],
		[
			"2005-05-04",
			4.43
		],
		[
			"2005-09-08",
			4.43
		],
		[
			"2006-09-06",
			4.43
		],
		[
			"2007-03-26",
			4.43
		],
		[
			"2008-03-31",
			4.43
		],
		[
			"2013-10-16",
			1.33
		],
		[
			"2014-09-09",
			1.33
		],
		[
			"2015-11-12",
			1.33
		],
		[
			"2009-07-06",
			4.43
		],
		[
			"2010-07-22",
			4.43
		],
		[
			"2011-05-09",
			4.43
		]
	],
	"42001006": [
		[
			"2006-12-05",
			6.9
		],
		[
			"2007-06-04",
			5.71
		],
		[
			"2008-05-07",
			1.6
		],
		[
			"2009-03-16",
			10.6
		],
		[
			"2010-03-04",
			8.5
		],
		[
			"2011-01-31",
			6.1
		],
		[
			"2012-06-29",
			17.51
		],
		[
			"2013-01-24",
			2.4
		],
		[
			"2014-01-20",
			2.5
		],
		[
			"2015-12-02",
			6.7
		],
		[
			"2010-06-23",
			13.2
		],
		[
			"2011-07-12",
			14.81
		],
		[
			"2012-11-27",
			19.51
		],
		[
			"2013-06-20",
			10.7
		],
		[
			"2013-11-26",
			8.2
		],
		[
			"2014-06-23",
			2.92
		],
		[
			"2014-11-20",
			6.5
		],
		[
			"2006-05-19",
			13.7
		],
		[
			"2007-11-28",
			7.7
		],
		[
			"2008-11-26",
			2.7
		],
		[
			"2000-07-10",
			20.01
		],
		[
			"2001-06-29",
			4.5
		],
		[
			"2003-08-12",
			10.3
		]
	],
	"42011097": [
		[
			"2006-11-28",
			82.03
		],
		[
			"2007-06-04",
			91.03
		],
		[
			"2008-05-07",
			68.02
		],
		[
			"2009-02-27",
			95.03
		],
		[
			"2010-03-04",
			98.03
		],
		[
			"2011-01-31",
			102.04
		],
		[
			"2012-06-13",
			62.02
		],
		[
			"2013-01-28",
			58.02
		],
		[
			"2014-01-13",
			59.02
		],
		[
			"2015-12-10",
			45.02
		],
		[
			"2006-05-18",
			88.03
		],
		[
			"2000-07-17",
			110.04
		],
		[
			"2003-08-11",
			95.03
		]
	],
	"42011358": [
		[
			"2006-11-27",
			19.61
		],
		[
			"2007-06-19",
			17.51
		],
		[
			"2008-05-08",
			17.01
		],
		[
			"2009-04-21",
			18.51
		],
		[
			"2010-04-01",
			15.41
		],
		[
			"2011-01-31",
			16.31
		],
		[
			"2012-01-05",
			16.21
		],
		[
			"2013-04-08",
			14.21
		],
		[
			"2014-01-16",
			15.51
		],
		[
			"2015-01-16",
			15.41
		],
		[
			"2001-07-24",
			20.31
		],
		[
			"2004-06-14",
			20.11
		]
	],
	"42013550": [
		[
			"2006-11-29",
			57.02
		],
		[
			"2007-06-13",
			51.02
		],
		[
			"2008-05-05",
			48.02
		],
		[
			"2009-04-22",
			55.02
		],
		[
			"2010-04-21",
			44.02
		],
		[
			"2011-01-25",
			47.02
		],
		[
			"2012-01-31",
			39.01
		],
		[
			"2013-04-02",
			47.02
		],
		[
			"2014-01-14",
			40.01
		],
		[
			"2015-01-15",
			37.01
		],
		[
			"2015-06-25",
			35.01
		],
		[
			"2010-03-08",
			47.02
		],
		[
			"2010-09-03",
			43.02
		],
		[
			"2011-08-03",
			47.02
		],
		[
			"2012-01-02",
			40.01
		],
		[
			"2012-07-24",
			49.02
		],
		[
			"2013-01-29",
			47.02
		],
		[
			"2013-07-04",
			41.01
		],
		[
			"2014-07-17",
			40.01
		],
		[
			"2005-02-22",
			65.02
		],
		[
			"2005-09-07",
			62.02
		],
		[
			"2006-03-22",
			53.02
		],
		[
			"2006-09-06",
			62.02
		],
		[
			"2007-03-22",
			50.02
		],
		[
			"2007-09-04",
			51.02
		],
		[
			"2008-02-28",
			52.02
		],
		[
			"2008-09-01",
			51.02
		],
		[
			"2009-02-16",
			50.02
		],
		[
			"2009-08-19",
			47.02
		],
		[
			"2000-02-07",
			78.03
		],
		[
			"2000-05-09",
			71.03
		],
		[
			"2000-08-07",
			73.03
		],
		[
			"2000-11-13",
			69.02
		],
		[
			"2001-02-12",
			71.03
		],
		[
			"2001-05-17",
			70.02
		],
		[
			"2001-07-26",
			70.02
		],
		[
			"2001-11-12",
			71.03
		],
		[
			"2002-02-26",
			72.03
		],
		[
			"2002-05-21",
			70.02
		],
		[
			"2002-08-22",
			69.02
		],
		[
			"2002-11-12",
			62.02
		],
		[
			"2003-03-12",
			68.02
		],
		[
			"2003-06-04",
			66.02
		],
		[
			"2003-09-04",
			74.03
		],
		[
			"2003-11-25",
			68.02
		],
		[
			"2004-03-16",
			67.02
		],
		[
			"2004-06-08",
			69.02
		],
		[
			"2004-06-21",
			72.03
		],
		[
			"2004-09-06",
			76.03
		]
	],
	"42013800": [
		[
			"2006-11-28",
			20.51
		],
		[
			"2007-06-21",
			20.61
		],
		[
			"2008-05-08",
			23.61
		],
		[
			"2009-04-20",
			24.01
		],
		[
			"2010-04-06",
			23.11
		],
		[
			"2011-01-25",
			25.01
		],
		[
			"2012-01-05",
			20.91
		],
		[
			"2013-04-02",
			22.01
		],
		[
			"2014-01-27",
			21.81
		],
		[
			"2015-01-15",
			19.51
		],
		[
			"2001-07-26",
			11.3
		],
		[
			"2004-06-16",
			18.51
		]
	],
	"42013987": [
		[
			"2006-11-27",
			16.81
		],
		[
			"2007-06-05",
			13.7
		],
		[
			"2008-05-06",
			14.21
		],
		[
			"2009-04-21",
			15.01
		],
		[
			"2010-04-01",
			13.2
		],
		[
			"2011-01-24",
			16.51
		],
		[
			"2012-01-03",
			16.71
		],
		[
			"2013-04-08",
			12
		],
		[
			"2014-01-13",
			13.3
		],
		[
			"2015-06-01",
			13.1
		],
		[
			"2001-07-24",
			14.61
		],
		[
			"2004-06-14",
			19.61
		]
	],
	"42014542": [
		[
			"2006-05-17",
			41.01
		],
		[
			"2006-05-17",
			41.01
		],
		[
			"2008-01-14",
			40.01
		],
		[
			"2008-05-06",
			43.02
		],
		[
			"2009-03-04",
			36.01
		],
		[
			"2010-03-03",
			41.01
		],
		[
			"2011-02-01",
			50.02
		],
		[
			"2012-06-12",
			42.01
		],
		[
			"2013-01-25",
			56.02
		],
		[
			"2014-01-15",
			37.01
		],
		[
			"2015-12-07",
			33.01
		],
		[
			"2000-08-14",
			44.02
		],
		[
			"2003-07-30",
			47.02
		]
	],
	"42016368": [
		[
			"2006-05-16",
			48.02
		],
		[
			"2006-05-16",
			48.02
		],
		[
			"2008-01-15",
			35.01
		],
		[
			"2008-05-06",
			38.01
		],
		[
			"2009-03-03",
			47.02
		],
		[
			"2010-03-03",
			50.02
		],
		[
			"2011-01-27",
			51.02
		],
		[
			"2012-06-12",
			64.02
		],
		[
			"2013-01-28",
			58.02
		],
		[
			"2014-01-15",
			42.01
		],
		[
			"2015-12-03",
			52.02
		],
		[
			"2000-08-14",
			60.02
		],
		[
			"2003-08-11",
			35.01
		]
	],
	"42016459": [
		[
			"2005-06-22",
			36.01
		],
		[
			"2005-06-22",
			36.01
		],
		[
			"2008-01-15",
			36.01
		],
		[
			"2008-05-14",
			56.02
		],
		[
			"2009-04-21",
			52.02
		],
		[
			"2010-03-03",
			23.91
		],
		[
			"2011-06-14",
			30.01
		],
		[
			"2012-06-04",
			47.02
		],
		[
			"2013-06-24",
			34.01
		],
		[
			"2014-04-24",
			60.02
		],
		[
			"2015-01-13",
			30.01
		],
		[
			"2002-09-09",
			43.02
		]
	],
	"42060564": [
		[
			"2008-01-15",
			146.05
		],
		[
			"2008-05-05",
			181.06
		],
		[
			"2009-04-21",
			179.06
		],
		[
			"2010-03-03",
			193.07
		],
		[
			"2011-01-31",
			222.08
		],
		[
			"2012-06-04",
			178.06
		],
		[
			"2013-01-28",
			157.06
		],
		[
			"2014-01-15",
			136.05
		],
		[
			"2015-01-15",
			106.04
		],
		[
			"2015-07-22",
			138.05
		],
		[
			"2008-02-07",
			218.08
		]
	],
	"42060620": [
		[
			"2006-11-28",
			18.11
		],
		[
			"2007-06-04",
			21.01
		],
		[
			"2008-05-08",
			26.01
		],
		[
			"2009-09-02",
			29.41
		],
		[
			"2010-03-02",
			31.01
		],
		[
			"2011-01-28",
			28.01
		],
		[
			"2012-06-13",
			24.11
		],
		[
			"2013-01-24",
			25.01
		],
		[
			"2014-01-20",
			20.61
		],
		[
			"2015-12-04",
			31.01
		],
		[
			"2005-01-24",
			15.91
		],
		[
			"2005-04-12",
			15.91
		],
		[
			"2005-10-25",
			17.21
		],
		[
			"2006-04-19",
			18.81
		],
		[
			"2006-05-23",
			18.81
		],
		[
			"2006-08-01",
			21.91
		],
		[
			"2000-02-22",
			19.01
		],
		[
			"2000-05-03",
			23.01
		],
		[
			"2000-08-02",
			23.01
		],
		[
			"2000-08-28",
			25.01
		],
		[
			"2000-11-08",
			24.01
		],
		[
			"2001-02-14",
			25.21
		],
		[
			"2001-05-15",
			20.51
		],
		[
			"2001-08-01",
			26.51
		],
		[
			"2001-10-30",
			30.01
		],
		[
			"2002-01-14",
			24.11
		],
		[
			"2002-04-30",
			20.21
		],
		[
			"2002-07-31",
			15.81
		],
		[
			"2002-10-29",
			17.41
		],
		[
			"2003-01-14",
			18.61
		],
		[
			"2003-04-07",
			15.91
		],
		[
			"2003-07-01",
			14.51
		],
		[
			"2003-07-17",
			0.05
		],
		[
			"2004-01-14",
			16.21
		],
		[
			"2004-03-30",
			18.91
		],
		[
			"2004-07-06",
			16.01
		],
		[
			"2004-10-11",
			15.81
		]
	],
	"42062329": [
		[
			"2006-11-29",
			2.36
		],
		[
			"2007-06-05",
			3.26
		],
		[
			"2008-05-05",
			18.61
		],
		[
			"2009-03-25",
			4
		],
		[
			"2010-03-22",
			1.1
		],
		[
			"2011-01-25",
			2.6
		],
		[
			"2012-06-19",
			0.29
		],
		[
			"2013-01-23",
			1.36
		],
		[
			"2014-01-14",
			2
		],
		[
			"2015-03-19",
			1.38
		],
		[
			"2015-09-17",
			1.4
		],
		[
			"2015-11-11",
			0.38
		],
		[
			"2010-09-15",
			2.1
		],
		[
			"2011-03-22",
			1.7
		],
		[
			"2011-09-21",
			0.6
		],
		[
			"2012-03-21",
			1.8
		],
		[
			"2012-09-24",
			0.05
		],
		[
			"2013-03-18",
			0.77
		],
		[
			"2013-09-12",
			0.05
		],
		[
			"2014-03-20",
			0.05
		],
		[
			"2014-09-22",
			0.36
		],
		[
			"2005-03-31",
			3.9
		],
		[
			"2005-09-20",
			1.7
		],
		[
			"2006-03-23",
			1.86
		],
		[
			"2006-05-31",
			1.79
		],
		[
			"2006-09-18",
			1.8
		],
		[
			"2007-03-21",
			3.46
		],
		[
			"2007-09-19",
			2.6
		],
		[
			"2008-03-27",
			14.91
		],
		[
			"2008-09-18",
			20.31
		],
		[
			"2009-09-30",
			3
		],
		[
			"2000-08-08",
			9.2
		],
		[
			"2001-10-09",
			7.5
		],
		[
			"2002-04-04",
			3.8
		],
		[
			"2002-09-24",
			3.6
		],
		[
			"2003-03-26",
			32.01
		],
		[
			"2003-08-14",
			2.21
		],
		[
			"2003-09-22",
			2.7
		],
		[
			"2004-04-06",
			3.18
		],
		[
			"2004-09-22",
			3.2
		]
	],
	"42063310": [
		[
			"2006-12-06",
			31.01
		],
		[
			"2007-06-14",
			37.01
		],
		[
			"2008-06-18",
			44.02
		],
		[
			"2009-05-05",
			43.02
		],
		[
			"2010-04-15",
			40.01
		],
		[
			"2011-02-16",
			34.01
		],
		[
			"2012-04-05",
			46.02
		],
		[
			"2013-04-10",
			36.01
		],
		[
			"2014-02-13",
			45.02
		],
		[
			"2015-03-10",
			34.01
		],
		[
			"2005-06-08",
			33.01
		],
		[
			"2006-02-28",
			27.01
		],
		[
			"2000-03-07",
			58.02
		],
		[
			"2001-07-19",
			44.02
		],
		[
			"2002-02-06",
			47.02
		],
		[
			"2003-03-27",
			38.01
		],
		[
			"2004-06-22",
			33.01
		]
	],
	"42063334": [
		[
			"2006-11-30",
			38.01
		],
		[
			"2007-06-14",
			45.02
		],
		[
			"2008-06-18",
			53.02
		],
		[
			"2009-05-15",
			46.02
		],
		[
			"2010-04-07",
			48.02
		],
		[
			"2011-02-24",
			54.02
		],
		[
			"2012-04-05",
			43.02
		],
		[
			"2013-04-11",
			46.02
		],
		[
			"2014-03-24",
			42.01
		],
		[
			"2015-03-24",
			49.02
		],
		[
			"2005-06-08",
			42.01
		],
		[
			"2006-03-02",
			34.01
		],
		[
			"2000-03-08",
			54.02
		],
		[
			"2001-07-17",
			49.02
		],
		[
			"2002-02-05",
			55.02
		],
		[
			"2003-04-03",
			50.02
		],
		[
			"2004-06-22",
			18.61
		]
	],
	"42063437": [
		[
			"2006-11-30",
			2.4
		],
		[
			"2007-06-05",
			2.2
		],
		[
			"2008-06-23",
			1.9
		],
		[
			"2009-07-02",
			11
		],
		[
			"2010-04-15",
			4.4
		],
		[
			"2011-02-18",
			18.61
		],
		[
			"2012-03-29",
			2.4
		],
		[
			"2013-04-18",
			4.3
		],
		[
			"2014-03-24",
			1.86
		],
		[
			"2015-04-22",
			1.23
		],
		[
			"2005-06-09",
			3.7
		],
		[
			"2006-02-28",
			4.43
		],
		[
			"2000-03-14",
			7.6
		],
		[
			"2001-07-19",
			0.95
		],
		[
			"2002-02-06",
			1.63
		],
		[
			"2003-04-02",
			1.45
		],
		[
			"2004-06-18",
			1.42
		]
	],
	"42063607": [
		[
			"2006-11-29",
			31.01
		],
		[
			"2007-06-20",
			29.61
		],
		[
			"2008-06-23",
			31.01
		],
		[
			"2009-05-07",
			30.01
		],
		[
			"2010-04-07",
			25.61
		],
		[
			"2011-02-14",
			30.01
		],
		[
			"2012-04-04",
			29.01
		],
		[
			"2013-04-05",
			28.01
		],
		[
			"2014-03-26",
			33.01
		],
		[
			"2015-03-11",
			23.31
		],
		[
			"2005-06-10",
			32.01
		],
		[
			"2006-03-01",
			30.01
		],
		[
			"2000-03-21",
			31.01
		],
		[
			"2001-07-23",
			36.01
		],
		[
			"2002-02-12",
			32.01
		],
		[
			"2003-04-01",
			42.01
		],
		[
			"2004-06-17",
			35.01
		]
	],
	"42063632": [
		[
			"2006-11-29",
			0.17
		],
		[
			"2007-06-20",
			0.05
		],
		[
			"2008-06-24",
			0.89
		],
		[
			"2009-05-07",
			3
		],
		[
			"2010-04-01",
			3.4
		],
		[
			"2011-02-10",
			4.4
		],
		[
			"2012-03-28",
			1.4
		],
		[
			"2013-04-04",
			1
		],
		[
			"2014-02-21",
			2.9
		],
		[
			"2015-03-10",
			1.89
		],
		[
			"2005-06-06",
			0.6
		],
		[
			"2006-03-07",
			12.3
		],
		[
			"2000-03-20",
			4.8
		],
		[
			"2001-07-23",
			1.06
		],
		[
			"2002-02-12",
			5
		],
		[
			"2003-03-26",
			1.33
		],
		[
			"2004-06-16",
			0.25
		]
	],
	"42063656": [
		[
			"2006-11-28",
			0.06
		],
		[
			"2007-06-21",
			0.05
		],
		[
			"2008-06-13",
			0.05
		],
		[
			"2009-05-04",
			0.05
		],
		[
			"2010-04-01",
			0.05
		],
		[
			"2011-02-10",
			0.05
		],
		[
			"2012-04-03",
			0.05
		],
		[
			"2013-07-05",
			0.05
		],
		[
			"2014-03-25",
			0.05
		],
		[
			"2015-03-12",
			0.05
		],
		[
			"2005-06-14",
			0.05
		],
		[
			"2006-03-10",
			0.05
		],
		[
			"2000-03-22",
			0.05
		],
		[
			"2001-07-24",
			0.05
		],
		[
			"2002-02-13",
			0.1
		],
		[
			"2003-03-26",
			0.05
		],
		[
			"2004-06-14",
			0.12
		]
	],
	"42063670": [
		[
			"2006-11-28",
			7
		],
		[
			"2007-06-21",
			7
		],
		[
			"2008-06-12",
			8.6
		],
		[
			"2009-08-21",
			5.6
		],
		[
			"2010-04-30",
			8
		],
		[
			"2011-02-10",
			16.71
		],
		[
			"2012-03-30",
			10.7
		],
		[
			"2013-04-04",
			10.2
		],
		[
			"2014-03-26",
			18.91
		],
		[
			"2015-03-12",
			12.3
		],
		[
			"2005-06-14",
			18.41
		],
		[
			"2006-03-10",
			11.4
		],
		[
			"2000-03-22",
			93.03
		],
		[
			"2001-07-24",
			77.03
		],
		[
			"2002-02-13",
			57.22
		],
		[
			"2003-04-01",
			72.03
		],
		[
			"2004-06-14",
			20.41
		]
	],
	"42063681": [
		[
			"2006-11-27",
			60.02
		],
		[
			"2007-06-25",
			54.02
		],
		[
			"2008-06-12",
			61.02
		],
		[
			"2009-05-04",
			37.01
		],
		[
			"2010-04-01",
			50.02
		],
		[
			"2011-02-10",
			56.02
		],
		[
			"2012-04-10",
			68.02
		],
		[
			"2013-04-02",
			62.02
		],
		[
			"2014-03-25",
			55.02
		],
		[
			"2015-03-13",
			49.02
		],
		[
			"2005-06-14",
			71.03
		],
		[
			"2006-03-09",
			70.02
		],
		[
			"2000-03-21",
			54.02
		],
		[
			"2001-07-24",
			75.03
		],
		[
			"2002-02-13",
			76.73
		],
		[
			"2003-03-31",
			70.02
		],
		[
			"2004-06-16",
			75.03
		]
	],
	"42063917": [
		[
			"2006-11-27",
			0.11
		],
		[
			"2007-06-05",
			0.21
		],
		[
			"2008-05-07",
			0.05
		],
		[
			"2009-04-20",
			0.05
		],
		[
			"2010-03-31",
			0.69
		],
		[
			"2011-01-24",
			0.97
		],
		[
			"2012-01-02",
			0.09
		],
		[
			"2013-04-08",
			0.05
		],
		[
			"2014-01-16",
			0.54
		],
		[
			"2015-01-15",
			0.15
		],
		[
			"2001-07-24",
			0.05
		],
		[
			"2004-06-14",
			0.98
		]
	],
	"42064697": [
		[
			"2006-11-28",
			11.7
		],
		[
			"2007-06-19",
			10.5
		],
		[
			"2008-05-08",
			10.8
		],
		[
			"2009-03-05",
			10
		],
		[
			"2010-03-04",
			10.6
		],
		[
			"2011-01-31",
			13.1
		],
		[
			"2012-06-26",
			9.6
		],
		[
			"2013-02-14",
			7.6
		],
		[
			"2014-01-20",
			20.21
		],
		[
			"2015-12-14",
			15.21
		],
		[
			"2006-05-23",
			10.4
		],
		[
			"2000-01-21",
			16.01
		],
		[
			"2000-07-18",
			14
		],
		[
			"2003-08-14",
			13.8
		]
	],
	"42065082": [
		[
			"2006-11-27",
			37.01
		],
		[
			"2007-06-04",
			37.01
		],
		[
			"2008-05-07",
			34.01
		],
		[
			"2009-03-02",
			35.01
		],
		[
			"2010-03-02",
			34.01
		],
		[
			"2011-01-28",
			34.01
		],
		[
			"2012-02-09",
			29.01
		],
		[
			"2013-01-25",
			34.01
		],
		[
			"2014-01-16",
			30.01
		],
		[
			"2015-12-07",
			45.02
		],
		[
			"2006-05-17",
			35.01
		],
		[
			"2000-11-23",
			35.01
		],
		[
			"2003-07-17",
			40.01
		]
	],
	"42065100": [
		[
			"2006-05-17",
			33.01
		],
		[
			"2006-05-17",
			33.01
		],
		[
			"2008-01-14",
			3.8
		],
		[
			"2008-05-07",
			4.1
		],
		[
			"2009-03-02",
			15.41
		],
		[
			"2010-03-02",
			12.2
		],
		[
			"2011-01-28",
			13.6
		],
		[
			"2012-02-10",
			21.01
		],
		[
			"2013-01-25",
			12.9
		],
		[
			"2014-01-16",
			20.01
		],
		[
			"2015-12-09",
			17.65
		],
		[
			"2000-10-19",
			34.01
		],
		[
			"2003-06-26",
			28.71
		]
	],
	"42065124": [
		[
			"2006-05-16",
			15.61
		],
		[
			"2006-05-16",
			15.61
		],
		[
			"2007-10-25",
			15.91
		],
		[
			"2007-10-25",
			15.91
		],
		[
			"2008-01-15",
			12.1
		],
		[
			"2008-05-06",
			14.21
		],
		[
			"2009-03-03",
			12.3
		],
		[
			"2010-03-23",
			12.7
		],
		[
			"2011-02-01",
			12.8
		],
		[
			"2012-06-12",
			13.1
		],
		[
			"2013-01-28",
			13.2
		],
		[
			"2014-01-15",
			14.91
		],
		[
			"2015-01-27",
			15.71
		],
		[
			"2015-03-17",
			16.01
		],
		[
			"2015-08-10",
			16.71
		],
		[
			"2015-09-21",
			16.01
		],
		[
			"2015-12-07",
			17.51
		],
		[
			"2010-07-28",
			14.11
		],
		[
			"2010-09-20",
			19.11
		],
		[
			"2010-10-28",
			15.31
		],
		[
			"2011-03-28",
			14.61
		],
		[
			"2011-05-04",
			15.71
		],
		[
			"2011-10-11",
			22.31
		],
		[
			"2012-03-22",
			13.6
		],
		[
			"2012-04-25",
			11.8
		],
		[
			"2012-09-19",
			14.51
		],
		[
			"2012-11-07",
			12.7
		],
		[
			"2013-03-20",
			13
		],
		[
			"2013-09-25",
			15.51
		],
		[
			"2013-10-24",
			15.71
		],
		[
			"2014-03-17",
			11
		],
		[
			"2014-09-18",
			12.8
		],
		[
			"2008-04-17",
			13.3
		],
		[
			"2008-10-29",
			12.68
		],
		[
			"2009-07-02",
			14.11
		],
		[
			"2009-09-23",
			14.41
		],
		[
			"2009-11-18",
			13.8
		],
		[
			"2000-11-23",
			23.01
		],
		[
			"2003-06-26",
			16.91
		]
	],
	"42065264": [
		[
			"2006-11-27",
			36.01
		],
		[
			"2007-06-04",
			52.02
		],
		[
			"2008-05-06",
			56.02
		],
		[
			"2009-03-06",
			34.01
		],
		[
			"2010-03-04",
			29.01
		],
		[
			"2011-01-24",
			31.01
		],
		[
			"2012-06-12",
			44.02
		],
		[
			"2013-01-24",
			47.02
		],
		[
			"2014-01-13",
			43.02
		],
		[
			"2015-12-09",
			45.02
		],
		[
			"2010-06-24",
			48.02
		],
		[
			"2011-07-13",
			40.01
		],
		[
			"2011-11-28",
			41.01
		],
		[
			"2012-11-21",
			59.02
		],
		[
			"2013-06-20",
			51.02
		],
		[
			"2013-11-19",
			47.02
		],
		[
			"2014-06-17",
			46.02
		],
		[
			"2006-05-18",
			54.02
		],
		[
			"2007-11-27",
			44.02
		],
		[
			"2008-12-03",
			43.02
		],
		[
			"2000-11-29",
			35.01
		],
		[
			"2003-08-12",
			63.02
		]
	],
	"42065343": [
		[
			"2006-05-16",
			86.03
		],
		[
			"2006-05-16",
			86.03
		],
		[
			"2008-01-15",
			78.03
		],
		[
			"2008-05-07",
			44.02
		],
		[
			"2009-03-03",
			22.01
		],
		[
			"2010-03-03",
			52.02
		],
		[
			"2011-02-01",
			66.02
		],
		[
			"2012-02-09",
			60.02
		],
		[
			"2013-01-28",
			72.03
		],
		[
			"2014-01-15",
			65.02
		],
		[
			"2015-12-03",
			54.02
		],
		[
			"2010-07-28",
			48.02
		],
		[
			"2000-11-23",
			63.02
		],
		[
			"2003-07-30",
			94.03
		]
	],
	"42065367": [
		[
			"2006-11-30",
			16.11
		],
		[
			"2007-06-05",
			19.41
		],
		[
			"2008-05-05",
			22.01
		],
		[
			"2009-03-26",
			22.01
		],
		[
			"2010-03-02",
			15.41
		],
		[
			"2011-01-28",
			14.61
		],
		[
			"2012-06-05",
			17.61
		],
		[
			"2013-01-23",
			8.2
		],
		[
			"2014-01-20",
			10.3
		],
		[
			"2015-11-11",
			12
		],
		[
			"2006-05-30",
			19.91
		],
		[
			"2000-08-24",
			22.01
		],
		[
			"2003-06-24",
			17.81
		]
	],
	"42065604": [
		[
			"2006-11-28",
			8.9
		],
		[
			"2007-06-04",
			11.9
		],
		[
			"2008-05-06",
			7.8
		],
		[
			"2009-02-27",
			8.6
		],
		[
			"2010-03-04",
			9.1
		],
		[
			"2011-01-31",
			11.2
		],
		[
			"2012-06-12",
			25.81
		],
		[
			"2013-01-29",
			23.61
		],
		[
			"2014-01-14",
			16.31
		],
		[
			"2015-12-14",
			11
		],
		[
			"2006-05-22",
			6.1
		],
		[
			"2000-11-17",
			7.3
		],
		[
			"2003-06-24",
			13.2
		]
	],
	"47077062": [
		[
			"2009-05-26",
			10.2
		],
		[
			"2008-11-18",
			6.7
		],
		[
			"2008-05-15",
			11.3
		],
		[
			"2000-05-24",
			14
		],
		[
			"2000-12-13",
			15.41
		],
		[
			"2001-05-08",
			12.4
		],
		[
			"2001-11-15",
			11.1
		],
		[
			"2002-08-07",
			12
		],
		[
			"2003-05-12",
			8.7
		],
		[
			"2003-11-06",
			9
		],
		[
			"2004-06-23",
			8.3
		],
		[
			"2004-11-30",
			8.4
		],
		[
			"2005-05-09",
			9.2
		],
		[
			"2005-11-10",
			10.9
		],
		[
			"2006-06-08",
			9.9
		],
		[
			"2006-11-06",
			9.8
		],
		[
			"2007-05-10",
			9.1
		],
		[
			"2010-05-17",
			8.9
		],
		[
			"2011-05-25",
			10.4
		],
		[
			"2010-11-10",
			11.6
		],
		[
			"2011-11-23",
			12
		],
		[
			"2013-11-20",
			10.6
		],
		[
			"2013-05-22",
			9.6
		],
		[
			"2012-11-21",
			9.5
		],
		[
			"2012-05-14",
			10.8
		],
		[
			"2014-05-14",
			9.6
		],
		[
			"2014-11-17",
			12.6
		],
		[
			"2015-11-11",
			10.2
		],
		[
			"2015-05-13",
			12.9
		]
	],
	"47200066": [
		[
			"2008-05-27",
			19.81
		],
		[
			"2008-10-21",
			19.81
		],
		[
			"2009-05-12",
			19.91
		],
		[
			"2009-10-27",
			19.61
		],
		[
			"2010-05-18",
			18.01
		],
		[
			"2001-04-04",
			20.01
		],
		[
			"2001-10-10",
			17.01
		],
		[
			"2000-04-18",
			17.01
		],
		[
			"2000-10-17",
			16.01
		],
		[
			"2002-04-11",
			16.01
		],
		[
			"2002-10-17",
			19.01
		],
		[
			"2003-07-16",
			20.01
		],
		[
			"2003-10-22",
			19.01
		],
		[
			"2004-05-05",
			19.01
		],
		[
			"2004-10-19",
			20.61
		],
		[
			"2005-05-10",
			18.81
		],
		[
			"2005-10-12",
			20.91
		],
		[
			"2006-05-11",
			19.31
		],
		[
			"2006-10-11",
			20.01
		],
		[
			"2007-05-08",
			20.21
		],
		[
			"2007-10-09",
			17.41
		],
		[
			"2010-10-27",
			19.91
		],
		[
			"2011-05-25",
			16.51
		],
		[
			"2011-10-25",
			19.71
		],
		[
			"2012-05-22",
			20.81
		],
		[
			"2012-11-13",
			21.11
		],
		[
			"2013-05-14",
			20.31
		],
		[
			"2013-10-30",
			27.31
		],
		[
			"2014-05-06",
			22.51
		],
		[
			"2014-09-23",
			21.11
		],
		[
			"2015-04-21",
			20.51
		],
		[
			"2015-09-08",
			24.41
		]
	],
	"47202063": [
		[
			"2008-05-28",
			12.7
		],
		[
			"2008-10-22",
			14.2
		],
		[
			"2008-11-27",
			11.6
		],
		[
			"2009-05-13",
			14.2
		],
		[
			"2009-10-28",
			13.8
		],
		[
			"2010-05-19",
			13.1
		],
		[
			"2001-10-11",
			11
		],
		[
			"2000-10-19",
			8
		],
		[
			"2001-04-05",
			11
		],
		[
			"2002-04-11",
			12
		],
		[
			"2002-10-17",
			12
		],
		[
			"2004-05-05",
			7.6
		],
		[
			"2004-10-20",
			10.5
		],
		[
			"2005-05-11",
			4.9
		],
		[
			"2006-01-31",
			5.5
		],
		[
			"2006-10-11",
			12
		],
		[
			"2007-05-09",
			10.8
		],
		[
			"2007-10-10",
			10.8
		],
		[
			"2010-10-28",
			12.5
		],
		[
			"2011-05-25",
			11.4
		],
		[
			"2011-10-26",
			11.1
		],
		[
			"2012-05-23",
			11.3
		],
		[
			"2012-11-14",
			10.5
		],
		[
			"2013-05-15",
			8.7
		],
		[
			"2013-10-30",
			4.1
		],
		[
			"2014-05-07",
			11.2
		],
		[
			"2014-09-24",
			10.4
		],
		[
			"2015-04-22",
			10.6
		],
		[
			"2015-09-09",
			10.1
		]
	],
	"59110168": [
		[
			"2000-08-29",
			46.94
		],
		[
			"2001-04-25",
			48.71
		],
		[
			"2002-07-15",
			46.5
		],
		[
			"2003-05-09",
			47.39
		],
		[
			"2004-05-11",
			48.71
		],
		[
			"2005-04-21",
			47.39
		],
		[
			"2006-03-20",
			37.64
		],
		[
			"2006-08-07",
			38.53
		],
		[
			"2007-03-22",
			36.31
		],
		[
			"2008-03-03",
			37.2
		],
		[
			"2013-06-07",
			26.44
		],
		[
			"2014-08-06",
			25.42
		],
		[
			"2015-06-17",
			27.68
		],
		[
			"2009-05-20",
			32.77
		],
		[
			"2010-04-23",
			30.56
		],
		[
			"2011-07-20",
			31
		]
	],
	"59110302": [
		[
			"2000-07-04",
			39.41
		],
		[
			"2001-05-03",
			34.99
		],
		[
			"2002-05-08",
			36.76
		],
		[
			"2003-04-07",
			37.64
		],
		[
			"2004-03-10",
			36.31
		],
		[
			"2005-02-24",
			34.1
		],
		[
			"2006-02-10",
			34.54
		],
		[
			"2007-03-09",
			31
		],
		[
			"2008-02-25",
			33.66
		],
		[
			"2013-06-27",
			34.54
		],
		[
			"2014-03-26",
			31.53
		],
		[
			"2015-05-06",
			30.07
		],
		[
			"2009-06-16",
			33.66
		],
		[
			"2010-04-23",
			32.33
		],
		[
			"2011-04-05",
			34.99
		],
		[
			"2012-08-14",
			33.21
		]
	],
	"59110340": [
		[
			"2006-03-21",
			18.16
		],
		[
			"2007-08-27",
			15.94
		],
		[
			"2008-03-03",
			16.39
		],
		[
			"2013-06-27",
			12.49
		],
		[
			"2014-08-06",
			11.87
		],
		[
			"2015-08-04",
			9.7
		],
		[
			"2009-06-29",
			16.39
		],
		[
			"2010-04-28",
			15.5
		],
		[
			"2011-07-20",
			11.07
		]
	],
	"59110363": [
		[
			"2013-09-04",
			2.86
		],
		[
			"2015-06-17",
			5.27
		],
		[
			"2011-10-27",
			5.76
		]
	],
	"59130015": [
		[
			"2000-05-08",
			2.21
		],
		[
			"2001-07-03",
			2.21
		],
		[
			"2002-04-26",
			2.21
		],
		[
			"2003-04-02",
			2.21
		],
		[
			"2004-06-29",
			2.21
		],
		[
			"2005-04-14",
			2.21
		],
		[
			"2006-03-02",
			2.21
		],
		[
			"2007-04-17",
			2.21
		],
		[
			"2010-02-02",
			0.89
		],
		[
			"2010-05-05",
			0.8
		],
		[
			"2010-08-10",
			1.02
		],
		[
			"2010-11-02",
			0.71
		],
		[
			"2011-02-01",
			0.89
		],
		[
			"2011-05-03",
			1.68
		],
		[
			"2011-08-02",
			0.09
		],
		[
			"2011-11-09",
			0.49
		],
		[
			"2012-02-14",
			0.71
		],
		[
			"2012-05-08",
			0.89
		],
		[
			"2012-08-08",
			1.02
		],
		[
			"2012-11-13",
			0.62
		],
		[
			"2013-02-05",
			0.49
		],
		[
			"2013-05-07",
			0.8
		],
		[
			"2013-08-06",
			0.71
		],
		[
			"2013-11-05",
			0.09
		],
		[
			"2013-06-20",
			1.33
		],
		[
			"2014-09-30",
			1.33
		],
		[
			"2015-10-20",
			1.33
		],
		[
			"2009-05-20",
			4.43
		],
		[
			"2010-05-10",
			4.43
		],
		[
			"2011-07-22",
			4.43
		]
	],
	"59130179": [
		[
			"2000-04-20",
			11.96
		],
		[
			"2000-11-13",
			10.63
		],
		[
			"2001-05-11",
			10.63
		],
		[
			"2002-09-24",
			15.94
		],
		[
			"2003-03-05",
			4.1
		],
		[
			"2003-09-02",
			3.6
		],
		[
			"2004-03-09",
			1.59
		],
		[
			"2004-09-14",
			15.94
		],
		[
			"2006-08-08",
			6.64
		],
		[
			"2005-03-24",
			11.96
		],
		[
			"2005-09-13",
			11.07
		],
		[
			"2007-04-17",
			8.41
		],
		[
			"2008-03-20",
			2.66
		],
		[
			"2010-03-26",
			2.48
		],
		[
			"2010-09-21",
			1.2
		],
		[
			"2011-03-11",
			1.5
		],
		[
			"2011-09-28",
			1.2
		],
		[
			"2011-12-01",
			1.4
		],
		[
			"2012-03-22",
			1
		],
		[
			"2012-09-25",
			2.4
		],
		[
			"2013-06-20",
			1.33
		],
		[
			"2014-09-01",
			1.33
		],
		[
			"2015-06-23",
			1.33
		],
		[
			"2007-04-02",
			5.7
		],
		[
			"2007-10-09",
			8
		],
		[
			"2008-03-18",
			3.7
		],
		[
			"2008-09-01",
			1.1
		],
		[
			"2009-08-10",
			4.43
		],
		[
			"2010-05-10",
			4.43
		],
		[
			"2011-07-22",
			4.43
		]
	],
	"59130430": [
		[
			"2006-08-08",
			2.21
		],
		[
			"2007-04-18",
			2.21
		],
		[
			"2008-03-04",
			2.21
		],
		[
			"2013-06-12",
			1.33
		],
		[
			"2014-07-28",
			1.33
		],
		[
			"2015-06-08",
			1.33
		],
		[
			"2009-06-30",
			4.43
		],
		[
			"2010-05-03",
			4.43
		],
		[
			"2011-07-19",
			4.43
		]
	],
	"59130441": [
		[
			"2001-07-05",
			27.46
		],
		[
			"2002-07-05",
			28.79
		],
		[
			"2003-09-26",
			45.61
		],
		[
			"2004-09-21",
			31.44
		],
		[
			"2005-04-20",
			48.71
		],
		[
			"2007-03-29",
			37.64
		],
		[
			"2008-04-07",
			29.23
		],
		[
			"2013-06-17",
			34.23
		],
		[
			"2014-08-04",
			35.3
		],
		[
			"2015-06-08",
			31.49
		],
		[
			"2009-08-05",
			25.69
		],
		[
			"2010-06-21",
			33.21
		],
		[
			"2011-08-19",
			46.5
		]
	],
	"59130465": [
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-04-18",
			6.2
		],
		[
			"2008-03-04",
			4.87
		],
		[
			"2013-06-12",
			12
		],
		[
			"2014-08-05",
			12
		],
		[
			"2015-10-26",
			9.17
		],
		[
			"2009-06-30",
			4.43
		],
		[
			"2010-05-03",
			4.43
		],
		[
			"2011-07-19",
			4.43
		]
	],
	"59130556": [
		[
			"2000-05-15",
			6.64
		],
		[
			"2002-05-07",
			22.59
		],
		[
			"2003-03-28",
			2.21
		],
		[
			"2004-07-08",
			2.21
		],
		[
			"2005-04-20",
			4.87
		],
		[
			"2007-04-02",
			2.21
		],
		[
			"2008-03-05",
			2.21
		],
		[
			"2013-06-17",
			1.33
		],
		[
			"2014-08-04",
			1.33
		],
		[
			"2015-06-22",
			1.33
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-08-19",
			7.53
		]
	],
	"59130570": [
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-04-18",
			2.21
		],
		[
			"2008-03-04",
			2.21
		],
		[
			"2013-06-12",
			1.33
		],
		[
			"2014-08-05",
			1.33
		],
		[
			"2015-07-07",
			1.33
		],
		[
			"2009-06-30",
			4.43
		],
		[
			"2010-05-03",
			4.43
		],
		[
			"2011-07-19",
			4.43
		]
	],
	"59130581": [
		[
			"2004-09-21",
			2.21
		],
		[
			"2005-04-20",
			3.54
		],
		[
			"2007-04-02",
			2.21
		],
		[
			"2008-03-05",
			2.21
		],
		[
			"2013-06-17",
			1.33
		],
		[
			"2014-09-01",
			1.33
		],
		[
			"2015-10-21",
			1.33
		],
		[
			"2009-08-05",
			4.43
		],
		[
			"2010-06-21",
			4.43
		],
		[
			"2011-08-19",
			4.43
		]
	],
	"59130600": [
		[
			"2000-05-09",
			2.21
		],
		[
			"2001-05-04",
			2.21
		],
		[
			"2002-06-20",
			2.21
		],
		[
			"2003-04-04",
			2.21
		],
		[
			"2004-06-28",
			2.21
		],
		[
			"2005-03-30",
			2.21
		],
		[
			"2006-03-01",
			2.21
		],
		[
			"2006-08-10",
			2.21
		],
		[
			"2007-03-27",
			2.21
		],
		[
			"2008-03-06",
			2.21
		],
		[
			"2013-06-24",
			1.33
		],
		[
			"2014-08-19",
			1.33
		],
		[
			"2015-06-22",
			1.33
		],
		[
			"2009-05-18",
			4.43
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-08-23",
			4.43
		]
	],
	"59130660": [
		[
			"2000-05-15",
			2.21
		],
		[
			"2001-04-27",
			2.21
		],
		[
			"2002-07-05",
			2.21
		],
		[
			"2003-09-26",
			2.21
		],
		[
			"2004-03-11",
			2.21
		],
		[
			"2005-04-18",
			2.21
		],
		[
			"2006-02-20",
			2.21
		],
		[
			"2006-08-09",
			2.21
		],
		[
			"2007-04-02",
			2.21
		],
		[
			"2008-03-05",
			2.21
		],
		[
			"2014-07-28",
			1.5
		],
		[
			"2015-03-24",
			1.33
		],
		[
			"2009-05-18",
			6.2
		],
		[
			"2010-07-21",
			4.43
		],
		[
			"2011-09-26",
			4.43
		],
		[
			"2012-08-14",
			1.33
		]
	],
	"59130714": [
		[
			"2006-08-17",
			25.69
		],
		[
			"2007-04-27",
			27.9
		],
		[
			"2008-04-01",
			29.67
		],
		[
			"2014-10-08",
			27.55
		],
		[
			"2015-10-26",
			20.15
		],
		[
			"2009-07-01",
			26.13
		],
		[
			"2010-06-21",
			23.91
		],
		[
			"2011-10-27",
			25.69
		]
	],
	"59130726": [
		[
			"2006-08-17",
			2.21
		],
		[
			"2007-10-16",
			2.21
		],
		[
			"2008-04-01",
			4.87
		],
		[
			"2014-10-08",
			1.33
		],
		[
			"2015-07-07",
			1.33
		],
		[
			"2009-07-01",
			4.43
		],
		[
			"2010-04-29",
			4.43
		],
		[
			"2011-08-23",
			4.43
		]
	],
	"59140185": [
		[
			"2000-08-18",
			28.79
		],
		[
			"2001-04-02",
			29.67
		],
		[
			"2002-04-16",
			30.56
		],
		[
			"2003-03-26",
			21.26
		],
		[
			"2004-04-29",
			30.11
		],
		[
			"2005-02-10",
			27.46
		],
		[
			"2006-02-06",
			21.7
		],
		[
			"2007-05-03",
			23.03
		],
		[
			"2008-03-11",
			20.81
		],
		[
			"2013-06-10",
			30.51
		],
		[
			"2014-08-13",
			33.79
		],
		[
			"2015-04-20",
			32.28
		],
		[
			"2009-05-11",
			24.8
		],
		[
			"2010-06-29",
			19.49
		],
		[
			"2011-07-18",
			25.69
		],
		[
			"2011-10-24",
			26.57
		]
	],
	"59140288": [
		[
			"2000-05-30",
			57.57
		],
		[
			"2001-03-19",
			55.36
		],
		[
			"2002-04-16",
			60.23
		],
		[
			"2003-03-26",
			58.46
		],
		[
			"2004-02-24",
			51.81
		],
		[
			"2005-02-16",
			50.49
		],
		[
			"2006-07-13",
			48.71
		],
		[
			"2007-04-27",
			38.97
		],
		[
			"2008-04-22",
			49.6
		],
		[
			"2013-06-10",
			41.01
		],
		[
			"2014-03-26",
			38.84
		],
		[
			"2015-03-23",
			45.61
		],
		[
			"2009-05-11",
			44.29
		],
		[
			"2010-04-30",
			41.63
		],
		[
			"2011-04-04",
			46.06
		],
		[
			"2012-08-14",
			42.07
		]
	],
	"59140331": [
		[
			"2005-03-15",
			14.17
		],
		[
			"2005-07-25",
			13.29
		],
		[
			"2006-03-30",
			13.73
		],
		[
			"2006-08-22",
			11.96
		],
		[
			"2007-07-04",
			11.96
		],
		[
			"2008-04-23",
			12.84
		],
		[
			"2014-10-21",
			11.2
		],
		[
			"2015-06-24",
			11.69
		],
		[
			"2009-07-21",
			12.84
		],
		[
			"2010-06-29",
			13.73
		],
		[
			"2011-10-24",
			12.84
		]
	],
	"59160068": [
		[
			"2000-09-11",
			2.21
		],
		[
			"2001-07-04",
			2.21
		],
		[
			"2003-07-07",
			2.21
		],
		[
			"2004-05-11",
			2.21
		],
		[
			"2005-04-07",
			2.21
		],
		[
			"2006-03-14",
			2.21
		],
		[
			"2007-04-16",
			2.21
		],
		[
			"2008-05-06",
			2.21
		],
		[
			"2013-06-18",
			1.33
		],
		[
			"2014-09-22",
			1.33
		],
		[
			"2015-06-15",
			1.33
		],
		[
			"2009-09-14",
			4.43
		],
		[
			"2010-07-16",
			4.43
		],
		[
			"2011-08-29",
			4.43
		]
	],
	"59160093": [
		[
			"2000-07-03",
			2.21
		],
		[
			"2001-10-26",
			2.21
		],
		[
			"2002-09-23",
			2.21
		],
		[
			"2004-05-11",
			2.21
		],
		[
			"2005-04-07",
			2.21
		],
		[
			"2006-02-23",
			2.21
		],
		[
			"2007-03-16",
			2.21
		],
		[
			"2008-03-07",
			2.21
		],
		[
			"2013-06-19",
			1.33
		],
		[
			"2014-09-22",
			1.33
		],
		[
			"2015-06-15",
			1.33
		],
		[
			"2009-08-04",
			4.43
		],
		[
			"2010-05-05",
			4.43
		],
		[
			"2011-08-29",
			4.43
		]
	],
	"59160123": [
		[
			"2000-07-03",
			2.21
		],
		[
			"2001-05-28",
			2.21
		],
		[
			"2002-06-14",
			2.21
		],
		[
			"2003-11-17",
			2.21
		],
		[
			"2004-09-22",
			2.21
		],
		[
			"2005-04-12",
			2.21
		],
		[
			"2006-03-08",
			2.21
		],
		[
			"2006-08-11",
			2.21
		],
		[
			"2007-04-19",
			2.21
		],
		[
			"2008-04-02",
			2.21
		],
		[
			"2013-06-24",
			1.33
		],
		[
			"2015-10-19",
			1.33
		],
		[
			"2010-05-05",
			4.43
		],
		[
			"2011-08-31",
			4.43
		]
	],
	"59160147": [
		[
			"2000-05-23",
			5.31
		],
		[
			"2001-08-08",
			2.21
		],
		[
			"2002-08-26",
			2.21
		],
		[
			"2003-07-11",
			2.21
		],
		[
			"2004-05-07",
			3.1
		],
		[
			"2005-04-12",
			2.21
		],
		[
			"2006-03-08",
			2.21
		],
		[
			"2007-04-19",
			2.21
		],
		[
			"2008-04-02",
			2.21
		],
		[
			"2013-06-19",
			3.01
		],
		[
			"2014-09-24",
			1.33
		],
		[
			"2015-06-09",
			1.33
		],
		[
			"2009-08-04",
			5.31
		],
		[
			"2010-05-05",
			4.43
		],
		[
			"2011-08-31",
			4.43
		]
	],
	"59160184": [
		[
			"2000-09-11",
			4.87
		],
		[
			"2001-08-20",
			6.2
		],
		[
			"2002-06-25",
			5.31
		],
		[
			"2003-07-04",
			5.31
		],
		[
			"2004-07-09",
			5.76
		],
		[
			"2005-04-27",
			4.87
		],
		[
			"2006-03-23",
			4.87
		],
		[
			"2006-08-11",
			6.64
		],
		[
			"2007-07-30",
			3.99
		],
		[
			"2008-06-20",
			3.54
		],
		[
			"2013-06-18",
			4.92
		],
		[
			"2014-09-24",
			5.14
		],
		[
			"2015-06-09",
			4.31
		],
		[
			"2009-06-29",
			6.2
		],
		[
			"2010-04-28",
			4.43
		],
		[
			"2011-08-31",
			4.43
		]
	],
	"59540187": [
		[
			"2000-07-04",
			2.66
		],
		[
			"2001-09-05",
			2.21
		],
		[
			"2002-05-15",
			3.99
		],
		[
			"2003-07-22",
			2.21
		],
		[
			"2004-04-27",
			2.66
		],
		[
			"2005-02-23",
			2.66
		],
		[
			"2006-03-22",
			2.21
		],
		[
			"2006-08-11",
			2.21
		],
		[
			"2007-03-02",
			6.2
		],
		[
			"2008-02-26",
			2.21
		],
		[
			"2013-08-02",
			1.33
		],
		[
			"2014-03-28",
			1.33
		],
		[
			"2015-03-24",
			1.33
		],
		[
			"2009-06-17",
			4.43
		],
		[
			"2010-05-27",
			4.43
		],
		[
			"2011-04-05",
			4.43
		],
		[
			"2012-07-25",
			1.33
		]
	],
	"59540308": [
		[
			"2000-09-08",
			85.91
		],
		[
			"2001-08-17",
			93
		],
		[
			"2003-07-22",
			56.24
		],
		[
			"2004-07-20",
			78.83
		],
		[
			"2005-04-22",
			36.76
		],
		[
			"2006-03-10",
			54.47
		],
		[
			"2007-04-04",
			20.37
		],
		[
			"2008-03-14",
			21.26
		],
		[
			"2013-06-07",
			29.49
		],
		[
			"2014-08-12",
			42.91
		],
		[
			"2015-08-18",
			46.94
		],
		[
			"2009-07-03",
			53.59
		],
		[
			"2010-07-21",
			56.69
		],
		[
			"2011-09-30",
			49.6
		]
	],
	"59540515": [
		[
			"2000-09-12",
			2.66
		],
		[
			"2001-05-18",
			6.2
		],
		[
			"2002-06-17",
			10.19
		],
		[
			"2003-06-30",
			2.21
		],
		[
			"2004-07-20",
			4.87
		],
		[
			"2005-06-15",
			3.1
		],
		[
			"2006-03-21",
			2.21
		],
		[
			"2007-07-16",
			2.66
		],
		[
			"2008-03-14",
			5.31
		],
		[
			"2013-06-06",
			1.72
		],
		[
			"2014-08-11",
			2.98
		],
		[
			"2015-06-16",
			6.86
		],
		[
			"2009-07-03",
			4.43
		],
		[
			"2010-05-19",
			7.09
		],
		[
			"2011-07-18",
			4.43
		]
	],
	"59540564": [
		[
			"2000-08-24",
			2.21
		],
		[
			"2001-06-13",
			2.21
		],
		[
			"2002-05-06",
			2.21
		],
		[
			"2003-05-23",
			2.21
		],
		[
			"2004-05-04",
			2.21
		],
		[
			"2005-04-22",
			2.21
		],
		[
			"2006-03-20",
			2.21
		],
		[
			"2007-03-22",
			2.21
		],
		[
			"2008-04-17",
			2.21
		],
		[
			"2013-06-06",
			1.33
		],
		[
			"2014-10-22",
			1.33
		],
		[
			"2015-10-19",
			1.33
		],
		[
			"2009-07-02",
			4.43
		],
		[
			"2010-05-19",
			4.43
		],
		[
			"2011-09-26",
			4.43
		]
	],
	"59540576": [
		[
			"2000-05-03",
			2.21
		],
		[
			"2001-06-13",
			2.21
		],
		[
			"2002-06-12",
			2.21
		],
		[
			"2004-02-25",
			2.21
		],
		[
			"2004-09-29",
			2.21
		],
		[
			"2005-02-23",
			2.21
		],
		[
			"2005-06-01",
			2.21
		],
		[
			"2005-06-17",
			2.21
		],
		[
			"2006-02-08",
			2.21
		],
		[
			"2007-03-02",
			2.21
		],
		[
			"2008-04-17",
			2.21
		],
		[
			"2013-09-04",
			1.33
		],
		[
			"2014-10-22",
			1.33
		],
		[
			"2015-05-06",
			1.33
		],
		[
			"2003-07-15",
			2.21
		],
		[
			"2009-06-17",
			4.43
		],
		[
			"2010-05-27",
			4.43
		],
		[
			"2011-04-29",
			4.43
		],
		[
			"2012-07-25",
			1.33
		]
	],
	"59540606": [
		[
			"2000-07-04",
			11.07
		],
		[
			"2001-05-18",
			16.83
		],
		[
			"2002-05-15",
			13.29
		],
		[
			"2003-06-24",
			2.21
		],
		[
			"2004-07-28",
			2.21
		],
		[
			"2005-06-17",
			2.21
		],
		[
			"2006-08-10",
			2.21
		],
		[
			"2007-08-31",
			2.21
		],
		[
			"2008-06-24",
			2.21
		],
		[
			"2013-06-10",
			1.33
		],
		[
			"2015-04-20",
			1.33
		],
		[
			"2009-07-02",
			4.43
		],
		[
			"2010-07-27",
			4.43
		],
		[
			"2011-08-30",
			4.43
		],
		[
			"2012-07-25",
			1.33
		]
	],
	"59540618": [
		[
			"2000-09-01",
			25.24
		],
		[
			"2001-04-02",
			42.96
		],
		[
			"2002-06-17",
			20.37
		],
		[
			"2003-06-24",
			21.26
		],
		[
			"2004-07-19",
			32.77
		],
		[
			"2005-07-07",
			25.24
		],
		[
			"2006-04-24",
			31.44
		],
		[
			"2007-03-28",
			35.87
		],
		[
			"2007-05-04",
			34.1
		],
		[
			"2008-03-19",
			34.1
		],
		[
			"2013-06-14",
			17.67
		],
		[
			"2014-08-26",
			32.59
		],
		[
			"2015-08-04",
			35.34
		],
		[
			"2009-09-14",
			23.03
		],
		[
			"2010-07-22",
			12.4
		],
		[
			"2011-08-30",
			27.9
		]
	],
	"59540643": [
		[
			"2000-11-27",
			6.2
		],
		[
			"2001-06-01",
			4.87
		],
		[
			"2002-04-29",
			4.43
		],
		[
			"2003-09-19",
			6.64
		],
		[
			"2004-02-16",
			6.64
		],
		[
			"2005-02-23",
			7.53
		],
		[
			"2006-02-08",
			5.76
		],
		[
			"2006-08-10",
			5.31
		],
		[
			"2007-03-02",
			6.2
		],
		[
			"2008-02-26",
			3.1
		],
		[
			"2013-06-26",
			2.88
		],
		[
			"2014-07-15",
			1.89
		],
		[
			"2015-03-23",
			4
		],
		[
			"2009-06-17",
			6.64
		],
		[
			"2010-05-27",
			6.64
		],
		[
			"2011-04-05",
			8.86
		],
		[
			"2012-07-23",
			3.1
		]
	],
	"59540734": [
		[
			"2002-04-29",
			39.86
		],
		[
			"2003-09-19",
			18.6
		],
		[
			"2004-02-25",
			18.6
		],
		[
			"2005-02-23",
			19.93
		],
		[
			"2006-02-08",
			35.87
		],
		[
			"2007-03-02",
			34.54
		],
		[
			"2008-02-26",
			29.67
		],
		[
			"2013-06-25",
			30.2
		],
		[
			"2014-07-08",
			17.45
		],
		[
			"2015-03-23",
			31
		],
		[
			"2009-06-17",
			25.24
		],
		[
			"2010-05-27",
			26.13
		],
		[
			"2011-04-05",
			27.9
		],
		[
			"2012-07-23",
			28.34
		]
	],
	"59540837": [
		[
			"2005-08-30",
			15.5
		],
		[
			"2006-03-22",
			16.83
		],
		[
			"2007-04-20",
			16.83
		],
		[
			"2008-06-24",
			15.06
		],
		[
			"2013-06-26",
			16.12
		],
		[
			"2014-07-08",
			14.61
		],
		[
			"2015-05-06",
			16.83
		],
		[
			"2009-07-03",
			20.81
		],
		[
			"2010-07-22",
			15.5
		],
		[
			"2011-08-30",
			16.39
		],
		[
			"2012-07-23",
			17.27
		]
	],
	"59620079": [
		[
			"2000-05-03",
			11.96
		],
		[
			"2001-06-20",
			13.29
		],
		[
			"2001-10-23",
			12.84
		],
		[
			"2002-05-31",
			12.84
		],
		[
			"2004-02-05",
			12.4
		],
		[
			"2004-09-28",
			12.84
		],
		[
			"2005-05-31",
			13.29
		],
		[
			"2006-02-14",
			12.4
		],
		[
			"2007-02-28",
			11.51
		],
		[
			"2007-07-13",
			12.4
		],
		[
			"2008-01-31",
			12.4
		],
		[
			"2013-06-21",
			12.75
		],
		[
			"2014-07-07",
			11.69
		],
		[
			"2015-03-30",
			12.13
		],
		[
			"2003-07-16",
			13.73
		],
		[
			"2009-06-25",
			16.83
		],
		[
			"2010-05-11",
			13.73
		],
		[
			"2011-04-04",
			13.29
		],
		[
			"2012-07-31",
			12.84
		]
	],
	"59620092": [
		[
			"2007-07-19",
			11.51
		],
		[
			"2008-06-25",
			11.51
		],
		[
			"2013-08-28",
			13.24
		],
		[
			"2014-07-15",
			12.22
		],
		[
			"2015-04-08",
			12.13
		],
		[
			"2009-07-09",
			12.4
		],
		[
			"2010-04-30",
			11.51
		],
		[
			"2011-09-05",
			12.84
		],
		[
			"2012-08-08",
			13.29
		]
	],
	"59620109": [
		[
			"2000-07-05",
			18.6
		],
		[
			"2001-06-12",
			17.27
		],
		[
			"2002-05-16",
			17.27
		],
		[
			"2003-05-13",
			17.71
		],
		[
			"2004-03-02",
			23.03
		],
		[
			"2005-03-14",
			14.61
		],
		[
			"2006-02-28",
			18.6
		],
		[
			"2006-08-15",
			21.7
		],
		[
			"2007-04-05",
			18.6
		],
		[
			"2008-04-18",
			19.93
		],
		[
			"2015-12-07",
			16.01
		],
		[
			"2013-08-28",
			16.61
		],
		[
			"2014-07-07",
			18.25
		],
		[
			"2015-03-30",
			16.39
		],
		[
			"2009-08-18",
			19.93
		],
		[
			"2010-07-29",
			19.93
		],
		[
			"2011-09-09",
			10.19
		],
		[
			"2012-08-08",
			12.84
		]
	],
	"59620134": [
		[
			"2000-05-29",
			25.24
		],
		[
			"2001-06-01",
			66.43
		],
		[
			"2003-04-09",
			39.86
		],
		[
			"2004-02-25",
			35.43
		],
		[
			"2005-06-01",
			46.5
		],
		[
			"2006-03-15",
			57.13
		],
		[
			"2007-03-13",
			38.97
		],
		[
			"2008-02-27",
			46.06
		],
		[
			"2013-06-25",
			42.51
		],
		[
			"2014-07-15",
			41.67
		],
		[
			"2015-03-30",
			15.94
		],
		[
			"2009-07-09",
			44.73
		],
		[
			"2010-07-15",
			55.8
		],
		[
			"2011-09-27",
			36.31
		],
		[
			"2012-08-08",
			43.4
		]
	],
	"59620183": [
		[
			"2000-07-05",
			25.69
		],
		[
			"2001-05-31",
			33.21
		],
		[
			"2003-04-10",
			31.44
		],
		[
			"2004-03-12",
			28.79
		],
		[
			"2005-06-24",
			27.46
		],
		[
			"2006-03-28",
			25.24
		],
		[
			"2007-05-07",
			27.01
		],
		[
			"2008-05-08",
			23.91
		],
		[
			"2013-06-26",
			21.3
		],
		[
			"2014-07-07",
			18.2
		],
		[
			"2015-03-16",
			22.01
		],
		[
			"2009-06-16",
			23.91
		],
		[
			"2010-07-27",
			17.71
		],
		[
			"2011-09-02",
			19.93
		],
		[
			"2012-07-31",
			21.26
		]
	],
	"59620201": [
		[
			"2000-06-08",
			33.21
		],
		[
			"2001-06-08",
			25.24
		],
		[
			"2003-05-22",
			36.31
		],
		[
			"2004-10-04",
			15.5
		],
		[
			"2005-04-11",
			16.83
		],
		[
			"2006-03-09",
			12.4
		],
		[
			"2007-05-21",
			18.6
		],
		[
			"2008-04-25",
			28.79
		],
		[
			"2013-07-11",
			37.24
		],
		[
			"2014-10-28",
			28.96
		],
		[
			"2015-09-09",
			24.14
		],
		[
			"2009-08-03",
			23.47
		],
		[
			"2010-06-25",
			32.77
		],
		[
			"2011-09-30",
			43.84
		]
	],
	"59620213": [
		[
			"2000-08-21",
			11.07
		],
		[
			"2001-05-17",
			10.63
		],
		[
			"2002-05-24",
			10.19
		],
		[
			"2003-05-13",
			10.63
		],
		[
			"2004-02-20",
			11.07
		],
		[
			"2005-05-31",
			11.96
		],
		[
			"2006-04-26",
			13.29
		],
		[
			"2007-04-25",
			16.39
		],
		[
			"2007-09-26",
			21.26
		],
		[
			"2008-06-16",
			25.24
		],
		[
			"2013-07-11",
			16.39
		],
		[
			"2014-03-12",
			16.61
		],
		[
			"2015-03-24",
			13.51
		],
		[
			"2009-07-07",
			25.69
		],
		[
			"2010-05-07",
			23.91
		],
		[
			"2011-04-04",
			22.14
		],
		[
			"2012-07-24",
			15.06
		]
	],
	"59620249": [
		[
			"2001-05-29",
			5.31
		],
		[
			"2002-06-06",
			5.76
		],
		[
			"2003-05-26",
			6.2
		],
		[
			"2004-03-31",
			7.09
		],
		[
			"2005-06-22",
			6.64
		],
		[
			"2006-03-24",
			7.53
		],
		[
			"2007-06-27",
			7.53
		],
		[
			"2008-07-16",
			7.53
		],
		[
			"2013-09-23",
			7.57
		],
		[
			"2014-07-14",
			7.71
		],
		[
			"2015-10-06",
			8.37
		],
		[
			"2009-11-30",
			7.97
		],
		[
			"2010-07-27",
			6.2
		],
		[
			"2011-09-27",
			6.64
		],
		[
			"2012-07-31",
			7.53
		]
	],
	"59620262": [
		[
			"2000-06-07",
			9.3
		],
		[
			"2001-05-17",
			10.63
		],
		[
			"2002-05-16",
			11.51
		],
		[
			"2003-05-13",
			11.07
		],
		[
			"2004-03-12",
			11.07
		],
		[
			"2005-08-30",
			11.96
		],
		[
			"2006-03-28",
			7.97
		],
		[
			"2006-08-15",
			11.07
		],
		[
			"2007-06-04",
			8.86
		],
		[
			"2008-07-22",
			7.53
		],
		[
			"2013-08-28",
			7.79
		],
		[
			"2015-04-08",
			4.74
		],
		[
			"2009-11-26",
			7.09
		]
	],
	"59620274": [
		[
			"2001-11-09",
			34.99
		],
		[
			"2002-07-22",
			36.76
		],
		[
			"2003-10-13",
			36.31
		],
		[
			"2004-07-13",
			38.53
		],
		[
			"2004-10-20",
			37.64
		],
		[
			"2005-02-11",
			40.3
		],
		[
			"2005-07-11",
			38.97
		],
		[
			"2006-03-31",
			40.74
		],
		[
			"2006-10-17",
			38.53
		],
		[
			"2007-09-12",
			39.41
		],
		[
			"2008-04-09",
			42.51
		],
		[
			"2013-09-05",
			34.23
		],
		[
			"2014-11-20",
			34.94
		],
		[
			"2015-10-05",
			33.04
		],
		[
			"2009-06-23",
			39.41
		],
		[
			"2010-04-26",
			38.53
		],
		[
			"2011-09-02",
			32.33
		]
	],
	"59620754": [
		[
			"2000-06-07",
			20.37
		],
		[
			"2001-05-17",
			25.69
		],
		[
			"2002-05-16",
			26.13
		],
		[
			"2003-12-17",
			15.06
		],
		[
			"2004-02-20",
			31.44
		],
		[
			"2005-05-31",
			25.69
		],
		[
			"2006-03-28",
			18.16
		],
		[
			"2006-09-04",
			21.7
		],
		[
			"2007-07-19",
			20.37
		],
		[
			"2007-09-25",
			26.57
		],
		[
			"2008-06-25",
			25.69
		],
		[
			"2013-07-11",
			18.29
		],
		[
			"2014-03-12",
			24.4
		],
		[
			"2015-09-30",
			13.15
		],
		[
			"2009-07-07",
			20.37
		],
		[
			"2010-05-06",
			23.03
		],
		[
			"2011-04-29",
			21.7
		],
		[
			"2012-07-24",
			17.71
		]
	],
	"59620821": [
		[
			"2000-05-29",
			6.64
		],
		[
			"2001-05-10",
			7.09
		],
		[
			"2002-06-10",
			8.86
		],
		[
			"2003-05-07",
			7.97
		],
		[
			"2004-02-16",
			7.53
		],
		[
			"2005-02-22",
			7.53
		],
		[
			"2006-02-07",
			7.53
		],
		[
			"2006-08-14",
			7.97
		],
		[
			"2007-07-26",
			7.53
		],
		[
			"2008-02-29",
			6.64
		],
		[
			"2013-06-25",
			8.81
		],
		[
			"2014-03-12",
			8.99
		],
		[
			"2015-03-16",
			8.02
		],
		[
			"2009-08-18",
			6.64
		],
		[
			"2010-05-12",
			7.97
		],
		[
			"2011-04-29",
			10.19
		],
		[
			"2012-07-23",
			8.86
		]
	],
	"59620869": [
		[
			"2000-02-25",
			11
		],
		[
			"2000-10-05",
			15.01
		],
		[
			"2011-03-22",
			18.31
		],
		[
			"2006-09-13",
			18.79
		],
		[
			"2006-11-15",
			21.63
		],
		[
			"2007-03-27",
			19.91
		],
		[
			"2007-10-23",
			18.51
		],
		[
			"2008-03-17",
			21.31
		],
		[
			"2008-10-21",
			22.71
		],
		[
			"2009-02-16",
			23.41
		],
		[
			"2009-10-19",
			23.11
		],
		[
			"2010-03-15",
			21.81
		],
		[
			"2010-10-18",
			19.71
		],
		[
			"2011-10-18",
			14.41
		],
		[
			"2012-02-21",
			17.61
		],
		[
			"2012-11-06",
			16.61
		],
		[
			"2013-02-19",
			16.41
		],
		[
			"2013-11-05",
			18.21
		],
		[
			"2014-11-04",
			15.71
		],
		[
			"2015-02-03",
			11.5
		]
	],
	"59620870": [
		[
			"2000-10-05",
			18.01
		],
		[
			"2000-02-25",
			16.01
		],
		[
			"2011-02-08",
			17.01
		],
		[
			"2006-09-07",
			17.51
		],
		[
			"2006-11-07",
			16.25
		],
		[
			"2007-03-20",
			17.61
		],
		[
			"2007-10-16",
			17.91
		],
		[
			"2008-02-25",
			18.51
		],
		[
			"2008-10-20",
			16.41
		],
		[
			"2009-02-03",
			18.11
		],
		[
			"2009-10-06",
			16.71
		],
		[
			"2010-02-16",
			18.21
		],
		[
			"2010-10-05",
			17.01
		],
		[
			"2011-10-04",
			16.01
		],
		[
			"2012-02-07",
			16.21
		],
		[
			"2012-11-20",
			15.01
		],
		[
			"2013-02-05",
			12.8
		],
		[
			"2013-11-18",
			14.31
		],
		[
			"2014-11-03",
			14
		],
		[
			"2015-02-02",
			15.01
		]
	],
	"59620936": [
		[
			"2001-05-17",
			4.87
		],
		[
			"2002-05-16",
			6.2
		],
		[
			"2003-12-10",
			10.63
		],
		[
			"2004-02-20",
			13.29
		],
		[
			"2005-03-14",
			15.5
		],
		[
			"2006-02-28",
			18.6
		],
		[
			"2007-04-05",
			19.49
		],
		[
			"2008-04-18",
			20.81
		],
		[
			"2013-11-05",
			11.38
		],
		[
			"2014-03-12",
			10.98
		],
		[
			"2015-03-16",
			11.25
		],
		[
			"2009-08-18",
			17.27
		],
		[
			"2010-07-29",
			7.53
		],
		[
			"2011-09-09",
			11.07
		],
		[
			"2012-07-24",
			8.41
		]
	],
	"59620950": [
		[
			"2000-05-02",
			3.54
		],
		[
			"2001-09-24",
			2.21
		],
		[
			"2002-08-30",
			2.21
		],
		[
			"2003-05-07",
			2.21
		],
		[
			"2004-08-25",
			2.21
		],
		[
			"2005-03-31",
			2.21
		],
		[
			"2006-03-16",
			2.21
		],
		[
			"2007-07-17",
			2.21
		],
		[
			"2008-05-09",
			2.21
		],
		[
			"2013-06-05",
			3.4
		],
		[
			"2014-07-22",
			4.43
		],
		[
			"2015-09-07",
			3.18
		],
		[
			"2009-07-06",
			4.43
		],
		[
			"2010-07-15",
			4.43
		],
		[
			"2011-09-27",
			4.43
		]
	],
	"59620985": [
		[
			"2000-12-06",
			10.19
		],
		[
			"2001-06-06",
			10.63
		],
		[
			"2002-04-29",
			9.74
		],
		[
			"2004-09-23",
			11.96
		],
		[
			"2005-04-15",
			10.63
		],
		[
			"2006-10-16",
			12.84
		],
		[
			"2007-08-30",
			9.74
		],
		[
			"2008-05-20",
			7.97
		],
		[
			"2013-06-05",
			10.32
		],
		[
			"2015-09-07",
			8.77
		],
		[
			"2009-07-06",
			11.96
		],
		[
			"2010-07-15",
			11.07
		],
		[
			"2011-08-24",
			13.73
		]
	],
	"59620997": [
		[
			"2000-11-27",
			8.41
		],
		[
			"2001-11-19",
			7.09
		],
		[
			"2002-06-26",
			8.41
		],
		[
			"2004-08-19",
			8.41
		],
		[
			"2005-04-15",
			10.19
		],
		[
			"2006-04-11",
			9.3
		],
		[
			"2006-08-16",
			9.3
		],
		[
			"2007-05-29",
			10.63
		],
		[
			"2008-03-17",
			11.51
		],
		[
			"2013-09-23",
			10.36
		],
		[
			"2014-11-25",
			8.02
		],
		[
			"2015-08-19",
			10.5
		],
		[
			"2009-07-21",
			10.63
		],
		[
			"2010-05-12",
			10.63
		],
		[
			"2011-08-24",
			11.07
		]
	],
	"59621072": [
		[
			"2001-08-31",
			23.47
		],
		[
			"2002-06-28",
			20.37
		],
		[
			"2003-10-15",
			23.91
		],
		[
			"2004-07-12",
			21.7
		],
		[
			"2004-10-25",
			23.47
		],
		[
			"2005-02-15",
			11.96
		],
		[
			"2005-07-11",
			21.7
		],
		[
			"2006-04-06",
			15.5
		],
		[
			"2006-09-26",
			21.26
		],
		[
			"2007-07-05",
			22.59
		],
		[
			"2008-05-21",
			21.7
		],
		[
			"2015-09-08",
			25.33
		]
	],
	"59621151": [
		[
			"2000-10-30",
			8.86
		],
		[
			"2001-09-10",
			34.1
		],
		[
			"2002-07-10",
			32.77
		],
		[
			"2004-09-30",
			32.33
		],
		[
			"2004-11-26",
			33.21
		],
		[
			"2005-03-23",
			31
		],
		[
			"2005-08-29",
			30.56
		],
		[
			"2006-03-13",
			33.21
		],
		[
			"2006-10-12",
			34.1
		],
		[
			"2007-09-17",
			31.89
		],
		[
			"2008-04-30",
			29.23
		],
		[
			"2013-09-05",
			18.47
		],
		[
			"2014-12-02",
			31.18
		],
		[
			"2015-10-07",
			30.29
		],
		[
			"2009-07-07",
			31.89
		],
		[
			"2010-05-06",
			29.23
		],
		[
			"2011-08-22",
			31.89
		]
	],
	"59621175": [
		[
			"2000-07-05",
			2.21
		],
		[
			"2001-09-05",
			2.21
		],
		[
			"2002-07-02",
			2.21
		],
		[
			"2003-07-25",
			2.66
		],
		[
			"2004-07-26",
			2.21
		],
		[
			"2004-10-27",
			2.21
		],
		[
			"2005-03-23",
			8.41
		],
		[
			"2005-08-03",
			2.21
		],
		[
			"2006-04-12",
			7.53
		],
		[
			"2007-09-13",
			5.76
		],
		[
			"2008-05-21",
			2.66
		],
		[
			"2014-11-10",
			1.33
		],
		[
			"2015-04-08",
			1.9
		],
		[
			"2009-06-25",
			4.87
		],
		[
			"2010-07-29",
			4.43
		],
		[
			"2011-08-22",
			4.43
		],
		[
			"2012-08-15",
			1.33
		]
	],
	"59621187": [
		[
			"2004-10-09",
			2.21
		],
		[
			"2006-12-08",
			2.21
		],
		[
			"2005-10-29",
			2.21
		],
		[
			"2008-07-16",
			5.31
		],
		[
			"2014-11-24",
			2.32
		],
		[
			"2015-10-06",
			3.08
		],
		[
			"2009-11-30",
			4.87
		],
		[
			"2010-07-22",
			4.43
		],
		[
			"2011-12-28",
			2.21
		],
		[
			"2012-08-15",
			2.66
		]
	],
	"59621199": [
		[
			"2004-10-09",
			7.09
		],
		[
			"2006-12-08",
			9.74
		],
		[
			"2005-10-29",
			8.86
		],
		[
			"2015-10-06",
			5.05
		]
	],
	"59621230": [
		[
			"2000-08-07",
			5.76
		],
		[
			"2001-08-09",
			7.97
		],
		[
			"2002-04-19",
			11.07
		],
		[
			"2003-05-21",
			11.07
		],
		[
			"2004-07-14",
			16.83
		],
		[
			"2004-10-09",
			3.99
		],
		[
			"2005-02-15",
			21.7
		],
		[
			"2005-07-28",
			17.71
		],
		[
			"2006-03-17",
			17.27
		],
		[
			"2006-10-12",
			11.07
		],
		[
			"2007-05-07",
			19.49
		],
		[
			"2008-04-14",
			23.47
		],
		[
			"2014-11-03",
			4.96
		],
		[
			"2015-09-09",
			2.43
		],
		[
			"2009-06-23",
			19.04
		],
		[
			"2010-04-26",
			29.23
		],
		[
			"2011-08-25",
			8.86
		]
	],
	"59621278": [
		[
			"2004-03-31",
			2.21
		],
		[
			"2005-07-01",
			2.21
		],
		[
			"2006-10-24",
			2.21
		],
		[
			"2007-09-18",
			2.21
		],
		[
			"2008-07-16",
			2.21
		],
		[
			"2013-09-23",
			1.33
		],
		[
			"2015-10-27",
			1.33
		],
		[
			"2000-12-08",
			2.21
		],
		[
			"2001-05-29",
			2.21
		],
		[
			"2002-06-11",
			2.21
		],
		[
			"2003-10-09",
			2.21
		],
		[
			"2009-09-23",
			4.43
		]
	],
	"59621280": [
		[
			"2001-09-14",
			8.86
		],
		[
			"2002-09-17",
			9.3
		],
		[
			"2003-05-27",
			8.86
		],
		[
			"2004-07-16",
			10.63
		],
		[
			"2004-10-22",
			8.41
		],
		[
			"2005-02-21",
			9.3
		],
		[
			"2005-08-09",
			11.51
		],
		[
			"2006-02-09",
			8.86
		],
		[
			"2006-09-22",
			8.41
		],
		[
			"2007-05-14",
			9.3
		],
		[
			"2008-03-12",
			8.41
		],
		[
			"2013-09-02",
			12.75
		],
		[
			"2014-12-16",
			17.8
		],
		[
			"2015-10-14",
			15.41
		],
		[
			"2009-06-24",
			10.63
		],
		[
			"2010-05-07",
			7.97
		],
		[
			"2011-09-05",
			9.74
		]
	],
	"59621291": [
		[
			"2001-10-22",
			36.76
		],
		[
			"2004-09-27",
			34.1
		],
		[
			"2004-11-19",
			35.43
		],
		[
			"2005-03-18",
			29.23
		],
		[
			"2005-05-30",
			29.23
		],
		[
			"2006-04-11",
			27.46
		],
		[
			"2006-08-14",
			31.44
		],
		[
			"2007-11-21",
			26.13
		],
		[
			"2008-04-18",
			27.46
		],
		[
			"2014-10-29",
			26.75
		],
		[
			"2015-08-31",
			24.93
		],
		[
			"2002-09-03",
			34.99
		],
		[
			"2003-07-16",
			36.31
		],
		[
			"2009-06-25",
			31.44
		],
		[
			"2010-04-30",
			26.57
		],
		[
			"2011-07-25",
			30.56
		]
	],
	"59621321": [
		[
			"2001-11-05",
			18.6
		],
		[
			"2002-04-19",
			19.93
		],
		[
			"2003-05-21",
			19.49
		],
		[
			"2004-07-14",
			19.49
		],
		[
			"2005-03-18",
			19.93
		],
		[
			"2006-04-28",
			19.49
		],
		[
			"2007-04-26",
			19.04
		],
		[
			"2008-04-15",
			20.37
		],
		[
			"2015-09-30",
			14.35
		]
	],
	"59621620": [
		[
			"2004-10-04",
			44.73
		],
		[
			"2004-11-23",
			44.73
		],
		[
			"2005-06-09",
			49.16
		],
		[
			"2005-09-06",
			43.4
		],
		[
			"2006-04-06",
			48.27
		],
		[
			"2006-10-18",
			40.3
		],
		[
			"2007-05-16",
			45.17
		],
		[
			"2008-06-16",
			44.29
		],
		[
			"2013-09-02",
			35.07
		],
		[
			"2014-11-18",
			33.92
		],
		[
			"2015-09-29",
			34.19
		],
		[
			"2009-08-03",
			43.84
		],
		[
			"2010-06-25",
			41.63
		],
		[
			"2011-08-25",
			40.3
		]
	],
	"60070109": [
		[
			"2000-05-04",
			115.14
		],
		[
			"2000-09-07",
			109.39
		],
		[
			"2001-08-06",
			103.63
		],
		[
			"2001-10-22",
			96.99
		],
		[
			"2002-09-17",
			47.83
		],
		[
			"2002-04-10",
			68.2
		],
		[
			"2003-05-21",
			90.34
		],
		[
			"2004-05-07",
			103.63
		],
		[
			"2004-06-07",
			101.86
		],
		[
			"2005-06-07",
			104.96
		],
		[
			"2005-10-24",
			94.77
		],
		[
			"2006-08-28",
			108.94
		],
		[
			"2006-09-25",
			102.3
		],
		[
			"2007-03-30",
			103.63
		],
		[
			"2007-06-15",
			103.63
		],
		[
			"2008-07-28",
			112.04
		],
		[
			"2013-06-07",
			85.91
		],
		[
			"2014-08-12",
			108.06
		],
		[
			"2015-12-17",
			111.16
		],
		[
			"2003-09-30",
			112.49
		],
		[
			"2009-05-15",
			96.54
		],
		[
			"2010-05-12",
			107.17
		],
		[
			"2011-05-05",
			101.86
		]
	],
	"60070298": [
		[
			"2000-04-03",
			4.43
		],
		[
			"2000-08-28",
			4.43
		],
		[
			"2001-07-02",
			4.43
		],
		[
			"2003-04-28",
			4.43
		],
		[
			"2004-07-13",
			4.43
		],
		[
			"2005-05-30",
			4.43
		],
		[
			"2006-09-07",
			4.43
		],
		[
			"2007-04-23",
			4.43
		],
		[
			"2008-04-21",
			4.43
		],
		[
			"2013-11-08",
			1.62
		],
		[
			"2014-07-21",
			1.33
		],
		[
			"2015-08-28",
			1.33
		],
		[
			"2002-05-23",
			4.43
		],
		[
			"2009-05-18",
			4.43
		],
		[
			"2010-05-03",
			4.43
		],
		[
			"2011-05-05",
			4.43
		]
	],
	"60070602": [
		[
			"2013-11-21",
			31.62
		],
		[
			"2014-08-29",
			29.89
		],
		[
			"2015-11-20",
			34.06
		]
	],
	"60071606": [
		[
			"2006-07-04",
			15.94
		],
		[
			"2007-05-29",
			16.39
		],
		[
			"2008-10-07",
			12.4
		],
		[
			"2013-06-07",
			22.94
		],
		[
			"2014-10-22",
			18.69
		],
		[
			"2015-12-07",
			18.95
		],
		[
			"2009-06-24",
			12.84
		],
		[
			"2010-06-21",
			11.96
		],
		[
			"2011-05-05",
			17.71
		]
	],
	"60080139": [
		[
			"2000-03-28",
			4.43
		],
		[
			"2000-08-30",
			4.43
		],
		[
			"2001-03-28",
			4.43
		],
		[
			"2001-10-04",
			4.43
		],
		[
			"2002-05-22",
			4.43
		],
		[
			"2003-06-24",
			4.43
		],
		[
			"2004-04-26",
			4.43
		],
		[
			"2005-08-31",
			4.43
		],
		[
			"2006-05-15",
			4.43
		],
		[
			"2007-05-09",
			4.43
		],
		[
			"2008-04-21",
			4.43
		],
		[
			"2013-10-07",
			1.33
		],
		[
			"2013-10-17",
			1.33
		],
		[
			"2014-09-05",
			1.62
		],
		[
			"2015-04-22",
			1.33
		],
		[
			"2009-05-18",
			4.43
		],
		[
			"2010-05-04",
			4.43
		],
		[
			"2011-04-07",
			4.43
		]
	],
	"60080280": [
		[
			"2000-03-31",
			11.51
		],
		[
			"2000-08-03",
			10.19
		],
		[
			"2001-03-30",
			15.06
		],
		[
			"2002-05-23",
			9.74
		],
		[
			"2003-06-03",
			13.29
		],
		[
			"2004-04-27",
			11.07
		],
		[
			"2005-08-31",
			5.31
		],
		[
			"2006-09-05",
			7.53
		],
		[
			"2007-06-15",
			5.76
		],
		[
			"2008-06-09",
			7.53
		],
		[
			"2013-12-12",
			5.23
		],
		[
			"2014-07-28",
			2.71
		],
		[
			"2015-10-28",
			1.71
		],
		[
			"2009-10-19",
			4.43
		],
		[
			"2010-05-04",
			10.19
		],
		[
			"2011-05-13",
			6.2
		]
	],
	"60081429": [
		[
			"2000-05-09",
			22.59
		],
		[
			"2000-08-29",
			40.3
		],
		[
			"2001-05-21",
			37.2
		],
		[
			"2002-04-05",
			30.56
		],
		[
			"2003-06-04",
			33.66
		],
		[
			"2004-06-21",
			30.56
		],
		[
			"2004-10-07",
			33.21
		],
		[
			"2005-10-10",
			32.33
		],
		[
			"2006-05-08",
			31
		],
		[
			"2007-02-20",
			29.67
		],
		[
			"2008-04-04",
			30.11
		],
		[
			"2015-12-03",
			27.15
		]
	],
	"60081430": [
		[
			"2000-05-09",
			14.17
		],
		[
			"2000-08-29",
			11.51
		],
		[
			"2001-04-24",
			8.86
		],
		[
			"2002-04-05",
			6.2
		],
		[
			"2003-06-24",
			11.96
		],
		[
			"2004-05-12",
			11.96
		],
		[
			"2005-10-10",
			21.26
		],
		[
			"2006-10-24",
			26.57
		],
		[
			"2006-08-31",
			26.13
		],
		[
			"2006-10-10",
			24.36
		],
		[
			"2007-06-22",
			20.37
		],
		[
			"2008-04-16",
			15.5
		],
		[
			"2013-06-05",
			16.65
		],
		[
			"2014-09-02",
			22.14
		],
		[
			"2015-04-28",
			19.44
		],
		[
			"2009-05-11",
			15.06
		],
		[
			"2010-06-28",
			13.29
		],
		[
			"2011-05-13",
			11.96
		]
	],
	"60082800": [
		[
			"2006-10-18",
			82.81
		],
		[
			"2007-09-11",
			78.39
		],
		[
			"2008-04-22",
			72.63
		],
		[
			"2014-07-24",
			79.27
		],
		[
			"2015-10-28",
			77.5
		],
		[
			"2009-11-30",
			65.54
		],
		[
			"2010-05-12",
			73.51
		],
		[
			"2011-05-06",
			75.73
		]
	],
	"60090248": [
		[
			"2000-05-18",
			8.86
		],
		[
			"2000-09-06",
			7.09
		],
		[
			"2001-04-30",
			10.19
		],
		[
			"2001-11-29",
			7.53
		],
		[
			"2002-08-20",
			4.87
		],
		[
			"2003-06-03",
			5.31
		],
		[
			"2004-05-03",
			7.09
		],
		[
			"2005-09-13",
			5.31
		],
		[
			"2007-10-24",
			7.53
		],
		[
			"2008-06-18",
			4.87
		],
		[
			"2014-07-23",
			8.99
		],
		[
			"2015-11-06",
			8.33
		],
		[
			"2009-07-01",
			8.41
		]
	],
	"60090340": [
		[
			"2000-03-29",
			39.86
		],
		[
			"2000-07-31",
			31.89
		],
		[
			"2001-04-26",
			52.26
		],
		[
			"2003-04-02",
			49.16
		],
		[
			"2004-05-17",
			42.07
		],
		[
			"2005-04-08",
			45.17
		],
		[
			"2006-04-12",
			35.87
		],
		[
			"2007-10-17",
			24.8
		],
		[
			"2008-06-03",
			29.67
		],
		[
			"2013-12-04",
			10.23
		],
		[
			"2014-07-23",
			10.27
		],
		[
			"2015-11-03",
			9.83
		],
		[
			"2002-04-24",
			44.73
		],
		[
			"2010-06-15",
			16.39
		],
		[
			"2011-06-15",
			12.4
		]
	],
	"60091101": [
		[
			"2000-05-18",
			7.97
		],
		[
			"2000-08-31",
			17.71
		],
		[
			"2001-05-29",
			7.97
		],
		[
			"2001-11-12",
			26.57
		],
		[
			"2002-04-24",
			19.04
		],
		[
			"2002-05-06",
			19.04
		],
		[
			"2004-05-03",
			25.24
		],
		[
			"2005-08-31",
			49.16
		],
		[
			"2006-07-06",
			25.24
		],
		[
			"2007-10-23",
			35.87
		],
		[
			"2008-07-29",
			36.31
		],
		[
			"2013-11-28",
			7.26
		],
		[
			"2014-07-22",
			11.69
		],
		[
			"2015-11-05",
			4.92
		],
		[
			"2009-06-23",
			28.79
		],
		[
			"2011-06-14",
			8.41
		]
	],
	"60092233": [
		[
			"2000-04-04",
			46.94
		],
		[
			"2000-08-08",
			25.69
		],
		[
			"2001-05-22",
			48.71
		],
		[
			"2001-11-21",
			29.67
		],
		[
			"2002-04-04",
			30.56
		],
		[
			"2002-07-15",
			40.74
		],
		[
			"2003-04-22",
			46.06
		],
		[
			"2004-04-21",
			48.71
		],
		[
			"2005-07-05",
			32.77
		],
		[
			"2005-08-22",
			39.41
		],
		[
			"2006-08-28",
			54.47
		],
		[
			"2006-09-25",
			49.6
		],
		[
			"2007-02-12",
			43.4
		],
		[
			"2007-11-26",
			52.7
		],
		[
			"2008-07-28",
			56.69
		],
		[
			"2013-06-06",
			43.09
		],
		[
			"2014-10-01",
			20.06
		],
		[
			"2015-12-01",
			20.33
		],
		[
			"2009-06-26",
			47.83
		],
		[
			"2010-08-02",
			54.47
		],
		[
			"2011-05-06",
			59.79
		]
	],
	"60100308": [
		[
			"2006-08-15",
			4.43
		],
		[
			"2007-10-17",
			4.43
		],
		[
			"2008-07-29",
			4.43
		],
		[
			"2013-10-30",
			1.33
		],
		[
			"2014-07-22",
			1.33
		],
		[
			"2015-11-19",
			1.33
		],
		[
			"2009-07-01",
			4.43
		],
		[
			"2010-06-17",
			4.43
		],
		[
			"2011-06-15",
			4.43
		]
	],
	"60100904": [
		[
			"2013-10-30",
			1.33
		],
		[
			"2014-07-22",
			1.33
		],
		[
			"2015-11-30",
			1.33
		],
		[
			"2009-11-23",
			4.43
		],
		[
			"2010-06-17",
			4.43
		]
	],
	"60102123": [
		[
			"2000-03-29",
			4.43
		],
		[
			"2000-07-31",
			4.43
		],
		[
			"2001-03-29",
			4.43
		],
		[
			"2002-04-11",
			5.76
		],
		[
			"2003-04-02",
			6.2
		],
		[
			"2004-05-17",
			5.76
		],
		[
			"2005-04-08",
			4.43
		],
		[
			"2006-09-07",
			4.43
		],
		[
			"2007-10-17",
			4.43
		],
		[
			"2008-07-01",
			4.43
		],
		[
			"2014-07-28",
			1.33
		],
		[
			"2015-11-24",
			6.86
		],
		[
			"2009-05-20",
			4.43
		],
		[
			"2010-06-15",
			4.43
		],
		[
			"2011-06-14",
			4.43
		]
	],
	"60102135": [
		[
			"2000-03-29",
			15.5
		],
		[
			"2000-07-31",
			9.74
		],
		[
			"2000-08-31",
			8.86
		],
		[
			"2001-04-26",
			6.64
		],
		[
			"2003-04-02",
			12.4
		],
		[
			"2004-05-17",
			9.3
		],
		[
			"2005-04-08",
			6.2
		],
		[
			"2006-09-07",
			4.43
		],
		[
			"2007-09-11",
			12.4
		],
		[
			"2008-07-01",
			4.43
		],
		[
			"2014-07-28",
			3.1
		],
		[
			"2015-11-25",
			2.93
		],
		[
			"2002-04-24",
			12.4
		],
		[
			"2009-05-20",
			5.76
		],
		[
			"2010-06-15",
			4.43
		],
		[
			"2011-06-14",
			4.43
		]
	],
	"60220028": [
		[
			"2000-05-03",
			153.67
		],
		[
			"2000-09-25",
			157.21
		],
		[
			"2001-07-30",
			188.66
		],
		[
			"2001-10-23",
			173.16
		],
		[
			"2002-07-24",
			206.37
		],
		[
			"2002-09-18",
			213.46
		],
		[
			"2003-03-31",
			216.56
		],
		[
			"2003-09-29",
			229.4
		],
		[
			"2004-04-16",
			216.56
		],
		[
			"2004-07-13",
			233.39
		],
		[
			"2004-06-09",
			221.43
		],
		[
			"2004-08-26",
			235.16
		],
		[
			"2005-04-01",
			221.43
		],
		[
			"2005-06-06",
			220.99
		],
		[
			"2005-08-16",
			204.6
		],
		[
			"2005-10-24",
			197.51
		],
		[
			"2006-06-19",
			183.79
		],
		[
			"2006-08-29",
			191.76
		],
		[
			"2007-05-11",
			177.14
		],
		[
			"2007-11-29",
			178.91
		],
		[
			"2008-04-08",
			195.3
		],
		[
			"2013-07-17",
			59.34
		],
		[
			"2014-10-07",
			71.3
		],
		[
			"2014-10-23",
			70.86
		],
		[
			"2015-01-30",
			77.94
		],
		[
			"2009-05-14",
			228.07
		],
		[
			"2009-11-09",
			245.34
		],
		[
			"2010-07-01",
			109.39
		],
		[
			"2012-08-17",
			51.37
		]
	],
	"60220478": [
		[
			"2000-05-30",
			4.43
		],
		[
			"2000-10-04",
			4.43
		],
		[
			"2001-06-19",
			4.43
		],
		[
			"2001-10-25",
			4.43
		],
		[
			"2002-06-19",
			4.43
		],
		[
			"2003-06-12",
			4.43
		],
		[
			"2004-05-07",
			4.43
		],
		[
			"2005-08-22",
			4.43
		],
		[
			"2006-05-22",
			4.43
		],
		[
			"2007-06-01",
			4.43
		],
		[
			"2008-05-08",
			4.43
		],
		[
			"2013-07-18",
			1.33
		],
		[
			"2014-10-01",
			3.37
		],
		[
			"2015-12-17",
			7.09
		],
		[
			"2009-07-02",
			4.43
		],
		[
			"2010-08-03",
			4.43
		],
		[
			"2012-08-20",
			1.33
		]
	],
	"60220697": [
		[
			"2000-06-07",
			42.96
		],
		[
			"2000-10-04",
			53.14
		],
		[
			"2001-06-19",
			33.66
		],
		[
			"2001-11-26",
			56.69
		],
		[
			"2002-08-08",
			44.29
		],
		[
			"2002-09-11",
			50.93
		],
		[
			"2002-06-19",
			28.34
		],
		[
			"2003-04-29",
			34.1
		],
		[
			"2004-04-20",
			34.54
		],
		[
			"2005-03-17",
			41.19
		],
		[
			"2006-09-28",
			39.41
		],
		[
			"2007-06-29",
			39.86
		],
		[
			"2007-06-01",
			42.51
		],
		[
			"2008-06-02",
			33.66
		],
		[
			"2013-12-04",
			27.37
		],
		[
			"2014-09-16",
			29.32
		],
		[
			"2015-11-25",
			34.99
		],
		[
			"2009-05-14",
			36.76
		],
		[
			"2010-06-30",
			22.14
		]
	],
	"60220867": [
		[
			"2000-05-15",
			8.41
		],
		[
			"2000-09-20",
			5.76
		],
		[
			"2001-06-11",
			8.86
		],
		[
			"2001-10-29",
			16.39
		],
		[
			"2002-07-24",
			28.79
		],
		[
			"2003-06-17",
			82.81
		],
		[
			"2004-04-16",
			51.81
		],
		[
			"2005-08-11",
			54.91
		],
		[
			"2006-06-19",
			76.17
		],
		[
			"2007-05-16",
			88.13
		],
		[
			"2008-04-03",
			115.14
		],
		[
			"2013-07-18",
			135.07
		],
		[
			"2014-09-30",
			152.79
		],
		[
			"2015-09-24",
			95.66
		],
		[
			"2009-10-15",
			129.31
		],
		[
			"2010-05-14",
			139.06
		],
		[
			"2012-08-17",
			169.17
		]
	],
	"60230058": [
		[
			"2000-05-30",
			67.31
		],
		[
			"2000-10-10",
			36.76
		],
		[
			"2001-05-15",
			104.07
		],
		[
			"2001-10-29",
			34.1
		],
		[
			"2002-07-22",
			27.46
		],
		[
			"2002-04-10",
			62.44
		],
		[
			"2003-04-09",
			37.64
		],
		[
			"2004-04-15",
			30.11
		],
		[
			"2005-03-23",
			45.61
		],
		[
			"2006-08-30",
			31.44
		],
		[
			"2007-05-16",
			23.91
		],
		[
			"2008-03-19",
			48.71
		],
		[
			"2013-08-02",
			93
		],
		[
			"2014-08-25",
			27.46
		],
		[
			"2014-10-22",
			38.09
		],
		[
			"2015-01-29",
			36.62
		],
		[
			"2009-06-25",
			51.81
		],
		[
			"2010-06-08",
			60.67
		],
		[
			"2011-06-01",
			12.4
		],
		[
			"2012-08-20",
			93.89
		]
	],
	"60230113": [
		[
			"2006-07-03",
			114.26
		],
		[
			"2007-04-25",
			117.36
		],
		[
			"2008-06-30",
			104.07
		],
		[
			"2013-11-13",
			151.46
		],
		[
			"2014-07-25",
			142.6
		],
		[
			"2015-06-22",
			147.03
		],
		[
			"2009-05-12",
			138.17
		],
		[
			"2010-06-22",
			127.99
		],
		[
			"2011-05-04",
			128.87
		]
	],
	"60230265": [
		[
			"2000-05-03",
			108.94
		],
		[
			"2000-10-10",
			69.53
		],
		[
			"2001-08-01",
			96.99
		],
		[
			"2001-10-24",
			80.6
		],
		[
			"2002-04-10",
			47.83
		],
		[
			"2003-04-09",
			56.69
		],
		[
			"2004-04-15",
			71.74
		],
		[
			"2004-06-08",
			115.14
		],
		[
			"2005-03-23",
			62.89
		],
		[
			"2005-06-08",
			83.26
		],
		[
			"2006-10-09",
			35.43
		],
		[
			"2006-08-30",
			43.4
		],
		[
			"2007-05-10",
			80.16
		],
		[
			"2007-11-29",
			42.96
		],
		[
			"2008-03-19",
			79.27
		],
		[
			"2013-07-18",
			139.5
		],
		[
			"2014-09-10",
			63.77
		],
		[
			"2015-12-08",
			29.63
		],
		[
			"2002-09-17",
			73.07
		],
		[
			"2003-09-30",
			43.84
		],
		[
			"2009-06-25",
			175.81
		],
		[
			"2010-06-08",
			175.81
		],
		[
			"2011-05-12",
			171.83
		],
		[
			"2012-08-16",
			113.37
		]
	],
	"60240027": [
		[
			"2006-08-03",
			4.43
		],
		[
			"2007-10-16",
			4.43
		],
		[
			"2008-09-15",
			4.43
		],
		[
			"2013-11-11",
			1.33
		],
		[
			"2014-09-17",
			1.33
		],
		[
			"2015-04-15",
			1.33
		],
		[
			"2009-05-13",
			4.43
		],
		[
			"2010-06-23",
			4.43
		],
		[
			"2011-05-27",
			4.43
		]
	],
	"60240040": [
		[
			"2006-08-03",
			103.19
		],
		[
			"2007-10-16",
			156.77
		],
		[
			"2008-09-15",
			103.63
		],
		[
			"2013-11-11",
			131.09
		],
		[
			"2014-09-17",
			111.6
		],
		[
			"2015-04-15",
			124.89
		],
		[
			"2009-05-13",
			104.07
		],
		[
			"2010-06-23",
			82.37
		],
		[
			"2011-05-27",
			95.66
		]
	],
	"60240052": [
		[
			"2006-07-25",
			4.43
		],
		[
			"2007-10-18",
			4.43
		],
		[
			"2008-09-23",
			4.43
		],
		[
			"2013-10-22",
			1.33
		],
		[
			"2014-10-16",
			1.33
		],
		[
			"2015-06-12",
			1.33
		],
		[
			"2009-07-21",
			4.43
		],
		[
			"2010-06-23",
			4.43
		]
	],
	"60240118": [
		[
			"2006-07-05",
			34.99
		],
		[
			"2007-10-18",
			19.04
		],
		[
			"2008-10-07",
			19.49
		],
		[
			"2013-11-05",
			4.52
		],
		[
			"2014-10-20",
			16.7
		],
		[
			"2015-04-16",
			16.16
		],
		[
			"2009-05-13",
			23.47
		],
		[
			"2010-06-10",
			6.2
		]
	],
	"60240120": [
		[
			"2000-04-26",
			4.43
		],
		[
			"2000-07-28",
			4.43
		],
		[
			"2001-04-02",
			4.43
		],
		[
			"2003-04-15",
			4.43
		],
		[
			"2004-04-14",
			4.43
		],
		[
			"2005-06-02",
			4.43
		],
		[
			"2006-04-06",
			4.43
		],
		[
			"2007-04-04",
			4.43
		],
		[
			"2008-03-11",
			4.43
		],
		[
			"2013-11-07",
			3.73
		],
		[
			"2014-09-01",
			3.76
		],
		[
			"2015-04-16",
			1.6
		],
		[
			"2002-04-02",
			4.43
		],
		[
			"2009-07-30",
			4.43
		],
		[
			"2010-06-10",
			4.43
		],
		[
			"2011-06-03",
			4.43
		]
	],
	"60240131": [
		[
			"2000-04-26",
			4.43
		],
		[
			"2000-07-28",
			4.43
		],
		[
			"2001-04-02",
			4.43
		],
		[
			"2003-08-04",
			4.43
		],
		[
			"2004-04-14",
			4.43
		],
		[
			"2005-04-12",
			4.43
		],
		[
			"2006-04-06",
			4.43
		],
		[
			"2007-04-04",
			4.43
		],
		[
			"2008-03-11",
			4.43
		],
		[
			"2013-11-06",
			1.33
		],
		[
			"2014-10-23",
			1.33
		],
		[
			"2015-05-18",
			1.33
		],
		[
			"2002-04-02",
			4.43
		],
		[
			"2009-07-02",
			4.43
		],
		[
			"2010-06-10",
			4.43
		],
		[
			"2011-06-03",
			4.43
		]
	],
	"60240155": [
		[
			"2004-12-01",
			14.17
		],
		[
			"2005-04-12",
			21.26
		],
		[
			"2005-08-05",
			18.16
		],
		[
			"2006-04-06",
			24.8
		],
		[
			"2006-08-21",
			18.16
		],
		[
			"2007-04-19",
			21.7
		],
		[
			"2007-11-14",
			13.73
		],
		[
			"2008-03-11",
			17.71
		],
		[
			"2014-10-21",
			20.19
		],
		[
			"2015-06-09",
			22.32
		],
		[
			"2009-07-02",
			4.43
		],
		[
			"2010-06-10",
			26.13
		],
		[
			"2011-06-03",
			10.19
		]
	],
	"60240246": [
		[
			"2000-05-02",
			6.2
		],
		[
			"2000-09-18",
			4.43
		],
		[
			"2001-08-06",
			4.43
		],
		[
			"2001-10-22",
			4.43
		],
		[
			"2002-07-24",
			4.43
		],
		[
			"2002-09-18",
			4.43
		],
		[
			"2003-03-31",
			8.86
		],
		[
			"2004-07-23",
			4.43
		],
		[
			"2004-06-07",
			4.43
		],
		[
			"2005-06-02",
			8.41
		],
		[
			"2005-08-30",
			4.43
		],
		[
			"2006-05-11",
			4.43
		],
		[
			"2006-09-11",
			4.43
		],
		[
			"2007-04-27",
			4.43
		],
		[
			"2007-11-14",
			4.87
		],
		[
			"2008-04-01",
			9.3
		],
		[
			"2008-05-06",
			4.87
		],
		[
			"2013-11-14",
			6.95
		],
		[
			"2014-10-13",
			1.33
		],
		[
			"2015-06-18",
			1.33
		],
		[
			"2003-09-30",
			4.43
		],
		[
			"2009-06-22",
			4.43
		],
		[
			"2010-07-05",
			4.43
		],
		[
			"2011-05-27",
			4.43
		]
	],
	"60240260": [
		[
			"2000-04-10",
			4.43
		],
		[
			"2000-09-18",
			4.43
		],
		[
			"2001-06-11",
			4.43
		],
		[
			"2002-07-18",
			4.43
		],
		[
			"2003-05-26",
			4.43
		],
		[
			"2004-04-16",
			4.43
		],
		[
			"2005-04-01",
			4.43
		],
		[
			"2006-09-11",
			4.43
		],
		[
			"2007-05-16",
			4.43
		],
		[
			"2008-04-03",
			4.43
		],
		[
			"2013-07-16",
			1.33
		],
		[
			"2014-10-08",
			1.33
		],
		[
			"2015-04-21",
			1.33
		],
		[
			"2009-10-15",
			4.43
		],
		[
			"2010-08-03",
			4.43
		],
		[
			"2011-06-01",
			4.43
		]
	],
	"60240295": [
		[
			"2000-05-03",
			60.67
		],
		[
			"2000-09-15",
			32.77
		],
		[
			"2001-07-30",
			46.06
		],
		[
			"2001-10-23",
			4.43
		],
		[
			"2002-07-24",
			69.09
		],
		[
			"2002-09-18",
			40.3
		],
		[
			"2003-03-31",
			56.24
		],
		[
			"2004-04-16",
			52.26
		],
		[
			"2004-06-09",
			75.29
		],
		[
			"2005-06-06",
			178.47
		],
		[
			"2005-08-30",
			83.7
		],
		[
			"2006-06-19",
			96.1
		],
		[
			"2006-08-29",
			34.1
		],
		[
			"2007-05-11",
			66.43
		],
		[
			"2007-11-29",
			69.97
		],
		[
			"2008-04-08",
			61.11
		],
		[
			"2013-07-17",
			52.7
		],
		[
			"2014-10-07",
			110.71
		],
		[
			"2015-09-16",
			20.11
		],
		[
			"2003-09-29",
			4.43
		],
		[
			"2009-11-09",
			41.19
		],
		[
			"2010-06-30",
			112.93
		],
		[
			"2011-06-01",
			55.36
		],
		[
			"2012-08-14",
			87.24
		]
	],
	"60240313": [
		[
			"2000-05-15",
			4.43
		],
		[
			"2000-09-20",
			4.43
		],
		[
			"2001-07-03",
			13.73
		],
		[
			"2003-05-26",
			19.49
		],
		[
			"2004-04-14",
			15.5
		],
		[
			"2005-06-02",
			4.43
		],
		[
			"2006-05-11",
			4.43
		],
		[
			"2007-04-04",
			16.83
		],
		[
			"2008-03-18",
			4.43
		],
		[
			"2013-10-23",
			1.33
		],
		[
			"2014-09-01",
			1.33
		],
		[
			"2015-04-21",
			1.33
		],
		[
			"2002-04-02",
			11.07
		],
		[
			"2009-07-21",
			4.43
		],
		[
			"2010-07-05",
			4.43
		]
	],
	"60240337": [
		[
			"2000-05-15",
			136.4
		],
		[
			"2000-09-21",
			135.96
		],
		[
			"2001-07-03",
			139.5
		],
		[
			"2001-11-20",
			148.8
		],
		[
			"2002-07-22",
			149.24
		],
		[
			"2002-07-16",
			151.9
		],
		[
			"2003-05-26",
			149.69
		],
		[
			"2004-07-13",
			140.83
		],
		[
			"2004-08-26",
			145.7
		],
		[
			"2005-04-01",
			147.91
		],
		[
			"2006-09-11",
			146.59
		],
		[
			"2007-05-08",
			141.27
		],
		[
			"2008-04-03",
			142.6
		],
		[
			"2013-07-16",
			155.44
		],
		[
			"2014-10-06",
			134.19
		],
		[
			"2015-06-10",
			126.66
		],
		[
			"2009-07-30",
			143.49
		],
		[
			"2010-08-03",
			138.17
		],
		[
			"2011-05-30",
			129.76
		],
		[
			"2012-08-17",
			148.36
		]
	],
	"60240374": [
		[
			"2000-11-10",
			23.47
		],
		[
			"2000-09-18",
			30.11
		],
		[
			"2001-06-11",
			48.71
		],
		[
			"2003-04-15",
			14.61
		],
		[
			"2004-05-12",
			14.17
		],
		[
			"2005-03-18",
			5.31
		],
		[
			"2006-08-21",
			4.43
		],
		[
			"2007-05-08",
			8.41
		],
		[
			"2008-04-08",
			14.61
		],
		[
			"2013-10-23",
			20.86
		],
		[
			"2014-10-08",
			13.11
		],
		[
			"2015-06-09",
			10.27
		],
		[
			"2002-08-20",
			21.26
		],
		[
			"2009-07-02",
			19.04
		],
		[
			"2010-07-07",
			11.96
		]
	],
	"60240386": [
		[
			"2000-04-10",
			8.41
		],
		[
			"2000-09-21",
			4.43
		],
		[
			"2001-04-25",
			4.43
		],
		[
			"2003-04-29",
			4.43
		],
		[
			"2004-04-29",
			4.43
		],
		[
			"2005-03-16",
			24.36
		],
		[
			"2006-05-04",
			23.91
		],
		[
			"2007-04-19",
			26.13
		],
		[
			"2008-03-18",
			27.01
		],
		[
			"2013-10-25",
			23.65
		],
		[
			"2014-10-17",
			26.88
		],
		[
			"2015-09-15",
			28.17
		],
		[
			"2002-04-26",
			4.43
		],
		[
			"2009-10-15",
			10.19
		],
		[
			"2010-07-07",
			25.69
		]
	],
	"60240398": [
		[
			"2000-04-10",
			4.43
		],
		[
			"2000-09-21",
			4.43
		],
		[
			"2001-04-25",
			4.43
		],
		[
			"2001-11-20",
			4.43
		],
		[
			"2002-07-18",
			4.43
		],
		[
			"2002-04-26",
			4.43
		],
		[
			"2003-04-15",
			4.43
		],
		[
			"2004-04-29",
			4.43
		],
		[
			"2004-07-23",
			4.43
		],
		[
			"2005-03-16",
			4.43
		],
		[
			"2006-05-04",
			4.43
		],
		[
			"2007-04-19",
			4.43
		],
		[
			"2008-03-18",
			4.43
		],
		[
			"2013-11-05",
			7.48
		],
		[
			"2014-10-20",
			1.6
		],
		[
			"2015-04-23",
			3.32
		],
		[
			"2009-10-15",
			4.43
		],
		[
			"2010-07-07",
			4.43
		]
	],
	"60240404": [
		[
			"2004-11-24",
			4.43
		],
		[
			"2005-03-14",
			4.43
		],
		[
			"2005-07-29",
			4.43
		],
		[
			"2006-08-17",
			4.43
		],
		[
			"2007-04-27",
			4.43
		],
		[
			"2008-05-06",
			4.43
		],
		[
			"2013-10-24",
			1.33
		],
		[
			"2014-10-10",
			1.33
		],
		[
			"2015-06-15",
			1.33
		],
		[
			"2009-06-22",
			4.43
		],
		[
			"2010-08-03",
			4.43
		],
		[
			"2011-05-30",
			4.43
		]
	],
	"60240416": [
		[
			"2004-11-24",
			4.43
		],
		[
			"2005-03-14",
			4.43
		],
		[
			"2005-07-29",
			4.43
		],
		[
			"2006-08-17",
			4.43
		],
		[
			"2007-04-27",
			4.43
		],
		[
			"2008-04-01",
			4.43
		],
		[
			"2013-10-24",
			1.33
		],
		[
			"2014-10-13",
			1.33
		],
		[
			"2015-06-15",
			1.33
		],
		[
			"2009-06-22",
			4.43
		],
		[
			"2010-07-05",
			4.43
		],
		[
			"2011-05-30",
			4.43
		]
	],
	"60240428": [
		[
			"2004-11-24",
			82.37
		],
		[
			"2005-03-14",
			100.09
		],
		[
			"2005-07-29",
			87.24
		],
		[
			"2006-05-11",
			81.04
		],
		[
			"2007-05-08",
			103.63
		],
		[
			"2008-04-01",
			127.99
		],
		[
			"2013-10-25",
			57.57
		],
		[
			"2014-10-10",
			44.11
		],
		[
			"2015-06-23",
			34.59
		],
		[
			"2009-06-22",
			64.66
		],
		[
			"2010-07-05",
			62
		]
	],
	"60240430": [
		[
			"2015-09-09",
			1.33
		]
	],
	"63111020": [
		[
			"2000-09-11",
			67.02
		],
		[
			"2001-05-02",
			60.02
		],
		[
			"2001-09-26",
			66.02
		],
		[
			"2002-05-13",
			80.03
		],
		[
			"2002-10-23",
			84.43
		],
		[
			"2003-04-28",
			78.03
		],
		[
			"2004-05-12",
			76.23
		],
		[
			"2004-10-04",
			77.83
		],
		[
			"2005-10-04",
			64.42
		],
		[
			"2005-05-11",
			83.33
		],
		[
			"2003-10-08",
			74.93
		],
		[
			"2006-04-10",
			62.12
		],
		[
			"2006-10-04",
			61.92
		],
		[
			"2007-04-11",
			63.02
		],
		[
			"2007-10-15",
			57.02
		],
		[
			"2009-05-18",
			51.72
		],
		[
			"2011-05-09",
			68.82
		],
		[
			"2010-10-04",
			49.62
		],
		[
			"2010-06-09",
			49.62
		],
		[
			"2009-09-21",
			44.02
		],
		[
			"2008-10-13",
			58.62
		],
		[
			"2008-05-05",
			47.82
		],
		[
			"2012-11-06",
			73.33
		],
		[
			"2013-04-23",
			69.92
		],
		[
			"2013-10-16",
			65.62
		],
		[
			"2014-04-07",
			67.22
		],
		[
			"2014-10-08",
			59.22
		],
		[
			"2015-04-21",
			61.52
		],
		[
			"2015-10-28",
			52.42
		]
	],
	"63451025": [
		[
			"2000-10-18",
			1
		],
		[
			"2000-03-14",
			3.6
		],
		[
			"2001-03-06",
			46.72
		],
		[
			"2001-10-09",
			1
		],
		[
			"2002-03-06",
			14.2
		],
		[
			"2002-10-09",
			1.7
		],
		[
			"2002-11-20",
			2.3
		],
		[
			"2003-06-04",
			3.7
		],
		[
			"2003-11-10",
			3.6
		],
		[
			"2004-10-06",
			0.5
		],
		[
			"2005-03-09",
			8.9
		],
		[
			"2006-03-06",
			3.5
		],
		[
			"2005-10-05",
			2.5
		],
		[
			"2006-10-16",
			1
		],
		[
			"2010-11-10",
			1
		],
		[
			"2011-10-31",
			1
		],
		[
			"2011-03-01",
			1
		],
		[
			"2012-04-04",
			1
		],
		[
			"2012-10-29",
			1
		],
		[
			"2014-04-23",
			1
		],
		[
			"2015-10-13",
			1
		],
		[
			"2008-10-06",
			1
		],
		[
			"2010-03-01",
			1
		],
		[
			"2008-03-13",
			1
		],
		[
			"2009-10-19",
			1
		],
		[
			"2009-03-17",
			1
		]
	],
	"68011210": [
		[
			"2000-04-12",
			8.3
		],
		[
			"2000-08-16",
			9.2
		],
		[
			"2001-04-11",
			9.5
		],
		[
			"2001-08-22",
			7.2
		],
		[
			"2002-04-10",
			9.8
		],
		[
			"2002-08-21",
			9.7
		],
		[
			"2003-04-09",
			10.8
		],
		[
			"2003-08-20",
			10.7
		],
		[
			"2004-04-28",
			10.4
		],
		[
			"2004-09-08",
			12.8
		],
		[
			"2005-04-27",
			11.2
		],
		[
			"2005-09-07",
			10
		],
		[
			"2006-03-29",
			10.5
		],
		[
			"2006-09-27",
			10.5
		],
		[
			"2011-09-28",
			11.2
		],
		[
			"2011-12-14",
			11.7
		],
		[
			"2012-09-26",
			12
		],
		[
			"2013-03-20",
			12.3
		],
		[
			"2013-09-18",
			12.3
		],
		[
			"2014-03-19",
			11.4
		],
		[
			"2015-03-18",
			13.1
		],
		[
			"2014-09-17",
			12
		],
		[
			"2015-09-16",
			13.5
		],
		[
			"2007-03-28",
			10.7
		],
		[
			"2007-09-26",
			10.9
		],
		[
			"2008-04-16",
			10.5
		],
		[
			"2008-09-24",
			11.2
		],
		[
			"2009-03-24",
			9.5
		],
		[
			"2009-09-30",
			11.4
		]
	],
	"70100214": [
		[
			"2013-08-08",
			13.46
		],
		[
			"2014-10-09",
			10.32
		],
		[
			"2015-04-27",
			3.81
		],
		[
			"2003-09-24",
			28.43
		],
		[
			"2004-05-17",
			21.17
		],
		[
			"2005-06-13",
			16.34
		],
		[
			"2007-07-16",
			17.8
		],
		[
			"2007-09-13",
			11.03
		],
		[
			"2008-07-24",
			13.46
		],
		[
			"2009-07-30",
			12.44
		],
		[
			"2010-07-05",
			12.58
		],
		[
			"2011-06-28",
			17.27
		]
	],
	"70134212": [
		[
			"2013-07-31",
			17.71
		],
		[
			"2014-02-12",
			24.53
		],
		[
			"2015-10-12",
			33.39
		],
		[
			"2003-09-24",
			31.18
		],
		[
			"2004-05-17",
			23.96
		],
		[
			"2005-06-14",
			18.25
		],
		[
			"2007-06-12",
			22.67
		],
		[
			"2007-09-12",
			20.73
		],
		[
			"2008-07-08",
			20.95
		],
		[
			"2009-07-22",
			24.89
		],
		[
			"2010-06-29",
			21.39
		],
		[
			"2011-05-25",
			19.93
		]
	],
	"70148715": [
		[
			"2014-08-28",
			29.18
		],
		[
			"2015-07-14",
			22.59
		],
		[
			"2007-06-11",
			28.34
		],
		[
			"2007-09-18",
			27.77
		],
		[
			"2008-07-22",
			24
		],
		[
			"2009-09-08",
			25.02
		],
		[
			"2010-06-08",
			25.24
		]
	],
	"70156116": [
		[
			"2013-08-05",
			1.33
		],
		[
			"2014-07-24",
			5.76
		],
		[
			"2015-06-09",
			1.95
		],
		[
			"2007-06-11",
			2.21
		],
		[
			"2007-09-17",
			6.91
		],
		[
			"2008-07-10",
			2.21
		],
		[
			"2009-07-24",
			2.21
		],
		[
			"2010-06-30",
			2.52
		]
	],
	"70157110": [
		[
			"2013-09-26",
			23.96
		],
		[
			"2014-08-14",
			24.45
		],
		[
			"2015-07-07",
			22.14
		],
		[
			"2007-09-28",
			22.76
		],
		[
			"2008-08-19",
			20.46
		],
		[
			"2009-08-26",
			20.55
		],
		[
			"2010-07-26",
			22.59
		]
	],
	"70168817": [
		[
			"2013-07-30",
			116.03
		],
		[
			"2014-07-22",
			123.56
		],
		[
			"2015-06-08",
			119.13
		],
		[
			"2000-09-18",
			112.04
		],
		[
			"2001-06-25",
			116.03
		],
		[
			"2002-09-23",
			108.06
		],
		[
			"2003-10-06",
			91.23
		],
		[
			"2004-06-14",
			110.71
		],
		[
			"2005-06-20",
			103.19
		],
		[
			"2006-10-04",
			111.6
		],
		[
			"2007-06-25",
			116.91
		],
		[
			"2007-09-13",
			123.11
		],
		[
			"2008-07-08",
			114.26
		],
		[
			"2009-07-22",
			116.91
		],
		[
			"2010-06-29",
			123.56
		]
	],
	"70187915": [
		[
			"2012-01-10",
			18.61
		],
		[
			"2013-07-23",
			22.71
		],
		[
			"2015-01-13",
			22.91
		],
		[
			"2014-07-15",
			21.21
		]
	],
	"70189110": [
		[
			"2013-05-24",
			41.14
		],
		[
			"2014-07-14",
			44.73
		],
		[
			"2015-04-23",
			43.58
		],
		[
			"2004-05-18",
			30.78
		],
		[
			"2005-06-14",
			36.76
		],
		[
			"2007-06-14",
			42.56
		],
		[
			"2007-09-12",
			36.14
		],
		[
			"2008-07-25",
			34.23
		],
		[
			"2009-08-17",
			35.12
		],
		[
			"2010-07-13",
			43.22
		],
		[
			"2011-07-07",
			40.3
		],
		[
			"2012-07-16",
			42.96
		]
	],
	"70196515": [
		[
			"2013-08-05",
			24.84
		],
		[
			"2014-07-17",
			23.91
		],
		[
			"2015-04-23",
			25.55
		],
		[
			"2000-07-10",
			31.04
		],
		[
			"2001-06-25",
			23.6
		],
		[
			"2002-07-22",
			31.71
		],
		[
			"2003-08-18",
			34.76
		],
		[
			"2004-05-19",
			27.77
		],
		[
			"2005-06-15",
			30.16
		],
		[
			"2006-10-04",
			25.07
		],
		[
			"2007-06-14",
			26.48
		],
		[
			"2007-09-17",
			25.95
		],
		[
			"2008-07-28",
			26.84
		],
		[
			"2009-08-11",
			25.42
		],
		[
			"2010-07-08",
			27.28
		],
		[
			"2011-06-29",
			22.14
		]
	],
	"70197313": [
		[
			"2013-05-28",
			14.53
		],
		[
			"2014-07-17",
			15.85
		],
		[
			"2015-04-30",
			13.24
		],
		[
			"2000-07-10",
			22.85
		],
		[
			"2001-06-25",
			20.55
		],
		[
			"2002-07-22",
			22.05
		],
		[
			"2003-08-18",
			22.94
		],
		[
			"2004-05-19",
			14.97
		],
		[
			"2005-06-15",
			17.09
		],
		[
			"2007-06-14",
			16.7
		],
		[
			"2007-09-13",
			15.9
		],
		[
			"2008-08-04",
			15.72
		],
		[
			"2009-08-17",
			16.3
		],
		[
			"2010-07-13",
			15.59
		]
	],
	"70197714": [
		[
			"2000-07-11",
			40.34
		],
		[
			"2001-06-26",
			35.96
		],
		[
			"2002-07-22",
			36.45
		],
		[
			"2003-09-01",
			34.9
		],
		[
			"2004-05-24",
			37.78
		],
		[
			"2005-06-16",
			35.3
		],
		[
			"2006-10-04",
			30.03
		],
		[
			"2012-01-10",
			30.61
		],
		[
			"2013-07-22",
			31.41
		],
		[
			"2015-01-12",
			27.81
		],
		[
			"2014-07-14",
			28.91
		]
	],
	"70197817": [
		[
			"2013-07-16",
			13.42
		],
		[
			"2014-07-18",
			15.99
		],
		[
			"2015-04-24",
			19.53
		],
		[
			"2000-09-18",
			27.86
		],
		[
			"2001-06-26",
			22.76
		],
		[
			"2002-09-23",
			23.07
		],
		[
			"2004-06-14",
			29.8
		],
		[
			"2005-06-22",
			16.78
		],
		[
			"2006-10-05",
			22.5
		],
		[
			"2007-06-14",
			18.42
		],
		[
			"2007-09-13",
			17.23
		],
		[
			"2008-07-18",
			15.32
		],
		[
			"2009-07-31",
			19
		],
		[
			"2010-06-09",
			20.77
		],
		[
			"2011-06-10",
			15.94
		]
	],
	"70197910": [
		[
			"2013-07-16",
			28.56
		],
		[
			"2014-07-18",
			29.94
		],
		[
			"2015-04-24",
			28.12
		],
		[
			"2000-05-04",
			36.49
		],
		[
			"2000-07-11",
			37.51
		],
		[
			"2001-06-26",
			31.62
		],
		[
			"2002-07-22",
			37.24
		],
		[
			"2003-09-01",
			39.41
		],
		[
			"2004-05-24",
			34.85
		],
		[
			"2005-06-16",
			29.76
		],
		[
			"2006-10-05",
			24.36
		],
		[
			"2007-06-14",
			25.15
		],
		[
			"2007-09-12",
			22.9
		],
		[
			"2008-07-18",
			17.98
		],
		[
			"2012-01-10",
			34.31
		],
		[
			"2013-07-22",
			26.61
		],
		[
			"2015-01-12",
			31.21
		],
		[
			"2014-07-14",
			32.91
		],
		[
			"2009-07-31",
			25.29
		],
		[
			"2010-07-15",
			27.1
		],
		[
			"2011-09-01",
			30.11
		]
	],
	"70198111": [
		[
			"2014-12-05",
			33.7
		],
		[
			"2015-08-19",
			35.87
		],
		[
			"2003-09-29",
			38.62
		],
		[
			"2004-05-25",
			26.75
		],
		[
			"2005-07-19",
			29.27
		],
		[
			"2007-06-11",
			28.34
		],
		[
			"2007-09-11",
			27.41
		],
		[
			"2008-07-22",
			31.53
		],
		[
			"2009-09-08",
			29.1
		],
		[
			"2010-06-08",
			24.76
		]
	],
	"70199619": [
		[
			"2013-07-01",
			40.65
		],
		[
			"2014-07-21",
			46.94
		],
		[
			"2015-04-29",
			44.73
		],
		[
			"2000-07-12",
			63.77
		],
		[
			"2001-06-27",
			45.17
		],
		[
			"2002-07-24",
			61.56
		],
		[
			"2003-08-20",
			54.03
		],
		[
			"2004-05-27",
			52.26
		],
		[
			"2005-06-17",
			48.27
		],
		[
			"2006-10-05",
			49.6
		],
		[
			"2007-06-12",
			50.04
		],
		[
			"2007-09-14",
			44.73
		],
		[
			"2008-07-10",
			46.5
		],
		[
			"2009-07-24",
			48.27
		],
		[
			"2010-06-30",
			50.93
		],
		[
			"2011-05-26",
			53.14
		],
		[
			"2012-07-17",
			47.83
		]
	],
	"70199814": [
		[
			"2013-09-03",
			24.09
		],
		[
			"2014-09-29",
			19.66
		],
		[
			"2015-08-20",
			17.85
		],
		[
			"2000-07-17",
			38.09
		],
		[
			"2001-06-28",
			32.82
		],
		[
			"2002-07-23",
			30.6
		],
		[
			"2003-08-20",
			31.04
		],
		[
			"2004-05-26",
			34.59
		],
		[
			"2005-06-27",
			25.42
		],
		[
			"2006-10-09",
			37.07
		],
		[
			"2007-06-19",
			41.89
		],
		[
			"2007-09-24",
			37.16
		],
		[
			"2008-07-24",
			38.26
		],
		[
			"2009-07-30",
			30.51
		],
		[
			"2010-07-05",
			29.41
		],
		[
			"2011-06-28",
			24.8
		]
	],
	"70200210": [
		[
			"2013-05-29",
			22.05
		],
		[
			"2014-07-17",
			21.7
		],
		[
			"2015-06-01",
			20.68
		],
		[
			"2007-06-12",
			22.23
		],
		[
			"2007-09-14",
			21.21
		],
		[
			"2008-07-10",
			23.87
		],
		[
			"2009-07-24",
			20.15
		],
		[
			"2010-06-30",
			24.93
		],
		[
			"2011-05-26",
			23.91
		],
		[
			"2012-07-17",
			22.45
		]
	],
	"70200518": [
		[
			"2013-07-01",
			13.06
		],
		[
			"2014-10-08",
			9.39
		],
		[
			"2015-08-10",
			8.5
		],
		[
			"2000-07-11",
			22.23
		],
		[
			"2001-06-29",
			20.77
		],
		[
			"2002-07-24",
			20.24
		],
		[
			"2003-08-21",
			25.77
		],
		[
			"2004-05-27",
			23.96
		],
		[
			"2005-06-28",
			21.52
		],
		[
			"2006-10-06",
			15.85
		],
		[
			"2007-06-19",
			14.66
		],
		[
			"2007-09-19",
			14.3
		],
		[
			"2008-07-29",
			11.91
		],
		[
			"2009-08-12",
			13.95
		],
		[
			"2010-07-19",
			14.08
		],
		[
			"2011-08-30",
			11.96
		]
	],
	"70200816": [
		[
			"2014-02-13",
			12.7
		],
		[
			"2015-08-12",
			15.41
		],
		[
			"2016-03-15",
			19.21
		]
	],
	"70201213": [
		[
			"2014-02-13",
			68.32
		],
		[
			"2015-08-12",
			68.02
		],
		[
			"2016-03-15",
			53.22
		]
	],
	"70201316": [
		[
			"2013-05-23",
			33.48
		],
		[
			"2014-07-16",
			43.13
		],
		[
			"2015-04-27",
			42.56
		],
		[
			"2016-04-04",
			37.2
		],
		[
			"2000-07-13",
			46.94
		],
		[
			"2001-07-09",
			52.26
		],
		[
			"2002-07-25",
			48.27
		],
		[
			"2003-08-22",
			47.83
		],
		[
			"2004-05-27",
			40.03
		],
		[
			"2005-06-28",
			36.67
		],
		[
			"2007-07-06",
			33.08
		],
		[
			"2007-09-17",
			37.51
		],
		[
			"2008-08-01",
			40.79
		],
		[
			"2009-08-10",
			37.33
		],
		[
			"2010-07-06",
			39.41
		],
		[
			"2011-06-08",
			39.41
		],
		[
			"2012-07-16",
			41.45
		]
	],
	"70201419": [
		[
			"2013-11-19",
			19.93
		],
		[
			"2014-07-17",
			24.62
		],
		[
			"2015-04-23",
			18.56
		],
		[
			"2016-04-05",
			19.04
		],
		[
			"2000-07-13",
			32.99
		],
		[
			"2001-07-02",
			28.65
		],
		[
			"2002-07-25",
			27.55
		],
		[
			"2003-08-22",
			24.76
		],
		[
			"2004-05-28",
			25.24
		],
		[
			"2005-06-28",
			25.64
		],
		[
			"2007-06-19",
			22.36
		],
		[
			"2007-09-17",
			22.32
		],
		[
			"2008-08-01",
			21.83
		],
		[
			"2009-08-17",
			20.81
		],
		[
			"2010-07-13",
			21.35
		],
		[
			"2011-07-07",
			19.93
		]
	],
	"70201810": [
		[
			"2013-05-22",
			27.24
		],
		[
			"2014-07-16",
			22.28
		],
		[
			"2015-04-28",
			25.29
		],
		[
			"2016-04-04",
			21.26
		],
		[
			"2000-07-14",
			38.17
		],
		[
			"2001-07-02",
			41.54
		],
		[
			"2002-08-01",
			42.87
		],
		[
			"2003-08-25",
			35.96
		],
		[
			"2004-06-01",
			31.71
		],
		[
			"2005-06-29",
			36.36
		],
		[
			"2007-06-19",
			28.61
		],
		[
			"2007-09-19",
			28.61
		],
		[
			"2008-08-05",
			31.62
		],
		[
			"2009-08-28",
			27.77
		],
		[
			"2010-07-23",
			27.01
		],
		[
			"2011-08-29",
			24.36
		]
	],
	"70202310": [
		[
			"2013-07-15",
			16.25
		],
		[
			"2014-10-23",
			12.8
		],
		[
			"2015-07-20",
			15.68
		],
		[
			"2000-07-20",
			20.68
		],
		[
			"2001-07-03",
			20.46
		],
		[
			"2002-09-02",
			24.18
		],
		[
			"2003-09-19",
			23.6
		],
		[
			"2004-06-02",
			21.39
		],
		[
			"2005-06-30",
			14.75
		],
		[
			"2007-06-20",
			14.3
		],
		[
			"2007-09-19",
			22.9
		],
		[
			"2008-08-15",
			15.46
		],
		[
			"2009-09-08",
			16.3
		],
		[
			"2010-06-09",
			13.29
		],
		[
			"2011-06-10",
			15.06
		]
	],
	"70202515": [
		[
			"2013-07-22",
			9.48
		],
		[
			"2014-07-30",
			2.61
		],
		[
			"2015-04-21",
			9.12
		],
		[
			"2016-04-11",
			8.41
		],
		[
			"2000-07-18",
			5.45
		],
		[
			"2001-07-04",
			15.68
		],
		[
			"2002-07-30",
			7.97
		],
		[
			"2003-08-26",
			4.21
		],
		[
			"2004-06-02",
			19.97
		],
		[
			"2005-07-18",
			15.72
		],
		[
			"2007-06-20",
			14.17
		],
		[
			"2007-09-19",
			24.93
		],
		[
			"2008-07-31",
			12
		],
		[
			"2009-08-14",
			6.42
		],
		[
			"2010-07-07",
			6.24
		],
		[
			"2011-07-08",
			3.63
		]
	],
	"70203416": [
		[
			"2013-07-17",
			148.8
		],
		[
			"2014-08-11",
			159.43
		],
		[
			"2015-05-26",
			147.91
		],
		[
			"2000-07-19",
			250.21
		],
		[
			"2001-07-05",
			224.97
		],
		[
			"2002-07-31",
			217.44
		],
		[
			"2003-08-28",
			177.59
		],
		[
			"2004-06-04",
			202.83
		],
		[
			"2005-07-04",
			219.21
		],
		[
			"2006-10-12",
			206.81
		],
		[
			"2007-06-18",
			209.91
		],
		[
			"2007-09-25",
			210.36
		],
		[
			"2008-07-07",
			198.4
		],
		[
			"2009-07-27",
			185.11
		],
		[
			"2000-03-29",
			234.71
		],
		[
			"2010-07-01",
			178.91
		],
		[
			"2011-06-07",
			168.29
		]
	],
	"70203817": [
		[
			"2013-07-08",
			196.63
		],
		[
			"2014-08-20",
			152.34
		],
		[
			"2015-05-28",
			162.53
		],
		[
			"2001-07-06",
			217.44
		],
		[
			"2002-08-02",
			211.69
		],
		[
			"2003-08-28",
			188.21
		],
		[
			"2004-06-07",
			155
		],
		[
			"2007-06-18",
			184.67
		],
		[
			"2007-09-25",
			209.03
		],
		[
			"2008-07-07",
			216.11
		],
		[
			"2009-07-27",
			170.94
		],
		[
			"2010-07-01",
			143.49
		],
		[
			"2011-06-07",
			141.71
		]
	],
	"70203910": [
		[
			"2013-07-18",
			16.74
		],
		[
			"2014-07-23",
			22.85
		],
		[
			"2015-04-20",
			18.95
		],
		[
			"2001-07-06",
			16.16
		],
		[
			"2002-08-02",
			16.7
		],
		[
			"2003-08-29",
			38.22
		],
		[
			"2004-06-07",
			18.95
		],
		[
			"2005-07-05",
			14.44
		],
		[
			"2006-10-12",
			12.13
		],
		[
			"2007-06-18",
			14.48
		],
		[
			"2007-09-25",
			9.34
		],
		[
			"2008-07-07",
			32.55
		],
		[
			"2009-07-27",
			8.86
		],
		[
			"2010-07-01",
			9.65
		],
		[
			"2011-06-07",
			19.04
		]
	],
	"70204214": [
		[
			"2013-05-27",
			12.09
		],
		[
			"2014-10-07",
			13.68
		],
		[
			"2015-06-02",
			13.2
		],
		[
			"2002-08-05",
			18.42
		],
		[
			"2003-08-29",
			18.73
		],
		[
			"2004-06-08",
			16.56
		],
		[
			"2005-07-05",
			15.23
		],
		[
			"2007-06-20",
			14.08
		],
		[
			"2007-09-26",
			14.57
		],
		[
			"2008-07-25",
			15.72
		],
		[
			"2009-08-10",
			15.99
		],
		[
			"2010-07-06",
			14.35
		],
		[
			"2011-06-08",
			16.39
		]
	],
	"70204410": [
		[
			"2013-07-11",
			21.66
		],
		[
			"2014-07-30",
			20.28
		],
		[
			"2015-04-28",
			22.5
		],
		[
			"2016-04-05",
			22.14
		],
		[
			"2003-09-23",
			30.51
		],
		[
			"2004-07-06",
			27.37
		],
		[
			"2007-06-20",
			27.32
		],
		[
			"2007-09-26",
			22.32
		],
		[
			"2008-07-31",
			27.01
		],
		[
			"2009-08-14",
			29.23
		],
		[
			"2010-07-07",
			27.37
		],
		[
			"2011-09-01",
			30.56
		]
	],
	"70205218": [
		[
			"2013-05-23",
			24.53
		],
		[
			"2014-07-30",
			23.56
		],
		[
			"2015-06-10",
			22.9
		],
		[
			"2004-07-06",
			31.49
		],
		[
			"2005-07-07",
			34.41
		],
		[
			"2007-06-21",
			30.91
		],
		[
			"2007-09-21",
			37.24
		],
		[
			"2008-07-25",
			28.61
		],
		[
			"2009-08-10",
			25.95
		],
		[
			"2010-07-06",
			22.1
		],
		[
			"2011-06-08",
			23.03
		]
	],
	"70270016": [
		[
			"2013-07-25",
			41.58
		],
		[
			"2014-07-31",
			38.75
		],
		[
			"2015-05-19",
			35.56
		],
		[
			"2000-09-18",
			57.13
		],
		[
			"2001-07-06",
			49.16
		],
		[
			"2002-09-23",
			56.69
		],
		[
			"2003-10-06",
			57.13
		],
		[
			"2004-06-14",
			50.93
		],
		[
			"2005-06-20",
			55.36
		],
		[
			"2006-10-16",
			47.39
		],
		[
			"2007-07-09",
			46.5
		],
		[
			"2007-09-21",
			51.37
		],
		[
			"2008-07-09",
			65.99
		],
		[
			"2009-07-23",
			55.36
		],
		[
			"2010-06-28",
			65.1
		],
		[
			"2011-05-24",
			53.14
		]
	],
	"70276018": [
		[
			"2013-08-01",
			32.59
		],
		[
			"2015-04-16",
			35.12
		],
		[
			"2016-03-29",
			35.87
		],
		[
			"2000-07-24",
			41.45
		],
		[
			"2001-07-09",
			44.24
		],
		[
			"2002-08-05",
			47.39
		],
		[
			"2003-09-03",
			40.61
		],
		[
			"2004-07-06",
			40.79
		],
		[
			"2005-07-08",
			39.1
		],
		[
			"2006-10-16",
			36.58
		],
		[
			"2007-09-21",
			38.17
		],
		[
			"2008-07-08",
			35.74
		],
		[
			"2010-10-08",
			37.71
		],
		[
			"2007-11-16",
			42.31
		],
		[
			"2006-11-13",
			31.91
		],
		[
			"2011-11-23",
			38.41
		],
		[
			"2009-11-13",
			44.52
		],
		[
			"2008-12-05",
			43.02
		],
		[
			"2009-07-22",
			39.02
		],
		[
			"2010-06-29",
			39.64
		],
		[
			"2011-05-25",
			36.31
		],
		[
			"2012-07-17",
			38.26
		]
	],
	"70276110": [
		[
			"2013-07-22",
			22.85
		],
		[
			"2014-08-21",
			23.16
		],
		[
			"2015-07-08",
			22.41
		],
		[
			"2004-07-07",
			19.66
		],
		[
			"2005-07-08",
			26.7
		],
		[
			"2006-10-17",
			30.82
		],
		[
			"2007-06-21",
			21.08
		],
		[
			"2007-09-21",
			25.6
		],
		[
			"2008-07-08",
			40.7
		],
		[
			"2009-07-22",
			18.38
		],
		[
			"2010-06-29",
			31
		],
		[
			"2011-05-25",
			17.27
		]
	],
	"70282511": [
		[
			"2012-01-09",
			10.5
		],
		[
			"2013-07-22",
			11.5
		],
		[
			"2015-01-12",
			10.7
		],
		[
			"2014-07-14",
			10.1
		]
	],
	"70282717": [
		[
			"2012-01-09",
			10
		],
		[
			"2013-07-22",
			25.21
		],
		[
			"2015-01-12",
			12
		],
		[
			"2014-07-14",
			15.81
		]
	],
	"70282810": [
		[
			"2012-01-09",
			17.41
		],
		[
			"2013-07-22",
			16.41
		],
		[
			"2015-01-12",
			16.61
		],
		[
			"2014-07-15",
			17.21
		]
	],
	"70283011": [
		[
			"2012-01-09",
			17.31
		],
		[
			"2013-07-22",
			18.61
		],
		[
			"2015-01-13",
			17.21
		],
		[
			"2014-07-15",
			17.91
		]
	],
	"70283618": [
		[
			"2013-09-23",
			13.6
		],
		[
			"2014-08-11",
			39.46
		],
		[
			"2015-06-19",
			40.92
		],
		[
			"2000-05-16",
			41.27
		],
		[
			"2000-10-13",
			35.69
		],
		[
			"2007-06-25",
			55.36
		],
		[
			"2007-09-18",
			32.46
		],
		[
			"2008-07-09",
			6.73
		],
		[
			"2009-07-23",
			20.81
		],
		[
			"2010-06-28",
			36.76
		],
		[
			"2011-05-24",
			23.03
		]
	],
	"70283813": [
		[
			"2013-11-21",
			33.13
		],
		[
			"2014-07-31",
			24.53
		],
		[
			"2015-06-03",
			21.88
		],
		[
			"2007-06-22",
			19.75
		],
		[
			"2007-09-27",
			18.64
		],
		[
			"2009-08-11",
			26
		],
		[
			"2008-07-28",
			22.41
		],
		[
			"2010-07-08",
			26.44
		],
		[
			"2011-06-29",
			25.24
		]
	],
	"70284015": [
		[
			"2013-07-23",
			1.33
		],
		[
			"2015-05-18",
			17.05
		],
		[
			"2009-08-11",
			2.21
		],
		[
			"2008-07-28",
			2.21
		],
		[
			"2010-07-08",
			3.19
		]
	],
	"70284118": [
		[
			"2013-07-23",
			32.33
		],
		[
			"2014-08-04",
			13.91
		],
		[
			"2015-06-03",
			19.71
		],
		[
			"2007-06-28",
			25.73
		],
		[
			"2007-09-27",
			38.57
		],
		[
			"2008-07-11",
			47.83
		],
		[
			"2009-08-21",
			16.16
		],
		[
			"2010-07-01",
			22.67
		]
	],
	"70284416": [
		[
			"2013-07-15",
			14.26
		],
		[
			"2014-08-12",
			17.09
		],
		[
			"2015-05-22",
			12.22
		],
		[
			"2000-07-18",
			21.79
		],
		[
			"2001-07-09",
			20.59
		],
		[
			"2002-08-06",
			24.71
		],
		[
			"2003-09-03",
			20.42
		],
		[
			"2004-07-07",
			16.65
		],
		[
			"2005-07-11",
			18.25
		],
		[
			"2007-06-27",
			16.43
		],
		[
			"2007-09-26",
			18.33
		],
		[
			"2008-08-15",
			18.51
		],
		[
			"2009-08-28",
			16.34
		],
		[
			"2010-07-23",
			15.5
		],
		[
			"2011-08-29",
			15.5
		]
	],
	"70284611": [
		[
			"2013-07-18",
			85.47
		],
		[
			"2014-07-29",
			112.49
		],
		[
			"2015-06-10",
			111.16
		],
		[
			"2004-07-07",
			110.71
		],
		[
			"2005-07-11",
			86.8
		],
		[
			"2006-10-26",
			71.3
		],
		[
			"2007-06-25",
			78.39
		],
		[
			"2007-09-25",
			64.21
		],
		[
			"2008-07-09",
			39.19
		],
		[
			"2009-07-23",
			36.76
		],
		[
			"2010-06-28",
			69.97
		],
		[
			"2011-05-24",
			57.57
		]
	],
	"70304257": [
		[
			"2014-12-10",
			77.06
		],
		[
			"2015-08-17",
			73.96
		],
		[
			"2000-02-08",
			60.23
		],
		[
			"2000-05-09",
			62.44
		],
		[
			"2000-07-20",
			61.11
		],
		[
			"2000-10-26",
			59.79
		],
		[
			"2001-01-25",
			60.23
		],
		[
			"2001-04-26",
			62.44
		],
		[
			"2001-07-26",
			62
		],
		[
			"2001-10-25",
			65.1
		],
		[
			"2002-08-01",
			62.89
		],
		[
			"2002-05-07",
			61.56
		],
		[
			"2002-11-21",
			58.9
		],
		[
			"2002-01-29",
			65.54
		],
		[
			"2003-01-28",
			59.79
		],
		[
			"2003-04-29",
			58.46
		],
		[
			"2003-07-29",
			63.33
		],
		[
			"2003-11-06",
			64.21
		],
		[
			"2004-01-29",
			61.56
		],
		[
			"2004-04-26",
			60.23
		],
		[
			"2004-07-29",
			59.34
		],
		[
			"2004-10-28",
			63.77
		],
		[
			"2005-01-25",
			61.56
		],
		[
			"2005-05-03",
			61.56
		],
		[
			"2005-07-26",
			62
		],
		[
			"2005-10-27",
			66.87
		],
		[
			"2007-07-09",
			60.23
		],
		[
			"2007-09-20",
			63.77
		],
		[
			"2007-01-03",
			65.54
		],
		[
			"2007-05-08",
			69.04
		],
		[
			"2007-07-23",
			68.02
		],
		[
			"2007-10-26",
			70.86
		],
		[
			"2008-01-24",
			70.02
		],
		[
			"2008-05-08",
			70.86
		],
		[
			"2008-07-30",
			67.31
		],
		[
			"2008-10-22",
			64.92
		],
		[
			"2010-01-25",
			63.53
		],
		[
			"2010-05-10",
			67.13
		],
		[
			"2010-07-19",
			69.23
		],
		[
			"2010-11-02",
			62.03
		],
		[
			"2011-01-24",
			15.11
		],
		[
			"2011-05-05",
			69.53
		],
		[
			"2011-07-28",
			68.64
		],
		[
			"2011-10-27",
			59.79
		],
		[
			"2012-01-26",
			68.2
		],
		[
			"2012-05-03",
			78.39
		],
		[
			"2012-07-26",
			77.06
		],
		[
			"2012-11-02",
			73.51
		],
		[
			"2012-11-13",
			80.16
		],
		[
			"2013-01-29",
			70.41
		],
		[
			"2013-06-17",
			77.94
		],
		[
			"2013-07-31",
			73.51
		],
		[
			"2013-10-30",
			77.5
		],
		[
			"2014-01-30",
			80.16
		],
		[
			"2014-05-12",
			75.73
		],
		[
			"2014-07-17",
			79.71
		],
		[
			"2014-10-14",
			83.26
		]
	],
	"70424019": [
		[
			"2011-04-05",
			13
		],
		[
			"2011-10-11",
			6
		],
		[
			"2012-04-02",
			12
		],
		[
			"2012-10-10",
			6
		],
		[
			"2013-04-09",
			15.01
		],
		[
			"2013-10-14",
			9
		],
		[
			"2014-04-08",
			10
		],
		[
			"2014-10-07",
			6
		],
		[
			"2015-04-14",
			20.01
		]
	],
	"70443208": [
		[
			"2000-02-07",
			18.01
		],
		[
			"2000-05-08",
			22.01
		],
		[
			"2001-10-08",
			21.01
		],
		[
			"2002-04-15",
			22.01
		],
		[
			"2007-06-11",
			15.01
		],
		[
			"2007-08-06",
			14
		],
		[
			"2007-09-03",
			22.01
		],
		[
			"2008-07-07",
			18.01
		],
		[
			"2007-01-15",
			14
		],
		[
			"2007-02-12",
			16.01
		],
		[
			"2007-03-12",
			16.01
		],
		[
			"2007-04-02",
			17.01
		],
		[
			"2007-05-07",
			16.01
		],
		[
			"2007-07-09",
			13
		],
		[
			"2008-10-13",
			12
		],
		[
			"2009-04-06",
			17.01
		],
		[
			"2009-10-05",
			12
		],
		[
			"2010-04-06",
			16.01
		],
		[
			"2010-10-04",
			14
		],
		[
			"2011-04-04",
			20.01
		],
		[
			"2011-10-10",
			20.01
		],
		[
			"2012-04-02",
			18.01
		],
		[
			"2012-10-08",
			13
		],
		[
			"2013-04-08",
			18.01
		],
		[
			"2013-10-14",
			17.01
		],
		[
			"2014-04-07",
			12
		],
		[
			"2014-10-06",
			11
		],
		[
			"2015-04-13",
			17.01
		]
	],
	"70465915": [
		[
			"2011-04-05",
			19.01
		],
		[
			"2011-10-11",
			18.01
		],
		[
			"2012-04-02",
			21.01
		],
		[
			"2012-10-10",
			12
		],
		[
			"2013-04-09",
			21.01
		],
		[
			"2013-10-14",
			17.01
		],
		[
			"2014-04-08",
			14
		],
		[
			"2014-10-07",
			7
		],
		[
			"2015-04-14",
			16.01
		]
	],
	"70466117": [
		[
			"2011-04-05",
			20.01
		],
		[
			"2011-10-11",
			31.01
		],
		[
			"2012-04-02",
			24.01
		],
		[
			"2012-10-10",
			22.01
		],
		[
			"2013-04-09",
			21.01
		],
		[
			"2013-10-14",
			18.01
		],
		[
			"2014-04-08",
			18.01
		],
		[
			"2014-10-07",
			34.01
		],
		[
			"2015-04-14",
			20.01
		]
	],
	"71100805": [
		[
			"2013-09-25",
			28.87
		],
		[
			"2014-08-19",
			27.72
		],
		[
			"2015-10-14",
			20.11
		],
		[
			"2007-06-26",
			32.68
		],
		[
			"2007-10-19",
			37.69
		],
		[
			"2008-08-25",
			31.27
		],
		[
			"2009-08-21",
			45.61
		],
		[
			"2010-07-20",
			46.5
		],
		[
			"2011-12-15",
			22.5
		]
	],
	"71200307": [
		[
			"2013-09-25",
			129.31
		],
		[
			"2014-08-19",
			131.09
		],
		[
			"2015-10-14",
			130.2
		],
		[
			"2007-06-26",
			170.5
		],
		[
			"2007-10-19",
			166.51
		],
		[
			"2008-08-25",
			147.03
		],
		[
			"2009-08-21",
			134.19
		],
		[
			"2010-07-20",
			148.8
		],
		[
			"2011-12-15",
			142.6
		]
	],
	"73311613": [
		[
			"2000-08-01",
			54.91
		],
		[
			"2001-07-31",
			57.57
		],
		[
			"2002-07-15",
			46.06
		],
		[
			"2003-09-15",
			59.34
		],
		[
			"2004-07-01",
			56.24
		],
		[
			"2005-07-25",
			57.57
		],
		[
			"2006-11-20",
			55.36
		],
		[
			"2013-06-04",
			49.02
		],
		[
			"2012-10-16",
			50.52
		],
		[
			"2015-06-18",
			50.82
		],
		[
			"2014-09-29",
			46.42
		]
	],
	"73506813": [
		[
			"2013-08-14",
			30.96
		],
		[
			"2014-08-06",
			30.11
		],
		[
			"2015-06-23",
			32.2
		],
		[
			"2000-08-02",
			35.21
		],
		[
			"2001-07-11",
			32.73
		],
		[
			"2002-07-18",
			31.35
		],
		[
			"2003-09-17",
			32.73
		],
		[
			"2005-07-15",
			38.09
		],
		[
			"2006-11-22",
			40.21
		],
		[
			"2007-07-16",
			41.85
		],
		[
			"2007-09-20",
			41.85
		],
		[
			"2008-07-14",
			33.13
		],
		[
			"2009-08-03",
			30.29
		],
		[
			"2010-06-21",
			27.81
		],
		[
			"2011-08-16",
			27.01
		]
	],
	"73508615": [
		[
			"2015-07-06",
			44.73
		],
		[
			"2000-08-03",
			49.6
		],
		[
			"2001-07-11",
			50.93
		],
		[
			"2002-07-18",
			48.27
		],
		[
			"2003-09-17",
			45.61
		],
		[
			"2005-07-15",
			40.96
		],
		[
			"2006-11-22",
			38.93
		],
		[
			"2007-07-10",
			43.27
		],
		[
			"2007-09-20",
			46.94
		],
		[
			"2008-07-14",
			41.5
		],
		[
			"2009-08-03",
			41.5
		],
		[
			"2010-06-21",
			42.65
		]
	],
	"73509310": [
		[
			"2000-08-03",
			13.51
		],
		[
			"2001-07-12",
			12.75
		],
		[
			"2002-07-18",
			18.25
		],
		[
			"2003-09-17",
			11.91
		],
		[
			"2004-07-13",
			17.85
		],
		[
			"2005-07-15",
			12.89
		],
		[
			"2006-11-22",
			17.85
		],
		[
			"2012-05-02",
			12.4
		],
		[
			"2013-10-14",
			13.1
		],
		[
			"2014-04-09",
			11.6
		],
		[
			"2015-10-01",
			11.3
		]
	],
	"73510312": [
		[
			"2013-08-14",
			17.23
		],
		[
			"2014-08-06",
			18.38
		],
		[
			"2015-06-11",
			16.65
		],
		[
			"2007-07-10",
			21.39
		],
		[
			"2007-10-01",
			19.35
		],
		[
			"2008-07-14",
			19.49
		],
		[
			"2009-08-03",
			16.16
		],
		[
			"2010-06-21",
			36.54
		],
		[
			"2011-08-16",
			17.71
		]
	],
	"73510919": [
		[
			"2000-08-03",
			33.61
		],
		[
			"2001-07-12",
			51.37
		],
		[
			"2002-07-18",
			28.74
		],
		[
			"2003-09-17",
			35.47
		],
		[
			"2004-07-13",
			21.66
		],
		[
			"2005-08-01",
			23.69
		],
		[
			"2006-11-22",
			19.4
		],
		[
			"2012-05-02",
			21.41
		],
		[
			"2013-10-14",
			25.61
		],
		[
			"2014-04-09",
			18.31
		],
		[
			"2015-10-05",
			22.41
		]
	],
	"73512515": [
		[
			"2000-08-02",
			19.66
		],
		[
			"2001-07-31",
			16.39
		],
		[
			"2002-07-15",
			19.49
		],
		[
			"2003-09-15",
			22.81
		],
		[
			"2004-07-05",
			22.85
		],
		[
			"2005-07-25",
			24.31
		],
		[
			"2006-11-20",
			24.31
		],
		[
			"2012-05-02",
			17.81
		],
		[
			"2013-10-15",
			17.11
		],
		[
			"2014-04-10",
			17.41
		],
		[
			"2015-10-05",
			18.41
		]
	],
	"73512618": [
		[
			"2013-08-13",
			40.83
		],
		[
			"2014-08-07",
			42.87
		],
		[
			"2015-06-11",
			44.02
		],
		[
			"2007-07-10",
			42.34
		],
		[
			"2007-10-01",
			42.07
		],
		[
			"2008-07-14",
			31.89
		],
		[
			"2009-08-03",
			34.99
		],
		[
			"2010-06-21",
			18.02
		],
		[
			"2011-08-15",
			33.21
		]
	],
	"73529217": [
		[
			"2013-07-24",
			48.71
		],
		[
			"2014-10-02",
			43.8
		],
		[
			"2015-08-13",
			44.73
		],
		[
			"2007-06-28",
			58.01
		],
		[
			"2007-10-01",
			61.11
		],
		[
			"2008-07-11",
			59.79
		],
		[
			"2009-07-28",
			59.79
		],
		[
			"2010-07-02",
			59.79
		],
		[
			"2011-05-27",
			57.57
		]
	],
	"73529412": [
		[
			"2013-07-24",
			39.15
		],
		[
			"2014-08-12",
			42.38
		],
		[
			"2015-07-13",
			42.74
		],
		[
			"2007-06-28",
			47.39
		],
		[
			"2007-10-01",
			45.61
		],
		[
			"2008-07-11",
			49.6
		],
		[
			"2009-07-28",
			46.94
		],
		[
			"2010-07-02",
			50.93
		],
		[
			"2011-05-27",
			44.29
		]
	],
	"73537410": [
		[
			"2013-08-21",
			30.96
		],
		[
			"2014-09-17",
			34.54
		],
		[
			"2015-07-02",
			32.2
		],
		[
			"2000-08-04",
			38.04
		],
		[
			"2001-07-12",
			35.74
		],
		[
			"2002-07-17",
			38.22
		],
		[
			"2003-09-18",
			37.42
		],
		[
			"2005-07-26",
			39.06
		],
		[
			"2007-07-10",
			34.72
		],
		[
			"2007-09-20",
			33.39
		],
		[
			"2008-07-16",
			30.11
		],
		[
			"2009-08-05",
			33.88
		],
		[
			"2010-06-23",
			36.58
		],
		[
			"2011-08-18",
			38.53
		]
	],
	"73542015": [
		[
			"2013-08-26",
			36.4
		],
		[
			"2014-08-05",
			32.46
		],
		[
			"2015-06-16",
			35.21
		],
		[
			"2002-04-25",
			44.73
		],
		[
			"2002-09-19",
			46.06
		],
		[
			"2003-03-31",
			44.73
		],
		[
			"2003-11-19",
			39.28
		],
		[
			"2007-07-16",
			38.57
		],
		[
			"2007-10-02",
			36.27
		],
		[
			"2008-07-16",
			32.86
		],
		[
			"2009-08-05",
			37.38
		],
		[
			"2010-06-23",
			37.11
		],
		[
			"2011-08-18",
			31.44
		]
	],
	"73546010": [
		[
			"2013-08-26",
			34.32
		],
		[
			"2014-08-05",
			31
		],
		[
			"2015-06-16",
			37.07
		],
		[
			"2002-04-22",
			24.58
		],
		[
			"2002-09-16",
			28.96
		],
		[
			"2003-03-24",
			25.24
		],
		[
			"2003-11-12",
			28.79
		],
		[
			"2007-07-16",
			41.58
		],
		[
			"2007-10-02",
			41.36
		],
		[
			"2009-08-04",
			41.23
		],
		[
			"2010-06-22",
			40.7
		],
		[
			"2011-08-17",
			34.54
		]
	],
	"73553815": [
		[
			"2013-08-13",
			24.45
		],
		[
			"2014-08-07",
			24.18
		],
		[
			"2015-06-11",
			22.32
		],
		[
			"2007-07-11",
			26.53
		],
		[
			"2007-10-02",
			27.99
		],
		[
			"2008-07-17",
			26.7
		],
		[
			"2009-08-06",
			27.41
		],
		[
			"2010-06-24",
			29.05
		],
		[
			"2011-08-19",
			27.01
		]
	],
	"73560110": [
		[
			"2013-08-26",
			45.61
		],
		[
			"2014-08-26",
			44.24
		],
		[
			"2015-07-01",
			39.33
		],
		[
			"2002-04-24",
			112.04
		],
		[
			"2002-09-18",
			110.27
		],
		[
			"2003-03-27",
			105.4
		],
		[
			"2003-11-17",
			101.86
		],
		[
			"2007-07-11",
			85.47
		],
		[
			"2007-10-04",
			85.03
		],
		[
			"2008-07-15",
			79.27
		],
		[
			"2009-08-04",
			77.94
		],
		[
			"2010-06-22",
			79.27
		],
		[
			"2011-08-17",
			62
		]
	],
	"73561915": [
		[
			"2013-08-19",
			38.71
		],
		[
			"2014-09-30",
			37.2
		],
		[
			"2015-06-30",
			36.4
		],
		[
			"2002-04-25",
			46.06
		],
		[
			"2002-09-19",
			48.27
		],
		[
			"2003-03-28",
			47.39
		],
		[
			"2003-11-18",
			46.5
		],
		[
			"2007-07-17",
			34.72
		],
		[
			"2007-10-04",
			36.31
		],
		[
			"2008-07-17",
			32.95
		],
		[
			"2009-08-06",
			35.03
		],
		[
			"2010-06-24",
			37.69
		],
		[
			"2011-08-19",
			33.66
		]
	],
	"73564217": [
		[
			"2013-08-22",
			28.83
		],
		[
			"2014-10-01",
			30.42
		],
		[
			"2015-07-03",
			28.3
		],
		[
			"2002-04-25",
			35.47
		],
		[
			"2002-09-30",
			31.71
		],
		[
			"2003-03-31",
			33.75
		],
		[
			"2003-11-20",
			35.25
		],
		[
			"2007-07-23",
			34.63
		],
		[
			"2007-10-04",
			33.21
		],
		[
			"2008-07-17",
			31.4
		],
		[
			"2009-08-06",
			32.95
		],
		[
			"2010-06-24",
			35.56
		],
		[
			"2011-08-19",
			31
		]
	],
	"73567012": [
		[
			"2013-08-20",
			48.71
		],
		[
			"2014-08-13",
			53.14
		],
		[
			"2015-06-22",
			46.06
		],
		[
			"2007-07-12",
			116.03
		],
		[
			"2007-10-04",
			112.04
		],
		[
			"2008-07-15",
			74.84
		],
		[
			"2009-08-04",
			97.43
		],
		[
			"2010-06-22",
			75.73
		],
		[
			"2011-08-17",
			84.14
		]
	],
	"73725500": [
		[
			"2013-10-11",
			14.66
		],
		[
			"2014-06-26",
			15.94
		],
		[
			"2015-03-23",
			16.65
		],
		[
			"2016-03-14",
			13.73
		],
		[
			"2000-08-16",
			13.82
		],
		[
			"2001-08-03",
			14.57
		],
		[
			"2002-08-20",
			15.28
		],
		[
			"2003-10-09",
			15.28
		],
		[
			"2004-07-19",
			16.92
		],
		[
			"2005-08-08",
			18.25
		],
		[
			"2007-08-13",
			18.82
		],
		[
			"2007-10-22",
			20.19
		],
		[
			"2008-08-26",
			17.05
		],
		[
			"2009-10-28",
			16.39
		],
		[
			"2010-11-04",
			14.61
		],
		[
			"2011-12-06",
			12.62
		]
	],
	"73725687": [
		[
			"2013-10-11",
			1.33
		],
		[
			"2014-06-16",
			1.33
		],
		[
			"2015-03-19",
			1.55
		],
		[
			"2016-03-14",
			1.64
		],
		[
			"2000-08-25",
			2.44
		],
		[
			"2001-08-03",
			2.21
		],
		[
			"2002-08-22",
			2.21
		],
		[
			"2003-10-09",
			2.21
		],
		[
			"2004-07-19",
			2.21
		],
		[
			"2005-08-08",
			2.21
		],
		[
			"2007-08-13",
			2.21
		],
		[
			"2008-08-26",
			2.21
		],
		[
			"2009-11-04",
			2.21
		],
		[
			"2007-10-22",
			2.21
		],
		[
			"2010-09-09",
			1.33
		],
		[
			"2011-11-21",
			1.37
		]
	],
	"73725780": [
		[
			"2013-10-11",
			17.49
		],
		[
			"2014-06-16",
			17.8
		],
		[
			"2015-03-23",
			17.54
		],
		[
			"2016-03-14",
			15.06
		],
		[
			"2000-08-16",
			20.81
		],
		[
			"2001-08-03",
			22.5
		],
		[
			"2002-08-20",
			21.21
		],
		[
			"2003-10-09",
			16.96
		],
		[
			"2004-08-04",
			20.5
		],
		[
			"2005-08-08",
			20.24
		],
		[
			"2007-08-13",
			19.75
		],
		[
			"2008-08-26",
			21.17
		],
		[
			"2009-11-04",
			17.14
		],
		[
			"2007-10-22",
			20.68
		],
		[
			"2010-09-09",
			19.49
		],
		[
			"2011-11-21",
			18.64
		]
	],
	"73725900": [
		[
			"2013-10-29",
			1.33
		],
		[
			"2014-06-11",
			1.33
		],
		[
			"2015-03-19",
			1.33
		],
		[
			"2016-03-23",
			1.33
		],
		[
			"2000-08-16",
			2.21
		],
		[
			"2001-08-03",
			2.21
		],
		[
			"2002-08-20",
			2.21
		],
		[
			"2003-10-10",
			6.78
		],
		[
			"2004-07-20",
			3.76
		],
		[
			"2005-08-10",
			2.21
		],
		[
			"2007-08-13",
			2.21
		],
		[
			"2008-08-26",
			2.21
		],
		[
			"2009-11-04",
			2.21
		],
		[
			"2007-10-22",
			2.21
		],
		[
			"2010-09-09",
			1.33
		],
		[
			"2011-11-21",
			0.66
		]
	],
	"73726000": [
		[
			"2013-10-29",
			12.31
		],
		[
			"2014-06-26",
			12.49
		],
		[
			"2015-03-24",
			13.11
		],
		[
			"2016-03-23",
			12.4
		],
		[
			"2000-09-19",
			9.7
		],
		[
			"2001-08-06",
			12.09
		],
		[
			"2002-09-25",
			12.62
		],
		[
			"2003-10-08",
			11.96
		],
		[
			"2004-06-15",
			10.81
		],
		[
			"2005-06-21",
			11.29
		],
		[
			"2007-08-14",
			11.34
		],
		[
			"2008-10-27",
			10.41
		],
		[
			"2009-10-28",
			11.96
		],
		[
			"2007-10-23",
			18.25
		],
		[
			"2010-08-25",
			4.25
		],
		[
			"2011-12-05",
			11.2
		]
	],
	"73726280": [
		[
			"2013-10-29",
			5.27
		],
		[
			"2014-09-24",
			1.77
		],
		[
			"2015-03-24",
			2.7
		],
		[
			"2016-03-08",
			6.64
		],
		[
			"2000-08-18",
			2.21
		],
		[
			"2001-08-06",
			2.21
		],
		[
			"2002-08-21",
			2.21
		],
		[
			"2003-10-10",
			3.76
		],
		[
			"2004-08-04",
			2.21
		],
		[
			"2005-08-10",
			2.21
		],
		[
			"2007-10-23",
			2.21
		],
		[
			"2008-10-30",
			3.99
		],
		[
			"2009-10-29",
			2.21
		],
		[
			"2011-07-12",
			1.33
		]
	],
	"73726382": [
		[
			"2013-12-09",
			17.18
		],
		[
			"2014-11-14",
			17.8
		],
		[
			"2015-12-18",
			17.49
		],
		[
			"2016-03-08",
			19.04
		],
		[
			"2000-08-18",
			20.19
		],
		[
			"2001-08-06",
			20.15
		],
		[
			"2002-09-03",
			21.04
		],
		[
			"2003-10-13",
			19.35
		],
		[
			"2004-08-04",
			20.24
		],
		[
			"2005-08-10",
			20.95
		],
		[
			"2007-08-14",
			20.5
		],
		[
			"2007-10-23",
			20.33
		],
		[
			"2008-10-27",
			18.51
		],
		[
			"2009-11-16",
			19.35
		],
		[
			"2010-11-11",
			18.16
		],
		[
			"2011-12-05",
			19.62
		]
	],
	"73726680": [
		[
			"2013-06-27",
			19.62
		],
		[
			"2014-11-14",
			16.43
		],
		[
			"2015-10-23",
			17.63
		],
		[
			"2016-03-23",
			17.71
		],
		[
			"2000-08-18",
			12.4
		],
		[
			"2001-08-07",
			12.13
		],
		[
			"2002-08-21",
			11.03
		],
		[
			"2003-10-13",
			11.91
		],
		[
			"2004-07-20",
			12
		],
		[
			"2005-08-12",
			14.88
		],
		[
			"2008-10-30",
			24.71
		],
		[
			"2009-11-16",
			30.96
		],
		[
			"2007-10-24",
			22.63
		],
		[
			"2010-11-04",
			23.91
		],
		[
			"2011-12-06",
			18.02
		]
	],
	"73727088": [
		[
			"2013-10-11",
			8.55
		],
		[
			"2014-06-06",
			9.03
		],
		[
			"2015-03-23",
			12.09
		],
		[
			"2000-08-15",
			8.9
		],
		[
			"2001-08-02",
			5.23
		],
		[
			"2002-08-21",
			18.38
		],
		[
			"2003-10-13",
			9.26
		],
		[
			"2004-07-21",
			9.21
		],
		[
			"2005-08-12",
			13.06
		],
		[
			"2007-08-15",
			21.97
		],
		[
			"2008-10-30",
			13.64
		],
		[
			"2009-10-29",
			8.59
		],
		[
			"2007-10-24",
			11.69
		],
		[
			"2010-08-25",
			14.61
		],
		[
			"2011-12-05",
			7.4
		]
	],
	"73727180": [
		[
			"2015-03-24",
			35.03
		],
		[
			"2000-08-15",
			29.98
		],
		[
			"2001-08-07",
			37.42
		],
		[
			"2002-08-21",
			20.06
		],
		[
			"2003-10-13",
			28.79
		],
		[
			"2004-07-21",
			32.06
		],
		[
			"2005-08-12",
			35.21
		],
		[
			"2007-08-15",
			34.72
		],
		[
			"2007-10-24",
			37.38
		],
		[
			"2008-10-30",
			27.37
		],
		[
			"2009-10-29",
			40.79
		],
		[
			"2010-08-25",
			35.43
		],
		[
			"2011-12-05",
			19.26
		]
	],
	"73727283": [
		[
			"2013-10-28",
			8.33
		],
		[
			"2014-10-31",
			9.61
		],
		[
			"2015-10-08",
			9.48
		],
		[
			"2000-08-22",
			6.33
		],
		[
			"2001-08-07",
			6.38
		],
		[
			"2003-10-14",
			6.11
		],
		[
			"2004-07-21",
			6.07
		],
		[
			"2005-08-17",
			7
		],
		[
			"2007-08-15",
			6.47
		],
		[
			"2007-10-18",
			6.78
		],
		[
			"2008-08-22",
			7.13
		],
		[
			"2009-10-07",
			7.62
		],
		[
			"2010-10-04",
			7.09
		],
		[
			"2011-12-13",
			7.93
		]
	],
	"73727301": [
		[
			"2013-10-14",
			2.35
		],
		[
			"2014-09-24",
			5.54
		],
		[
			"2015-03-25",
			14.35
		],
		[
			"2000-08-22",
			26.26
		],
		[
			"2001-08-07",
			15.9
		],
		[
			"2002-08-22",
			27.77
		],
		[
			"2003-10-14",
			16.39
		],
		[
			"2004-07-21",
			15.54
		],
		[
			"2005-08-17",
			2.21
		],
		[
			"2007-08-15",
			2.21
		],
		[
			"2008-08-22",
			2.21
		],
		[
			"2009-10-07",
			11.56
		],
		[
			"2007-10-18",
			2.21
		],
		[
			"2010-10-04",
			2.04
		],
		[
			"2011-12-13",
			7.79
		]
	],
	"73736806": [
		[
			"2000-03-15",
			5
		],
		[
			"2000-09-13",
			5.6
		],
		[
			"2001-03-23",
			5
		],
		[
			"2001-10-08",
			5
		],
		[
			"2002-03-11",
			5
		],
		[
			"2002-09-25",
			5
		],
		[
			"2003-04-03",
			5
		],
		[
			"2003-09-15",
			5
		],
		[
			"2004-04-08",
			5
		],
		[
			"2004-09-14",
			5
		],
		[
			"2005-04-21",
			5
		],
		[
			"2005-09-27",
			5
		],
		[
			"2006-04-26",
			5.6
		],
		[
			"2006-10-18",
			5
		],
		[
			"2007-05-02",
			5
		],
		[
			"2007-10-16",
			5
		],
		[
			"2008-04-09",
			5
		],
		[
			"2008-10-28",
			5
		],
		[
			"2009-04-21",
			5
		],
		[
			"2009-10-26",
			5
		],
		[
			"2010-04-29",
			5
		],
		[
			"2010-10-14",
			5.4
		],
		[
			"2011-04-27",
			5
		],
		[
			"2011-10-20",
			5.2
		],
		[
			"2012-04-17",
			5
		],
		[
			"2012-10-30",
			5.3
		],
		[
			"2013-04-15",
			5
		],
		[
			"2013-10-22",
			5
		],
		[
			"2014-04-14",
			5
		],
		[
			"2014-10-09",
			5
		],
		[
			"2015-04-09",
			5.3
		],
		[
			"2015-09-21",
			5
		]
	],
	"73737288": [
		[
			"2013-10-24",
			13.51
		],
		[
			"2014-11-06",
			40.83
		],
		[
			"2015-04-01",
			42.96
		],
		[
			"2016-03-24",
			41.19
		],
		[
			"2000-08-10",
			39.72
		],
		[
			"2001-07-26",
			40.17
		],
		[
			"2002-08-16",
			39.55
		],
		[
			"2003-09-25",
			40.96
		],
		[
			"2004-07-22",
			35.47
		],
		[
			"2005-08-15",
			37.95
		],
		[
			"2007-08-16",
			33.08
		],
		[
			"2008-10-20",
			37.51
		],
		[
			"2009-12-03",
			40.12
		],
		[
			"2007-10-25",
			35.87
		],
		[
			"2011-12-14",
			41.5
		]
	],
	"73737380": [
		[
			"2013-10-24",
			10.5
		],
		[
			"2014-07-15",
			8.9
		],
		[
			"2015-04-08",
			10.45
		],
		[
			"2000-08-14",
			16.47
		],
		[
			"2001-08-02",
			16.7
		],
		[
			"2002-08-19",
			14.17
		],
		[
			"2004-07-26",
			14.53
		],
		[
			"2005-08-16",
			15.94
		],
		[
			"2007-08-17",
			13.73
		],
		[
			"2008-10-16",
			11.43
		],
		[
			"2009-11-05",
			14.17
		],
		[
			"2007-10-29",
			13.95
		],
		[
			"2011-05-30",
			10.63
		]
	],
	"73738517": [
		[
			"2000-08-07",
			3.5
		],
		[
			"2002-08-06",
			2.21
		],
		[
			"2012-02-06",
			5.9
		],
		[
			"2013-08-05",
			5
		],
		[
			"2015-01-20",
			5
		],
		[
			"2014-07-22",
			5
		]
	],
	"73746710": [
		[
			"2013-07-11",
			21.61
		],
		[
			"2014-08-27",
			33.75
		],
		[
			"2015-07-31",
			27.37
		],
		[
			"2000-07-24",
			24.22
		],
		[
			"2001-07-17",
			25.91
		],
		[
			"2002-08-07",
			38.13
		],
		[
			"2003-09-04",
			39.72
		],
		[
			"2006-10-17",
			32.86
		],
		[
			"2007-06-27",
			32.46
		],
		[
			"2007-09-24",
			37.78
		],
		[
			"2008-07-25",
			34.59
		],
		[
			"2009-08-10",
			35.83
		],
		[
			"2010-07-06",
			37.51
		],
		[
			"2011-06-08",
			33.66
		]
	],
	"73751789": [
		[
			"2013-10-24",
			33.75
		],
		[
			"2014-11-06",
			33.35
		],
		[
			"2015-04-08",
			45.61
		],
		[
			"2000-08-14",
			25.29
		],
		[
			"2001-08-02",
			19.22
		],
		[
			"2002-08-19",
			19.53
		],
		[
			"2003-09-26",
			19.93
		],
		[
			"2004-07-26",
			27.15
		],
		[
			"2005-08-16",
			33.26
		],
		[
			"2007-08-17",
			39.5
		],
		[
			"2007-10-29",
			29.01
		],
		[
			"2008-10-16",
			29.85
		],
		[
			"2009-11-05",
			24.09
		],
		[
			"2011-05-30",
			22.59
		]
	],
	"73756507": [
		[
			"2000-03-15",
			15.01
		],
		[
			"2000-09-13",
			16.51
		],
		[
			"2001-03-23",
			15.71
		],
		[
			"2001-10-08",
			6.6
		],
		[
			"2002-03-11",
			14.31
		],
		[
			"2002-09-25",
			13.1
		],
		[
			"2003-04-03",
			14.61
		],
		[
			"2003-09-15",
			12.8
		],
		[
			"2004-04-08",
			15.31
		],
		[
			"2004-09-14",
			15.41
		],
		[
			"2005-04-21",
			16.11
		],
		[
			"2005-09-27",
			15.11
		],
		[
			"2006-04-26",
			16.51
		],
		[
			"2006-10-18",
			12.3
		],
		[
			"2007-05-02",
			16.01
		],
		[
			"2007-10-16",
			15.91
		],
		[
			"2008-04-09",
			15.41
		],
		[
			"2008-10-28",
			15.61
		],
		[
			"2009-04-21",
			14.71
		],
		[
			"2009-10-26",
			13.8
		],
		[
			"2010-04-29",
			15.31
		],
		[
			"2010-10-14",
			15.21
		],
		[
			"2011-04-27",
			14.61
		],
		[
			"2011-10-20",
			14.81
		],
		[
			"2012-04-17",
			13.8
		],
		[
			"2012-10-30",
			13.3
		],
		[
			"2013-04-15",
			13.3
		],
		[
			"2013-10-22",
			12.9
		],
		[
			"2014-04-14",
			13.3
		],
		[
			"2014-10-09",
			12.8
		],
		[
			"2015-04-09",
			13.8
		],
		[
			"2015-09-21",
			12.3
		]
	],
	"73756714": [
		[
			"2000-04-19",
			31.62
		],
		[
			"2000-09-11",
			26.88
		],
		[
			"2002-08-07",
			22.1
		],
		[
			"2003-09-05",
			23.83
		],
		[
			"2004-06-24",
			30.47
		],
		[
			"2005-08-02",
			27.72
		],
		[
			"2012-06-04",
			29.31
		],
		[
			"2013-10-30",
			28.31
		],
		[
			"2014-05-14",
			28.21
		],
		[
			"2015-10-22",
			28.81
		]
	],
	"73756817": [
		[
			"2013-08-20",
			18.87
		],
		[
			"2015-06-24",
			19.35
		],
		[
			"2000-05-11",
			26.79
		],
		[
			"2000-09-11",
			23.25
		],
		[
			"2001-07-18",
			21.79
		],
		[
			"2002-08-07",
			18.64
		],
		[
			"2003-09-05",
			20.42
		],
		[
			"2004-06-24",
			20.99
		],
		[
			"2005-08-02",
			26.97
		],
		[
			"2006-10-19",
			22.72
		],
		[
			"2007-06-27",
			25.24
		],
		[
			"2007-09-24",
			24.67
		],
		[
			"2008-07-21",
			25.55
		],
		[
			"2009-08-07",
			22.67
		],
		[
			"2010-06-25",
			23.83
		],
		[
			"2011-08-22",
			19.04
		]
	],
	"73757421": [
		[
			"2000-07-26",
			9.65
		],
		[
			"2000-04-12",
			10.89
		],
		[
			"2002-08-08",
			6.6
		],
		[
			"2003-09-08",
			5.58
		],
		[
			"2004-06-28",
			7.48
		],
		[
			"2005-07-22",
			6.82
		],
		[
			"2006-10-20",
			5.27
		],
		[
			"2013-03-13",
			10.1
		],
		[
			"2012-08-22",
			7.5
		],
		[
			"2015-03-12",
			9.8
		],
		[
			"2014-08-18",
			7.3
		]
	],
	"73757433": [
		[
			"2013-08-15",
			13.2
		],
		[
			"2014-08-13",
			15.01
		],
		[
			"2015-06-24",
			13.2
		],
		[
			"2000-07-26",
			12.67
		],
		[
			"2001-07-19",
			13.55
		],
		[
			"2000-04-12",
			13.2
		],
		[
			"2002-08-08",
			13.42
		],
		[
			"2003-09-08",
			12.89
		],
		[
			"2004-06-28",
			15.85
		],
		[
			"2005-07-22",
			16.92
		],
		[
			"2006-10-20",
			17.8
		],
		[
			"2007-07-17",
			17.85
		],
		[
			"2007-10-05",
			18.11
		],
		[
			"2008-07-21",
			5.31
		],
		[
			"2009-08-07",
			15.81
		],
		[
			"2010-06-25",
			15.32
		],
		[
			"2011-08-16",
			16.39
		]
	],
	"73757512": [
		[
			"2000-04-12",
			23.56
		],
		[
			"2000-08-07",
			23.38
		],
		[
			"2001-07-18",
			22.54
		],
		[
			"2002-08-09",
			21.43
		],
		[
			"2003-09-09",
			18.29
		],
		[
			"2004-06-28",
			21.35
		],
		[
			"2005-07-28",
			16.34
		],
		[
			"2006-10-20",
			19
		],
		[
			"2013-03-14",
			18.61
		],
		[
			"2012-08-23",
			17.71
		],
		[
			"2015-03-19",
			19.11
		],
		[
			"2014-08-19",
			19.21
		]
	],
	"73761308": [
		[
			"2001-09-26",
			2.21
		],
		[
			"2002-04-08",
			2.21
		],
		[
			"2002-10-01",
			2.21
		],
		[
			"2003-04-09",
			6.69
		],
		[
			"2004-06-17",
			1
		],
		[
			"2004-11-03",
			1
		],
		[
			"2003-05-26",
			1
		],
		[
			"2002-11-26",
			1
		],
		[
			"2002-08-06",
			1
		],
		[
			"2001-12-05",
			1
		],
		[
			"2009-05-04",
			6
		],
		[
			"2009-11-02",
			6
		],
		[
			"2007-06-11",
			6
		],
		[
			"2003-11-25",
			1
		],
		[
			"2010-05-04",
			6
		],
		[
			"2010-11-22",
			6
		],
		[
			"2011-05-16",
			5
		],
		[
			"2011-11-15",
			5
		],
		[
			"2012-06-14",
			5
		],
		[
			"2012-11-21",
			6
		],
		[
			"2013-05-14",
			6
		],
		[
			"2013-11-18",
			6
		],
		[
			"2014-05-05",
			6
		],
		[
			"2014-11-11",
			6
		],
		[
			"2015-05-19",
			6
		]
	],
	"73765211": [
		[
			"2013-09-20",
			45.61
		],
		[
			"2014-08-25",
			46.5
		],
		[
			"2015-07-15",
			59.34
		],
		[
			"2007-07-12",
			47.83
		],
		[
			"2007-10-05",
			36.76
		],
		[
			"2008-08-21",
			52.7
		],
		[
			"2009-09-09",
			59.79
		],
		[
			"2010-07-22",
			52.7
		],
		[
			"2011-08-22",
			57.57
		]
	],
	"73767610": [
		[
			"2013-08-09",
			21.43
		],
		[
			"2015-08-03",
			16.3
		],
		[
			"2002-10-09",
			30.03
		],
		[
			"2003-04-15",
			29.76
		],
		[
			"2003-11-07",
			28.08
		],
		[
			"2004-04-14",
			25.15
		],
		[
			"2007-07-12",
			21.83
		],
		[
			"2007-10-08",
			22.54
		],
		[
			"2008-07-30",
			22.23
		],
		[
			"2009-08-18",
			21.39
		],
		[
			"2010-07-15",
			20.86
		],
		[
			"2011-08-23",
			19.93
		]
	],
	"73770504": [
		[
			"2001-09-25",
			30.87
		],
		[
			"2002-04-08",
			31.13
		],
		[
			"2001-07-04",
			31.01
		],
		[
			"2002-10-01",
			30.03
		],
		[
			"2003-04-08",
			29.89
		],
		[
			"2004-06-17",
			28.01
		],
		[
			"2004-08-23",
			27.41
		],
		[
			"2004-11-03",
			26.79
		],
		[
			"2003-05-26",
			28.21
		],
		[
			"2002-11-26",
			29.61
		],
		[
			"2002-08-06",
			29.01
		],
		[
			"2007-11-05",
			26.51
		],
		[
			"2008-05-26",
			28.21
		],
		[
			"2008-11-03",
			27.11
		],
		[
			"2009-05-04",
			27.81
		],
		[
			"2009-11-02",
			28.81
		],
		[
			"2007-06-11",
			25.71
		],
		[
			"2006-11-27",
			24.71
		],
		[
			"2006-05-09",
			25.51
		],
		[
			"2005-05-10",
			27.61
		],
		[
			"2005-11-21",
			28.51
		],
		[
			"2003-11-25",
			27.61
		],
		[
			"2010-05-04",
			27.81
		],
		[
			"2010-11-22",
			27.01
		],
		[
			"2011-05-16",
			26.01
		],
		[
			"2011-11-15",
			21.01
		],
		[
			"2012-06-14",
			29.01
		],
		[
			"2012-11-12",
			29.01
		],
		[
			"2013-05-14",
			30.01
		],
		[
			"2013-11-18",
			30.01
		],
		[
			"2014-05-05",
			30.01
		],
		[
			"2014-11-11",
			31.01
		],
		[
			"2015-05-19",
			31.01
		]
	],
	"73770607": [
		[
			"2001-07-04",
			22.01
		],
		[
			"2004-06-17",
			18.31
		],
		[
			"2004-11-03",
			21.61
		],
		[
			"2003-05-26",
			20.19
		],
		[
			"2002-11-26",
			20.99
		],
		[
			"2002-08-06",
			21.01
		],
		[
			"2009-11-02",
			21.11
		],
		[
			"2009-05-04",
			21.31
		],
		[
			"2008-11-03",
			19.51
		],
		[
			"2008-05-26",
			21.11
		],
		[
			"2007-11-05",
			17.71
		],
		[
			"2007-06-13",
			16.31
		],
		[
			"2006-11-27",
			15.81
		],
		[
			"2006-05-09",
			16.51
		],
		[
			"2005-05-10",
			18.51
		],
		[
			"2005-11-21",
			18.11
		],
		[
			"2003-11-25",
			17.81
		],
		[
			"2010-05-04",
			21.31
		],
		[
			"2010-11-22",
			21.01
		],
		[
			"2011-05-16",
			20.01
		],
		[
			"2011-11-15",
			22.01
		],
		[
			"2012-06-14",
			21.01
		],
		[
			"2012-11-12",
			20.01
		],
		[
			"2013-05-14",
			21.01
		],
		[
			"2013-11-18",
			20.01
		],
		[
			"2014-05-05",
			21.01
		],
		[
			"2014-11-11",
			21.01
		],
		[
			"2015-05-19",
			24.01
		]
	],
	"73770802": [
		[
			"2001-07-04",
			25.51
		],
		[
			"2004-06-17",
			24.58
		],
		[
			"2004-11-03",
			25.2
		],
		[
			"2003-05-26",
			23.78
		],
		[
			"2002-11-26",
			24.4
		],
		[
			"2002-08-06",
			23.01
		],
		[
			"2009-11-02",
			26.41
		],
		[
			"2009-05-04",
			25.81
		],
		[
			"2008-11-03",
			24.71
		],
		[
			"2008-05-26",
			25.01
		],
		[
			"2007-11-05",
			28.61
		],
		[
			"2007-06-13",
			25.11
		],
		[
			"2006-11-27",
			24.91
		],
		[
			"2006-05-09",
			23.91
		],
		[
			"2005-05-10",
			25.41
		],
		[
			"2005-11-21",
			25.91
		],
		[
			"2003-11-25",
			24.31
		],
		[
			"2010-05-04",
			26.21
		],
		[
			"2010-11-22",
			28.01
		],
		[
			"2011-05-16",
			25.01
		],
		[
			"2011-11-15",
			30.01
		],
		[
			"2012-11-12",
			30.01
		],
		[
			"2013-05-14",
			30.01
		],
		[
			"2013-11-18",
			29.01
		],
		[
			"2014-05-05",
			29.01
		],
		[
			"2014-11-11",
			29.01
		],
		[
			"2015-05-19",
			27.01
		]
	],
	"73770905": [
		[
			"2001-09-26",
			30.29
		],
		[
			"2002-04-08",
			31.35
		],
		[
			"2002-10-01",
			32.64
		],
		[
			"2003-04-09",
			34.5
		],
		[
			"2004-11-03",
			29.31
		],
		[
			"2003-05-26",
			32.06
		],
		[
			"2002-11-26",
			32.15
		],
		[
			"2002-08-06",
			31.01
		],
		[
			"2009-11-02",
			32.91
		],
		[
			"2009-05-04",
			32.11
		],
		[
			"2008-11-03",
			28.71
		],
		[
			"2008-05-26",
			29.91
		],
		[
			"2007-11-05",
			28.81
		],
		[
			"2007-06-13",
			27.51
		],
		[
			"2006-11-27",
			27.51
		],
		[
			"2006-05-09",
			27.61
		],
		[
			"2005-05-10",
			31.01
		],
		[
			"2005-11-21",
			31.71
		],
		[
			"2004-01-22",
			32.11
		],
		[
			"2010-05-04",
			31.91
		],
		[
			"2010-11-22",
			31.01
		],
		[
			"2011-05-16",
			31.01
		],
		[
			"2011-11-15",
			40.01
		],
		[
			"2012-06-14",
			36.01
		],
		[
			"2012-11-12",
			37.01
		],
		[
			"2013-05-14",
			37.01
		],
		[
			"2013-11-18",
			36.01
		],
		[
			"2014-05-05",
			35.01
		],
		[
			"2014-11-11",
			37.01
		],
		[
			"2015-05-19",
			35.01
		]
	],
	"73774182": [
		[
			"2013-10-15",
			25.07
		],
		[
			"2013-12-02",
			28.12
		],
		[
			"2014-11-11",
			31.8
		],
		[
			"2015-04-02",
			29.41
		],
		[
			"2000-08-28",
			19.13
		],
		[
			"2001-08-08",
			19.57
		],
		[
			"2002-08-26",
			21.43
		],
		[
			"2003-10-15",
			20.86
		],
		[
			"2004-07-28",
			22.67
		],
		[
			"2005-08-18",
			23.38
		],
		[
			"2007-10-30",
			24.36
		],
		[
			"2008-10-15",
			24.31
		],
		[
			"2009-11-04",
			21.97
		],
		[
			"2010-09-16",
			21.7
		],
		[
			"2011-11-30",
			22.5
		]
	],
	"73774200": [
		[
			"2013-10-15",
			31.49
		],
		[
			"2014-11-11",
			31.18
		],
		[
			"2015-04-02",
			29.72
		],
		[
			"2000-08-28",
			31.75
		],
		[
			"2001-08-08",
			30.56
		],
		[
			"2002-08-26",
			30.96
		],
		[
			"2003-10-15",
			30.82
		],
		[
			"2004-07-29",
			32.73
		],
		[
			"2005-08-18",
			32.59
		],
		[
			"2007-08-23",
			31.4
		],
		[
			"2007-10-30",
			30.03
		],
		[
			"2008-10-15",
			31.22
		],
		[
			"2009-11-04",
			30.25
		],
		[
			"2010-09-16",
			29.67
		],
		[
			"2011-11-30",
			31.84
		]
	],
	"73774303": [
		[
			"2013-10-15",
			28.39
		],
		[
			"2014-11-11",
			26
		],
		[
			"2015-04-02",
			25.69
		],
		[
			"2000-09-20",
			26.57
		],
		[
			"2001-08-08",
			28.21
		],
		[
			"2002-09-25",
			28.87
		],
		[
			"2003-10-08",
			28.56
		],
		[
			"2004-06-15",
			29.18
		],
		[
			"2005-06-21",
			28.92
		],
		[
			"2007-10-30",
			27.72
		],
		[
			"2008-10-15",
			27.37
		],
		[
			"2009-11-04",
			28.65
		],
		[
			"2010-09-16",
			27.01
		],
		[
			"2011-11-30",
			28.74
		]
	],
	"73774480": [
		[
			"2013-10-15",
			18.42
		],
		[
			"2014-11-10",
			17.71
		],
		[
			"2015-04-10",
			19.44
		],
		[
			"2000-08-28",
			15.28
		],
		[
			"2001-08-08",
			15.72
		],
		[
			"2002-08-26",
			16.3
		],
		[
			"2003-09-30",
			16.21
		],
		[
			"2004-07-29",
			0
		],
		[
			"2005-08-18",
			17.71
		],
		[
			"2007-08-23",
			20.64
		],
		[
			"2007-10-30",
			19.18
		],
		[
			"2008-10-15",
			20.9
		],
		[
			"2009-11-04",
			17.09
		],
		[
			"2010-09-16",
			19.04
		],
		[
			"2011-11-30",
			17.49
		]
	],
	"73774686": [
		[
			"2013-10-21",
			17.71
		],
		[
			"2014-11-10",
			21.21
		],
		[
			"2015-04-10",
			21.26
		],
		[
			"2000-09-20",
			16.03
		],
		[
			"2001-08-09",
			16.25
		],
		[
			"2002-09-25",
			15.94
		],
		[
			"2004-06-15",
			15.72
		],
		[
			"2005-06-21",
			14.84
		],
		[
			"2007-08-24",
			12.93
		],
		[
			"2007-10-31",
			14.57
		],
		[
			"2008-10-13",
			16.34
		],
		[
			"2009-11-11",
			12.98
		],
		[
			"2003-10-08",
			15.28
		],
		[
			"2010-08-24",
			18.6
		],
		[
			"2011-12-01",
			17.49
		]
	],
	"73774789": [
		[
			"2014-12-01",
			3.76
		],
		[
			"2015-04-10",
			12.8
		],
		[
			"2000-08-21",
			7.04
		],
		[
			"2001-07-30",
			6.42
		],
		[
			"2002-08-27",
			3.37
		],
		[
			"2004-07-29",
			6.82
		],
		[
			"2005-08-22",
			6.24
		],
		[
			"2007-08-23",
			16.56
		],
		[
			"2007-10-31",
			4.92
		],
		[
			"2008-10-13",
			9.21
		],
		[
			"2009-11-11",
			16.7
		],
		[
			"2010-08-24",
			6.64
		]
	],
	"73774807": [
		[
			"2013-10-21",
			1.42
		],
		[
			"2014-11-04",
			12.71
		],
		[
			"2015-03-31",
			11.25
		],
		[
			"2000-08-21",
			2.57
		],
		[
			"2001-08-09",
			8.15
		],
		[
			"2002-08-27",
			8.5
		],
		[
			"2003-10-02",
			2.21
		],
		[
			"2004-07-27",
			8.72
		],
		[
			"2007-08-27",
			12.49
		],
		[
			"2007-10-31",
			5.54
		],
		[
			"2008-10-13",
			5.49
		],
		[
			"2009-11-11",
			23.96
		],
		[
			"2010-08-24",
			1.33
		],
		[
			"2011-12-01",
			1.64
		]
	],
	"73775289": [
		[
			"2013-10-23",
			20.11
		],
		[
			"2014-11-04",
			16.12
		],
		[
			"2015-03-31",
			13.77
		],
		[
			"2000-08-28",
			16.47
		],
		[
			"2001-08-10",
			18.56
		],
		[
			"2002-08-28",
			18.33
		],
		[
			"2003-10-01",
			19.57
		],
		[
			"2004-07-30",
			17.09
		],
		[
			"2005-08-22",
			17.14
		],
		[
			"2007-08-20",
			14.84
		],
		[
			"2007-10-26",
			17.01
		],
		[
			"2008-10-23",
			15.63
		],
		[
			"2009-10-12",
			20.02
		],
		[
			"2010-09-08",
			16.83
		],
		[
			"2011-11-16",
			18.78
		]
	],
	"73775381": [
		[
			"2013-12-02",
			17.32
		],
		[
			"2014-11-05",
			26.48
		],
		[
			"2015-03-30",
			22.81
		],
		[
			"2000-08-25",
			18.91
		],
		[
			"2001-08-10",
			17.89
		],
		[
			"2002-08-28",
			17.85
		],
		[
			"2003-10-01",
			18.56
		],
		[
			"2004-07-30",
			15.19
		],
		[
			"2005-08-23",
			14.75
		],
		[
			"2008-10-23",
			11.96
		]
	],
	"73775484": [
		[
			"2013-10-16",
			5.93
		],
		[
			"2014-11-18",
			8.02
		],
		[
			"2015-04-07",
			8.46
		],
		[
			"2016-03-23",
			7.53
		],
		[
			"2000-08-24",
			6.73
		],
		[
			"2002-09-04",
			7.48
		],
		[
			"2004-08-03",
			7
		],
		[
			"2005-08-24",
			7.31
		],
		[
			"2007-08-22",
			10.32
		],
		[
			"2007-11-02",
			13.42
		],
		[
			"2008-10-27",
			11.78
		],
		[
			"2009-11-04",
			13.29
		],
		[
			"2010-09-09",
			7.53
		],
		[
			"2011-11-21",
			6.24
		]
	],
	"73775605": [
		[
			"2013-10-16",
			1.86
		],
		[
			"2014-11-05",
			14.39
		],
		[
			"2015-04-07",
			5.36
		],
		[
			"2000-08-23",
			10.05
		],
		[
			"2001-08-15",
			7.93
		],
		[
			"2002-08-29",
			8.72
		],
		[
			"2003-10-16",
			9.57
		],
		[
			"2004-08-02",
			6.2
		],
		[
			"2005-08-23",
			4.87
		],
		[
			"2007-08-21",
			11.78
		],
		[
			"2007-11-05",
			6.33
		],
		[
			"2008-10-17",
			7
		],
		[
			"2009-12-01",
			11.43
		],
		[
			"2010-09-15",
			5.31
		],
		[
			"2011-11-23",
			9.21
		]
	],
	"73775708": [
		[
			"2013-10-16",
			12.27
		],
		[
			"2014-08-27",
			13.42
		],
		[
			"2015-04-07",
			10.85
		],
		[
			"2000-08-23",
			13.15
		],
		[
			"2001-08-13",
			15.32
		],
		[
			"2002-09-03",
			11.29
		],
		[
			"2003-10-16",
			16.56
		],
		[
			"2004-08-02",
			13.42
		],
		[
			"2005-08-24",
			12.31
		],
		[
			"2007-08-21",
			11.82
		],
		[
			"2007-11-06",
			12.22
		],
		[
			"2008-10-17",
			10.58
		],
		[
			"2009-12-02",
			11.16
		],
		[
			"2010-09-15",
			11.07
		],
		[
			"2011-11-23",
			9.52
		]
	],
	"73775885": [
		[
			"2013-10-16",
			15.37
		],
		[
			"2014-11-05",
			14.66
		],
		[
			"2015-04-07",
			14.13
		],
		[
			"2001-08-13",
			12.75
		],
		[
			"2002-08-29",
			14.57
		],
		[
			"2003-10-16",
			14.08
		],
		[
			"2004-08-02",
			17.71
		],
		[
			"2005-08-24",
			20.02
		],
		[
			"2007-08-21",
			24.4
		],
		[
			"2007-11-06",
			22.01
		],
		[
			"2008-10-17",
			20.33
		],
		[
			"2009-12-01",
			19.53
		],
		[
			"2010-09-15",
			16.83
		],
		[
			"2011-11-23",
			14.48
		]
	],
	"73779118": [
		[
			"2013-09-30",
			13.06
		],
		[
			"2015-05-20",
			11.29
		],
		[
			"2016-04-07",
			10.63
		],
		[
			"2001-11-20",
			20.28
		],
		[
			"2002-04-30",
			15.9
		],
		[
			"2002-10-22",
			22.19
		],
		[
			"2003-04-09",
			20.9
		],
		[
			"2007-07-13",
			20.55
		],
		[
			"2007-09-26",
			15.81
		],
		[
			"2008-08-05",
			15.94
		],
		[
			"2009-08-20",
			13.46
		],
		[
			"2010-07-14",
			17.76
		],
		[
			"2011-08-23",
			11.07
		]
	],
	"73779210": [
		[
			"2013-08-06",
			32.82
		],
		[
			"2014-10-13",
			38.09
		],
		[
			"2015-10-08",
			37.2
		],
		[
			"2016-04-12",
			34.1
		],
		[
			"2001-09-28",
			39.02
		],
		[
			"2002-04-08",
			35.78
		],
		[
			"2002-10-01",
			39.19
		],
		[
			"2003-04-08",
			37.51
		],
		[
			"2009-08-20",
			32.24
		],
		[
			"2010-07-14",
			38.09
		],
		[
			"2011-08-23",
			34.54
		]
	],
	"73779817": [
		[
			"2013-08-06",
			70.41
		],
		[
			"2014-08-27",
			98.76
		],
		[
			"2015-08-12",
			59.79
		],
		[
			"2016-04-12",
			62
		],
		[
			"2001-09-26",
			61.56
		],
		[
			"2002-04-09",
			61.11
		],
		[
			"2002-10-02",
			64.21
		],
		[
			"2003-04-10",
			62.44
		],
		[
			"2007-07-18",
			100.53
		],
		[
			"2007-10-08",
			101.86
		],
		[
			"2008-08-05",
			72.19
		],
		[
			"2009-08-20",
			67.31
		],
		[
			"2010-08-11",
			70.86
		],
		[
			"2011-09-01",
			57.57
		]
	],
	"73785015": [
		[
			"2013-08-12",
			21.12
		],
		[
			"2013-11-19",
			14.97
		],
		[
			"2014-08-08",
			16.87
		],
		[
			"2015-06-17",
			10.27
		],
		[
			"2000-07-26",
			19.4
		],
		[
			"2001-07-18",
			28.3
		],
		[
			"2002-08-09",
			30.11
		],
		[
			"2003-09-09",
			27.99
		],
		[
			"2004-06-28",
			21.04
		],
		[
			"2005-07-28",
			28.7
		],
		[
			"2006-10-20",
			22.81
		],
		[
			"2007-07-13",
			25.6
		],
		[
			"2007-10-05",
			25.42
		],
		[
			"2008-07-17",
			24.18
		],
		[
			"2009-08-06",
			21.3
		],
		[
			"2010-06-24",
			24.49
		],
		[
			"2011-08-19",
			23.03
		]
	],
	"73903206": [
		[
			"2013-10-15",
			21.08
		],
		[
			"2014-11-10",
			19.8
		],
		[
			"2015-10-13",
			21.35
		],
		[
			"2000-08-21",
			24.58
		],
		[
			"2001-08-08",
			26.62
		],
		[
			"2001-08-15",
			25.38
		],
		[
			"2002-08-26",
			26.75
		],
		[
			"2003-09-30",
			26.26
		],
		[
			"2004-07-29",
			25.6
		],
		[
			"2005-08-18",
			25.46
		],
		[
			"2007-08-23",
			23.47
		],
		[
			"2008-10-16",
			21.74
		],
		[
			"2009-11-05",
			22.81
		],
		[
			"2007-10-29",
			22.23
		],
		[
			"2011-05-30",
			23.03
		]
	],
	"76402710": [
		[
			"2000-08-08",
			25.95
		],
		[
			"2001-07-20",
			27.72
		],
		[
			"2002-09-02",
			22.5
		],
		[
			"2003-09-10",
			7.93
		],
		[
			"2004-07-23",
			5.09
		],
		[
			"2005-07-19",
			17.49
		],
		[
			"2006-10-23",
			20.64
		],
		[
			"2000-04-26",
			29.91
		],
		[
			"2000-10-23",
			25.91
		],
		[
			"2001-04-30",
			28.51
		],
		[
			"2001-11-05",
			32.91
		],
		[
			"2002-07-16",
			26.21
		],
		[
			"2002-10-30",
			21.81
		],
		[
			"2003-05-07",
			16.71
		],
		[
			"2003-11-18",
			9.9
		],
		[
			"2004-04-26",
			5.5
		],
		[
			"2004-10-21",
			3.7
		],
		[
			"2005-04-25",
			11.8
		],
		[
			"2005-10-28",
			19.51
		],
		[
			"2006-04-06",
			21.11
		],
		[
			"2006-10-23",
			23.71
		],
		[
			"2006-12-15",
			25.01
		],
		[
			"2007-01-31",
			22.21
		],
		[
			"2007-06-28",
			20.81
		],
		[
			"2007-04-24",
			22.41
		],
		[
			"2007-09-27",
			23.07
		],
		[
			"2014-10-29",
			13.46
		],
		[
			"2015-04-29",
			15.73
		],
		[
			"2015-11-17",
			29.36
		]
	],
	"76503410": [
		[
			"2013-09-17",
			86.36
		],
		[
			"2014-09-23",
			80.6
		],
		[
			"2015-05-12",
			72.63
		],
		[
			"2000-09-19",
			109.83
		],
		[
			"2001-07-20",
			112.49
		],
		[
			"2002-09-24",
			91.23
		],
		[
			"2003-10-07",
			68.2
		],
		[
			"2004-06-16",
			77.94
		],
		[
			"2005-06-22",
			82.81
		],
		[
			"2006-10-24",
			84.14
		],
		[
			"2007-06-29",
			101.86
		],
		[
			"2007-09-27",
			109.39
		],
		[
			"2008-07-10",
			104.51
		],
		[
			"2009-07-24",
			99.64
		],
		[
			"2010-06-30",
			79.71
		],
		[
			"2011-05-26",
			70.86
		]
	],
	"76544710": [
		[
			"2013-09-26",
			1.33
		],
		[
			"2015-07-29",
			1.33
		],
		[
			"2004-03-02",
			0.44
		],
		[
			"2004-09-22",
			0.22
		],
		[
			"2005-03-10",
			0.22
		],
		[
			"2005-09-16",
			0.22
		],
		[
			"2007-06-29",
			2.21
		],
		[
			"2007-10-09",
			2.21
		],
		[
			"2008-11-06",
			2.21
		],
		[
			"2007-03-21",
			1.11
		],
		[
			"2007-09-10",
			1.11
		],
		[
			"2008-03-04",
			0.22
		],
		[
			"2008-09-19",
			4.43
		],
		[
			"2010-03-09",
			0.44
		],
		[
			"2010-09-16",
			0.44
		],
		[
			"2011-03-15",
			1.33
		],
		[
			"2011-09-12",
			1.33
		],
		[
			"2012-03-16",
			1.33
		],
		[
			"2012-09-19",
			1.33
		],
		[
			"2013-03-18",
			1.33
		],
		[
			"2013-09-02",
			1.33
		],
		[
			"2009-09-08",
			2.21
		],
		[
			"2010-07-26",
			2.21
		],
		[
			"2011-08-31",
			1.33
		]
	],
	"76555112": [
		[
			"2013-09-12",
			52.7
		],
		[
			"2014-09-23",
			50.04
		],
		[
			"2015-07-14",
			49.16
		],
		[
			"2000-08-07",
			54.47
		],
		[
			"2001-07-23",
			56.24
		],
		[
			"2002-08-13",
			63.77
		],
		[
			"2003-09-11",
			59.34
		],
		[
			"2005-07-29",
			56.24
		],
		[
			"2006-10-24",
			46.94
		],
		[
			"2007-06-29",
			51.81
		],
		[
			"2007-10-09",
			50.93
		],
		[
			"2008-07-22",
			47.83
		],
		[
			"2008-08-19",
			46.06
		],
		[
			"2009-08-26",
			48.27
		],
		[
			"2010-07-09",
			52.7
		],
		[
			"2011-08-31",
			48.71
		]
	],
	"76632015": [
		[
			"2013-08-28",
			18.47
		],
		[
			"2014-09-19",
			15.9
		],
		[
			"2015-05-21",
			17.01
		],
		[
			"2007-07-02",
			19.22
		],
		[
			"2007-10-16",
			18.95
		],
		[
			"2008-07-11",
			20.81
		],
		[
			"2009-07-28",
			18.38
		],
		[
			"2010-07-20",
			4.87
		],
		[
			"2011-09-02",
			7.97
		]
	],
	"76672815": [
		[
			"2013-05-13",
			0.5
		],
		[
			"2014-04-15",
			0.5
		],
		[
			"2015-04-14",
			0.5
		],
		[
			"2012-04-25",
			0.5
		],
		[
			"2011-04-19",
			0.5
		],
		[
			"2010-04-14",
			0.5
		],
		[
			"2009-03-31",
			0.5
		],
		[
			"2008-04-02",
			0.5
		],
		[
			"2006-05-09",
			0.5
		]
	],
	"76727609": [
		[
			"2013-10-10",
			1.33
		],
		[
			"2014-10-24",
			1.33
		],
		[
			"2015-04-01",
			1.33
		],
		[
			"2016-03-24",
			1.33
		],
		[
			"2000-08-14",
			14.84
		],
		[
			"2001-07-26",
			11.96
		],
		[
			"2002-08-16",
			16.25
		],
		[
			"2003-09-25",
			15.72
		],
		[
			"2004-07-26",
			10.63
		],
		[
			"2005-08-15",
			5.93
		],
		[
			"2007-08-16",
			10.41
		],
		[
			"2009-12-03",
			5.67
		],
		[
			"2007-10-25",
			21.08
		],
		[
			"2011-06-01",
			3.19
		]
	],
	"76734985": [
		[
			"2013-10-10",
			67.76
		],
		[
			"2014-10-24",
			56.24
		],
		[
			"2015-04-01",
			52.26
		],
		[
			"2016-03-24",
			48.71
		],
		[
			"2000-08-10",
			77.06
		],
		[
			"2001-07-26",
			77.94
		],
		[
			"2002-08-16",
			79.71
		],
		[
			"2003-09-25",
			62.89
		],
		[
			"2005-08-15",
			71.74
		],
		[
			"2008-11-20",
			51.81
		],
		[
			"2009-12-03",
			70.86
		],
		[
			"2011-06-01",
			62
		]
	],
	"76737718": [
		[
			"2013-09-12",
			25.11
		],
		[
			"2014-09-16",
			49.16
		],
		[
			"2015-04-17",
			69.97
		],
		[
			"2007-07-03",
			18.73
		],
		[
			"2007-10-08",
			24.18
		],
		[
			"2008-08-25",
			18.16
		],
		[
			"2009-08-17",
			35.74
		],
		[
			"2010-08-11",
			35.87
		]
	],
	"76744218": [
		[
			"2000-07-31",
			29.14
		],
		[
			"2001-07-24",
			35.12
		],
		[
			"2003-09-12",
			29.49
		],
		[
			"2004-07-16",
			31.09
		],
		[
			"2005-07-29",
			29.45
		],
		[
			"2006-10-24",
			27.94
		],
		[
			"2012-06-05",
			19.91
		],
		[
			"2013-11-04",
			19.41
		],
		[
			"2014-05-15",
			19.11
		],
		[
			"2015-10-22",
			19.11
		]
	],
	"76769306": [
		[
			"2013-10-10",
			8.68
		],
		[
			"2014-11-17",
			2.08
		],
		[
			"2015-04-08",
			5.62
		],
		[
			"2000-08-14",
			2.21
		],
		[
			"2001-08-02",
			2.21
		],
		[
			"2002-08-19",
			12.58
		],
		[
			"2003-09-30",
			2.21
		],
		[
			"2004-07-26",
			2.21
		],
		[
			"2005-08-16",
			2.21
		],
		[
			"2007-08-17",
			13.29
		],
		[
			"2008-10-16",
			11.38
		],
		[
			"2009-11-05",
			2.21
		],
		[
			"2007-10-29",
			12.53
		],
		[
			"2011-05-30",
			1.33
		]
	],
	"76781010": [
		[
			"2013-09-12",
			20.02
		],
		[
			"2014-09-22",
			23.47
		],
		[
			"2015-07-21",
			22.54
		],
		[
			"2000-07-31",
			23.47
		],
		[
			"2001-07-30",
			26.84
		],
		[
			"2002-08-14",
			28.56
		],
		[
			"2003-09-23",
			25.95
		],
		[
			"2004-07-16",
			26.48
		],
		[
			"2005-07-28",
			20.9
		],
		[
			"2007-07-17",
			18.51
		],
		[
			"2007-10-10",
			17.63
		],
		[
			"2008-08-14",
			17.05
		],
		[
			"2009-09-11",
			22.23
		],
		[
			"2010-07-22",
			21.04
		],
		[
			"2011-08-31",
			15.94
		]
	],
	"76806420": [
		[
			"2013-09-24",
			19.26
		],
		[
			"2015-08-06",
			18.25
		],
		[
			"2007-10-09",
			15.85
		],
		[
			"2008-07-24",
			17.36
		],
		[
			"2013-04-02",
			15.31
		],
		[
			"2009-07-30",
			16.87
		],
		[
			"2010-07-05",
			18.16
		],
		[
			"2011-06-28",
			19.04
		]
	],
	"76809201": [
		[
			"2013-10-21",
			1.33
		],
		[
			"2014-11-04",
			1.33
		],
		[
			"2015-03-31",
			1.33
		],
		[
			"2016-03-02",
			1.59
		],
		[
			"2000-08-21",
			2.21
		],
		[
			"2001-08-09",
			2.21
		],
		[
			"2002-08-29",
			2.21
		],
		[
			"2003-10-02",
			2.21
		],
		[
			"2004-07-27",
			2.21
		],
		[
			"2005-08-22",
			2.21
		],
		[
			"2007-08-27",
			2.21
		],
		[
			"2007-10-31",
			2.21
		],
		[
			"2008-10-13",
			2.21
		],
		[
			"2009-11-11",
			2.21
		],
		[
			"2010-08-24",
			1.33
		],
		[
			"2011-12-01",
			1.06
		]
	],
	"76809304": [
		[
			"2013-10-23",
			1.33
		],
		[
			"2014-11-04",
			1.55
		],
		[
			"2015-03-31",
			2.26
		],
		[
			"2000-08-22",
			2.57
		],
		[
			"2001-08-09",
			2.21
		],
		[
			"2002-08-28",
			2.21
		],
		[
			"2003-10-01",
			3.28
		],
		[
			"2004-07-30",
			2.21
		],
		[
			"2005-08-22",
			2.52
		],
		[
			"2007-08-20",
			2.21
		],
		[
			"2008-10-23",
			4.83
		],
		[
			"2009-10-12",
			2.79
		],
		[
			"2007-10-26",
			2.48
		],
		[
			"2010-09-08",
			1.33
		],
		[
			"2011-11-16",
			1.95
		]
	],
	"76809407": [
		[
			"2014-12-08",
			9.03
		],
		[
			"2015-04-22",
			8.99
		],
		[
			"2000-08-23",
			14.44
		],
		[
			"2001-08-13",
			13.46
		],
		[
			"2002-08-28",
			14.61
		],
		[
			"2003-10-15",
			11.25
		],
		[
			"2004-07-30",
			0
		],
		[
			"2005-08-23",
			11.34
		]
	],
	"76809500": [
		[
			"2013-10-16",
			1.33
		],
		[
			"2014-11-05",
			7.66
		],
		[
			"2015-03-30",
			11.16
		],
		[
			"2000-08-23",
			7.66
		],
		[
			"2001-08-13",
			7.09
		],
		[
			"2002-08-29",
			8.99
		],
		[
			"2003-10-16",
			10.81
		],
		[
			"2004-08-02",
			9.3
		],
		[
			"2005-08-23",
			9.96
		],
		[
			"2007-08-21",
			10.45
		],
		[
			"2007-11-05",
			8.99
		],
		[
			"2008-10-17",
			8.77
		],
		[
			"2009-12-01",
			12.93
		],
		[
			"2010-09-15",
			9.74
		],
		[
			"2011-11-23",
			2.17
		]
	],
	"76811311": [
		[
			"2013-08-30",
			12.62
		],
		[
			"2014-09-26",
			15.68
		],
		[
			"2015-07-30",
			13.15
		],
		[
			"2002-10-15",
			13.06
		],
		[
			"2003-04-08",
			12.44
		],
		[
			"2003-11-06",
			15.46
		],
		[
			"2004-04-22",
			16.96
		],
		[
			"2007-07-03",
			16.96
		],
		[
			"2007-10-16",
			15.23
		],
		[
			"2008-07-30",
			12.44
		],
		[
			"2009-08-18",
			13.99
		],
		[
			"2010-07-15",
			15.06
		],
		[
			"2011-09-01",
			13.29
		]
	],
	"76815717": [
		[
			"2013-09-27",
			1.55
		],
		[
			"2014-09-25",
			1.33
		],
		[
			"2015-07-17",
			11.69
		],
		[
			"2001-01-10",
			3.1
		],
		[
			"2001-04-26",
			29.67
		],
		[
			"2001-07-05",
			41.63
		],
		[
			"2001-10-09",
			11.07
		],
		[
			"2002-07-02",
			36.76
		],
		[
			"2000-07-04",
			4.43
		],
		[
			"2000-10-10",
			2.66
		],
		[
			"2000-04-11",
			4.43
		],
		[
			"2002-01-16",
			8.86
		],
		[
			"2002-04-17",
			39.86
		],
		[
			"2000-01-18",
			7.75
		],
		[
			"2002-10-22",
			13.29
		],
		[
			"2003-01-14",
			9.74
		],
		[
			"2003-04-09",
			38.09
		],
		[
			"2003-07-16",
			27.9
		],
		[
			"2003-10-16",
			13.29
		],
		[
			"2004-01-06",
			8.86
		],
		[
			"2004-04-24",
			19.04
		],
		[
			"2004-07-06",
			19.93
		],
		[
			"2004-10-27",
			6.2
		],
		[
			"2005-01-11",
			12.84
		],
		[
			"2005-04-05",
			20.37
		],
		[
			"2005-07-06",
			8.86
		],
		[
			"2005-10-18",
			18.6
		],
		[
			"2007-07-13",
			5
		],
		[
			"2007-10-08",
			4.47
		],
		[
			"2007-01-08",
			9.74
		],
		[
			"2007-04-24",
			4.43
		],
		[
			"2007-07-04",
			4.07
		],
		[
			"2007-10-09",
			2.21
		],
		[
			"2008-02-12",
			4.43
		],
		[
			"2008-04-01",
			8.41
		],
		[
			"2008-07-02",
			24.36
		],
		[
			"2008-10-21",
			6.2
		],
		[
			"2010-01-20",
			3.99
		],
		[
			"2010-04-07",
			4.87
		],
		[
			"2010-07-06",
			10.19
		],
		[
			"2010-10-19",
			3.1
		],
		[
			"2011-01-11",
			2.21
		],
		[
			"2011-02-28",
			16.08
		],
		[
			"2011-04-05",
			57.57
		],
		[
			"2011-07-12",
			27.01
		],
		[
			"2011-11-04",
			10.63
		],
		[
			"2012-01-10",
			8.86
		],
		[
			"2012-04-03",
			6.2
		],
		[
			"2012-07-10",
			2.21
		],
		[
			"2012-10-09",
			4.87
		],
		[
			"2013-01-15",
			2.21
		],
		[
			"2013-04-17",
			2.21
		],
		[
			"2013-07-16",
			2.21
		],
		[
			"2013-10-15",
			2.21
		],
		[
			"2009-07-30",
			13.15
		],
		[
			"2008-07-24",
			24.49
		],
		[
			"2010-08-11",
			4.43
		],
		[
			"2011-06-28",
			27.01
		]
	],
	"76819310": [
		[
			"2013-08-28",
			16.43
		],
		[
			"2015-07-23",
			23.74
		],
		[
			"2007-10-15",
			15.41
		],
		[
			"2008-08-04",
			17.49
		],
		[
			"2009-08-18",
			17.4
		],
		[
			"2010-07-15",
			28.65
		],
		[
			"2011-09-05",
			19.04
		]
	],
	"76832314": [
		[
			"2014-10-21",
			64.66
		],
		[
			"2015-08-04",
			67.31
		],
		[
			"2000-08-09",
			134.63
		],
		[
			"2001-07-24",
			22.23
		],
		[
			"2002-08-15",
			3.9
		],
		[
			"2003-09-12",
			2.21
		],
		[
			"2004-07-28",
			0
		],
		[
			"2005-08-05",
			13.37
		],
		[
			"2007-07-23",
			96.54
		],
		[
			"2008-08-21",
			108.94
		],
		[
			"2009-09-09",
			99.2
		],
		[
			"2007-10-10",
			115.14
		],
		[
			"2010-07-22",
			10.45
		]
	],
	"76839217": [
		[
			"2013-08-23",
			8.55
		],
		[
			"2014-09-16",
			7.31
		],
		[
			"2015-05-13",
			7.13
		],
		[
			"2007-07-02",
			13.02
		],
		[
			"2007-10-16",
			13.11
		],
		[
			"2008-07-29",
			11.87
		],
		[
			"2009-08-12",
			8.81
		],
		[
			"2010-07-19",
			7.66
		],
		[
			"2011-08-30",
			6.2
		]
	],
	"76839916": [
		[
			"2014-12-03",
			1.33
		],
		[
			"2015-05-13",
			1.33
		]
	],
	"76840116": [
		[
			"2013-08-23",
			2.13
		],
		[
			"2014-09-16",
			25.77
		],
		[
			"2015-05-13",
			1.68
		],
		[
			"2007-07-02",
			52.26
		],
		[
			"2008-07-28",
			2.21
		],
		[
			"2009-08-11",
			4.34
		],
		[
			"2010-07-08",
			62
		],
		[
			"2011-06-29",
			14.17
		]
	],
	"76849211": [
		[
			"2000-02-29",
			23.29
		],
		[
			"2001-03-06",
			24.36
		],
		[
			"2001-08-15",
			22.28
		],
		[
			"2002-02-21",
			20.5
		],
		[
			"2002-08-28",
			23.78
		],
		[
			"2003-02-19",
			20.15
		],
		[
			"2003-08-29",
			21.26
		],
		[
			"2007-07-19",
			19.53
		],
		[
			"2007-10-10",
			17.09
		],
		[
			"2008-08-19",
			16.25
		],
		[
			"2013-03-20",
			18.82
		],
		[
			"2012-09-18",
			14.04
		],
		[
			"2013-09-19",
			16.81
		],
		[
			"2014-09-18",
			0.44
		],
		[
			"2010-03-02",
			13.73
		],
		[
			"2010-08-25",
			15.5
		],
		[
			"2011-02-28",
			14.17
		],
		[
			"2011-09-14",
			15.94
		],
		[
			"2012-03-20",
			17.45
		],
		[
			"2013-09-18",
			16.83
		],
		[
			"2014-03-25",
			16.52
		],
		[
			"2015-03-20",
			14.51
		],
		[
			"2015-12-18",
			17.21
		],
		[
			"2015-09-18",
			15.31
		],
		[
			"2009-09-11",
			16.52
		],
		[
			"2010-07-26",
			15.94
		]
	],
	"76866713": [
		[
			"2013-09-04",
			30.29
		],
		[
			"2014-09-22",
			22.9
		],
		[
			"2015-07-22",
			16.74
		],
		[
			"2007-07-04",
			37.02
		],
		[
			"2007-10-15",
			30.34
		],
		[
			"2008-07-23",
			33.7
		],
		[
			"2009-07-29",
			30.16
		],
		[
			"2010-07-12",
			22.63
		],
		[
			"2011-06-30",
			20.81
		]
	],
	"76886414": [
		[
			"2013-09-04",
			49.6
		],
		[
			"2014-09-22",
			41.67
		],
		[
			"2015-07-23",
			46.06
		],
		[
			"2000-04-25",
			47.83
		],
		[
			"2000-09-14",
			55.36
		],
		[
			"2007-07-04",
			47.83
		],
		[
			"2007-10-15",
			46.06
		],
		[
			"2008-08-14",
			43.58
		],
		[
			"2009-08-19",
			45.61
		],
		[
			"2010-07-21",
			47.83
		],
		[
			"2011-09-05",
			41.63
		]
	],
	"76929012": [
		[
			"2013-11-19",
			1.33
		],
		[
			"2014-09-18",
			1.33
		],
		[
			"2015-07-28",
			1.33
		],
		[
			"2007-07-04",
			2.21
		],
		[
			"2007-10-11",
			2.21
		],
		[
			"2008-07-23",
			2.21
		],
		[
			"2009-07-29",
			3.23
		],
		[
			"2010-07-12",
			2.21
		],
		[
			"2011-06-30",
			1.95
		]
	],
	"76929218": [
		[
			"2013-09-19",
			15.32
		],
		[
			"2014-09-18",
			16.03
		],
		[
			"2015-07-28",
			15.37
		],
		[
			"2007-07-04",
			18.87
		],
		[
			"2007-10-11",
			15.41
		],
		[
			"2008-07-23",
			15.68
		],
		[
			"2009-08-19",
			15.5
		],
		[
			"2010-07-12",
			15.81
		],
		[
			"2011-06-30",
			15.94
		]
	],
	"76929310": [
		[
			"2013-09-19",
			18.33
		],
		[
			"2014-09-18",
			18.87
		],
		[
			"2015-07-28",
			15.59
		],
		[
			"2007-07-05",
			18.78
		],
		[
			"2007-10-11",
			18.33
		],
		[
			"2008-08-14",
			19.4
		],
		[
			"2009-08-19",
			17.94
		],
		[
			"2010-07-12",
			19.13
		],
		[
			"2011-06-30",
			16.83
		]
	],
	"76931912": [
		[
			"2013-09-06",
			29.85
		],
		[
			"2014-09-18",
			37.24
		],
		[
			"2015-07-27",
			38.62
		],
		[
			"2000-04-26",
			36.09
		],
		[
			"2000-09-15",
			35.3
		],
		[
			"2007-07-05",
			34.99
		],
		[
			"2007-10-15",
			24.53
		],
		[
			"2008-08-14",
			27.37
		],
		[
			"2009-08-19",
			25.24
		],
		[
			"2010-07-21",
			28.43
		]
	],
	"76934019": [
		[
			"2013-09-11",
			3.5
		],
		[
			"2014-10-20",
			2.61
		],
		[
			"2015-08-11",
			2.21
		],
		[
			"2007-07-05",
			4.38
		],
		[
			"2007-10-17",
			3.94
		],
		[
			"2008-07-23",
			4.34
		],
		[
			"2009-09-09",
			3.23
		],
		[
			"2010-07-09",
			3.85
		],
		[
			"2011-09-05",
			3.06
		]
	],
	"76956805": [
		[
			"2013-10-10",
			21.48
		],
		[
			"2014-10-24",
			13.2
		],
		[
			"2015-04-01",
			21.52
		],
		[
			"2016-03-24",
			20.81
		],
		[
			"2007-07-19",
			22.67
		],
		[
			"2007-10-10",
			22.72
		],
		[
			"2008-10-20",
			21.92
		],
		[
			"2009-09-09",
			23.12
		],
		[
			"2010-12-01",
			20.81
		],
		[
			"2011-12-14",
			24.8
		]
	],
	"76965612": [
		[
			"2013-05-15",
			8.9
		],
		[
			"2013-10-02",
			7.8
		],
		[
			"2014-04-08",
			8.3
		],
		[
			"2015-04-08",
			9.4
		],
		[
			"2014-10-31",
			7.6
		]
	],
	"76981113": [
		[
			"2014-12-09",
			1.33
		],
		[
			"2015-08-14",
			1.33
		],
		[
			"2008-08-04",
			2.21
		],
		[
			"2009-08-18",
			2.21
		],
		[
			"2010-07-21",
			2.21
		]
	],
	"76987218": [
		[
			"2014-12-09",
			22.36
		],
		[
			"2015-08-17",
			8.06
		],
		[
			"2007-10-17",
			2.75
		],
		[
			"2008-07-31",
			7.44
		],
		[
			"2009-08-13",
			2.57
		],
		[
			"2010-07-23",
			5.31
		]
	],
	"76988399": [
		[
			"2013-10-14",
			17.58
		],
		[
			"2014-10-31",
			22.81
		],
		[
			"2015-03-26",
			14.88
		],
		[
			"2008-11-24",
			15.06
		],
		[
			"2009-11-27",
			16.43
		],
		[
			"2010-10-01",
			19.04
		],
		[
			"2011-12-14",
			15.5
		]
	],
	"76988491": [
		[
			"2013-10-28",
			11.51
		],
		[
			"2014-07-02",
			10.72
		],
		[
			"2015-03-26",
			15.23
		],
		[
			"2007-07-18",
			10.76
		],
		[
			"2007-10-18",
			10.45
		],
		[
			"2008-08-22",
			10.72
		],
		[
			"2009-12-08",
			10.81
		],
		[
			"2010-10-04",
			9.3
		],
		[
			"2011-12-13",
			10.1
		]
	],
	"76988594": [
		[
			"2013-10-14",
			8.19
		],
		[
			"2014-07-02",
			8.37
		],
		[
			"2015-03-25",
			9.03
		],
		[
			"2007-07-18",
			6.29
		],
		[
			"2007-11-06",
			6.55
		],
		[
			"2008-10-31",
			6.95
		],
		[
			"2009-10-07",
			7.31
		],
		[
			"2010-10-04",
			6.64
		],
		[
			"2011-12-13",
			7.62
		]
	],
	"76990280": [
		[
			"2014-07-14",
			26.44
		],
		[
			"2015-03-25",
			25.55
		],
		[
			"2007-07-18",
			35.16
		],
		[
			"2007-10-18",
			40.61
		],
		[
			"2008-08-22",
			30.82
		],
		[
			"2009-10-07",
			26.31
		],
		[
			"2010-10-01",
			44.29
		]
	],
	"80000046": [
		[
			"2013-07-12",
			42.07
		],
		[
			"2014-12-01",
			63.77
		],
		[
			"2015-09-30",
			74.4
		],
		[
			"2000-01-07",
			78.39
		],
		[
			"2000-11-16",
			78.39
		],
		[
			"2001-03-19",
			62.89
		],
		[
			"2001-10-17",
			59.79
		],
		[
			"2002-05-10",
			64.66
		],
		[
			"2003-03-05",
			73.07
		],
		[
			"2003-09-10",
			81.93
		],
		[
			"2004-02-16",
			87.69
		],
		[
			"2004-09-21",
			117.36
		],
		[
			"2005-04-05",
			110.71
		],
		[
			"2006-04-20",
			78.39
		],
		[
			"2006-12-15",
			75.29
		],
		[
			"2007-07-02",
			67.76
		],
		[
			"2008-05-20",
			52.7
		],
		[
			"2010-01-26",
			62
		],
		[
			"2011-01-19",
			62.89
		],
		[
			"2011-08-22",
			59.34
		],
		[
			"2012-09-10",
			42.78
		]
	],
	"80000113": [
		[
			"2015-09-01",
			16.87
		],
		[
			"2000-10-30",
			83.7
		],
		[
			"2000-12-18",
			154.56
		],
		[
			"2001-02-28",
			259.51
		],
		[
			"2001-09-27",
			44.24
		],
		[
			"2002-04-05",
			169.61
		],
		[
			"2003-07-29",
			38.09
		],
		[
			"2004-03-04",
			80.6
		],
		[
			"2004-10-01",
			66.87
		],
		[
			"2005-03-07",
			103.19
		],
		[
			"2006-01-17",
			93.44
		],
		[
			"2006-11-08",
			228.07
		],
		[
			"2007-07-24",
			57.13
		],
		[
			"2008-02-25",
			70.41
		],
		[
			"2003-02-14",
			122.23
		],
		[
			"2010-01-12",
			72.63
		],
		[
			"2011-01-12",
			48.27
		],
		[
			"2012-03-01",
			61.56
		],
		[
			"2013-02-05",
			53.59
		]
	],
	"80100612": [
		[
			"2014-09-09",
			108.94
		],
		[
			"2015-09-10",
			102.3
		],
		[
			"2000-04-05",
			94.77
		],
		[
			"2000-10-04",
			95.66
		],
		[
			"2001-02-08",
			96.99
		],
		[
			"2001-09-12",
			96.99
		],
		[
			"2002-03-25",
			80.6
		],
		[
			"2003-07-03",
			91.23
		],
		[
			"2004-04-20",
			95.66
		],
		[
			"2004-11-04",
			88.57
		],
		[
			"2005-04-15",
			89.46
		],
		[
			"2006-09-29",
			90.79
		],
		[
			"2007-08-31",
			87.69
		],
		[
			"2008-04-17",
			94.77
		],
		[
			"2003-01-24",
			91.23
		],
		[
			"2005-11-29",
			89.46
		],
		[
			"2009-11-10",
			89.01
		],
		[
			"2010-11-04",
			99.64
		],
		[
			"2012-10-01",
			118.24
		]
	],
	"80100697": [
		[
			"2013-05-02",
			96.99
		],
		[
			"2015-09-08",
			68.64
		],
		[
			"2000-10-25",
			111.6
		],
		[
			"2001-02-20",
			85.47
		],
		[
			"2001-09-21",
			125.33
		],
		[
			"2002-02-21",
			99.64
		],
		[
			"2003-07-24",
			108.94
		],
		[
			"2004-01-16",
			142.6
		],
		[
			"2004-10-11",
			139.06
		],
		[
			"2005-04-19",
			62.44
		],
		[
			"2006-01-05",
			89.01
		],
		[
			"2007-08-23",
			58.9
		],
		[
			"2008-03-05",
			101.86
		],
		[
			"2003-02-06",
			104.07
		],
		[
			"2006-11-03",
			115.59
		],
		[
			"2009-12-02",
			46.5
		],
		[
			"2010-11-10",
			58.9
		],
		[
			"2011-06-01",
			99.64
		],
		[
			"2012-10-26",
			88.13
		]
	],
	"80100806": [
		[
			"2015-09-09",
			88.57
		],
		[
			"2000-01-17",
			60.23
		],
		[
			"2000-10-23",
			62
		],
		[
			"2001-03-09",
			160.76
		],
		[
			"2001-04-23",
			65.54
		],
		[
			"2001-10-05",
			71.74
		],
		[
			"2002-04-12",
			59.34
		],
		[
			"2002-07-01",
			65.99
		],
		[
			"2003-02-26",
			60.23
		],
		[
			"2003-07-07",
			64.21
		],
		[
			"2004-03-31",
			66.87
		],
		[
			"2004-10-04",
			68.64
		],
		[
			"2005-03-14",
			65.1
		],
		[
			"2006-01-25",
			75.73
		],
		[
			"2006-10-11",
			73.96
		],
		[
			"2008-04-07",
			73.51
		],
		[
			"2007-07-26",
			73.96
		],
		[
			"2005-09-19",
			61.56
		],
		[
			"2009-12-16",
			71.3
		],
		[
			"2010-11-02",
			64.21
		],
		[
			"2011-08-18",
			57.13
		]
	],
	"80100818": [
		[
			"2014-09-15",
			60.23
		],
		[
			"2015-07-10",
			51.37
		],
		[
			"2007-09-07",
			46.5
		],
		[
			"2005-04-19",
			54.47
		],
		[
			"2008-03-10",
			54.47
		],
		[
			"2006-10-11",
			53.59
		],
		[
			"2010-11-10",
			56.69
		],
		[
			"2011-06-01",
			56.24
		],
		[
			"2012-10-02",
			58.01
		],
		[
			"2013-02-25",
			53.59
		]
	],
	"80100946": [
		[
			"2013-07-01",
			30.82
		],
		[
			"2014-05-27",
			20.5
		],
		[
			"2015-02-27",
			21.74
		],
		[
			"2000-02-09",
			11.51
		],
		[
			"2000-09-12",
			13.29
		],
		[
			"2001-01-19",
			9.3
		],
		[
			"2001-07-17",
			8.86
		],
		[
			"2002-01-14",
			11.07
		],
		[
			"2002-09-17",
			8.41
		],
		[
			"2003-06-11",
			13.11
		],
		[
			"2004-01-13",
			16.39
		],
		[
			"2004-11-26",
			52.26
		],
		[
			"2006-09-19",
			35.74
		],
		[
			"2007-08-31",
			51.81
		],
		[
			"2007-11-26",
			51.81
		],
		[
			"2008-07-09",
			38.66
		],
		[
			"2010-06-10",
			22.76
		],
		[
			"2011-05-18",
			21.92
		],
		[
			"2012-12-18",
			39.72
		]
	],
	"80200357": [
		[
			"2013-07-01",
			22.32
		],
		[
			"2014-12-11",
			16.65
		],
		[
			"2015-10-15",
			17.49
		],
		[
			"2000-03-03",
			30.11
		],
		[
			"2000-09-15",
			38.53
		],
		[
			"2001-01-25",
			45.17
		],
		[
			"2001-11-13",
			42.51
		],
		[
			"2002-01-23",
			40.74
		],
		[
			"2002-09-11",
			35.87
		],
		[
			"2003-06-12",
			34.41
		],
		[
			"2004-02-05",
			37.64
		],
		[
			"2004-10-26",
			31.58
		],
		[
			"2005-04-25",
			28.83
		],
		[
			"2005-11-02",
			22.72
		],
		[
			"2006-08-25",
			22.45
		],
		[
			"2007-10-10",
			20.99
		],
		[
			"2007-05-16",
			23.03
		],
		[
			"2008-06-09",
			19.26
		],
		[
			"2010-06-08",
			24.98
		],
		[
			"2010-12-13",
			23.12
		],
		[
			"2011-09-01",
			28.12
		],
		[
			"2012-09-24",
			23.83
		]
	],
	"80200734": [
		[
			"2006-11-30",
			27.01
		],
		[
			"2007-06-19",
			22.31
		],
		[
			"2008-05-05",
			27.31
		],
		[
			"2009-04-22",
			29.01
		],
		[
			"2010-03-02",
			34.01
		],
		[
			"2013-05-24",
			36.27
		],
		[
			"2014-12-17",
			33.92
		],
		[
			"2015-09-10",
			32.15
		],
		[
			"2000-04-05",
			40.3
		],
		[
			"2000-10-11",
			40.3
		],
		[
			"2001-02-08",
			40.74
		],
		[
			"2001-10-04",
			37.64
		],
		[
			"2002-03-25",
			35.87
		],
		[
			"2003-07-03",
			31
		],
		[
			"2004-04-26",
			29.67
		],
		[
			"2004-11-04",
			29.36
		],
		[
			"2005-04-15",
			23.91
		],
		[
			"2006-10-26",
			29.27
		],
		[
			"2007-07-12",
			23.96
		],
		[
			"2008-04-17",
			30.11
		],
		[
			"2011-01-25",
			35.01
		],
		[
			"2012-01-02",
			38.01
		],
		[
			"2013-01-23",
			41.01
		],
		[
			"2014-01-14",
			35.01
		],
		[
			"2015-01-16",
			32.01
		],
		[
			"2003-01-24",
			30.11
		],
		[
			"2005-11-29",
			26.84
		],
		[
			"2009-10-30",
			25.82
		],
		[
			"2010-11-23",
			34.28
		],
		[
			"2011-06-28",
			38.93
		],
		[
			"2012-12-07",
			38.93
		]
	],
	"80200758": [
		[
			"2013-04-25",
			70.41
		],
		[
			"2014-08-25",
			67.31
		],
		[
			"2015-05-22",
			62
		],
		[
			"2000-01-05",
			128.87
		],
		[
			"2000-11-10",
			137.29
		],
		[
			"2001-03-09",
			142.6
		],
		[
			"2001-10-15",
			133.74
		],
		[
			"2002-04-22",
			137.73
		],
		[
			"2003-09-01",
			127.54
		],
		[
			"2004-04-29",
			123.56
		],
		[
			"2004-08-10",
			126.21
		],
		[
			"2005-03-31",
			124.44
		],
		[
			"2006-03-06",
			109.83
		],
		[
			"2006-12-11",
			50.49
		],
		[
			"2007-08-14",
			72.19
		],
		[
			"2008-03-11",
			64.66
		],
		[
			"2003-02-24",
			136.4
		],
		[
			"2010-01-21",
			85.03
		],
		[
			"2011-02-22",
			76.17
		],
		[
			"2012-11-09",
			67.31
		]
	],
	"80200801": [
		[
			"2014-02-10",
			20.73
		],
		[
			"2015-03-17",
			21.08
		],
		[
			"2016-01-06",
			21.26
		],
		[
			"2000-02-02",
			31.44
		],
		[
			"2000-08-14",
			32.33
		],
		[
			"2001-01-03",
			38.97
		],
		[
			"2001-07-13",
			35.87
		],
		[
			"2002-01-18",
			38.09
		],
		[
			"2002-09-05",
			35.87
		],
		[
			"2003-04-14",
			38.97
		],
		[
			"2003-12-10",
			38.97
		],
		[
			"2004-03-23",
			35.87
		],
		[
			"2004-09-07",
			33.26
		],
		[
			"2004-12-16",
			32.33
		],
		[
			"2005-11-03",
			27.59
		],
		[
			"2006-08-21",
			24.84
		],
		[
			"2006-10-12",
			25.02
		],
		[
			"2007-09-17",
			21.57
		],
		[
			"2008-05-21",
			19.71
		],
		[
			"2010-07-14",
			22.72
		],
		[
			"2011-06-09",
			21.35
		],
		[
			"2012-08-27",
			22.1
		],
		[
			"2013-03-06",
			24.58
		]
	],
	"80200953": [
		[
			"2013-07-09",
			78.39
		],
		[
			"2014-08-12",
			78.83
		],
		[
			"2015-06-18",
			74.84
		],
		[
			"2016-01-26",
			79.71
		],
		[
			"2000-02-22",
			109.83
		],
		[
			"2000-08-30",
			110.71
		],
		[
			"2001-01-12",
			110.71
		],
		[
			"2001-08-24",
			106.29
		],
		[
			"2002-03-12",
			107.17
		],
		[
			"2003-05-21",
			104.51
		],
		[
			"2003-12-17",
			99.64
		],
		[
			"2004-04-14",
			96.54
		],
		[
			"2004-08-13",
			96.54
		],
		[
			"2004-12-09",
			96.54
		],
		[
			"2005-11-18",
			88.57
		],
		[
			"2006-08-29",
			87.24
		],
		[
			"2007-05-08",
			78.83
		],
		[
			"2007-11-16",
			74.84
		],
		[
			"2008-07-17",
			73.07
		],
		[
			"2008-11-03",
			73.07
		],
		[
			"2009-08-19",
			71.74
		],
		[
			"2010-09-07",
			73.51
		],
		[
			"2011-06-08",
			65.99
		],
		[
			"2012-10-29",
			74.84
		]
	],
	"80201520": [
		[
			"2014-09-25",
			74.4
		],
		[
			"2015-06-23",
			67.31
		],
		[
			"2000-03-08",
			58.01
		],
		[
			"2000-10-05",
			60.67
		],
		[
			"2001-01-31",
			60.67
		],
		[
			"2001-09-04",
			72.19
		],
		[
			"2002-02-05",
			66.43
		],
		[
			"2003-01-07",
			81.04
		],
		[
			"2003-06-16",
			86.36
		],
		[
			"2004-01-26",
			84.59
		],
		[
			"2004-09-08",
			92.56
		],
		[
			"2005-02-01",
			93.44
		],
		[
			"2006-09-21",
			91.67
		],
		[
			"2007-01-26",
			89.01
		],
		[
			"2007-11-30",
			91.67
		],
		[
			"2008-07-22",
			81.49
		],
		[
			"2005-12-01",
			95.21
		],
		[
			"2009-10-06",
			69.09
		],
		[
			"2010-09-30",
			71.3
		],
		[
			"2011-03-25",
			68.2
		],
		[
			"2012-01-24",
			68.64
		],
		[
			"2013-01-10",
			65.54
		]
	],
	"80201556": [
		[
			"2014-06-04",
			1.33
		],
		[
			"2015-10-14",
			0.13
		],
		[
			"2000-03-08",
			1.33
		],
		[
			"2000-09-25",
			1.33
		],
		[
			"2001-01-31",
			1.33
		],
		[
			"2001-09-04",
			1.33
		],
		[
			"2002-02-05",
			1.33
		],
		[
			"2003-06-16",
			1.33
		],
		[
			"2004-01-26",
			1.33
		],
		[
			"2004-09-08",
			1.33
		],
		[
			"2005-02-01",
			1.33
		],
		[
			"2006-10-09",
			1.33
		],
		[
			"2007-01-26",
			1.33
		],
		[
			"2007-11-30",
			1.33
		],
		[
			"2008-07-22",
			1.33
		],
		[
			"2003-01-20",
			1.33
		],
		[
			"2005-12-01",
			1.33
		],
		[
			"2009-10-26",
			0.13
		],
		[
			"2010-11-03",
			1.33
		],
		[
			"2011-03-21",
			0.18
		],
		[
			"2012-09-28",
			0.13
		],
		[
			"2013-03-04",
			0.44
		]
	],
	"80201570": [
		[
			"2014-01-31",
			247.56
		],
		[
			"2015-08-27",
			234.71
		],
		[
			"2000-03-07",
			178.91
		],
		[
			"2001-01-11",
			177.59
		],
		[
			"2001-07-10",
			198.4
		],
		[
			"2002-02-18",
			195.74
		],
		[
			"2002-07-02",
			179.36
		],
		[
			"2003-05-07",
			161.64
		],
		[
			"2003-07-08",
			201.94
		],
		[
			"2004-04-30",
			147.47
		],
		[
			"2004-10-06",
			186
		],
		[
			"2005-01-31",
			193.09
		],
		[
			"2006-09-06",
			193.53
		],
		[
			"2006-10-05",
			220.99
		],
		[
			"2007-05-11",
			231.17
		],
		[
			"2007-11-09",
			263.06
		],
		[
			"2008-07-30",
			293.17
		],
		[
			"2005-09-21",
			183.34
		],
		[
			"2009-08-10",
			249.77
		],
		[
			"2010-09-06",
			235.6
		],
		[
			"2011-05-31",
			257.3
		],
		[
			"2012-05-23",
			244.01
		],
		[
			"2013-03-21",
			242.24
		]
	],
	"80201581": [
		[
			"2013-07-30",
			115.14
		],
		[
			"2014-03-28",
			96.54
		],
		[
			"2015-08-27",
			104.51
		],
		[
			"2000-03-07",
			101.41
		],
		[
			"2001-01-11",
			128.43
		],
		[
			"2001-07-10",
			104.96
		],
		[
			"2002-02-18",
			138.17
		],
		[
			"2002-07-02",
			130.64
		],
		[
			"2003-05-08",
			127.54
		],
		[
			"2003-07-08",
			133.74
		],
		[
			"2004-04-30",
			123.56
		],
		[
			"2004-10-06",
			127.1
		],
		[
			"2005-04-04",
			118.69
		],
		[
			"2006-09-06",
			121.34
		],
		[
			"2007-01-22",
			113.37
		],
		[
			"2007-11-09",
			112.04
		],
		[
			"2008-05-28",
			105.4
		],
		[
			"2005-09-21",
			112.04
		]
	],
	"80201600": [
		[
			"2014-03-28",
			118.24
		],
		[
			"2015-08-27",
			112.04
		],
		[
			"2000-03-07",
			111.16
		],
		[
			"2001-01-11",
			109.83
		],
		[
			"2001-07-09",
			107.61
		],
		[
			"2002-02-18",
			113.37
		],
		[
			"2002-09-26",
			113.81
		],
		[
			"2003-05-08",
			114.7
		],
		[
			"2004-04-30",
			109.39
		],
		[
			"2004-10-25",
			116.47
		],
		[
			"2005-04-04",
			116.47
		],
		[
			"2006-09-11",
			115.59
		],
		[
			"2007-01-22",
			112.49
		],
		[
			"2007-11-09",
			123.56
		],
		[
			"2008-05-28",
			110.71
		],
		[
			"2005-11-23",
			116.03
		],
		[
			"2010-08-03",
			120.46
		],
		[
			"2011-05-31",
			115.14
		],
		[
			"2012-05-16",
			123.56
		],
		[
			"2013-03-08",
			121.34
		]
	],
	"80201611": [
		[
			"2013-06-28",
			95.66
		],
		[
			"2014-05-22",
			88.57
		],
		[
			"2015-09-04",
			103.63
		],
		[
			"2000-09-11",
			86.8
		],
		[
			"2001-01-17",
			95.21
		],
		[
			"2001-07-09",
			86.8
		],
		[
			"2002-02-19",
			104.96
		],
		[
			"2002-09-26",
			97.43
		],
		[
			"2003-05-08",
			91.67
		],
		[
			"2004-05-03",
			89.01
		],
		[
			"2004-10-25",
			85.47
		],
		[
			"2005-04-04",
			65.54
		],
		[
			"2006-09-11",
			96.1
		],
		[
			"2006-10-05",
			93.44
		],
		[
			"2007-05-11",
			96.54
		],
		[
			"2007-11-13",
			88.57
		],
		[
			"2008-05-28",
			73.96
		],
		[
			"2005-11-23",
			88.57
		],
		[
			"2009-08-17",
			112.49
		],
		[
			"2010-06-07",
			103.19
		],
		[
			"2011-05-31",
			84.59
		],
		[
			"2012-11-06",
			84.59
		]
	],
	"80201623": [
		[
			"2014-12-16",
			54.03
		],
		[
			"2015-08-31",
			54.47
		],
		[
			"2016-01-08",
			57.57
		],
		[
			"2000-02-03",
			53.14
		],
		[
			"2000-08-22",
			53.14
		],
		[
			"2001-01-24",
			53.14
		],
		[
			"2001-07-05",
			55.36
		],
		[
			"2002-01-07",
			57.13
		],
		[
			"2002-09-03",
			58.9
		],
		[
			"2004-01-12",
			53.59
		],
		[
			"2004-07-26",
			54.03
		],
		[
			"2004-12-07",
			53.59
		],
		[
			"2006-08-24",
			57.13
		],
		[
			"2007-01-23",
			56.69
		],
		[
			"2007-09-19",
			58.01
		],
		[
			"2008-06-04",
			62
		],
		[
			"2003-02-19",
			58.9
		],
		[
			"2005-09-22",
			54.03
		],
		[
			"2010-06-11",
			64.66
		],
		[
			"2011-03-18",
			61.11
		],
		[
			"2012-01-03",
			62.89
		],
		[
			"2013-01-07",
			61.56
		]
	],
	"80201714": [
		[
			"2014-05-12",
			13.86
		],
		[
			"2015-09-23",
			13.6
		],
		[
			"2000-02-04",
			19.93
		],
		[
			"2000-08-21",
			12.84
		],
		[
			"2001-01-04",
			17.27
		],
		[
			"2001-07-17",
			13.29
		],
		[
			"2002-01-10",
			9.3
		],
		[
			"2002-09-04",
			8.41
		],
		[
			"2003-04-30",
			9.3
		],
		[
			"2004-01-13",
			35.43
		],
		[
			"2004-10-08",
			28.96
		],
		[
			"2005-02-11",
			31.27
		],
		[
			"2005-11-07",
			30.34
		],
		[
			"2006-08-28",
			36.45
		],
		[
			"2007-01-23",
			30.03
		],
		[
			"2007-11-26",
			17.4
		],
		[
			"2008-07-09",
			14.04
		],
		[
			"2010-06-09",
			21.3
		],
		[
			"2011-01-04",
			16.56
		],
		[
			"2012-02-13",
			26.22
		],
		[
			"2013-01-28",
			18.29
		]
	],
	"80300285": [
		[
			"2013-05-08",
			1.33
		],
		[
			"2014-12-11",
			0.18
		],
		[
			"2015-02-23",
			0.62
		],
		[
			"2000-02-17",
			3.32
		],
		[
			"2000-09-12",
			9.3
		],
		[
			"2001-01-19",
			18.16
		],
		[
			"2001-08-29",
			1.51
		],
		[
			"2002-01-15",
			8.86
		],
		[
			"2002-09-16",
			7.53
		],
		[
			"2003-02-28",
			20.81
		],
		[
			"2004-01-21",
			6.55
		],
		[
			"2004-08-18",
			1.33
		],
		[
			"2004-12-15",
			1.33
		],
		[
			"2005-10-21",
			1.33
		],
		[
			"2006-08-28",
			1.33
		],
		[
			"2007-05-16",
			1.33
		],
		[
			"2007-11-22",
			1.33
		],
		[
			"2008-07-24",
			1.33
		],
		[
			"2010-06-09",
			10.05
		],
		[
			"2011-01-04",
			3.76
		]
	],
	"80300364": [
		[
			"2013-04-15",
			62
		],
		[
			"2014-05-23",
			74.84
		],
		[
			"2015-09-25",
			70.86
		],
		[
			"2016-01-27",
			84.14
		],
		[
			"2000-03-29",
			47.39
		],
		[
			"2000-09-26",
			39.86
		],
		[
			"2001-02-02",
			38.53
		],
		[
			"2001-09-07",
			34.99
		],
		[
			"2002-01-29",
			37.2
		],
		[
			"2002-07-03",
			23.03
		],
		[
			"2003-07-09",
			51.81
		],
		[
			"2004-04-15",
			59.79
		],
		[
			"2004-10-05",
			29.23
		],
		[
			"2004-12-28",
			40.52
		],
		[
			"2006-10-09",
			39.86
		],
		[
			"2007-05-23",
			46.5
		],
		[
			"2008-04-11",
			50.04
		],
		[
			"2008-07-30",
			46.94
		],
		[
			"2003-01-23",
			42.07
		],
		[
			"2005-09-20",
			32.9
		],
		[
			"2009-10-07",
			63.33
		],
		[
			"2010-05-31",
			54.03
		],
		[
			"2011-05-04",
			39.99
		],
		[
			"2012-08-31",
			72.19
		]
	],
	"80300376": [
		[
			"2014-09-25",
			73.07
		],
		[
			"2015-09-25",
			35.21
		],
		[
			"2016-01-27",
			36.31
		],
		[
			"2000-03-10",
			24.62
		],
		[
			"2000-09-26",
			25.11
		],
		[
			"2001-02-02",
			46.5
		],
		[
			"2001-09-07",
			22.59
		],
		[
			"2002-01-29",
			20.37
		],
		[
			"2003-06-24",
			29.01
		],
		[
			"2004-04-19",
			25.69
		],
		[
			"2004-09-13",
			25.86
		],
		[
			"2004-12-20",
			15.28
		],
		[
			"2006-09-28",
			27.63
		],
		[
			"2007-07-31",
			27.72
		],
		[
			"2008-04-11",
			23.47
		],
		[
			"2003-01-21",
			17.71
		],
		[
			"2005-12-08",
			24.71
		],
		[
			"2009-10-07",
			28.12
		],
		[
			"2010-09-16",
			33.7
		],
		[
			"2011-06-10",
			11.07
		],
		[
			"2012-09-14",
			32.68
		],
		[
			"2013-01-29",
			43
		]
	],
	"80300662": [
		[
			"2015-07-07",
			31.71
		],
		[
			"2000-03-03",
			15.46
		],
		[
			"2000-08-28",
			27.46
		],
		[
			"2001-01-18",
			14.61
		],
		[
			"2001-07-11",
			27.01
		],
		[
			"2002-02-13",
			30.11
		],
		[
			"2002-09-26",
			35.69
		],
		[
			"2003-05-09",
			23.03
		],
		[
			"2004-01-27",
			35.87
		],
		[
			"2004-07-29",
			31.89
		],
		[
			"2005-01-28",
			31.4
		],
		[
			"2006-09-05",
			28.7
		],
		[
			"2007-01-22",
			29.89
		],
		[
			"2008-04-10",
			44.29
		],
		[
			"2007-11-08",
			30.65
		],
		[
			"2005-11-22",
			31.62
		],
		[
			"2009-07-31",
			24.49
		],
		[
			"2010-08-03",
			31.49
		],
		[
			"2011-05-05",
			39.95
		],
		[
			"2012-01-16",
			31.8
		],
		[
			"2013-03-08",
			26.04
		]
	],
	"80300686": [
		[
			"2014-05-22",
			119.13
		],
		[
			"2015-10-14",
			112.49
		],
		[
			"2000-05-25",
			101.86
		],
		[
			"2000-09-11",
			108.94
		],
		[
			"2001-01-18",
			108.94
		],
		[
			"2001-07-09",
			111.16
		],
		[
			"2002-02-19",
			112.49
		],
		[
			"2002-07-02",
			109.39
		],
		[
			"2003-07-08",
			109.83
		],
		[
			"2004-05-03",
			110.27
		],
		[
			"2004-10-06",
			118.69
		],
		[
			"2005-01-28",
			121.79
		],
		[
			"2006-09-11",
			131.53
		],
		[
			"2006-10-05",
			126.66
		],
		[
			"2007-05-11",
			126.66
		],
		[
			"2007-11-13",
			124.89
		],
		[
			"2008-04-10",
			124
		],
		[
			"2005-09-21",
			121.34
		],
		[
			"2009-08-17",
			121.79
		],
		[
			"2010-09-08",
			124
		],
		[
			"2011-05-25",
			127.1
		],
		[
			"2012-06-18",
			128.43
		],
		[
			"2013-03-21",
			127.1
		]
	],
	"80300789": [
		[
			"2014-08-12",
			18.69
		],
		[
			"2015-08-31",
			32.77
		],
		[
			"2016-01-08",
			29.67
		],
		[
			"2000-02-03",
			56.24
		],
		[
			"2000-08-21",
			69.97
		],
		[
			"2001-01-25",
			67.31
		],
		[
			"2001-07-05",
			64.66
		],
		[
			"2002-01-10",
			79.27
		],
		[
			"2002-09-03",
			71.74
		],
		[
			"2003-05-06",
			69.09
		],
		[
			"2004-01-12",
			73.51
		],
		[
			"2004-07-26",
			70.86
		],
		[
			"2004-12-07",
			70.86
		],
		[
			"2005-11-04",
			66.87
		],
		[
			"2006-08-24",
			60.67
		],
		[
			"2007-01-23",
			55.36
		],
		[
			"2007-09-19",
			57.57
		],
		[
			"2008-06-04",
			48.27
		],
		[
			"2010-06-11",
			38.57
		],
		[
			"2011-03-18",
			37.33
		],
		[
			"2012-01-03",
			39.81
		],
		[
			"2013-01-07",
			28.79
		]
	],
	"80300911": [
		[
			"2013-06-27",
			44.73
		],
		[
			"2015-09-08",
			71.74
		],
		[
			"2000-01-21",
			81.93
		],
		[
			"2000-11-08",
			81.93
		],
		[
			"2001-03-15",
			84.14
		],
		[
			"2001-10-05",
			70.86
		],
		[
			"2002-04-02",
			88.57
		],
		[
			"2003-02-18",
			84.59
		],
		[
			"2003-08-06",
			75.29
		],
		[
			"2004-01-30",
			82.81
		],
		[
			"2004-08-05",
			84.14
		],
		[
			"2005-01-25",
			79.27
		],
		[
			"2006-03-07",
			79.27
		],
		[
			"2007-08-16",
			60.23
		],
		[
			"2008-11-11",
			51.37
		],
		[
			"2010-01-15",
			57.57
		],
		[
			"2011-01-05",
			58.46
		],
		[
			"2012-09-26",
			45.61
		]
	],
	"80300935": [
		[
			"2014-02-03",
			1.33
		],
		[
			"2015-09-01",
			0.13
		],
		[
			"2000-10-23",
			7.97
		],
		[
			"2001-03-02",
			8.41
		],
		[
			"2001-10-04",
			5.31
		],
		[
			"2002-04-11",
			12.84
		],
		[
			"2002-07-01",
			5.76
		],
		[
			"2003-02-17",
			13.73
		],
		[
			"2003-07-07",
			7.97
		],
		[
			"2004-04-26",
			7.97
		],
		[
			"2004-10-04",
			7.31
		],
		[
			"2005-03-08",
			11.07
		],
		[
			"2006-01-20",
			8.86
		],
		[
			"2006-10-11",
			10.5
		],
		[
			"2007-07-25",
			10.67
		],
		[
			"2008-03-06",
			11.96
		],
		[
			"2000-04-14",
			8.41
		],
		[
			"2005-09-19",
			5.93
		],
		[
			"2010-01-14",
			11.47
		],
		[
			"2011-08-22",
			0.13
		],
		[
			"2012-09-10",
			0.13
		],
		[
			"2013-01-11",
			0.13
		]
	],
	"80300947": [
		[
			"2013-04-11",
			38.17
		],
		[
			"2014-08-25",
			37.82
		],
		[
			"2015-08-24",
			31.31
		],
		[
			"2000-10-30",
			93.89
		],
		[
			"2001-02-28",
			63.77
		],
		[
			"2001-09-27",
			63.33
		],
		[
			"2002-04-05",
			57.57
		],
		[
			"2003-07-28",
			69.53
		],
		[
			"2004-03-11",
			55.36
		],
		[
			"2004-10-12",
			52.7
		],
		[
			"2005-03-09",
			64.21
		],
		[
			"2006-01-18",
			56.24
		],
		[
			"2006-11-08",
			58.01
		],
		[
			"2007-07-20",
			51.37
		],
		[
			"2008-03-04",
			50.49
		],
		[
			"2000-05-02",
			69.53
		],
		[
			"2003-02-14",
			79.27
		],
		[
			"2010-01-13",
			58.01
		],
		[
			"2011-01-17",
			43.36
		],
		[
			"2012-07-05",
			40.57
		]
	],
	"80300960": [
		[
			"2013-04-11",
			88.57
		],
		[
			"2014-09-16",
			95.66
		],
		[
			"2015-09-01",
			89.46
		],
		[
			"2000-11-02",
			80.6
		],
		[
			"2001-03-01",
			86.36
		],
		[
			"2001-10-04",
			83.26
		],
		[
			"2002-04-10",
			89.01
		],
		[
			"2003-02-18",
			87.69
		],
		[
			"2003-07-31",
			84.14
		],
		[
			"2004-03-10",
			84.14
		],
		[
			"2004-10-11",
			85.03
		],
		[
			"2005-03-14",
			85.47
		],
		[
			"2006-01-30",
			85.47
		],
		[
			"2006-11-10",
			91.23
		],
		[
			"2007-07-26",
			88.57
		],
		[
			"2008-08-25",
			89.46
		],
		[
			"2000-05-02",
			80.16
		],
		[
			"2010-01-18",
			93.89
		],
		[
			"2011-01-17",
			89.01
		],
		[
			"2012-07-05",
			92.11
		]
	],
	"80300996": [
		[
			"2014-05-16",
			37.91
		],
		[
			"2015-08-25",
			38.79
		],
		[
			"2016-01-07",
			33.21
		],
		[
			"2000-10-20",
			31.44
		],
		[
			"2001-02-20",
			31
		],
		[
			"2001-09-21",
			22.28
		],
		[
			"2002-04-02",
			32.33
		],
		[
			"2002-07-01",
			29.23
		],
		[
			"2003-07-07",
			34.99
		],
		[
			"2004-04-21",
			38.09
		],
		[
			"2004-10-04",
			28.48
		],
		[
			"2005-01-19",
			34.45
		],
		[
			"2006-01-04",
			34.1
		],
		[
			"2006-10-18",
			32.06
		],
		[
			"2007-07-27",
			31.31
		],
		[
			"2008-01-29",
			41.94
		],
		[
			"2008-11-10",
			43.53
		],
		[
			"2003-02-11",
			36.31
		],
		[
			"2005-09-20",
			37.02
		],
		[
			"2009-11-18",
			37.51
		],
		[
			"2010-09-15",
			42.91
		],
		[
			"2011-03-11",
			47.39
		],
		[
			"2012-05-31",
			41.98
		],
		[
			"2013-02-14",
			41.54
		]
	],
	"80301009": [
		[
			"2013-05-02",
			77.5
		],
		[
			"2015-10-12",
			65.1
		],
		[
			"2000-10-16",
			109.83
		],
		[
			"2001-02-19",
			115.14
		],
		[
			"2001-09-20",
			113.81
		],
		[
			"2002-02-22",
			118.69
		],
		[
			"2003-07-16",
			118.24
		],
		[
			"2004-01-14",
			115.59
		],
		[
			"2004-09-27",
			108.06
		],
		[
			"2005-01-26",
			115.59
		],
		[
			"2006-01-03",
			117.36
		],
		[
			"2007-07-17",
			109.83
		],
		[
			"2008-03-07",
			121.79
		],
		[
			"2000-04-10",
			120.46
		],
		[
			"2003-02-04",
			132.86
		],
		[
			"2006-10-27",
			108.5
		],
		[
			"2009-11-20",
			116.47
		],
		[
			"2010-08-04",
			107.61
		],
		[
			"2011-05-19",
			98.76
		],
		[
			"2012-10-26",
			80.6
		]
	],
	"80301010": [
		[
			"2013-05-02",
			78.39
		],
		[
			"2014-02-06",
			80.6
		],
		[
			"2015-06-17",
			53.59
		],
		[
			"2016-01-22",
			53.14
		],
		[
			"2000-04-10",
			64.66
		],
		[
			"2000-10-16",
			58.46
		],
		[
			"2001-02-19",
			44.73
		],
		[
			"2001-09-20",
			52.26
		],
		[
			"2002-02-22",
			32.33
		],
		[
			"2003-07-14",
			43.84
		],
		[
			"2004-01-14",
			68.64
		],
		[
			"2004-09-24",
			62.89
		],
		[
			"2005-01-26",
			39.95
		],
		[
			"2006-01-03",
			67.31
		],
		[
			"2007-07-17",
			62
		],
		[
			"2008-02-01",
			26.84
		],
		[
			"2003-02-04",
			39.86
		],
		[
			"2006-10-23",
			47.83
		],
		[
			"2009-11-20",
			64.66
		],
		[
			"2010-08-04",
			77.5
		],
		[
			"2011-05-19",
			62.89
		]
	],
	"80301022": [
		[
			"2015-08-25",
			58.46
		],
		[
			"2016-01-07",
			57.57
		],
		[
			"2000-04-10",
			56.69
		],
		[
			"2000-10-16",
			72.19
		],
		[
			"2001-02-19",
			69.53
		],
		[
			"2001-09-20",
			83.7
		],
		[
			"2002-02-22",
			75.29
		],
		[
			"2003-07-14",
			114.7
		],
		[
			"2004-01-14",
			95.21
		],
		[
			"2004-09-24",
			88.57
		],
		[
			"2005-01-26",
			93.44
		],
		[
			"2006-01-03",
			111.6
		],
		[
			"2006-10-23",
			97.43
		],
		[
			"2007-07-18",
			80.6
		],
		[
			"2008-03-07",
			85.91
		],
		[
			"2003-02-04",
			94.33
		],
		[
			"2009-12-02",
			53.59
		],
		[
			"2010-08-18",
			61.11
		],
		[
			"2011-02-24",
			47.39
		],
		[
			"2012-05-31",
			65.54
		],
		[
			"2013-02-14",
			49.6
		]
	],
	"80301034": [
		[
			"2014-02-06",
			1.33
		],
		[
			"2015-06-17",
			0.13
		],
		[
			"2000-04-07",
			1.33
		],
		[
			"2000-10-17",
			1.33
		],
		[
			"2001-02-16",
			1.33
		],
		[
			"2001-09-19",
			1.33
		],
		[
			"2002-02-20",
			1.33
		],
		[
			"2003-07-15",
			3.54
		],
		[
			"2004-04-21",
			1.33
		],
		[
			"2004-09-27",
			1.33
		],
		[
			"2005-01-11",
			1.33
		],
		[
			"2006-01-05",
			1.33
		],
		[
			"2007-07-18",
			1.33
		],
		[
			"2008-01-28",
			1.33
		],
		[
			"2003-02-10",
			1.9
		],
		[
			"2006-10-27",
			1.33
		],
		[
			"2009-11-19",
			1.33
		],
		[
			"2010-08-06",
			1.33
		],
		[
			"2011-03-10",
			0.31
		],
		[
			"2012-01-30",
			0.13
		],
		[
			"2013-02-20",
			0.13
		]
	],
	"80301060": [
		[
			"2014-05-16",
			97.87
		],
		[
			"2015-06-22",
			97.87
		],
		[
			"2000-01-28",
			186.44
		],
		[
			"2000-10-06",
			171.83
		],
		[
			"2001-02-12",
			181.13
		],
		[
			"2001-09-17",
			164.3
		],
		[
			"2002-03-15",
			166.96
		],
		[
			"2002-07-03",
			150.13
		],
		[
			"2003-07-09",
			140.83
		],
		[
			"2004-04-22",
			121.79
		],
		[
			"2004-10-05",
			99.2
		],
		[
			"2005-01-04",
			100.09
		],
		[
			"2006-01-06",
			92.11
		],
		[
			"2006-10-10",
			89.46
		],
		[
			"2007-06-06",
			93.89
		],
		[
			"2008-01-15",
			97.87
		],
		[
			"2003-01-30",
			150.57
		],
		[
			"2005-09-20",
			92.56
		],
		[
			"2009-11-05",
			97.87
		],
		[
			"2010-11-11",
			91.23
		],
		[
			"2011-06-30",
			91.67
		],
		[
			"2012-09-28",
			93.89
		],
		[
			"2013-03-20",
			98.76
		]
	],
	"80301150": [
		[
			"2015-08-31",
			5.71
		],
		[
			"2016-01-08",
			4.43
		],
		[
			"2000-02-23",
			27.1
		],
		[
			"2000-08-25",
			25.24
		],
		[
			"2000-12-18",
			21.7
		],
		[
			"2001-01-09",
			20.37
		],
		[
			"2001-07-12",
			23.03
		],
		[
			"2002-02-12",
			19.93
		],
		[
			"2002-09-25",
			18.2
		],
		[
			"2003-05-06",
			11.96
		],
		[
			"2004-01-22",
			15.1
		],
		[
			"2004-08-16",
			17.27
		],
		[
			"2005-03-17",
			13.99
		],
		[
			"2006-09-20",
			13.82
		],
		[
			"2007-05-25",
			10.36
		],
		[
			"2007-11-08",
			9.34
		],
		[
			"2008-08-04",
			7.44
		],
		[
			"2005-11-25",
			15.77
		],
		[
			"2009-07-31",
			7.09
		],
		[
			"2010-09-03",
			3.94
		],
		[
			"2011-03-17",
			5.89
		],
		[
			"2012-01-17",
			6.69
		],
		[
			"2013-03-21",
			4.61
		]
	],
	"80301277": [
		[
			"2013-05-08",
			1.33
		],
		[
			"2014-09-29",
			1.33
		],
		[
			"2015-06-18",
			0.13
		],
		[
			"2016-01-26",
			0.97
		],
		[
			"2000-02-18",
			5.49
		],
		[
			"2000-09-01",
			3.37
		],
		[
			"2001-01-15",
			6.64
		],
		[
			"2001-08-22",
			1.68
		],
		[
			"2002-03-11",
			7.09
		],
		[
			"2002-09-23",
			1.51
		],
		[
			"2003-05-23",
			2.48
		],
		[
			"2003-12-12",
			1.33
		],
		[
			"2004-03-08",
			8.41
		],
		[
			"2004-07-27",
			2.97
		],
		[
			"2004-12-08",
			4.43
		],
		[
			"2006-09-15",
			3.19
		],
		[
			"2007-01-25",
			6.95
		],
		[
			"2007-11-12",
			3.9
		],
		[
			"2008-07-15",
			3.81
		],
		[
			"2005-11-15",
			1.46
		],
		[
			"2009-08-18",
			0.35
		],
		[
			"2010-09-06",
			1.33
		],
		[
			"2011-06-22",
			0.18
		],
		[
			"2012-10-29",
			1.06
		]
	],
	"80301289": [
		[
			"2013-07-09",
			19.35
		],
		[
			"2014-06-16",
			19
		],
		[
			"2015-09-24",
			17.49
		],
		[
			"2000-02-17",
			26.79
		],
		[
			"2000-08-30",
			27.01
		],
		[
			"2000-12-18",
			26.13
		],
		[
			"2001-01-18",
			27.46
		],
		[
			"2001-08-28",
			27.46
		],
		[
			"2002-03-12",
			28.34
		],
		[
			"2002-09-17",
			27.01
		],
		[
			"2003-05-28",
			25.46
		],
		[
			"2004-04-01",
			21.26
		],
		[
			"2004-08-17",
			20.81
		],
		[
			"2004-12-09",
			22.36
		],
		[
			"2006-09-19",
			14.53
		],
		[
			"2007-06-11",
			21.52
		],
		[
			"2007-11-16",
			20.86
		],
		[
			"2008-07-18",
			18.11
		],
		[
			"2005-11-21",
			15.85
		],
		[
			"2009-08-19",
			29.94
		],
		[
			"2010-09-07",
			22.45
		],
		[
			"2011-06-08",
			23.34
		],
		[
			"2012-10-29",
			20.9
		]
	],
	"80301290": [
		[
			"2013-09-27",
			11.96
		],
		[
			"2014-03-17",
			10.54
		],
		[
			"2015-12-03",
			4.83
		],
		[
			"2000-02-16",
			25.91
		],
		[
			"2000-09-13",
			1.86
		],
		[
			"2001-01-22",
			3.81
		],
		[
			"2001-08-30",
			44.29
		],
		[
			"2002-01-16",
			49.6
		],
		[
			"2002-07-04",
			30.11
		],
		[
			"2003-06-11",
			21.66
		],
		[
			"2003-07-10",
			22.59
		],
		[
			"2004-01-21",
			60.23
		],
		[
			"2004-05-25",
			54.03
		],
		[
			"2004-10-07",
			48.27
		],
		[
			"2004-12-21",
			49.6
		],
		[
			"2006-09-12",
			13.15
		],
		[
			"2007-06-18",
			19.97
		],
		[
			"2007-11-22",
			14.48
		],
		[
			"2008-07-21",
			17.63
		],
		[
			"2008-11-05",
			12.8
		],
		[
			"2005-09-21",
			34.14
		],
		[
			"2009-08-21",
			27.24
		],
		[
			"2010-07-29",
			18.87
		],
		[
			"2011-05-05",
			23.96
		],
		[
			"2012-02-09",
			62
		],
		[
			"2013-01-28",
			26.53
		]
	],
	"80301307": [
		[
			"2013-09-25",
			10.76
		],
		[
			"2013-05-03",
			10.76
		],
		[
			"2014-01-10",
			11.2
		],
		[
			"2015-07-03",
			14.17
		],
		[
			"2000-01-24",
			19.49
		],
		[
			"2000-09-15",
			21.7
		],
		[
			"2000-11-28",
			20.11
		],
		[
			"2001-01-31",
			21.17
		],
		[
			"2001-11-13",
			17.71
		],
		[
			"2002-01-23",
			20.81
		],
		[
			"2002-09-11",
			41.19
		],
		[
			"2003-06-12",
			34.72
		],
		[
			"2004-01-29",
			20.68
		],
		[
			"2005-04-25",
			12.18
		],
		[
			"2005-11-02",
			11.87
		],
		[
			"2006-08-25",
			11.43
		],
		[
			"2007-10-10",
			10.45
		],
		[
			"2007-05-16",
			9.88
		],
		[
			"2008-06-09",
			10.5
		],
		[
			"2010-06-10",
			9.65
		],
		[
			"2011-06-16",
			11.38
		],
		[
			"2012-07-03",
			12.8
		]
	],
	"80301332": [
		[
			"2013-05-13",
			61.11
		],
		[
			"2014-03-31",
			65.1
		],
		[
			"2015-08-20",
			75.29
		],
		[
			"2000-05-24",
			54.91
		],
		[
			"2000-08-16",
			88.57
		],
		[
			"2000-11-21",
			62.44
		],
		[
			"2001-01-04",
			63.33
		],
		[
			"2001-07-17",
			55.36
		],
		[
			"2002-01-10",
			80.16
		],
		[
			"2002-07-04",
			68.2
		],
		[
			"2003-04-30",
			77.06
		],
		[
			"2003-07-10",
			70.41
		],
		[
			"2004-05-25",
			75.29
		],
		[
			"2004-10-07",
			74.4
		],
		[
			"2005-04-14",
			65.99
		],
		[
			"2006-08-28",
			74.4
		],
		[
			"2008-04-16",
			65.1
		],
		[
			"2007-07-04",
			58.46
		],
		[
			"2005-09-22",
			67.76
		],
		[
			"2010-11-22",
			89.9
		],
		[
			"2011-06-20",
			46.94
		],
		[
			"2012-09-03",
			51.37
		]
	],
	"80301344": [
		[
			"2013-05-13",
			19.35
		],
		[
			"2014-03-18",
			21.66
		],
		[
			"2015-07-03",
			20.11
		],
		[
			"2000-02-02",
			30.11
		],
		[
			"2000-08-14",
			24.8
		],
		[
			"2001-01-03",
			33.66
		],
		[
			"2001-07-16",
			38.53
		],
		[
			"2002-01-18",
			39.41
		],
		[
			"2002-09-05",
			35.43
		],
		[
			"2006-08-22",
			9.57
		],
		[
			"2007-05-16",
			9.57
		],
		[
			"2008-05-21",
			8.77
		],
		[
			"2008-11-05",
			2.57
		],
		[
			"2007-10-15",
			8.9
		],
		[
			"2009-12-03",
			3.5
		],
		[
			"2010-11-22",
			7.66
		],
		[
			"2011-06-20",
			10.23
		],
		[
			"2012-09-03",
			15.63
		]
	],
	"80301356": [
		[
			"2013-09-30",
			19.04
		],
		[
			"2014-02-10",
			20.46
		],
		[
			"2015-03-17",
			20.11
		],
		[
			"2000-11-21",
			20.37
		],
		[
			"2001-01-03",
			20.81
		],
		[
			"2001-07-13",
			25.24
		],
		[
			"2002-01-22",
			18.6
		],
		[
			"2002-07-04",
			20.81
		],
		[
			"2003-04-14",
			17.27
		],
		[
			"2003-07-10",
			17.71
		],
		[
			"2004-03-23",
			10.63
		],
		[
			"2004-10-07",
			11.2
		],
		[
			"2004-12-22",
			11.51
		],
		[
			"2006-08-21",
			15.85
		],
		[
			"2007-05-22",
			19.75
		],
		[
			"2008-05-21",
			19.8
		],
		[
			"2000-05-04",
			25.15
		],
		[
			"2005-09-22",
			13.51
		],
		[
			"2007-10-15",
			19.31
		],
		[
			"2010-06-08",
			15.41
		],
		[
			"2011-06-09",
			20.19
		],
		[
			"2012-08-27",
			14.44
		],
		[
			"2013-03-06",
			15.72
		]
	],
	"80301423": [
		[
			"2013-04-18",
			1.33
		],
		[
			"2014-08-21",
			0.13
		],
		[
			"2015-09-02",
			0.13
		],
		[
			"2000-11-15",
			1.33
		],
		[
			"2001-03-22",
			12.84
		],
		[
			"2001-10-25",
			1.33
		],
		[
			"2002-05-07",
			3.68
		],
		[
			"2003-03-27",
			3.28
		],
		[
			"2003-09-12",
			1.33
		],
		[
			"2004-02-24",
			20.15
		],
		[
			"2004-11-03",
			1.33
		],
		[
			"2005-04-11",
			3.14
		],
		[
			"2006-03-01",
			10.45
		],
		[
			"2006-10-12",
			1.33
		],
		[
			"2007-09-03",
			1.33
		],
		[
			"2008-05-26",
			1.33
		],
		[
			"2000-05-04",
			17.71
		],
		[
			"2010-07-12",
			0.13
		],
		[
			"2011-02-24",
			11.82
		],
		[
			"2011-08-03",
			0.13
		],
		[
			"2012-11-26",
			0.13
		]
	],
	"80301435": [
		[
			"2014-08-21",
			81.93
		],
		[
			"2015-09-02",
			65.1
		],
		[
			"2000-11-15",
			97.87
		],
		[
			"2001-03-22",
			77.94
		],
		[
			"2001-10-25",
			77.5
		],
		[
			"2002-05-07",
			62.44
		],
		[
			"2003-03-27",
			64.66
		],
		[
			"2003-09-12",
			66.87
		],
		[
			"2004-02-24",
			62.44
		],
		[
			"2004-11-03",
			60.67
		],
		[
			"2005-04-11",
			62
		],
		[
			"2006-03-01",
			71.3
		],
		[
			"2007-09-03",
			60.67
		],
		[
			"2008-05-26",
			73.07
		],
		[
			"2000-05-04",
			95.21
		],
		[
			"2006-10-12",
			62.89
		],
		[
			"2011-01-06",
			65.54
		],
		[
			"2010-07-12",
			62
		],
		[
			"2012-01-31",
			65.54
		],
		[
			"2013-01-24",
			66.43
		]
	],
	"80301460": [
		[
			"2015-09-28",
			31.18
		],
		[
			"2000-11-13",
			35.43
		],
		[
			"2001-03-20",
			53.14
		],
		[
			"2001-10-24",
			40.3
		],
		[
			"2002-04-26",
			62.89
		],
		[
			"2003-03-25",
			62
		],
		[
			"2003-09-11",
			50.49
		],
		[
			"2004-02-25",
			70.41
		],
		[
			"2004-11-02",
			38.4
		],
		[
			"2005-04-12",
			55.36
		],
		[
			"2006-03-08",
			48.71
		],
		[
			"2006-12-12",
			36.62
		],
		[
			"2007-09-06",
			35.21
		],
		[
			"2008-06-02",
			39.02
		],
		[
			"2000-05-03",
			42.29
		],
		[
			"2010-01-28",
			45.17
		],
		[
			"2011-01-20",
			32.2
		],
		[
			"2012-10-02",
			36.98
		],
		[
			"2013-03-01",
			39.28
		]
	],
	"80301484": [
		[
			"2014-06-25",
			26.17
		],
		[
			"2015-09-28",
			26.75
		],
		[
			"2000-11-14",
			119.57
		],
		[
			"2001-03-20",
			125.77
		],
		[
			"2001-10-24",
			109.83
		],
		[
			"2002-05-06",
			73.96
		],
		[
			"2003-03-25",
			76.61
		],
		[
			"2003-09-11",
			74.84
		],
		[
			"2004-02-25",
			68.64
		],
		[
			"2004-10-29",
			84.59
		],
		[
			"2005-04-12",
			86.8
		],
		[
			"2006-03-08",
			89.9
		],
		[
			"2006-12-12",
			62.44
		],
		[
			"2007-09-06",
			63.33
		],
		[
			"2008-06-02",
			38
		],
		[
			"2000-05-03",
			113.37
		],
		[
			"2005-09-19",
			75.73
		],
		[
			"2010-01-28",
			39.72
		],
		[
			"2011-01-20",
			42.47
		],
		[
			"2012-10-02",
			35.38
		],
		[
			"2013-03-01",
			35.34
		]
	],
	"80301496": [
		[
			"2014-06-13",
			1.95
		],
		[
			"2015-08-14",
			1.28
		],
		[
			"2000-11-14",
			1.95
		],
		[
			"2001-03-26",
			4.78
		],
		[
			"2001-10-24",
			1.9
		],
		[
			"2002-05-06",
			2.21
		],
		[
			"2003-03-25",
			2.97
		],
		[
			"2003-09-08",
			3.72
		],
		[
			"2004-02-17",
			1.77
		],
		[
			"2004-10-29",
			1.33
		],
		[
			"2005-04-18",
			2.66
		],
		[
			"2006-03-14",
			1.46
		],
		[
			"2006-12-14",
			1.59
		],
		[
			"2007-09-07",
			3.14
		],
		[
			"2008-06-02",
			1.33
		],
		[
			"2010-01-29",
			4.47
		],
		[
			"2011-01-19",
			3.54
		],
		[
			"2012-06-29",
			3.23
		],
		[
			"2013-01-24",
			2.79
		]
	],
	"80301502": [
		[
			"2013-06-24",
			52.26
		],
		[
			"2014-01-13",
			47.83
		],
		[
			"2015-09-03",
			50.04
		],
		[
			"2016-01-28",
			48.71
		],
		[
			"2000-01-04",
			53.14
		],
		[
			"2000-11-13",
			49.6
		],
		[
			"2001-03-14",
			41.63
		],
		[
			"2001-10-16",
			61.56
		],
		[
			"2002-04-26",
			63.33
		],
		[
			"2003-09-01",
			77.5
		],
		[
			"2004-04-29",
			75.29
		],
		[
			"2004-08-10",
			74.84
		],
		[
			"2005-03-31",
			69.97
		],
		[
			"2006-03-06",
			73.07
		],
		[
			"2006-12-11",
			68.2
		],
		[
			"2007-08-14",
			62
		],
		[
			"2008-08-06",
			61.11
		],
		[
			"2003-02-26",
			71.3
		],
		[
			"2010-01-21",
			61.11
		],
		[
			"2011-02-18",
			52.7
		],
		[
			"2012-09-26",
			24.36
		],
		[
			"2013-01-04",
			55.8
		]
	],
	"80301514": [
		[
			"2014-09-08",
			46.94
		],
		[
			"2015-03-16",
			52.7
		],
		[
			"2016-01-25",
			48.71
		],
		[
			"2000-01-04",
			26.13
		],
		[
			"2000-11-09",
			18.6
		],
		[
			"2001-03-14",
			14.17
		],
		[
			"2001-10-23",
			9.3
		],
		[
			"2002-04-23",
			11.56
		],
		[
			"2003-09-01",
			12.4
		],
		[
			"2004-04-27",
			13.73
		],
		[
			"2004-08-10",
			14.61
		],
		[
			"2005-03-31",
			17.01
		],
		[
			"2006-03-06",
			29.85
		],
		[
			"2006-12-11",
			35.69
		],
		[
			"2007-08-14",
			38.75
		],
		[
			"2008-03-11",
			41.81
		],
		[
			"2003-02-25",
			9.74
		],
		[
			"2010-01-20",
			34.54
		],
		[
			"2011-01-21",
			31.18
		],
		[
			"2012-01-09",
			24.71
		],
		[
			"2013-01-04",
			38.26
		]
	],
	"80301540": [
		[
			"2013-04-25",
			31
		],
		[
			"2014-12-15",
			24.62
		],
		[
			"2015-09-03",
			23.74
		],
		[
			"2016-01-25",
			23.47
		],
		[
			"2000-01-05",
			37.2
		],
		[
			"2000-11-09",
			35.87
		],
		[
			"2001-03-13",
			33.52
		],
		[
			"2001-10-16",
			28.34
		],
		[
			"2002-04-23",
			30.73
		],
		[
			"2003-08-05",
			24.18
		],
		[
			"2004-04-27",
			25.69
		],
		[
			"2004-08-09",
			25.24
		],
		[
			"2005-04-01",
			25.55
		],
		[
			"2006-03-03",
			26.04
		],
		[
			"2006-12-21",
			24.89
		],
		[
			"2007-08-13",
			25.64
		],
		[
			"2008-08-06",
			22.72
		],
		[
			"2003-02-25",
			27.46
		],
		[
			"2010-01-20",
			28.39
		],
		[
			"2011-02-22",
			26.62
		],
		[
			"2012-11-09",
			29.18
		]
	],
	"80301551": [
		[
			"2014-01-13",
			25.24
		],
		[
			"2015-03-16",
			25.55
		],
		[
			"2016-01-28",
			27.01
		],
		[
			"2000-01-04",
			37.64
		],
		[
			"2000-11-09",
			27.46
		],
		[
			"2001-03-14",
			25.69
		],
		[
			"2001-10-15",
			26.75
		],
		[
			"2002-04-22",
			25.42
		],
		[
			"2003-08-05",
			30.51
		],
		[
			"2004-04-27",
			27.46
		],
		[
			"2004-08-09",
			26.57
		],
		[
			"2005-04-01",
			24.76
		],
		[
			"2006-03-03",
			23.52
		],
		[
			"2006-12-21",
			27.55
		],
		[
			"2007-08-13",
			24.76
		],
		[
			"2008-03-11",
			24.67
		],
		[
			"2003-02-24",
			27.46
		],
		[
			"2010-01-19",
			25.73
		],
		[
			"2011-01-21",
			24.98
		],
		[
			"2012-01-09",
			24.71
		],
		[
			"2013-02-19",
			26.13
		]
	],
	"80301630": [
		[
			"2014-12-01",
			0.13
		],
		[
			"2015-09-30",
			0.13
		],
		[
			"2000-01-07",
			1.33
		],
		[
			"2000-11-17",
			1.33
		],
		[
			"2001-03-26",
			1.33
		],
		[
			"2001-10-17",
			1.33
		],
		[
			"2002-05-13",
			1.33
		],
		[
			"2003-03-05",
			1.33
		],
		[
			"2003-09-10",
			1.33
		],
		[
			"2004-02-16",
			1.33
		],
		[
			"2004-09-21",
			1.33
		],
		[
			"2005-04-05",
			1.33
		],
		[
			"2006-04-20",
			1.33
		],
		[
			"2006-12-15",
			1.33
		],
		[
			"2007-07-02",
			1.33
		],
		[
			"2008-05-20",
			1.33
		],
		[
			"2010-01-25",
			0.13
		],
		[
			"2011-01-11",
			0.13
		],
		[
			"2011-10-12",
			0.13
		],
		[
			"2012-09-04",
			0.13
		],
		[
			"2013-03-18",
			0.13
		]
	],
	"80301654": [
		[
			"2013-06-24",
			1.51
		],
		[
			"2015-01-07",
			23.78
		],
		[
			"2000-01-06",
			7.97
		],
		[
			"2000-11-16",
			9.74
		],
		[
			"2001-03-15",
			15.5
		],
		[
			"2001-10-18",
			7.53
		],
		[
			"2002-05-10",
			8.86
		],
		[
			"2003-03-24",
			6.82
		],
		[
			"2003-09-08",
			1.33
		],
		[
			"2004-02-17",
			36.31
		],
		[
			"2006-03-14",
			21.97
		],
		[
			"2006-12-14",
			5.76
		],
		[
			"2008-04-21",
			22.67
		],
		[
			"2007-07-02",
			4.61
		],
		[
			"2010-01-22",
			4.47
		],
		[
			"2011-01-07",
			3.99
		],
		[
			"2011-10-13",
			0.53
		],
		[
			"2012-09-04",
			1.15
		],
		[
			"2013-02-15",
			28.65
		]
	],
	"80301678": [
		[
			"2015-09-09",
			29.98
		],
		[
			"2000-01-20",
			23.91
		],
		[
			"2000-11-03",
			21.26
		],
		[
			"2001-03-08",
			31.89
		],
		[
			"2001-10-08",
			27.46
		],
		[
			"2002-04-15",
			39.33
		],
		[
			"2003-09-04",
			20.33
		],
		[
			"2004-03-31",
			19.49
		],
		[
			"2004-10-19",
			9.43
		],
		[
			"2005-03-15",
			15.9
		],
		[
			"2006-02-01",
			7.31
		],
		[
			"2006-12-06",
			10.23
		],
		[
			"2007-06-15",
			14.53
		],
		[
			"2008-04-08",
			24.58
		],
		[
			"2003-02-28",
			22.59
		],
		[
			"2010-01-19",
			26.44
		],
		[
			"2011-01-13",
			18.82
		],
		[
			"2012-01-19",
			21.43
		],
		[
			"2013-03-19",
			28.83
		]
	],
	"80301691": [
		[
			"2013-04-24",
			111.16
		],
		[
			"2015-09-09",
			68.64
		],
		[
			"2000-01-20",
			18.6
		],
		[
			"2000-11-02",
			27.9
		],
		[
			"2001-03-07",
			17.27
		],
		[
			"2001-10-09",
			8.41
		],
		[
			"2002-04-16",
			46.06
		],
		[
			"2003-02-28",
			34.99
		],
		[
			"2003-09-02",
			8.41
		],
		[
			"2004-03-22",
			26.57
		],
		[
			"2004-10-19",
			25.02
		],
		[
			"2005-03-15",
			5.85
		],
		[
			"2006-01-25",
			27.41
		],
		[
			"2006-11-10",
			27.55
		],
		[
			"2007-06-15",
			27.19
		],
		[
			"2008-04-07",
			52.7
		],
		[
			"2010-01-18",
			59.34
		],
		[
			"2011-01-13",
			90.79
		],
		[
			"2012-11-08",
			31.09
		]
	],
	"80301710": [
		[
			"2013-04-24",
			61.11
		],
		[
			"2015-09-11",
			63.33
		],
		[
			"2000-01-26",
			75.29
		],
		[
			"2000-11-06",
			59.79
		],
		[
			"2001-03-07",
			54.47
		],
		[
			"2001-10-09",
			57.13
		],
		[
			"2002-04-17",
			51.81
		],
		[
			"2003-03-24",
			45.61
		],
		[
			"2003-09-04",
			62.89
		],
		[
			"2004-02-12",
			60.67
		],
		[
			"2004-10-28",
			58.01
		],
		[
			"2005-03-30",
			62.89
		],
		[
			"2006-02-01",
			58.9
		],
		[
			"2006-12-06",
			58.9
		],
		[
			"2007-07-10",
			66.87
		],
		[
			"2008-03-18",
			69.53
		],
		[
			"2010-11-09",
			52.26
		],
		[
			"2011-06-06",
			62
		]
	],
	"80301721": [
		[
			"2014-06-06",
			108.94
		],
		[
			"2015-09-03",
			103.63
		],
		[
			"2016-03-08",
			75.29
		],
		[
			"2000-01-21",
			93
		],
		[
			"2000-11-08",
			96.54
		],
		[
			"2001-03-15",
			79.27
		],
		[
			"2001-10-05",
			102.74
		],
		[
			"2002-04-02",
			82.81
		],
		[
			"2003-02-20",
			90.79
		],
		[
			"2003-08-06",
			87.69
		],
		[
			"2004-01-30",
			100.09
		],
		[
			"2004-08-05",
			100.09
		],
		[
			"2005-01-25",
			81.49
		],
		[
			"2006-03-07",
			105.84
		],
		[
			"2007-08-16",
			92.56
		],
		[
			"2008-03-10",
			74.4
		],
		[
			"2006-10-13",
			108.06
		],
		[
			"2010-01-15",
			109.39
		],
		[
			"2011-01-05",
			94.33
		],
		[
			"2012-02-23",
			102.74
		],
		[
			"2013-02-19",
			94.33
		]
	],
	"80301794": [
		[
			"2015-10-02",
			111.16
		],
		[
			"2000-01-28",
			94.77
		],
		[
			"2000-10-09",
			93.89
		],
		[
			"2001-02-12",
			110.27
		],
		[
			"2001-09-17",
			55.8
		],
		[
			"2002-03-15",
			18.6
		],
		[
			"2003-02-03",
			21.7
		],
		[
			"2003-07-21",
			89.01
		],
		[
			"2004-01-09",
			114.26
		],
		[
			"2004-09-20",
			136.84
		],
		[
			"2005-01-05",
			128.87
		],
		[
			"2006-10-10",
			96.1
		],
		[
			"2007-05-21",
			98.76
		],
		[
			"2007-09-18",
			83.26
		],
		[
			"2005-12-22",
			95.21
		],
		[
			"2008-01-15",
			108.5
		],
		[
			"2009-11-05",
			101.86
		],
		[
			"2010-11-11",
			98.31
		],
		[
			"2011-05-27",
			100.97
		],
		[
			"2012-07-04",
			118.24
		],
		[
			"2013-03-20",
			131.53
		]
	],
	"80301800": [
		[
			"2013-05-24",
			51.37
		],
		[
			"2015-07-01",
			49.6
		],
		[
			"2000-01-31",
			86.8
		],
		[
			"2000-10-06",
			82.81
		],
		[
			"2001-02-13",
			84.59
		],
		[
			"2001-09-14",
			68.2
		],
		[
			"2002-03-13",
			62
		],
		[
			"2003-07-18",
			42.96
		],
		[
			"2004-01-08",
			48.71
		],
		[
			"2004-09-16",
			45.17
		],
		[
			"2005-01-04",
			46.06
		],
		[
			"2006-01-06",
			48.71
		],
		[
			"2006-10-17",
			46.06
		],
		[
			"2007-05-21",
			46.5
		],
		[
			"2008-01-17",
			39.19
		],
		[
			"2003-01-30",
			67.76
		],
		[
			"2009-11-11",
			52.7
		],
		[
			"2010-11-18",
			53.14
		],
		[
			"2011-07-01",
			36.58
		]
	],
	"80301848": [
		[
			"2015-10-02",
			39.99
		],
		[
			"2000-03-08",
			67.76
		],
		[
			"2000-09-19",
			108.5
		],
		[
			"2001-01-31",
			80.16
		],
		[
			"2001-09-04",
			71.3
		],
		[
			"2002-02-07",
			53.59
		],
		[
			"2003-01-08",
			47.39
		],
		[
			"2003-06-17",
			54.47
		],
		[
			"2004-02-02",
			68.2
		],
		[
			"2004-09-10",
			86.36
		],
		[
			"2005-02-04",
			135.96
		],
		[
			"2005-12-12",
			150.13
		],
		[
			"2006-09-25",
			136.84
		],
		[
			"2007-01-30",
			135.51
		],
		[
			"2008-01-11",
			106.73
		],
		[
			"2009-10-26",
			56.69
		],
		[
			"2010-11-03",
			29.01
		],
		[
			"2011-03-21",
			10.41
		],
		[
			"2012-01-25",
			20.02
		],
		[
			"2013-03-04",
			30.2
		]
	],
	"80301850": [
		[
			"2014-06-05",
			177.14
		],
		[
			"2015-07-07",
			156.33
		],
		[
			"2000-03-09",
			146.59
		],
		[
			"2000-09-25",
			99.64
		],
		[
			"2001-02-01",
			145.26
		],
		[
			"2001-09-03",
			72.63
		],
		[
			"2002-02-08",
			132.41
		],
		[
			"2002-10-28",
			96.99
		],
		[
			"2003-01-07",
			180.24
		],
		[
			"2003-08-01",
			11.96
		],
		[
			"2004-04-15",
			126.66
		],
		[
			"2004-09-09",
			143.04
		],
		[
			"2005-02-08",
			194.86
		],
		[
			"2006-09-22",
			141.71
		],
		[
			"2007-06-04",
			171.83
		],
		[
			"2007-11-29",
			178.91
		],
		[
			"2008-07-23",
			153.67
		],
		[
			"2005-12-15",
			169.17
		],
		[
			"2009-10-06",
			187.77
		],
		[
			"2010-09-30",
			146.59
		],
		[
			"2011-03-25",
			150.57
		],
		[
			"2012-01-24",
			179.36
		],
		[
			"2013-01-10",
			188.21
		]
	],
	"80301861": [
		[
			"2015-10-13",
			0.53
		],
		[
			"2000-03-30",
			11.96
		],
		[
			"2000-09-26",
			7.26
		],
		[
			"2001-02-02",
			14.17
		],
		[
			"2001-09-11",
			3.19
		],
		[
			"2002-01-29",
			25.24
		],
		[
			"2003-06-23",
			2.35
		],
		[
			"2004-04-15",
			3.76
		],
		[
			"2004-09-13",
			1.33
		],
		[
			"2004-12-27",
			10.76
		],
		[
			"2006-09-28",
			1.33
		],
		[
			"2007-07-31",
			1.33
		],
		[
			"2008-04-11",
			1.33
		],
		[
			"2003-01-22",
			7.09
		],
		[
			"2005-12-08",
			2.79
		],
		[
			"2009-10-09",
			1.33
		],
		[
			"2010-09-16",
			0.13
		],
		[
			"2011-06-10",
			1.33
		],
		[
			"2012-09-14",
			0.13
		],
		[
			"2013-01-29",
			0.49
		]
	],
	"80301873": [
		[
			"2013-05-07",
			34.9
		],
		[
			"2014-05-23",
			20.64
		],
		[
			"2015-10-13",
			23.03
		],
		[
			"2000-03-27",
			29.67
		],
		[
			"2000-10-04",
			27.01
		],
		[
			"2001-02-07",
			28.79
		],
		[
			"2001-09-11",
			24.36
		],
		[
			"2002-02-01",
			27.01
		],
		[
			"2002-07-03",
			29.67
		],
		[
			"2003-07-09",
			27.32
		],
		[
			"2004-04-19",
			21.26
		],
		[
			"2004-10-05",
			22.45
		],
		[
			"2004-12-29",
			20.46
		],
		[
			"2006-09-27",
			13.68
		],
		[
			"2007-05-23",
			14.22
		],
		[
			"2008-04-14",
			19.4
		],
		[
			"2008-11-03",
			12.93
		],
		[
			"2003-01-21",
			15.94
		],
		[
			"2005-09-20",
			14.53
		],
		[
			"2009-10-28",
			20.55
		],
		[
			"2010-06-01",
			13.73
		],
		[
			"2011-05-04",
			10.32
		],
		[
			"2012-08-31",
			36.49
		]
	],
	"80301885": [
		[
			"2013-05-07",
			2.44
		],
		[
			"2014-05-26",
			1.33
		],
		[
			"2015-04-17",
			77.94
		],
		[
			"2016-01-21",
			5.31
		],
		[
			"2000-04-05",
			6.2
		],
		[
			"2000-10-04",
			1.33
		],
		[
			"2001-02-08",
			7.53
		],
		[
			"2001-09-12",
			7.97
		],
		[
			"2002-03-25",
			9.74
		],
		[
			"2003-01-24",
			2.66
		],
		[
			"2003-06-26",
			4.3
		],
		[
			"2004-04-26",
			16.39
		],
		[
			"2004-11-04",
			3.5
		],
		[
			"2005-01-24",
			15.99
		],
		[
			"2006-09-29",
			2.88
		],
		[
			"2007-07-12",
			21.88
		],
		[
			"2008-04-17",
			13.42
		],
		[
			"2005-11-29",
			1.33
		],
		[
			"2009-10-30",
			1.33
		],
		[
			"2010-11-23",
			9.83
		],
		[
			"2011-06-28",
			5.23
		],
		[
			"2012-12-07",
			0.13
		]
	],
	"80301903": [
		[
			"2013-07-09",
			5
		],
		[
			"2014-06-12",
			8.55
		],
		[
			"2015-09-24",
			8.95
		],
		[
			"2000-02-24",
			7.53
		],
		[
			"2000-09-01",
			11.51
		],
		[
			"2001-01-17",
			5.76
		],
		[
			"2001-08-20",
			3.32
		],
		[
			"2002-02-28",
			4.43
		],
		[
			"2002-09-18",
			2.04
		],
		[
			"2003-05-23",
			2.57
		],
		[
			"2003-12-15",
			2.88
		],
		[
			"2004-04-14",
			2.61
		],
		[
			"2004-08-17",
			2.57
		],
		[
			"2004-12-20",
			1.33
		],
		[
			"2006-09-18",
			5.89
		],
		[
			"2007-06-11",
			8.37
		],
		[
			"2007-11-19",
			10.1
		],
		[
			"2008-08-07",
			15.28
		],
		[
			"2005-11-16",
			2.04
		],
		[
			"2009-08-20",
			17.23
		],
		[
			"2010-09-06",
			18.78
		],
		[
			"2011-06-22",
			8.41
		],
		[
			"2012-10-29",
			2.08
		]
	],
	"80302040": [
		[
			"2013-07-29",
			66.43
		],
		[
			"2015-11-27",
			66.87
		],
		[
			"2016-01-26",
			62
		],
		[
			"2000-02-18",
			56.69
		],
		[
			"2000-09-01",
			52.26
		],
		[
			"2001-01-16",
			52.7
		],
		[
			"2001-08-24",
			49.16
		],
		[
			"2002-03-11",
			39.41
		],
		[
			"2002-09-18",
			55.36
		],
		[
			"2003-05-22",
			42.96
		],
		[
			"2003-12-15",
			66.87
		],
		[
			"2004-03-08",
			58.46
		],
		[
			"2004-07-27",
			54.91
		],
		[
			"2004-12-08",
			54.03
		],
		[
			"2006-09-15",
			75.73
		],
		[
			"2007-01-25",
			67.31
		],
		[
			"2007-11-12",
			61.11
		],
		[
			"2008-07-16",
			58.01
		],
		[
			"2005-11-15",
			58.9
		],
		[
			"2010-06-01",
			76.61
		]
	],
	"80302063": [
		[
			"2013-04-15",
			29.67
		],
		[
			"2014-06-24",
			54.91
		],
		[
			"2015-11-19",
			48.27
		],
		[
			"2000-03-30",
			49.6
		],
		[
			"2000-09-28",
			44.29
		],
		[
			"2001-02-05",
			47.39
		],
		[
			"2001-09-10",
			43.84
		],
		[
			"2002-01-31",
			53.59
		],
		[
			"2003-06-24",
			54.47
		],
		[
			"2004-04-20",
			56.69
		],
		[
			"2004-09-14",
			56.69
		],
		[
			"2004-12-28",
			60.67
		],
		[
			"2006-09-28",
			56.24
		],
		[
			"2007-08-01",
			51.37
		],
		[
			"2008-04-15",
			46.94
		],
		[
			"2003-01-23",
			56.69
		],
		[
			"2005-12-05",
			58.9
		],
		[
			"2009-11-09",
			47.39
		],
		[
			"2010-11-24",
			51.37
		],
		[
			"2011-05-04",
			27.24
		],
		[
			"2012-08-31",
			39.55
		]
	],
	"80302154": [
		[
			"2013-04-19",
			159.43
		],
		[
			"2014-12-10",
			163.41
		],
		[
			"2015-06-23",
			154.11
		],
		[
			"2000-02-01",
			197.96
		],
		[
			"2000-10-05",
			198.4
		],
		[
			"2001-02-09",
			190.43
		],
		[
			"2001-09-18",
			180.24
		],
		[
			"2002-03-14",
			142.6
		],
		[
			"2003-07-17",
			162.09
		],
		[
			"2004-01-08",
			173.6
		],
		[
			"2004-09-16",
			144.81
		],
		[
			"2005-01-04",
			168.73
		],
		[
			"2005-12-22",
			185.56
		],
		[
			"2006-10-04",
			184.67
		],
		[
			"2007-08-02",
			172.71
		],
		[
			"2008-01-18",
			176.26
		],
		[
			"2003-01-29",
			158.1
		],
		[
			"2009-11-13",
			168.29
		],
		[
			"2010-11-24",
			176.26
		],
		[
			"2011-07-01",
			180.69
		],
		[
			"2012-11-08",
			175.37
		]
	],
	"80302166": [
		[
			"2014-12-10",
			11.16
		],
		[
			"2015-03-20",
			8.55
		],
		[
			"2000-01-31",
			36.76
		],
		[
			"2000-10-09",
			70.41
		],
		[
			"2001-02-12",
			44.29
		],
		[
			"2001-09-14",
			68.64
		],
		[
			"2002-03-13",
			59.34
		],
		[
			"2003-07-18",
			23.03
		],
		[
			"2006-10-10",
			3.9
		],
		[
			"2007-05-21",
			16.16
		],
		[
			"2007-09-18",
			9.21
		],
		[
			"2008-01-15",
			8.06
		],
		[
			"2003-02-03",
			20.81
		],
		[
			"2009-11-12",
			11.38
		],
		[
			"2010-11-11",
			12.58
		],
		[
			"2011-05-27",
			13.37
		],
		[
			"2012-07-04",
			15.01
		],
		[
			"2013-02-06",
			4.87
		]
	],
	"80302180": [
		[
			"2014-05-19",
			70.86
		],
		[
			"2015-03-20",
			62.89
		],
		[
			"2000-04-07",
			97.87
		],
		[
			"2000-10-17",
			81.04
		],
		[
			"2001-02-16",
			73.07
		],
		[
			"2001-09-19",
			93.44
		],
		[
			"2002-02-20",
			124.44
		],
		[
			"2003-02-10",
			96.99
		],
		[
			"2003-07-15",
			106.29
		],
		[
			"2004-01-15",
			124.44
		],
		[
			"2004-09-23",
			101.86
		],
		[
			"2005-01-11",
			95.21
		],
		[
			"2006-01-04",
			115.14
		],
		[
			"2007-07-18",
			87.69
		],
		[
			"2008-01-28",
			75.29
		],
		[
			"2006-10-18",
			120.01
		],
		[
			"2009-11-18",
			75.29
		],
		[
			"2010-09-15",
			77.94
		],
		[
			"2011-03-11",
			74.84
		],
		[
			"2012-06-01",
			82.37
		],
		[
			"2013-01-25",
			89.46
		]
	],
	"80302208": [
		[
			"2014-09-15",
			1.33
		],
		[
			"2015-08-26",
			0.4
		],
		[
			"2000-10-26",
			1.33
		],
		[
			"2001-02-22",
			1.33
		],
		[
			"2001-09-25",
			1.33
		],
		[
			"2002-03-27",
			1.33
		],
		[
			"2003-07-22",
			3.41
		],
		[
			"2004-01-28",
			1.33
		],
		[
			"2004-09-30",
			1.33
		],
		[
			"2005-02-09",
			1.33
		],
		[
			"2006-01-12",
			1.33
		],
		[
			"2006-11-07",
			1.33
		],
		[
			"2007-08-22",
			1.33
		],
		[
			"2008-01-23",
			1.33
		],
		[
			"2003-02-12",
			4.03
		],
		[
			"2009-11-30",
			1.33
		],
		[
			"2010-09-14",
			0.13
		],
		[
			"2011-03-09",
			0.13
		],
		[
			"2012-01-04",
			0.13
		],
		[
			"2013-01-09",
			0.13
		]
	],
	"80302518": [
		[
			"2014-08-28",
			36.31
		],
		[
			"2015-01-12",
			31.58
		],
		[
			"2016-03-07",
			35.43
		],
		[
			"2000-02-11",
			47.83
		],
		[
			"2000-09-13",
			46.94
		],
		[
			"2001-01-22",
			50.49
		],
		[
			"2001-08-29",
			50.93
		],
		[
			"2002-01-16",
			51.37
		],
		[
			"2002-09-12",
			52.7
		],
		[
			"2003-06-10",
			56.24
		],
		[
			"2004-01-19",
			52.7
		],
		[
			"2004-08-18",
			52.7
		],
		[
			"2004-12-14",
			54.47
		],
		[
			"2006-09-12",
			50.04
		],
		[
			"2007-06-18",
			49.6
		],
		[
			"2007-11-22",
			46.94
		],
		[
			"2008-07-28",
			46.06
		],
		[
			"2005-11-08",
			53.59
		],
		[
			"2009-08-21",
			42.6
		],
		[
			"2010-07-29",
			39.37
		],
		[
			"2011-01-04",
			40.52
		],
		[
			"2012-02-13",
			36.89
		],
		[
			"2013-01-28",
			33.92
		]
	],
	"80302520": [
		[
			"2013-05-07",
			74.4
		],
		[
			"2014-06-24",
			59.34
		],
		[
			"2015-12-03",
			50.04
		],
		[
			"2000-03-30",
			113.81
		],
		[
			"2000-10-04",
			101.86
		],
		[
			"2001-02-05",
			113.81
		],
		[
			"2001-09-11",
			99.64
		],
		[
			"2002-02-01",
			111.16
		],
		[
			"2003-06-26",
			95.21
		],
		[
			"2004-04-20",
			73.96
		],
		[
			"2004-09-14",
			69.97
		],
		[
			"2004-12-29",
			64.66
		],
		[
			"2006-09-29",
			82.37
		],
		[
			"2007-07-31",
			84.59
		],
		[
			"2008-04-15",
			81.49
		],
		[
			"2003-01-23",
			100.09
		],
		[
			"2005-12-05",
			70.86
		],
		[
			"2009-10-09",
			75.29
		],
		[
			"2010-11-25",
			75.73
		],
		[
			"2011-08-19",
			85.47
		],
		[
			"2012-09-20",
			75.73
		]
	],
	"80302543": [
		[
			"2015-08-24",
			93.44
		],
		[
			"2000-10-31",
			106.29
		],
		[
			"2001-03-01",
			104.96
		],
		[
			"2001-10-01",
			110.27
		],
		[
			"2002-04-10",
			112.93
		],
		[
			"2003-07-31",
			101.86
		],
		[
			"2004-03-10",
			112.04
		],
		[
			"2004-10-12",
			106.73
		],
		[
			"2005-03-09",
			107.17
		],
		[
			"2006-01-18",
			114.7
		],
		[
			"2006-11-09",
			120.46
		],
		[
			"2007-07-25",
			108.06
		],
		[
			"2008-03-04",
			104.51
		],
		[
			"2003-02-14",
			114.26
		],
		[
			"2010-01-12",
			93.89
		],
		[
			"2011-01-12",
			88.57
		],
		[
			"2012-03-01",
			106.29
		],
		[
			"2013-02-05",
			95.66
		]
	],
	"80302555": [
		[
			"2015-08-24",
			158.99
		],
		[
			"2000-11-02",
			152.79
		],
		[
			"2001-03-01",
			152.79
		],
		[
			"2001-10-01",
			161.2
		],
		[
			"2002-04-10",
			180.24
		],
		[
			"2003-02-18",
			162.97
		],
		[
			"2003-07-28",
			160.76
		],
		[
			"2004-03-10",
			166.96
		],
		[
			"2004-10-11",
			176.7
		],
		[
			"2005-03-09",
			183.79
		],
		[
			"2006-01-18",
			178.47
		],
		[
			"2006-11-08",
			201.5
		],
		[
			"2007-07-25",
			180.24
		],
		[
			"2008-03-04",
			183.34
		],
		[
			"2000-05-02",
			162.09
		],
		[
			"2010-01-13",
			155
		],
		[
			"2011-01-14",
			135.51
		],
		[
			"2012-01-02",
			137.29
		],
		[
			"2013-01-11",
			169.17
		]
	],
	"80302646": [
		[
			"2014-01-17",
			55.8
		],
		[
			"2015-06-15",
			46.06
		],
		[
			"2016-01-22",
			53.14
		],
		[
			"2000-10-16",
			51.81
		],
		[
			"2001-02-21",
			58.46
		],
		[
			"2001-09-24",
			51.37
		],
		[
			"2002-02-25",
			48.27
		],
		[
			"2003-07-14",
			44.73
		],
		[
			"2004-01-15",
			31.44
		],
		[
			"2003-02-11",
			43.4
		],
		[
			"2004-09-29",
			44.73
		],
		[
			"2005-01-19",
			34.9
		],
		[
			"2006-01-03",
			51.81
		],
		[
			"2006-10-23",
			40.03
		],
		[
			"2007-07-17",
			43.27
		],
		[
			"2008-01-29",
			49.6
		],
		[
			"2009-12-01",
			45.17
		],
		[
			"2010-11-08",
			57.13
		],
		[
			"2011-05-16",
			57.13
		],
		[
			"2012-03-02",
			51.37
		],
		[
			"2013-01-08",
			49.6
		]
	],
	"80302660": [
		[
			"2013-04-08",
			52.7
		],
		[
			"2014-09-16",
			23.12
		],
		[
			"2015-09-02",
			26.22
		],
		[
			"2000-11-15",
			103.63
		],
		[
			"2001-03-22",
			51.37
		],
		[
			"2001-10-25",
			77.5
		],
		[
			"2002-05-07",
			92.11
		],
		[
			"2003-03-27",
			81.04
		],
		[
			"2003-09-12",
			62.89
		],
		[
			"2004-02-24",
			49.16
		],
		[
			"2004-11-03",
			40.17
		],
		[
			"2005-04-11",
			36.23
		],
		[
			"2006-03-01",
			31.44
		],
		[
			"2006-12-20",
			33.21
		],
		[
			"2007-09-03",
			38.35
		],
		[
			"2008-05-26",
			36.62
		],
		[
			"2000-05-04",
			91.23
		],
		[
			"2010-01-29",
			28.48
		],
		[
			"2011-01-06",
			45.61
		],
		[
			"2012-06-28",
			55.8
		]
	],
	"80302762": [
		[
			"2013-04-19",
			59.34
		],
		[
			"2014-11-25",
			51.37
		],
		[
			"2015-08-26",
			52.26
		],
		[
			"2000-05-22",
			151.9
		],
		[
			"2000-10-06",
			143.93
		],
		[
			"2001-02-13",
			144.37
		],
		[
			"2001-09-18",
			144.37
		],
		[
			"2002-03-15",
			136.4
		],
		[
			"2003-07-17",
			100.97
		],
		[
			"2004-01-09",
			84.59
		],
		[
			"2004-09-16",
			78.39
		],
		[
			"2005-01-06",
			72.63
		],
		[
			"2006-03-02",
			67.76
		],
		[
			"2006-10-04",
			72.19
		],
		[
			"2007-05-21",
			75.29
		],
		[
			"2008-01-17",
			68.64
		],
		[
			"2008-11-10",
			79.71
		],
		[
			"2003-02-05",
			109.83
		],
		[
			"2009-11-12",
			80.16
		],
		[
			"2010-11-18",
			79.27
		],
		[
			"2011-06-30",
			82.81
		],
		[
			"2012-11-08",
			64.21
		]
	],
	"80302798": [
		[
			"2014-12-08",
			39.81
		],
		[
			"2015-09-04",
			40.7
		],
		[
			"2000-02-21",
			75.29
		],
		[
			"2001-01-15",
			68.2
		],
		[
			"2001-08-23",
			64.66
		],
		[
			"2002-02-28",
			66.43
		],
		[
			"2002-09-24",
			58.9
		],
		[
			"2003-05-26",
			58.46
		],
		[
			"2003-12-12",
			60.67
		],
		[
			"2004-04-13",
			53.14
		],
		[
			"2004-08-11",
			54.47
		],
		[
			"2004-12-10",
			53.59
		],
		[
			"2006-08-30",
			48.71
		],
		[
			"2007-06-11",
			45.61
		],
		[
			"2007-11-15",
			39.15
		],
		[
			"2008-07-15",
			42.2
		],
		[
			"2005-11-17",
			50.04
		],
		[
			"2009-08-18",
			44.15
		],
		[
			"2010-09-08",
			44.73
		],
		[
			"2011-05-25",
			45.61
		],
		[
			"2012-06-18",
			46.5
		],
		[
			"2013-03-07",
			51.81
		]
	],
	"80302944": [
		[
			"2013-04-17",
			46.94
		],
		[
			"2014-05-28",
			50.49
		],
		[
			"2015-08-19",
			40.03
		],
		[
			"2000-04-06",
			68.2
		],
		[
			"2000-10-10",
			72.63
		],
		[
			"2001-02-14",
			79.27
		],
		[
			"2001-09-13",
			69.53
		],
		[
			"2002-03-18",
			71.74
		],
		[
			"2003-06-13",
			68.64
		],
		[
			"2004-02-04",
			27.77
		],
		[
			"2004-10-14",
			66.43
		],
		[
			"2005-01-07",
			64.21
		],
		[
			"2006-01-10",
			62
		],
		[
			"2006-10-16",
			54.91
		],
		[
			"2007-08-20",
			59.34
		],
		[
			"2008-01-23",
			50.93
		],
		[
			"2003-01-28",
			72.19
		],
		[
			"2009-11-13",
			43.98
		],
		[
			"2010-11-22",
			28.96
		],
		[
			"2011-05-20",
			31
		],
		[
			"2012-12-03",
			50.04
		]
	],
	"80302981": [
		[
			"2014-07-16",
			1.33
		],
		[
			"2015-02-27",
			1.42
		],
		[
			"2000-02-18",
			1.33
		],
		[
			"2000-09-11",
			1.46
		],
		[
			"2001-01-16",
			1.33
		],
		[
			"2001-08-20",
			1.33
		],
		[
			"2002-03-11",
			1.9
		],
		[
			"2002-09-18",
			1.42
		],
		[
			"2003-05-22",
			2.08
		],
		[
			"2003-12-15",
			1.95
		],
		[
			"2004-04-01",
			1.86
		],
		[
			"2004-07-27",
			1.33
		],
		[
			"2004-12-13",
			1.33
		],
		[
			"2006-09-18",
			1.33
		],
		[
			"2007-01-25",
			1.33
		],
		[
			"2007-11-19",
			1.33
		],
		[
			"2008-07-16",
			1.33
		],
		[
			"2005-11-16",
			1.33
		],
		[
			"2009-08-20",
			0.4
		],
		[
			"2010-09-08",
			0.13
		],
		[
			"2011-05-25",
			1.9
		],
		[
			"2012-06-21",
			2.75
		],
		[
			"2013-03-07",
			3.45
		]
	],
	"80303080": [
		[
			"2013-06-28",
			1.33
		],
		[
			"2014-09-19",
			1.33
		],
		[
			"2015-09-23",
			0.13
		],
		[
			"2007-10-12",
			1.33
		],
		[
			"2008-06-11",
			1.33
		],
		[
			"2000-03-01",
			1.33
		],
		[
			"2000-09-15",
			1.33
		],
		[
			"2001-01-31",
			1.33
		],
		[
			"2001-11-13",
			1.33
		],
		[
			"2002-01-23",
			1.33
		],
		[
			"2002-09-10",
			1.33
		],
		[
			"2003-06-12",
			1.82
		],
		[
			"2004-02-10",
			1.33
		],
		[
			"2004-10-08",
			1.33
		],
		[
			"2005-04-21",
			1.33
		],
		[
			"2005-11-03",
			1.33
		],
		[
			"2006-08-25",
			1.33
		],
		[
			"2007-05-14",
			1.33
		],
		[
			"2009-07-16",
			1.33
		],
		[
			"2010-11-22",
			0.13
		],
		[
			"2011-05-18",
			0.13
		],
		[
			"2012-12-18",
			1.33
		]
	],
	"80303183": [
		[
			"2013-06-27",
			103.19
		],
		[
			"2015-09-08",
			107.61
		],
		[
			"2016-03-08",
			106.29
		],
		[
			"2007-09-07",
			92.56
		],
		[
			"2008-11-11",
			83.26
		],
		[
			"2006-10-13",
			100.97
		],
		[
			"2010-01-22",
			98.76
		],
		[
			"2011-02-18",
			94.77
		],
		[
			"2012-09-26",
			105.84
		]
	],
	"80303201": [
		[
			"2015-08-26",
			77.06
		],
		[
			"2001-12-06",
			56.24
		],
		[
			"2002-04-11",
			58.9
		],
		[
			"2003-02-17",
			48.71
		],
		[
			"2003-07-24",
			65.1
		],
		[
			"2005-03-08",
			21.74
		],
		[
			"2006-01-20",
			24.8
		],
		[
			"2006-11-09",
			25.6
		],
		[
			"2007-07-20",
			17.4
		],
		[
			"2008-03-06",
			26.48
		],
		[
			"2010-01-14",
			73.51
		],
		[
			"2010-12-21",
			74.4
		],
		[
			"2012-01-02",
			73.07
		],
		[
			"2013-02-20",
			71.3
		]
	],
	"80303237": [
		[
			"2014-01-17",
			36.98
		],
		[
			"2015-08-25",
			36.4
		],
		[
			"2016-01-07",
			36.76
		],
		[
			"2001-12-06",
			47.39
		],
		[
			"2002-02-25",
			46.5
		],
		[
			"2003-07-15",
			53.59
		],
		[
			"2004-01-15",
			50.04
		],
		[
			"2003-02-11",
			52.7
		],
		[
			"2004-09-29",
			49.6
		],
		[
			"2005-01-19",
			44.11
		],
		[
			"2006-01-04",
			44.06
		],
		[
			"2007-07-27",
			52.7
		],
		[
			"2008-01-29",
			50.04
		],
		[
			"2006-10-27",
			38.88
		],
		[
			"2009-11-17",
			47.83
		],
		[
			"2010-11-08",
			45.61
		],
		[
			"2011-05-16",
			42.47
		],
		[
			"2012-03-02",
			41.54
		],
		[
			"2013-01-08",
			37.82
		]
	],
	"80303262": [
		[
			"2013-05-08",
			24.49
		],
		[
			"2013-09-24",
			22.59
		],
		[
			"2014-09-29",
			32.9
		],
		[
			"2015-11-27",
			26.84
		],
		[
			"2016-03-07",
			33.66
		],
		[
			"2001-12-12",
			35.87
		],
		[
			"2002-01-21",
			35.87
		],
		[
			"2002-09-16",
			33.21
		],
		[
			"2003-06-11",
			39.5
		],
		[
			"2004-02-10",
			34.1
		],
		[
			"2004-08-19",
			38.53
		],
		[
			"2004-12-15",
			37.91
		],
		[
			"2006-09-08",
			37.55
		],
		[
			"2007-05-14",
			35.3
		],
		[
			"2007-11-26",
			33.7
		],
		[
			"2008-07-09",
			29.41
		],
		[
			"2005-11-14",
			36.49
		],
		[
			"2010-06-09",
			30.69
		],
		[
			"2011-05-18",
			32.46
		],
		[
			"2012-12-18",
			27.55
		]
	],
	"80303316": [
		[
			"2015-09-11",
			117.8
		],
		[
			"2000-01-21",
			121.34
		],
		[
			"2000-11-06",
			142.6
		],
		[
			"2001-03-09",
			65.1
		],
		[
			"2001-04-23",
			157.21
		],
		[
			"2001-10-09",
			174.04
		],
		[
			"2002-04-12",
			199.29
		],
		[
			"2003-07-31",
			154.11
		],
		[
			"2004-03-31",
			119.57
		],
		[
			"2004-10-19",
			122.67
		],
		[
			"2005-03-14",
			124.89
		],
		[
			"2006-01-25",
			171.39
		],
		[
			"2006-11-10",
			174.04
		],
		[
			"2008-04-07",
			151.46
		],
		[
			"2007-06-15",
			176.26
		],
		[
			"2008-08-05",
			138.61
		],
		[
			"2003-02-28",
			152.79
		],
		[
			"2009-12-16",
			144.37
		],
		[
			"2010-11-02",
			131.53
		],
		[
			"2011-08-18",
			118.24
		],
		[
			"2012-09-07",
			127.1
		],
		[
			"2013-02-25",
			129.76
		]
	],
	"80303328": [
		[
			"2015-03-27",
			15.85
		],
		[
			"2000-01-26",
			204.16
		],
		[
			"2000-05-23",
			12.84
		],
		[
			"2000-10-26",
			1.33
		],
		[
			"2001-02-22",
			45.61
		],
		[
			"2001-09-25",
			3.01
		],
		[
			"2002-03-27",
			81.93
		],
		[
			"2003-07-22",
			2.35
		],
		[
			"2004-01-28",
			174.04
		],
		[
			"2004-09-30",
			1.42
		],
		[
			"2005-03-11",
			46.5
		],
		[
			"2006-01-12",
			6.69
		],
		[
			"2006-11-07",
			2.7
		],
		[
			"2007-08-22",
			2.92
		],
		[
			"2008-01-28",
			98.76
		],
		[
			"2003-02-12",
			143.49
		],
		[
			"2009-11-30",
			21.7
		],
		[
			"2010-09-14",
			3.85
		],
		[
			"2011-03-09",
			77.5
		],
		[
			"2012-01-04",
			25.51
		],
		[
			"2013-01-09",
			16.87
		]
	],
	"80303330": [
		[
			"2013-04-17",
			37.2
		],
		[
			"2014-05-15",
			32.73
		],
		[
			"2015-10-12",
			32.02
		],
		[
			"2000-01-27",
			40.3
		],
		[
			"2000-10-26",
			35.87
		],
		[
			"2001-02-14",
			30.56
		],
		[
			"2001-09-13",
			25.69
		],
		[
			"2002-03-18",
			28.79
		],
		[
			"2003-07-22",
			29.67
		],
		[
			"2004-02-04",
			69.97
		],
		[
			"2004-10-14",
			25.38
		],
		[
			"2005-01-07",
			27.86
		],
		[
			"2006-01-10",
			26.88
		],
		[
			"2007-08-20",
			29.01
		],
		[
			"2008-01-23",
			30.69
		],
		[
			"2003-01-28",
			30.11
		],
		[
			"2006-10-16",
			28.21
		],
		[
			"2009-11-17",
			33.88
		],
		[
			"2010-11-22",
			26.79
		],
		[
			"2011-05-20",
			58.46
		],
		[
			"2012-09-18",
			39.68
		]
	],
	"80303353": [
		[
			"2014-09-18",
			23.69
		],
		[
			"2015-10-14",
			26.93
		],
		[
			"2001-12-11",
			65.1
		],
		[
			"2002-03-12",
			65.1
		],
		[
			"2002-09-19",
			69.09
		],
		[
			"2003-05-21",
			75.29
		],
		[
			"2003-12-17",
			74.4
		],
		[
			"2004-04-13",
			72.19
		],
		[
			"2004-08-13",
			70.86
		],
		[
			"2004-12-09",
			68.64
		],
		[
			"2006-08-29",
			58.46
		],
		[
			"2007-05-08",
			45.17
		],
		[
			"2007-11-16",
			43.22
		],
		[
			"2008-07-17",
			37.07
		],
		[
			"2005-11-17",
			65.1
		],
		[
			"2009-08-18",
			35.83
		],
		[
			"2010-09-07",
			33.79
		],
		[
			"2011-06-08",
			39.15
		],
		[
			"2012-06-21",
			43.8
		],
		[
			"2013-03-07",
			33.88
		]
	],
	"80303377": [
		[
			"2014-09-09",
			39.86
		],
		[
			"2015-11-19",
			2.3
		],
		[
			"2001-12-07",
			4.25
		],
		[
			"2002-02-01",
			1.33
		],
		[
			"2003-01-22",
			1.37
		],
		[
			"2004-04-19",
			8.41
		],
		[
			"2004-09-13",
			3.85
		],
		[
			"2004-12-27",
			2.61
		],
		[
			"2007-07-19",
			3.41
		],
		[
			"2008-08-22",
			3.99
		],
		[
			"2005-12-05",
			3.54
		],
		[
			"2010-08-03",
			5.09
		],
		[
			"2011-12-09",
			4.3
		],
		[
			"2012-09-14",
			5.05
		],
		[
			"2013-01-29",
			3.19
		]
	],
	"80303389": [
		[
			"2013-05-03",
			1.33
		],
		[
			"2015-10-13",
			0.13
		],
		[
			"2006-10-09",
			1.33
		],
		[
			"2007-07-31",
			1.33
		],
		[
			"2008-04-15",
			1.33
		],
		[
			"2009-11-09",
			1.33
		],
		[
			"2010-11-25",
			0.13
		],
		[
			"2011-08-19",
			0.13
		],
		[
			"2012-09-19",
			0.13
		]
	],
	"80303390": [
		[
			"2014-05-19",
			45.17
		],
		[
			"2015-07-01",
			42.07
		],
		[
			"2001-12-06",
			77.5
		],
		[
			"2002-02-20",
			69.97
		],
		[
			"2004-01-16",
			58.01
		],
		[
			"2004-09-23",
			55.36
		],
		[
			"2005-01-11",
			58.46
		],
		[
			"2006-01-04",
			58.46
		],
		[
			"2007-07-27",
			54.47
		],
		[
			"2008-01-28",
			55.8
		],
		[
			"2006-10-18",
			55.36
		],
		[
			"2009-11-19",
			53.14
		],
		[
			"2010-08-06",
			54.91
		],
		[
			"2011-03-10",
			44.73
		],
		[
			"2012-06-01",
			50.04
		],
		[
			"2013-01-25",
			47.83
		]
	],
	"80303407": [
		[
			"2013-04-08",
			38.44
		],
		[
			"2014-06-25",
			54.03
		],
		[
			"2015-01-07",
			59.79
		],
		[
			"2006-12-20",
			77.06
		],
		[
			"2007-07-10",
			157.21
		],
		[
			"2008-04-21",
			74.84
		],
		[
			"2010-01-26",
			48.27
		],
		[
			"2011-01-07",
			25.86
		],
		[
			"2012-06-29",
			96.54
		]
	],
	"80303420": [
		[
			"2015-09-11",
			62
		],
		[
			"2003-09-04",
			44.29
		],
		[
			"2004-02-12",
			74.84
		],
		[
			"2004-10-21",
			78.83
		],
		[
			"2005-04-19",
			79.71
		],
		[
			"2006-01-30",
			77.06
		],
		[
			"2006-11-20",
			74.4
		],
		[
			"2007-07-10",
			69.53
		],
		[
			"2008-03-18",
			56.24
		],
		[
			"2010-11-09",
			65.99
		],
		[
			"2011-06-06",
			65.54
		],
		[
			"2012-08-24",
			65.1
		],
		[
			"2013-03-19",
			70.41
		]
	],
	"80303559": [
		[
			"2013-04-18",
			29.27
		],
		[
			"2015-09-30",
			25.95
		],
		[
			"2007-07-16",
			54.91
		],
		[
			"2008-08-05",
			27.94
		],
		[
			"2010-01-25",
			44.29
		],
		[
			"2011-01-11",
			36.89
		],
		[
			"2011-08-03",
			31
		],
		[
			"2012-11-26",
			39.99
		]
	],
	"80303614": [
		[
			"2014-06-23",
			30.2
		],
		[
			"2015-09-23",
			27.15
		],
		[
			"2005-01-18",
			32.11
		],
		[
			"2007-05-22",
			26.17
		],
		[
			"2008-03-17",
			26.62
		],
		[
			"2008-11-05",
			27.19
		],
		[
			"2009-12-03",
			29.94
		],
		[
			"2010-06-02",
			26.31
		],
		[
			"2011-06-09",
			29.18
		],
		[
			"2012-08-27",
			25.51
		],
		[
			"2013-03-06",
			21.83
		]
	],
	"80303638": [
		[
			"2013-07-10",
			1.33
		],
		[
			"2014-09-19",
			1.33
		],
		[
			"2015-09-10",
			0.13
		],
		[
			"2005-01-24",
			1.33
		],
		[
			"2007-07-12",
			1.33
		],
		[
			"2008-08-21",
			1.33
		],
		[
			"2010-11-04",
			1.33
		],
		[
			"2011-11-30",
			0.13
		],
		[
			"2012-12-11",
			1.33
		]
	],
	"81150040": [
		[
			"2013-07-23",
			16.83
		],
		[
			"2015-09-04",
			14.7
		],
		[
			"2000-02-29",
			2.79
		],
		[
			"2000-08-23",
			3.45
		],
		[
			"2001-01-10",
			4.43
		],
		[
			"2001-07-12",
			4.87
		],
		[
			"2002-02-13",
			4.43
		],
		[
			"2002-10-28",
			4.43
		],
		[
			"2003-05-05",
			4.87
		],
		[
			"2004-01-22",
			3.94
		],
		[
			"2004-07-29",
			3.76
		],
		[
			"2005-03-10",
			1.55
		],
		[
			"2006-09-20",
			2.48
		],
		[
			"2007-05-25",
			6.2
		],
		[
			"2007-11-05",
			8.55
		],
		[
			"2008-08-04",
			7
		],
		[
			"2005-11-25",
			1.33
		],
		[
			"2009-08-10",
			5.4
		],
		[
			"2010-09-03",
			4.12
		],
		[
			"2011-03-17",
			4.56
		],
		[
			"2012-01-17",
			5.54
		]
	],
	"86452010": [
		[
			"2007-10-10",
			14
		],
		[
			"2007-04-18",
			29.21
		],
		[
			"2008-04-09",
			30.31
		],
		[
			"2006-09-27",
			32.31
		],
		[
			"2008-10-15",
			30.71
		],
		[
			"2009-10-07",
			32.01
		],
		[
			"2009-04-22",
			28.11
		],
		[
			"2000-10-25",
			31.01
		],
		[
			"2000-04-26",
			32.01
		],
		[
			"2001-10-02",
			28.01
		],
		[
			"2001-04-24",
			30.01
		],
		[
			"2002-10-15",
			36.41
		],
		[
			"2002-04-09",
			34.01
		],
		[
			"2003-10-01",
			35.01
		],
		[
			"2003-04-01",
			36.41
		],
		[
			"2004-10-20",
			29.91
		],
		[
			"2004-04-14",
			42.92
		],
		[
			"2005-04-20",
			21.21
		],
		[
			"2006-04-19",
			29.51
		],
		[
			"2011-10-12",
			26.81
		],
		[
			"2011-04-06",
			21.01
		],
		[
			"2010-10-20",
			23.31
		],
		[
			"2010-04-14",
			28.11
		],
		[
			"2012-10-24",
			21.81
		],
		[
			"2012-05-09",
			26.91
		],
		[
			"2013-10-16",
			17.41
		],
		[
			"2013-04-10",
			17.61
		],
		[
			"2014-10-09",
			15.31
		],
		[
			"2014-04-08",
			15.91
		],
		[
			"2015-10-07",
			17.81
		],
		[
			"2015-03-31",
			15.21
		]
	],
	"86452216": [
		[
			"2008-03-13",
			12
		],
		[
			"2007-09-18",
			21.01
		],
		[
			"2007-03-13",
			16.01
		],
		[
			"2008-09-09",
			13
		],
		[
			"2009-03-16",
			15.01
		],
		[
			"2009-09-15",
			13
		],
		[
			"2002-11-13",
			14
		],
		[
			"2004-09-30",
			19.01
		],
		[
			"2005-03-17",
			15.01
		],
		[
			"2006-09-13",
			9
		],
		[
			"2006-03-13",
			11
		],
		[
			"2010-09-22",
			13
		],
		[
			"2010-03-23",
			9
		],
		[
			"2011-03-22",
			14
		],
		[
			"2011-09-06",
			21.01
		],
		[
			"2012-03-20",
			17.01
		],
		[
			"2012-09-18",
			22.01
		],
		[
			"2014-03-18",
			15.01
		],
		[
			"2013-09-17",
			16.01
		],
		[
			"2013-03-19",
			18.01
		],
		[
			"2014-09-23",
			14
		],
		[
			"2015-03-17",
			16.01
		],
		[
			"2015-09-22",
			17.01
		]
	],
	"86454328": [
		[
			"2007-11-07",
			2.6
		],
		[
			"2007-08-29",
			3.1
		],
		[
			"2007-07-04",
			2.7
		],
		[
			"2007-05-02",
			2
		],
		[
			"2007-02-28",
			2.6
		],
		[
			"2007-01-03",
			2.6
		],
		[
			"2008-02-27",
			1.9
		],
		[
			"2008-10-29",
			3.1
		],
		[
			"2009-04-29",
			3.6
		],
		[
			"2009-10-28",
			2.9
		],
		[
			"2010-03-03",
			2.6
		],
		[
			"2000-11-21",
			2.6
		],
		[
			"2000-09-27",
			4
		],
		[
			"2000-07-19",
			3.6
		],
		[
			"2000-05-04",
			4.5
		],
		[
			"2001-11-19",
			4.1
		],
		[
			"2001-09-20",
			3.2
		],
		[
			"2001-07-17",
			4.5
		],
		[
			"2001-05-03",
			4.4
		],
		[
			"2002-11-26",
			4.3
		],
		[
			"2002-09-27",
			4.7
		],
		[
			"2002-07-24",
			3.1
		],
		[
			"2002-05-08",
			4.6
		],
		[
			"2002-02-18",
			4.4
		],
		[
			"2003-12-10",
			4.1
		],
		[
			"2003-11-05",
			4
		],
		[
			"2003-10-15",
			3.9
		],
		[
			"2003-08-12",
			5.2
		],
		[
			"2003-06-17",
			4.8
		],
		[
			"2003-04-16",
			6.4
		],
		[
			"2003-03-25",
			4.7
		],
		[
			"2003-01-15",
			4.1
		],
		[
			"2004-11-16",
			1.8
		],
		[
			"2004-09-01",
			3.5
		],
		[
			"2004-07-07",
			3.2
		],
		[
			"2004-05-05",
			3.4
		],
		[
			"2004-03-03",
			4
		],
		[
			"2004-01-07",
			4
		],
		[
			"2005-05-11",
			1.7
		],
		[
			"2005-03-02",
			2.3
		],
		[
			"2005-01-05",
			2.8
		],
		[
			"2006-11-08",
			3
		],
		[
			"2006-05-03",
			3.4
		],
		[
			"2006-03-01",
			3.1
		],
		[
			"2006-01-04",
			2.4
		],
		[
			"2010-10-27",
			2.9
		],
		[
			"2011-03-01",
			5.6
		],
		[
			"2012-02-28",
			5
		],
		[
			"2012-10-30",
			5
		],
		[
			"2014-01-16",
			5
		],
		[
			"2013-02-26",
			5
		],
		[
			"2015-02-24",
			5
		],
		[
			"2014-11-06",
			5
		],
		[
			"2015-10-27",
			5
		],
		[
			"2016-02-23",
			5
		]
	],
	"86530550": [
		[
			"2007-11-21",
			4.5
		],
		[
			"2007-07-16",
			5.8
		],
		[
			"2007-02-06",
			5.9
		],
		[
			"2006-11-14",
			4.2
		],
		[
			"2006-07-18",
			6.6
		],
		[
			"2006-04-03",
			6.9
		],
		[
			"2006-03-07",
			7.3
		],
		[
			"2005-11-16",
			7
		],
		[
			"2005-07-05",
			6.2
		],
		[
			"2005-03-08",
			7.5
		],
		[
			"2004-11-16",
			8.8
		],
		[
			"2004-07-14",
			8.8
		],
		[
			"2004-03-02",
			9
		],
		[
			"2003-11-11",
			8.5
		],
		[
			"2003-07-08",
			8
		],
		[
			"2003-05-08",
			1
		],
		[
			"2003-02-25",
			9
		],
		[
			"2009-11-05",
			8.6
		],
		[
			"2009-07-16",
			6.9
		],
		[
			"2009-03-04",
			4.5
		],
		[
			"2008-11-20",
			5.9
		],
		[
			"2008-07-24",
			5.6
		],
		[
			"2008-03-11",
			2.6
		],
		[
			"2000-09-19",
			9.4
		],
		[
			"2000-06-20",
			8.8
		],
		[
			"2000-02-08",
			7.7
		],
		[
			"2001-09-19",
			11
		],
		[
			"2001-06-19",
			11
		],
		[
			"2001-03-07",
			7.2
		],
		[
			"2002-08-28",
			9.1
		],
		[
			"2002-06-18",
			12
		],
		[
			"2002-02-12",
			8.2
		],
		[
			"2011-03-08",
			7.9
		],
		[
			"2011-07-05",
			8.3
		],
		[
			"2011-11-17",
			8.4
		],
		[
			"2012-03-08",
			8.2
		],
		[
			"2012-07-19",
			7.5
		],
		[
			"2012-11-15",
			8.4
		],
		[
			"2013-07-18",
			5.6
		],
		[
			"2013-03-05",
			8.5
		],
		[
			"2013-11-27",
			5.8
		],
		[
			"2014-07-03",
			8
		],
		[
			"2014-11-05",
			7.56
		],
		[
			"2015-06-18",
			9.18
		],
		[
			"2015-11-18",
			9.94
		]
	],
	"86532649": [
		[
			"2007-11-21",
			4.9
		],
		[
			"2007-07-16",
			6.4
		],
		[
			"2007-03-06",
			4.7
		],
		[
			"2006-11-14",
			5
		],
		[
			"2006-07-20",
			10.9
		],
		[
			"2006-03-07",
			7.3
		],
		[
			"2005-11-16",
			4.9
		],
		[
			"2005-07-07",
			6.6
		],
		[
			"2005-03-10",
			6.7
		],
		[
			"2004-11-16",
			6.9
		],
		[
			"2004-07-14",
			6.6
		],
		[
			"2004-03-02",
			5.1
		],
		[
			"2003-11-11",
			6.7
		],
		[
			"2003-07-08",
			6.7
		],
		[
			"2003-05-15",
			7
		],
		[
			"2003-02-25",
			7.7
		],
		[
			"2009-11-05",
			3.1
		],
		[
			"2009-07-16",
			3
		],
		[
			"2009-03-04",
			3.3
		],
		[
			"2008-11-17",
			4.4
		],
		[
			"2008-07-17",
			4
		],
		[
			"2008-03-11",
			4.9
		],
		[
			"2000-09-19",
			9.3
		],
		[
			"2000-06-20",
			9.2
		],
		[
			"2000-02-08",
			8.8
		],
		[
			"2001-09-19",
			9.2
		],
		[
			"2001-06-19",
			11
		],
		[
			"2001-02-28",
			9.3
		],
		[
			"2002-08-28",
			6.7
		],
		[
			"2002-06-18",
			8.6
		],
		[
			"2002-04-26",
			7.4
		],
		[
			"2002-02-12",
			9.3
		],
		[
			"2011-03-08",
			3.4
		],
		[
			"2011-07-26",
			3
		],
		[
			"2011-11-22",
			2.4
		],
		[
			"2012-03-08",
			2.1
		],
		[
			"2012-07-17",
			2.5
		],
		[
			"2012-11-13",
			2.5
		],
		[
			"2013-07-09",
			2.1
		],
		[
			"2013-03-06",
			2.4
		],
		[
			"2013-11-28",
			1.8
		],
		[
			"2014-07-03",
			3.4
		],
		[
			"2014-11-06",
			3.11
		],
		[
			"2015-06-23",
			2.94
		],
		[
			"2015-11-19",
			2.99
		]
	],
	"86541377": [
		[
			"2006-10-24",
			45.32
		],
		[
			"2006-04-11",
			44.32
		],
		[
			"2007-10-15",
			42.82
		],
		[
			"2007-04-03",
			45.82
		],
		[
			"2008-09-24",
			43.32
		],
		[
			"2008-03-11",
			43.82
		],
		[
			"2009-10-06",
			39.81
		],
		[
			"2009-03-10",
			40.91
		],
		[
			"2000-06-27",
			42.01
		],
		[
			"2000-05-18",
			43.02
		],
		[
			"2000-04-11",
			43.02
		],
		[
			"2000-03-20",
			41.01
		],
		[
			"2000-02-17",
			40.01
		],
		[
			"2000-01-19",
			42.01
		],
		[
			"2001-12-05",
			47.02
		],
		[
			"2001-11-26",
			47.02
		],
		[
			"2001-10-17",
			43.02
		],
		[
			"2001-09-24",
			43.02
		],
		[
			"2001-08-08",
			42.01
		],
		[
			"2001-07-10",
			43.02
		],
		[
			"2001-06-18",
			42.01
		],
		[
			"2001-05-14",
			44.02
		],
		[
			"2001-04-18",
			44.02
		],
		[
			"2001-03-12",
			43.02
		],
		[
			"2001-02-08",
			41.01
		],
		[
			"2001-01-17",
			42.01
		],
		[
			"2002-10-28",
			51.02
		],
		[
			"2002-07-16",
			50.02
		],
		[
			"2002-06-04",
			50.02
		],
		[
			"2002-02-25",
			49.02
		],
		[
			"2002-01-28",
			49.02
		],
		[
			"2003-06-03",
			50.62
		],
		[
			"2003-02-25",
			45.02
		],
		[
			"2004-11-11",
			49.92
		],
		[
			"2004-03-23",
			46.72
		],
		[
			"2004-02-03",
			47.22
		],
		[
			"2005-11-08",
			46.22
		],
		[
			"2005-04-19",
			50.22
		],
		[
			"2010-05-20",
			39.91
		],
		[
			"2011-11-29",
			39.31
		],
		[
			"2012-10-15",
			39.21
		],
		[
			"2012-03-28",
			39.11
		],
		[
			"2013-11-26",
			36.81
		],
		[
			"2013-03-13",
			37.11
		],
		[
			"2014-11-04",
			34.41
		],
		[
			"2014-03-13",
			33.11
		],
		[
			"2015-10-15",
			34.01
		],
		[
			"2015-03-26",
			34.31
		]
	],
	"86551863": [
		[
			"2007-09-25",
			66.22
		],
		[
			"2008-10-07",
			72.63
		],
		[
			"2007-03-07",
			35.91
		],
		[
			"2009-04-01",
			44.82
		],
		[
			"2009-10-15",
			85.33
		],
		[
			"2000-10-16",
			66.62
		],
		[
			"2000-06-26",
			68.02
		],
		[
			"2001-10-29",
			73.63
		],
		[
			"2001-06-18",
			65.32
		],
		[
			"2002-02-18",
			46.92
		],
		[
			"2006-03-14",
			51.02
		],
		[
			"2005-10-05",
			63.92
		],
		[
			"2005-03-01",
			41.61
		],
		[
			"2004-10-12",
			60.92
		],
		[
			"2004-03-16",
			61.62
		],
		[
			"2010-03-16",
			47.32
		],
		[
			"2010-11-03",
			78.03
		],
		[
			"2011-05-17",
			95.83
		],
		[
			"2011-06-06",
			94.73
		],
		[
			"2011-06-14",
			92.73
		],
		[
			"2011-06-20",
			85.33
		],
		[
			"2011-11-22",
			89.83
		],
		[
			"2012-05-31",
			75.73
		],
		[
			"2012-10-11",
			78.73
		],
		[
			"2013-05-07",
			57.02
		],
		[
			"2013-10-17",
			66.42
		],
		[
			"2014-06-05",
			59.42
		],
		[
			"2014-10-09",
			56.72
		],
		[
			"2015-05-07",
			57.32
		],
		[
			"2015-10-08",
			71.43
		]
	],
	"86568371": [
		[
			"2007-03-07",
			22.71
		],
		[
			"2007-09-25",
			25.81
		],
		[
			"2008-10-07",
			25.01
		],
		[
			"2009-03-03",
			23.01
		],
		[
			"2009-09-17",
			22.81
		],
		[
			"2002-07-08",
			27.01
		],
		[
			"2002-02-18",
			26.71
		],
		[
			"2010-04-13",
			22.51
		],
		[
			"2010-11-03",
			26.21
		],
		[
			"2011-04-13",
			27.31
		],
		[
			"2011-10-25",
			25.91
		],
		[
			"2012-05-24",
			24.91
		],
		[
			"2012-10-11",
			25.41
		],
		[
			"2013-11-07",
			23.61
		],
		[
			"2014-06-12",
			21.81
		],
		[
			"2013-05-23",
			24.21
		],
		[
			"2014-10-23",
			22.71
		],
		[
			"2015-05-21",
			22.71
		],
		[
			"2015-10-22",
			20.91
		]
	],
	"86573470": [
		[
			"2006-09-12",
			56.42
		],
		[
			"2006-05-10",
			54.82
		],
		[
			"2007-11-06",
			60.42
		],
		[
			"2007-03-29",
			60.62
		],
		[
			"2008-10-01",
			58.32
		],
		[
			"2008-03-06",
			59.52
		],
		[
			"2009-09-30",
			60.02
		],
		[
			"2009-03-05",
			59.22
		],
		[
			"2000-07-19",
			53.02
		],
		[
			"2000-06-26",
			51.02
		],
		[
			"2000-05-25",
			55.02
		],
		[
			"2000-04-13",
			53.02
		],
		[
			"2000-03-13",
			55.02
		],
		[
			"2000-02-16",
			54.02
		],
		[
			"2000-01-18",
			50.02
		],
		[
			"2001-12-04",
			53.02
		],
		[
			"2001-11-21",
			51.02
		],
		[
			"2001-10-15",
			51.02
		],
		[
			"2001-09-10",
			51.02
		],
		[
			"2001-08-20",
			51.02
		],
		[
			"2001-08-07",
			52.02
		],
		[
			"2001-07-03",
			53.02
		],
		[
			"2001-05-31",
			53.02
		],
		[
			"2001-04-19",
			53.02
		],
		[
			"2001-03-19",
			49.02
		],
		[
			"2001-02-07",
			51.02
		],
		[
			"2001-01-15",
			46.02
		],
		[
			"2002-09-09",
			52.02
		],
		[
			"2002-08-07",
			52.02
		],
		[
			"2002-06-03",
			54.02
		],
		[
			"2002-02-20",
			54.02
		],
		[
			"2003-07-02",
			52.22
		],
		[
			"2004-12-01",
			60.92
		],
		[
			"2004-02-18",
			51.72
		],
		[
			"2004-02-03",
			52.62
		],
		[
			"2005-11-15",
			54.82
		],
		[
			"2005-04-28",
			58.82
		],
		[
			"2010-10-14",
			61.42
		],
		[
			"2010-04-15",
			61.22
		],
		[
			"2011-11-30",
			61.22
		],
		[
			"2011-02-17",
			60.32
		],
		[
			"2012-10-15",
			59.92
		],
		[
			"2012-03-27",
			60.82
		],
		[
			"2013-11-14",
			56.22
		],
		[
			"2013-03-14",
			60.52
		],
		[
			"2014-11-13",
			55.02
		],
		[
			"2014-03-14",
			55.02
		],
		[
			"2015-10-20",
			55.72
		],
		[
			"2015-02-10",
			55.52
		]
	],
	"86573974": [
		[
			"2006-11-08",
			86.33
		],
		[
			"2006-06-08",
			87.73
		],
		[
			"2007-10-25",
			93.63
		],
		[
			"2007-03-15",
			93.83
		],
		[
			"2008-10-09",
			89.73
		],
		[
			"2008-02-28",
			88.73
		],
		[
			"2009-09-24",
			84.73
		],
		[
			"2009-03-12",
			85.03
		],
		[
			"2001-09-03",
			95.03
		],
		[
			"2001-03-07",
			100.04
		],
		[
			"2002-09-04",
			102.04
		],
		[
			"2002-03-18",
			103.04
		],
		[
			"2003-06-05",
			104.14
		],
		[
			"2004-10-28",
			98.23
		],
		[
			"2004-03-23",
			94.63
		],
		[
			"2005-11-16",
			93.03
		],
		[
			"2005-04-27",
			99.74
		],
		[
			"2010-10-07",
			79.33
		],
		[
			"2010-04-13",
			80.13
		],
		[
			"2011-10-13",
			77.93
		],
		[
			"2011-02-09",
			77.33
		],
		[
			"2012-10-30",
			76.23
		],
		[
			"2012-04-11",
			73.13
		],
		[
			"2013-11-28",
			58.62
		],
		[
			"2013-03-21",
			72.13
		],
		[
			"2014-12-04",
			64.92
		],
		[
			"2014-02-06",
			71.03
		],
		[
			"2015-10-20",
			67.82
		],
		[
			"2015-02-11",
			67.92
		]
	],
	"86573986": [
		[
			"2006-11-08",
			95.83
		],
		[
			"2006-06-08",
			92.13
		],
		[
			"2007-10-25",
			92.03
		],
		[
			"2007-03-15",
			98.33
		],
		[
			"2008-10-09",
			80.13
		],
		[
			"2008-02-28",
			88.73
		],
		[
			"2009-09-24",
			74.73
		],
		[
			"2009-03-12",
			79.23
		],
		[
			"2001-09-03",
			101.04
		],
		[
			"2001-03-07",
			46.02
		],
		[
			"2002-09-04",
			109.04
		],
		[
			"2002-03-18",
			111.04
		],
		[
			"2003-06-05",
			111.94
		],
		[
			"2004-10-28",
			110.94
		],
		[
			"2004-03-23",
			103.44
		],
		[
			"2005-11-16",
			95.73
		],
		[
			"2005-04-27",
			104.94
		],
		[
			"2010-10-07",
			69.42
		],
		[
			"2010-04-13",
			72.23
		],
		[
			"2011-10-13",
			69.42
		],
		[
			"2011-02-09",
			71.43
		],
		[
			"2012-04-11",
			65.62
		],
		[
			"2013-11-28",
			53.52
		],
		[
			"2013-03-26",
			66.62
		],
		[
			"2014-12-04",
			56.02
		],
		[
			"2014-02-06",
			65.02
		],
		[
			"2015-10-21",
			61.92
		],
		[
			"2015-02-11",
			60.52
		]
	],
	"86591459": [
		[
			"2009-03-25",
			15.31
		],
		[
			"2008-12-15",
			1
		],
		[
			"2008-04-09",
			20.51
		],
		[
			"2007-08-22",
			13.8
		],
		[
			"2007-03-28",
			9
		],
		[
			"2006-09-06",
			12.1
		],
		[
			"2006-04-25",
			10.9
		],
		[
			"2005-08-31",
			9
		],
		[
			"2005-04-20",
			9
		],
		[
			"2004-04-06",
			8
		],
		[
			"2003-08-14",
			8.9
		],
		[
			"2003-04-29",
			7
		],
		[
			"2002-11-11",
			10.6
		],
		[
			"2002-04-23",
			8.2
		],
		[
			"2001-11-13",
			7
		],
		[
			"2001-04-25",
			5
		],
		[
			"2000-10-18",
			9
		],
		[
			"2000-05-09",
			9
		],
		[
			"2010-10-06",
			20.01
		],
		[
			"2011-04-04",
			17.01
		],
		[
			"2009-10-01",
			22.11
		],
		[
			"2013-10-14",
			25.11
		],
		[
			"2013-04-04",
			22.71
		],
		[
			"2012-10-22",
			9.4
		],
		[
			"2012-04-25",
			18.51
		],
		[
			"2011-10-05",
			24.41
		],
		[
			"2014-05-27",
			21.21
		],
		[
			"2015-11-16",
			28.21
		],
		[
			"2015-04-28",
			26.01
		],
		[
			"2014-11-12",
			24.11
		]
	],
	"86592786": [
		[
			"2007-11-27",
			116.04
		],
		[
			"2008-11-04",
			105.04
		],
		[
			"2008-03-18",
			112.04
		],
		[
			"2007-07-09",
			105.04
		],
		[
			"2007-04-17",
			110.04
		],
		[
			"2009-04-21",
			106.04
		],
		[
			"2009-11-17",
			113.04
		],
		[
			"2010-04-28",
			116.04
		],
		[
			"2000-11-15",
			149.05
		],
		[
			"2000-08-30",
			145.05
		],
		[
			"2000-04-05",
			137.05
		],
		[
			"2001-11-14",
			106.04
		],
		[
			"2001-08-22",
			123.04
		],
		[
			"2001-04-25",
			151.05
		],
		[
			"2002-11-20",
			94.23
		],
		[
			"2002-08-21",
			97.03
		],
		[
			"2002-05-15",
			100.04
		],
		[
			"2003-11-26",
			111.04
		],
		[
			"2003-08-27",
			97.13
		],
		[
			"2003-05-21",
			103.04
		],
		[
			"2004-12-01",
			117.04
		],
		[
			"2004-07-21",
			130.05
		],
		[
			"2004-03-15",
			134.05
		],
		[
			"2006-11-21",
			111.04
		],
		[
			"2006-07-25",
			121.04
		],
		[
			"2010-10-13",
			119.04
		],
		[
			"2011-04-13",
			123.04
		],
		[
			"2011-10-18",
			123.04
		],
		[
			"2012-03-27",
			127.05
		],
		[
			"2012-10-10",
			124.04
		],
		[
			"2013-11-12",
			124.04
		],
		[
			"2013-05-07",
			143.05
		],
		[
			"2014-11-26",
			119.34
		],
		[
			"2014-08-06",
			111.44
		],
		[
			"2014-05-19",
			122.84
		],
		[
			"2014-02-17",
			119.14
		],
		[
			"2015-05-21",
			121.24
		],
		[
			"2015-11-04",
			117.34
		],
		[
			"2015-02-05",
			121.74
		]
	],
	"86594606": [
		[
			"2007-11-26",
			57.62
		],
		[
			"2008-11-03",
			58.42
		],
		[
			"2008-03-17",
			60.52
		],
		[
			"2007-07-10",
			60.42
		],
		[
			"2007-04-16",
			62.42
		],
		[
			"2009-04-20",
			49.92
		],
		[
			"2009-11-16",
			53.52
		],
		[
			"2010-04-26",
			50.02
		],
		[
			"2000-11-14",
			73.03
		],
		[
			"2000-08-29",
			76.03
		],
		[
			"2000-04-04",
			64.02
		],
		[
			"2001-11-13",
			68.02
		],
		[
			"2001-08-21",
			63.02
		],
		[
			"2001-04-24",
			58.02
		],
		[
			"2002-11-19",
			71.33
		],
		[
			"2002-08-20",
			72.03
		],
		[
			"2002-05-14",
			67.02
		],
		[
			"2003-11-25",
			73.03
		],
		[
			"2003-08-26",
			69.12
		],
		[
			"2003-05-20",
			66.92
		],
		[
			"2004-11-30",
			65.92
		],
		[
			"2004-07-20",
			68.52
		],
		[
			"2004-03-16",
			73.63
		],
		[
			"2006-11-20",
			56.82
		],
		[
			"2006-07-26",
			62.12
		],
		[
			"2010-10-12",
			54.62
		],
		[
			"2011-04-11",
			55.02
		],
		[
			"2011-10-17",
			49.42
		],
		[
			"2012-03-26",
			58.52
		],
		[
			"2012-10-09",
			50.62
		],
		[
			"2013-11-11",
			49.92
		],
		[
			"2013-05-06",
			56.12
		],
		[
			"2014-11-24",
			54.12
		],
		[
			"2014-08-04",
			50.52
		],
		[
			"2014-05-12",
			51.32
		],
		[
			"2014-02-10",
			53.72
		],
		[
			"2015-05-18",
			45.92
		],
		[
			"2015-11-09",
			49.52
		],
		[
			"2015-02-02",
			54.42
		]
	],
	"86600485": [
		[
			"2014-11-20",
			0.13
		],
		[
			"2015-11-23",
			0.05
		],
		[
			"2012-06-18",
			0.05
		],
		[
			"2006-06-06",
			0.11
		],
		[
			"2009-03-18",
			0.15
		],
		[
			"2000-03-09",
			0.05
		],
		[
			"2000-08-21",
			0.05
		],
		[
			"2003-08-13",
			0.05
		]
	],
	"86600643": [
		[
			"2014-11-20",
			16.52
		],
		[
			"2015-11-30",
			15.71
		],
		[
			"2012-06-18",
			12.4
		],
		[
			"2006-06-02",
			22.91
		],
		[
			"2009-03-18",
			21.31
		],
		[
			"2000-03-10",
			38.01
		],
		[
			"2000-08-22",
			32.01
		],
		[
			"2003-08-13",
			27.61
		]
	],
	"86612025": [
		[
			"2007-11-13",
			1
		],
		[
			"2007-07-02",
			5.5
		],
		[
			"2007-02-28",
			1
		],
		[
			"2008-03-06",
			4.4
		],
		[
			"2008-11-17",
			1
		],
		[
			"2008-07-07",
			6.9
		],
		[
			"2009-03-02",
			6
		],
		[
			"2009-07-06",
			8.2
		],
		[
			"2009-11-24",
			4.9
		],
		[
			"2010-03-29",
			4.3
		],
		[
			"2010-02-02",
			1.1
		],
		[
			"2000-10-17",
			13
		],
		[
			"2000-06-27",
			15.01
		],
		[
			"2000-02-14",
			16.01
		],
		[
			"2001-11-21",
			1
		],
		[
			"2001-07-25",
			9.2
		],
		[
			"2001-03-12",
			15.01
		],
		[
			"2002-11-25",
			1
		],
		[
			"2002-07-09",
			6
		],
		[
			"2003-11-24",
			4.5
		],
		[
			"2003-07-16",
			1.7
		],
		[
			"2003-03-11",
			3.1
		],
		[
			"2004-11-17",
			3.1
		],
		[
			"2004-07-26",
			8.3
		],
		[
			"2004-03-17",
			11.7
		],
		[
			"2005-12-13",
			2.1
		],
		[
			"2005-11-28",
			5.1
		],
		[
			"2005-07-12",
			2.9
		],
		[
			"2005-03-03",
			5.3
		],
		[
			"2006-11-16",
			1.2
		],
		[
			"2006-07-11",
			8.1
		],
		[
			"2006-03-02",
			3.5
		],
		[
			"2010-07-12",
			4.2
		],
		[
			"2010-10-25",
			2.9
		],
		[
			"2011-03-03",
			4.3
		],
		[
			"2011-07-25",
			5.9
		],
		[
			"2011-10-24",
			4.1
		],
		[
			"2012-03-05",
			2.9
		],
		[
			"2012-07-02",
			3.6
		],
		[
			"2013-09-25",
			2.6
		],
		[
			"2013-07-02",
			3.9
		],
		[
			"2013-03-04",
			5.6
		],
		[
			"2012-10-17",
			3.4
		],
		[
			"2014-09-23",
			6.18
		],
		[
			"2014-07-07",
			5.1
		],
		[
			"2014-03-10",
			8.2
		],
		[
			"2015-03-09",
			7.42
		],
		[
			"2015-10-13",
			5.08
		],
		[
			"2015-07-08",
			4.18
		]
	],
	"86621555": [
		[
			"2009-02-17",
			48.82
		],
		[
			"2008-09-03",
			51.72
		],
		[
			"2008-06-23",
			55.82
		],
		[
			"2008-02-25",
			54.62
		],
		[
			"2007-09-19",
			55.52
		],
		[
			"2007-06-26",
			57.02
		],
		[
			"2007-03-05",
			53.72
		],
		[
			"2006-09-19",
			56.62
		],
		[
			"2006-06-21",
			52.62
		],
		[
			"2006-02-20",
			51.72
		],
		[
			"2005-09-19",
			56.82
		],
		[
			"2005-06-27",
			62.92
		],
		[
			"2005-03-08",
			61.92
		],
		[
			"2004-09-08",
			56.92
		],
		[
			"2004-05-05",
			53.22
		],
		[
			"2004-03-22",
			55.12
		],
		[
			"2009-06-25",
			51.62
		],
		[
			"2009-09-23",
			50.32
		],
		[
			"2010-03-16",
			51.72
		],
		[
			"2000-10-04",
			68.02
		],
		[
			"2000-05-29",
			65.02
		],
		[
			"2000-02-01",
			69.02
		],
		[
			"2001-10-09",
			58.02
		],
		[
			"2001-06-11",
			65.02
		],
		[
			"2001-02-06",
			63.02
		],
		[
			"2002-06-12",
			59.02
		],
		[
			"2002-02-05",
			55.02
		],
		[
			"2003-09-29",
			54.52
		],
		[
			"2003-06-04",
			53.42
		],
		[
			"2003-02-26",
			58.02
		],
		[
			"2010-09-21",
			55.82
		],
		[
			"2010-06-28",
			53.12
		],
		[
			"2011-02-09",
			54.32
		],
		[
			"2011-06-28",
			53.52
		],
		[
			"2011-10-06",
			51.82
		],
		[
			"2012-02-27",
			53.62
		],
		[
			"2012-06-25",
			52.12
		],
		[
			"2012-11-07",
			49.82
		],
		[
			"2013-09-24",
			50.02
		],
		[
			"2013-06-10",
			47.92
		],
		[
			"2013-03-05",
			52.32
		],
		[
			"2014-06-23",
			53.92
		],
		[
			"2014-02-24",
			46.72
		],
		[
			"2014-09-16",
			51.42
		],
		[
			"2015-06-08",
			48.32
		],
		[
			"2015-03-03",
			50.32
		],
		[
			"2015-09-28",
			52.52
		]
	],
	"86621567": [
		[
			"2009-02-20",
			61.62
		],
		[
			"2008-09-03",
			53.42
		],
		[
			"2008-06-05",
			59.92
		],
		[
			"2008-02-25",
			52.92
		],
		[
			"2007-09-19",
			60.52
		],
		[
			"2007-06-26",
			61.22
		],
		[
			"2007-03-05",
			53.12
		],
		[
			"2006-09-19",
			58.62
		],
		[
			"2006-06-21",
			52.02
		],
		[
			"2006-02-20",
			55.82
		],
		[
			"2005-09-19",
			59.42
		],
		[
			"2005-07-06",
			50.92
		],
		[
			"2005-03-08",
			52.12
		],
		[
			"2004-09-08",
			56.02
		],
		[
			"2004-05-05",
			55.72
		],
		[
			"2004-02-18",
			61.02
		],
		[
			"2009-06-25",
			60.72
		],
		[
			"2009-09-23",
			54.12
		],
		[
			"2010-03-02",
			67.12
		],
		[
			"2000-11-22",
			45.02
		],
		[
			"2000-11-14",
			53.02
		],
		[
			"2000-10-04",
			55.02
		],
		[
			"2000-05-29",
			45.02
		],
		[
			"2000-02-01",
			46.02
		],
		[
			"2001-10-09",
			49.02
		],
		[
			"2001-06-11",
			46.02
		],
		[
			"2001-02-06",
			48.02
		],
		[
			"2002-06-12",
			53.02
		],
		[
			"2002-02-05",
			53.02
		],
		[
			"2003-09-29",
			54.82
		],
		[
			"2003-06-04",
			55.82
		],
		[
			"2003-02-26",
			52.72
		],
		[
			"2010-09-21",
			66.12
		],
		[
			"2010-07-06",
			65.72
		],
		[
			"2011-02-09",
			65.22
		],
		[
			"2011-06-28",
			65.12
		],
		[
			"2011-10-06",
			64.92
		],
		[
			"2012-02-27",
			65.32
		],
		[
			"2012-06-25",
			65.52
		],
		[
			"2012-11-07",
			64.52
		],
		[
			"2013-09-24",
			64.02
		],
		[
			"2013-06-10",
			63.82
		],
		[
			"2013-02-25",
			62.72
		],
		[
			"2014-06-23",
			62.52
		],
		[
			"2014-02-24",
			61.72
		],
		[
			"2014-09-16",
			60.92
		],
		[
			"2015-06-08",
			58.42
		],
		[
			"2015-02-23",
			57.72
		],
		[
			"2015-09-28",
			59.62
		]
	],
	"86625081": [
		[
			"2008-04-29",
			12
		],
		[
			"2007-04-24",
			15.51
		],
		[
			"2008-10-14",
			13.6
		],
		[
			"2009-04-21",
			14.11
		],
		[
			"2009-10-27",
			13.4
		],
		[
			"2010-04-28",
			13.2
		],
		[
			"2002-05-06",
			18.41
		],
		[
			"2002-10-23",
			17.91
		],
		[
			"2004-04-20",
			14.41
		],
		[
			"2004-10-27",
			11
		],
		[
			"2005-04-19",
			5.2
		],
		[
			"2005-06-17",
			14.71
		],
		[
			"2005-10-18",
			14.91
		],
		[
			"2006-04-24",
			15.51
		],
		[
			"2006-10-17",
			13.7
		],
		[
			"2007-10-15",
			5.2
		],
		[
			"2010-11-24",
			10.8
		],
		[
			"2011-04-27",
			12.1
		],
		[
			"2011-10-17",
			10.3
		],
		[
			"2012-04-23",
			8.4
		],
		[
			"2012-10-22",
			9.6
		],
		[
			"2013-04-23",
			9.5
		],
		[
			"2013-10-22",
			8.8
		],
		[
			"2014-04-28",
			9.4
		],
		[
			"2014-10-21",
			9.2
		],
		[
			"2015-04-27",
			9.1
		],
		[
			"2015-10-20",
			10.3
		]
	],
	"86625123": [
		[
			"2008-04-29",
			11.7
		],
		[
			"2007-04-24",
			14
		],
		[
			"2008-10-14",
			14.91
		],
		[
			"2009-04-21",
			13.8
		],
		[
			"2009-10-27",
			14.31
		],
		[
			"2010-04-28",
			14.51
		],
		[
			"2002-06-04",
			7.9
		],
		[
			"2004-04-20",
			11.3
		],
		[
			"2004-01-15",
			13.1
		],
		[
			"2004-07-14",
			15.81
		],
		[
			"2004-10-27",
			17.01
		],
		[
			"2005-01-10",
			15.31
		],
		[
			"2005-04-19",
			16.11
		],
		[
			"2005-10-18",
			13.5
		],
		[
			"2006-04-24",
			10.4
		],
		[
			"2006-10-17",
			11.8
		],
		[
			"2007-10-15",
			10.7
		],
		[
			"2010-11-24",
			15.01
		],
		[
			"2011-04-27",
			14
		],
		[
			"2011-10-17",
			15.01
		],
		[
			"2012-04-23",
			13.8
		],
		[
			"2012-10-22",
			10.4
		],
		[
			"2013-06-17",
			11.2
		],
		[
			"2013-10-22",
			9.4
		],
		[
			"2014-04-28",
			8.6
		],
		[
			"2003-06-05",
			15.31
		],
		[
			"2003-11-04",
			11.6
		],
		[
			"2014-10-21",
			17.21
		],
		[
			"2015-04-27",
			12.3
		],
		[
			"2015-10-20",
			10.9
		]
	],
	"91112000": [
		[
			"2015-06-24",
			1.33
		],
		[
			"2006-03-16",
			0.66
		],
		[
			"2006-08-30",
			0.66
		],
		[
			"2007-02-28",
			0.66
		],
		[
			"2008-02-11",
			0.66
		],
		[
			"2009-04-23",
			0.66
		],
		[
			"2010-05-17",
			0.66
		],
		[
			"2011-11-29",
			0.66
		]
	],
	"91120100": [
		[
			"2014-12-16",
			1.33
		],
		[
			"2015-06-24",
			1.33
		],
		[
			"2007-02-20",
			0.66
		],
		[
			"2008-02-11",
			0.66
		],
		[
			"2009-03-23",
			0.66
		],
		[
			"2010-05-17",
			0.66
		],
		[
			"2011-11-29",
			0.66
		]
	],
	"91120202": [
		[
			"2013-11-12",
			1.33
		],
		[
			"2014-12-16",
			32.02
		],
		[
			"2015-06-17",
			1.33
		],
		[
			"2006-02-16",
			0.66
		],
		[
			"2006-10-25",
			0.66
		],
		[
			"2007-02-21",
			0.66
		],
		[
			"2008-02-06",
			0.66
		],
		[
			"2009-03-23",
			0.66
		],
		[
			"2010-08-04",
			0.66
		],
		[
			"2011-05-02",
			0.66
		]
	],
	"91130608": [
		[
			"2013-12-10",
			1.33
		],
		[
			"2014-12-09",
			1.33
		],
		[
			"2015-06-17",
			1.33
		],
		[
			"2000-11-28",
			2.21
		],
		[
			"2001-09-05",
			0.44
		],
		[
			"2002-11-18",
			1.33
		],
		[
			"2004-01-07",
			0.44
		],
		[
			"2005-02-15",
			0.89
		],
		[
			"2005-12-06",
			0.66
		],
		[
			"2006-02-15",
			0.66
		],
		[
			"2006-11-29",
			0.66
		],
		[
			"2007-02-21",
			0.66
		],
		[
			"2008-02-06",
			0.66
		],
		[
			"2009-04-22",
			0.66
		],
		[
			"2010-04-15",
			0.66
		],
		[
			"2011-03-22",
			0.66
		]
	],
	"91130700": [
		[
			"2013-11-07",
			6.78
		],
		[
			"2014-04-01",
			1.59
		],
		[
			"2015-06-17",
			1.33
		],
		[
			"2000-12-11",
			13.73
		],
		[
			"2001-09-05",
			10.19
		],
		[
			"2002-11-18",
			6.2
		],
		[
			"2004-01-07",
			6.64
		],
		[
			"2005-02-15",
			0.89
		],
		[
			"2006-03-20",
			3.32
		],
		[
			"2006-11-23",
			4.21
		],
		[
			"2007-03-01",
			1.51
		],
		[
			"2008-02-12",
			0.66
		],
		[
			"2009-03-25",
			4.43
		],
		[
			"2005-12-07",
			5.05
		],
		[
			"2010-08-04",
			0.66
		],
		[
			"2011-03-24",
			0.66
		]
	],
	"91130803": [
		[
			"2013-11-04",
			1.33
		],
		[
			"2014-12-02",
			1.33
		],
		[
			"2015-06-23",
			2.44
		],
		[
			"2006-03-15",
			0.8
		],
		[
			"2006-08-23",
			0.84
		],
		[
			"2007-03-01",
			0.8
		],
		[
			"2008-02-11",
			0.97
		],
		[
			"2009-04-20",
			1.99
		],
		[
			"2010-04-15",
			1.02
		],
		[
			"2011-03-22",
			1.33
		]
	],
	"91130906": [
		[
			"2013-11-07",
			14.92
		],
		[
			"2014-12-02",
			10.05
		],
		[
			"2015-06-23",
			12.58
		],
		[
			"2000-11-29",
			25.24
		],
		[
			"2001-09-05",
			23.03
		],
		[
			"2002-11-18",
			22.14
		],
		[
			"2004-01-07",
			17.71
		],
		[
			"2005-02-15",
			18.16
		],
		[
			"2005-12-07",
			17.76
		],
		[
			"2006-10-17",
			17.36
		],
		[
			"2007-03-05",
			16.34
		],
		[
			"2008-02-07",
			14.84
		],
		[
			"2009-04-20",
			16.03
		],
		[
			"2010-04-15",
			18.38
		],
		[
			"2011-03-28",
			16.43
		]
	],
	"91131005": [
		[
			"2013-11-07",
			1.33
		],
		[
			"2014-12-01",
			4.43
		],
		[
			"2015-06-23",
			3.19
		],
		[
			"2006-03-23",
			7.53
		],
		[
			"2006-08-23",
			4.65
		],
		[
			"2007-03-05",
			7.71
		],
		[
			"2007-10-18",
			0.66
		],
		[
			"2008-02-12",
			7.4
		],
		[
			"2009-03-24",
			5.49
		],
		[
			"2010-05-05",
			4.38
		],
		[
			"2011-03-24",
			4.56
		]
	],
	"91131406": [
		[
			"2014-12-02",
			1.33
		],
		[
			"2015-10-12",
			1.33
		],
		[
			"2000-11-29",
			0.44
		],
		[
			"2001-09-25",
			0.44
		],
		[
			"2002-11-21",
			0.44
		],
		[
			"2004-01-08",
			0.44
		],
		[
			"2005-03-15",
			0.44
		],
		[
			"2005-12-07",
			0.66
		],
		[
			"2006-02-15",
			0.66
		],
		[
			"2007-02-21",
			0.66
		],
		[
			"2008-02-07",
			0.66
		],
		[
			"2006-11-29",
			0.66
		],
		[
			"2010-07-12",
			0.66
		],
		[
			"2011-03-28",
			0.66
		]
	],
	"91132204": [
		[
			"2013-11-07",
			1.33
		],
		[
			"2014-12-01",
			1.33
		],
		[
			"2015-10-12",
			1.33
		],
		[
			"2006-02-20",
			0.66
		],
		[
			"2006-08-31",
			0.66
		],
		[
			"2008-02-14",
			0.66
		],
		[
			"2010-08-03",
			0.66
		],
		[
			"2011-03-28",
			0.66
		]
	],
	"91133002": [
		[
			"2014-11-03",
			1.33
		],
		[
			"2015-12-03",
			1.33
		],
		[
			"2006-03-15",
			0.66
		],
		[
			"2006-09-06",
			0.66
		],
		[
			"2007-03-06",
			0.66
		],
		[
			"2008-02-14",
			0.66
		],
		[
			"2010-08-31",
			0.66
		],
		[
			"2011-07-25",
			0.66
		]
	],
	"91133300": [
		[
			"2014-11-03",
			1.33
		],
		[
			"2015-10-14",
			1.33
		],
		[
			"2006-10-25",
			0.66
		],
		[
			"2007-03-06",
			0.66
		],
		[
			"2007-07-04",
			0.07
		],
		[
			"2008-02-13",
			0.66
		],
		[
			"2009-03-25",
			0.66
		],
		[
			"2010-08-03",
			0.66
		],
		[
			"2011-07-25",
			0.66
		]
	],
	"91133609": [
		[
			"2013-11-04",
			46.94
		],
		[
			"2014-11-03",
			35.34
		],
		[
			"2015-10-26",
			38.44
		],
		[
			"2000-10-26",
			60.23
		],
		[
			"2001-09-25",
			49.6
		],
		[
			"2002-11-21",
			54.03
		],
		[
			"2004-01-06",
			35.43
		],
		[
			"2005-03-15",
			47.83
		],
		[
			"2005-11-28",
			30.91
		],
		[
			"2006-10-10",
			17.45
		],
		[
			"2007-02-27",
			21.48
		],
		[
			"2008-02-18",
			36.58
		],
		[
			"2009-04-22",
			20.02
		],
		[
			"2010-04-28",
			41.41
		],
		[
			"2011-08-10",
			41.54
		]
	],
	"91135000": [
		[
			"2013-12-17",
			34.32
		],
		[
			"2014-08-11",
			27.46
		],
		[
			"2015-11-09",
			27.9
		],
		[
			"2000-09-13",
			38.53
		],
		[
			"2001-12-19",
			33.21
		],
		[
			"2003-03-27",
			32.33
		],
		[
			"2003-12-02",
			39.86
		],
		[
			"2004-10-27",
			39.41
		],
		[
			"2005-10-25",
			37.29
		],
		[
			"2006-05-16",
			32.59
		],
		[
			"2007-05-15",
			41.1
		],
		[
			"2008-04-17",
			31.27
		],
		[
			"2006-12-20",
			35.83
		],
		[
			"2009-07-02",
			33.75
		],
		[
			"2010-07-26",
			33.39
		],
		[
			"2011-04-06",
			30.38
		]
	],
	"91135102": [
		[
			"2015-10-19",
			24.45
		],
		[
			"2006-05-16",
			23.34
		],
		[
			"2007-05-15",
			24.27
		],
		[
			"2008-04-17",
			26.04
		],
		[
			"2008-11-17",
			26.26
		],
		[
			"2009-07-02",
			23.29
		],
		[
			"2010-09-16",
			23.12
		],
		[
			"2011-04-06",
			23.69
		]
	],
	"91140900": [
		[
			"2013-11-04",
			1.33
		],
		[
			"2014-10-30",
			1.33
		],
		[
			"2015-09-03",
			1.33
		],
		[
			"2006-02-21",
			0.66
		],
		[
			"2006-08-31",
			0.66
		],
		[
			"2007-02-26",
			0.66
		],
		[
			"2008-02-18",
			0.66
		],
		[
			"2009-03-03",
			0.66
		],
		[
			"2010-08-02",
			0.66
		],
		[
			"2011-05-25",
			0.66
		]
	],
	"91141102": [
		[
			"2013-11-07",
			11.03
		],
		[
			"2015-09-03",
			84.14
		],
		[
			"2000-11-29",
			0.44
		],
		[
			"2001-09-06",
			0.89
		],
		[
			"2002-11-21",
			49.6
		],
		[
			"2004-02-10",
			47.83
		],
		[
			"2006-03-15",
			7.97
		],
		[
			"2006-11-23",
			8.1
		],
		[
			"2007-02-26",
			5.54
		],
		[
			"2008-02-14",
			106.73
		],
		[
			"2009-03-02",
			20.68
		],
		[
			"2010-08-02",
			89.9
		],
		[
			"2010-10-05",
			69.09
		],
		[
			"2011-05-25",
			73.07
		]
	],
	"91143100": [
		[
			"2013-09-26",
			26.35
		],
		[
			"2014-11-11",
			23.96
		],
		[
			"2015-11-09",
			24.4
		],
		[
			"2000-09-13",
			34.99
		],
		[
			"2001-12-19",
			31.44
		],
		[
			"2003-12-02",
			27.46
		],
		[
			"2004-10-28",
			26.57
		],
		[
			"2005-11-02",
			23.43
		],
		[
			"2006-05-16",
			23.29
		],
		[
			"2007-05-15",
			24.76
		],
		[
			"2008-04-17",
			26.57
		],
		[
			"2006-12-20",
			23.12
		],
		[
			"2009-07-02",
			27.5
		],
		[
			"2009-10-22",
			27.63
		],
		[
			"2010-07-26",
			28.39
		],
		[
			"2011-04-12",
			26.88
		]
	],
	"91161150": [
		[
			"2013-10-28",
			52.26
		],
		[
			"2014-07-09",
			51.37
		],
		[
			"2015-06-15",
			58.46
		],
		[
			"2006-03-29",
			72.19
		],
		[
			"2006-09-07",
			64.66
		],
		[
			"2007-03-13",
			84.59
		],
		[
			"2008-02-28",
			78.39
		],
		[
			"2009-03-26",
			77.94
		],
		[
			"2010-06-28",
			64.66
		],
		[
			"2011-04-28",
			62
		]
	],
	"91161253": [
		[
			"2013-10-28",
			63.33
		],
		[
			"2015-10-20",
			69.97
		],
		[
			"2006-03-29",
			53.59
		],
		[
			"2006-09-07",
			60.23
		],
		[
			"2008-03-03",
			65.54
		],
		[
			"2008-10-22",
			59.34
		],
		[
			"2009-03-26",
			52.26
		],
		[
			"2011-04-28",
			73.96
		]
	],
	"91161356": [
		[
			"2014-07-16",
			24.93
		],
		[
			"2014-08-11",
			24.62
		],
		[
			"2015-05-28",
			26.53
		],
		[
			"2006-03-29",
			25.38
		],
		[
			"2006-09-07",
			25.6
		],
		[
			"2008-03-03",
			32.06
		],
		[
			"2008-10-22",
			26.26
		],
		[
			"2009-03-26",
			24.58
		],
		[
			"2010-06-28",
			26.39
		],
		[
			"2011-04-27",
			26.93
		]
	],
	"91162002": [
		[
			"2013-12-10",
			1.33
		],
		[
			"2014-10-28",
			1.33
		],
		[
			"2015-05-28",
			1.33
		],
		[
			"2015-10-21",
			1.33
		],
		[
			"2000-11-22",
			0.44
		],
		[
			"2001-08-29",
			0.44
		],
		[
			"2002-12-03",
			0.44
		],
		[
			"2004-01-21",
			0.44
		],
		[
			"2005-03-16",
			0.44
		],
		[
			"2006-05-17",
			0.66
		],
		[
			"2006-10-24",
			0.66
		],
		[
			"2007-03-06",
			0.66
		],
		[
			"2008-02-21",
			0.66
		],
		[
			"2009-03-10",
			0.66
		],
		[
			"2005-12-20",
			0.66
		],
		[
			"2010-07-20",
			0.66
		],
		[
			"2010-11-08",
			0.66
		],
		[
			"2011-05-03",
			0.66
		]
	],
	"91163705": [
		[
			"2015-06-15",
			42.74
		],
		[
			"2006-03-30",
			43.22
		],
		[
			"2006-09-11",
			38.31
		],
		[
			"2007-06-27",
			48.27
		],
		[
			"2008-02-28",
			31.75
		],
		[
			"2009-05-25",
			27.46
		],
		[
			"2010-08-30",
			34.23
		],
		[
			"2011-04-27",
			32.2
		]
	],
	"91164916": [
		[
			"2013-07-01",
			1.33
		],
		[
			"2014-10-28",
			1.33
		],
		[
			"2015-06-22",
			1.33
		],
		[
			"2000-10-04",
			0.44
		],
		[
			"2000-11-16",
			0.44
		],
		[
			"2000-12-07",
			0.89
		],
		[
			"2001-10-17",
			0.44
		],
		[
			"2002-06-26",
			0.44
		],
		[
			"2002-12-04",
			0.89
		],
		[
			"2004-01-15",
			1.33
		],
		[
			"2004-09-27",
			0.44
		],
		[
			"2005-02-21",
			0.44
		],
		[
			"2005-06-14",
			0.44
		],
		[
			"2005-12-14",
			0.66
		],
		[
			"2006-05-17",
			0.66
		],
		[
			"2007-03-08",
			0.66
		],
		[
			"2008-02-25",
			0.66
		],
		[
			"2009-03-10",
			0.66
		],
		[
			"2010-07-20",
			21.57
		],
		[
			"2011-08-03",
			0.66
		]
	],
	"91165908": [
		[
			"2013-10-28",
			1.33
		],
		[
			"2014-10-28",
			1.33
		],
		[
			"2015-10-20",
			3.14
		],
		[
			"2000-10-04",
			6.64
		],
		[
			"2000-11-16",
			4.87
		],
		[
			"2001-09-03",
			1.33
		],
		[
			"2002-12-04",
			2.66
		],
		[
			"2004-01-15",
			8.86
		],
		[
			"2005-02-21",
			4.43
		],
		[
			"2005-12-14",
			1.73
		],
		[
			"2006-05-22",
			4.74
		],
		[
			"2006-10-24",
			3.94
		],
		[
			"2007-03-08",
			2.7
		],
		[
			"2008-02-27",
			1.28
		],
		[
			"2009-07-28",
			0.66
		],
		[
			"2010-09-13",
			2.66
		],
		[
			"2011-05-24",
			0.66
		]
	],
	"91166603": [
		[
			"2013-10-28",
			90.34
		],
		[
			"2014-11-13",
			85.03
		],
		[
			"2015-06-22",
			96.1
		],
		[
			"2000-11-20",
			77.06
		],
		[
			"2002-12-02",
			74.84
		],
		[
			"2004-01-19",
			69.09
		],
		[
			"2005-03-14",
			86.8
		],
		[
			"2006-04-03",
			95.21
		],
		[
			"2007-03-12",
			97.87
		],
		[
			"2008-03-04",
			94.77
		],
		[
			"2006-11-28",
			81.49
		],
		[
			"2009-07-15",
			84.14
		],
		[
			"2005-12-15",
			78.39
		],
		[
			"2010-07-08",
			98.31
		],
		[
			"2011-05-24",
			75.29
		]
	],
	"91167309": [
		[
			"2015-10-21",
			10.81
		],
		[
			"2000-10-11",
			7.97
		],
		[
			"2003-03-17",
			8.41
		],
		[
			"2004-11-02",
			17.27
		],
		[
			"2005-11-21",
			18.42
		],
		[
			"2006-05-22",
			15.46
		],
		[
			"2008-04-22",
			9.65
		],
		[
			"2008-11-13",
			10.36
		],
		[
			"2009-07-09",
			9.92
		],
		[
			"2010-06-30",
			14.75
		],
		[
			"2011-04-13",
			17.4
		]
	],
	"91167504": [
		[
			"2015-09-29",
			17.4
		],
		[
			"2003-05-07",
			14.61
		],
		[
			"2003-12-08",
			13.73
		],
		[
			"2004-11-11",
			13.29
		],
		[
			"2006-01-11",
			16.3
		],
		[
			"2006-05-22",
			20.73
		],
		[
			"2007-05-09",
			23.47
		],
		[
			"2008-08-27",
			16.3
		],
		[
			"2008-12-15",
			22.14
		],
		[
			"2009-07-09",
			14.35
		],
		[
			"2010-06-30",
			11.69
		],
		[
			"2011-04-13",
			19.13
		]
	],
	"91174909": [
		[
			"2015-12-01",
			30.29
		],
		[
			"2000-09-21",
			28.34
		],
		[
			"2001-12-11",
			30.11
		],
		[
			"2003-03-18",
			28.79
		],
		[
			"2003-12-08",
			24.36
		],
		[
			"2004-10-21",
			28.34
		],
		[
			"2005-10-19",
			26.57
		],
		[
			"2006-05-30",
			27.94
		],
		[
			"2006-11-16",
			25.91
		],
		[
			"2007-05-22",
			29.54
		],
		[
			"2009-07-08",
			25.55
		],
		[
			"2008-04-16",
			28.61
		],
		[
			"2010-07-06",
			24.62
		],
		[
			"2011-03-29",
			25.15
		]
	],
	"91175008": [
		[
			"2015-11-10",
			22.45
		],
		[
			"2000-09-21",
			27.9
		],
		[
			"2003-03-18",
			27.9
		],
		[
			"2003-11-25",
			23.03
		],
		[
			"2005-04-27",
			33.61
		],
		[
			"2005-10-19",
			23.21
		],
		[
			"2006-05-30",
			32.2
		],
		[
			"2006-11-20",
			31.8
		],
		[
			"2007-05-22",
			37.2
		],
		[
			"2009-07-08",
			22.9
		],
		[
			"2008-04-16",
			29.76
		],
		[
			"2010-07-06",
			29.23
		],
		[
			"2011-03-29",
			36.93
		]
	],
	"94110013": [
		[
			"2014-10-06",
			1.33
		],
		[
			"2015-09-22",
			1.33
		],
		[
			"2000-09-11",
			0.44
		],
		[
			"2002-12-18",
			0.44
		],
		[
			"2004-01-13",
			0.44
		],
		[
			"2005-12-05",
			0.66
		],
		[
			"2006-06-06",
			0.66
		],
		[
			"2007-02-20",
			0.66
		],
		[
			"2008-07-08",
			0.66
		],
		[
			"2009-04-29",
			2.39
		],
		[
			"2010-07-12",
			0.66
		],
		[
			"2010-10-07",
			0.66
		],
		[
			"2011-05-17",
			0.66
		]
	],
	"94110219": [
		[
			"2013-08-14",
			16.12
		],
		[
			"2014-10-06",
			12.09
		],
		[
			"2015-04-13",
			16.96
		],
		[
			"2006-08-24",
			17.8
		],
		[
			"2008-07-03",
			15.32
		],
		[
			"2009-08-05",
			11.6
		],
		[
			"2010-07-15",
			17.01
		],
		[
			"2011-05-26",
			18.56
		]
	],
	"94120330": [
		[
			"2013-08-19",
			5.18
		],
		[
			"2015-05-26",
			32.02
		],
		[
			"2006-03-28",
			27.9
		],
		[
			"2006-09-13",
			23.21
		],
		[
			"2007-03-15",
			31.84
		],
		[
			"2009-10-21",
			12.13
		],
		[
			"2008-07-03",
			15.19
		],
		[
			"2010-07-27",
			22.67
		],
		[
			"2011-11-17",
			17.98
		]
	],
	"94120341": [
		[
			"2013-07-01",
			46.94
		],
		[
			"2014-05-12",
			43.4
		],
		[
			"2015-04-13",
			41.01
		],
		[
			"2006-03-09",
			45.17
		],
		[
			"2006-09-12",
			47.39
		],
		[
			"2007-02-06",
			46.06
		],
		[
			"2008-03-05",
			45.61
		],
		[
			"2009-03-12",
			43.09
		],
		[
			"2010-04-29",
			46.06
		],
		[
			"2011-03-09",
			46.5
		]
	],
	"94120353": [
		[
			"2015-04-13",
			42.03
		],
		[
			"2006-03-09",
			37.42
		],
		[
			"2006-09-13",
			37.64
		],
		[
			"2007-02-06",
			41.41
		],
		[
			"2008-03-05",
			39.15
		],
		[
			"2009-03-12",
			48.27
		],
		[
			"2010-04-29",
			41.41
		],
		[
			"2011-03-09",
			42.25
		]
	],
	"94120365": [
		[
			"2014-05-07",
			1.33
		],
		[
			"2015-04-16",
			1.33
		],
		[
			"2006-05-29",
			0.66
		],
		[
			"2006-09-14",
			0.66
		],
		[
			"2007-02-07",
			1.24
		],
		[
			"2008-07-08",
			0.66
		],
		[
			"2009-04-29",
			0.66
		],
		[
			"2010-04-21",
			1.06
		],
		[
			"2011-04-04",
			0.84
		]
	],
	"94120377": [
		[
			"2015-10-13",
			1.33
		],
		[
			"2006-05-29",
			0.66
		],
		[
			"2006-09-14",
			0.66
		],
		[
			"2007-03-01",
			0.66
		],
		[
			"2008-07-08",
			0.66
		],
		[
			"2009-08-05",
			0.66
		],
		[
			"2010-05-05",
			0.66
		]
	],
	"94120390": [
		[
			"2013-07-01",
			51.37
		],
		[
			"2015-04-16",
			35.87
		],
		[
			"2006-06-06",
			35.21
		],
		[
			"2006-09-06",
			32.15
		],
		[
			"2007-02-07",
			30.51
		],
		[
			"2008-02-21",
			30.38
		],
		[
			"2009-03-17",
			36.45
		],
		[
			"2010-04-21",
			41.36
		],
		[
			"2011-03-15",
			38.75
		]
	],
	"94130590": [
		[
			"2013-08-26",
			35.65
		],
		[
			"2014-11-20",
			34.81
		],
		[
			"2015-04-08",
			35.12
		],
		[
			"2002-03-08",
			45.02
		],
		[
			"2005-03-18",
			39.01
		],
		[
			"2005-09-16",
			42.01
		],
		[
			"2007-12-13",
			37.69
		],
		[
			"2008-07-16",
			35.34
		],
		[
			"2008-11-04",
			35.74
		],
		[
			"2009-07-27",
			34.72
		],
		[
			"2010-07-14",
			34.63
		]
	],
	"94130619": [
		[
			"2008-05-09",
			39.01
		],
		[
			"2009-05-22",
			38.01
		],
		[
			"2013-08-26",
			36.62
		],
		[
			"2014-11-20",
			34.1
		],
		[
			"2015-05-04",
			34.23
		],
		[
			"2004-06-04",
			40.01
		],
		[
			"2005-06-03",
			41.01
		],
		[
			"2006-05-05",
			40.01
		],
		[
			"2007-05-03",
			37.01
		],
		[
			"2007-12-13",
			30.51
		],
		[
			"2011-05-03",
			37.01
		],
		[
			"2012-05-18",
			35.01
		],
		[
			"2008-07-16",
			36.05
		],
		[
			"2008-11-04",
			36.8
		],
		[
			"2009-07-27",
			34.68
		],
		[
			"2010-07-14",
			35.47
		],
		[
			"2011-12-12",
			35.16
		]
	],
	"94130656": [
		[
			"2009-10-16",
			12
		],
		[
			"2013-08-26",
			13.24
		],
		[
			"2014-11-20",
			14.75
		],
		[
			"2015-05-04",
			14.7
		],
		[
			"2005-04-15",
			14
		],
		[
			"2005-10-14",
			13
		],
		[
			"2006-04-10",
			14
		],
		[
			"2006-10-04",
			12
		],
		[
			"2007-04-05",
			14
		],
		[
			"2007-12-13",
			17.94
		],
		[
			"2010-10-20",
			13
		],
		[
			"2011-05-03",
			14
		],
		[
			"2011-11-15",
			13
		],
		[
			"2012-04-20",
			13
		],
		[
			"2014-05-28",
			14
		],
		[
			"2010-07-27",
			12.84
		]
	],
	"94130700": [
		[
			"2015-04-01",
			47.83
		],
		[
			"2007-02-05",
			51.37
		],
		[
			"2007-10-16",
			47.83
		],
		[
			"2008-03-05",
			46.94
		],
		[
			"2009-03-12",
			43.53
		],
		[
			"2010-07-29",
			38.26
		],
		[
			"2011-03-21",
			45.17
		]
	],
	"94130711": [
		[
			"2013-07-03",
			40.39
		],
		[
			"2014-05-06",
			35.03
		],
		[
			"2015-04-01",
			39.95
		],
		[
			"2007-02-05",
			43.44
		],
		[
			"2007-10-16",
			46.5
		],
		[
			"2008-02-21",
			47.83
		],
		[
			"2009-03-24",
			42.78
		],
		[
			"2010-08-03",
			43.13
		],
		[
			"2011-03-16",
			43.36
		]
	],
	"94130723": [
		[
			"2013-07-03",
			42.43
		],
		[
			"2014-05-06",
			39.77
		],
		[
			"2015-04-01",
			47.83
		],
		[
			"2007-02-05",
			47.83
		],
		[
			"2008-02-21",
			46.06
		],
		[
			"2009-04-22",
			44.73
		],
		[
			"2010-04-28",
			46.06
		],
		[
			"2011-03-16",
			42.96
		]
	],
	"94130735": [
		[
			"2013-07-04",
			41.72
		],
		[
			"2014-05-12",
			39.19
		],
		[
			"2015-04-01",
			43.22
		],
		[
			"2007-02-05",
			50.04
		],
		[
			"2007-10-16",
			50.04
		],
		[
			"2008-03-05",
			48.27
		],
		[
			"2008-10-22",
			44.73
		],
		[
			"2009-03-12",
			46.5
		],
		[
			"2010-07-29",
			43.44
		],
		[
			"2011-03-21",
			47.39
		]
	],
	"94140017": [
		[
			"2008-06-04",
			1
		],
		[
			"2009-05-06",
			1
		],
		[
			"2015-05-07",
			1.33
		],
		[
			"2002-02-14",
			1
		],
		[
			"2003-06-23",
			1
		],
		[
			"2004-05-05",
			1
		],
		[
			"2005-05-04",
			1
		],
		[
			"2006-06-06",
			1
		],
		[
			"2007-05-03",
			1
		],
		[
			"2010-06-07",
			1
		],
		[
			"2011-12-13",
			1
		],
		[
			"2012-06-14",
			1
		],
		[
			"2013-05-15",
			1
		],
		[
			"2014-06-11",
			1
		],
		[
			"2009-10-21",
			0.66
		],
		[
			"2010-07-19",
			0.66
		],
		[
			"2011-12-08",
			0.66
		]
	],
	"94140042": [
		[
			"2013-08-19",
			1.33
		],
		[
			"2014-11-20",
			4.65
		],
		[
			"2015-04-09",
			1.33
		],
		[
			"2000-08-23",
			0.89
		],
		[
			"2001-09-18",
			0.44
		],
		[
			"2002-10-17",
			0.44
		],
		[
			"2003-11-26",
			0.44
		],
		[
			"2005-11-17",
			1.11
		],
		[
			"2006-05-10",
			0.66
		],
		[
			"2006-10-17",
			0.66
		],
		[
			"2007-10-16",
			0.66
		],
		[
			"2008-05-06",
			0.66
		],
		[
			"2009-05-25",
			0.66
		],
		[
			"2010-07-28",
			0.84
		],
		[
			"2011-03-21",
			0.66
		]
	],
	"94140170": [
		[
			"2008-04-07",
			14
		],
		[
			"2008-11-07",
			13
		],
		[
			"2009-11-13",
			16.01
		],
		[
			"2014-11-20",
			12.22
		],
		[
			"2015-04-08",
			13.37
		],
		[
			"2004-06-04",
			9
		],
		[
			"2005-12-21",
			12
		],
		[
			"2006-11-03",
			11
		],
		[
			"2007-11-26",
			13
		],
		[
			"2010-11-19",
			14
		],
		[
			"2011-12-09",
			12
		],
		[
			"2010-07-27",
			12.13
		],
		[
			"2009-11-10",
			14.48
		],
		[
			"2011-12-01",
			11.2
		]
	],
	"94140224": [
		[
			"2014-11-20",
			31
		],
		[
			"2015-05-07",
			34.1
		],
		[
			"2002-08-29",
			41.63
		],
		[
			"2003-08-18",
			30.11
		],
		[
			"2004-05-12",
			42.51
		],
		[
			"2005-05-23",
			42.51
		],
		[
			"2006-02-15",
			41.63
		],
		[
			"2007-03-27",
			40.74
		]
	],
	"94140236": [
		[
			"2013-08-22",
			1.33
		],
		[
			"2015-04-08",
			8.9
		],
		[
			"2002-08-29",
			8.41
		],
		[
			"2003-08-25",
			8.86
		],
		[
			"2004-05-12",
			7.97
		],
		[
			"2005-05-23",
			7.97
		],
		[
			"2006-02-15",
			5.31
		],
		[
			"2007-03-27",
			4.87
		],
		[
			"2010-11-09",
			4.21
		]
	],
	"94140248": [
		[
			"2013-07-04",
			38.22
		],
		[
			"2014-05-05",
			40.34
		],
		[
			"2015-04-09",
			41.98
		],
		[
			"2006-03-07",
			38.66
		],
		[
			"2006-09-12",
			35.07
		],
		[
			"2007-02-06",
			37.69
		],
		[
			"2008-02-12",
			37.33
		],
		[
			"2009-03-16",
			40.03
		],
		[
			"2010-07-28",
			36.31
		],
		[
			"2011-03-10",
			37.33
		]
	],
	"94140250": [
		[
			"2013-07-03",
			36.54
		],
		[
			"2014-05-05",
			34.85
		],
		[
			"2014-11-20",
			37.24
		],
		[
			"2015-04-09",
			39.06
		],
		[
			"2006-03-07",
			39.99
		],
		[
			"2006-09-20",
			36.45
		],
		[
			"2007-02-06",
			38.84
		],
		[
			"2008-02-12",
			37.6
		],
		[
			"2009-03-16",
			38.26
		],
		[
			"2010-07-29",
			35.3
		],
		[
			"2011-03-10",
			37.86
		]
	],
	"94150023": [
		[
			"2013-06-27",
			39.5
		],
		[
			"2014-05-12",
			31.58
		],
		[
			"2015-09-04",
			42.82
		],
		[
			"2000-08-23",
			52.26
		],
		[
			"2001-09-13",
			46.94
		],
		[
			"2002-10-17",
			47.83
		],
		[
			"2003-11-20",
			59.79
		],
		[
			"2004-11-18",
			44.73
		],
		[
			"2005-12-12",
			48.27
		],
		[
			"2006-06-20",
			39.28
		],
		[
			"2007-02-08",
			46.06
		],
		[
			"2006-12-06",
			41.14
		],
		[
			"2009-03-31",
			51.81
		],
		[
			"2008-05-06",
			43.13
		],
		[
			"2010-08-30",
			86.36
		],
		[
			"2011-03-14",
			42.69
		]
	],
	"94150084": [
		[
			"2013-11-25",
			1.33
		],
		[
			"2015-05-07",
			3.85
		],
		[
			"2007-06-27",
			1.82
		],
		[
			"2007-10-22",
			0.66
		],
		[
			"2008-12-15",
			5.31
		],
		[
			"2008-07-16",
			0.66
		],
		[
			"2009-07-16",
			0.66
		],
		[
			"2010-11-08",
			0.66
		],
		[
			"2011-05-03",
			0.66
		]
	],
	"94150096": [
		[
			"2013-08-20",
			1.33
		],
		[
			"2015-05-07",
			1.33
		],
		[
			"2000-08-22",
			3.1
		],
		[
			"2001-09-18",
			0.89
		],
		[
			"2002-11-04",
			2.21
		],
		[
			"2003-11-26",
			1.33
		],
		[
			"2004-11-25",
			0.89
		],
		[
			"2006-04-24",
			0.66
		],
		[
			"2007-02-19",
			0.66
		],
		[
			"2008-03-10",
			0.75
		],
		[
			"2006-12-07",
			1.28
		],
		[
			"2009-07-15",
			0.66
		],
		[
			"2005-12-19",
			1.59
		],
		[
			"2010-05-10",
			0.66
		],
		[
			"2011-04-28",
			0.66
		]
	],
	"94150175": [
		[
			"2008-10-15",
			7
		],
		[
			"2009-10-21",
			8
		],
		[
			"2000-04-07",
			5
		],
		[
			"2000-10-25",
			4
		],
		[
			"2001-04-11",
			5
		],
		[
			"2001-10-10",
			5
		],
		[
			"2002-04-10",
			5
		],
		[
			"2002-10-21",
			5
		],
		[
			"2003-04-09",
			6
		],
		[
			"2003-10-22",
			6
		],
		[
			"2004-04-06",
			6
		],
		[
			"2004-10-07",
			5
		],
		[
			"2005-04-05",
			5
		],
		[
			"2005-10-31",
			5
		],
		[
			"2006-10-31",
			7
		],
		[
			"2007-10-18",
			7
		],
		[
			"2010-11-10",
			6
		],
		[
			"2011-04-07",
			6
		],
		[
			"2011-10-31",
			6
		],
		[
			"2012-04-17",
			5
		],
		[
			"2012-10-09",
			6
		],
		[
			"2013-04-24",
			6
		],
		[
			"2013-10-29",
			5.7
		],
		[
			"2014-04-15",
			5.1
		],
		[
			"2014-10-28",
			5.7
		],
		[
			"2015-10-27",
			6.3
		],
		[
			"2010-09-28",
			6.69
		],
		[
			"2011-11-21",
			6.33
		]
	],
	"94150242": [
		[
			"2008-04-21",
			1
		],
		[
			"2008-10-13",
			1
		],
		[
			"2009-04-14",
			1
		],
		[
			"2009-10-12",
			1
		],
		[
			"2015-12-14",
			1.33
		],
		[
			"2000-04-20",
			1
		],
		[
			"2001-04-27",
			1
		],
		[
			"2002-04-29",
			1
		],
		[
			"2003-04-28",
			1
		],
		[
			"2004-04-29",
			1
		],
		[
			"2004-10-29",
			1
		],
		[
			"2005-04-20",
			1
		],
		[
			"2006-04-18",
			1
		],
		[
			"2006-10-09",
			1
		],
		[
			"2007-04-16",
			1
		],
		[
			"2007-10-08",
			1
		],
		[
			"2010-04-19",
			1
		],
		[
			"2010-10-11",
			1
		],
		[
			"2011-04-11",
			1
		],
		[
			"2011-10-05",
			1
		],
		[
			"2012-04-10",
			1
		],
		[
			"2012-10-15",
			1
		],
		[
			"2013-04-02",
			1
		],
		[
			"2013-10-28",
			1
		],
		[
			"2014-04-14",
			1
		],
		[
			"2014-10-06",
			1
		],
		[
			"2015-04-13",
			1
		],
		[
			"2015-10-19",
			1
		],
		[
			"2011-12-15",
			0.66
		]
	],
	"94150448": [
		[
			"2008-12-16",
			23.01
		],
		[
			"2009-12-28",
			21.01
		],
		[
			"2015-12-15",
			17.4
		],
		[
			"2001-09-26",
			20.01
		],
		[
			"2007-12-18",
			20.01
		],
		[
			"2011-02-15",
			18.01
		],
		[
			"2011-12-22",
			27.01
		],
		[
			"2013-01-08",
			19.01
		],
		[
			"2015-12-22",
			16.01
		],
		[
			"2010-11-08",
			23.69
		],
		[
			"2011-12-12",
			11.34
		]
	],
	"94150450": [
		[
			"2014-05-13",
			6.6
		],
		[
			"2013-07-18",
			3.14
		],
		[
			"2015-09-04",
			4.78
		],
		[
			"2006-05-08",
			4.07
		],
		[
			"2007-07-03",
			15.77
		],
		[
			"2007-10-17",
			7.17
		],
		[
			"2008-07-09",
			10.19
		],
		[
			"2009-07-16",
			5.27
		],
		[
			"2010-11-25",
			8.95
		],
		[
			"2011-04-27",
			7.62
		]
	],
	"94150461": [
		[
			"2013-07-18",
			3.06
		],
		[
			"2014-10-01",
			2.04
		],
		[
			"2015-12-14",
			5.62
		],
		[
			"2006-09-21",
			4.25
		],
		[
			"2007-07-25",
			3.68
		],
		[
			"2007-10-30",
			8.68
		],
		[
			"2008-07-09",
			1.15
		],
		[
			"2009-07-29",
			2.21
		],
		[
			"2010-06-08",
			3.1
		],
		[
			"2011-04-27",
			6.91
		]
	],
	"94160041": [
		[
			"2008-05-20",
			39.01
		],
		[
			"2008-06-03",
			37.01
		],
		[
			"2008-06-16",
			37.01
		],
		[
			"2008-04-23",
			46.02
		],
		[
			"2008-05-05",
			38.01
		],
		[
			"2008-07-03",
			34.01
		],
		[
			"2008-07-31",
			36.01
		],
		[
			"2008-08-14",
			39.01
		],
		[
			"2008-07-15",
			35.01
		],
		[
			"2008-10-01",
			38.01
		],
		[
			"2009-04-06",
			41.01
		],
		[
			"2009-11-16",
			55.02
		],
		[
			"2010-03-30",
			56.02
		],
		[
			"2014-10-08",
			41.58
		],
		[
			"2015-10-28",
			42.96
		],
		[
			"2000-04-11",
			38.01
		],
		[
			"2000-10-10",
			36.01
		],
		[
			"2001-04-23",
			38.01
		],
		[
			"2001-10-18",
			39.01
		],
		[
			"2002-04-30",
			41.01
		],
		[
			"2002-10-22",
			37.01
		],
		[
			"2003-04-08",
			39.01
		],
		[
			"2003-10-24",
			46.02
		],
		[
			"2004-04-02",
			43.02
		],
		[
			"2004-10-12",
			45.02
		],
		[
			"2005-04-05",
			55.02
		],
		[
			"2005-10-13",
			42.01
		],
		[
			"2006-04-11",
			40.01
		],
		[
			"2006-10-04",
			37.01
		],
		[
			"2007-04-11",
			39.01
		],
		[
			"2007-09-17",
			40.01
		],
		[
			"2007-09-24",
			38.01
		],
		[
			"2007-10-01",
			58.02
		],
		[
			"2007-10-10",
			41.01
		],
		[
			"2007-10-16",
			41.01
		],
		[
			"2007-10-30",
			39.01
		],
		[
			"2007-10-24",
			33.01
		],
		[
			"2007-11-07",
			44.02
		],
		[
			"2007-11-12",
			64.02
		],
		[
			"2007-11-21",
			50.02
		],
		[
			"2007-11-06",
			42.01
		],
		[
			"2007-12-19",
			48.02
		],
		[
			"2007-11-27",
			41.01
		],
		[
			"2007-12-05",
			46.02
		],
		[
			"2007-12-10",
			52.02
		],
		[
			"2008-01-16",
			41.01
		],
		[
			"2008-02-14",
			45.02
		],
		[
			"2008-01-30",
			48.02
		],
		[
			"2008-03-12",
			40.01
		],
		[
			"2010-10-12",
			46.02
		],
		[
			"2011-04-07",
			38.01
		],
		[
			"2011-10-10",
			43.02
		],
		[
			"2012-10-01",
			39.01
		],
		[
			"2012-04-16",
			39.01
		],
		[
			"2013-04-11",
			45.02
		],
		[
			"2013-10-17",
			52.02
		],
		[
			"2014-04-02",
			40.01
		],
		[
			"2014-10-08",
			41.01
		],
		[
			"2015-10-05",
			39.01
		],
		[
			"2009-05-25",
			36.45
		],
		[
			"2010-08-30",
			68.2
		],
		[
			"2011-08-03",
			35.87
		]
	],
	"94160077": [
		[
			"2013-06-27",
			36.54
		],
		[
			"2014-10-08",
			46.94
		],
		[
			"2015-05-26",
			30.47
		],
		[
			"2000-08-22",
			36.31
		],
		[
			"2001-09-13",
			33.66
		],
		[
			"2002-10-17",
			45.61
		],
		[
			"2003-11-20",
			54.03
		],
		[
			"2004-11-29",
			52.26
		],
		[
			"2005-12-13",
			44.73
		],
		[
			"2006-03-27",
			42.56
		],
		[
			"2007-02-08",
			46.5
		],
		[
			"2007-07-25",
			40.88
		],
		[
			"2008-03-10",
			45.61
		],
		[
			"2009-03-16",
			49.16
		],
		[
			"2010-05-10",
			43.53
		],
		[
			"2011-04-27",
			36.85
		]
	],
	"94160089": [
		[
			"2008-06-17",
			41.01
		],
		[
			"2009-05-27",
			39.01
		],
		[
			"2013-12-05",
			39.41
		],
		[
			"2014-11-20",
			37.64
		],
		[
			"2015-05-05",
			38.35
		],
		[
			"2016-03-07",
			36.76
		],
		[
			"2000-06-07",
			45.02
		],
		[
			"2001-07-06",
			44.02
		],
		[
			"2002-06-06",
			43.02
		],
		[
			"2003-08-20",
			40.01
		],
		[
			"2004-05-26",
			43.02
		],
		[
			"2005-05-18",
			40.01
		],
		[
			"2006-06-26",
			41.01
		],
		[
			"2007-07-16",
			38.01
		],
		[
			"2010-06-30",
			42.01
		],
		[
			"2011-07-26",
			38.01
		],
		[
			"2012-05-22",
			40.01
		],
		[
			"2013-06-18",
			43.02
		],
		[
			"2014-04-04",
			38.01
		],
		[
			"2009-10-21",
			38.26
		],
		[
			"2010-06-29",
			38.53
		]
	],
	"94160090": [
		[
			"2008-04-07",
			16.01
		],
		[
			"2008-05-14",
			16.01
		],
		[
			"2008-06-04",
			16.01
		],
		[
			"2008-09-08",
			16.01
		],
		[
			"2008-07-09",
			16.01
		],
		[
			"2008-08-04",
			16.01
		],
		[
			"2008-10-06",
			16.01
		],
		[
			"2008-12-10",
			16.01
		],
		[
			"2008-11-11",
			16.01
		],
		[
			"2009-03-10",
			18.01
		],
		[
			"2009-02-04",
			17.01
		],
		[
			"2009-01-07",
			16.01
		],
		[
			"2009-06-04",
			17.01
		],
		[
			"2009-04-07",
			16.01
		],
		[
			"2009-05-06",
			16.01
		],
		[
			"2009-09-03",
			17.01
		],
		[
			"2009-07-14",
			17.01
		],
		[
			"2009-08-04",
			17.01
		],
		[
			"2009-12-02",
			17.01
		],
		[
			"2009-10-06",
			17.01
		],
		[
			"2009-11-03",
			17.01
		],
		[
			"2010-02-15",
			17.01
		],
		[
			"2010-03-04",
			18.01
		],
		[
			"2010-01-05",
			17.01
		],
		[
			"2014-11-20",
			17.63
		],
		[
			"2015-05-05",
			17.32
		],
		[
			"2000-01-24",
			15.01
		],
		[
			"2000-02-03",
			15.01
		],
		[
			"2000-03-08",
			15.01
		],
		[
			"2000-04-18",
			15.01
		],
		[
			"2000-05-23",
			15.01
		],
		[
			"2000-06-13",
			15.01
		],
		[
			"2000-07-24",
			15.01
		],
		[
			"2000-08-10",
			15.01
		],
		[
			"2000-09-18",
			15.01
		],
		[
			"2000-10-23",
			14
		],
		[
			"2000-11-09",
			15.01
		],
		[
			"2000-12-11",
			16.01
		],
		[
			"2001-01-22",
			16.01
		],
		[
			"2001-02-15",
			16.01
		],
		[
			"2001-03-12",
			16.01
		],
		[
			"2001-04-25",
			15.01
		],
		[
			"2001-05-17",
			15.01
		],
		[
			"2001-06-26",
			15.01
		],
		[
			"2001-07-19",
			15.01
		],
		[
			"2001-08-14",
			15.01
		],
		[
			"2001-09-10",
			15.01
		],
		[
			"2001-10-12",
			16.01
		],
		[
			"2001-11-12",
			16.01
		],
		[
			"2001-12-12",
			16.01
		],
		[
			"2002-01-08",
			15.01
		],
		[
			"2002-02-12",
			14
		],
		[
			"2002-03-12",
			16.01
		],
		[
			"2002-04-09",
			15.01
		],
		[
			"2002-05-06",
			15.01
		],
		[
			"2002-06-11",
			15.01
		],
		[
			"2002-07-11",
			15.01
		],
		[
			"2002-08-09",
			16.01
		],
		[
			"2002-09-12",
			15.01
		],
		[
			"2002-11-22",
			15.01
		],
		[
			"2002-10-29",
			15.01
		],
		[
			"2002-12-06",
			16.01
		],
		[
			"2003-02-27",
			15.01
		],
		[
			"2003-03-25",
			15.01
		],
		[
			"2003-06-30",
			17.01
		],
		[
			"2003-04-29",
			17.01
		],
		[
			"2003-05-19",
			15.01
		],
		[
			"2003-07-29",
			16.01
		],
		[
			"2003-08-18",
			16.01
		],
		[
			"2003-09-29",
			16.01
		],
		[
			"2003-10-22",
			16.01
		],
		[
			"2003-11-11",
			17.01
		],
		[
			"2003-12-10",
			16.01
		],
		[
			"2004-01-06",
			16.01
		],
		[
			"2004-02-09",
			17.01
		],
		[
			"2004-03-09",
			16.01
		],
		[
			"2004-04-05",
			16.01
		],
		[
			"2004-05-05",
			16.01
		],
		[
			"2004-06-02",
			16.01
		],
		[
			"2004-07-05",
			17.01
		],
		[
			"2004-08-02",
			17.01
		],
		[
			"2004-09-06",
			16.01
		],
		[
			"2004-10-07",
			16.01
		],
		[
			"2004-11-16",
			17.01
		],
		[
			"2004-12-14",
			17.01
		],
		[
			"2005-01-05",
			17.01
		],
		[
			"2005-02-14",
			16.01
		],
		[
			"2005-03-09",
			18.01
		],
		[
			"2005-04-06",
			19.01
		],
		[
			"2005-05-04",
			19.01
		],
		[
			"2005-06-14",
			18.01
		],
		[
			"2005-07-05",
			21.01
		],
		[
			"2005-08-02",
			16.01
		],
		[
			"2005-09-06",
			18.01
		],
		[
			"2005-11-09",
			16.01
		],
		[
			"2005-10-11",
			19.01
		],
		[
			"2005-12-06",
			16.01
		],
		[
			"2006-01-04",
			17.01
		],
		[
			"2006-02-07",
			17.01
		],
		[
			"2006-03-14",
			16.01
		],
		[
			"2006-04-04",
			15.01
		],
		[
			"2006-05-04",
			17.01
		],
		[
			"2006-06-06",
			16.01
		],
		[
			"2006-09-12",
			16.01
		],
		[
			"2006-07-04",
			16.01
		],
		[
			"2006-08-09",
			16.01
		],
		[
			"2006-10-09",
			16.01
		],
		[
			"2006-11-08",
			16.01
		],
		[
			"2006-12-05",
			17.01
		],
		[
			"2007-03-07",
			17.01
		],
		[
			"2007-02-06",
			17.01
		],
		[
			"2007-01-04",
			17.01
		],
		[
			"2007-06-05",
			17.01
		],
		[
			"2007-05-03",
			16.01
		],
		[
			"2007-04-12",
			16.01
		],
		[
			"2007-08-02",
			17.01
		],
		[
			"2007-08-24",
			17.01
		],
		[
			"2007-07-03",
			17.01
		],
		[
			"2007-11-08",
			16.01
		],
		[
			"2007-10-02",
			16.01
		],
		[
			"2007-12-10",
			17.01
		],
		[
			"2008-03-05",
			17.01
		],
		[
			"2008-01-07",
			18.01
		],
		[
			"2008-02-06",
			16.01
		],
		[
			"2010-04-06",
			17.01
		],
		[
			"2010-05-10",
			17.01
		],
		[
			"2010-06-07",
			17.01
		],
		[
			"2010-09-06",
			17.01
		],
		[
			"2010-07-07",
			16.01
		],
		[
			"2010-08-02",
			17.01
		],
		[
			"2010-10-06",
			16.01
		],
		[
			"2010-12-06",
			17.01
		],
		[
			"2011-02-14",
			17.01
		],
		[
			"2011-03-03",
			17.01
		],
		[
			"2011-04-04",
			18.01
		],
		[
			"2011-06-20",
			17.01
		],
		[
			"2011-05-02",
			16.01
		],
		[
			"2011-09-22",
			16.01
		],
		[
			"2011-07-21",
			16.01
		],
		[
			"2011-08-29",
			16.01
		],
		[
			"2011-11-21",
			16.01
		],
		[
			"2011-11-28",
			16.01
		],
		[
			"2011-12-14",
			16.01
		],
		[
			"2011-10-20",
			16.01
		],
		[
			"2011-11-15",
			16.01
		],
		[
			"2012-01-18",
			17.01
		],
		[
			"2012-02-07",
			18.01
		],
		[
			"2012-03-06",
			17.01
		],
		[
			"2012-04-12",
			17.01
		],
		[
			"2012-05-07",
			17.01
		],
		[
			"2012-06-14",
			17.01
		],
		[
			"2012-07-04",
			18.01
		],
		[
			"2012-08-07",
			16.01
		],
		[
			"2012-09-11",
			16.01
		],
		[
			"2012-10-04",
			16.01
		],
		[
			"2013-02-11",
			18.01
		],
		[
			"2012-11-07",
			16.01
		],
		[
			"2013-03-06",
			18.01
		],
		[
			"2013-01-08",
			17.01
		],
		[
			"2012-12-10",
			16.01
		],
		[
			"2013-06-13",
			18.01
		],
		[
			"2013-07-16",
			19.01
		],
		[
			"2013-08-19",
			18.01
		],
		[
			"2013-05-15",
			18.01
		],
		[
			"2013-09-12",
			17.01
		],
		[
			"2013-10-16",
			13
		],
		[
			"2013-11-25",
			17.01
		],
		[
			"2013-12-16",
			17.01
		],
		[
			"2014-01-21",
			18.01
		],
		[
			"2014-02-19",
			18.01
		],
		[
			"2014-03-17",
			17.01
		],
		[
			"2014-04-14",
			17.01
		],
		[
			"2014-05-12",
			17.01
		],
		[
			"2014-06-11",
			16.01
		],
		[
			"2014-09-10",
			17.01
		],
		[
			"2014-07-09",
			16.01
		],
		[
			"2014-08-19",
			17.01
		],
		[
			"2015-01-14",
			18.01
		],
		[
			"2014-10-20",
			17.01
		],
		[
			"2014-11-19",
			18.01
		],
		[
			"2015-07-15",
			17.01
		],
		[
			"2015-08-13",
			17.01
		],
		[
			"2015-09-08",
			17.01
		],
		[
			"2015-10-07",
			16.01
		],
		[
			"2015-11-17",
			16.01
		],
		[
			"2015-12-09",
			16.01
		],
		[
			"2009-07-28",
			16.65
		],
		[
			"2010-06-29",
			16.83
		],
		[
			"2011-12-08",
			15.23
		]
	],
	"94160107": [
		[
			"2008-09-22",
			16.01
		],
		[
			"2009-09-15",
			17.01
		],
		[
			"2014-11-24",
			16.43
		],
		[
			"2015-04-29",
			14.7
		],
		[
			"2000-03-08",
			19.01
		],
		[
			"2000-06-13",
			16.01
		],
		[
			"2000-09-29",
			15.01
		],
		[
			"2000-12-11",
			16.01
		],
		[
			"2001-03-12",
			16.01
		],
		[
			"2001-06-26",
			16.01
		],
		[
			"2001-09-10",
			15.01
		],
		[
			"2001-12-12",
			17.01
		],
		[
			"2002-03-12",
			19.01
		],
		[
			"2002-06-11",
			16.01
		],
		[
			"2002-09-12",
			16.01
		],
		[
			"2002-12-06",
			17.01
		],
		[
			"2003-09-17",
			16.01
		],
		[
			"2004-08-18",
			17.01
		],
		[
			"2005-09-21",
			18.01
		],
		[
			"2006-09-13",
			16.01
		],
		[
			"2007-09-18",
			17.01
		],
		[
			"2010-09-07",
			16.01
		],
		[
			"2011-09-26",
			16.01
		],
		[
			"2012-08-14",
			16.01
		],
		[
			"2012-09-12",
			16.01
		],
		[
			"2012-10-02",
			16.01
		],
		[
			"2013-03-19",
			17.01
		],
		[
			"2012-11-13",
			17.01
		],
		[
			"2013-01-28",
			17.01
		],
		[
			"2013-02-19",
			17.01
		],
		[
			"2012-12-07",
			16.01
		],
		[
			"2013-04-17",
			17.01
		],
		[
			"2013-05-14",
			17.01
		],
		[
			"2013-06-12",
			17.01
		],
		[
			"2013-07-09",
			16.01
		],
		[
			"2013-08-20",
			16.01
		],
		[
			"2013-09-18",
			16.01
		],
		[
			"2013-10-21",
			16.01
		],
		[
			"2013-12-12",
			16.01
		],
		[
			"2014-01-23",
			17.01
		],
		[
			"2014-02-20",
			16.01
		],
		[
			"2014-03-10",
			16.01
		],
		[
			"2014-04-17",
			16.01
		],
		[
			"2014-05-14",
			16.01
		],
		[
			"2014-06-24",
			16.01
		],
		[
			"2014-08-28",
			16.01
		],
		[
			"2014-09-18",
			16.01
		],
		[
			"2014-07-24",
			16.01
		],
		[
			"2015-01-22",
			17.01
		],
		[
			"2014-10-16",
			16.01
		],
		[
			"2014-11-14",
			16.01
		],
		[
			"2015-07-23",
			17.01
		],
		[
			"2015-08-20",
			17.01
		],
		[
			"2015-09-24",
			16.01
		],
		[
			"2015-10-29",
			16.01
		],
		[
			"2015-11-19",
			16.01
		],
		[
			"2015-12-17",
			16.01
		],
		[
			"2008-07-21",
			16.34
		],
		[
			"2009-07-16",
			16.12
		],
		[
			"2010-09-01",
			10.41
		],
		[
			"2011-05-18",
			16.21
		]
	],
	"94160170": [
		[
			"2008-09-22",
			33.01
		],
		[
			"2009-09-15",
			32.01
		],
		[
			"2013-10-01",
			34.59
		],
		[
			"2014-11-24",
			36.89
		],
		[
			"2015-09-23",
			33.61
		],
		[
			"2000-02-03",
			28.01
		],
		[
			"2000-08-10",
			28.01
		],
		[
			"2001-02-15",
			38.01
		],
		[
			"2001-08-14",
			28.01
		],
		[
			"2002-02-12",
			39.01
		],
		[
			"2002-08-09",
			40.01
		],
		[
			"2003-09-17",
			33.01
		],
		[
			"2007-09-18",
			38.01
		],
		[
			"2010-06-29",
			31.01
		],
		[
			"2010-09-07",
			32.01
		],
		[
			"2011-03-02",
			34.01
		],
		[
			"2011-09-26",
			32.01
		],
		[
			"2011-12-22",
			37.01
		],
		[
			"2013-03-19",
			39.01
		],
		[
			"2013-09-18",
			34.01
		],
		[
			"2014-03-10",
			35.01
		],
		[
			"2014-09-18",
			35.01
		],
		[
			"2015-09-24",
			34.01
		],
		[
			"2010-09-01",
			30.38
		],
		[
			"2011-05-18",
			32.28
		]
	],
	"94160193": [
		[
			"2008-06-17",
			39.01
		],
		[
			"2009-05-27",
			41.01
		],
		[
			"2014-11-20",
			42.51
		],
		[
			"2015-04-23",
			44.29
		],
		[
			"2000-06-07",
			32.01
		],
		[
			"2001-07-06",
			30.01
		],
		[
			"2002-06-06",
			29.01
		],
		[
			"2003-08-20",
			32.01
		],
		[
			"2004-05-26",
			35.01
		],
		[
			"2005-05-18",
			36.01
		],
		[
			"2006-06-26",
			37.01
		],
		[
			"2007-07-16",
			34.01
		],
		[
			"2010-06-30",
			45.02
		],
		[
			"2011-07-26",
			42.01
		],
		[
			"2012-05-22",
			44.02
		],
		[
			"2013-06-18",
			48.02
		],
		[
			"2014-04-04",
			44.02
		]
	],
	"94160314": [
		[
			"2013-12-05",
			48.27
		],
		[
			"2014-05-05",
			41.23
		],
		[
			"2015-09-04",
			54.91
		],
		[
			"2006-03-30",
			38.17
		],
		[
			"2006-09-11",
			34.72
		],
		[
			"2007-02-19",
			45.17
		],
		[
			"2008-02-12",
			43.89
		],
		[
			"2009-03-16",
			48.71
		],
		[
			"2010-04-20",
			42.78
		],
		[
			"2011-03-14",
			43.31
		]
	],
	"94160466": [
		[
			"2008-09-18",
			7
		],
		[
			"2009-09-17",
			8
		],
		[
			"2013-11-18",
			9.7
		],
		[
			"2014-11-27",
			9.57
		],
		[
			"2015-09-21",
			3.68
		],
		[
			"2004-09-09",
			6
		],
		[
			"2005-09-19",
			7
		],
		[
			"2006-09-21",
			7
		],
		[
			"2007-09-27",
			9
		],
		[
			"2010-09-27",
			9
		],
		[
			"2011-09-16",
			12
		],
		[
			"2012-09-26",
			9
		],
		[
			"2013-05-28",
			10
		],
		[
			"2014-05-20",
			8.9
		],
		[
			"2010-09-15",
			8.77
		],
		[
			"2011-11-16",
			8.72
		]
	],
	"94160594": [
		[
			"2015-12-15",
			8.68
		],
		[
			"2003-10-22",
			8
		],
		[
			"2003-10-21",
			8
		],
		[
			"2003-04-09",
			8
		],
		[
			"2010-09-28",
			7.62
		],
		[
			"2011-11-21",
			7.09
		]
	],
	"94160661": [
		[
			"2014-12-01",
			8.81
		],
		[
			"2015-05-06",
			9.08
		],
		[
			"2002-04-09",
			7
		],
		[
			"2010-09-28",
			9.92
		],
		[
			"2011-11-21",
			9.21
		]
	],
	"94170083": [
		[
			"2014-04-29",
			2.35
		],
		[
			"2014-11-20",
			12.93
		],
		[
			"2015-04-23",
			17.94
		],
		[
			"2006-03-09",
			17.63
		],
		[
			"2006-09-19",
			12.8
		],
		[
			"2007-02-13",
			18.78
		],
		[
			"2008-03-04",
			19.49
		],
		[
			"2009-03-31",
			19
		],
		[
			"2010-06-30",
			12.36
		]
	],
	"94170101": [
		[
			"2008-11-04",
			22.01
		],
		[
			"2009-10-06",
			20.01
		],
		[
			"2009-11-17",
			21.01
		],
		[
			"2013-12-04",
			19.22
		],
		[
			"2014-11-20",
			18.02
		],
		[
			"2015-04-10",
			19
		],
		[
			"2000-05-25",
			19.01
		],
		[
			"2000-11-28",
			19.49
		],
		[
			"2001-05-03",
			17.01
		],
		[
			"2001-10-18",
			19.04
		],
		[
			"2002-05-07",
			19.01
		],
		[
			"2002-06-24",
			19.04
		],
		[
			"2002-11-04",
			18.6
		],
		[
			"2003-11-24",
			19.93
		],
		[
			"2003-05-05",
			18.01
		],
		[
			"2004-09-21",
			11.07
		],
		[
			"2004-05-11",
			21.01
		],
		[
			"2005-05-09",
			24.01
		],
		[
			"2005-06-15",
			20.15
		],
		[
			"2005-11-10",
			19.84
		],
		[
			"2006-04-24",
			20.59
		],
		[
			"2006-11-29",
			21.01
		],
		[
			"2006-12-07",
			20.64
		],
		[
			"2007-11-14",
			20.01
		],
		[
			"2010-10-04",
			21.01
		],
		[
			"2010-11-02",
			20.01
		],
		[
			"2011-11-09",
			21.01
		],
		[
			"2012-10-18",
			20.01
		],
		[
			"2012-11-08",
			20.01
		],
		[
			"2013-11-13",
			21.01
		],
		[
			"2014-05-08",
			18.01
		],
		[
			"2015-10-07",
			20.01
		],
		[
			"2015-11-04",
			21.01
		],
		[
			"2009-10-07",
			19.97
		],
		[
			"2010-06-07",
			19.35
		],
		[
			"2011-05-17",
			19.44
		]
	],
	"94170253": [
		[
			"2010-03-24",
			17.01
		],
		[
			"2014-11-24",
			7.4
		],
		[
			"2015-04-28",
			7.79
		],
		[
			"2000-03-07",
			10
		],
		[
			"2001-03-05",
			9
		],
		[
			"2002-03-04",
			10
		],
		[
			"2003-03-27",
			8
		],
		[
			"2004-03-25",
			8
		],
		[
			"2005-03-23",
			6
		],
		[
			"2006-04-06",
			11
		],
		[
			"2007-03-28",
			11
		],
		[
			"2008-03-19",
			16.01
		]
	],
	"94170319": [
		[
			"2008-10-09",
			17.01
		],
		[
			"2009-10-06",
			16.01
		],
		[
			"2013-12-04",
			8.77
		],
		[
			"2014-11-20",
			8.64
		],
		[
			"2015-04-10",
			8.46
		],
		[
			"2000-10-10",
			10
		],
		[
			"2001-10-15",
			9
		],
		[
			"2002-10-17",
			9
		],
		[
			"2003-10-06",
			9
		],
		[
			"2004-10-18",
			10
		],
		[
			"2005-11-24",
			11
		],
		[
			"2006-11-29",
			13
		],
		[
			"2007-11-14",
			16.01
		],
		[
			"2010-10-04",
			14
		],
		[
			"2011-04-08",
			14
		],
		[
			"2011-10-06",
			11
		],
		[
			"2012-10-18",
			10
		],
		[
			"2013-10-02",
			9.3
		],
		[
			"2014-10-16",
			8.6
		],
		[
			"2015-10-07",
			9
		],
		[
			"2010-09-15",
			13.64
		],
		[
			"2011-09-22",
			11.16
		]
	],
	"94170320": [
		[
			"2008-11-04",
			16.01
		],
		[
			"2009-11-17",
			16.01
		],
		[
			"2009-10-06",
			15.01
		],
		[
			"2015-04-10",
			15.37
		],
		[
			"2000-05-25",
			21.01
		],
		[
			"2001-05-03",
			16.01
		],
		[
			"2002-05-07",
			16.01
		],
		[
			"2003-05-05",
			17.01
		],
		[
			"2004-05-11",
			19.01
		],
		[
			"2005-05-09",
			20.01
		],
		[
			"2006-11-29",
			20.01
		],
		[
			"2007-11-14",
			13
		],
		[
			"2008-02-05",
			16.01
		],
		[
			"2010-10-04",
			17.01
		],
		[
			"2010-11-02",
			19.01
		],
		[
			"2011-11-09",
			18.01
		],
		[
			"2012-10-18",
			16.01
		],
		[
			"2013-10-02",
			16.01
		],
		[
			"2014-10-16",
			13
		],
		[
			"2015-10-07",
			14
		],
		[
			"2009-10-07",
			15.59
		],
		[
			"2010-06-07",
			17.58
		],
		[
			"2011-05-17",
			16.92
		]
	],
	"94170332": [
		[
			"2008-05-27",
			21.01
		],
		[
			"2008-11-04",
			24.01
		],
		[
			"2009-05-05",
			22.01
		],
		[
			"2009-07-15",
			23.01
		],
		[
			"2009-11-17",
			27.01
		],
		[
			"2010-02-08",
			25.01
		],
		[
			"2000-05-25",
			21.01
		],
		[
			"2000-10-10",
			23.01
		],
		[
			"2001-05-03",
			23.01
		],
		[
			"2001-10-15",
			23.01
		],
		[
			"2002-05-07",
			22.01
		],
		[
			"2002-10-17",
			20.01
		],
		[
			"2003-05-05",
			18.01
		],
		[
			"2003-10-06",
			23.01
		],
		[
			"2004-05-11",
			23.01
		],
		[
			"2004-10-18",
			25.01
		],
		[
			"2005-05-09",
			24.01
		],
		[
			"2005-11-24",
			22.01
		],
		[
			"2006-05-02",
			24.01
		],
		[
			"2007-05-23",
			22.01
		],
		[
			"2007-11-15",
			24.01
		],
		[
			"2010-05-04",
			25.01
		],
		[
			"2010-11-02",
			24.01
		],
		[
			"2011-05-06",
			24.01
		],
		[
			"2011-10-28",
			27.01
		],
		[
			"2012-05-24",
			24.01
		],
		[
			"2012-11-08",
			25.01
		],
		[
			"2013-05-21",
			28.01
		],
		[
			"2013-11-13",
			25.01
		],
		[
			"2014-05-08",
			24.01
		],
		[
			"2014-11-11",
			26.01
		],
		[
			"2015-05-07",
			24.01
		],
		[
			"2015-11-04",
			25.01
		],
		[
			"2010-06-07",
			24.31
		],
		[
			"2011-03-30",
			23.07
		]
	],
	"94170344": [
		[
			"2013-08-13",
			8.33
		],
		[
			"2015-04-28",
			8.41
		],
		[
			"2006-05-23",
			5.93
		],
		[
			"2006-09-05",
			3.9
		],
		[
			"2007-03-14",
			3.63
		],
		[
			"2008-03-11",
			9.26
		],
		[
			"2009-09-03",
			9.08
		],
		[
			"2010-04-26",
			4.07
		],
		[
			"2011-03-17",
			11.6
		]
	],
	"94170356": [
		[
			"2013-08-13",
			4.38
		],
		[
			"2015-09-24",
			4.47
		],
		[
			"2006-05-23",
			4.52
		],
		[
			"2007-03-14",
			3.94
		],
		[
			"2007-08-20",
			4.07
		],
		[
			"2008-03-11",
			3.68
		],
		[
			"2009-09-03",
			4.16
		],
		[
			"2010-04-26",
			4.07
		]
	],
	"94170368": [
		[
			"2014-11-27",
			1.86
		],
		[
			"2015-09-21",
			1.77
		],
		[
			"2003-06-16",
			3.3
		],
		[
			"2004-05-26",
			3.9
		],
		[
			"2002-05-27",
			2.8
		],
		[
			"2001-05-16",
			3.7
		],
		[
			"2000-05-30",
			3
		],
		[
			"2005-06-27",
			4.8
		],
		[
			"2006-05-16",
			3
		]
	],
	"94170435": [
		[
			"2013-06-27",
			5.27
		],
		[
			"2014-11-20",
			12.27
		],
		[
			"2015-04-10",
			16.08
		],
		[
			"2006-05-31",
			14.04
		],
		[
			"2006-09-19",
			6.02
		],
		[
			"2007-02-14",
			13.06
		],
		[
			"2008-07-21",
			6.02
		],
		[
			"2009-09-17",
			7.93
		],
		[
			"2010-04-19",
			9.92
		],
		[
			"2011-04-27",
			8.28
		]
	],
	"94170459": [
		[
			"2013-07-03",
			36.31
		],
		[
			"2014-05-05",
			31.62
		],
		[
			"2014-10-08",
			41.58
		],
		[
			"2015-04-15",
			42.51
		],
		[
			"2006-12-11",
			37.82
		],
		[
			"2007-02-08",
			43.13
		],
		[
			"2007-08-20",
			43.93
		],
		[
			"2008-02-18",
			41.1
		],
		[
			"2008-11-12",
			36.18
		],
		[
			"2009-03-31",
			41.27
		],
		[
			"2010-04-20",
			40.83
		],
		[
			"2011-03-16",
			35.38
		]
	],
	"94180027": [
		[
			"2008-04-17",
			28.01
		],
		[
			"2008-10-16",
			27.01
		],
		[
			"2009-10-09",
			28.01
		],
		[
			"2014-11-27",
			26.97
		],
		[
			"2015-04-14",
			24.53
		],
		[
			"2000-04-14",
			26.01
		],
		[
			"2000-10-26",
			29.01
		],
		[
			"2000-12-14",
			30.01
		],
		[
			"2001-04-23",
			29.01
		],
		[
			"2001-09-11",
			29.01
		],
		[
			"2002-04-16",
			25.01
		],
		[
			"2002-10-01",
			28.01
		],
		[
			"2003-04-03",
			25.01
		],
		[
			"2003-10-07",
			27.01
		],
		[
			"2004-05-10",
			28.01
		],
		[
			"2004-10-19",
			30.01
		],
		[
			"2005-04-18",
			32.01
		],
		[
			"2005-10-17",
			29.01
		],
		[
			"2006-04-06",
			28.01
		],
		[
			"2006-10-19",
			28.01
		],
		[
			"2007-04-18",
			27.01
		],
		[
			"2007-10-16",
			28.01
		],
		[
			"2010-04-20",
			27.01
		],
		[
			"2010-10-18",
			27.01
		],
		[
			"2012-12-12",
			27.01
		],
		[
			"2012-12-14",
			26.01
		],
		[
			"2013-04-17",
			28.01
		],
		[
			"2013-10-16",
			27.01
		],
		[
			"2010-04-14",
			25.91
		],
		[
			"2011-12-06",
			27.1
		]
	],
	"94180052": [
		[
			"2014-12-01",
			16.3
		],
		[
			"2015-05-06",
			5.89
		],
		[
			"2002-11-07",
			9
		],
		[
			"2003-11-13",
			7
		],
		[
			"2010-11-10",
			6.16
		]
	],
	"94180106": [
		[
			"2008-11-11",
			26.01
		],
		[
			"2010-03-09",
			28.01
		],
		[
			"2013-12-02",
			10.32
		],
		[
			"2014-11-27",
			14.08
		],
		[
			"2015-04-14",
			15.9
		],
		[
			"2000-05-26",
			21.01
		],
		[
			"2001-05-15",
			20.01
		],
		[
			"2002-05-08",
			17.01
		],
		[
			"2003-05-06",
			20.01
		],
		[
			"2004-05-10",
			22.01
		],
		[
			"2005-05-10",
			30.01
		],
		[
			"2006-05-03",
			22.01
		],
		[
			"2007-05-24",
			17.01
		],
		[
			"2011-04-20",
			19.01
		],
		[
			"2012-12-14",
			9
		],
		[
			"2012-11-22",
			9
		],
		[
			"2013-05-14",
			16.01
		],
		[
			"2009-09-07",
			13.37
		],
		[
			"2010-04-14",
			26.35
		],
		[
			"2011-05-25",
			16.92
		]
	],
	"94180118": [
		[
			"2008-04-08",
			22.01
		],
		[
			"2013-12-04",
			21.39
		],
		[
			"2014-11-20",
			21.12
		],
		[
			"2000-10-10",
			21.01
		],
		[
			"2001-10-15",
			20.01
		],
		[
			"2002-10-17",
			21.01
		],
		[
			"2003-10-07",
			22.01
		],
		[
			"2004-10-19",
			23.01
		],
		[
			"2005-11-24",
			21.01
		],
		[
			"2006-11-29",
			21.01
		],
		[
			"2007-10-02",
			21.01
		],
		[
			"2010-04-08",
			23.01
		],
		[
			"2011-04-08",
			22.01
		],
		[
			"2012-04-13",
			22.01
		],
		[
			"2013-10-02",
			22.01
		],
		[
			"2014-09-02",
			21.01
		],
		[
			"2015-10-07",
			21.01
		],
		[
			"2010-04-19",
			22.1
		],
		[
			"2011-09-22",
			21.52
		]
	],
	"94180120": [
		[
			"2008-09-05",
			27.01
		],
		[
			"2009-10-09",
			26.01
		],
		[
			"2013-06-27",
			23.29
		],
		[
			"2014-11-27",
			27.01
		],
		[
			"2015-04-14",
			25.82
		],
		[
			"2000-09-19",
			29.01
		],
		[
			"2001-09-11",
			27.01
		],
		[
			"2002-08-14",
			27.01
		],
		[
			"2003-09-09",
			26.01
		],
		[
			"2004-09-20",
			29.01
		],
		[
			"2005-09-13",
			33.01
		],
		[
			"2006-09-20",
			28.01
		],
		[
			"2007-09-12",
			29.01
		],
		[
			"2010-04-20",
			25.01
		],
		[
			"2010-10-18",
			25.01
		],
		[
			"2011-04-20",
			25.01
		],
		[
			"2009-09-07",
			25.95
		],
		[
			"2010-04-14",
			24.09
		],
		[
			"2011-05-25",
			24.58
		]
	],
	"94190094": [
		[
			"2010-03-09",
			60.02
		],
		[
			"2013-12-02",
			54.03
		],
		[
			"2015-09-30",
			47.83
		],
		[
			"2000-08-29",
			57.02
		],
		[
			"2001-08-21",
			56.02
		],
		[
			"2006-05-09",
			62.44
		],
		[
			"2006-09-19",
			59.34
		],
		[
			"2007-11-29",
			65.99
		],
		[
			"2008-07-21",
			59.79
		],
		[
			"2009-09-07",
			60.23
		],
		[
			"2010-05-19",
			62.89
		],
		[
			"2011-05-25",
			57.13
		]
	],
	"94190173": [
		[
			"2008-04-11",
			48.02
		],
		[
			"2008-08-14",
			48.02
		],
		[
			"2008-07-10",
			47.02
		],
		[
			"2008-09-05",
			49.02
		],
		[
			"2008-11-11",
			44.02
		],
		[
			"2008-10-16",
			47.02
		],
		[
			"2009-03-25",
			44.02
		],
		[
			"2009-01-29",
			49.02
		],
		[
			"2009-02-11",
			49.02
		],
		[
			"2009-04-21",
			46.02
		],
		[
			"2009-06-26",
			50.02
		],
		[
			"2009-05-13",
			49.02
		],
		[
			"2009-08-25",
			45.02
		],
		[
			"2009-09-15",
			48.02
		],
		[
			"2009-07-29",
			49.02
		],
		[
			"2009-12-10",
			49.02
		],
		[
			"2009-10-09",
			47.02
		],
		[
			"2009-11-10",
			49.02
		],
		[
			"2010-03-09",
			49.02
		],
		[
			"2010-01-12",
			49.02
		],
		[
			"2010-02-12",
			50.02
		],
		[
			"2014-11-27",
			40.7
		],
		[
			"2015-04-14",
			46.94
		],
		[
			"2000-05-17",
			55.8
		],
		[
			"2000-10-26",
			53.02
		],
		[
			"2001-02-13",
			50.02
		],
		[
			"2001-10-25",
			58.02
		],
		[
			"2002-02-27",
			55.02
		],
		[
			"2002-10-01",
			54.02
		],
		[
			"2003-03-13",
			56.02
		],
		[
			"2003-07-15",
			58.02
		],
		[
			"2004-03-08",
			54.02
		],
		[
			"2004-10-19",
			53.02
		],
		[
			"2005-02-21",
			50.02
		],
		[
			"2006-03-09",
			50.02
		],
		[
			"2006-01-10",
			49.02
		],
		[
			"2006-02-07",
			50.02
		],
		[
			"2006-04-06",
			51.02
		],
		[
			"2006-09-20",
			50.02
		],
		[
			"2007-06-13",
			49.02
		],
		[
			"2007-04-18",
			49.02
		],
		[
			"2007-05-24",
			49.02
		],
		[
			"2007-08-22",
			49.02
		],
		[
			"2007-09-12",
			48.02
		],
		[
			"2007-10-16",
			51.02
		],
		[
			"2007-11-27",
			46.02
		],
		[
			"2008-01-17",
			48.02
		],
		[
			"2008-03-06",
			48.02
		],
		[
			"2008-02-14",
			47.02
		],
		[
			"2010-04-20",
			49.02
		],
		[
			"2010-06-15",
			46.02
		],
		[
			"2011-04-20",
			47.02
		],
		[
			"2009-10-29",
			48.71
		],
		[
			"2010-05-19",
			45.17
		],
		[
			"2011-12-06",
			43.31
		]
	],
	"98120414": [
		[
			"2015-06-24",
			1.33
		],
		[
			"2007-03-05",
			1
		],
		[
			"2007-06-26",
			1
		],
		[
			"2007-09-03",
			1.02
		],
		[
			"2007-12-05",
			1
		],
		[
			"2008-06-25",
			1
		],
		[
			"2008-09-22",
			1
		],
		[
			"2008-12-12",
			1
		],
		[
			"2005-02-11",
			0.89
		],
		[
			"2005-05-12",
			4.43
		],
		[
			"2005-08-11",
			1.33
		],
		[
			"2005-11-09",
			1
		],
		[
			"2006-06-01",
			1.02
		],
		[
			"2006-03-15",
			0.89
		],
		[
			"2006-11-20",
			1.02
		],
		[
			"2006-08-29",
			1.02
		],
		[
			"2000-03-23",
			13.29
		],
		[
			"2000-06-15",
			13.29
		],
		[
			"2000-09-28",
			13.29
		],
		[
			"2000-12-19",
			3.1
		],
		[
			"2001-03-19",
			31
		],
		[
			"2001-04-19",
			31
		],
		[
			"2001-06-21",
			3.1
		],
		[
			"2001-09-26",
			34.99
		],
		[
			"2001-12-17",
			3.1
		],
		[
			"2002-04-09",
			4.43
		],
		[
			"2002-07-12",
			0.89
		],
		[
			"2002-09-27",
			0.89
		],
		[
			"2002-12-19",
			0.89
		],
		[
			"2003-02-12",
			2.21
		],
		[
			"2003-05-14",
			0.89
		],
		[
			"2003-08-14",
			0.89
		],
		[
			"2003-11-11",
			0.89
		],
		[
			"2004-02-11",
			0.89
		],
		[
			"2004-05-11",
			0.89
		],
		[
			"2004-08-19",
			0.89
		],
		[
			"2004-11-23",
			0.89
		],
		[
			"2010-03-18",
			1
		],
		[
			"2010-06-08",
			1
		],
		[
			"2010-09-29",
			1
		],
		[
			"2011-01-17",
			1
		],
		[
			"2011-03-03",
			1
		],
		[
			"2011-05-19",
			1
		],
		[
			"2011-08-16",
			1
		],
		[
			"2011-12-05",
			1
		],
		[
			"2012-03-08",
			1
		],
		[
			"2012-06-05",
			1
		],
		[
			"2012-09-28",
			1
		],
		[
			"2012-12-19",
			1
		],
		[
			"2013-03-18",
			1
		],
		[
			"2013-06-06",
			1
		],
		[
			"2013-10-24",
			1
		],
		[
			"2013-12-18",
			1
		]
	],
	"99580044": [
		[
			"2008-07-04",
			23.01
		],
		[
			"2009-01-09",
			22.01
		],
		[
			"2009-07-03",
			23.01
		],
		[
			"2010-01-22",
			22.01
		],
		[
			"2015-05-04",
			22.59
		],
		[
			"2000-08-28",
			27.01
		],
		[
			"2001-09-19",
			26.13
		],
		[
			"2002-01-03",
			25.01
		],
		[
			"2002-10-24",
			26.13
		],
		[
			"2003-11-26",
			25.69
		],
		[
			"2004-10-27",
			24.36
		],
		[
			"2005-01-28",
			24.01
		],
		[
			"2005-10-26",
			22.85
		],
		[
			"2005-11-18",
			22.01
		],
		[
			"2006-02-03",
			23.01
		],
		[
			"2006-07-21",
			24.01
		],
		[
			"2006-11-15",
			22.81
		],
		[
			"2007-01-04",
			22.01
		],
		[
			"2007-07-13",
			23.01
		],
		[
			"2008-01-18",
			22.01
		],
		[
			"2010-12-01",
			22.01
		],
		[
			"2010-07-23",
			23.01
		],
		[
			"2011-01-11",
			21.01
		],
		[
			"2011-08-09",
			23.01
		],
		[
			"2012-01-13",
			21.01
		],
		[
			"2012-07-27",
			23.01
		],
		[
			"2013-07-05",
			26.01
		],
		[
			"2014-07-23",
			22.01
		],
		[
			"2015-07-29",
			23.01
		],
		[
			"2006-12-12",
			22.32
		],
		[
			"2009-07-27",
			22.41
		],
		[
			"2010-07-19",
			21.74
		],
		[
			"2011-04-06",
			22.28
		]
	],
	"99580093": [
		[
			"2013-11-18",
			30.6
		],
		[
			"2015-02-27",
			29.72
		],
		[
			"2000-08-24",
			16.39
		],
		[
			"2001-09-25",
			23.03
		],
		[
			"2002-10-30",
			20.37
		],
		[
			"2003-12-03",
			17.71
		],
		[
			"2004-11-24",
			23.03
		],
		[
			"2005-10-11",
			15.63
		],
		[
			"2006-04-26",
			19.13
		],
		[
			"2006-11-22",
			21.7
		],
		[
			"2007-03-19",
			20.95
		],
		[
			"2009-07-30",
			23.6
		],
		[
			"2010-06-08",
			22.45
		],
		[
			"2011-11-16",
			27.59
		]
	],
	"99580111": [
		[
			"2014-10-01",
			9.92
		],
		[
			"2015-06-11",
			9.79
		],
		[
			"2000-08-24",
			5.76
		],
		[
			"2001-09-25",
			3.54
		],
		[
			"2002-10-23",
			4.43
		],
		[
			"2003-12-03",
			4.87
		],
		[
			"2005-12-13",
			5.31
		],
		[
			"2006-04-25",
			8.19
		],
		[
			"2006-11-22",
			8.9
		],
		[
			"2007-07-03",
			10.98
		],
		[
			"2009-07-29",
			22.85
		],
		[
			"2010-04-22",
			18.51
		],
		[
			"2011-11-30",
			12.71
		]
	],
	"99580123": [
		[
			"2014-05-13",
			17.14
		],
		[
			"2015-09-21",
			18.11
		],
		[
			"2000-08-31",
			15.94
		],
		[
			"2001-10-22",
			13.73
		],
		[
			"2002-10-23",
			14.61
		],
		[
			"2003-12-01",
			15.5
		],
		[
			"2005-01-11",
			14.17
		],
		[
			"2005-10-20",
			14.3
		],
		[
			"2006-04-27",
			15.5
		],
		[
			"2006-11-21",
			14.79
		],
		[
			"2007-07-03",
			15.99
		],
		[
			"2009-07-30",
			14.88
		],
		[
			"2010-04-22",
			16.52
		],
		[
			"2011-11-16",
			17.89
		]
	],
	"99580172": [
		[
			"2008-07-22",
			22.01
		],
		[
			"2009-04-09",
			22.01
		],
		[
			"2009-10-13",
			21.01
		],
		[
			"2015-09-24",
			20.24
		],
		[
			"2001-04-09",
			23.01
		],
		[
			"2002-04-11",
			22.01
		],
		[
			"2005-07-14",
			26.01
		],
		[
			"2006-07-19",
			21.01
		],
		[
			"2007-07-12",
			22.01
		],
		[
			"2010-04-13",
			22.01
		],
		[
			"2010-07-26",
			22.01
		],
		[
			"2011-04-12",
			22.01
		],
		[
			"2012-04-24",
			20.01
		],
		[
			"2008-09-10",
			21.79
		],
		[
			"2010-07-21",
			20.73
		],
		[
			"2009-10-20",
			20.5
		]
	],
	"99580184": [
		[
			"2014-12-01",
			8.19
		],
		[
			"2015-05-06",
			8.95
		],
		[
			"2001-09-18",
			6.2
		],
		[
			"2002-10-30",
			6.2
		],
		[
			"2003-12-04",
			8.41
		],
		[
			"2004-11-24",
			6.64
		],
		[
			"2006-04-26",
			8.02
		],
		[
			"2005-10-27",
			8.15
		],
		[
			"2002-04-09",
			8
		],
		[
			"2007-10-23",
			8.5
		],
		[
			"2008-07-10",
			8.46
		],
		[
			"2010-10-18",
			9.03
		],
		[
			"2011-11-21",
			7.66
		]
	],
	"99580202": [
		[
			"2014-10-01",
			5.49
		],
		[
			"2015-06-11",
			3.9
		],
		[
			"2015-09-30",
			3.32
		],
		[
			"2000-08-24",
			4.87
		],
		[
			"2003-03-26",
			3.1
		],
		[
			"2003-11-25",
			3.1
		],
		[
			"2005-03-17",
			3.59
		],
		[
			"2005-10-11",
			3.59
		],
		[
			"2006-04-25",
			4.43
		],
		[
			"2006-11-22",
			3.81
		],
		[
			"2007-03-19",
			3.81
		],
		[
			"2008-07-09",
			4.43
		],
		[
			"2009-07-29",
			3.94
		],
		[
			"2010-04-22",
			4.34
		],
		[
			"2011-11-30",
			2.75
		]
	],
	"99580251": [
		[
			"2014-12-01",
			7.48
		],
		[
			"2015-05-06",
			7.66
		],
		[
			"2000-08-24",
			4.43
		],
		[
			"2001-09-18",
			3.54
		],
		[
			"2002-10-30",
			3.54
		],
		[
			"2004-02-04",
			5.76
		],
		[
			"2004-11-24",
			5.76
		],
		[
			"2006-04-26",
			6.95
		],
		[
			"2008-12-16",
			9.52
		],
		[
			"2008-09-04",
			8.81
		],
		[
			"2005-10-27",
			5.14
		],
		[
			"2010-11-08",
			8.19
		]
	],
	"99780112": [
		[
			"2015-04-13",
			17.71
		],
		[
			"2000-10-12",
			1.33
		],
		[
			"2003-05-05",
			0.44
		],
		[
			"2004-01-12",
			0.44
		],
		[
			"2004-11-22",
			0.44
		],
		[
			"2005-11-24",
			0.44
		],
		[
			"2006-10-11",
			0.66
		],
		[
			"2007-06-28",
			0.66
		],
		[
			"2008-07-15",
			0.66
		],
		[
			"2009-03-11",
			4.92
		],
		[
			"2010-04-13",
			0.66
		],
		[
			"2011-09-07",
			0.66
		]
	],
	"100120015": [
		[
			"2013-05-02",
			19.93
		],
		[
			"2014-07-16",
			10.81
		],
		[
			"2015-10-22",
			18.11
		],
		[
			"2000-07-07",
			17.27
		],
		[
			"2002-11-21",
			16.3
		],
		[
			"2005-04-21",
			19.04
		],
		[
			"2006-10-11",
			20.37
		],
		[
			"2007-07-19",
			11.07
		],
		[
			"2009-10-21",
			15.94
		],
		[
			"2010-06-21",
			15.94
		],
		[
			"2008-06-12",
			11.51
		],
		[
			"2011-06-06",
			12.84
		],
		[
			"2012-08-11",
			16.39
		]
	],
	"100120180": [
		[
			"2013-05-02",
			2.21
		],
		[
			"2014-07-16",
			1.33
		],
		[
			"2015-09-23",
			3.63
		],
		[
			"2000-07-07",
			2.21
		],
		[
			"2002-11-21",
			2.21
		],
		[
			"2005-10-21",
			2.21
		],
		[
			"2005-04-21",
			2.21
		],
		[
			"2006-10-11",
			2.21
		],
		[
			"2007-07-19",
			2.21
		],
		[
			"2008-06-12",
			2.21
		],
		[
			"2009-10-21",
			2.21
		],
		[
			"2010-06-21",
			2.21
		],
		[
			"2011-06-08",
			2.21
		],
		[
			"2012-10-09",
			2.21
		]
	],
	"100120258": [
		[
			"2013-07-18",
			31.89
		],
		[
			"2014-08-20",
			27.46
		],
		[
			"2015-10-05",
			11.12
		],
		[
			"2005-06-27",
			11.07
		],
		[
			"2006-09-19",
			12.4
		],
		[
			"2007-07-04",
			13.73
		],
		[
			"2008-12-01",
			5.31
		],
		[
			"2009-10-27",
			17.71
		],
		[
			"2010-06-08",
			25.24
		],
		[
			"2011-09-06",
			16.83
		],
		[
			"2012-08-07",
			28.79
		]
	],
	"100135020": [
		[
			"2013-04-22",
			31
		],
		[
			"2014-02-11",
			27.9
		],
		[
			"2015-06-24",
			26.88
		],
		[
			"2016-03-23",
			25.69
		],
		[
			"2000-07-04",
			19.04
		],
		[
			"2000-10-12",
			46.5
		],
		[
			"2001-01-29",
			42.96
		],
		[
			"2001-04-18",
			41.81
		],
		[
			"2002-06-07",
			22.63
		],
		[
			"2002-11-07",
			17.71
		],
		[
			"2004-06-21",
			30.51
		],
		[
			"2005-06-28",
			23.91
		],
		[
			"2005-08-29",
			27.01
		],
		[
			"2006-10-06",
			27.01
		],
		[
			"2007-08-06",
			22.14
		],
		[
			"2008-06-19",
			27.9
		],
		[
			"2009-10-13",
			31
		],
		[
			"2010-06-02",
			29.67
		],
		[
			"2003-09-25",
			18.42
		],
		[
			"2011-09-01",
			25.24
		],
		[
			"2012-10-09",
			35.43
		]
	],
	"100135031": [
		[
			"2013-05-06",
			62.89
		],
		[
			"2014-04-23",
			68.64
		],
		[
			"2015-04-13",
			54.47
		],
		[
			"2000-01-12",
			94.33
		],
		[
			"2001-01-24",
			80.6
		],
		[
			"2002-05-17",
			65.1
		],
		[
			"2002-10-24",
			79.71
		],
		[
			"2005-06-28",
			84.14
		],
		[
			"2006-08-07",
			75.29
		],
		[
			"2006-09-06",
			75.29
		],
		[
			"2007-08-01",
			79.71
		],
		[
			"2009-09-24",
			62
		],
		[
			"2008-08-01",
			62
		],
		[
			"2010-09-29",
			79.71
		],
		[
			"2011-06-30",
			62
		],
		[
			"2012-07-17",
			62
		]
	],
	"100135067": [
		[
			"2013-04-30",
			11.51
		],
		[
			"2014-04-08",
			13.29
		],
		[
			"2015-04-08",
			12.31
		],
		[
			"2000-06-27",
			2.21
		],
		[
			"2002-10-24",
			20.73
		],
		[
			"2005-05-24",
			10.19
		],
		[
			"2006-07-28",
			14.17
		],
		[
			"2007-08-01",
			17.71
		],
		[
			"2008-07-10",
			25.24
		],
		[
			"2009-11-12",
			13.29
		],
		[
			"2010-08-25",
			16.83
		],
		[
			"2011-07-19",
			15.06
		],
		[
			"2012-07-03",
			15.5
		]
	],
	"100135158": [
		[
			"2013-04-30",
			2.21
		],
		[
			"2014-04-08",
			2.21
		],
		[
			"2015-04-08",
			1.33
		],
		[
			"2006-12-01",
			2.21
		],
		[
			"2007-08-08",
			2.21
		],
		[
			"2009-10-13",
			2.21
		],
		[
			"2010-10-12",
			2.21
		],
		[
			"2011-09-14",
			2.21
		],
		[
			"2012-10-15",
			2.21
		]
	],
	"100135213": [
		[
			"2013-04-30",
			67.76
		],
		[
			"2014-02-12",
			63.33
		],
		[
			"2015-04-08",
			69.53
		],
		[
			"2000-04-27",
			103.63
		],
		[
			"2000-10-12",
			115.14
		],
		[
			"2001-01-30",
			112.93
		],
		[
			"2001-04-18",
			98.31
		],
		[
			"2002-06-07",
			94.77
		],
		[
			"2002-10-01",
			102.3
		],
		[
			"2002-10-24",
			100.09
		],
		[
			"2004-06-24",
			70.86
		],
		[
			"2005-05-24",
			75.29
		],
		[
			"2005-08-29",
			75.29
		],
		[
			"2006-09-06",
			75.29
		],
		[
			"2007-08-07",
			70.86
		],
		[
			"2009-09-03",
			84.14
		],
		[
			"2003-09-25",
			93
		],
		[
			"2008-07-24",
			75.29
		],
		[
			"2010-05-05",
			66.43
		],
		[
			"2011-09-01",
			84.14
		],
		[
			"2012-05-31",
			79.71
		]
	],
	"100135468": [
		[
			"2013-07-11",
			35.43
		],
		[
			"2014-07-14",
			33.88
		],
		[
			"2015-03-31",
			31.97
		],
		[
			"2003-03-05",
			32.15
		],
		[
			"2005-06-22",
			24.8
		],
		[
			"2006-10-10",
			34.54
		],
		[
			"2007-07-09",
			30.11
		],
		[
			"2009-11-18",
			36.31
		],
		[
			"2008-04-21",
			27.46
		],
		[
			"2010-11-15",
			48.71
		],
		[
			"2011-11-10",
			42.07
		],
		[
			"2012-10-18",
			35.43
		]
	],
	"100135559": [
		[
			"2010-04-02",
			2
		],
		[
			"2010-08-22",
			2
		],
		[
			"2013-05-06",
			2.21
		],
		[
			"2014-02-12",
			2.21
		],
		[
			"2015-04-09",
			1.33
		],
		[
			"2000-06-27",
			41.19
		],
		[
			"2001-01-30",
			46.5
		],
		[
			"2002-11-07",
			2.21
		],
		[
			"2003-08-31",
			21.71
		],
		[
			"2003-03-16",
			2
		],
		[
			"2002-08-12",
			39.71
		],
		[
			"2004-08-22",
			19.41
		],
		[
			"2005-08-30",
			2.21
		],
		[
			"2006-08-06",
			2
		],
		[
			"2006-03-28",
			2
		],
		[
			"2006-09-01",
			2.21
		],
		[
			"2007-03-11",
			2
		],
		[
			"2007-08-05",
			5.76
		],
		[
			"2007-07-25",
			3.14
		],
		[
			"2008-03-29",
			6.7
		],
		[
			"2008-06-26",
			12.84
		],
		[
			"2008-08-19",
			3.5
		],
		[
			"2009-03-29",
			2
		],
		[
			"2009-08-23",
			2
		],
		[
			"2005-03-23",
			2
		],
		[
			"2013-04-09",
			2.21
		],
		[
			"2013-08-22",
			1.99
		],
		[
			"2009-09-02",
			4.43
		],
		[
			"2010-10-12",
			2.21
		],
		[
			"2011-06-30",
			2.21
		],
		[
			"2012-07-11",
			2.21
		]
	],
	"100135560": [
		[
			"2013-04-30",
			19.93
		],
		[
			"2014-04-23",
			17.27
		],
		[
			"2015-04-08",
			19.71
		],
		[
			"2002-12-05",
			17.85
		],
		[
			"2005-05-17",
			20.37
		],
		[
			"2006-09-06",
			22.14
		],
		[
			"2007-08-07",
			18.6
		],
		[
			"2008-07-10",
			25.24
		],
		[
			"2009-09-02",
			21.26
		],
		[
			"2010-05-05",
			23.47
		],
		[
			"2011-04-11",
			27.46
		],
		[
			"2012-07-03",
			19.93
		]
	],
	"100135596": [
		[
			"2013-04-25",
			34.54
		],
		[
			"2014-04-08",
			38.09
		],
		[
			"2015-04-09",
			17.4
		],
		[
			"2000-04-27",
			132.86
		],
		[
			"2002-12-05",
			177.14
		],
		[
			"2005-05-24",
			212.57
		],
		[
			"2006-07-26",
			141.71
		],
		[
			"2007-07-25",
			48.71
		],
		[
			"2009-09-02",
			15.5
		],
		[
			"2008-07-24",
			84.14
		],
		[
			"2010-08-25",
			62
		],
		[
			"2011-09-01",
			48.71
		],
		[
			"2012-07-11",
			79.71
		]
	],
	"100135602": [
		[
			"2013-05-06",
			2.21
		],
		[
			"2014-04-08",
			5.31
		],
		[
			"2015-04-09",
			4.61
		],
		[
			"2000-06-27",
			16.39
		],
		[
			"2002-12-05",
			7.31
		],
		[
			"2005-04-28",
			8.41
		],
		[
			"2006-07-26",
			3.54
		],
		[
			"2007-07-26",
			7.09
		],
		[
			"2008-07-10",
			3.85
		],
		[
			"2009-09-02",
			12.84
		],
		[
			"2012-08-09",
			4.07
		]
	],
	"100135614": [
		[
			"2013-09-12",
			44.29
		],
		[
			"2014-08-28",
			45.17
		],
		[
			"2015-04-23",
			50.04
		],
		[
			"2003-03-04",
			55.8
		],
		[
			"2005-06-21",
			48.71
		],
		[
			"2006-10-16",
			53.14
		],
		[
			"2007-06-12",
			53.14
		],
		[
			"2009-11-18",
			43.84
		],
		[
			"2008-06-03",
			42.96
		],
		[
			"2010-11-02",
			48.71
		],
		[
			"2012-07-02",
			53.14
		]
	],
	"100135626": [
		[
			"2013-04-25",
			135.07
		],
		[
			"2014-02-12",
			39.86
		],
		[
			"2015-04-09",
			108.5
		],
		[
			"2000-04-27",
			39.86
		],
		[
			"2005-05-24",
			21.26
		],
		[
			"2006-09-06",
			11.96
		],
		[
			"2007-08-06",
			6.2
		],
		[
			"2008-07-03",
			31.44
		],
		[
			"2009-09-24",
			14.17
		],
		[
			"2010-09-30",
			14.61
		],
		[
			"2011-08-25",
			15.94
		],
		[
			"2012-08-09",
			11.51
		]
	],
	"100135640": [
		[
			"2013-04-25",
			2.21
		],
		[
			"2014-04-16",
			2.21
		],
		[
			"2015-04-16",
			1.33
		],
		[
			"2006-08-01",
			2.21
		],
		[
			"2005-05-24",
			2.21
		],
		[
			"2005-11-24",
			2.21
		],
		[
			"2007-08-06",
			2.21
		],
		[
			"2009-09-24",
			2.21
		],
		[
			"2008-07-24",
			2.21
		],
		[
			"2010-09-30",
			2.21
		],
		[
			"2011-04-11",
			2.21
		],
		[
			"2012-09-13",
			2.21
		]
	],
	"100135651": [
		[
			"2013-04-25",
			313.54
		],
		[
			"2014-04-16",
			301.14
		],
		[
			"2015-04-16",
			281.21
		],
		[
			"2005-05-24",
			159.43
		],
		[
			"2006-10-06",
			190.43
		],
		[
			"2007-08-06",
			398.57
		],
		[
			"2009-09-03",
			261.29
		],
		[
			"2008-07-24",
			487.14
		],
		[
			"2010-08-25",
			261.29
		],
		[
			"2011-04-11",
			225.86
		],
		[
			"2012-09-13",
			256.86
		]
	],
	"100140014": [
		[
			"2013-04-24",
			34.54
		],
		[
			"2014-10-23",
			32.86
		],
		[
			"2015-09-17",
			32.2
		],
		[
			"2000-06-26",
			53.14
		],
		[
			"2001-01-29",
			47.83
		],
		[
			"2002-11-07",
			48.27
		],
		[
			"2005-05-24",
			44.29
		],
		[
			"2006-10-06",
			40.74
		],
		[
			"2007-11-14",
			42.96
		],
		[
			"2009-11-11",
			41.19
		],
		[
			"2008-07-25",
			41.63
		],
		[
			"2010-09-30",
			37.2
		],
		[
			"2011-08-25",
			33.66
		],
		[
			"2012-08-09",
			34.99
		]
	],
	"100140087": [
		[
			"2013-05-13",
			72.19
		],
		[
			"2014-04-01",
			81.49
		],
		[
			"2015-03-17",
			84.14
		],
		[
			"2000-05-03",
			93
		],
		[
			"2001-02-13",
			69.97
		],
		[
			"2002-11-14",
			70.86
		],
		[
			"2005-06-01",
			62
		],
		[
			"2006-10-06",
			66.43
		],
		[
			"2008-07-02",
			62
		],
		[
			"2009-09-23",
			66.43
		],
		[
			"2010-06-10",
			66.43
		],
		[
			"2011-09-20",
			75.29
		],
		[
			"2012-10-11",
			79.71
		]
	],
	"100140312": [
		[
			"2013-05-13",
			2.21
		],
		[
			"2014-02-18",
			2.21
		],
		[
			"2015-03-26",
			1.33
		],
		[
			"2000-07-05",
			2.21
		],
		[
			"2001-02-13",
			2.21
		],
		[
			"2002-11-14",
			2.21
		],
		[
			"2005-06-01",
			2.21
		],
		[
			"2006-09-01",
			2.21
		],
		[
			"2007-10-01",
			2.21
		],
		[
			"2008-07-02",
			2.21
		],
		[
			"2009-10-06",
			2.21
		],
		[
			"2010-06-10",
			2.21
		],
		[
			"2011-07-13",
			2.21
		],
		[
			"2012-10-11",
			2.21
		]
	],
	"100140324": [
		[
			"2013-05-22",
			14.17
		],
		[
			"2014-02-18",
			11.51
		],
		[
			"2015-06-02",
			15.15
		],
		[
			"2000-07-04",
			40.74
		],
		[
			"2000-10-13",
			53.14
		],
		[
			"2001-01-31",
			22.14
		],
		[
			"2001-04-19",
			23.43
		],
		[
			"2002-10-10",
			124.89
		],
		[
			"2002-11-14",
			111.6
		],
		[
			"2004-06-24",
			20.15
		],
		[
			"2005-05-19",
			15.94
		],
		[
			"2005-09-02",
			26.13
		],
		[
			"2006-09-01",
			84.14
		],
		[
			"2007-10-15",
			6.64
		],
		[
			"2008-06-26",
			62
		],
		[
			"2009-09-11",
			48.71
		],
		[
			"2003-09-25",
			113.81
		],
		[
			"2010-10-07",
			35.87
		],
		[
			"2011-07-13",
			28.34
		],
		[
			"2012-05-31",
			9.74
		]
	],
	"100140350": [
		[
			"2013-04-23",
			17.71
		],
		[
			"2014-04-16",
			36.31
		],
		[
			"2015-03-17",
			8.9
		],
		[
			"2000-05-03",
			2.21
		],
		[
			"2001-01-31",
			2.21
		],
		[
			"2002-11-14",
			2.21
		],
		[
			"2005-06-01",
			11.51
		],
		[
			"2006-07-28",
			2.21
		],
		[
			"2007-10-01",
			2.21
		],
		[
			"2008-07-02",
			2.21
		],
		[
			"2009-09-24",
			2.21
		],
		[
			"2010-06-10",
			2.21
		],
		[
			"2011-09-20",
			2.21
		],
		[
			"2012-09-19",
			2.21
		]
	],
	"100140683": [
		[
			"2013-05-14",
			152.79
		],
		[
			"2014-02-18",
			113.81
		],
		[
			"2015-05-21",
			84.59
		],
		[
			"2000-07-05",
			66.43
		],
		[
			"2000-10-13",
			79.71
		],
		[
			"2001-02-14",
			154.11
		],
		[
			"2001-04-19",
			140.39
		],
		[
			"2002-10-10",
			88.57
		],
		[
			"2002-11-14",
			119.57
		],
		[
			"2004-06-22",
			149.69
		],
		[
			"2007-10-17",
			88.57
		],
		[
			"2008-07-17",
			239.14
		],
		[
			"2009-08-27",
			124
		],
		[
			"2003-09-24",
			67.76
		],
		[
			"2010-09-01",
			199.29
		],
		[
			"2011-07-06",
			119.57
		],
		[
			"2012-08-13",
			79.71
		]
	],
	"100140749": [
		[
			"2013-04-24",
			137.29
		],
		[
			"2014-03-25",
			145.26
		],
		[
			"2015-04-16",
			144.37
		],
		[
			"2000-06-26",
			185.11
		],
		[
			"2000-10-13",
			168.29
		],
		[
			"2001-01-30",
			173.6
		],
		[
			"2001-04-19",
			180.69
		],
		[
			"2002-11-07",
			154.56
		],
		[
			"2004-06-24",
			136.4
		],
		[
			"2005-06-01",
			146.14
		],
		[
			"2005-09-02",
			137.29
		],
		[
			"2006-10-06",
			150.57
		],
		[
			"2007-07-26",
			141.71
		],
		[
			"2008-07-02",
			137.29
		],
		[
			"2009-09-23",
			128.43
		],
		[
			"2003-09-25",
			137.29
		],
		[
			"2010-09-08",
			132.86
		],
		[
			"2011-09-14",
			124
		],
		[
			"2012-09-19",
			124
		]
	],
	"100140750": [
		[
			"2013-05-06",
			2.21
		],
		[
			"2014-03-25",
			2.21
		],
		[
			"2015-04-16",
			1.33
		],
		[
			"2000-05-03",
			2.21
		],
		[
			"2001-01-30",
			2.21
		],
		[
			"2002-11-07",
			2.21
		],
		[
			"2005-06-28",
			2.21
		],
		[
			"2006-09-06",
			2.21
		],
		[
			"2007-07-26",
			2.21
		],
		[
			"2008-07-03",
			2.21
		],
		[
			"2009-09-03",
			4.12
		],
		[
			"2010-08-25",
			2.21
		],
		[
			"2011-09-14",
			2.21
		],
		[
			"2012-10-15",
			2.21
		]
	],
	"100140762": [
		[
			"2013-05-13",
			22.59
		],
		[
			"2014-03-25",
			30.11
		],
		[
			"2015-04-16",
			34.41
		],
		[
			"2007-11-14",
			7.97
		],
		[
			"2008-07-03",
			15.94
		],
		[
			"2009-11-12",
			8.86
		],
		[
			"2010-09-08",
			11.96
		],
		[
			"2011-07-21",
			8.86
		],
		[
			"2012-05-31",
			14.61
		]
	],
	"100140774": [
		[
			"2013-05-13",
			3.81
		],
		[
			"2014-02-12",
			2.21
		],
		[
			"2015-04-16",
			3.28
		],
		[
			"2000-05-03",
			3.32
		],
		[
			"2005-06-28",
			2.3
		],
		[
			"2006-07-26",
			2.21
		],
		[
			"2007-07-26",
			2.21
		],
		[
			"2008-07-03",
			2.21
		],
		[
			"2009-09-03",
			2.21
		],
		[
			"2010-09-29",
			2.21
		],
		[
			"2011-08-25",
			2.21
		],
		[
			"2012-10-15",
			3.94
		]
	],
	"100140865": [
		[
			"2013-04-23",
			2.21
		],
		[
			"2014-02-11",
			2.21
		],
		[
			"2015-07-01",
			1.33
		],
		[
			"2000-06-26",
			2.21
		],
		[
			"2001-01-31",
			2.21
		],
		[
			"2002-11-07",
			2.21
		],
		[
			"2005-05-19",
			2.21
		],
		[
			"2006-10-06",
			2.21
		],
		[
			"2007-08-08",
			2.21
		],
		[
			"2009-09-23",
			2.21
		],
		[
			"2010-09-08",
			2.21
		],
		[
			"2011-07-19",
			2.21
		],
		[
			"2012-07-17",
			2.21
		]
	],
	"100140920": [
		[
			"2013-04-23",
			2.21
		],
		[
			"2014-04-01",
			3.19
		],
		[
			"2015-06-24",
			5.27
		],
		[
			"2016-03-23",
			1.42
		],
		[
			"2005-05-19",
			2.21
		],
		[
			"2006-12-01",
			2.21
		],
		[
			"2007-10-15",
			2.21
		],
		[
			"2008-07-17",
			2.21
		],
		[
			"2009-09-23",
			2.21
		],
		[
			"2010-09-08",
			2.21
		],
		[
			"2011-07-19",
			2.21
		],
		[
			"2012-07-11",
			2.21
		]
	],
	"100141328": [
		[
			"2013-05-14",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-21",
			1.33
		],
		[
			"2000-07-06",
			2.21
		],
		[
			"2005-05-12",
			2.21
		],
		[
			"2006-09-01",
			2.21
		],
		[
			"2007-05-11",
			2.21
		],
		[
			"2009-09-11",
			2.21
		],
		[
			"2008-07-25",
			2.21
		],
		[
			"2010-09-01",
			2.21
		],
		[
			"2011-06-09",
			2.21
		],
		[
			"2012-09-14",
			2.21
		]
	],
	"100141365": [
		[
			"2013-05-22",
			2.21
		],
		[
			"2014-04-01",
			2.21
		],
		[
			"2015-06-02",
			1.33
		],
		[
			"2000-07-04",
			2.21
		],
		[
			"2005-05-19",
			2.21
		],
		[
			"2006-09-01",
			5.76
		],
		[
			"2007-11-14",
			2.21
		],
		[
			"2008-06-26",
			3.68
		],
		[
			"2009-10-06",
			2.21
		],
		[
			"2010-09-23",
			2.21
		],
		[
			"2011-07-13",
			2.21
		],
		[
			"2012-10-11",
			2.21
		]
	],
	"100141377": [
		[
			"2013-05-21",
			2.21
		],
		[
			"2014-04-01",
			2.21
		],
		[
			"2015-06-02",
			1.33
		],
		[
			"2000-07-04",
			2.21
		],
		[
			"2005-05-12",
			4.07
		],
		[
			"2006-09-01",
			2.21
		],
		[
			"2007-05-11",
			2.21
		],
		[
			"2008-06-26",
			2.21
		],
		[
			"2009-10-06",
			2.21
		],
		[
			"2010-09-23",
			2.21
		],
		[
			"2011-07-13",
			2.21
		],
		[
			"2012-10-11",
			2.21
		]
	],
	"100141389": [
		[
			"2013-04-24",
			30.11
		],
		[
			"2014-02-11",
			26.57
		],
		[
			"2015-09-17",
			30.82
		],
		[
			"2006-12-01",
			38.53
		],
		[
			"2007-08-08",
			36.76
		],
		[
			"2009-09-23",
			38.53
		],
		[
			"2008-07-25",
			29.67
		],
		[
			"2010-09-30",
			37.2
		],
		[
			"2011-07-21",
			27.46
		],
		[
			"2012-07-03",
			32.77
		]
	],
	"100150020": [
		[
			"2013-05-14",
			2.21
		],
		[
			"2014-03-26",
			2.21
		],
		[
			"2015-05-19",
			1.33
		],
		[
			"2000-10-13",
			2.21
		],
		[
			"2001-02-14",
			2.21
		],
		[
			"2001-04-19",
			3.9
		],
		[
			"2002-10-10",
			2.21
		],
		[
			"2002-11-08",
			2.21
		],
		[
			"2004-06-22",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2005-08-29",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-05-11",
			2.21
		],
		[
			"2008-07-17",
			2.21
		],
		[
			"2009-08-27",
			2.66
		],
		[
			"2003-09-24",
			2.21
		],
		[
			"2010-09-01",
			2.21
		],
		[
			"2011-07-06",
			2.21
		],
		[
			"2012-08-13",
			2.21
		]
	],
	"100150032": [
		[
			"2013-05-15",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-12",
			1.33
		],
		[
			"2001-02-22",
			2.21
		],
		[
			"2002-11-08",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-10-15",
			2.83
		],
		[
			"2008-06-13",
			4.43
		],
		[
			"2009-11-10",
			2.21
		],
		[
			"2006-08-08",
			2.21
		],
		[
			"2010-10-07",
			2.21
		],
		[
			"2011-06-09",
			2.21
		],
		[
			"2012-07-04",
			2.21
		]
	],
	"100150287": [
		[
			"2013-05-21",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-12",
			2.21
		],
		[
			"2000-07-06",
			2.21
		],
		[
			"2001-02-14",
			2.21
		],
		[
			"2002-11-08",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-02",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-05-10",
			2.21
		],
		[
			"2008-06-20",
			2.21
		],
		[
			"2009-08-27",
			2.21
		],
		[
			"2010-07-07",
			2.21
		],
		[
			"2011-06-09",
			2.21
		],
		[
			"2012-05-29",
			2.21
		]
	],
	"100150329": [
		[
			"2013-05-15",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-12",
			1.33
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-02",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-05-10",
			2.21
		],
		[
			"2009-09-11",
			48.71
		],
		[
			"2008-06-13",
			2.21
		],
		[
			"2010-07-07",
			2.21
		],
		[
			"2011-09-22",
			2.21
		],
		[
			"2012-05-29",
			2.21
		]
	],
	"100150640": [
		[
			"2013-05-21",
			2.21
		],
		[
			"2014-03-26",
			2.21
		],
		[
			"2015-05-19",
			1.33
		],
		[
			"2000-07-05",
			2.21
		],
		[
			"2002-11-14",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-02",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-05-10",
			2.21
		],
		[
			"2008-06-20",
			2.21
		],
		[
			"2009-11-10",
			2.21
		],
		[
			"2010-07-07",
			2.21
		],
		[
			"2011-07-06",
			2.21
		],
		[
			"2012-09-14",
			2.21
		]
	],
	"100151085": [
		[
			"2013-05-21",
			2.21
		],
		[
			"2014-03-26",
			2.21
		],
		[
			"2015-07-01",
			1.33
		],
		[
			"2000-07-05",
			2.52
		],
		[
			"2001-04-04",
			2.21
		],
		[
			"2002-11-08",
			2.21
		],
		[
			"2005-05-19",
			2.21
		],
		[
			"2006-09-01",
			2.21
		],
		[
			"2007-05-11",
			2.21
		],
		[
			"2008-06-20",
			4.87
		],
		[
			"2009-11-11",
			2.21
		],
		[
			"2010-09-23",
			5.76
		],
		[
			"2011-09-22",
			7.97
		],
		[
			"2012-07-04",
			10.19
		],
		[
			"2012-09-14",
			7.53
		]
	],
	"100151140": [
		[
			"2013-05-14",
			3.5
		],
		[
			"2014-03-26",
			6.64
		],
		[
			"2015-05-21",
			3.63
		],
		[
			"2008-06-20",
			2.21
		],
		[
			"2009-10-06",
			2.21
		],
		[
			"2010-09-23",
			9.3
		],
		[
			"2011-07-06",
			2.21
		],
		[
			"2012-08-13",
			2.21
		]
	],
	"100160025": [
		[
			"2013-06-26",
			18.6
		],
		[
			"2014-05-06",
			14.17
		],
		[
			"2015-06-30",
			31.18
		],
		[
			"2005-05-12",
			29.67
		],
		[
			"2006-10-12",
			24.36
		],
		[
			"2007-07-27",
			11.96
		],
		[
			"2008-06-19",
			20.37
		],
		[
			"2009-10-22",
			23.03
		],
		[
			"2010-06-09",
			27.46
		],
		[
			"2011-07-07",
			27.9
		],
		[
			"2012-08-03",
			23.91
		]
	],
	"100700238": [
		[
			"2000-04-12",
			40.81
		],
		[
			"2000-10-17",
			48.82
		],
		[
			"2001-04-24",
			51.02
		],
		[
			"2001-10-10",
			57.02
		],
		[
			"2002-04-03",
			62.02
		],
		[
			"2002-11-12",
			57.02
		],
		[
			"2003-04-15",
			46.02
		],
		[
			"2004-04-21",
			45.02
		],
		[
			"2003-11-19",
			42.01
		],
		[
			"2004-10-21",
			46.02
		],
		[
			"2005-04-20",
			48.02
		],
		[
			"2005-10-19",
			39.01
		],
		[
			"2006-04-26",
			45.02
		],
		[
			"2007-04-18",
			47.02
		],
		[
			"2007-10-17",
			49.02
		],
		[
			"2008-04-17",
			49.02
		],
		[
			"2008-10-15",
			48.02
		],
		[
			"2006-11-03",
			45.02
		],
		[
			"2009-04-16",
			45.02
		],
		[
			"2009-10-21",
			45.02
		],
		[
			"2010-04-22",
			47.02
		],
		[
			"2010-10-21",
			46.02
		],
		[
			"2012-10-25",
			44.02
		],
		[
			"2012-04-18",
			48.02
		],
		[
			"2013-10-16",
			44.02
		],
		[
			"2013-04-17",
			39.01
		],
		[
			"2014-10-07",
			44.02
		],
		[
			"2014-04-16",
			40.01
		],
		[
			"2015-10-22",
			47.02
		],
		[
			"2015-04-21",
			51.02
		]
	],
	"100700512": [
		[
			"2000-03-16",
			77.03
		],
		[
			"2000-11-08",
			74.03
		],
		[
			"2001-04-09",
			70.02
		],
		[
			"2001-10-17",
			73.03
		],
		[
			"2002-10-14",
			68.02
		],
		[
			"2002-05-08",
			65.02
		],
		[
			"2003-04-14",
			69.02
		],
		[
			"2003-11-06",
			60.02
		],
		[
			"2004-04-02",
			81.03
		],
		[
			"2004-10-04",
			52.02
		],
		[
			"2005-04-18",
			55.02
		],
		[
			"2005-10-18",
			72.03
		],
		[
			"2006-04-10",
			73.03
		],
		[
			"2006-11-20",
			66.02
		],
		[
			"2007-04-16",
			72.03
		],
		[
			"2008-04-15",
			67.02
		],
		[
			"2008-10-27",
			74.03
		],
		[
			"2009-04-15",
			73.03
		],
		[
			"2009-10-12",
			6
		],
		[
			"2010-04-26",
			68.02
		],
		[
			"2010-10-11",
			64.02
		],
		[
			"2012-10-30",
			70.02
		],
		[
			"2012-04-16",
			76.03
		],
		[
			"2013-09-30",
			68.02
		],
		[
			"2013-04-15",
			69.02
		],
		[
			"2014-09-29",
			68.02
		],
		[
			"2014-04-14",
			72.03
		],
		[
			"2015-10-19",
			68.02
		],
		[
			"2015-05-26",
			70.02
		]
	],
	"100700550": [
		[
			"2000-03-16",
			12
		],
		[
			"2000-11-08",
			14
		],
		[
			"2001-04-09",
			13
		],
		[
			"2001-10-17",
			13
		],
		[
			"2002-10-14",
			6
		],
		[
			"2002-05-08",
			2
		],
		[
			"2003-04-14",
			9
		],
		[
			"2003-11-06",
			12
		],
		[
			"2004-04-02",
			22.01
		],
		[
			"2004-10-04",
			10
		],
		[
			"2005-04-18",
			6
		],
		[
			"2005-10-18",
			13
		],
		[
			"2006-04-10",
			1
		],
		[
			"2006-11-20",
			1
		],
		[
			"2007-10-15",
			10
		],
		[
			"2008-04-15",
			13
		],
		[
			"2008-10-27",
			18.01
		],
		[
			"2009-04-15",
			18.01
		],
		[
			"2009-10-12",
			18.01
		],
		[
			"2010-04-26",
			10
		],
		[
			"2010-10-11",
			14
		],
		[
			"2012-10-30",
			17.01
		],
		[
			"2012-04-16",
			17.01
		],
		[
			"2013-09-30",
			13
		],
		[
			"2013-04-15",
			16.01
		],
		[
			"2014-09-29",
			18.01
		],
		[
			"2014-04-14",
			17.01
		],
		[
			"2015-10-19",
			16.01
		],
		[
			"2015-05-26",
			14
		]
	],
	"100701255": [
		[
			"2000-03-13",
			9
		],
		[
			"2000-10-02",
			7
		],
		[
			"2001-03-05",
			4
		],
		[
			"2001-09-10",
			7
		],
		[
			"2002-03-11",
			3
		],
		[
			"2006-03-20",
			2
		],
		[
			"2002-09-16",
			2
		],
		[
			"2006-09-07",
			5
		],
		[
			"2005-09-12",
			6
		],
		[
			"2005-03-29",
			4
		],
		[
			"2003-09-08",
			6
		],
		[
			"2004-09-13",
			4
		],
		[
			"2004-03-15",
			6.2
		],
		[
			"2003-03-17",
			11
		],
		[
			"2007-03-12",
			2
		],
		[
			"2007-09-24",
			4
		],
		[
			"2008-03-31",
			7
		],
		[
			"2008-09-08",
			5
		],
		[
			"2009-03-09",
			3
		],
		[
			"2009-09-14",
			5
		],
		[
			"2010-03-22",
			1
		],
		[
			"2010-09-20",
			1
		],
		[
			"2012-09-10",
			2
		],
		[
			"2012-03-12",
			2
		],
		[
			"2013-09-09",
			1
		],
		[
			"2013-04-08",
			1
		],
		[
			"2014-09-15",
			2
		],
		[
			"2014-03-31",
			2
		],
		[
			"2015-09-28",
			1
		],
		[
			"2015-03-02",
			2
		]
	],
	"100701541": [
		[
			"2000-04-12",
			1
		],
		[
			"2000-10-18",
			1
		],
		[
			"2001-04-26",
			0.5
		],
		[
			"2001-11-06",
			1.4
		],
		[
			"2002-04-03",
			0.5
		],
		[
			"2002-11-12",
			0.5
		],
		[
			"2007-04-18",
			1
		],
		[
			"2007-10-17",
			1
		],
		[
			"2008-10-15",
			1
		],
		[
			"2006-04-26",
			1
		],
		[
			"2006-11-03",
			1
		],
		[
			"2009-10-21",
			1
		],
		[
			"2010-04-22",
			1
		],
		[
			"2010-10-21",
			1
		],
		[
			"2012-10-25",
			1
		],
		[
			"2012-04-18",
			1
		],
		[
			"2013-10-16",
			1
		],
		[
			"2013-04-17",
			1
		],
		[
			"2014-10-07",
			1
		],
		[
			"2014-04-16",
			1
		],
		[
			"2015-10-22",
			1
		],
		[
			"2015-06-17",
			1
		]
	],
	"100702119": [
		[
			"2000-04-07",
			36.01
		],
		[
			"2000-09-06",
			35.01
		],
		[
			"2001-03-02",
			35.01
		],
		[
			"2001-09-06",
			39.01
		],
		[
			"2002-10-02",
			37.01
		],
		[
			"2003-03-12",
			36.01
		],
		[
			"2003-09-11",
			39.01
		],
		[
			"2004-03-16",
			32.01
		],
		[
			"2004-09-07",
			32.01
		],
		[
			"2005-03-22",
			34.01
		],
		[
			"2005-09-02",
			31.01
		],
		[
			"2006-03-22",
			31.01
		],
		[
			"2006-09-06",
			31.01
		],
		[
			"2007-03-26",
			29.01
		],
		[
			"2007-10-08",
			31.01
		],
		[
			"2008-04-22",
			32.01
		],
		[
			"2008-10-08",
			29.01
		],
		[
			"2009-04-29",
			29.01
		],
		[
			"2009-10-20",
			30.01
		],
		[
			"2010-05-19",
			30.01
		],
		[
			"2012-05-23",
			29.01
		],
		[
			"2013-11-12",
			28.01
		],
		[
			"2013-05-22",
			29.01
		],
		[
			"2015-05-11",
			31.01
		]
	],
	"100702533": [
		[
			"2000-04-14",
			5
		],
		[
			"2000-10-12",
			5
		],
		[
			"2001-04-11",
			12
		],
		[
			"2001-10-11",
			3
		],
		[
			"2002-04-04",
			7
		],
		[
			"2004-05-27",
			3.4
		],
		[
			"2005-05-25",
			8
		],
		[
			"2004-11-03",
			1
		],
		[
			"2003-10-29",
			7
		],
		[
			"2003-04-10",
			5
		],
		[
			"2002-10-17",
			1
		],
		[
			"2005-11-10",
			2
		],
		[
			"2007-05-31",
			1
		],
		[
			"2009-10-13",
			5
		],
		[
			"2014-10-09",
			3
		],
		[
			"2014-06-18",
			1
		],
		[
			"2015-10-08",
			4
		]
	],
	"100703331": [
		[
			"2000-04-06",
			11
		],
		[
			"2002-04-11",
			11
		],
		[
			"2004-09-30",
			12
		],
		[
			"2004-09-30",
			12
		],
		[
			"2007-11-08",
			15.01
		],
		[
			"2008-04-10",
			15.01
		],
		[
			"2006-04-25",
			15.01
		],
		[
			"2009-11-12",
			14
		],
		[
			"2010-04-27",
			15.01
		],
		[
			"2012-05-03",
			11
		],
		[
			"2013-11-21",
			10
		],
		[
			"2014-05-13",
			13
		],
		[
			"2015-10-27",
			12
		]
	],
	"100705121": [
		[
			"2000-03-02",
			1
		],
		[
			"2000-10-27",
			1
		],
		[
			"2001-04-05",
			1
		],
		[
			"2001-10-30",
			1
		],
		[
			"2002-10-23",
			1
		],
		[
			"2005-10-06",
			1
		],
		[
			"2005-05-04",
			1
		],
		[
			"2006-04-05",
			1
		],
		[
			"2003-11-10",
			1
		],
		[
			"2003-04-29",
			1
		],
		[
			"2004-10-28",
			1
		],
		[
			"2004-05-28",
			1
		],
		[
			"2002-04-04",
			1
		],
		[
			"2006-10-06",
			1
		],
		[
			"2007-04-17",
			1
		],
		[
			"2007-10-25",
			1
		],
		[
			"2008-04-22",
			1
		],
		[
			"2008-10-06",
			1
		],
		[
			"2009-04-27",
			1
		],
		[
			"2009-10-19",
			1
		],
		[
			"2010-04-15",
			1
		],
		[
			"2010-10-27",
			1
		],
		[
			"2012-10-17",
			1
		],
		[
			"2012-04-30",
			1
		],
		[
			"2013-09-25",
			1
		],
		[
			"2013-04-09",
			1
		],
		[
			"2014-10-29",
			1
		],
		[
			"2014-05-05",
			1
		],
		[
			"2015-10-13",
			1
		],
		[
			"2015-04-15",
			2
		]
	],
	"100705170": [
		[
			"2000-03-02",
			1
		],
		[
			"2000-10-27",
			1
		],
		[
			"2001-04-05",
			1
		],
		[
			"2001-10-30",
			1
		],
		[
			"2002-10-23",
			1
		],
		[
			"2005-10-06",
			1
		],
		[
			"2006-04-05",
			1
		],
		[
			"2003-11-10",
			1
		],
		[
			"2003-04-29",
			1
		],
		[
			"2004-10-28",
			1
		],
		[
			"2004-05-28",
			1
		],
		[
			"2005-05-04",
			1
		],
		[
			"2002-04-04",
			1
		],
		[
			"2006-10-06",
			1
		],
		[
			"2007-04-17",
			1
		],
		[
			"2007-10-25",
			1
		],
		[
			"2008-04-22",
			1
		],
		[
			"2008-10-06",
			1
		],
		[
			"2009-04-27",
			1
		],
		[
			"2009-10-19",
			1
		],
		[
			"2010-04-15",
			1
		],
		[
			"2010-10-27",
			1
		],
		[
			"2012-10-17",
			1
		],
		[
			"2012-04-30",
			1
		],
		[
			"2013-09-25",
			1
		],
		[
			"2013-04-09",
			1
		],
		[
			"2014-10-29",
			1
		],
		[
			"2014-05-05",
			1
		],
		[
			"2015-10-13",
			1
		],
		[
			"2015-04-15",
			1
		]
	],
	"100706617": [
		[
			"2000-03-29",
			1
		],
		[
			"2000-10-31",
			1
		],
		[
			"2001-04-23",
			1
		],
		[
			"2001-10-23",
			1
		],
		[
			"2002-10-15",
			1
		],
		[
			"2003-11-20",
			1
		],
		[
			"2005-05-12",
			1
		],
		[
			"2005-11-23",
			1
		],
		[
			"2006-05-18",
			1
		],
		[
			"2007-05-03",
			1
		],
		[
			"2007-11-07",
			1
		],
		[
			"2008-04-29",
			2
		],
		[
			"2008-10-16",
			1
		],
		[
			"2009-05-07",
			1
		],
		[
			"2009-10-22",
			1
		],
		[
			"2010-04-29",
			1
		],
		[
			"2010-11-11",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-04-24",
			1
		],
		[
			"2013-10-31",
			1
		],
		[
			"2013-06-07",
			1
		],
		[
			"2014-10-14",
			1
		],
		[
			"2014-06-12",
			1
		],
		[
			"2015-11-10",
			1
		],
		[
			"2015-05-19",
			1
		]
	],
	"100706680": [
		[
			"2000-03-29",
			13
		],
		[
			"2000-10-31",
			16.01
		],
		[
			"2001-04-23",
			16.01
		],
		[
			"2001-10-23",
			20.01
		],
		[
			"2002-10-15",
			16.01
		],
		[
			"2003-11-20",
			18.01
		],
		[
			"2005-05-12",
			17.01
		],
		[
			"2005-11-23",
			21.01
		],
		[
			"2006-05-18",
			18.01
		],
		[
			"2007-05-03",
			19.01
		],
		[
			"2007-11-07",
			19.01
		],
		[
			"2008-04-29",
			20.01
		],
		[
			"2010-04-29",
			18.01
		],
		[
			"2010-11-11",
			16.01
		],
		[
			"2012-11-13",
			15.01
		],
		[
			"2012-04-24",
			15.01
		],
		[
			"2013-10-31",
			17.01
		],
		[
			"2013-06-07",
			28.01
		],
		[
			"2014-10-14",
			20.01
		],
		[
			"2014-06-12",
			22.01
		],
		[
			"2015-11-10",
			20.01
		],
		[
			"2015-05-19",
			19.01
		]
	],
	"100706940": [
		[
			"2003-11-20",
			1
		],
		[
			"2005-05-12",
			1
		],
		[
			"2005-11-23",
			1
		],
		[
			"2006-05-18",
			1
		],
		[
			"2007-05-03",
			1
		],
		[
			"2006-10-31",
			1
		],
		[
			"2007-11-07",
			1
		],
		[
			"2008-04-29",
			1
		],
		[
			"2008-10-16",
			1
		],
		[
			"2010-04-29",
			1
		],
		[
			"2010-11-11",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-04-24",
			1
		],
		[
			"2013-10-31",
			1
		],
		[
			"2013-06-07",
			1
		],
		[
			"2014-10-14",
			1
		],
		[
			"2014-06-12",
			1
		],
		[
			"2015-11-10",
			1
		],
		[
			"2015-05-19",
			1
		]
	],
	"100707543": [
		[
			"2000-04-07",
			39.01
		],
		[
			"2000-09-06",
			41.01
		],
		[
			"2001-03-03",
			42.01
		],
		[
			"2001-09-06",
			44.02
		],
		[
			"2002-03-06",
			40.01
		],
		[
			"2002-10-02",
			36.01
		],
		[
			"2003-03-12",
			36.01
		],
		[
			"2003-09-11",
			46.02
		],
		[
			"2004-03-16",
			39.01
		],
		[
			"2004-09-07",
			41.01
		],
		[
			"2005-03-22",
			44.02
		],
		[
			"2005-09-02",
			41.01
		],
		[
			"2006-03-22",
			41.01
		],
		[
			"2006-09-06",
			40.01
		],
		[
			"2007-03-26",
			39.01
		],
		[
			"2007-10-08",
			40.01
		],
		[
			"2008-04-22",
			41.01
		],
		[
			"2008-10-08",
			38.01
		],
		[
			"2009-04-29",
			38.01
		],
		[
			"2009-10-20",
			36.01
		],
		[
			"2010-05-19",
			34.01
		],
		[
			"2010-11-10",
			33.01
		],
		[
			"2012-10-10",
			32.01
		],
		[
			"2012-05-23",
			31.01
		],
		[
			"2013-11-12",
			28.01
		],
		[
			"2013-05-22",
			28.01
		],
		[
			"2014-10-28",
			22.01
		],
		[
			"2014-06-16",
			22.01
		],
		[
			"2015-10-16",
			20.01
		],
		[
			"2015-05-11",
			20.01
		]
	],
	"100720341": [
		[
			"2000-03-29",
			35.01
		],
		[
			"2000-09-27",
			35.01
		],
		[
			"2001-03-21",
			34.01
		],
		[
			"2001-09-21",
			32.01
		],
		[
			"2002-03-14",
			29.01
		],
		[
			"2002-09-25",
			37.01
		],
		[
			"2003-03-20",
			41.01
		],
		[
			"2003-09-25",
			41.01
		],
		[
			"2004-03-23",
			35.01
		],
		[
			"2004-09-27",
			35.01
		],
		[
			"2005-03-23",
			32.01
		],
		[
			"2006-03-29",
			29.01
		],
		[
			"2006-09-28",
			35.01
		],
		[
			"2007-03-27",
			35.01
		],
		[
			"2006-01-09",
			38.01
		],
		[
			"2006-02-20",
			35.01
		],
		[
			"2006-07-26",
			36.01
		],
		[
			"2006-10-25",
			37.01
		],
		[
			"2007-04-23",
			36.01
		],
		[
			"2007-05-31",
			36.01
		],
		[
			"2007-07-31",
			36.01
		],
		[
			"2007-01-29",
			35.01
		],
		[
			"2007-08-30",
			32.01
		],
		[
			"2007-10-24",
			33.01
		],
		[
			"2007-09-26",
			33.01
		],
		[
			"2008-04-23",
			39.01
		],
		[
			"2008-02-21",
			38.01
		],
		[
			"2008-03-26",
			37.01
		],
		[
			"2008-01-28",
			33.01
		],
		[
			"2008-05-19",
			34.01
		],
		[
			"2008-06-26",
			31.01
		],
		[
			"2008-10-24",
			38.01
		],
		[
			"2008-09-22",
			37.01
		],
		[
			"2008-08-25",
			36.01
		],
		[
			"2008-11-26",
			38.01
		],
		[
			"2008-12-15",
			43.02
		],
		[
			"2009-01-12",
			35.01
		],
		[
			"2009-02-10",
			35.01
		],
		[
			"2009-04-21",
			35.01
		],
		[
			"2009-05-15",
			35.01
		],
		[
			"2009-03-24",
			37.01
		],
		[
			"2009-07-31",
			38.01
		],
		[
			"2009-08-27",
			37.01
		],
		[
			"2009-11-10",
			38.01
		],
		[
			"2009-12-07",
			32.01
		],
		[
			"2009-06-19",
			33.01
		],
		[
			"2009-09-29",
			36.01
		],
		[
			"2009-10-22",
			35.01
		],
		[
			"2010-05-18",
			36.01
		],
		[
			"2010-02-22",
			34.01
		],
		[
			"2010-01-25",
			33.01
		],
		[
			"2010-04-09",
			44.02
		],
		[
			"2010-07-26",
			33.01
		],
		[
			"2010-09-21",
			34.01
		],
		[
			"2010-08-24",
			34.01
		],
		[
			"2010-06-28",
			31.01
		],
		[
			"2010-10-15",
			34.01
		],
		[
			"2010-12-06",
			37.01
		],
		[
			"2010-11-19",
			37.01
		],
		[
			"2012-12-05",
			37.01
		],
		[
			"2012-11-12",
			34.01
		],
		[
			"2012-10-10",
			35.01
		],
		[
			"2012-09-26",
			35.01
		],
		[
			"2012-08-06",
			36.01
		],
		[
			"2012-07-13",
			34.01
		],
		[
			"2012-06-25",
			36.01
		],
		[
			"2012-05-25",
			36.01
		],
		[
			"2012-04-16",
			38.01
		],
		[
			"2012-03-12",
			39.01
		],
		[
			"2012-02-27",
			39.01
		],
		[
			"2012-01-24",
			40.01
		],
		[
			"2013-11-18",
			33.01
		],
		[
			"2013-10-09",
			30.01
		],
		[
			"2013-09-16",
			30.01
		],
		[
			"2013-08-12",
			31.01
		],
		[
			"2013-07-01",
			32.01
		],
		[
			"2013-06-03",
			32.01
		],
		[
			"2013-05-08",
			32.01
		],
		[
			"2013-04-10",
			32.01
		],
		[
			"2013-03-19",
			33.01
		],
		[
			"2013-02-21",
			33.01
		],
		[
			"2013-01-10",
			35.01
		],
		[
			"2014-11-18",
			31.01
		],
		[
			"2014-10-23",
			32.01
		],
		[
			"2014-09-18",
			31.01
		],
		[
			"2014-08-05",
			33.01
		],
		[
			"2014-07-08",
			33.01
		],
		[
			"2014-05-06",
			32.01
		],
		[
			"2014-04-14",
			32.01
		],
		[
			"2014-03-24",
			34.01
		],
		[
			"2014-02-18",
			33.01
		],
		[
			"2014-01-13",
			33.01
		],
		[
			"2015-12-11",
			30.01
		],
		[
			"2015-11-26",
			30.01
		],
		[
			"2015-10-20",
			27.01
		],
		[
			"2015-09-24",
			29.01
		],
		[
			"2015-08-10",
			32.01
		],
		[
			"2015-07-13",
			30.01
		],
		[
			"2015-06-05",
			29.01
		],
		[
			"2015-05-12",
			29.01
		],
		[
			"2015-04-13",
			28.01
		],
		[
			"2015-03-26",
			29.01
		],
		[
			"2015-02-23",
			28.01
		]
	],
	"100721217": [
		[
			"2000-04-13",
			1
		],
		[
			"2000-10-12",
			2
		],
		[
			"2001-04-11",
			1
		],
		[
			"2001-10-11",
			1
		],
		[
			"2002-04-04",
			1
		],
		[
			"2004-05-27",
			1
		],
		[
			"2005-05-25",
			1
		],
		[
			"2006-11-14",
			1
		],
		[
			"2006-05-30",
			1
		],
		[
			"2005-11-10",
			1
		],
		[
			"2004-11-03",
			1
		],
		[
			"2003-10-29",
			1
		],
		[
			"2008-03-27",
			1
		],
		[
			"2008-10-14",
			1
		],
		[
			"2007-05-31",
			1
		],
		[
			"2007-10-10",
			1
		],
		[
			"2009-03-17",
			1
		],
		[
			"2009-10-13",
			1
		],
		[
			"2010-05-05",
			1
		],
		[
			"2010-10-05",
			1
		],
		[
			"2012-10-09",
			1
		],
		[
			"2012-04-10",
			1
		],
		[
			"2013-10-23",
			1
		],
		[
			"2013-04-29",
			1
		],
		[
			"2014-10-09",
			1
		],
		[
			"2014-04-22",
			1
		],
		[
			"2015-11-13",
			1
		],
		[
			"2015-04-16",
			1
		]
	],
	"100730024": [
		[
			"2000-02-29",
			53.02
		],
		[
			"2000-09-13",
			50.02
		],
		[
			"2001-03-14",
			49.02
		],
		[
			"2001-09-19",
			48.02
		],
		[
			"2002-03-13",
			50.02
		],
		[
			"2002-09-18",
			46.02
		],
		[
			"2002-03-13",
			50.02
		],
		[
			"2003-09-04",
			47.82
		],
		[
			"2003-03-11",
			54.12
		],
		[
			"2004-09-15",
			41.41
		],
		[
			"2004-03-16",
			47.52
		],
		[
			"2005-09-29",
			32.71
		],
		[
			"2005-04-06",
			37.21
		],
		[
			"2013-04-18",
			34.71
		],
		[
			"2013-10-08",
			32.71
		],
		[
			"2011-04-11",
			47.02
		],
		[
			"2011-10-20",
			33.41
		],
		[
			"2014-04-08",
			30.71
		],
		[
			"2014-10-21",
			26.71
		],
		[
			"2015-04-22",
			26.21
		],
		[
			"2015-10-20",
			27.41
		]
	],
	"100730050": [
		[
			"2002-10-16",
			20.01
		],
		[
			"2002-04-18",
			30.01
		],
		[
			"2006-10-20",
			25.01
		],
		[
			"2006-04-21",
			27.01
		],
		[
			"2005-11-23",
			28.01
		],
		[
			"2005-04-08",
			28.01
		],
		[
			"2004-11-11",
			24.01
		],
		[
			"2004-04-29",
			28.01
		],
		[
			"2003-10-29",
			28.01
		],
		[
			"2003-04-02",
			34.01
		],
		[
			"2001-09-13",
			29.01
		],
		[
			"2001-04-09",
			26.01
		],
		[
			"2000-09-14",
			25.01
		],
		[
			"2000-04-13",
			22.01
		],
		[
			"2008-03-14",
			21.01
		],
		[
			"2008-09-11",
			19.01
		],
		[
			"2007-04-25",
			24.01
		],
		[
			"2007-10-05",
			25.01
		],
		[
			"2009-04-21",
			19.01
		],
		[
			"2010-04-23",
			19.01
		],
		[
			"2010-10-22",
			17.01
		],
		[
			"2012-10-12",
			15.01
		],
		[
			"2012-04-23",
			16.01
		],
		[
			"2013-10-17",
			13
		],
		[
			"2013-04-29",
			14
		],
		[
			"2014-10-30",
			13
		],
		[
			"2014-04-22",
			13
		],
		[
			"2015-11-23",
			12
		],
		[
			"2015-04-24",
			13
		]
	],
	"100730103": [
		[
			"2000-03-01",
			28.01
		],
		[
			"2000-09-14",
			25.01
		],
		[
			"2001-03-15",
			26.01
		],
		[
			"2001-09-19",
			35.01
		],
		[
			"2002-03-13",
			29.01
		],
		[
			"2002-03-13",
			29.01
		],
		[
			"2003-09-04",
			33.01
		],
		[
			"2003-03-11",
			30.61
		],
		[
			"2004-09-15",
			30.91
		],
		[
			"2004-03-16",
			33.01
		],
		[
			"2005-09-29",
			32.31
		],
		[
			"2005-04-06",
			30.41
		],
		[
			"2013-04-18",
			31.21
		],
		[
			"2013-10-08",
			31.71
		],
		[
			"2011-04-11",
			36.91
		],
		[
			"2011-10-20",
			32.51
		],
		[
			"2014-04-08",
			33.11
		],
		[
			"2014-10-21",
			32.41
		],
		[
			"2015-04-22",
			30.51
		],
		[
			"2015-10-20",
			32.41
		]
	],
	"100731296": [
		[
			"2000-04-13",
			40.01
		],
		[
			"2000-10-12",
			34.01
		],
		[
			"2001-04-11",
			31.01
		],
		[
			"2001-10-11",
			34.01
		],
		[
			"2002-04-04",
			33.01
		],
		[
			"2004-05-27",
			38.01
		],
		[
			"2005-05-25",
			27.01
		],
		[
			"2006-11-14",
			30.01
		],
		[
			"2006-05-30",
			35.01
		],
		[
			"2005-11-10",
			44.02
		],
		[
			"2004-11-03",
			40.01
		],
		[
			"2003-10-29",
			34.01
		],
		[
			"2003-04-10",
			38.01
		],
		[
			"2002-10-17",
			34.01
		],
		[
			"2008-03-27",
			41.01
		],
		[
			"2008-10-14",
			43.02
		],
		[
			"2007-05-31",
			33.01
		],
		[
			"2007-10-10",
			40.01
		],
		[
			"2009-10-13",
			36.01
		],
		[
			"2010-05-05",
			36.01
		],
		[
			"2010-10-05",
			32.01
		],
		[
			"2012-04-10",
			41.01
		],
		[
			"2013-10-23",
			37.01
		],
		[
			"2013-04-29",
			37.01
		],
		[
			"2014-10-09",
			36.01
		],
		[
			"2014-04-22",
			37.01
		],
		[
			"2015-10-08",
			36.01
		],
		[
			"2015-04-16",
			34.01
		]
	],
	"100731478": [
		[
			"2013-04-22",
			47.83
		],
		[
			"2014-02-11",
			50.49
		],
		[
			"2015-06-24",
			35.07
		],
		[
			"2008-07-18",
			48.71
		],
		[
			"2009-11-12",
			44.29
		],
		[
			"2010-06-02",
			48.71
		],
		[
			"2011-09-20",
			44.29
		],
		[
			"2012-09-19",
			30.11
		]
	],
	"100740029": [
		[
			"2000-11-09",
			34.01
		],
		[
			"2002-11-12",
			36.01
		],
		[
			"2005-11-15",
			36.01
		],
		[
			"2003-10-14",
			34.01
		],
		[
			"2008-01-08",
			35.01
		],
		[
			"2008-04-14",
			37.01
		],
		[
			"2008-07-08",
			32.01
		],
		[
			"2008-10-06",
			37.01
		],
		[
			"2008-12-11",
			37.01
		],
		[
			"2009-05-11",
			36.01
		],
		[
			"2009-11-09",
			34.01
		],
		[
			"2010-05-10",
			34.01
		],
		[
			"2010-11-08",
			34.01
		],
		[
			"2013-11-11",
			35.01
		],
		[
			"2014-11-10",
			32.01
		],
		[
			"2014-05-12",
			35.01
		],
		[
			"2015-11-09",
			32.01
		],
		[
			"2015-05-11",
			32.01
		]
	],
	"100740522": [
		[
			"2000-05-09",
			42.01
		],
		[
			"2000-10-17",
			45.02
		],
		[
			"2001-05-08",
			45.02
		],
		[
			"2001-10-16",
			47.02
		],
		[
			"2002-11-14",
			45.02
		],
		[
			"2006-05-11",
			40.01
		],
		[
			"2003-11-19",
			40.01
		],
		[
			"2006-11-07",
			40.01
		],
		[
			"2005-11-22",
			47.02
		],
		[
			"2005-05-31",
			48.02
		],
		[
			"2004-11-10",
			44.02
		],
		[
			"2004-06-02",
			49.02
		],
		[
			"2003-05-08",
			38.01
		],
		[
			"2002-05-16",
			42.01
		],
		[
			"2008-04-17",
			54.02
		],
		[
			"2008-10-28",
			52.02
		],
		[
			"2009-06-17",
			44.02
		],
		[
			"2009-11-03",
			38.01
		],
		[
			"2007-12-14",
			47.02
		],
		[
			"2007-05-22",
			45.02
		],
		[
			"2007-11-15",
			49.02
		],
		[
			"2010-05-04",
			43.02
		],
		[
			"2010-06-22",
			43.02
		],
		[
			"2010-09-14",
			49.02
		],
		[
			"2010-11-03",
			48.02
		],
		[
			"2012-10-23",
			51.02
		],
		[
			"2012-09-12",
			45.02
		],
		[
			"2012-06-26",
			45.02
		],
		[
			"2012-04-17",
			51.02
		],
		[
			"2012-04-03",
			52.02
		],
		[
			"2012-01-11",
			50.02
		],
		[
			"2013-10-29",
			51.02
		],
		[
			"2013-09-17",
			52.02
		],
		[
			"2013-06-25",
			54.02
		],
		[
			"2013-05-28",
			54.02
		],
		[
			"2013-04-02",
			48.02
		],
		[
			"2013-01-08",
			53.02
		],
		[
			"2014-10-30",
			52.02
		],
		[
			"2014-09-16",
			60.02
		],
		[
			"2014-06-24",
			57.02
		],
		[
			"2014-04-01",
			41.01
		],
		[
			"2014-01-07",
			45.02
		],
		[
			"2015-06-24",
			62.02
		],
		[
			"2015-03-31",
			58.02
		],
		[
			"2015-01-07",
			39.01
		]
	],
	"100741010": [
		[
			"2000-10-17",
			24.01
		],
		[
			"2000-05-09",
			34.01
		],
		[
			"2001-05-08",
			22.01
		],
		[
			"2001-10-15",
			20.01
		],
		[
			"2002-11-14",
			22.01
		],
		[
			"2004-11-10",
			14
		],
		[
			"2003-11-13",
			24.01
		],
		[
			"2006-05-11",
			13
		],
		[
			"2002-05-16",
			22.01
		],
		[
			"2006-11-07",
			10
		],
		[
			"2005-11-22",
			10
		],
		[
			"2007-05-22",
			33.01
		],
		[
			"2007-11-14",
			19.01
		],
		[
			"2003-05-08",
			22.01
		],
		[
			"2008-04-17",
			23.01
		],
		[
			"2008-10-28",
			17.01
		],
		[
			"2009-11-03",
			22.01
		],
		[
			"2009-06-17",
			27.01
		],
		[
			"2010-05-04",
			15.01
		],
		[
			"2010-11-04",
			13
		],
		[
			"2012-12-13",
			11
		],
		[
			"2012-04-17",
			13
		],
		[
			"2013-10-29",
			7
		],
		[
			"2013-05-28",
			9
		],
		[
			"2014-10-30",
			9
		],
		[
			"2014-06-24",
			7
		],
		[
			"2015-03-31",
			6
		]
	],
	"100741654": [
		[
			"2000-05-09",
			33.01
		],
		[
			"2000-10-17",
			31.01
		],
		[
			"2001-05-08",
			30.01
		],
		[
			"2001-10-16",
			31.01
		],
		[
			"2002-11-14",
			33.01
		],
		[
			"2006-11-07",
			30.01
		],
		[
			"2006-05-11",
			29.01
		],
		[
			"2005-11-22",
			30.01
		],
		[
			"2004-11-10",
			27.01
		],
		[
			"2004-06-02",
			30.01
		],
		[
			"2003-11-13",
			28.01
		],
		[
			"2003-05-08",
			29.01
		],
		[
			"2002-05-16",
			30.01
		],
		[
			"2007-05-22",
			30.01
		],
		[
			"2007-11-14",
			29.01
		],
		[
			"2008-04-17",
			33.01
		],
		[
			"2008-10-28",
			32.01
		],
		[
			"2009-06-17",
			31.01
		],
		[
			"2009-11-04",
			43.02
		],
		[
			"2010-05-04",
			30.01
		],
		[
			"2010-11-03",
			31.01
		],
		[
			"2012-10-23",
			30.01
		],
		[
			"2012-04-17",
			32.01
		],
		[
			"2013-10-29",
			28.01
		],
		[
			"2013-05-28",
			29.01
		],
		[
			"2014-10-30",
			30.01
		],
		[
			"2014-06-24",
			32.01
		],
		[
			"2015-03-31",
			30.01
		]
	],
	"100742208": [
		[
			"2000-10-18",
			1
		],
		[
			"2000-05-09",
			1
		],
		[
			"2001-10-15",
			1
		],
		[
			"2001-05-08",
			1
		],
		[
			"2002-11-20",
			1
		],
		[
			"2002-05-16",
			1
		],
		[
			"2006-05-11",
			1
		],
		[
			"2005-11-22",
			1
		],
		[
			"2005-05-31",
			1
		],
		[
			"2004-08-05",
			1
		],
		[
			"2004-06-02",
			1
		],
		[
			"2003-11-13",
			11
		],
		[
			"2003-05-08",
			1
		],
		[
			"2006-11-07",
			1
		],
		[
			"2007-05-22",
			1
		],
		[
			"2007-11-15",
			1
		],
		[
			"2008-11-11",
			1
		],
		[
			"2009-11-03",
			1
		],
		[
			"2009-06-17",
			1
		],
		[
			"2010-05-04",
			2
		],
		[
			"2010-11-04",
			1
		],
		[
			"2012-12-13",
			1
		],
		[
			"2013-10-30",
			1
		],
		[
			"2014-10-30",
			1
		],
		[
			"2014-07-11",
			1
		],
		[
			"2015-03-31",
			1
		]
	],
	"100742427": [
		[
			"2000-03-23",
			10
		],
		[
			"2001-03-15",
			3
		],
		[
			"2002-03-14",
			11
		],
		[
			"2006-04-04",
			10
		],
		[
			"2006-11-22",
			11
		],
		[
			"2007-10-23",
			13
		],
		[
			"2010-06-01",
			8.6
		],
		[
			"2009-10-26",
			12
		],
		[
			"2008-05-14",
			13
		],
		[
			"2008-10-28",
			12
		],
		[
			"2009-05-11",
			14
		],
		[
			"2010-10-21",
			7.8
		],
		[
			"2011-05-18",
			7.2
		],
		[
			"2011-11-10",
			7.5
		],
		[
			"2012-05-15",
			6.2
		],
		[
			"2012-11-15",
			6.6
		],
		[
			"2013-05-16",
			6.7
		],
		[
			"2013-11-07",
			6.4
		],
		[
			"2014-05-21",
			5.8
		],
		[
			"2015-05-05",
			6.8
		],
		[
			"2014-11-06",
			9.7
		],
		[
			"2015-11-05",
			9.8
		]
	],
	"100744412": [
		[
			"2000-03-23",
			1
		],
		[
			"2001-03-15",
			1
		],
		[
			"2001-12-13",
			1
		],
		[
			"2002-03-14",
			1
		],
		[
			"2002-07-29",
			1
		],
		[
			"2006-11-22",
			0.2
		],
		[
			"2007-10-22",
			0.4
		],
		[
			"2008-05-13",
			2.1
		],
		[
			"2008-10-28",
			0.6
		],
		[
			"2009-05-14",
			4.5
		],
		[
			"2009-10-26",
			1.7
		],
		[
			"2010-10-20",
			1.4
		],
		[
			"2011-05-17",
			2.2
		],
		[
			"2011-11-09",
			0.9
		],
		[
			"2012-05-10",
			1.1
		],
		[
			"2012-11-14",
			1.5
		],
		[
			"2013-05-15",
			4.2
		],
		[
			"2013-11-06",
			1.4
		],
		[
			"2014-05-21",
			2.8
		],
		[
			"2015-05-06",
			4.6
		],
		[
			"2014-11-05",
			2.4
		],
		[
			"2015-11-04",
			1
		]
	],
	"100746410": [
		[
			"2000-03-23",
			36.01
		],
		[
			"2000-09-22",
			41.01
		],
		[
			"2001-03-15",
			37.01
		],
		[
			"2001-09-27",
			38.01
		],
		[
			"2002-03-14",
			39.01
		],
		[
			"2002-09-26",
			43.02
		],
		[
			"2008-03-17",
			20.01
		],
		[
			"2008-05-14",
			36.01
		],
		[
			"2010-05-31",
			33.01
		],
		[
			"2009-10-28",
			34.01
		],
		[
			"2009-05-14",
			38.01
		],
		[
			"2008-10-29",
			40.01
		],
		[
			"2010-10-21",
			33.01
		],
		[
			"2011-05-18",
			35.01
		],
		[
			"2011-11-10",
			39.01
		],
		[
			"2012-05-15",
			39.01
		],
		[
			"2012-11-14",
			36.01
		],
		[
			"2013-05-16",
			37.01
		],
		[
			"2013-11-06",
			35.01
		],
		[
			"2014-05-23",
			36.01
		],
		[
			"2015-05-06",
			35.01
		],
		[
			"2014-11-06",
			36.01
		],
		[
			"2015-11-04",
			39.01
		]
	],
	"100748454": [
		[
			"2013-05-02",
			30.56
		],
		[
			"2014-04-29",
			33.21
		],
		[
			"2015-02-12",
			37.2
		],
		[
			"2016-02-17",
			34.1
		],
		[
			"2001-05-07",
			27.81
		],
		[
			"2001-11-05",
			31.01
		],
		[
			"2000-05-02",
			29.01
		],
		[
			"2000-10-31",
			37.01
		],
		[
			"2002-05-07",
			29.01
		],
		[
			"2002-11-05",
			28.01
		],
		[
			"2003-05-07",
			29.01
		],
		[
			"2003-11-03",
			34.01
		],
		[
			"2004-05-04",
			30.01
		],
		[
			"2004-11-04",
			38.01
		],
		[
			"2005-05-10",
			28.01
		],
		[
			"2005-11-07",
			33.01
		],
		[
			"2006-05-08",
			23.01
		],
		[
			"2006-11-08",
			30.01
		],
		[
			"2006-10-11",
			31.44
		],
		[
			"2007-10-17",
			28.34
		],
		[
			"2008-06-12",
			29.23
		],
		[
			"2008-05-06",
			31.01
		],
		[
			"2008-11-05",
			27.01
		],
		[
			"2009-05-05",
			27.01
		],
		[
			"2009-11-04",
			30.01
		],
		[
			"2010-05-04",
			25.01
		],
		[
			"2010-11-01",
			28.01
		],
		[
			"2011-05-03",
			26.01
		],
		[
			"2011-11-07",
			35.01
		],
		[
			"2012-05-07",
			37.01
		],
		[
			"2012-11-05",
			37.01
		],
		[
			"2013-05-06",
			32.01
		],
		[
			"2013-12-09",
			34.01
		],
		[
			"2014-05-05",
			33.01
		],
		[
			"2014-11-03",
			33.01
		],
		[
			"2009-10-13",
			34.99
		],
		[
			"2008-08-20",
			33.66
		],
		[
			"2010-06-02",
			29.67
		],
		[
			"2011-06-16",
			31
		],
		[
			"2012-08-04",
			34.54
		]
	],
	"100750059": [
		[
			"2001-05-07",
			23.01
		],
		[
			"2001-11-05",
			23.01
		],
		[
			"2002-11-04",
			18.01
		],
		[
			"2002-05-06",
			15.01
		],
		[
			"2003-05-06",
			20.01
		],
		[
			"2006-04-07",
			20.01
		],
		[
			"2004-04-05",
			20.01
		],
		[
			"2005-04-01",
			15.01
		],
		[
			"2006-10-13",
			11
		],
		[
			"2005-10-11",
			14
		],
		[
			"2004-10-11",
			12
		],
		[
			"2008-04-29",
			17.01
		],
		[
			"2008-10-20",
			14
		],
		[
			"2007-05-07",
			19.01
		],
		[
			"2007-10-22",
			22.01
		],
		[
			"2009-10-05",
			12
		],
		[
			"2010-04-23",
			19.01
		],
		[
			"2010-10-18",
			13
		],
		[
			"2012-10-22",
			14
		],
		[
			"2012-04-19",
			19.01
		],
		[
			"2013-11-05",
			17.01
		],
		[
			"2013-05-06",
			16.01
		],
		[
			"2014-10-20",
			15.01
		],
		[
			"2014-04-28",
			15.01
		],
		[
			"2015-10-12",
			15.01
		],
		[
			"2015-04-20",
			18.01
		]
	],
	"100760156": [
		[
			"2000-03-22",
			7
		],
		[
			"2000-11-07",
			10
		],
		[
			"2001-03-27",
			7
		],
		[
			"2001-09-24",
			8
		],
		[
			"2002-03-19",
			6
		],
		[
			"2002-09-18",
			7
		],
		[
			"2003-11-12",
			8
		],
		[
			"2004-09-09",
			8
		],
		[
			"2004-04-06",
			1
		],
		[
			"2005-03-31",
			6
		],
		[
			"2008-09-11",
			4
		],
		[
			"2008-03-18",
			3
		],
		[
			"2009-04-02",
			4
		],
		[
			"2009-09-09",
			6
		],
		[
			"2010-03-31",
			7
		],
		[
			"2010-11-16",
			7
		],
		[
			"2012-09-25",
			8
		],
		[
			"2012-04-12",
			7
		],
		[
			"2013-10-24",
			5
		],
		[
			"2013-04-25",
			6
		],
		[
			"2014-09-23",
			7
		],
		[
			"2014-03-20",
			8
		],
		[
			"2015-10-05",
			7
		],
		[
			"2015-04-14",
			6
		]
	],
	"100760168": [
		[
			"2000-11-07",
			1
		],
		[
			"2001-09-24",
			1
		],
		[
			"2002-09-18",
			2
		],
		[
			"2003-11-12",
			1
		],
		[
			"2004-09-09",
			1
		],
		[
			"2008-09-11",
			1
		],
		[
			"2009-09-09",
			1
		],
		[
			"2010-11-16",
			1
		],
		[
			"2012-09-25",
			1
		],
		[
			"2013-10-24",
			1
		],
		[
			"2014-09-23",
			1
		],
		[
			"2015-10-05",
			1
		]
	],
	"100761161": [
		[
			"2000-11-07",
			22.01
		],
		[
			"2001-06-20",
			22.01
		],
		[
			"2001-09-24",
			28.01
		],
		[
			"2002-03-19",
			32.01
		],
		[
			"2002-09-18",
			26.01
		],
		[
			"2003-11-12",
			21.01
		],
		[
			"2004-09-09",
			18.01
		],
		[
			"2003-03-18",
			23.01
		],
		[
			"2004-04-06",
			30.01
		],
		[
			"2005-03-31",
			20.01
		],
		[
			"2005-09-22",
			21.01
		],
		[
			"2008-09-11",
			19.01
		],
		[
			"2008-03-18",
			21.01
		],
		[
			"2009-09-09",
			18.01
		],
		[
			"2009-04-02",
			21.01
		],
		[
			"2010-03-31",
			25.01
		],
		[
			"2010-11-16",
			26.01
		],
		[
			"2012-09-25",
			18.01
		],
		[
			"2012-04-12",
			20.01
		],
		[
			"2013-10-24",
			17.01
		],
		[
			"2013-04-25",
			21.01
		],
		[
			"2014-09-23",
			16.01
		],
		[
			"2014-03-20",
			18.01
		],
		[
			"2015-10-05",
			21.01
		],
		[
			"2015-04-14",
			21.01
		]
	],
	"100761410": [
		[
			"2000-03-01",
			1
		],
		[
			"2000-09-04",
			1
		],
		[
			"2001-03-06",
			1
		],
		[
			"2001-10-08",
			1
		],
		[
			"2006-03-22",
			1
		],
		[
			"2006-09-01",
			1
		],
		[
			"2007-03-28",
			1
		],
		[
			"2007-09-25",
			1
		],
		[
			"2008-09-25",
			1
		],
		[
			"2008-03-19",
			1
		],
		[
			"2009-09-02",
			1
		],
		[
			"2009-03-18",
			1
		],
		[
			"2010-03-11",
			1
		],
		[
			"2010-09-08",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2013-10-21",
			1
		],
		[
			"2013-04-26",
			1
		],
		[
			"2014-05-06",
			1
		],
		[
			"2015-11-04",
			1
		],
		[
			"2015-01-15",
			1
		],
		[
			"2015-01-14",
			1
		]
	],
	"100761616": [
		[
			"2000-03-22",
			75.03
		],
		[
			"2001-03-28",
			80.03
		],
		[
			"2002-03-20",
			67.02
		],
		[
			"2003-03-18",
			68.02
		],
		[
			"2004-04-06",
			75.03
		],
		[
			"2005-03-31",
			59.02
		],
		[
			"2008-03-18",
			60.02
		],
		[
			"2009-04-02",
			61.02
		],
		[
			"2010-03-31",
			60.02
		],
		[
			"2012-04-12",
			62.02
		],
		[
			"2013-04-25",
			53.02
		],
		[
			"2014-03-20",
			54.02
		],
		[
			"2015-04-14",
			53.02
		]
	],
	"100790318": [
		[
			"2000-03-20",
			7
		],
		[
			"2000-10-10",
			7
		],
		[
			"2001-06-11",
			7
		],
		[
			"2001-11-08",
			7
		],
		[
			"2002-05-16",
			7
		],
		[
			"2002-11-13",
			7
		],
		[
			"2003-03-24",
			7
		],
		[
			"2003-11-18",
			7
		],
		[
			"2004-05-05",
			7
		],
		[
			"2004-11-08",
			8
		],
		[
			"2005-05-11",
			7
		],
		[
			"2005-11-08",
			8
		],
		[
			"2006-11-14",
			8
		],
		[
			"2006-05-15",
			8
		],
		[
			"2007-03-26",
			8
		],
		[
			"2007-11-12",
			8
		],
		[
			"2008-03-26",
			7
		],
		[
			"2008-10-13",
			8
		],
		[
			"2009-05-11",
			8
		],
		[
			"2009-09-28",
			8
		],
		[
			"2010-04-26",
			8
		],
		[
			"2010-11-02",
			10
		],
		[
			"2011-05-09",
			8
		],
		[
			"2011-11-02",
			8
		],
		[
			"2012-05-14",
			8
		],
		[
			"2012-10-15",
			8
		],
		[
			"2013-06-04",
			9
		],
		[
			"2013-11-12",
			10
		],
		[
			"2014-04-10",
			9
		],
		[
			"2014-11-13",
			9
		],
		[
			"2015-05-19",
			8
		],
		[
			"2015-11-10",
			9
		]
	],
	"100791554": [
		[
			"2000-03-30",
			32.01
		],
		[
			"2000-10-16",
			48.02
		],
		[
			"2001-05-14",
			68.02
		],
		[
			"2002-11-15",
			48.02
		],
		[
			"2015-10-28",
			37.01
		]
	],
	"104004046": [
		[
			"2013-04-30",
			60.23
		],
		[
			"2014-04-08",
			49.16
		],
		[
			"2015-04-09",
			51.37
		],
		[
			"2001-12-12",
			52.26
		],
		[
			"2002-06-11",
			52.7
		],
		[
			"2002-09-04",
			69.53
		],
		[
			"2002-11-28",
			74.4
		],
		[
			"2003-09-10",
			35.07
		],
		[
			"2004-09-14",
			43.62
		],
		[
			"2005-10-24",
			44.29
		],
		[
			"2006-09-06",
			2.21
		],
		[
			"2007-08-08",
			44.29
		],
		[
			"2003-03-06",
			77.94
		],
		[
			"2012-09-13",
			2.21
		]
	],
	"106500028": [
		[
			"2013-05-27",
			28.34
		],
		[
			"2014-02-04",
			35.87
		],
		[
			"2015-02-12",
			33.88
		],
		[
			"2016-01-26",
			33.66
		],
		[
			"2000-08-31",
			34.99
		],
		[
			"2000-10-12",
			34.54
		],
		[
			"2001-04-18",
			31.89
		],
		[
			"2003-09-23",
			32.06
		],
		[
			"2004-06-21",
			23.65
		],
		[
			"2005-06-24",
			30.56
		],
		[
			"2005-08-30",
			30.56
		],
		[
			"2005-04-21",
			29.23
		],
		[
			"2006-10-11",
			30.56
		],
		[
			"2007-06-14",
			31
		],
		[
			"2008-06-12",
			32.33
		],
		[
			"2009-10-15",
			34.54
		],
		[
			"2008-08-14",
			31
		],
		[
			"2010-09-15",
			32.33
		],
		[
			"2011-06-16",
			30.56
		],
		[
			"2012-06-27",
			29.23
		]
	],
	"106500041": [
		[
			"2000-12-14",
			31.01
		],
		[
			"2000-10-05",
			32.01
		],
		[
			"2001-05-14",
			32.01
		],
		[
			"2001-10-22",
			33.01
		],
		[
			"2006-10-30",
			28.01
		],
		[
			"2007-04-26",
			32.01
		],
		[
			"2007-09-28",
			30.01
		],
		[
			"2008-04-08",
			31.01
		],
		[
			"2008-10-23",
			31.01
		],
		[
			"2009-04-24",
			30.01
		],
		[
			"2009-09-22",
			27.01
		],
		[
			"2010-04-28",
			30.01
		],
		[
			"2010-09-10",
			29.01
		],
		[
			"2012-09-21",
			27.01
		],
		[
			"2012-05-02",
			29.01
		],
		[
			"2013-12-09",
			26.01
		],
		[
			"2013-05-16",
			26.01
		],
		[
			"2014-12-15",
			25.01
		],
		[
			"2014-05-20",
			27.01
		],
		[
			"2015-11-24",
			25.01
		],
		[
			"2015-05-26",
			26.01
		]
	],
	"106500053": [
		[
			"2013-05-02",
			3.01
		],
		[
			"2015-02-25",
			14.66
		],
		[
			"2016-02-17",
			14.61
		],
		[
			"2000-07-10",
			15.94
		],
		[
			"2002-11-21",
			15.94
		],
		[
			"2005-04-28",
			15.94
		],
		[
			"2005-06-24",
			17.27
		],
		[
			"2006-10-19",
			14.61
		],
		[
			"2007-07-13",
			15.5
		],
		[
			"2008-05-19",
			16.83
		],
		[
			"2010-06-21",
			15.06
		],
		[
			"2011-06-08",
			15.06
		],
		[
			"2012-04-25",
			14.17
		]
	],
	"106501100": [
		[
			"2000-05-08",
			33.01
		],
		[
			"2000-11-13",
			30.01
		],
		[
			"2001-10-01",
			29.01
		],
		[
			"2002-04-23",
			28.01
		],
		[
			"2002-10-21",
			31.01
		],
		[
			"2003-03-20",
			31.01
		],
		[
			"2003-12-01",
			27.01
		],
		[
			"2004-03-16",
			34.01
		],
		[
			"2004-09-28",
			29.01
		],
		[
			"2005-09-26",
			26.01
		],
		[
			"2006-11-09",
			28.01
		],
		[
			"2006-06-07",
			31.01
		],
		[
			"2007-03-19",
			31.01
		],
		[
			"2007-11-15",
			31.01
		],
		[
			"2008-05-08",
			29.01
		],
		[
			"2008-10-23",
			28.01
		],
		[
			"2009-05-04",
			25.01
		],
		[
			"2009-10-13",
			26.01
		],
		[
			"2010-03-23",
			33.01
		],
		[
			"2010-09-30",
			30.01
		],
		[
			"2011-05-03",
			23.01
		],
		[
			"2011-11-07",
			26.01
		],
		[
			"2012-04-16",
			28.01
		],
		[
			"2012-11-21",
			26.01
		],
		[
			"2013-04-23",
			28.01
		],
		[
			"2013-11-18",
			24.01
		],
		[
			"2014-05-21",
			28.01
		],
		[
			"2014-11-17",
			26.01
		],
		[
			"2015-03-30",
			28.01
		],
		[
			"2015-10-14",
			27.01
		]
	],
	"106501926": [
		[
			"2000-03-22",
			22.01
		],
		[
			"2001-06-13",
			26.01
		],
		[
			"2002-05-16",
			22.01
		],
		[
			"2002-11-12",
			15.01
		],
		[
			"2003-03-25",
			18.01
		],
		[
			"2004-06-16",
			21.01
		],
		[
			"2006-05-22",
			22.01
		],
		[
			"2007-03-26",
			20.01
		],
		[
			"2007-11-12",
			18.01
		],
		[
			"2008-05-20",
			22.01
		],
		[
			"2008-10-13",
			21.01
		],
		[
			"2009-05-11",
			21.01
		],
		[
			"2009-09-28",
			21.01
		],
		[
			"2010-04-27",
			21.01
		],
		[
			"2010-11-02",
			20.01
		],
		[
			"2011-05-09",
			21.01
		],
		[
			"2011-11-02",
			20.01
		],
		[
			"2012-04-04",
			21.01
		],
		[
			"2012-04-12",
			21.01
		],
		[
			"2012-04-18",
			21.01
		],
		[
			"2012-04-26",
			21.01
		],
		[
			"2012-05-02",
			21.01
		],
		[
			"2012-05-14",
			20.01
		],
		[
			"2012-06-12",
			19.01
		],
		[
			"2012-07-02",
			21.01
		],
		[
			"2012-08-01",
			21.01
		],
		[
			"2012-09-03",
			19.01
		],
		[
			"2012-10-02",
			19.01
		],
		[
			"2012-10-16",
			21.01
		],
		[
			"2012-11-19",
			21.01
		],
		[
			"2012-12-03",
			20.01
		],
		[
			"2013-01-14",
			20.01
		],
		[
			"2013-02-04",
			21.01
		],
		[
			"2013-03-04",
			21.01
		],
		[
			"2013-04-02",
			21.01
		],
		[
			"2013-05-06",
			21.01
		],
		[
			"2013-06-11",
			20.01
		],
		[
			"2013-07-02",
			21.01
		],
		[
			"2013-08-05",
			18.01
		],
		[
			"2013-09-03",
			21.01
		],
		[
			"2013-10-07",
			21.01
		],
		[
			"2013-11-04",
			20.01
		],
		[
			"2013-11-13",
			21.01
		],
		[
			"2013-12-02",
			22.01
		],
		[
			"2014-01-06",
			22.01
		],
		[
			"2014-02-04",
			20.01
		],
		[
			"2014-03-03",
			20.01
		],
		[
			"2014-04-01",
			21.01
		],
		[
			"2014-04-08",
			20.01
		],
		[
			"2014-08-11",
			22.01
		],
		[
			"2014-09-16",
			21.01
		],
		[
			"2014-10-07",
			21.01
		],
		[
			"2014-11-05",
			20.01
		],
		[
			"2014-11-12",
			21.01
		],
		[
			"2014-12-02",
			20.01
		],
		[
			"2015-01-05",
			19.01
		],
		[
			"2015-02-10",
			19.01
		],
		[
			"2015-03-02",
			20.01
		],
		[
			"2015-04-01",
			20.01
		],
		[
			"2015-05-04",
			21.01
		],
		[
			"2015-05-18",
			19.01
		],
		[
			"2015-06-08",
			21.01
		],
		[
			"2015-07-01",
			21.01
		],
		[
			"2015-08-04",
			21.01
		],
		[
			"2015-09-03",
			21.01
		],
		[
			"2015-10-19",
			21.01
		]
	],
	"106501987": [
		[
			"2000-03-20",
			7
		],
		[
			"2001-06-11",
			5
		],
		[
			"2002-05-14",
			6
		],
		[
			"2003-03-24",
			6
		],
		[
			"2004-05-04",
			5
		],
		[
			"2004-11-08",
			5
		],
		[
			"2006-05-15",
			5
		],
		[
			"2007-03-26",
			7
		],
		[
			"2007-11-12",
			5
		],
		[
			"2008-05-20",
			5
		],
		[
			"2008-10-13",
			5
		],
		[
			"2009-05-11",
			5
		],
		[
			"2009-09-28",
			5
		],
		[
			"2010-04-26",
			5
		],
		[
			"2010-11-02",
			5
		],
		[
			"2011-05-09",
			5
		],
		[
			"2011-11-02",
			5
		],
		[
			"2012-05-14",
			5
		],
		[
			"2012-10-15",
			5
		],
		[
			"2013-06-04",
			6
		],
		[
			"2013-11-13",
			7
		],
		[
			"2014-04-09",
			5
		],
		[
			"2014-11-12",
			6
		],
		[
			"2015-05-18",
			5
		],
		[
			"2015-10-28",
			5
		]
	],
	"106502025": [
		[
			"2000-05-03",
			1
		],
		[
			"2000-11-08",
			8
		],
		[
			"2001-04-23",
			18.01
		],
		[
			"2001-10-12",
			6
		],
		[
			"2003-10-14",
			18.01
		],
		[
			"2004-10-12",
			8
		],
		[
			"2005-04-22",
			14
		],
		[
			"2005-10-04",
			18.01
		],
		[
			"2010-05-10",
			15.01
		],
		[
			"2010-10-04",
			12
		],
		[
			"2009-04-27",
			19.01
		],
		[
			"2009-10-26",
			19.01
		],
		[
			"2008-04-14",
			18.01
		],
		[
			"2008-10-13",
			16.01
		],
		[
			"2012-10-08",
			14
		],
		[
			"2012-04-25",
			17.01
		],
		[
			"2013-11-18",
			16.01
		],
		[
			"2013-04-22",
			13
		],
		[
			"2014-10-06",
			19.01
		],
		[
			"2014-04-07",
			12
		],
		[
			"2015-10-06",
			18.01
		]
	],
	"106502062": [
		[
			"2000-05-03",
			7
		],
		[
			"2000-11-08",
			6
		],
		[
			"2001-04-23",
			12
		],
		[
			"2001-10-12",
			5
		],
		[
			"2002-10-22",
			6.4
		],
		[
			"2003-10-14",
			7
		],
		[
			"2004-10-12",
			6
		],
		[
			"2010-05-10",
			8
		],
		[
			"2010-10-04",
			6
		],
		[
			"2009-04-27",
			10
		],
		[
			"2009-10-26",
			5
		],
		[
			"2008-10-13",
			7
		],
		[
			"2008-04-14",
			14
		],
		[
			"2012-04-25",
			7
		],
		[
			"2013-11-18",
			9
		],
		[
			"2013-04-24",
			8
		],
		[
			"2014-10-01",
			5
		],
		[
			"2014-04-07",
			7
		],
		[
			"2015-10-06",
			7
		],
		[
			"2015-04-13",
			12
		]
	],
	"106502130": [
		[
			"2000-05-03",
			12
		],
		[
			"2000-11-08",
			11
		],
		[
			"2001-04-23",
			11
		],
		[
			"2001-10-12",
			12
		],
		[
			"2002-10-22",
			11
		],
		[
			"2003-10-14",
			13
		],
		[
			"2006-05-05",
			12
		],
		[
			"2006-10-04",
			11
		],
		[
			"2007-04-13",
			11
		],
		[
			"2007-10-09",
			11
		],
		[
			"2004-10-12",
			12
		],
		[
			"2005-04-22",
			8.9
		],
		[
			"2005-10-04",
			10
		],
		[
			"2008-04-14",
			12
		],
		[
			"2008-10-13",
			12
		],
		[
			"2009-04-27",
			12
		],
		[
			"2009-10-26",
			11
		],
		[
			"2010-05-10",
			11
		],
		[
			"2010-10-04",
			11
		],
		[
			"2012-10-08",
			11
		],
		[
			"2012-04-25",
			12
		],
		[
			"2013-11-18",
			13
		],
		[
			"2013-04-22",
			12
		],
		[
			"2014-10-06",
			15.01
		],
		[
			"2014-04-07",
			15.01
		],
		[
			"2015-10-06",
			15.01
		],
		[
			"2015-04-13",
			15.01
		]
	],
	"106502165": [
		[
			"2000-05-03",
			10
		],
		[
			"2000-11-08",
			11
		],
		[
			"2001-04-23",
			11
		],
		[
			"2001-10-12",
			12
		],
		[
			"2002-10-22",
			13
		],
		[
			"2004-04-27",
			11
		],
		[
			"2004-10-12",
			11
		],
		[
			"2005-04-22",
			8.4
		],
		[
			"2005-10-04",
			10
		],
		[
			"2006-05-05",
			13
		],
		[
			"2006-10-04",
			13
		],
		[
			"2007-04-13",
			14
		],
		[
			"2007-10-09",
			13
		],
		[
			"2008-10-13",
			13
		],
		[
			"2008-04-14",
			13
		],
		[
			"2009-04-27",
			13
		],
		[
			"2009-10-26",
			12
		],
		[
			"2010-05-10",
			13
		],
		[
			"2010-10-04",
			11
		],
		[
			"2012-10-08",
			12
		],
		[
			"2013-11-18",
			14
		],
		[
			"2013-04-22",
			12
		],
		[
			"2014-10-06",
			15.01
		],
		[
			"2014-04-07",
			15.01
		],
		[
			"2015-10-06",
			14
		],
		[
			"2015-04-13",
			14
		]
	],
	"106502219": [
		[
			"2000-04-06",
			18.01
		],
		[
			"2000-09-20",
			16.01
		],
		[
			"2001-04-19",
			16.01
		],
		[
			"2001-10-09",
			17.01
		],
		[
			"2002-10-10",
			15.01
		],
		[
			"2007-03-19",
			17.01
		],
		[
			"2006-09-14",
			17.01
		],
		[
			"2006-03-21",
			18.01
		],
		[
			"2005-09-06",
			16.01
		],
		[
			"2005-03-30",
			17.01
		],
		[
			"2004-09-28",
			14
		],
		[
			"2004-04-20",
			16.01
		],
		[
			"2003-10-06",
			14
		],
		[
			"2003-04-29",
			16.01
		],
		[
			"2006-08-31",
			16.01
		],
		[
			"2008-01-31",
			20.01
		],
		[
			"2008-02-29",
			19.01
		],
		[
			"2008-03-31",
			20.01
		],
		[
			"2008-05-30",
			21.01
		],
		[
			"2008-07-31",
			22.01
		],
		[
			"2008-09-23",
			20.01
		],
		[
			"2008-09-30",
			20.01
		],
		[
			"2008-10-31",
			19.01
		],
		[
			"2008-04-30",
			20.01
		],
		[
			"2008-11-28",
			20.01
		],
		[
			"2008-06-30",
			19.01
		],
		[
			"2008-08-29",
			21.01
		],
		[
			"2009-02-27",
			17.01
		],
		[
			"2009-03-31",
			18.01
		],
		[
			"2009-04-30",
			19.01
		],
		[
			"2009-06-30",
			17.01
		],
		[
			"2009-03-17",
			18.01
		],
		[
			"2009-05-29",
			18.01
		],
		[
			"2009-01-30",
			17.01
		],
		[
			"2009-09-30",
			18.01
		],
		[
			"2009-10-30",
			16.01
		],
		[
			"2009-08-31",
			18.01
		],
		[
			"2009-07-31",
			19.01
		],
		[
			"2009-09-01",
			17.01
		],
		[
			"2009-11-30",
			16.01
		],
		[
			"2010-03-30",
			19.01
		],
		[
			"2010-04-12",
			21.01
		],
		[
			"2010-04-30",
			19.01
		],
		[
			"2010-03-03",
			17.01
		],
		[
			"2010-01-04",
			20.01
		],
		[
			"2010-02-26",
			21.01
		],
		[
			"2010-05-31",
			18.01
		],
		[
			"2010-01-29",
			17.01
		],
		[
			"2010-03-19",
			18.01
		],
		[
			"2010-06-29",
			17.01
		],
		[
			"2010-08-31",
			4
		],
		[
			"2010-07-30",
			18.01
		],
		[
			"2010-09-06",
			19.01
		],
		[
			"2010-09-30",
			16.01
		],
		[
			"2010-11-30",
			18.01
		],
		[
			"2010-11-02",
			17.01
		],
		[
			"2012-11-30",
			15.01
		],
		[
			"2012-10-31",
			14
		],
		[
			"2012-09-28",
			14
		],
		[
			"2012-08-31",
			15.01
		],
		[
			"2012-07-31",
			15.01
		],
		[
			"2012-05-31",
			15.01
		],
		[
			"2012-05-02",
			17.01
		],
		[
			"2012-04-02",
			16.01
		],
		[
			"2012-03-30",
			16.01
		],
		[
			"2012-02-29",
			16.01
		],
		[
			"2012-01-31",
			15.01
		],
		[
			"2012-01-02",
			13
		],
		[
			"2013-12-30",
			16.01
		],
		[
			"2013-11-29",
			16.01
		],
		[
			"2013-11-05",
			17.01
		],
		[
			"2013-09-30",
			15.01
		],
		[
			"2013-09-02",
			16.01
		],
		[
			"2013-07-31",
			16.01
		],
		[
			"2013-07-01",
			16.01
		],
		[
			"2013-06-03",
			16.01
		],
		[
			"2013-04-30",
			15.01
		],
		[
			"2013-03-28",
			15.01
		],
		[
			"2013-03-14",
			14
		],
		[
			"2013-02-28",
			15.01
		],
		[
			"2013-01-31",
			14
		],
		[
			"2013-01-02",
			15.01
		],
		[
			"2014-12-01",
			14
		],
		[
			"2014-11-03",
			14
		],
		[
			"2014-09-29",
			14
		],
		[
			"2014-09-02",
			15.01
		],
		[
			"2014-07-31",
			15.01
		],
		[
			"2014-06-30",
			15.01
		],
		[
			"2014-05-28",
			15.01
		],
		[
			"2014-04-30",
			15.01
		],
		[
			"2014-04-01",
			16.01
		],
		[
			"2014-03-20",
			16.01
		],
		[
			"2014-02-28",
			16.01
		],
		[
			"2014-01-31",
			16.01
		],
		[
			"2015-11-30",
			14
		],
		[
			"2015-10-30",
			14
		],
		[
			"2015-10-01",
			14
		],
		[
			"2015-08-27",
			15.01
		],
		[
			"2015-07-30",
			14
		],
		[
			"2015-06-30",
			15.01
		],
		[
			"2015-06-01",
			15.01
		],
		[
			"2015-04-30",
			14
		],
		[
			"2015-04-08",
			14
		],
		[
			"2015-03-31",
			14
		],
		[
			"2015-02-27",
			14
		],
		[
			"2015-01-30",
			14
		]
	],
	"106502300": [
		[
			"2000-04-05",
			11
		],
		[
			"2000-09-06",
			6
		],
		[
			"2001-03-02",
			6
		],
		[
			"2001-09-06",
			9
		],
		[
			"2002-03-06",
			13
		],
		[
			"2002-10-02",
			11
		],
		[
			"2008-04-22",
			15.01
		],
		[
			"2008-01-17",
			9
		],
		[
			"2006-03-22",
			8
		],
		[
			"2007-03-26",
			11
		],
		[
			"2006-09-06",
			6
		],
		[
			"2007-01-08",
			6
		],
		[
			"2009-04-29",
			9
		],
		[
			"2009-01-07",
			5
		],
		[
			"2010-01-27",
			9
		],
		[
			"2010-05-19",
			9
		],
		[
			"2012-05-23",
			6
		],
		[
			"2012-01-05",
			5
		],
		[
			"2013-05-22",
			8
		],
		[
			"2013-01-16",
			7
		],
		[
			"2014-06-16",
			6
		],
		[
			"2014-01-07",
			7
		],
		[
			"2015-05-11",
			11
		],
		[
			"2015-01-07",
			8
		]
	],
	"106502335": [
		[
			"2000-05-09",
			20.01
		],
		[
			"2000-11-14",
			21.01
		],
		[
			"2001-05-16",
			19.01
		],
		[
			"2001-10-08",
			17.01
		],
		[
			"2002-05-13",
			18.01
		],
		[
			"2002-11-11",
			19.01
		],
		[
			"2003-03-25",
			18.01
		],
		[
			"2003-11-11",
			19.01
		],
		[
			"2004-03-15",
			17.01
		],
		[
			"2004-09-28",
			17.01
		],
		[
			"2005-09-28",
			18.01
		],
		[
			"2005-04-21",
			18.01
		],
		[
			"2006-07-06",
			17.01
		],
		[
			"2007-10-01",
			21.01
		],
		[
			"2008-10-23",
			17.01
		],
		[
			"2009-03-26",
			17.01
		],
		[
			"2009-10-19",
			17.01
		],
		[
			"2010-09-28",
			16.01
		],
		[
			"2011-04-27",
			16.01
		],
		[
			"2011-10-26",
			17.01
		],
		[
			"2012-05-08",
			16.01
		],
		[
			"2012-11-06",
			16.01
		],
		[
			"2013-05-28",
			17.01
		],
		[
			"2013-11-07",
			16.01
		],
		[
			"2014-04-22",
			16.01
		],
		[
			"2015-04-20",
			17.01
		],
		[
			"2015-10-15",
			16.01
		]
	],
	"106502359": [
		[
			"2002-05-14",
			1
		],
		[
			"2002-11-11",
			1
		],
		[
			"2003-03-17",
			1
		],
		[
			"2003-11-11",
			1
		],
		[
			"2004-03-15",
			1
		],
		[
			"2004-09-27",
			1
		],
		[
			"2005-09-28",
			1
		],
		[
			"2005-04-21",
			1
		],
		[
			"2006-11-13",
			1
		],
		[
			"2006-05-03",
			1
		],
		[
			"2007-03-21",
			1
		],
		[
			"2007-10-01",
			1
		],
		[
			"2008-05-19",
			1
		],
		[
			"2008-10-29",
			1
		],
		[
			"2009-03-26",
			1
		],
		[
			"2009-10-19",
			1
		],
		[
			"2010-04-12",
			1
		],
		[
			"2010-09-28",
			1
		],
		[
			"2011-04-27",
			1
		],
		[
			"2011-10-26",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2012-11-06",
			1
		],
		[
			"2013-05-28",
			1
		],
		[
			"2013-11-14",
			1
		],
		[
			"2014-05-20",
			1
		],
		[
			"2014-11-19",
			1
		],
		[
			"2015-05-05",
			1
		],
		[
			"2015-10-13",
			1
		]
	],
	"106502372": [
		[
			"2000-05-09",
			3
		],
		[
			"2001-05-16",
			1
		],
		[
			"2001-10-08",
			1
		],
		[
			"2002-05-13",
			1
		],
		[
			"2002-11-11",
			1
		],
		[
			"2003-03-17",
			1
		],
		[
			"2003-11-11",
			1
		],
		[
			"2004-03-16",
			1
		],
		[
			"2004-09-27",
			1
		],
		[
			"2004-11-29",
			1
		],
		[
			"2005-09-27",
			1
		],
		[
			"2005-04-20",
			1
		],
		[
			"2006-11-13",
			1
		],
		[
			"2006-05-02",
			1
		],
		[
			"2007-03-21",
			1
		],
		[
			"2007-10-01",
			1
		],
		[
			"2008-05-19",
			1
		],
		[
			"2008-10-23",
			1
		],
		[
			"2009-03-26",
			1
		],
		[
			"2009-10-19",
			1
		],
		[
			"2010-04-12",
			1
		],
		[
			"2010-09-28",
			1
		],
		[
			"2011-04-27",
			1
		],
		[
			"2011-10-26",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2012-11-06",
			1
		],
		[
			"2013-05-28",
			1
		],
		[
			"2013-11-14",
			1
		],
		[
			"2014-05-20",
			1
		],
		[
			"2014-11-19",
			1
		],
		[
			"2015-05-05",
			1
		],
		[
			"2015-10-13",
			1
		]
	],
	"106502402": [
		[
			"2000-03-16",
			24.01
		],
		[
			"2000-09-14",
			23.01
		],
		[
			"2001-03-21",
			28.01
		],
		[
			"2001-09-05",
			34.01
		],
		[
			"2002-03-13",
			24.01
		],
		[
			"2002-09-03",
			22.01
		],
		[
			"2003-09-25",
			20.01
		],
		[
			"2003-03-17",
			22.01
		],
		[
			"2004-10-06",
			16.01
		],
		[
			"2004-03-18",
			21.01
		],
		[
			"2005-09-26",
			18.01
		],
		[
			"2005-03-16",
			21.01
		],
		[
			"2006-03-23",
			20.01
		],
		[
			"2006-09-18",
			18.01
		],
		[
			"2007-04-03",
			18.01
		],
		[
			"2007-09-24",
			17.01
		],
		[
			"2008-04-25",
			18.01
		],
		[
			"2008-09-15",
			20.01
		],
		[
			"2009-04-21",
			19.01
		],
		[
			"2009-09-07",
			19.01
		],
		[
			"2010-04-09",
			18.01
		],
		[
			"2010-09-07",
			19.01
		],
		[
			"2012-10-01",
			17.01
		],
		[
			"2012-05-07",
			19.01
		],
		[
			"2013-09-24",
			17.01
		],
		[
			"2013-04-24",
			17.01
		],
		[
			"2014-09-23",
			18.01
		],
		[
			"2014-04-02",
			20.01
		],
		[
			"2015-09-28",
			19.01
		],
		[
			"2015-05-21",
			20.01
		]
	],
	"106502426": [
		[
			"2000-05-10",
			33.01
		],
		[
			"2000-11-15",
			27.01
		],
		[
			"2001-05-16",
			30.01
		],
		[
			"2001-10-08",
			29.01
		],
		[
			"2002-05-13",
			34.01
		],
		[
			"2002-11-11",
			30.01
		],
		[
			"2003-03-17",
			33.01
		],
		[
			"2003-11-11",
			26.01
		],
		[
			"2004-03-15",
			31.01
		],
		[
			"2004-09-27",
			25.01
		],
		[
			"2005-09-27",
			24.01
		],
		[
			"2005-04-20",
			29.01
		],
		[
			"2006-11-13",
			24.01
		],
		[
			"2006-05-02",
			29.01
		],
		[
			"2007-03-21",
			28.01
		],
		[
			"2007-10-01",
			28.01
		],
		[
			"2008-05-19",
			30.01
		],
		[
			"2008-10-29",
			24.01
		],
		[
			"2009-03-26",
			26.01
		],
		[
			"2009-10-19",
			25.01
		],
		[
			"2010-04-12",
			31.01
		],
		[
			"2010-09-28",
			33.01
		],
		[
			"2011-04-27",
			30.01
		],
		[
			"2011-10-26",
			29.01
		],
		[
			"2012-05-08",
			31.01
		],
		[
			"2012-11-06",
			25.01
		],
		[
			"2013-05-28",
			30.01
		],
		[
			"2013-11-14",
			27.01
		],
		[
			"2014-05-20",
			27.01
		],
		[
			"2014-11-19",
			27.01
		],
		[
			"2015-05-05",
			33.01
		],
		[
			"2015-10-13",
			26.01
		]
	],
	"106502463": [
		[
			"2000-03-16",
			19.01
		],
		[
			"2000-09-14",
			21.01
		],
		[
			"2001-03-21",
			21.01
		],
		[
			"2001-09-05",
			22.01
		],
		[
			"2002-03-13",
			19.01
		],
		[
			"2002-09-03",
			20.01
		],
		[
			"2003-09-25",
			22.01
		],
		[
			"2003-03-17",
			23.01
		],
		[
			"2004-10-06",
			17.01
		],
		[
			"2004-03-18",
			22.01
		],
		[
			"2005-03-16",
			20.01
		],
		[
			"2005-09-26",
			18.01
		],
		[
			"2006-09-18",
			18.01
		],
		[
			"2006-03-23",
			20.01
		],
		[
			"2007-04-03",
			21.01
		],
		[
			"2007-09-24",
			20.01
		],
		[
			"2008-02-08",
			21.01
		],
		[
			"2008-04-03",
			23.01
		],
		[
			"2008-09-15",
			22.01
		],
		[
			"2009-02-06",
			5
		],
		[
			"2009-09-07",
			19.01
		],
		[
			"2010-02-02",
			20.01
		],
		[
			"2010-04-09",
			21.01
		],
		[
			"2010-09-07",
			21.01
		],
		[
			"2009-04-21",
			21.01
		],
		[
			"2012-10-01",
			20.01
		],
		[
			"2012-05-07",
			20.01
		],
		[
			"2012-02-22",
			19.01
		],
		[
			"2013-09-24",
			20.01
		],
		[
			"2013-02-20",
			19.01
		],
		[
			"2014-09-23",
			19.01
		],
		[
			"2014-04-02",
			21.01
		],
		[
			"2015-09-28",
			19.01
		],
		[
			"2015-05-21",
			4
		],
		[
			"2015-02-25",
			19.01
		]
	],
	"106502475": [
		[
			"2000-03-16",
			30.01
		],
		[
			"2000-09-14",
			31.01
		],
		[
			"2001-03-21",
			31.01
		],
		[
			"2001-09-05",
			31.01
		],
		[
			"2002-03-13",
			32.01
		],
		[
			"2002-09-03",
			29.01
		],
		[
			"2003-09-25",
			14
		],
		[
			"2003-03-17",
			29.01
		],
		[
			"2004-03-18",
			31.01
		],
		[
			"2004-10-06",
			24.01
		],
		[
			"2005-09-26",
			27.01
		],
		[
			"2005-03-16",
			31.01
		],
		[
			"2006-09-18",
			27.01
		],
		[
			"2006-03-23",
			28.01
		],
		[
			"2007-04-03",
			30.01
		],
		[
			"2007-05-24",
			26.01
		],
		[
			"2007-09-24",
			29.01
		],
		[
			"2008-09-15",
			30.01
		],
		[
			"2008-04-03",
			30.01
		],
		[
			"2009-05-26",
			29.01
		],
		[
			"2009-04-21",
			31.01
		],
		[
			"2009-09-07",
			30.01
		],
		[
			"2010-04-22",
			29.01
		],
		[
			"2010-05-27",
			29.01
		],
		[
			"2010-09-07",
			29.01
		],
		[
			"2012-10-01",
			29.01
		],
		[
			"2012-05-07",
			30.01
		],
		[
			"2013-09-24",
			28.01
		],
		[
			"2013-04-24",
			12
		],
		[
			"2014-09-23",
			29.01
		],
		[
			"2014-05-19",
			30.01
		],
		[
			"2014-04-02",
			30.01
		],
		[
			"2015-09-28",
			29.01
		],
		[
			"2015-05-21",
			28.01
		],
		[
			"2015-02-25",
			28.01
		]
	],
	"106502517": [
		[
			"2000-03-16",
			1
		],
		[
			"2000-09-14",
			1
		],
		[
			"2001-03-21",
			2
		],
		[
			"2001-09-05",
			1
		],
		[
			"2002-03-13",
			1
		],
		[
			"2002-09-03",
			2
		],
		[
			"2003-03-17",
			1
		],
		[
			"2003-09-25",
			1
		],
		[
			"2004-03-18",
			1
		],
		[
			"2004-10-06",
			1
		],
		[
			"2005-03-16",
			1
		],
		[
			"2005-09-26",
			1
		],
		[
			"2006-03-23",
			1
		],
		[
			"2006-09-18",
			1
		],
		[
			"2010-04-09",
			2
		],
		[
			"2010-09-07",
			1
		],
		[
			"2009-04-21",
			1
		],
		[
			"2009-09-07",
			1
		],
		[
			"2008-04-03",
			1
		],
		[
			"2008-09-15",
			1
		],
		[
			"2012-10-01",
			1
		],
		[
			"2012-05-07",
			1
		],
		[
			"2013-09-24",
			1
		],
		[
			"2013-04-24",
			1
		],
		[
			"2014-09-23",
			1
		],
		[
			"2014-04-02",
			1
		],
		[
			"2015-09-28",
			1
		],
		[
			"2015-05-21",
			1
		]
	],
	"106502566": [
		[
			"2000-03-30",
			23.01
		],
		[
			"2000-10-16",
			33.01
		],
		[
			"2002-11-15",
			31.01
		],
		[
			"2013-06-27",
			37.01
		],
		[
			"2015-10-28",
			33.01
		]
	],
	"106502578": [
		[
			"2000-11-08",
			1
		],
		[
			"2001-03-28",
			5
		],
		[
			"2000-03-22",
			6
		],
		[
			"2001-09-25",
			1
		],
		[
			"2002-03-20",
			8
		],
		[
			"2002-09-18",
			7
		],
		[
			"2003-03-18",
			7
		],
		[
			"2008-03-18",
			5
		],
		[
			"2008-09-11",
			1
		],
		[
			"2010-03-31",
			2
		],
		[
			"2010-11-16",
			1
		],
		[
			"2012-09-25",
			1
		],
		[
			"2013-10-24",
			1
		],
		[
			"2013-04-26",
			1
		],
		[
			"2014-09-23",
			1
		],
		[
			"2014-03-20",
			1
		],
		[
			"2015-10-05",
			1
		],
		[
			"2015-04-14",
			4
		]
	],
	"106502633": [
		[
			"2000-04-12",
			2
		],
		[
			"2000-09-11",
			2
		],
		[
			"2001-09-03",
			3
		],
		[
			"2004-09-08",
			1
		],
		[
			"2004-04-23",
			2
		],
		[
			"2003-09-23",
			1
		],
		[
			"2002-09-16",
			1
		],
		[
			"2002-05-13",
			1
		],
		[
			"2006-09-21",
			1
		],
		[
			"2006-10-13",
			1
		],
		[
			"2008-04-29",
			2
		],
		[
			"2008-10-20",
			1
		],
		[
			"2006-04-07",
			1
		],
		[
			"2007-05-07",
			1
		],
		[
			"2009-04-30",
			1
		],
		[
			"2009-10-05",
			1
		],
		[
			"2010-04-23",
			1
		],
		[
			"2010-07-16",
			1
		],
		[
			"2010-10-18",
			1
		],
		[
			"2012-10-22",
			1
		],
		[
			"2012-07-09",
			1
		],
		[
			"2013-11-05",
			1
		],
		[
			"2013-07-12",
			1
		],
		[
			"2013-05-06",
			1
		],
		[
			"2014-10-20",
			1
		],
		[
			"2015-10-12",
			1
		],
		[
			"2015-07-03",
			2
		],
		[
			"2015-04-20",
			1
		]
	],
	"106503613": [
		[
			"2000-03-29",
			1
		],
		[
			"2000-09-27",
			2
		],
		[
			"2001-03-12",
			1
		],
		[
			"2001-09-21",
			6
		],
		[
			"2002-03-14",
			4
		],
		[
			"2002-09-25",
			18.01
		],
		[
			"2002-09-25",
			18.01
		],
		[
			"2002-09-25",
			18.01
		],
		[
			"2003-09-25",
			2
		],
		[
			"2003-03-20",
			3
		],
		[
			"2003-09-25",
			2
		],
		[
			"2004-09-27",
			1
		],
		[
			"2004-03-23",
			1
		],
		[
			"2005-03-23",
			1
		],
		[
			"2007-03-27",
			1
		],
		[
			"2006-03-29",
			1
		],
		[
			"2006-09-28",
			1
		],
		[
			"2007-09-26",
			1
		],
		[
			"2008-03-26",
			1
		],
		[
			"2008-09-22",
			1
		],
		[
			"2009-03-24",
			11
		],
		[
			"2009-09-29",
			1
		],
		[
			"2010-03-25",
			1
		],
		[
			"2010-09-21",
			2
		],
		[
			"2015-09-24",
			1
		],
		[
			"2015-03-26",
			1
		]
	],
	"106503649": [
		[
			"2000-03-01",
			20.01
		],
		[
			"2000-09-13",
			9
		],
		[
			"2001-03-14",
			21.01
		],
		[
			"2001-09-19",
			8
		],
		[
			"2002-03-13",
			19.01
		],
		[
			"2002-09-18",
			11
		],
		[
			"2002-03-13",
			19.01
		],
		[
			"2003-09-04",
			5.2
		],
		[
			"2003-03-11",
			9.3
		],
		[
			"2004-09-15",
			5.9
		],
		[
			"2004-03-16",
			12.4
		],
		[
			"2005-09-29",
			5.3
		],
		[
			"2005-04-06",
			8.4
		],
		[
			"2013-04-18",
			13.8
		],
		[
			"2013-10-08",
			9.1
		],
		[
			"2011-04-11",
			16.41
		],
		[
			"2011-10-20",
			7.9
		],
		[
			"2014-04-08",
			13.3
		],
		[
			"2014-10-21",
			11.9
		],
		[
			"2015-04-22",
			12.8
		],
		[
			"2015-10-20",
			6.6
		]
	],
	"106503730": [
		[
			"2000-04-18",
			15.61
		],
		[
			"2000-10-18",
			4.65
		],
		[
			"2001-04-25",
			16.01
		],
		[
			"2001-10-23",
			11
		],
		[
			"2002-04-03",
			17.01
		],
		[
			"2002-11-12",
			16.01
		],
		[
			"2013-10-16",
			12
		],
		[
			"2014-10-07",
			13
		],
		[
			"2014-04-16",
			12
		],
		[
			"2015-04-21",
			19.01
		]
	],
	"106503820": [
		[
			"2000-03-13",
			26.01
		],
		[
			"2000-10-02",
			24.01
		],
		[
			"2001-03-05",
			23.01
		],
		[
			"2001-09-10",
			5
		],
		[
			"2002-03-11",
			24.01
		],
		[
			"2002-09-16",
			14
		],
		[
			"2006-03-20",
			21.01
		],
		[
			"2006-09-07",
			22.01
		],
		[
			"2005-09-12",
			20.01
		],
		[
			"2005-03-29",
			20.01
		],
		[
			"2004-09-13",
			21.01
		],
		[
			"2004-03-15",
			22.01
		],
		[
			"2003-09-08",
			28.01
		],
		[
			"2003-03-17",
			23.01
		],
		[
			"2015-09-28",
			3
		],
		[
			"2015-03-02",
			3
		]
	],
	"106503959": [
		[
			"2000-04-03",
			1
		],
		[
			"2000-10-05",
			1
		],
		[
			"2001-04-02",
			1
		],
		[
			"2001-10-22",
			1
		],
		[
			"2002-10-01",
			1
		],
		[
			"2007-04-04",
			1
		],
		[
			"2006-05-04",
			1
		],
		[
			"2005-10-19",
			1
		],
		[
			"2005-04-20",
			1
		],
		[
			"2004-11-10",
			1
		],
		[
			"2004-04-14",
			1
		],
		[
			"2003-11-03",
			1
		],
		[
			"2003-04-03",
			1
		],
		[
			"2007-11-05",
			1
		],
		[
			"2008-04-02",
			1
		],
		[
			"2008-10-17",
			1
		],
		[
			"2009-10-15",
			1
		],
		[
			"2009-04-07",
			1
		],
		[
			"2010-05-04",
			1
		],
		[
			"2010-11-10",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2013-10-21",
			1
		],
		[
			"2013-04-16",
			1
		],
		[
			"2014-11-11",
			1
		],
		[
			"2014-05-06",
			1
		],
		[
			"2015-04-14",
			2
		]
	],
	"106503960": [
		[
			"2000-04-03",
			1
		],
		[
			"2000-10-05",
			1
		],
		[
			"2001-04-02",
			1
		],
		[
			"2001-10-22",
			1
		],
		[
			"2002-10-01",
			6
		],
		[
			"2007-04-04",
			1
		],
		[
			"2006-10-23",
			1
		],
		[
			"2006-05-04",
			1
		],
		[
			"2005-10-19",
			6
		],
		[
			"2004-11-10",
			1
		],
		[
			"2004-04-14",
			1
		],
		[
			"2003-11-03",
			1
		],
		[
			"2003-04-03",
			2
		],
		[
			"2007-11-05",
			1
		],
		[
			"2008-04-02",
			1
		],
		[
			"2008-10-17",
			1
		],
		[
			"2009-04-07",
			1
		],
		[
			"2009-10-15",
			1
		],
		[
			"2010-05-04",
			2
		],
		[
			"2010-11-10",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2013-10-21",
			1
		],
		[
			"2013-04-16",
			1
		],
		[
			"2014-11-11",
			1
		],
		[
			"2014-05-06",
			1
		],
		[
			"2015-04-14",
			1
		]
	],
	"106503984": [
		[
			"2000-04-03",
			2
		],
		[
			"2000-10-05",
			2
		],
		[
			"2001-04-02",
			2
		],
		[
			"2001-10-22",
			3
		],
		[
			"2002-10-01",
			2
		],
		[
			"2007-04-04",
			2
		],
		[
			"2006-10-23",
			1
		],
		[
			"2006-05-04",
			2
		],
		[
			"2005-10-19",
			1
		],
		[
			"2005-04-20",
			6
		],
		[
			"2004-11-10",
			1
		],
		[
			"2004-04-14",
			1
		],
		[
			"2003-11-03",
			6
		],
		[
			"2003-04-03",
			4
		],
		[
			"2007-11-05",
			2
		],
		[
			"2008-04-02",
			1
		],
		[
			"2008-10-17",
			2
		],
		[
			"2009-04-07",
			2
		],
		[
			"2009-10-15",
			2
		],
		[
			"2010-05-04",
			2
		],
		[
			"2010-11-10",
			1
		],
		[
			"2012-11-13",
			1
		],
		[
			"2012-05-08",
			1
		],
		[
			"2013-10-21",
			1
		],
		[
			"2013-04-16",
			1
		],
		[
			"2014-11-11",
			2
		],
		[
			"2014-05-06",
			2
		],
		[
			"2015-04-14",
			2
		]
	],
	"106505014": [
		[
			"2000-12-14",
			27.01
		],
		[
			"2000-10-05",
			34.01
		],
		[
			"2001-05-14",
			41.01
		],
		[
			"2001-10-22",
			33.01
		],
		[
			"2006-04-28",
			31.01
		],
		[
			"2006-10-30",
			29.01
		],
		[
			"2007-04-26",
			33.01
		],
		[
			"2007-09-24",
			34.01
		],
		[
			"2008-04-08",
			30.01
		],
		[
			"2008-10-23",
			27.01
		],
		[
			"2009-04-24",
			30.01
		],
		[
			"2009-09-22",
			27.01
		],
		[
			"2010-04-28",
			33.01
		],
		[
			"2010-09-10",
			57.02
		],
		[
			"2010-09-30",
			27.01
		],
		[
			"2012-09-21",
			29.01
		],
		[
			"2012-05-02",
			32.01
		],
		[
			"2013-12-09",
			31.01
		],
		[
			"2013-05-16",
			32.01
		],
		[
			"2014-12-15",
			29.01
		],
		[
			"2014-05-20",
			33.01
		],
		[
			"2015-11-24",
			30.01
		],
		[
			"2015-05-26",
			34.01
		]
	],
	"106505117": [
		[
			"2000-04-06",
			30.01
		],
		[
			"2000-09-20",
			26.01
		],
		[
			"2001-04-19",
			9
		],
		[
			"2001-10-09",
			27.01
		],
		[
			"2002-10-15",
			25.01
		],
		[
			"2007-03-19",
			24.01
		],
		[
			"2006-09-14",
			24.01
		],
		[
			"2006-03-21",
			25.01
		],
		[
			"2005-09-06",
			22.01
		],
		[
			"2005-03-30",
			32.01
		],
		[
			"2004-10-19",
			21.01
		],
		[
			"2003-10-06",
			24.01
		],
		[
			"2003-04-29",
			27.01
		],
		[
			"2006-02-28",
			30.01
		],
		[
			"2006-03-31",
			44.02
		],
		[
			"2006-04-27",
			25.01
		],
		[
			"2006-05-31",
			25.01
		],
		[
			"2006-01-31",
			26.01
		],
		[
			"2006-08-31",
			44.02
		],
		[
			"2006-09-28",
			34.01
		],
		[
			"2006-06-29",
			25.01
		],
		[
			"2006-07-31",
			26.01
		],
		[
			"2006-11-30",
			24.01
		],
		[
			"2006-10-31",
			37.01
		],
		[
			"2007-01-02",
			40.01
		],
		[
			"2007-01-31",
			35.01
		],
		[
			"2007-02-28",
			25.01
		],
		[
			"2007-04-27",
			26.01
		],
		[
			"2007-03-30",
			26.01
		],
		[
			"2007-05-31",
			25.01
		],
		[
			"2007-09-14",
			24.01
		],
		[
			"2007-09-28",
			28.01
		],
		[
			"2007-10-31",
			39.01
		],
		[
			"2007-11-30",
			29.01
		],
		[
			"2007-06-29",
			26.01
		],
		[
			"2007-07-30",
			25.01
		],
		[
			"2007-08-31",
			25.01
		],
		[
			"2007-12-27",
			26.01
		],
		[
			"2008-03-17",
			30.01
		],
		[
			"2008-03-31",
			28.01
		],
		[
			"2008-01-31",
			25.01
		],
		[
			"2008-04-30",
			32.01
		],
		[
			"2008-08-29",
			45.02
		],
		[
			"2008-05-30",
			32.01
		],
		[
			"2008-09-23",
			30.01
		],
		[
			"2008-09-30",
			30.01
		],
		[
			"2008-02-29",
			36.01
		],
		[
			"2008-10-31",
			29.01
		],
		[
			"2008-11-28",
			29.01
		],
		[
			"2008-06-30",
			36.01
		],
		[
			"2008-07-31",
			34.01
		],
		[
			"2009-03-31",
			32.01
		],
		[
			"2009-05-29",
			32.01
		],
		[
			"2009-07-31",
			33.01
		],
		[
			"2009-01-30",
			26.01
		],
		[
			"2009-03-17",
			30.01
		],
		[
			"2009-04-30",
			31.01
		],
		[
			"2009-06-30",
			30.01
		],
		[
			"2009-11-30",
			28.01
		],
		[
			"2009-08-31",
			30.01
		],
		[
			"2009-10-30",
			28.01
		],
		[
			"2009-09-01",
			31.01
		],
		[
			"2009-09-30",
			31.01
		],
		[
			"2010-03-03",
			30.01
		],
		[
			"2010-03-30",
			31.01
		],
		[
			"2010-01-04",
			28.01
		],
		[
			"2010-01-29",
			29.01
		],
		[
			"2010-02-26",
			30.01
		],
		[
			"2010-05-31",
			30.01
		],
		[
			"2010-04-30",
			31.01
		],
		[
			"2010-06-29",
			28.01
		],
		[
			"2010-11-02",
			31.01
		],
		[
			"2010-11-30",
			31.01
		],
		[
			"2010-07-30",
			27.01
		],
		[
			"2010-08-31",
			30.01
		],
		[
			"2010-09-06",
			31.01
		],
		[
			"2010-09-30",
			27.01
		],
		[
			"2009-02-27",
			28.01
		],
		[
			"2012-11-30",
			30.01
		],
		[
			"2012-10-31",
			28.01
		],
		[
			"2012-09-28",
			29.01
		],
		[
			"2012-08-31",
			29.01
		],
		[
			"2012-07-31",
			29.01
		],
		[
			"2012-06-29",
			30.01
		],
		[
			"2012-05-31",
			30.01
		],
		[
			"2012-05-02",
			31.01
		],
		[
			"2012-04-02",
			31.01
		],
		[
			"2012-03-30",
			31.01
		],
		[
			"2012-02-29",
			31.01
		],
		[
			"2012-01-31",
			30.01
		],
		[
			"2012-01-02",
			26.01
		],
		[
			"2013-11-29",
			30.01
		],
		[
			"2013-11-04",
			29.01
		],
		[
			"2013-09-30",
			28.01
		],
		[
			"2013-09-02",
			29.01
		],
		[
			"2013-07-31",
			29.01
		],
		[
			"2013-07-01",
			29.01
		],
		[
			"2013-06-03",
			29.01
		],
		[
			"2013-04-30",
			28.01
		],
		[
			"2013-03-28",
			30.01
		],
		[
			"2013-03-14",
			29.01
		],
		[
			"2013-02-28",
			29.01
		],
		[
			"2013-01-31",
			29.01
		],
		[
			"2013-01-02",
			30.01
		],
		[
			"2014-12-01",
			29.01
		],
		[
			"2014-11-03",
			28.01
		],
		[
			"2014-09-29",
			28.01
		],
		[
			"2014-09-02",
			29.01
		],
		[
			"2014-07-31",
			29.01
		],
		[
			"2014-06-30",
			36.01
		],
		[
			"2014-05-28",
			31.01
		],
		[
			"2014-04-30",
			30.01
		],
		[
			"2014-04-01",
			31.01
		],
		[
			"2014-03-20",
			30.01
		],
		[
			"2014-02-28",
			30.01
		],
		[
			"2014-01-31",
			30.01
		],
		[
			"2015-11-30",
			28.01
		],
		[
			"2015-10-02",
			34.01
		],
		[
			"2015-08-27",
			28.01
		],
		[
			"2015-07-30",
			27.01
		],
		[
			"2015-06-30",
			34.01
		],
		[
			"2015-06-01",
			28.01
		],
		[
			"2015-04-30",
			28.01
		],
		[
			"2015-04-08",
			27.01
		],
		[
			"2015-03-31",
			27.01
		],
		[
			"2015-02-27",
			20.01
		],
		[
			"2015-01-30",
			22.01
		]
	],
	"106505129": [
		[
			"2000-04-06",
			20.01
		],
		[
			"2000-09-20",
			20.01
		],
		[
			"2001-04-19",
			21.01
		],
		[
			"2001-10-09",
			21.01
		],
		[
			"2002-10-10",
			17.01
		],
		[
			"2007-03-19",
			21.01
		],
		[
			"2006-09-14",
			17.01
		],
		[
			"2006-03-21",
			21.01
		],
		[
			"2005-09-06",
			16.01
		],
		[
			"2005-03-30",
			18.01
		],
		[
			"2004-09-28",
			16.01
		],
		[
			"2003-10-06",
			18.01
		],
		[
			"2003-04-29",
			18.01
		],
		[
			"2004-04-20",
			17.01
		],
		[
			"2006-08-31",
			18.01
		],
		[
			"2007-09-14",
			19.01
		],
		[
			"2008-04-30",
			23.01
		],
		[
			"2008-01-31",
			19.01
		],
		[
			"2008-07-31",
			21.01
		],
		[
			"2008-08-29",
			20.01
		],
		[
			"2008-09-23",
			19.01
		],
		[
			"2008-10-31",
			20.01
		],
		[
			"2008-02-29",
			18.01
		],
		[
			"2008-03-17",
			18.01
		],
		[
			"2008-03-31",
			21.01
		],
		[
			"2008-05-30",
			19.01
		],
		[
			"2008-06-30",
			18.01
		],
		[
			"2008-11-28",
			20.01
		],
		[
			"2009-03-31",
			22.01
		],
		[
			"2009-04-30",
			21.01
		],
		[
			"2009-02-27",
			20.01
		],
		[
			"2009-03-17",
			22.01
		],
		[
			"2009-01-30",
			19.01
		],
		[
			"2009-05-29",
			20.01
		],
		[
			"2009-06-30",
			19.01
		],
		[
			"2009-08-31",
			17.01
		],
		[
			"2009-09-30",
			22.01
		],
		[
			"2009-11-30",
			20.01
		],
		[
			"2009-10-30",
			19.01
		],
		[
			"2009-07-31",
			20.01
		],
		[
			"2009-09-01",
			19.01
		],
		[
			"2010-01-04",
			20.01
		],
		[
			"2010-03-03",
			22.01
		],
		[
			"2010-03-30",
			20.01
		],
		[
			"2010-01-29",
			20.01
		],
		[
			"2010-02-26",
			19.01
		],
		[
			"2010-05-31",
			18.01
		],
		[
			"2010-04-30",
			19.01
		],
		[
			"2010-06-29",
			17.01
		],
		[
			"2010-07-30",
			17.01
		],
		[
			"2010-11-02",
			18.01
		],
		[
			"2010-08-31",
			18.01
		],
		[
			"2010-09-06",
			19.01
		],
		[
			"2010-09-30",
			19.01
		],
		[
			"2010-11-30",
			19.01
		],
		[
			"2008-09-30",
			20.01
		],
		[
			"2012-11-30",
			19.01
		],
		[
			"2012-10-31",
			17.01
		],
		[
			"2012-09-28",
			18.01
		],
		[
			"2012-08-31",
			18.01
		],
		[
			"2012-07-31",
			17.01
		],
		[
			"2012-06-29",
			18.01
		],
		[
			"2012-05-31",
			17.01
		],
		[
			"2012-05-02",
			19.01
		],
		[
			"2012-04-02",
			18.01
		],
		[
			"2012-03-30",
			18.01
		],
		[
			"2012-02-29",
			20.01
		],
		[
			"2012-01-31",
			19.01
		],
		[
			"2013-11-29",
			19.01
		],
		[
			"2013-11-05",
			19.01
		],
		[
			"2013-09-30",
			17.01
		],
		[
			"2013-09-02",
			18.01
		],
		[
			"2013-07-31",
			17.01
		],
		[
			"2013-07-01",
			26.01
		],
		[
			"2013-06-03",
			18.01
		],
		[
			"2013-04-30",
			17.01
		],
		[
			"2013-03-28",
			18.01
		],
		[
			"2013-03-14",
			18.01
		],
		[
			"2013-02-28",
			18.01
		],
		[
			"2013-01-31",
			18.01
		],
		[
			"2013-01-02",
			20.01
		],
		[
			"2014-12-01",
			19.01
		],
		[
			"2014-11-03",
			19.01
		],
		[
			"2014-09-29",
			18.01
		],
		[
			"2014-09-02",
			19.01
		],
		[
			"2014-07-31",
			19.01
		],
		[
			"2014-06-30",
			18.01
		],
		[
			"2014-05-28",
			19.01
		],
		[
			"2014-04-30",
			18.01
		],
		[
			"2014-04-01",
			19.01
		],
		[
			"2014-03-20",
			19.01
		],
		[
			"2014-02-28",
			19.01
		],
		[
			"2014-01-31",
			18.01
		],
		[
			"2013-12-30",
			20.01
		],
		[
			"2015-11-30",
			20.01
		],
		[
			"2015-10-30",
			19.01
		],
		[
			"2015-10-01",
			19.01
		],
		[
			"2015-08-27",
			19.01
		],
		[
			"2015-07-30",
			19.01
		],
		[
			"2015-06-30",
			19.01
		],
		[
			"2015-06-01",
			18.01
		],
		[
			"2015-04-30",
			19.01
		],
		[
			"2015-04-08",
			19.01
		],
		[
			"2015-03-31",
			13
		],
		[
			"2015-02-27",
			19.01
		],
		[
			"2015-01-30",
			20.01
		]
	],
	"106505154": [
		[
			"2000-04-06",
			25.01
		],
		[
			"2000-09-20",
			27.01
		],
		[
			"2001-04-19",
			28.01
		],
		[
			"2001-10-09",
			29.01
		],
		[
			"2002-10-15",
			24.01
		],
		[
			"2007-03-19",
			25.01
		],
		[
			"2006-09-14",
			25.01
		],
		[
			"2006-03-21",
			27.01
		],
		[
			"2005-09-06",
			24.01
		],
		[
			"2005-03-30",
			24.01
		],
		[
			"2004-04-20",
			20.01
		],
		[
			"2004-09-28",
			22.01
		],
		[
			"2003-10-06",
			22.01
		],
		[
			"2003-04-29",
			21.01
		],
		[
			"2006-01-31",
			29.01
		],
		[
			"2006-03-31",
			27.01
		],
		[
			"2006-04-27",
			27.01
		],
		[
			"2006-05-31",
			25.01
		],
		[
			"2006-02-28",
			30.01
		],
		[
			"2006-09-28",
			26.01
		],
		[
			"2006-08-31",
			25.01
		],
		[
			"2006-10-31",
			25.01
		],
		[
			"2006-05-18",
			26.01
		],
		[
			"2006-06-29",
			25.01
		],
		[
			"2006-07-31",
			26.01
		],
		[
			"2006-11-30",
			28.01
		],
		[
			"2007-04-27",
			24.01
		],
		[
			"2007-01-31",
			18.01
		],
		[
			"2007-02-28",
			20.01
		],
		[
			"2007-03-30",
			25.01
		],
		[
			"2007-05-31",
			24.01
		],
		[
			"2007-01-02",
			27.01
		],
		[
			"2007-06-29",
			25.01
		],
		[
			"2007-07-30",
			23.01
		],
		[
			"2007-08-31",
			26.01
		],
		[
			"2007-07-10",
			24.01
		],
		[
			"2007-09-28",
			27.01
		],
		[
			"2007-11-30",
			25.01
		],
		[
			"2007-12-27",
			23.01
		],
		[
			"2007-10-31",
			26.01
		],
		[
			"2008-03-17",
			23.01
		],
		[
			"2008-01-31",
			22.01
		],
		[
			"2008-04-30",
			24.01
		],
		[
			"2008-05-30",
			23.01
		],
		[
			"2008-08-29",
			23.01
		],
		[
			"2008-09-23",
			24.01
		],
		[
			"2008-09-30",
			24.01
		],
		[
			"2008-06-30",
			22.01
		],
		[
			"2008-10-31",
			24.01
		],
		[
			"2008-02-29",
			21.01
		],
		[
			"2008-03-31",
			22.01
		],
		[
			"2008-11-28",
			27.01
		],
		[
			"2008-07-31",
			24.01
		],
		[
			"2009-06-30",
			22.01
		],
		[
			"2009-07-31",
			24.01
		],
		[
			"2009-02-27",
			24.01
		],
		[
			"2009-05-29",
			23.01
		],
		[
			"2009-01-30",
			22.01
		],
		[
			"2009-03-17",
			24.01
		],
		[
			"2009-03-31",
			25.01
		],
		[
			"2009-04-30",
			23.01
		],
		[
			"2009-08-31",
			23.01
		],
		[
			"2009-09-01",
			23.01
		],
		[
			"2009-09-30",
			24.01
		],
		[
			"2009-11-30",
			24.01
		],
		[
			"2009-10-30",
			24.01
		],
		[
			"2010-01-04",
			23.01
		],
		[
			"2010-01-29",
			23.01
		],
		[
			"2010-06-29",
			21.01
		],
		[
			"2010-03-03",
			23.01
		],
		[
			"2010-03-30",
			23.01
		],
		[
			"2010-04-30",
			23.01
		],
		[
			"2010-02-26",
			22.01
		],
		[
			"2010-05-31",
			21.01
		],
		[
			"2010-07-30",
			21.01
		],
		[
			"2010-08-31",
			24.01
		],
		[
			"2010-09-06",
			24.01
		],
		[
			"2010-09-30",
			22.01
		],
		[
			"2010-09-20",
			25.01
		],
		[
			"2010-11-02",
			22.01
		],
		[
			"2010-11-30",
			22.01
		],
		[
			"2012-11-30",
			25.01
		],
		[
			"2012-10-31",
			24.01
		],
		[
			"2012-09-28",
			24.01
		],
		[
			"2012-08-31",
			24.01
		],
		[
			"2012-07-31",
			22.01
		],
		[
			"2012-06-29",
			23.01
		],
		[
			"2012-05-31",
			23.01
		],
		[
			"2012-05-02",
			24.01
		],
		[
			"2012-04-02",
			23.01
		],
		[
			"2012-03-30",
			22.01
		],
		[
			"2012-02-29",
			24.01
		],
		[
			"2012-01-31",
			23.01
		],
		[
			"2012-01-02",
			22.01
		],
		[
			"2013-11-29",
			24.01
		],
		[
			"2013-11-04",
			24.01
		],
		[
			"2013-09-30",
			23.01
		],
		[
			"2013-09-02",
			23.01
		],
		[
			"2013-07-31",
			23.01
		],
		[
			"2013-07-01",
			23.01
		],
		[
			"2013-06-03",
			23.01
		],
		[
			"2013-04-30",
			23.01
		],
		[
			"2013-03-28",
			23.01
		],
		[
			"2013-03-14",
			23.01
		],
		[
			"2013-02-28",
			22.01
		],
		[
			"2013-01-31",
			24.01
		],
		[
			"2013-01-02",
			26.01
		],
		[
			"2014-12-01",
			24.01
		],
		[
			"2014-11-03",
			23.01
		],
		[
			"2014-09-29",
			24.01
		],
		[
			"2014-09-02",
			24.01
		],
		[
			"2014-07-31",
			24.01
		],
		[
			"2014-06-30",
			24.01
		],
		[
			"2014-05-28",
			26.01
		],
		[
			"2014-04-30",
			24.01
		],
		[
			"2014-04-01",
			25.01
		],
		[
			"2014-03-20",
			25.01
		],
		[
			"2014-02-28",
			25.01
		],
		[
			"2014-01-31",
			25.01
		],
		[
			"2013-12-30",
			25.01
		],
		[
			"2015-11-30",
			24.01
		],
		[
			"2015-10-30",
			24.01
		],
		[
			"2015-10-01",
			24.01
		],
		[
			"2015-08-27",
			24.01
		],
		[
			"2015-07-30",
			24.01
		],
		[
			"2015-06-30",
			24.01
		],
		[
			"2015-06-01",
			24.01
		],
		[
			"2015-04-30",
			23.01
		],
		[
			"2015-04-08",
			23.01
		],
		[
			"2015-03-31",
			23.01
		],
		[
			"2015-02-27",
			23.01
		],
		[
			"2015-01-30",
			22.01
		]
	],
	"106505166": [
		[
			"2000-04-06",
			40.01
		],
		[
			"2000-09-20",
			38.01
		],
		[
			"2001-04-19",
			39.01
		],
		[
			"2001-10-09",
			38.01
		],
		[
			"2002-10-15",
			36.01
		],
		[
			"2007-03-19",
			33.01
		],
		[
			"2006-09-14",
			30.01
		],
		[
			"2006-03-21",
			31.01
		],
		[
			"2005-09-06",
			27.01
		],
		[
			"2005-04-18",
			31.01
		],
		[
			"2004-09-28",
			27.01
		],
		[
			"2004-04-20",
			29.01
		],
		[
			"2003-10-06",
			32.01
		],
		[
			"2003-04-29",
			35.01
		],
		[
			"2006-08-31",
			30.01
		],
		[
			"2007-09-14",
			31.01
		],
		[
			"2008-02-29",
			36.01
		],
		[
			"2008-01-31",
			35.01
		],
		[
			"2008-03-17",
			35.01
		],
		[
			"2008-03-31",
			36.01
		],
		[
			"2008-04-30",
			36.01
		],
		[
			"2008-05-30",
			35.01
		],
		[
			"2008-06-30",
			30.01
		],
		[
			"2008-09-30",
			34.01
		],
		[
			"2008-07-31",
			36.01
		],
		[
			"2008-10-31",
			33.01
		],
		[
			"2008-11-28",
			35.01
		],
		[
			"2008-08-29",
			33.01
		],
		[
			"2008-09-23",
			34.01
		],
		[
			"2009-01-30",
			31.01
		],
		[
			"2009-03-17",
			33.01
		],
		[
			"2009-03-31",
			36.01
		],
		[
			"2009-04-30",
			33.01
		],
		[
			"2009-06-30",
			31.01
		],
		[
			"2009-07-31",
			32.01
		],
		[
			"2009-05-29",
			31.01
		],
		[
			"2009-02-27",
			32.01
		],
		[
			"2009-09-01",
			30.01
		],
		[
			"2009-11-30",
			31.01
		],
		[
			"2009-10-30",
			29.01
		],
		[
			"2009-08-31",
			30.01
		],
		[
			"2009-09-30",
			31.01
		],
		[
			"2010-01-29",
			32.01
		],
		[
			"2010-03-03",
			32.01
		],
		[
			"2010-03-30",
			33.01
		],
		[
			"2010-04-30",
			31.01
		],
		[
			"2010-01-04",
			30.01
		],
		[
			"2010-02-26",
			32.01
		],
		[
			"2010-06-29",
			27.01
		],
		[
			"2010-05-31",
			29.01
		],
		[
			"2010-09-30",
			27.01
		],
		[
			"2010-11-02",
			30.01
		],
		[
			"2010-09-06",
			30.01
		],
		[
			"2010-07-30",
			27.01
		],
		[
			"2010-08-31",
			30.01
		],
		[
			"2010-11-30",
			29.01
		],
		[
			"2012-11-30",
			30.01
		],
		[
			"2012-10-31",
			28.01
		],
		[
			"2012-09-28",
			28.01
		],
		[
			"2012-08-31",
			29.01
		],
		[
			"2012-07-31",
			28.01
		],
		[
			"2012-06-29",
			29.01
		],
		[
			"2012-05-31",
			29.01
		],
		[
			"2012-05-02",
			31.01
		],
		[
			"2012-04-02",
			32.01
		],
		[
			"2012-03-30",
			30.01
		],
		[
			"2012-02-29",
			32.01
		],
		[
			"2012-01-31",
			34.01
		],
		[
			"2012-01-02",
			31.01
		],
		[
			"2013-11-29",
			29.01
		],
		[
			"2013-11-04",
			28.01
		],
		[
			"2013-09-30",
			27.01
		],
		[
			"2013-09-02",
			28.01
		],
		[
			"2013-07-31",
			29.01
		],
		[
			"2013-07-01",
			29.01
		],
		[
			"2013-06-03",
			30.01
		],
		[
			"2013-04-30",
			29.01
		],
		[
			"2013-03-28",
			31.01
		],
		[
			"2013-03-14",
			29.01
		],
		[
			"2013-02-28",
			31.01
		],
		[
			"2013-01-31",
			31.01
		],
		[
			"2013-01-02",
			34.01
		],
		[
			"2014-12-01",
			27.01
		],
		[
			"2014-11-03",
			28.01
		],
		[
			"2014-09-29",
			28.01
		],
		[
			"2014-09-02",
			28.01
		],
		[
			"2014-07-31",
			28.01
		],
		[
			"2014-06-30",
			28.01
		],
		[
			"2014-05-28",
			36.01
		],
		[
			"2014-04-30",
			29.01
		],
		[
			"2014-04-01",
			30.01
		],
		[
			"2014-03-20",
			29.01
		],
		[
			"2014-02-28",
			30.01
		],
		[
			"2014-01-31",
			30.01
		],
		[
			"2013-12-30",
			33.01
		],
		[
			"2015-11-30",
			29.01
		],
		[
			"2015-10-30",
			27.01
		],
		[
			"2015-10-02",
			28.01
		],
		[
			"2015-08-27",
			28.01
		],
		[
			"2015-07-30",
			28.01
		],
		[
			"2015-06-30",
			27.01
		],
		[
			"2015-06-01",
			29.01
		],
		[
			"2015-04-30",
			28.01
		],
		[
			"2015-04-08",
			29.01
		],
		[
			"2015-03-31",
			28.01
		],
		[
			"2015-02-27",
			28.01
		],
		[
			"2015-01-30",
			27.01
		]
	],
	"106505178": [
		[
			"2000-04-06",
			28.01
		],
		[
			"2000-09-20",
			28.01
		],
		[
			"2001-04-19",
			27.01
		],
		[
			"2001-10-09",
			29.01
		],
		[
			"2002-10-10",
			26.01
		],
		[
			"2007-03-19",
			25.01
		],
		[
			"2006-09-14",
			23.01
		],
		[
			"2006-03-21",
			24.01
		],
		[
			"2005-09-06",
			23.01
		],
		[
			"2005-03-30",
			24.01
		],
		[
			"2004-12-06",
			30.01
		],
		[
			"2004-11-30",
			29.01
		],
		[
			"2004-09-28",
			25.01
		],
		[
			"2004-04-20",
			24.01
		],
		[
			"2003-10-06",
			27.01
		],
		[
			"2003-04-29",
			27.01
		],
		[
			"2006-08-31",
			24.01
		],
		[
			"2008-01-31",
			24.01
		],
		[
			"2008-02-29",
			19.01
		],
		[
			"2008-03-17",
			24.01
		],
		[
			"2008-04-30",
			26.01
		],
		[
			"2008-09-30",
			29.01
		],
		[
			"2008-08-29",
			27.01
		],
		[
			"2008-10-31",
			28.01
		],
		[
			"2008-03-31",
			27.01
		],
		[
			"2008-05-30",
			27.01
		],
		[
			"2008-06-30",
			24.01
		],
		[
			"2008-07-31",
			17.01
		],
		[
			"2008-09-23",
			29.01
		],
		[
			"2008-11-28",
			28.01
		],
		[
			"2009-02-27",
			26.01
		],
		[
			"2009-04-30",
			23.01
		],
		[
			"2009-01-30",
			21.01
		],
		[
			"2009-03-17",
			13
		],
		[
			"2009-03-31",
			27.01
		],
		[
			"2009-05-29",
			17.01
		],
		[
			"2009-09-30",
			27.01
		],
		[
			"2009-08-31",
			27.01
		],
		[
			"2009-07-31",
			27.01
		],
		[
			"2009-09-01",
			27.01
		],
		[
			"2009-11-30",
			25.01
		],
		[
			"2009-06-30",
			25.01
		],
		[
			"2009-10-30",
			26.01
		],
		[
			"2010-01-29",
			25.01
		],
		[
			"2010-04-30",
			26.01
		],
		[
			"2010-05-31",
			24.01
		],
		[
			"2010-06-29",
			23.01
		],
		[
			"2010-02-26",
			26.01
		],
		[
			"2010-03-03",
			24.01
		],
		[
			"2010-03-30",
			25.01
		],
		[
			"2010-01-04",
			26.01
		],
		[
			"2010-09-06",
			26.01
		],
		[
			"2010-07-30",
			21.01
		],
		[
			"2010-08-31",
			26.01
		],
		[
			"2010-11-02",
			26.01
		],
		[
			"2010-09-30",
			23.01
		],
		[
			"2010-11-30",
			26.01
		],
		[
			"2012-11-30",
			27.01
		],
		[
			"2012-10-31",
			26.01
		],
		[
			"2012-09-28",
			26.01
		],
		[
			"2012-08-31",
			27.01
		],
		[
			"2012-07-31",
			27.01
		],
		[
			"2012-06-29",
			27.01
		],
		[
			"2012-05-31",
			27.01
		],
		[
			"2012-05-02",
			28.01
		],
		[
			"2012-04-02",
			29.01
		],
		[
			"2012-03-30",
			29.01
		],
		[
			"2012-02-29",
			28.01
		],
		[
			"2012-01-31",
			28.01
		],
		[
			"2012-01-02",
			25.01
		],
		[
			"2013-11-29",
			26.01
		],
		[
			"2013-11-04",
			26.01
		],
		[
			"2013-09-30",
			25.01
		],
		[
			"2013-09-02",
			25.01
		],
		[
			"2013-07-31",
			15.01
		],
		[
			"2013-07-01",
			26.01
		],
		[
			"2013-06-03",
			26.01
		],
		[
			"2013-04-30",
			25.01
		],
		[
			"2013-03-28",
			26.01
		],
		[
			"2013-03-14",
			24.01
		],
		[
			"2013-02-28",
			26.01
		],
		[
			"2013-01-31",
			26.01
		],
		[
			"2013-01-02",
			28.01
		],
		[
			"2014-12-01",
			27.01
		],
		[
			"2014-11-03",
			26.01
		],
		[
			"2014-09-29",
			26.01
		],
		[
			"2014-09-02",
			27.01
		],
		[
			"2014-07-31",
			27.01
		],
		[
			"2014-07-16",
			26.01
		],
		[
			"2014-06-30",
			56.02
		],
		[
			"2014-05-28",
			28.01
		],
		[
			"2014-04-30",
			26.01
		],
		[
			"2014-04-01",
			27.01
		],
		[
			"2014-03-20",
			27.01
		],
		[
			"2014-02-28",
			27.01
		],
		[
			"2014-01-31",
			27.01
		],
		[
			"2013-12-30",
			26.01
		],
		[
			"2015-11-30",
			27.01
		],
		[
			"2015-10-30",
			27.01
		],
		[
			"2015-10-01",
			28.01
		],
		[
			"2015-08-27",
			28.01
		],
		[
			"2015-07-30",
			28.01
		],
		[
			"2015-06-30",
			28.01
		],
		[
			"2015-06-01",
			28.01
		],
		[
			"2015-04-30",
			29.01
		],
		[
			"2015-04-08",
			28.01
		],
		[
			"2015-03-31",
			28.01
		],
		[
			"2015-02-27",
			28.01
		],
		[
			"2015-01-30",
			28.01
		]
	],
	"106505180": [
		[
			"2000-04-06",
			36.01
		],
		[
			"2000-09-20",
			37.01
		],
		[
			"2001-04-19",
			35.01
		],
		[
			"2001-10-09",
			32.01
		],
		[
			"2002-10-10",
			28.01
		],
		[
			"2007-03-19",
			34.01
		],
		[
			"2006-09-14",
			35.01
		],
		[
			"2006-03-21",
			36.01
		],
		[
			"2005-09-06",
			33.01
		],
		[
			"2005-04-18",
			31.01
		],
		[
			"2004-09-28",
			29.01
		],
		[
			"2004-04-20",
			26.01
		],
		[
			"2003-10-06",
			30.01
		],
		[
			"2003-04-29",
			31.01
		],
		[
			"2010-03-03",
			38.01
		],
		[
			"2010-04-30",
			39.01
		],
		[
			"2010-03-30",
			41.01
		],
		[
			"2010-01-04",
			35.01
		],
		[
			"2010-01-29",
			38.01
		],
		[
			"2010-02-26",
			40.01
		],
		[
			"2010-05-31",
			38.01
		],
		[
			"2010-06-29",
			35.01
		],
		[
			"2010-08-31",
			39.01
		],
		[
			"2010-09-30",
			31.01
		],
		[
			"2010-09-06",
			36.01
		],
		[
			"2010-11-02",
			37.01
		],
		[
			"2010-11-30",
			40.01
		],
		[
			"2010-07-30",
			35.01
		],
		[
			"2009-06-30",
			38.01
		],
		[
			"2009-03-17",
			36.01
		],
		[
			"2009-04-30",
			39.01
		],
		[
			"2009-07-31",
			40.01
		],
		[
			"2009-02-27",
			35.01
		],
		[
			"2009-01-30",
			36.01
		],
		[
			"2009-03-31",
			40.01
		],
		[
			"2009-05-29",
			38.01
		],
		[
			"2009-09-30",
			40.01
		],
		[
			"2009-10-30",
			39.01
		],
		[
			"2009-08-31",
			39.01
		],
		[
			"2009-11-30",
			36.01
		],
		[
			"2009-09-01",
			39.01
		],
		[
			"2008-02-29",
			38.01
		],
		[
			"2008-04-30",
			38.01
		],
		[
			"2008-03-31",
			39.01
		],
		[
			"2008-01-31",
			36.01
		],
		[
			"2008-03-17",
			36.01
		],
		[
			"2008-05-30",
			38.01
		],
		[
			"2008-06-30",
			33.01
		],
		[
			"2008-08-29",
			38.01
		],
		[
			"2008-09-23",
			40.01
		],
		[
			"2008-09-30",
			40.01
		],
		[
			"2008-10-31",
			40.01
		],
		[
			"2008-07-31",
			41.01
		],
		[
			"2008-11-28",
			41.01
		],
		[
			"2012-11-30",
			44.02
		],
		[
			"2012-10-31",
			44.02
		],
		[
			"2012-09-28",
			45.02
		],
		[
			"2012-08-31",
			45.02
		],
		[
			"2012-07-31",
			46.02
		],
		[
			"2012-06-29",
			46.02
		],
		[
			"2012-05-31",
			45.02
		],
		[
			"2012-05-02",
			46.02
		],
		[
			"2012-04-02",
			46.02
		],
		[
			"2012-03-30",
			46.02
		],
		[
			"2012-02-29",
			46.02
		],
		[
			"2012-01-31",
			45.02
		],
		[
			"2012-01-02",
			41.01
		],
		[
			"2013-11-29",
			45.02
		],
		[
			"2013-11-04",
			46.02
		],
		[
			"2013-09-30",
			44.02
		],
		[
			"2013-09-02",
			46.02
		],
		[
			"2013-07-31",
			46.02
		],
		[
			"2013-07-01",
			45.02
		],
		[
			"2013-06-03",
			44.02
		],
		[
			"2013-04-30",
			45.02
		],
		[
			"2013-03-28",
			47.02
		],
		[
			"2013-03-14",
			45.02
		],
		[
			"2013-02-28",
			46.02
		],
		[
			"2013-01-31",
			46.02
		],
		[
			"2013-01-02",
			46.02
		],
		[
			"2014-12-01",
			43.02
		],
		[
			"2014-11-03",
			42.01
		],
		[
			"2014-09-29",
			44.02
		],
		[
			"2014-09-02",
			47.02
		],
		[
			"2014-07-31",
			33.01
		],
		[
			"2014-07-16",
			41.01
		],
		[
			"2014-06-30",
			36.01
		],
		[
			"2014-05-28",
			51.02
		],
		[
			"2014-04-30",
			48.02
		],
		[
			"2014-04-01",
			50.02
		],
		[
			"2014-03-20",
			49.02
		],
		[
			"2014-02-28",
			50.02
		],
		[
			"2014-01-31",
			49.02
		],
		[
			"2014-01-09",
			46.02
		],
		[
			"2013-12-30",
			45.02
		],
		[
			"2015-11-30",
			39.01
		],
		[
			"2015-10-30",
			39.01
		],
		[
			"2015-10-01",
			44.02
		],
		[
			"2015-08-27",
			47.02
		],
		[
			"2015-07-30",
			47.02
		],
		[
			"2015-06-30",
			47.02
		],
		[
			"2015-06-01",
			47.02
		],
		[
			"2015-04-30",
			47.02
		],
		[
			"2015-04-08",
			46.02
		],
		[
			"2015-03-31",
			44.02
		],
		[
			"2015-02-27",
			45.02
		],
		[
			"2015-01-30",
			45.02
		]
	],
	"106505233": [
		[
			"2000-05-10",
			11
		],
		[
			"2000-11-15",
			11
		],
		[
			"2002-04-23",
			11
		],
		[
			"2002-11-12",
			11
		],
		[
			"2003-03-20",
			11
		],
		[
			"2003-12-01",
			11
		],
		[
			"2004-03-18",
			11
		],
		[
			"2004-09-28",
			11
		],
		[
			"2005-09-26",
			11
		],
		[
			"2005-04-27",
			11
		],
		[
			"2006-11-09",
			11
		],
		[
			"2006-05-10",
			11
		],
		[
			"2007-03-20",
			11
		],
		[
			"2007-11-15",
			11
		],
		[
			"2008-05-08",
			10
		],
		[
			"2008-10-23",
			11
		],
		[
			"2009-05-05",
			11
		],
		[
			"2009-10-13",
			12
		],
		[
			"2010-03-23",
			12
		],
		[
			"2010-10-27",
			11
		],
		[
			"2011-05-04",
			11
		],
		[
			"2011-11-07",
			11
		],
		[
			"2012-05-21",
			12
		],
		[
			"2012-10-29",
			11
		],
		[
			"2013-06-06",
			11
		],
		[
			"2013-10-24",
			11
		],
		[
			"2014-03-31",
			11
		],
		[
			"2014-10-30",
			11
		],
		[
			"2015-03-25",
			11
		],
		[
			"2015-10-08",
			18.01
		]
	],
	"106505312": [
		[
			"2002-11-28",
			18.01
		],
		[
			"2003-03-26",
			17.01
		],
		[
			"2003-11-13",
			20.01
		],
		[
			"2004-05-05",
			18.01
		],
		[
			"2004-11-10",
			21.01
		],
		[
			"2005-04-27",
			18.01
		],
		[
			"2005-10-20",
			22.01
		],
		[
			"2006-10-25",
			21.01
		],
		[
			"2006-05-04",
			26.01
		],
		[
			"2007-03-22",
			24.01
		],
		[
			"2007-10-08",
			28.01
		],
		[
			"2008-04-16",
			19.01
		],
		[
			"2008-11-12",
			23.01
		],
		[
			"2009-05-12",
			20.01
		],
		[
			"2009-10-20",
			22.01
		],
		[
			"2010-03-25",
			25.01
		],
		[
			"2010-10-27",
			22.01
		],
		[
			"2011-05-17",
			19.01
		],
		[
			"2011-11-10",
			22.01
		],
		[
			"2012-05-29",
			20.01
		],
		[
			"2012-10-23",
			15.01
		],
		[
			"2013-04-08",
			19.01
		],
		[
			"2013-10-21",
			21.01
		],
		[
			"2014-03-27",
			20.01
		],
		[
			"2014-10-29",
			14
		],
		[
			"2015-04-15",
			23.01
		],
		[
			"2015-10-29",
			19.01
		]
	],
	"106505439": [
		[
			"2000-05-11",
			32.01
		],
		[
			"2000-11-10",
			35.01
		],
		[
			"2001-11-15",
			50.02
		],
		[
			"2001-03-16",
			34.01
		],
		[
			"2002-03-12",
			31.01
		],
		[
			"2002-11-11",
			35.01
		],
		[
			"2005-04-11",
			39.01
		],
		[
			"2005-11-14",
			35.01
		],
		[
			"2003-03-10",
			32.01
		],
		[
			"2003-10-13",
			31.01
		],
		[
			"2006-10-18",
			31.01
		],
		[
			"2007-04-02",
			33.01
		],
		[
			"2007-09-19",
			30.01
		],
		[
			"2008-04-14",
			29.01
		],
		[
			"2008-10-06",
			31.01
		],
		[
			"2008-12-11",
			33.01
		],
		[
			"2009-11-09",
			29.01
		],
		[
			"2010-05-10",
			27.01
		],
		[
			"2010-11-08",
			31.01
		],
		[
			"2012-11-12",
			29.01
		],
		[
			"2012-05-14",
			27.01
		],
		[
			"2013-11-11",
			28.01
		],
		[
			"2013-05-17",
			28.01
		],
		[
			"2014-11-10",
			28.01
		],
		[
			"2014-05-12",
			28.01
		],
		[
			"2015-11-09",
			28.01
		],
		[
			"2015-05-11",
			28.01
		]
	],
	"106505452": [
		[
			"2000-02-23",
			46.02
		],
		[
			"2000-09-13",
			50.02
		],
		[
			"2000-11-09",
			50.02
		],
		[
			"2002-12-09",
			54.02
		],
		[
			"2005-11-15",
			53.02
		],
		[
			"2003-01-06",
			51.02
		],
		[
			"2003-04-11",
			51.02
		],
		[
			"2003-10-14",
			52.02
		],
		[
			"2006-10-19",
			51.02
		],
		[
			"2007-07-17",
			51.02
		],
		[
			"2007-10-29",
			55.02
		],
		[
			"2007-09-19",
			54.02
		],
		[
			"2008-04-14",
			56.02
		],
		[
			"2008-10-06",
			57.02
		],
		[
			"2008-07-08",
			52.02
		],
		[
			"2010-05-10",
			53.02
		],
		[
			"2010-11-08",
			55.02
		],
		[
			"2013-11-11",
			53.02
		],
		[
			"2014-11-10",
			54.02
		],
		[
			"2014-05-12",
			55.02
		],
		[
			"2015-09-14",
			50.02
		]
	],
	"106505520": [
		[
			"2000-04-11",
			13
		],
		[
			"2000-09-12",
			13
		],
		[
			"2001-04-03",
			14
		],
		[
			"2002-09-24",
			13
		],
		[
			"2007-03-15",
			12
		],
		[
			"2009-03-10",
			13
		],
		[
			"2010-03-04",
			13
		],
		[
			"2012-03-20",
			13
		],
		[
			"2013-03-21",
			12
		],
		[
			"2014-03-05",
			12
		],
		[
			"2015-04-21",
			13
		]
	],
	"106505853": [
		[
			"2000-04-11",
			20.01
		],
		[
			"2000-09-12",
			20.01
		],
		[
			"2001-04-03",
			21.01
		],
		[
			"2001-09-11",
			21.01
		],
		[
			"2002-09-24",
			10
		],
		[
			"2006-03-29",
			22.01
		],
		[
			"2006-11-22",
			17.01
		],
		[
			"2007-03-15",
			23.01
		],
		[
			"2013-03-21",
			24.01
		],
		[
			"2014-04-29",
			20.01
		],
		[
			"2014-03-05",
			24.01
		],
		[
			"2015-04-21",
			23.01
		]
	],
	"106505877": [
		[
			"2000-04-11",
			15.01
		],
		[
			"2000-09-12",
			16.01
		],
		[
			"2001-04-03",
			15.01
		],
		[
			"2001-09-11",
			14
		],
		[
			"2002-09-24",
			14
		],
		[
			"2006-03-29",
			15.01
		],
		[
			"2006-11-22",
			13
		],
		[
			"2007-03-15",
			13
		],
		[
			"2007-09-20",
			13
		],
		[
			"2008-04-17",
			13
		],
		[
			"2008-10-22",
			15.01
		],
		[
			"2009-03-10",
			12
		],
		[
			"2009-09-17",
			14
		],
		[
			"2010-03-04",
			12
		],
		[
			"2010-09-16",
			13
		],
		[
			"2012-09-18",
			12
		],
		[
			"2012-03-20",
			13
		],
		[
			"2013-11-07",
			12
		],
		[
			"2013-03-21",
			11
		],
		[
			"2014-11-04",
			11
		],
		[
			"2014-04-29",
			12
		],
		[
			"2015-09-21",
			12
		],
		[
			"2015-04-21",
			12
		]
	],
	"106506020": [
		[
			"2000-05-02",
			24.01
		],
		[
			"2000-09-21",
			23.01
		],
		[
			"2001-04-17",
			23.01
		],
		[
			"2001-10-04",
			23.01
		],
		[
			"2002-10-14",
			23.01
		],
		[
			"2002-04-11",
			19.01
		],
		[
			"2005-11-08",
			17.01
		],
		[
			"2005-04-04",
			18.01
		],
		[
			"2004-10-18",
			19.01
		],
		[
			"2004-05-04",
			20.01
		],
		[
			"2003-11-06",
			18.01
		],
		[
			"2003-04-02",
			21.01
		],
		[
			"2007-04-19",
			20.01
		],
		[
			"2006-10-16",
			19.01
		],
		[
			"2006-04-11",
			20.01
		],
		[
			"2007-10-09",
			21.01
		],
		[
			"2008-04-01",
			20.01
		],
		[
			"2008-09-19",
			22.01
		],
		[
			"2008-10-24",
			20.01
		],
		[
			"2009-04-08",
			22.01
		],
		[
			"2009-10-19",
			21.01
		],
		[
			"2010-04-13",
			21.01
		],
		[
			"2010-10-22",
			19.01
		],
		[
			"2012-10-25",
			18.01
		],
		[
			"2012-04-18",
			20.01
		],
		[
			"2013-11-18",
			19.01
		],
		[
			"2013-04-23",
			17.01
		],
		[
			"2014-10-29",
			18.01
		],
		[
			"2014-04-24",
			18.01
		],
		[
			"2015-10-15",
			17.01
		],
		[
			"2015-04-09",
			18.01
		]
	],
	"106506031": [
		[
			"2000-05-02",
			23.01
		],
		[
			"2000-09-21",
			21.01
		],
		[
			"2001-04-17",
			28.01
		],
		[
			"2001-10-04",
			24.01
		],
		[
			"2002-04-11",
			21.01
		],
		[
			"2005-11-08",
			12
		],
		[
			"2005-04-04",
			17.01
		],
		[
			"2004-10-18",
			17.01
		],
		[
			"2004-05-04",
			22.01
		],
		[
			"2003-11-06",
			15.01
		],
		[
			"2003-04-02",
			20.01
		],
		[
			"2007-04-19",
			20.01
		],
		[
			"2006-10-16",
			18.01
		],
		[
			"2006-04-11",
			17.01
		],
		[
			"2007-10-09",
			21.01
		],
		[
			"2008-04-01",
			16.01
		],
		[
			"2008-10-09",
			17.01
		],
		[
			"2009-04-08",
			20.01
		],
		[
			"2009-10-19",
			14
		],
		[
			"2010-04-13",
			13
		],
		[
			"2010-10-22",
			14
		],
		[
			"2012-10-25",
			28.01
		],
		[
			"2012-04-18",
			16.01
		],
		[
			"2013-11-18",
			14
		],
		[
			"2013-04-23",
			16.01
		],
		[
			"2014-10-29",
			17.01
		],
		[
			"2014-04-24",
			14
		],
		[
			"2015-10-15",
			13
		],
		[
			"2015-04-09",
			13
		]
	],
	"106506043": [
		[
			"2000-05-02",
			10
		],
		[
			"2000-09-21",
			8
		],
		[
			"2001-04-17",
			10
		],
		[
			"2001-10-04",
			9
		],
		[
			"2002-10-14",
			10
		],
		[
			"2002-04-11",
			8
		],
		[
			"2005-11-08",
			8
		],
		[
			"2005-04-04",
			7
		],
		[
			"2004-10-18",
			8
		],
		[
			"2004-05-04",
			9
		],
		[
			"2003-11-06",
			7
		],
		[
			"2003-04-02",
			13
		],
		[
			"2007-04-19",
			7
		],
		[
			"2006-10-16",
			8
		],
		[
			"2006-04-11",
			10
		],
		[
			"2007-10-09",
			12
		],
		[
			"2008-10-09",
			9
		],
		[
			"2008-04-01",
			11
		],
		[
			"2009-04-08",
			11
		],
		[
			"2009-10-19",
			9
		],
		[
			"2010-04-13",
			11
		],
		[
			"2010-10-22",
			9
		],
		[
			"2012-10-25",
			9
		],
		[
			"2012-04-18",
			9
		],
		[
			"2013-11-18",
			10
		],
		[
			"2013-04-23",
			9
		],
		[
			"2014-10-29",
			10
		],
		[
			"2014-04-24",
			10
		],
		[
			"2015-10-15",
			9
		],
		[
			"2015-04-09",
			11
		]
	],
	"106506067": [
		[
			"2000-05-02",
			39.01
		],
		[
			"2000-09-21",
			37.01
		],
		[
			"2001-04-17",
			38.01
		],
		[
			"2001-10-04",
			48.02
		],
		[
			"2002-10-14",
			60.02
		],
		[
			"2002-05-08",
			45.02
		],
		[
			"2005-10-24",
			30.01
		],
		[
			"2005-04-04",
			55.02
		],
		[
			"2004-10-18",
			31.01
		],
		[
			"2004-05-04",
			56.02
		],
		[
			"2003-11-06",
			33.01
		],
		[
			"2003-04-02",
			57.02
		],
		[
			"2007-04-19",
			45.02
		],
		[
			"2006-10-16",
			33.01
		],
		[
			"2006-04-11",
			49.02
		],
		[
			"2007-12-13",
			34.01
		],
		[
			"2008-04-01",
			46.02
		],
		[
			"2008-10-09",
			36.01
		],
		[
			"2009-04-08",
			51.02
		],
		[
			"2009-10-19",
			35.01
		],
		[
			"2010-04-13",
			38.01
		],
		[
			"2010-10-22",
			32.01
		],
		[
			"2012-10-25",
			36.01
		],
		[
			"2012-04-18",
			62.02
		],
		[
			"2013-12-13",
			34.01
		],
		[
			"2013-11-18",
			53.02
		],
		[
			"2013-04-23",
			59.02
		],
		[
			"2014-10-29",
			53.02
		],
		[
			"2014-04-24",
			35.01
		],
		[
			"2015-10-15",
			33.01
		],
		[
			"2015-04-09",
			48.02
		]
	],
	"106506079": [
		[
			"2000-05-02",
			12
		],
		[
			"2000-09-21",
			13
		],
		[
			"2001-04-17",
			18.01
		],
		[
			"2001-10-04",
			11
		],
		[
			"2002-10-14",
			10
		],
		[
			"2002-04-11",
			12
		],
		[
			"2005-10-24",
			10
		],
		[
			"2005-04-04",
			13
		],
		[
			"2004-10-18",
			8
		],
		[
			"2004-05-04",
			8
		],
		[
			"2003-11-06",
			6
		],
		[
			"2003-04-02",
			9
		],
		[
			"2007-04-19",
			5
		],
		[
			"2006-10-16",
			7
		],
		[
			"2006-04-11",
			14
		],
		[
			"2007-10-09",
			6
		],
		[
			"2008-04-01",
			7
		],
		[
			"2008-10-09",
			3
		],
		[
			"2009-04-08",
			6
		],
		[
			"2009-10-19",
			4
		],
		[
			"2010-04-13",
			7
		],
		[
			"2010-10-22",
			5
		],
		[
			"2012-10-25",
			4
		],
		[
			"2012-04-18",
			5
		],
		[
			"2013-11-18",
			6
		],
		[
			"2013-04-23",
			5
		],
		[
			"2014-10-29",
			5
		],
		[
			"2014-04-24",
			5
		],
		[
			"2015-10-15",
			5
		],
		[
			"2015-04-09",
			9
		]
	],
	"106506080": [
		[
			"2000-05-02",
			25.01
		],
		[
			"2000-09-21",
			25.01
		],
		[
			"2001-04-17",
			24.01
		],
		[
			"2001-10-04",
			18.01
		],
		[
			"2002-10-14",
			23.01
		],
		[
			"2002-04-11",
			23.01
		],
		[
			"2005-10-24",
			23.01
		],
		[
			"2005-04-04",
			20.01
		],
		[
			"2004-10-18",
			23.01
		],
		[
			"2004-05-04",
			23.01
		],
		[
			"2003-11-06",
			22.01
		],
		[
			"2003-04-02",
			22.01
		],
		[
			"2007-04-19",
			20.01
		],
		[
			"2006-10-16",
			22.01
		],
		[
			"2006-04-11",
			22.01
		],
		[
			"2007-10-09",
			24.01
		],
		[
			"2008-10-09",
			22.01
		],
		[
			"2008-04-01",
			23.01
		],
		[
			"2009-04-08",
			23.01
		],
		[
			"2009-10-19",
			23.01
		],
		[
			"2010-04-13",
			21.01
		],
		[
			"2010-10-22",
			20.01
		],
		[
			"2012-10-25",
			20.01
		],
		[
			"2012-04-18",
			21.01
		],
		[
			"2013-11-18",
			21.01
		],
		[
			"2013-04-23",
			18.01
		],
		[
			"2014-10-29",
			21.01
		],
		[
			"2014-04-24",
			21.01
		],
		[
			"2015-10-15",
			19.01
		],
		[
			"2015-04-09",
			17.01
		]
	],
	"106506109": [
		[
			"2000-05-02",
			45.02
		],
		[
			"2000-09-21",
			52.02
		],
		[
			"2001-04-17",
			56.02
		],
		[
			"2001-10-04",
			49.02
		],
		[
			"2002-10-14",
			49.02
		],
		[
			"2002-04-11",
			43.02
		],
		[
			"2005-10-24",
			37.01
		],
		[
			"2005-04-04",
			42.01
		],
		[
			"2004-10-18",
			49.02
		],
		[
			"2004-05-04",
			49.02
		],
		[
			"2003-11-06",
			46.02
		],
		[
			"2003-04-02",
			42.01
		],
		[
			"2007-04-19",
			37.01
		],
		[
			"2006-10-16",
			39.01
		],
		[
			"2006-04-11",
			44.02
		],
		[
			"2007-10-09",
			48.02
		],
		[
			"2008-04-01",
			44.02
		],
		[
			"2008-10-09",
			41.01
		],
		[
			"2009-04-08",
			44.02
		],
		[
			"2009-10-19",
			38.01
		],
		[
			"2010-04-13",
			40.01
		],
		[
			"2010-10-22",
			64.02
		],
		[
			"2012-10-25",
			36.01
		],
		[
			"2012-04-18",
			37.01
		],
		[
			"2013-12-13",
			38.01
		],
		[
			"2013-11-18",
			36.01
		],
		[
			"2013-04-23",
			36.01
		],
		[
			"2013-02-19",
			41.01
		],
		[
			"2014-10-29",
			42.01
		],
		[
			"2014-06-06",
			39.01
		],
		[
			"2015-10-15",
			38.01
		],
		[
			"2015-04-09",
			44.02
		]
	],
	"106506110": [
		[
			"2000-05-02",
			17.01
		],
		[
			"2000-09-21",
			12
		],
		[
			"2001-04-17",
			13
		],
		[
			"2001-10-04",
			13
		],
		[
			"2002-10-14",
			14
		],
		[
			"2003-11-06",
			9
		],
		[
			"2003-04-02",
			16.01
		],
		[
			"2004-10-18",
			12
		],
		[
			"2004-05-04",
			12
		],
		[
			"2005-11-08",
			11
		],
		[
			"2005-04-04",
			9
		],
		[
			"2006-10-16",
			10
		],
		[
			"2006-04-11",
			11
		],
		[
			"2008-05-15",
			18.01
		],
		[
			"2007-10-09",
			15.01
		],
		[
			"2007-04-19",
			14
		],
		[
			"2012-07-16",
			10
		],
		[
			"2014-02-10",
			28.01
		],
		[
			"2015-07-27",
			11
		]
	],
	"106506195": [
		[
			"2000-11-08",
			1
		],
		[
			"2001-03-28",
			1
		],
		[
			"2001-09-25",
			1
		],
		[
			"2002-03-20",
			4
		],
		[
			"2002-10-02",
			1
		],
		[
			"2003-11-12",
			1
		],
		[
			"2003-03-18",
			1
		],
		[
			"2004-09-09",
			1
		],
		[
			"2004-04-06",
			1
		],
		[
			"2005-03-31",
			2
		],
		[
			"2008-03-18",
			1
		],
		[
			"2008-09-11",
			1
		],
		[
			"2009-04-02",
			1
		],
		[
			"2009-09-09",
			1
		],
		[
			"2010-03-31",
			1
		],
		[
			"2010-11-16",
			1
		],
		[
			"2012-10-18",
			1
		],
		[
			"2012-04-12",
			1
		],
		[
			"2013-10-24",
			1
		],
		[
			"2013-04-26",
			1
		],
		[
			"2014-09-23",
			1
		],
		[
			"2014-03-20",
			1
		],
		[
			"2015-10-05",
			1
		],
		[
			"2015-04-14",
			1
		]
	],
	"106506547": [
		[
			"2000-05-10",
			2
		],
		[
			"2000-11-14",
			1
		],
		[
			"2002-05-14",
			5
		],
		[
			"2002-11-11",
			4
		],
		[
			"2003-03-17",
			4
		],
		[
			"2003-11-11",
			2
		],
		[
			"2004-03-15",
			4
		],
		[
			"2004-09-27",
			2
		],
		[
			"2005-09-27",
			2
		],
		[
			"2005-04-20",
			4
		],
		[
			"2006-11-13",
			2
		],
		[
			"2006-05-03",
			3
		],
		[
			"2007-03-21",
			13
		],
		[
			"2007-10-01",
			3
		],
		[
			"2008-05-19",
			4
		],
		[
			"2008-10-29",
			2
		],
		[
			"2009-03-26",
			9
		],
		[
			"2009-10-19",
			1
		],
		[
			"2010-04-12",
			4
		],
		[
			"2010-09-28",
			2
		],
		[
			"2011-04-27",
			3
		],
		[
			"2011-10-26",
			1
		],
		[
			"2012-05-08",
			2
		],
		[
			"2012-11-06",
			1
		],
		[
			"2013-05-28",
			3
		],
		[
			"2013-11-14",
			6
		],
		[
			"2014-05-20",
			5
		],
		[
			"2014-11-19",
			6
		],
		[
			"2015-05-05",
			5
		],
		[
			"2015-10-13",
			2
		]
	],
	"106520015": [
		[
			"2013-05-13",
			47.83
		],
		[
			"2015-04-13",
			39.9
		],
		[
			"2000-01-12",
			32.77
		],
		[
			"2000-10-12",
			41.63
		],
		[
			"2001-01-24",
			61.56
		],
		[
			"2001-04-18",
			62.44
		],
		[
			"2002-05-17",
			50.04
		],
		[
			"2002-10-01",
			38.75
		],
		[
			"2002-10-24",
			34.85
		],
		[
			"2003-09-23",
			30.29
		],
		[
			"2004-06-21",
			50.04
		],
		[
			"2005-06-28",
			48.71
		],
		[
			"2005-08-29",
			62
		],
		[
			"2006-08-07",
			37.2
		],
		[
			"2006-09-06",
			40.74
		],
		[
			"2007-08-01",
			48.71
		],
		[
			"2008-08-01",
			35.87
		]
	],
	"106520027": [
		[
			"2013-05-13",
			3.72
		],
		[
			"2014-04-23",
			3.32
		],
		[
			"2015-04-13",
			2.79
		],
		[
			"2000-01-12",
			5.31
		],
		[
			"2001-01-24",
			3.54
		],
		[
			"2002-05-17",
			5.45
		],
		[
			"2002-10-24",
			14.66
		],
		[
			"2005-06-28",
			48.71
		],
		[
			"2006-08-07",
			6.2
		],
		[
			"2006-09-06",
			53.14
		],
		[
			"2007-08-01",
			5.31
		],
		[
			"2009-09-24",
			3.01
		],
		[
			"2008-08-01",
			62
		],
		[
			"2010-09-29",
			2.61
		],
		[
			"2011-06-30",
			2.39
		],
		[
			"2012-07-17",
			6.2
		]
	],
	"106520040": [
		[
			"2013-05-15",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-12",
			1.82
		],
		[
			"2001-02-22",
			2.21
		],
		[
			"2002-11-08",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-08",
			2.21
		],
		[
			"2006-08-30",
			2.21
		],
		[
			"2007-05-10",
			2.21
		],
		[
			"2008-06-13",
			2.21
		],
		[
			"2009-11-10",
			2.21
		],
		[
			"2010-10-07",
			2.21
		],
		[
			"2011-06-09",
			2.21
		],
		[
			"2012-07-04",
			2.21
		]
	],
	"106520052": [
		[
			"2013-05-15",
			2.21
		],
		[
			"2014-04-02",
			2.21
		],
		[
			"2015-05-12",
			1.33
		],
		[
			"2000-07-06",
			2.21
		],
		[
			"2000-10-13",
			2.21
		],
		[
			"2001-04-19",
			2.21
		],
		[
			"2002-10-10",
			2.21
		],
		[
			"2004-06-22",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2005-08-29",
			2.21
		],
		[
			"2006-08-08",
			2.21
		],
		[
			"2007-05-10",
			2.21
		],
		[
			"2008-06-13",
			2.21
		],
		[
			"2009-09-11",
			2.21
		],
		[
			"2003-09-24",
			2.21
		],
		[
			"2010-07-07",
			2.21
		],
		[
			"2011-09-22",
			2.21
		],
		[
			"2012-05-29",
			2.21
		]
	],
	"106525165": [
		[
			"2013-08-19",
			11.51
		],
		[
			"2014-07-15",
			12.58
		],
		[
			"2015-10-22",
			8.46
		],
		[
			"2000-11-30",
			15.06
		],
		[
			"2002-11-21",
			18.78
		],
		[
			"2005-04-28",
			10.63
		],
		[
			"2006-10-19",
			7.97
		],
		[
			"2007-07-13",
			7.53
		],
		[
			"2008-04-18",
			9.74
		],
		[
			"2008-07-31",
			10.63
		],
		[
			"2010-10-13",
			15.5
		],
		[
			"2011-07-27",
			14.61
		],
		[
			"2012-08-11",
			11.96
		]
	],
	"106530021": [
		[
			"2013-07-11",
			84.14
		],
		[
			"2015-03-31",
			128.43
		],
		[
			"2003-03-05",
			105.4
		],
		[
			"2005-06-22",
			128.43
		],
		[
			"2006-10-10",
			124
		],
		[
			"2007-07-09",
			101.86
		],
		[
			"2009-11-18",
			106.29
		],
		[
			"2008-04-21",
			110.71
		],
		[
			"2011-11-10",
			115.14
		],
		[
			"2012-10-18",
			115.14
		]
	],
	"106530033": [
		[
			"2013-07-11",
			106.29
		],
		[
			"2014-07-14",
			110.27
		],
		[
			"2015-03-31",
			103.19
		],
		[
			"2005-06-22",
			115.14
		],
		[
			"2006-10-10",
			97.43
		],
		[
			"2007-07-09",
			70.86
		],
		[
			"2009-11-18",
			88.57
		],
		[
			"2008-04-21",
			79.71
		],
		[
			"2010-11-15",
			101.86
		],
		[
			"2011-11-10",
			141.71
		],
		[
			"2012-10-18",
			101.86
		]
	],
	"106530045": [
		[
			"2013-07-11",
			84.14
		],
		[
			"2014-07-14",
			86.8
		],
		[
			"2015-03-31",
			77.5
		],
		[
			"2003-03-05",
			120.9
		],
		[
			"2005-06-22",
			66.43
		],
		[
			"2006-10-10",
			53.14
		],
		[
			"2007-07-09",
			48.71
		],
		[
			"2009-11-18",
			79.71
		],
		[
			"2008-04-21",
			62
		],
		[
			"2010-11-15",
			70.86
		],
		[
			"2011-11-10",
			132.86
		],
		[
			"2012-10-18",
			79.71
		]
	],
	"106530057": [
		[
			"2013-07-11",
			66.43
		],
		[
			"2014-07-14",
			62.44
		],
		[
			"2015-03-31",
			46.94
		],
		[
			"2005-06-22",
			53.14
		],
		[
			"2006-10-10",
			48.71
		],
		[
			"2007-07-09",
			44.29
		],
		[
			"2009-11-18",
			70.86
		],
		[
			"2003-03-05",
			62.44
		],
		[
			"2008-04-21",
			48.71
		],
		[
			"2010-11-15",
			70.86
		],
		[
			"2011-11-10",
			93
		],
		[
			"2012-10-18",
			66.43
		]
	],
	"106530203": [
		[
			"2013-09-12",
			132.86
		],
		[
			"2014-08-28",
			109.39
		],
		[
			"2015-04-23",
			101.86
		],
		[
			"2003-03-04",
			118.24
		],
		[
			"2005-06-21",
			101.86
		],
		[
			"2006-10-16",
			124
		],
		[
			"2007-06-12",
			97.43
		],
		[
			"2009-11-18",
			79.71
		],
		[
			"2008-06-03",
			106.29
		],
		[
			"2010-11-02",
			110.71
		],
		[
			"2011-09-21",
			132.86
		],
		[
			"2012-07-02",
			119.57
		]
	],
	"106530215": [
		[
			"2013-09-12",
			48.71
		],
		[
			"2014-08-28",
			50.49
		],
		[
			"2015-04-23",
			50.04
		],
		[
			"2003-03-04",
			60.23
		],
		[
			"2005-06-21",
			62
		],
		[
			"2006-10-16",
			70.86
		],
		[
			"2007-06-12",
			62
		],
		[
			"2009-11-18",
			48.71
		],
		[
			"2008-06-03",
			66.43
		],
		[
			"2010-11-02",
			62
		],
		[
			"2012-07-02",
			62
		]
	],
	"106530239": [
		[
			"2013-09-12",
			48.71
		],
		[
			"2014-08-28",
			48.71
		],
		[
			"2015-04-23",
			49.16
		],
		[
			"2003-03-04",
			58.01
		],
		[
			"2005-06-21",
			53.14
		],
		[
			"2006-10-16",
			57.57
		],
		[
			"2007-06-12",
			53.14
		],
		[
			"2009-11-18",
			42.96
		],
		[
			"2008-06-03",
			48.71
		],
		[
			"2010-11-02",
			53.14
		],
		[
			"2011-09-21",
			53.14
		],
		[
			"2012-07-02",
			53.14
		]
	],
	"106530288": [
		[
			"2013-07-18",
			101.86
		],
		[
			"2014-08-20",
			140.39
		],
		[
			"2015-10-05",
			142.16
		],
		[
			"2005-06-27",
			194.86
		],
		[
			"2006-09-19",
			115.14
		],
		[
			"2007-07-04",
			93
		],
		[
			"2008-12-01",
			97.43
		],
		[
			"2009-10-27",
			97.43
		],
		[
			"2010-06-08",
			93
		],
		[
			"2011-09-06",
			62
		],
		[
			"2012-08-07",
			93
		]
	],
	"106530290": [
		[
			"2013-07-18",
			42.96
		],
		[
			"2014-08-20",
			44.29
		],
		[
			"2015-10-05",
			34.19
		],
		[
			"2005-06-27",
			110.71
		],
		[
			"2006-09-19",
			62
		],
		[
			"2007-07-04",
			93
		],
		[
			"2008-12-01",
			79.71
		],
		[
			"2009-10-27",
			70.86
		],
		[
			"2010-06-08",
			48.71
		],
		[
			"2011-09-06",
			79.71
		],
		[
			"2012-08-07",
			62
		]
	],
	"106530306": [
		[
			"2013-07-18",
			48.71
		],
		[
			"2014-08-20",
			51.37
		],
		[
			"2015-10-05",
			29.98
		],
		[
			"2005-06-27",
			53.14
		],
		[
			"2006-09-19",
			53.14
		],
		[
			"2007-07-04",
			48.71
		],
		[
			"2008-12-01",
			44.29
		],
		[
			"2009-10-27",
			57.57
		],
		[
			"2010-06-08",
			53.14
		],
		[
			"2011-09-06",
			39.86
		],
		[
			"2012-08-07",
			40.74
		]
	],
	"106530318": [
		[
			"2013-07-18",
			70.86
		],
		[
			"2014-08-20",
			65.54
		],
		[
			"2015-10-05",
			36.85
		],
		[
			"2005-06-27",
			48.71
		],
		[
			"2006-09-19",
			57.57
		],
		[
			"2007-07-04",
			41.19
		],
		[
			"2008-12-01",
			38.09
		],
		[
			"2009-10-27",
			57.57
		],
		[
			"2010-06-08",
			43.4
		],
		[
			"2011-09-06",
			48.71
		],
		[
			"2012-08-07",
			75.29
		]
	],
	"106530320": [
		[
			"2013-07-18",
			31.89
		],
		[
			"2014-08-20",
			34.59
		],
		[
			"2015-10-05",
			23.38
		],
		[
			"2005-06-27",
			13.29
		],
		[
			"2006-09-19",
			23.03
		],
		[
			"2007-07-04",
			11.96
		],
		[
			"2008-12-01",
			4.87
		],
		[
			"2009-10-27",
			25.24
		],
		[
			"2010-06-08",
			17.71
		],
		[
			"2011-09-06",
			13.29
		],
		[
			"2012-08-07",
			34.1
		]
	],
	"110040107": [
		[
			"2013-08-26",
			2.14
		],
		[
			"2014-08-07",
			1.33
		],
		[
			"2015-12-02",
			9.08
		],
		[
			"2000-10-25",
			1.2
		],
		[
			"2001-05-09",
			36.27
		],
		[
			"2001-11-13",
			0.22
		],
		[
			"2002-06-04",
			15.85
		],
		[
			"2002-08-30",
			1.9
		],
		[
			"2003-04-15",
			17.85
		],
		[
			"2004-11-09",
			2.3
		],
		[
			"2005-05-09",
			0.22
		],
		[
			"2006-08-17",
			0.58
		],
		[
			"2007-05-03",
			31.27
		],
		[
			"2008-10-07",
			0.22
		],
		[
			"2003-09-15",
			0.62
		],
		[
			"2005-10-05",
			0.22
		],
		[
			"2008-05-09",
			0.27
		],
		[
			"2009-06-09",
			4.43
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-05-06",
			4.43
		],
		[
			"2012-06-04",
			1.33
		]
	],
	"110040132": [
		[
			"2013-08-21",
			1.33
		],
		[
			"2014-07-30",
			1.33
		],
		[
			"2015-08-25",
			1.33
		],
		[
			"2006-08-17",
			0.62
		],
		[
			"2007-05-02",
			0.27
		],
		[
			"2008-05-09",
			0.49
		],
		[
			"2009-05-28",
			4.43
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-04-27",
			4.43
		],
		[
			"2012-05-25",
			1.33
		]
	],
	"110040144": [
		[
			"2013-08-21",
			1.33
		],
		[
			"2014-07-30",
			1.33
		],
		[
			"2015-09-02",
			1.33
		],
		[
			"2006-08-17",
			0.22
		],
		[
			"2007-05-02",
			0.22
		],
		[
			"2008-05-09",
			0.49
		],
		[
			"2009-05-28",
			4.43
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-04-27",
			4.43
		],
		[
			"2012-05-25",
			1.33
		]
	],
	"110040156": [
		[
			"2013-08-23",
			69.09
		],
		[
			"2014-08-15",
			35.43
		],
		[
			"2015-09-01",
			39.02
		],
		[
			"2000-05-18",
			71.74
		],
		[
			"2000-10-17",
			67.76
		],
		[
			"2001-05-21",
			71.74
		],
		[
			"2001-10-24",
			97.43
		],
		[
			"2002-05-31",
			74.4
		],
		[
			"2002-09-17",
			72.19
		],
		[
			"2003-04-11",
			94.77
		],
		[
			"2003-10-23",
			83.26
		],
		[
			"2004-04-20",
			84.59
		],
		[
			"2004-11-09",
			102.74
		],
		[
			"2005-10-27",
			88.57
		],
		[
			"2005-05-09",
			101.86
		],
		[
			"2007-04-26",
			104.51
		],
		[
			"2006-08-15",
			82.81
		],
		[
			"2008-09-11",
			67.31
		],
		[
			"2008-05-06",
			68.64
		],
		[
			"2009-05-27",
			82.81
		],
		[
			"2010-05-12",
			79.71
		],
		[
			"2011-04-19",
			78.83
		],
		[
			"2012-05-29",
			57.13
		]
	],
	"110040181": [
		[
			"2013-07-01",
			3.94
		],
		[
			"2015-12-02",
			3.88
		],
		[
			"2000-05-17",
			16.61
		],
		[
			"2000-10-24",
			8.06
		],
		[
			"2001-05-09",
			11.2
		],
		[
			"2001-10-22",
			4.87
		],
		[
			"2002-05-03",
			10.76
		],
		[
			"2002-08-27",
			3.1
		],
		[
			"2003-04-01",
			14.53
		],
		[
			"2003-09-11",
			3.94
		],
		[
			"2004-06-28",
			6.51
		],
		[
			"2004-11-19",
			3.23
		],
		[
			"2005-10-05",
			3.28
		],
		[
			"2005-05-18",
			10.14
		],
		[
			"2007-05-02",
			4.25
		],
		[
			"2006-08-10",
			3.72
		],
		[
			"2008-09-11",
			3.28
		],
		[
			"2008-05-07",
			12.58
		],
		[
			"2009-06-26",
			20.37
		],
		[
			"2010-05-31",
			8.86
		],
		[
			"2011-04-21",
			17.27
		],
		[
			"2012-06-04",
			3.54
		]
	],
	"110040200": [
		[
			"2013-06-17",
			127.54
		],
		[
			"2014-08-13",
			141.27
		],
		[
			"2015-12-03",
			124.44
		],
		[
			"2000-05-22",
			21.57
		],
		[
			"2000-10-24",
			75.73
		],
		[
			"2001-05-11",
			54.03
		],
		[
			"2001-05-07",
			13.24
		],
		[
			"2001-08-21",
			127.54
		],
		[
			"2001-10-23",
			150.13
		],
		[
			"2002-04-29",
			48.71
		],
		[
			"2002-06-03",
			58.46
		],
		[
			"2002-10-28",
			138.61
		],
		[
			"2002-08-29",
			128.43
		],
		[
			"2003-03-31",
			26.39
		],
		[
			"2003-09-16",
			149.69
		],
		[
			"2003-06-05",
			50.93
		],
		[
			"2003-10-27",
			137.73
		],
		[
			"2004-04-19",
			35.52
		],
		[
			"2004-06-29",
			81.49
		],
		[
			"2004-10-12",
			118.24
		],
		[
			"2004-12-01",
			124
		],
		[
			"2005-12-06",
			128.43
		],
		[
			"2005-05-30",
			63.77
		],
		[
			"2005-04-13",
			27.5
		],
		[
			"2006-08-08",
			120.46
		],
		[
			"2006-11-30",
			120.46
		],
		[
			"2008-06-04",
			73.96
		],
		[
			"2008-09-08",
			85.03
		],
		[
			"2000-03-07",
			5.93
		],
		[
			"2000-10-10",
			77.06
		],
		[
			"2005-10-04",
			126.21
		],
		[
			"2007-05-04",
			53.14
		],
		[
			"2008-05-14",
			31.53
		],
		[
			"2009-06-24",
			102.3
		],
		[
			"2010-06-02",
			62.44
		],
		[
			"2011-05-09",
			77.5
		],
		[
			"2012-06-18",
			113.37
		]
	],
	"110040223": [
		[
			"2013-08-23",
			1.33
		],
		[
			"2014-08-01",
			1.33
		],
		[
			"2015-09-02",
			1.33
		],
		[
			"2000-05-18",
			0.44
		],
		[
			"2000-10-17",
			0.27
		],
		[
			"2001-05-21",
			0.22
		],
		[
			"2001-10-24",
			1.24
		],
		[
			"2002-05-03",
			1.2
		],
		[
			"2002-09-20",
			0.22
		],
		[
			"2003-04-14",
			1.28
		],
		[
			"2003-11-05",
			0.27
		],
		[
			"2004-04-21",
			0.27
		],
		[
			"2004-10-19",
			0.22
		],
		[
			"2005-11-07",
			0.22
		],
		[
			"2005-05-09",
			0.22
		],
		[
			"2007-04-26",
			0.93
		],
		[
			"2006-08-15",
			0.27
		],
		[
			"2008-09-04",
			0.22
		],
		[
			"2008-05-05",
			0.35
		],
		[
			"2009-05-26",
			4.43
		],
		[
			"2010-05-12",
			4.43
		],
		[
			"2011-04-19",
			4.43
		],
		[
			"2012-05-29",
			1.33
		]
	],
	"110040247": [
		[
			"2013-08-07",
			1.33
		],
		[
			"2014-08-06",
			1.33
		],
		[
			"2015-12-10",
			1.33
		],
		[
			"2003-11-25",
			0.4
		],
		[
			"2004-06-03",
			0.22
		],
		[
			"2004-11-30",
			0.53
		],
		[
			"2005-11-07",
			11.47
		],
		[
			"2005-05-02",
			1.33
		],
		[
			"2006-10-23",
			0.66
		],
		[
			"2007-09-03",
			5.93
		],
		[
			"2008-07-22",
			1.15
		],
		[
			"2009-08-12",
			4.43
		],
		[
			"2010-08-10",
			4.43
		],
		[
			"2011-07-06",
			4.43
		],
		[
			"2012-07-12",
			1.33
		]
	],
	"110040259": [
		[
			"2013-08-01",
			1.33
		],
		[
			"2014-09-11",
			1.33
		],
		[
			"2015-04-30",
			1.33
		],
		[
			"2007-07-04",
			0.22
		],
		[
			"2008-08-04",
			0.31
		],
		[
			"2009-08-28",
			4.43
		],
		[
			"2010-07-22",
			4.43
		],
		[
			"2011-07-14",
			4.43
		],
		[
			"2012-07-03",
			1.33
		]
	],
	"110040260": [
		[
			"2013-07-29",
			1.33
		],
		[
			"2014-09-15",
			1.33
		],
		[
			"2015-11-09",
			1.33
		],
		[
			"2007-07-05",
			1.33
		],
		[
			"2008-08-07",
			0.22
		],
		[
			"2009-09-02",
			4.43
		],
		[
			"2010-07-26",
			4.43
		],
		[
			"2011-10-25",
			4.43
		],
		[
			"2012-07-03",
			1.33
		]
	],
	"110040284": [
		[
			"2013-08-15",
			1.42
		],
		[
			"2014-09-03",
			1.71
		],
		[
			"2015-05-12",
			1.57
		],
		[
			"2007-07-05",
			21.39
		],
		[
			"2008-08-08",
			7.88
		],
		[
			"2009-09-02",
			6.2
		],
		[
			"2010-07-29",
			4.43
		],
		[
			"2011-10-25",
			4.43
		],
		[
			"2012-07-12",
			3.1
		]
	],
	"110050010": [
		[
			"2013-09-05",
			1.33
		],
		[
			"2014-09-18",
			1.33
		],
		[
			"2015-03-13",
			1.33
		],
		[
			"2006-08-24",
			0.89
		],
		[
			"2007-06-15",
			2.52
		],
		[
			"2007-11-21",
			0.66
		],
		[
			"2008-05-28",
			3.01
		],
		[
			"2009-05-15",
			6.2
		],
		[
			"2010-06-14",
			5.76
		],
		[
			"2011-05-12",
			4.43
		],
		[
			"2012-07-31",
			3.54
		]
	],
	"110050071": [
		[
			"2013-09-02",
			1.33
		],
		[
			"2014-09-17",
			3.87
		],
		[
			"2015-04-13",
			2.51
		],
		[
			"2000-05-19",
			2.35
		],
		[
			"2000-10-26",
			7.97
		],
		[
			"2001-05-07",
			11.91
		],
		[
			"2001-11-07",
			1.42
		],
		[
			"2002-05-07",
			4.07
		],
		[
			"2002-09-03",
			2.92
		],
		[
			"2003-04-24",
			2.75
		],
		[
			"2004-06-28",
			1.15
		],
		[
			"2004-11-19",
			0.4
		],
		[
			"2005-05-23",
			1.55
		],
		[
			"2006-09-05",
			0.22
		],
		[
			"2007-06-06",
			4.61
		],
		[
			"2003-09-15",
			0.22
		],
		[
			"2005-10-12",
			0.22
		],
		[
			"2008-07-08",
			2.61
		],
		[
			"2009-06-18",
			4.43
		],
		[
			"2010-07-30",
			4.43
		],
		[
			"2011-07-05",
			4.43
		],
		[
			"2012-07-11",
			1.33
		]
	],
	"110050095": [
		[
			"2013-08-19",
			1.33
		],
		[
			"2014-09-18",
			1.33
		],
		[
			"2015-04-13",
			1.33
		],
		[
			"2000-05-24",
			0.22
		],
		[
			"2000-11-20",
			1.51
		],
		[
			"2001-11-05",
			0.22
		],
		[
			"2001-05-31",
			0.22
		],
		[
			"2002-05-29",
			1.15
		],
		[
			"2002-09-03",
			1.02
		],
		[
			"2003-11-12",
			0.22
		],
		[
			"2004-05-26",
			0.22
		],
		[
			"2004-11-11",
			0.22
		],
		[
			"2005-10-24",
			0.22
		],
		[
			"2005-04-25",
			0.22
		],
		[
			"2006-09-04",
			2.13
		],
		[
			"2007-06-04",
			0.22
		],
		[
			"2008-07-07",
			0.22
		],
		[
			"2009-06-16",
			4.43
		],
		[
			"2010-07-27",
			4.43
		],
		[
			"2011-06-20",
			4.43
		],
		[
			"2012-08-15",
			1.33
		]
	],
	"110050113": [
		[
			"2014-11-19",
			1.33
		],
		[
			"2015-09-08",
			1.33
		],
		[
			"2006-08-21",
			0.53
		],
		[
			"2007-06-14",
			0.22
		],
		[
			"2008-05-30",
			0.22
		],
		[
			"2009-06-08",
			4.43
		],
		[
			"2010-06-11",
			4.43
		],
		[
			"2011-05-12",
			4.43
		],
		[
			"2012-07-13",
			1.33
		]
	],
	"110050125": [
		[
			"2013-08-26",
			114.26
		],
		[
			"2014-08-13",
			81.49
		],
		[
			"2015-11-04",
			69.09
		],
		[
			"2000-05-19",
			81.04
		],
		[
			"2000-10-16",
			138.17
		],
		[
			"2001-05-17",
			99.64
		],
		[
			"2001-11-16",
			127.1
		],
		[
			"2002-05-31",
			101.41
		],
		[
			"2002-09-18",
			116.47
		],
		[
			"2003-04-15",
			139.5
		],
		[
			"2003-10-30",
			138.17
		],
		[
			"2004-04-21",
			112.93
		],
		[
			"2004-11-08",
			122.67
		],
		[
			"2005-11-02",
			107.61
		],
		[
			"2005-05-04",
			135.51
		],
		[
			"2006-08-16",
			108.06
		],
		[
			"2007-06-13",
			39.81
		],
		[
			"2008-10-10",
			127.1
		],
		[
			"2008-05-30",
			62.89
		],
		[
			"2009-06-09",
			144.37
		],
		[
			"2010-06-11",
			86.8
		],
		[
			"2011-05-11",
			42.07
		],
		[
			"2012-07-13",
			73.51
		]
	],
	"110050137": [
		[
			"2013-08-19",
			2.44
		],
		[
			"2014-10-20",
			1.33
		],
		[
			"2015-04-14",
			1.33
		],
		[
			"2006-09-04",
			1.02
		],
		[
			"2007-06-05",
			0.22
		],
		[
			"2008-07-08",
			0.22
		],
		[
			"2009-06-17",
			4.43
		],
		[
			"2010-07-21",
			4.43
		],
		[
			"2011-06-20",
			4.43
		],
		[
			"2012-07-12",
			1.33
		]
	],
	"110050149": [
		[
			"2013-09-03",
			1.33
		],
		[
			"2014-10-08",
			1.33
		],
		[
			"2015-09-07",
			1.33
		],
		[
			"2006-08-21",
			1.73
		],
		[
			"2007-06-12",
			0.22
		],
		[
			"2008-06-05",
			0.22
		],
		[
			"2009-06-08",
			4.43
		],
		[
			"2010-07-01",
			4.43
		],
		[
			"2011-04-28",
			4.43
		],
		[
			"2012-06-19",
			1.33
		]
	],
	"110050150": [
		[
			"2013-07-30",
			1.33
		],
		[
			"2014-10-06",
			1.33
		],
		[
			"2015-09-28",
			1.33
		],
		[
			"2007-07-06",
			0.22
		],
		[
			"2008-08-13",
			0.22
		],
		[
			"2009-09-03",
			4.43
		],
		[
			"2010-07-21",
			4.43
		],
		[
			"2011-10-07",
			4.43
		],
		[
			"2012-06-22",
			1.33
		]
	],
	"110060064": [
		[
			"2013-07-22",
			1.33
		],
		[
			"2014-10-28",
			1.33
		],
		[
			"2015-12-08",
			3.31
		],
		[
			"2000-06-19",
			1.99
		],
		[
			"2000-10-26",
			2.7
		],
		[
			"2001-05-14",
			1.9
		],
		[
			"2001-11-23",
			0.22
		],
		[
			"2002-06-05",
			2.66
		],
		[
			"2002-08-30",
			1.06
		],
		[
			"2003-09-17",
			0.62
		],
		[
			"2003-05-07",
			4.56
		],
		[
			"2004-11-03",
			0.22
		],
		[
			"2004-07-01",
			2.13
		],
		[
			"2005-04-22",
			2.83
		],
		[
			"2006-08-29",
			0.22
		],
		[
			"2008-11-04",
			0.27
		],
		[
			"2005-10-07",
			0.22
		],
		[
			"2007-05-10",
			0.22
		],
		[
			"2008-06-18",
			5.45
		],
		[
			"2009-07-14",
			4.43
		],
		[
			"2010-07-14",
			4.43
		],
		[
			"2011-06-06",
			4.43
		],
		[
			"2012-06-27",
			1.33
		]
	],
	"110060090": [
		[
			"2013-07-05",
			121.79
		],
		[
			"2014-12-15",
			112.93
		],
		[
			"2015-11-24",
			116.47
		],
		[
			"2006-08-30",
			132.41
		],
		[
			"2007-05-09",
			139.06
		],
		[
			"2007-11-19",
			133.3
		],
		[
			"2008-11-05",
			131.97
		],
		[
			"2008-06-10",
			119.57
		],
		[
			"2009-07-09",
			133.74
		],
		[
			"2010-07-14",
			139.06
		],
		[
			"2011-06-08",
			103.63
		],
		[
			"2012-06-28",
			140.83
		]
	],
	"110060155": [
		[
			"2013-10-10",
			4.56
		],
		[
			"2014-12-16",
			56.24
		],
		[
			"2015-11-13",
			1.33
		],
		[
			"2006-10-10",
			20.24
		],
		[
			"2007-07-25",
			10.27
		],
		[
			"2003-06-24",
			1.73
		],
		[
			"2003-12-01",
			0.93
		],
		[
			"2008-07-21",
			1.24
		],
		[
			"2009-07-28",
			4.43
		],
		[
			"2010-08-18",
			26.57
		],
		[
			"2011-06-09",
			20.81
		],
		[
			"2012-06-26",
			1.33
		]
	],
	"110060210": [
		[
			"2013-07-22",
			9.12
		],
		[
			"2015-11-09",
			8.59
		],
		[
			"2006-08-29",
			8.72
		],
		[
			"2007-05-08",
			11.2
		],
		[
			"2007-11-23",
			47.83
		],
		[
			"2008-11-04",
			5.71
		],
		[
			"2008-06-11",
			19.8
		],
		[
			"2009-07-10",
			10.63
		],
		[
			"2010-06-30",
			11.07
		],
		[
			"2011-05-30",
			27.9
		],
		[
			"2012-06-27",
			18.6
		]
	],
	"110060234": [
		[
			"2013-07-22",
			10.94
		],
		[
			"2014-11-20",
			19.26
		],
		[
			"2015-11-17",
			22.59
		],
		[
			"2000-06-19",
			16.7
		],
		[
			"2000-11-13",
			29.05
		],
		[
			"2001-05-29",
			30.78
		],
		[
			"2001-11-08",
			60.23
		],
		[
			"2002-06-05",
			42.07
		],
		[
			"2002-10-22",
			30.2
		],
		[
			"2003-05-07",
			37.42
		],
		[
			"2003-11-13",
			32.68
		],
		[
			"2004-05-24",
			39.55
		],
		[
			"2004-10-27",
			27.99
		],
		[
			"2005-04-22",
			27.77
		],
		[
			"2006-08-29",
			22.72
		],
		[
			"2007-05-08",
			29.41
		],
		[
			"2005-11-18",
			14.35
		],
		[
			"2008-11-04",
			0.31
		],
		[
			"2008-06-11",
			24.36
		],
		[
			"2009-07-10",
			7.09
		],
		[
			"2010-06-30",
			6.64
		],
		[
			"2011-05-30",
			19.04
		],
		[
			"2012-06-27",
			7.53
		]
	],
	"110070045": [
		[
			"2013-09-27",
			1.33
		],
		[
			"2014-12-17",
			1.33
		],
		[
			"2015-11-12",
			1.33
		],
		[
			"2002-06-03",
			1.15
		],
		[
			"2003-04-10",
			0.31
		],
		[
			"2003-11-24",
			0.49
		],
		[
			"2004-05-19",
			0.31
		],
		[
			"2004-10-13",
			0.22
		],
		[
			"2005-10-26",
			0.22
		],
		[
			"2005-04-21",
			0.44
		],
		[
			"2006-09-12",
			0.22
		],
		[
			"2007-07-24",
			0.62
		],
		[
			"2002-10-08",
			0.93
		],
		[
			"2008-07-15",
			0.22
		],
		[
			"2009-07-24",
			4.43
		],
		[
			"2010-08-11",
			4.43
		],
		[
			"2011-10-12",
			4.43
		],
		[
			"2012-06-21",
			1.33
		]
	],
	"110070057": [
		[
			"2014-12-17",
			120.46
		],
		[
			"2015-11-12",
			163.41
		],
		[
			"2000-06-19",
			118.69
		],
		[
			"2000-10-18",
			132.41
		],
		[
			"2001-05-29",
			140.83
		],
		[
			"2001-11-08",
			161.64
		],
		[
			"2002-06-03",
			187.77
		],
		[
			"2003-04-10",
			56.69
		],
		[
			"2003-11-07",
			23.56
		],
		[
			"2004-05-19",
			40.39
		],
		[
			"2004-10-13",
			35.03
		],
		[
			"2005-10-26",
			36.23
		],
		[
			"2005-04-21",
			28.17
		],
		[
			"2006-09-12",
			31.27
		],
		[
			"2007-07-25",
			26.53
		],
		[
			"2002-09-20",
			82.81
		],
		[
			"2008-07-15",
			106.29
		],
		[
			"2009-07-28",
			83.7
		],
		[
			"2010-08-12",
			113.81
		],
		[
			"2011-10-12",
			166.96
		],
		[
			"2012-06-21",
			210.8
		]
	],
	"110070094": [
		[
			"2013-07-24",
			135.96
		],
		[
			"2014-08-12",
			105.4
		],
		[
			"2015-12-08",
			146.59
		],
		[
			"2000-03-07",
			63.77
		],
		[
			"2000-06-15",
			59.34
		],
		[
			"2000-10-18",
			64.66
		],
		[
			"2001-05-11",
			59.34
		],
		[
			"2001-05-15",
			58.46
		],
		[
			"2001-08-22",
			58.9
		],
		[
			"2001-11-21",
			81.04
		],
		[
			"2002-05-06",
			57.13
		],
		[
			"2002-04-30",
			65.1
		],
		[
			"2002-10-29",
			61.11
		],
		[
			"2003-03-31",
			57.57
		],
		[
			"2003-09-11",
			67.31
		],
		[
			"2003-06-05",
			59.34
		],
		[
			"2003-10-27",
			72.19
		],
		[
			"2004-04-19",
			57.13
		],
		[
			"2004-06-29",
			93.44
		],
		[
			"2004-10-11",
			86.36
		],
		[
			"2004-12-01",
			81.04
		],
		[
			"2005-05-30",
			101.41
		],
		[
			"2005-04-13",
			90.79
		],
		[
			"2006-08-07",
			69.53
		],
		[
			"2006-11-07",
			71.74
		],
		[
			"2008-09-05",
			92.56
		],
		[
			"2000-10-11",
			71.3
		],
		[
			"2002-08-29",
			62
		],
		[
			"2005-10-04",
			88.13
		],
		[
			"2005-12-05",
			79.71
		],
		[
			"2007-04-25",
			78.39
		],
		[
			"2008-04-29",
			88.57
		],
		[
			"2009-07-03",
			88.57
		],
		[
			"2010-06-10",
			99.2
		],
		[
			"2011-06-08",
			95.21
		],
		[
			"2012-06-26",
			91.67
		]
	],
	"110070148": [
		[
			"2013-07-02",
			81.93
		],
		[
			"2014-12-03",
			107.61
		],
		[
			"2015-12-01",
			98.76
		],
		[
			"2000-03-07",
			78.39
		],
		[
			"2000-06-20",
			31.27
		],
		[
			"2000-10-11",
			67.31
		],
		[
			"2000-10-24",
			58.9
		],
		[
			"2001-05-14",
			43.09
		],
		[
			"2001-08-21",
			0.22
		],
		[
			"2001-05-15",
			43.75
		],
		[
			"2001-11-14",
			25.02
		],
		[
			"2002-05-29",
			46.94
		],
		[
			"2002-04-29",
			54.91
		],
		[
			"2002-10-28",
			143.93
		],
		[
			"2003-03-28",
			50.93
		],
		[
			"2003-09-11",
			0.22
		],
		[
			"2003-09-16",
			0.84
		],
		[
			"2003-06-06",
			46.06
		],
		[
			"2004-04-19",
			57.13
		],
		[
			"2004-06-29",
			70.41
		],
		[
			"2004-10-12",
			12.62
		],
		[
			"2004-11-24",
			43.71
		],
		[
			"2005-04-13",
			90.79
		],
		[
			"2005-05-30",
			82.81
		],
		[
			"2006-08-07",
			2.21
		],
		[
			"2006-11-30",
			34.68
		],
		[
			"2007-05-10",
			72.63
		],
		[
			"2008-09-10",
			50.49
		],
		[
			"2002-08-28",
			81.93
		],
		[
			"2005-10-05",
			5.54
		],
		[
			"2005-12-06",
			82.81
		],
		[
			"2008-05-27",
			81.04
		],
		[
			"2009-07-02",
			67.76
		],
		[
			"2010-05-26",
			102.3
		],
		[
			"2011-04-28",
			52.26
		],
		[
			"2012-05-24",
			82.81
		]
	],
	"110070173": [
		[
			"2013-08-21",
			1.64
		],
		[
			"2014-08-27",
			1.33
		],
		[
			"2015-08-24",
			1.33
		],
		[
			"2006-08-17",
			0.22
		],
		[
			"2007-05-02",
			0.22
		],
		[
			"2008-05-09",
			0.22
		],
		[
			"2009-05-28",
			4.43
		],
		[
			"2010-05-11",
			4.43
		],
		[
			"2011-04-27",
			4.43
		],
		[
			"2012-05-25",
			1.33
		]
	],
	"110070227": [
		[
			"2013-09-02",
			6.24
		],
		[
			"2015-06-26",
			6.47
		],
		[
			"2000-05-19",
			46.5
		],
		[
			"2000-11-21",
			49.16
		],
		[
			"2001-05-31",
			9.83
		],
		[
			"2001-11-07",
			15.68
		],
		[
			"2002-05-23",
			4.52
		],
		[
			"2002-10-21",
			8.68
		],
		[
			"2003-04-16",
			5.4
		],
		[
			"2003-11-05",
			8.46
		],
		[
			"2004-04-22",
			9.88
		],
		[
			"2004-11-10",
			23.34
		],
		[
			"2005-05-13",
			4.47
		],
		[
			"2006-08-21",
			7.71
		],
		[
			"2007-06-06",
			6.38
		],
		[
			"2005-11-17",
			5.71
		],
		[
			"2008-07-09",
			7.75
		],
		[
			"2009-06-18",
			15.5
		],
		[
			"2010-07-30",
			9.74
		],
		[
			"2011-07-11",
			4.43
		],
		[
			"2012-07-11",
			3.54
		]
	],
	"110070288": [
		[
			"2013-08-15",
			6.47
		],
		[
			"2015-07-22",
			6.86
		],
		[
			"2000-11-22",
			39.86
		],
		[
			"2001-05-31",
			28.61
		],
		[
			"2001-11-16",
			31.89
		],
		[
			"2002-05-23",
			18.6
		],
		[
			"2002-10-21",
			16.47
		],
		[
			"2003-04-09",
			14.44
		],
		[
			"2003-11-11",
			24.4
		],
		[
			"2004-04-21",
			28.08
		],
		[
			"2004-11-19",
			36.85
		],
		[
			"2005-12-19",
			44.15
		],
		[
			"2005-05-23",
			32.59
		],
		[
			"2006-08-21",
			24.45
		],
		[
			"2007-06-13",
			18.73
		],
		[
			"2008-10-08",
			17.58
		],
		[
			"2008-06-09",
			16.87
		],
		[
			"2009-06-05",
			20.81
		],
		[
			"2010-05-25",
			16.39
		],
		[
			"2011-05-04",
			12.4
		],
		[
			"2012-05-31",
			7.97
		]
	],
	"110070409": [
		[
			"2013-07-31",
			1.33
		],
		[
			"2015-11-11",
			1.33
		],
		[
			"2006-09-12",
			0.22
		],
		[
			"2007-07-19",
			1.59
		],
		[
			"2008-07-15",
			0.4
		],
		[
			"2009-07-24",
			4.43
		],
		[
			"2010-08-11",
			4.43
		],
		[
			"2011-10-12",
			4.43
		],
		[
			"2012-07-05",
			1.33
		]
	],
	"110070422": [
		[
			"2015-11-18",
			1.33
		],
		[
			"2006-10-10",
			1.24
		],
		[
			"2007-07-25",
			0.4
		],
		[
			"2007-11-15",
			1.33
		],
		[
			"2003-07-02",
			1.77
		],
		[
			"2003-12-09",
			3.14
		],
		[
			"2008-07-23",
			0.22
		],
		[
			"2009-07-27",
			4.43
		],
		[
			"2010-09-06",
			5.76
		],
		[
			"2011-10-18",
			4.43
		],
		[
			"2012-07-05",
			1.33
		]
	],
	"110070513": [
		[
			"2015-11-24",
			1.33
		],
		[
			"2003-07-02",
			1.51
		],
		[
			"2003-12-09",
			0.22
		],
		[
			"2004-05-19",
			0.44
		],
		[
			"2004-10-13",
			0.22
		],
		[
			"2005-10-26",
			0.35
		],
		[
			"2005-04-21",
			0.22
		],
		[
			"2006-09-12",
			0.4
		],
		[
			"2007-07-19",
			0.22
		],
		[
			"2008-07-23",
			0.44
		],
		[
			"2009-07-28",
			4.43
		],
		[
			"2010-08-12",
			4.43
		],
		[
			"2011-10-26",
			4.43
		],
		[
			"2012-07-10",
			1.33
		]
	],
	"110070525": [
		[
			"2013-07-31",
			1.33
		],
		[
			"2014-11-26",
			1.33
		],
		[
			"2015-11-17",
			1.33
		],
		[
			"2004-12-09",
			0.22
		],
		[
			"2005-04-21",
			2.48
		],
		[
			"2006-11-23",
			0.97
		],
		[
			"2007-07-26",
			0.53
		],
		[
			"2007-11-23",
			0.84
		],
		[
			"2005-11-29",
			0.22
		],
		[
			"2008-07-23",
			0.22
		],
		[
			"2009-07-21",
			6.2
		],
		[
			"2010-08-12",
			4.43
		],
		[
			"2011-10-18",
			4.43
		],
		[
			"2012-07-05",
			1.33
		]
	],
	"110070537": [
		[
			"2013-07-31",
			1.33
		],
		[
			"2015-11-12",
			3.81
		],
		[
			"2005-12-21",
			0.8
		],
		[
			"2006-11-22",
			2.21
		],
		[
			"2007-07-26",
			0.44
		],
		[
			"2008-07-24",
			0.22
		],
		[
			"2009-07-21",
			4.43
		],
		[
			"2010-09-06",
			4.43
		],
		[
			"2011-10-26",
			4.43
		],
		[
			"2012-07-09",
			1.33
		]
	],
	"110070549": [
		[
			"2013-07-31",
			1.33
		],
		[
			"2014-11-25",
			1.33
		],
		[
			"2015-11-12",
			1.33
		],
		[
			"2006-11-22",
			0.31
		],
		[
			"2007-07-26",
			0.22
		],
		[
			"2005-12-21",
			0.22
		],
		[
			"2008-07-24",
			0.27
		],
		[
			"2009-07-21",
			4.43
		],
		[
			"2010-09-06",
			4.43
		],
		[
			"2011-10-26",
			4.43
		],
		[
			"2012-07-09",
			1.33
		]
	],
	"110151057": [
		[
			"2013-08-22",
			16.03
		],
		[
			"2015-11-12",
			11.29
		],
		[
			"2006-11-17",
			15.19
		],
		[
			"2008-09-03",
			12.4
		],
		[
			"2007-07-24",
			9.34
		],
		[
			"2009-10-05",
			17.71
		],
		[
			"2010-07-09",
			11.07
		],
		[
			"2011-11-17",
			13.73
		],
		[
			"2012-08-07",
			19.49
		]
	],
	"110151094": [
		[
			"2013-08-22",
			1.33
		],
		[
			"2015-11-03",
			1.33
		],
		[
			"2007-06-27",
			33.52
		],
		[
			"2008-07-10",
			0.53
		],
		[
			"2009-07-01",
			4.43
		],
		[
			"2010-07-09",
			4.43
		],
		[
			"2012-08-07",
			1.33
		]
	],
	"110200020": [
		[
			"2013-07-03",
			1.33
		],
		[
			"2014-07-23",
			1.33
		],
		[
			"2015-10-28",
			1.33
		],
		[
			"2000-05-23",
			0.22
		],
		[
			"2000-10-26",
			0.22
		],
		[
			"2001-05-09",
			0.22
		],
		[
			"2001-10-23",
			0.84
		],
		[
			"2002-05-08",
			1.15
		],
		[
			"2003-09-16",
			0.75
		],
		[
			"2003-04-14",
			1.24
		],
		[
			"2004-06-29",
			0.22
		],
		[
			"2004-10-19",
			0.22
		],
		[
			"2005-05-17",
			0.22
		],
		[
			"2006-08-09",
			0.22
		],
		[
			"2007-06-18",
			0.22
		],
		[
			"2002-08-30",
			1.02
		],
		[
			"2005-10-07",
			0.22
		],
		[
			"2008-05-16",
			0.22
		],
		[
			"2009-07-08",
			4.43
		],
		[
			"2010-06-07",
			4.43
		],
		[
			"2011-05-26",
			4.43
		],
		[
			"2012-07-25",
			1.33
		]
	],
	"110200056": [
		[
			"2013-09-17",
			1.33
		],
		[
			"2014-08-28",
			1.33
		],
		[
			"2015-10-29",
			1.33
		],
		[
			"2006-08-24",
			35.69
		],
		[
			"2007-06-26",
			0.53
		],
		[
			"2007-11-14",
			0.58
		],
		[
			"2008-11-12",
			0.44
		],
		[
			"2008-06-18",
			0.89
		],
		[
			"2009-05-25",
			4.43
		],
		[
			"2010-06-21",
			4.43
		],
		[
			"2011-06-17",
			4.43
		],
		[
			"2012-08-02",
			1.33
		]
	],
	"110200070": [
		[
			"2013-09-04",
			55.36
		],
		[
			"2014-10-30",
			54.03
		],
		[
			"2015-11-02",
			49.6
		],
		[
			"2000-05-30",
			69.97
		],
		[
			"2000-11-14",
			73.96
		],
		[
			"2001-06-05",
			65.54
		],
		[
			"2001-11-13",
			68.2
		],
		[
			"2002-05-27",
			54.47
		],
		[
			"2003-04-17",
			54.03
		],
		[
			"2003-11-11",
			69.53
		],
		[
			"2004-07-15",
			71.3
		],
		[
			"2004-11-08",
			83.7
		],
		[
			"2005-11-02",
			76.17
		],
		[
			"2005-05-04",
			71.74
		],
		[
			"2006-08-16",
			86.8
		],
		[
			"2007-06-15",
			42.12
		],
		[
			"2008-10-10",
			0.22
		],
		[
			"2002-09-19",
			50.93
		],
		[
			"2008-05-28",
			69.53
		],
		[
			"2009-06-10",
			72.63
		],
		[
			"2010-06-14",
			63.77
		],
		[
			"2011-05-12",
			52.26
		],
		[
			"2012-07-31",
			48.71
		]
	],
	"110200081": [
		[
			"2013-09-04",
			92.56
		],
		[
			"2014-10-30",
			144.81
		],
		[
			"2015-11-02",
			141.71
		],
		[
			"2006-08-18",
			76.61
		],
		[
			"2007-06-14",
			127.1
		],
		[
			"2008-05-29",
			138.17
		],
		[
			"2009-06-10",
			154.56
		],
		[
			"2010-06-16",
			138.17
		],
		[
			"2011-05-26",
			109.39
		],
		[
			"2012-08-01",
			70.86
		]
	],
	"110200093": [
		[
			"2014-11-05",
			75.73
		],
		[
			"2015-11-02",
			56.24
		],
		[
			"2006-08-16",
			34.1
		],
		[
			"2007-06-15",
			65.1
		],
		[
			"2008-05-29",
			57.57
		],
		[
			"2009-06-15",
			67.31
		],
		[
			"2010-06-08",
			84.59
		],
		[
			"2011-05-11",
			77.5
		]
	],
	"110200100": [
		[
			"2013-07-04",
			21.61
		],
		[
			"2014-11-11",
			2.54
		],
		[
			"2015-10-30",
			2.17
		],
		[
			"2000-05-23",
			21.88
		],
		[
			"2000-11-17",
			7.84
		],
		[
			"2001-06-29",
			5.23
		],
		[
			"2001-10-23",
			16.08
		],
		[
			"2002-05-08",
			1.15
		],
		[
			"2003-05-06",
			3.1
		],
		[
			"2003-11-10",
			0.22
		],
		[
			"2004-04-23",
			2.66
		],
		[
			"2004-10-18",
			178.03
		],
		[
			"2005-11-04",
			34.85
		],
		[
			"2005-05-11",
			12.67
		],
		[
			"2007-05-07",
			15.63
		],
		[
			"2006-08-09",
			10.41
		],
		[
			"2008-09-09",
			111.6
		],
		[
			"2002-09-23",
			67.31
		],
		[
			"2008-05-16",
			7.84
		],
		[
			"2009-07-07",
			34.1
		],
		[
			"2010-06-07",
			23.91
		],
		[
			"2011-06-09",
			7.09
		],
		[
			"2012-07-25",
			41.19
		]
	],
	"110200123": [
		[
			"2013-09-05",
			108.5
		],
		[
			"2014-08-21",
			69.97
		],
		[
			"2015-11-03",
			97.43
		],
		[
			"2000-05-30",
			47.83
		],
		[
			"2000-10-25",
			32.28
		],
		[
			"2001-05-10",
			54.03
		],
		[
			"2001-11-26",
			65.1
		],
		[
			"2002-06-20",
			41.05
		],
		[
			"2003-09-17",
			43.44
		],
		[
			"2003-04-17",
			71.3
		],
		[
			"2004-11-08",
			96.99
		],
		[
			"2004-06-30",
			60.23
		],
		[
			"2005-06-22",
			70.86
		],
		[
			"2006-08-18",
			61.11
		],
		[
			"2007-06-20",
			59.34
		],
		[
			"2008-10-14",
			63.77
		],
		[
			"2002-08-28",
			27.72
		],
		[
			"2005-10-12",
			64.66
		],
		[
			"2008-05-29",
			78.39
		],
		[
			"2009-06-10",
			69.97
		],
		[
			"2010-06-14",
			92.11
		],
		[
			"2011-05-12",
			81.49
		],
		[
			"2012-07-31",
			150.13
		]
	],
	"110200135": [
		[
			"2014-10-30",
			95.21
		],
		[
			"2015-12-08",
			81.93
		],
		[
			"2006-08-24",
			78.39
		],
		[
			"2006-11-29",
			73.96
		],
		[
			"2007-06-26",
			79.27
		],
		[
			"2007-11-14",
			78.39
		],
		[
			"2008-06-18",
			83.26
		],
		[
			"2009-05-25",
			80.6
		],
		[
			"2010-06-23",
			116.03
		],
		[
			"2011-06-17",
			79.71
		],
		[
			"2012-08-02",
			120.01
		]
	],
	"110200159": [
		[
			"2013-09-04",
			1.33
		],
		[
			"2014-11-03",
			1.33
		],
		[
			"2015-03-11",
			1.33
		],
		[
			"2006-08-23",
			0.31
		],
		[
			"2006-12-01",
			0.22
		],
		[
			"2007-06-20",
			0.22
		],
		[
			"2008-10-15",
			0.22
		],
		[
			"2007-11-15",
			0.27
		],
		[
			"2003-06-24",
			1.73
		],
		[
			"2003-12-08",
			0.27
		],
		[
			"2008-05-15",
			0.22
		],
		[
			"2009-05-15",
			4.43
		],
		[
			"2010-06-16",
			4.43
		],
		[
			"2011-05-23",
			4.43
		],
		[
			"2012-07-26",
			1.33
		]
	],
	"110200160": [
		[
			"2013-06-18",
			370.67
		],
		[
			"2014-11-03",
			101.86
		],
		[
			"2015-12-08",
			120.9
		],
		[
			"2000-06-26",
			14.57
		],
		[
			"2000-11-16",
			22.36
		],
		[
			"2001-05-30",
			37.78
		],
		[
			"2001-11-19",
			14.66
		],
		[
			"2002-05-27",
			26.97
		],
		[
			"2003-04-24",
			28.61
		],
		[
			"2003-10-23",
			5.31
		],
		[
			"2004-05-14",
			21.39
		],
		[
			"2004-11-05",
			28.39
		],
		[
			"2005-11-24",
			35.07
		],
		[
			"2005-05-20",
			143.04
		],
		[
			"2007-06-22",
			46.06
		],
		[
			"2006-08-23",
			139.06
		],
		[
			"2008-11-07",
			73.51
		],
		[
			"2002-09-12",
			17.45
		],
		[
			"2008-05-28",
			45.61
		],
		[
			"2009-05-15",
			140.83
		],
		[
			"2010-06-21",
			174.93
		],
		[
			"2011-05-26",
			89.01
		],
		[
			"2012-08-13",
			102.74
		]
	],
	"110200172": [
		[
			"2013-09-19",
			23.07
		],
		[
			"2014-11-04",
			5.31
		],
		[
			"2015-03-13",
			40.61
		],
		[
			"2003-12-04",
			0.62
		],
		[
			"2004-11-05",
			0.44
		],
		[
			"2004-06-08",
			14.61
		],
		[
			"2005-05-20",
			23.6
		],
		[
			"2006-08-23",
			4.16
		],
		[
			"2007-06-21",
			22.45
		],
		[
			"2008-10-15",
			5.31
		],
		[
			"2005-11-23",
			0.22
		],
		[
			"2008-05-26",
			0.53
		],
		[
			"2009-05-13",
			31.44
		],
		[
			"2010-06-16",
			34.54
		],
		[
			"2011-05-23",
			27.9
		],
		[
			"2012-07-26",
			18.16
		]
	],
	"110200184": [
		[
			"2013-10-14",
			45.17
		],
		[
			"2014-11-04",
			32.99
		],
		[
			"2015-03-12",
			34.94
		],
		[
			"2006-08-23",
			0.97
		],
		[
			"2007-06-22",
			43.89
		],
		[
			"2008-05-26",
			27.1
		],
		[
			"2009-05-14",
			52.26
		],
		[
			"2010-06-17",
			21.26
		],
		[
			"2011-05-23",
			57.13
		],
		[
			"2012-07-30",
			73.51
		]
	],
	"110200196": [
		[
			"2013-06-18",
			1.33
		],
		[
			"2015-04-01",
			1.33
		],
		[
			"2000-06-26",
			0.22
		],
		[
			"2000-11-16",
			1.02
		],
		[
			"2001-06-01",
			0.58
		],
		[
			"2001-11-12",
			0.22
		],
		[
			"2002-05-22",
			1.2
		],
		[
			"2003-04-22",
			1.28
		],
		[
			"2003-10-23",
			0.53
		],
		[
			"2004-05-14",
			0.35
		],
		[
			"2004-10-26",
			0.22
		],
		[
			"2005-05-19",
			0.22
		],
		[
			"2006-09-01",
			0.22
		],
		[
			"2007-06-21",
			0.58
		],
		[
			"2005-11-23",
			0.22
		],
		[
			"2008-10-15",
			0.22
		],
		[
			"2002-09-18",
			0.4
		],
		[
			"2008-05-15",
			0.27
		],
		[
			"2009-05-13",
			4.43
		],
		[
			"2010-06-17",
			4.43
		],
		[
			"2011-05-23",
			4.43
		],
		[
			"2012-08-13",
			1.33
		]
	],
	"110200214": [
		[
			"2013-06-18",
			85.47
		],
		[
			"2014-07-22",
			52.7
		],
		[
			"2015-03-30",
			180.24
		],
		[
			"2000-07-10",
			0.71
		],
		[
			"2000-10-25",
			1.11
		],
		[
			"2001-05-10",
			2.52
		],
		[
			"2001-11-12",
			0.89
		],
		[
			"2002-05-22",
			14.66
		],
		[
			"2003-04-22",
			72.19
		],
		[
			"2004-10-26",
			19.13
		],
		[
			"2004-06-30",
			27.32
		],
		[
			"2005-05-19",
			52.7
		],
		[
			"2006-08-31",
			38.84
		],
		[
			"2007-06-21",
			58.9
		],
		[
			"2008-11-10",
			71.74
		],
		[
			"2002-08-28",
			24.84
		],
		[
			"2003-09-15",
			86.8
		],
		[
			"2005-10-12",
			18.42
		],
		[
			"2008-05-15",
			100.09
		],
		[
			"2009-05-14",
			58.46
		],
		[
			"2010-06-17",
			45.61
		],
		[
			"2011-05-24",
			73.07
		],
		[
			"2012-07-30",
			35.87
		]
	],
	"110200226": [
		[
			"2013-10-14",
			16.39
		],
		[
			"2015-03-26",
			30.16
		],
		[
			"2002-05-22",
			91.23
		],
		[
			"2002-06-04",
			1.82
		],
		[
			"2003-04-22",
			1.59
		],
		[
			"2003-12-04",
			0.31
		],
		[
			"2004-06-08",
			0.75
		],
		[
			"2004-10-26",
			1.64
		],
		[
			"2005-05-19",
			0.93
		],
		[
			"2006-08-31",
			1.86
		],
		[
			"2007-06-21",
			1.24
		],
		[
			"2007-11-21",
			1.02
		],
		[
			"2005-11-23",
			1.06
		],
		[
			"2008-11-10",
			2.97
		],
		[
			"2002-09-19",
			0.44
		],
		[
			"2008-05-26",
			0.44
		],
		[
			"2009-05-14",
			4.43
		],
		[
			"2011-05-24",
			4.43
		],
		[
			"2012-07-30",
			8.41
		]
	],
	"110200238": [
		[
			"2013-09-18",
			1.33
		],
		[
			"2015-04-01",
			4.74
		],
		[
			"2006-09-01",
			26.97
		],
		[
			"2006-12-01",
			37.33
		],
		[
			"2007-06-22",
			28.48
		],
		[
			"2007-11-21",
			36.09
		],
		[
			"2008-11-07",
			1.95
		],
		[
			"2003-06-17",
			29.23
		],
		[
			"2003-12-08",
			42.51
		],
		[
			"2008-06-16",
			4.21
		],
		[
			"2009-05-19",
			4.43
		],
		[
			"2010-06-28",
			4.43
		],
		[
			"2011-06-15",
			5.31
		],
		[
			"2012-08-09",
			3.1
		]
	],
	"110200251": [
		[
			"2013-09-12",
			218.77
		],
		[
			"2015-12-08",
			183.79
		],
		[
			"2006-08-24",
			104.51
		],
		[
			"2007-06-26",
			111.6
		],
		[
			"2003-06-17",
			111.6
		],
		[
			"2003-12-03",
			77.94
		],
		[
			"2008-06-13",
			103.63
		],
		[
			"2009-05-18",
			143.04
		],
		[
			"2010-07-16",
			127.54
		],
		[
			"2011-06-17",
			121.34
		],
		[
			"2012-08-21",
			131.09
		]
	],
	"110200287": [
		[
			"2013-10-10",
			7
		],
		[
			"2015-03-24",
			18.11
		],
		[
			"2006-11-21",
			15.06
		],
		[
			"2007-06-28",
			3.14
		],
		[
			"2008-07-14",
			6.86
		],
		[
			"2009-07-17",
			22.59
		],
		[
			"2010-09-02",
			16.83
		],
		[
			"2011-11-14",
			8.86
		],
		[
			"2012-08-22",
			12.4
		]
	],
	"110200305": [
		[
			"2013-09-12",
			1.33
		],
		[
			"2015-03-12",
			1.33
		],
		[
			"2000-06-26",
			7.62
		],
		[
			"2000-11-16",
			7.71
		],
		[
			"2001-05-30",
			12.05
		],
		[
			"2001-11-12",
			3.63
		],
		[
			"2002-05-27",
			3.41
		],
		[
			"2003-04-24",
			3.63
		],
		[
			"2003-10-23",
			5
		],
		[
			"2004-05-14",
			0.75
		],
		[
			"2004-11-05",
			0.22
		],
		[
			"2005-11-24",
			0.22
		],
		[
			"2005-05-20",
			0.22
		],
		[
			"2006-08-23",
			0.89
		],
		[
			"2007-06-20",
			0.71
		],
		[
			"2008-10-14",
			0.8
		],
		[
			"2002-09-18",
			5.23
		],
		[
			"2008-05-28",
			0.49
		],
		[
			"2009-05-13",
			4.43
		],
		[
			"2010-06-21",
			4.43
		],
		[
			"2011-05-24",
			11.07
		],
		[
			"2012-07-31",
			19.04
		]
	],
	"110200329": [
		[
			"2014-07-24",
			1.33
		],
		[
			"2015-03-18",
			1.33
		],
		[
			"2000-05-23",
			0.27
		],
		[
			"2000-11-14",
			1.02
		],
		[
			"2001-06-01",
			0.22
		],
		[
			"2001-11-13",
			0.22
		],
		[
			"2002-05-03",
			1.15
		],
		[
			"2003-06-24",
			1.28
		],
		[
			"2003-11-26",
			0.22
		],
		[
			"2004-05-25",
			0.66
		],
		[
			"2004-10-21",
			0.22
		],
		[
			"2005-12-01",
			0.22
		],
		[
			"2005-05-18",
			0.22
		],
		[
			"2006-09-06",
			0.22
		],
		[
			"2007-08-20",
			0.22
		],
		[
			"2002-09-12",
			1.11
		],
		[
			"2008-07-14",
			0.22
		],
		[
			"2009-08-19",
			4.43
		],
		[
			"2010-09-01",
			4.43
		],
		[
			"2011-11-14",
			4.43
		],
		[
			"2012-08-22",
			1.33
		]
	],
	"110200330": [
		[
			"2014-07-22",
			187.77
		],
		[
			"2015-03-17",
			145.26
		],
		[
			"2003-06-17",
			141.27
		],
		[
			"2004-07-05",
			126.66
		],
		[
			"2004-10-21",
			109.39
		],
		[
			"2005-04-20",
			131.53
		],
		[
			"2006-09-01",
			130.64
		],
		[
			"2007-06-29",
			129.76
		],
		[
			"2008-11-11",
			126.21
		],
		[
			"2005-12-02",
			149.24
		],
		[
			"2008-06-16",
			124
		],
		[
			"2009-05-19",
			166.96
		],
		[
			"2010-06-28",
			159.43
		],
		[
			"2011-06-15",
			110.71
		],
		[
			"2012-08-09",
			186.44
		]
	],
	"110200342": [
		[
			"2013-09-26",
			1.33
		],
		[
			"2015-03-19",
			1.33
		],
		[
			"2003-07-01",
			1.82
		],
		[
			"2003-12-04",
			0.22
		],
		[
			"2004-05-25",
			0.22
		],
		[
			"2004-10-20",
			1.73
		],
		[
			"2005-12-02",
			0.27
		],
		[
			"2005-05-17",
			0.22
		],
		[
			"2006-09-11",
			0.22
		],
		[
			"2007-08-13",
			0.22
		],
		[
			"2008-09-02",
			0.4
		],
		[
			"2009-09-10",
			4.43
		],
		[
			"2010-08-18",
			4.43
		],
		[
			"2011-10-06",
			4.43
		],
		[
			"2012-08-23",
			1.33
		]
	],
	"110200354": [
		[
			"2013-09-23",
			2.12
		],
		[
			"2015-03-23",
			1.33
		],
		[
			"2006-11-21",
			3.5
		],
		[
			"2007-08-13",
			0.22
		],
		[
			"2008-09-01",
			0.22
		],
		[
			"2009-09-09",
			4.43
		],
		[
			"2010-08-16",
			4.43
		],
		[
			"2011-10-05",
			4.43
		],
		[
			"2012-07-24",
			1.33
		]
	],
	"110200366": [
		[
			"2013-09-26",
			35.03
		],
		[
			"2015-03-24",
			25.82
		],
		[
			"2003-07-01",
			13.15
		],
		[
			"2003-12-03",
			14.17
		],
		[
			"2004-07-05",
			17.01
		],
		[
			"2004-10-20",
			15.59
		],
		[
			"2005-12-02",
			17.54
		],
		[
			"2005-05-17",
			17.8
		],
		[
			"2006-09-11",
			17.54
		],
		[
			"2007-08-10",
			15.5
		],
		[
			"2008-09-01",
			21.83
		],
		[
			"2009-09-09",
			23.91
		],
		[
			"2010-08-18",
			24.36
		],
		[
			"2011-10-05",
			26.57
		],
		[
			"2012-07-24",
			28.79
		]
	],
	"110200378": [
		[
			"2013-10-16",
			2.6
		],
		[
			"2015-03-19",
			1.33
		],
		[
			"2003-11-26",
			0.4
		],
		[
			"2004-05-25",
			0.66
		],
		[
			"2004-10-21",
			0.35
		],
		[
			"2005-12-01",
			0.8
		],
		[
			"2005-05-18",
			0.4
		],
		[
			"2006-09-06",
			2.39
		],
		[
			"2007-08-16",
			1.77
		],
		[
			"2008-09-02",
			0.53
		],
		[
			"2009-09-10",
			4.43
		],
		[
			"2010-08-20",
			4.43
		],
		[
			"2011-10-06",
			4.43
		],
		[
			"2012-08-23",
			1.33
		]
	],
	"110200380": [
		[
			"2013-07-25",
			76.61
		],
		[
			"2015-03-18",
			93.44
		],
		[
			"2004-05-25",
			86.8
		],
		[
			"2004-10-20",
			56.69
		],
		[
			"2005-12-01",
			46.06
		],
		[
			"2005-05-18",
			76.17
		],
		[
			"2006-09-06",
			68.2
		],
		[
			"2007-08-13",
			77.94
		],
		[
			"2008-09-02",
			16.61
		],
		[
			"2009-09-10",
			57.13
		],
		[
			"2010-08-20",
			69.53
		]
	],
	"110200391": [
		[
			"2013-09-23",
			32.24
		],
		[
			"2015-03-20",
			18.16
		],
		[
			"2007-08-10",
			0.22
		],
		[
			"2008-09-01",
			13.02
		],
		[
			"2009-09-09",
			18.6
		],
		[
			"2010-08-18",
			18.16
		],
		[
			"2011-10-05",
			21.7
		],
		[
			"2012-07-24",
			20.81
		]
	],
	"110200408": [
		[
			"2013-07-04",
			78.83
		],
		[
			"2015-10-29",
			202.83
		],
		[
			"2003-12-02",
			167.4
		],
		[
			"2004-06-07",
			178.03
		],
		[
			"2004-10-19",
			165.63
		],
		[
			"2005-12-06",
			123.11
		],
		[
			"2005-05-17",
			115.14
		],
		[
			"2006-08-10",
			164.3
		],
		[
			"2007-06-18",
			116.91
		],
		[
			"2007-11-13",
			170.94
		],
		[
			"2008-10-09",
			232.06
		],
		[
			"2008-05-19",
			185.11
		],
		[
			"2009-07-08",
			248
		],
		[
			"2010-06-23",
			248
		],
		[
			"2011-04-29",
			258.19
		],
		[
			"2012-07-24",
			194.41
		]
	],
	"110200410": [
		[
			"2013-09-17",
			22.23
		],
		[
			"2015-12-01",
			78.39
		],
		[
			"2006-11-16",
			6.78
		],
		[
			"2007-08-17",
			18.47
		],
		[
			"2007-11-13",
			68.2
		],
		[
			"2005-12-20",
			46.06
		],
		[
			"2008-07-28",
			11.69
		],
		[
			"2009-08-18",
			15.06
		],
		[
			"2010-08-20",
			15.5
		],
		[
			"2011-11-16",
			12.84
		],
		[
			"2012-08-21",
			24.36
		]
	],
	"110200445": [
		[
			"2013-10-10",
			45.61
		],
		[
			"2015-12-01",
			27.37
		],
		[
			"2007-08-16",
			38.35
		],
		[
			"2008-07-25",
			6.16
		],
		[
			"2009-08-19",
			37.64
		],
		[
			"2010-09-01",
			73.07
		],
		[
			"2011-11-14",
			60.67
		],
		[
			"2012-08-23",
			46.5
		]
	],
	"110200457": [
		[
			"2013-09-11",
			57.13
		],
		[
			"2014-07-25",
			33.13
		],
		[
			"2015-12-08",
			32.28
		],
		[
			"2007-08-24",
			15.59
		],
		[
			"2008-07-28",
			46.5
		],
		[
			"2009-08-21",
			57.57
		],
		[
			"2010-08-31",
			51.81
		],
		[
			"2011-11-18",
			62.89
		],
		[
			"2012-08-21",
			53.14
		]
	],
	"110200469": [
		[
			"2013-09-11",
			2.38
		],
		[
			"2015-11-24",
			6.69
		],
		[
			"2007-08-20",
			0.22
		],
		[
			"2008-07-25",
			0.22
		],
		[
			"2009-08-21",
			4.43
		],
		[
			"2010-08-31",
			4.43
		],
		[
			"2011-11-16",
			4.43
		],
		[
			"2012-08-02",
			1.33
		]
	],
	"110200470": [
		[
			"2013-09-23",
			1.33
		],
		[
			"2015-05-05",
			1.33
		],
		[
			"2007-08-23",
			0.71
		],
		[
			"2008-09-03",
			0.31
		],
		[
			"2009-09-10",
			4.43
		],
		[
			"2010-08-31",
			4.43
		],
		[
			"2011-10-06",
			4.43
		],
		[
			"2012-07-25",
			2.66
		]
	],
	"110200482": [
		[
			"2013-07-25",
			13.82
		],
		[
			"2015-11-24",
			15.85
		],
		[
			"2007-08-23",
			11.2
		],
		[
			"2008-08-01",
			7.26
		],
		[
			"2009-07-07",
			12.4
		],
		[
			"2010-06-07",
			11.51
		],
		[
			"2011-06-09",
			9.74
		],
		[
			"2012-07-25",
			13.73
		]
	],
	"110210050": [
		[
			"2013-08-05",
			1.33
		],
		[
			"2015-05-06",
			1.33
		],
		[
			"2004-12-07",
			0.49
		],
		[
			"2005-04-14",
			0.22
		],
		[
			"2006-10-19",
			0.22
		],
		[
			"2007-07-13",
			0.22
		],
		[
			"2008-08-19",
			0.22
		],
		[
			"2008-08-29",
			0.58
		],
		[
			"2005-10-13",
			0.22
		],
		[
			"2010-07-05",
			4.43
		],
		[
			"2011-11-15",
			4.43
		],
		[
			"2012-08-08",
			1.33
		]
	],
	"110210062": [
		[
			"2013-08-07",
			1.33
		],
		[
			"2015-09-29",
			1.33
		],
		[
			"2000-05-29",
			2.48
		],
		[
			"2000-11-24",
			0.4
		],
		[
			"2001-05-18",
			0.62
		],
		[
			"2001-10-29",
			1.02
		],
		[
			"2002-05-06",
			1.28
		],
		[
			"2003-04-03",
			1.06
		],
		[
			"2003-10-24",
			4.92
		],
		[
			"2004-06-02",
			0.22
		],
		[
			"2004-10-22",
			0.58
		],
		[
			"2005-10-25",
			0.62
		],
		[
			"2005-04-14",
			0.22
		],
		[
			"2006-10-20",
			1.55
		],
		[
			"2007-07-13",
			4.16
		],
		[
			"2008-08-20",
			2.3
		],
		[
			"2002-09-25",
			0.22
		],
		[
			"2009-08-07",
			4.43
		],
		[
			"2010-07-05",
			4.43
		],
		[
			"2011-05-27",
			4.43
		],
		[
			"2012-06-12",
			1.33
		]
	],
	"110210074": [
		[
			"2013-06-17",
			1.33
		],
		[
			"2015-09-17",
			1.33
		],
		[
			"2000-05-29",
			0.31
		],
		[
			"2000-10-13",
			0.22
		],
		[
			"2001-05-22",
			0.22
		],
		[
			"2001-10-30",
			0.75
		],
		[
			"2002-05-06",
			1.2
		],
		[
			"2002-10-25",
			1.24
		],
		[
			"2003-10-24",
			0.4
		],
		[
			"2003-04-07",
			0.22
		],
		[
			"2004-05-11",
			0.22
		],
		[
			"2004-10-22",
			0.22
		],
		[
			"2005-10-26",
			0.22
		],
		[
			"2005-04-14",
			0.22
		],
		[
			"2006-10-11",
			0.22
		],
		[
			"2007-07-13",
			1.15
		],
		[
			"2008-08-28",
			0.22
		],
		[
			"2008-08-19",
			0.22
		],
		[
			"2009-08-06",
			4.43
		],
		[
			"2010-06-15",
			4.43
		],
		[
			"2011-05-27",
			4.43
		],
		[
			"2012-06-01",
			1.33
		]
	],
	"110210086": [
		[
			"2013-08-05",
			1.33
		],
		[
			"2015-09-29",
			1.33
		],
		[
			"2000-06-15",
			0.66
		],
		[
			"2000-10-13",
			1.59
		],
		[
			"2001-05-16",
			0.22
		],
		[
			"2001-11-09",
			1.55
		],
		[
			"2002-04-30",
			0.62
		],
		[
			"2003-04-03",
			0.97
		],
		[
			"2003-10-24",
			1.46
		],
		[
			"2004-05-11",
			0.71
		],
		[
			"2004-10-22",
			0.58
		],
		[
			"2005-10-25",
			1.06
		],
		[
			"2005-04-20",
			0.53
		],
		[
			"2006-10-12",
			1.9
		],
		[
			"2007-07-17",
			1.55
		],
		[
			"2008-08-20",
			0.31
		],
		[
			"2002-09-25",
			0.75
		],
		[
			"2009-08-06",
			4.43
		],
		[
			"2010-06-18",
			4.43
		],
		[
			"2011-05-27",
			4.43
		],
		[
			"2012-06-01",
			1.33
		]
	],
	"110210130": [
		[
			"2013-06-25",
			1.33
		],
		[
			"2015-11-02",
			1.33
		],
		[
			"2000-06-15",
			1.33
		],
		[
			"2000-10-13",
			1.77
		],
		[
			"2001-05-18",
			0.89
		],
		[
			"2001-10-29",
			0.84
		],
		[
			"2002-06-17",
			1.59
		],
		[
			"2003-10-24",
			10.85
		],
		[
			"2003-04-07",
			0.22
		],
		[
			"2004-05-11",
			7.71
		],
		[
			"2004-10-25",
			1.64
		],
		[
			"2005-10-25",
			1.86
		],
		[
			"2005-04-20",
			5.49
		],
		[
			"2006-10-11",
			1.28
		],
		[
			"2007-05-11",
			5
		],
		[
			"2002-09-25",
			1.55
		],
		[
			"2008-06-19",
			2.7
		],
		[
			"2009-06-19",
			8.41
		],
		[
			"2010-05-19",
			4.43
		],
		[
			"2011-05-02",
			4.43
		],
		[
			"2012-06-12",
			1.33
		]
	],
	"110210177": [
		[
			"2013-06-28",
			33.88
		],
		[
			"2015-10-29",
			37.02
		],
		[
			"2004-06-09",
			31.35
		],
		[
			"2004-10-25",
			30.47
		],
		[
			"2005-04-15",
			33.88
		],
		[
			"2006-10-19",
			16.96
		],
		[
			"2007-05-11",
			24.84
		],
		[
			"2005-10-13",
			29.36
		],
		[
			"2008-06-23",
			14.26
		],
		[
			"2009-07-13",
			19.49
		],
		[
			"2010-06-09",
			27.9
		],
		[
			"2011-05-03",
			30.56
		],
		[
			"2012-06-13",
			25.24
		]
	],
	"110210189": [
		[
			"2013-08-07",
			1.33
		],
		[
			"2015-05-08",
			1.33
		],
		[
			"2004-12-03",
			0.22
		],
		[
			"2005-04-15",
			0.22
		],
		[
			"2006-10-19",
			0.22
		],
		[
			"2007-06-19",
			0.22
		],
		[
			"2005-10-13",
			0.22
		],
		[
			"2008-06-23",
			0.22
		],
		[
			"2009-09-11",
			4.43
		],
		[
			"2010-07-06",
			4.43
		],
		[
			"2011-10-27",
			4.43
		],
		[
			"2012-06-13",
			1.33
		]
	],
	"110210190": [
		[
			"2013-06-19",
			186.44
		],
		[
			"2015-11-18",
			152.34
		],
		[
			"2004-12-03",
			184.67
		],
		[
			"2005-10-25",
			166.96
		],
		[
			"2005-04-20",
			133.74
		],
		[
			"2006-10-12",
			159.87
		],
		[
			"2007-05-14",
			116.91
		],
		[
			"2008-06-24",
			115.14
		],
		[
			"2009-06-19",
			167.84
		],
		[
			"2010-05-19",
			114.26
		],
		[
			"2011-05-13",
			126.21
		],
		[
			"2012-06-13",
			173.16
		]
	],
	"110210207": [
		[
			"2013-06-21",
			16.92
		],
		[
			"2015-11-16",
			21.39
		],
		[
			"2004-12-08",
			14.57
		],
		[
			"2005-11-11",
			9.88
		],
		[
			"2005-04-26",
			15.23
		],
		[
			"2006-11-02",
			7.93
		],
		[
			"2007-05-16",
			14.84
		],
		[
			"2008-07-01",
			7.66
		],
		[
			"2009-06-23",
			9.74
		],
		[
			"2010-05-20",
			15.06
		],
		[
			"2011-05-25",
			12.84
		],
		[
			"2012-06-20",
			18.16
		]
	],
	"110210219": [
		[
			"2013-06-26",
			1.33
		],
		[
			"2015-09-30",
			1.33
		],
		[
			"2004-12-08",
			0.53
		],
		[
			"2005-04-26",
			0.22
		],
		[
			"2006-11-06",
			0.22
		],
		[
			"2007-07-17",
			0.22
		],
		[
			"2008-08-29",
			0.4
		],
		[
			"2005-11-11",
			0.22
		],
		[
			"2009-08-10",
			4.43
		],
		[
			"2010-07-02",
			4.43
		],
		[
			"2011-06-21",
			4.43
		],
		[
			"2012-06-20",
			1.33
		]
	],
	"110220092": [
		[
			"2013-06-21",
			1.33
		],
		[
			"2014-12-08",
			1.33
		],
		[
			"2015-11-05",
			1.33
		],
		[
			"2006-11-02",
			3.45
		],
		[
			"2007-05-16",
			1.06
		],
		[
			"2008-07-01",
			0.44
		],
		[
			"2010-05-10",
			4.43
		],
		[
			"2011-05-05",
			4.43
		],
		[
			"2012-06-15",
			1.33
		]
	],
	"110220109": [
		[
			"2013-06-21",
			100.53
		],
		[
			"2014-12-04",
			90.34
		],
		[
			"2015-11-05",
			89.46
		],
		[
			"2000-05-29",
			72.19
		],
		[
			"2000-10-27",
			46.94
		],
		[
			"2000-10-11",
			50.93
		],
		[
			"2001-05-15",
			116.47
		],
		[
			"2001-05-23",
			110.71
		],
		[
			"2001-08-23",
			85.47
		],
		[
			"2001-10-30",
			74.84
		],
		[
			"2002-04-30",
			96.54
		],
		[
			"2002-06-17",
			69.09
		],
		[
			"2002-10-29",
			104.07
		],
		[
			"2003-03-31",
			94.33
		],
		[
			"2003-09-12",
			90.34
		],
		[
			"2003-06-06",
			50.93
		],
		[
			"2003-12-10",
			46.94
		],
		[
			"2004-04-19",
			91.23
		],
		[
			"2004-06-28",
			76.61
		],
		[
			"2004-10-12",
			75.73
		],
		[
			"2004-12-02",
			58.9
		],
		[
			"2005-12-05",
			79.71
		],
		[
			"2005-04-13",
			82.81
		],
		[
			"2005-05-30",
			71.74
		],
		[
			"2006-08-07",
			69.09
		],
		[
			"2006-11-02",
			61.11
		],
		[
			"2007-05-16",
			83.26
		],
		[
			"2008-07-01",
			66.43
		],
		[
			"2000-03-07",
			98.76
		],
		[
			"2002-09-16",
			101.41
		],
		[
			"2005-10-05",
			79.71
		],
		[
			"2009-06-23",
			71.74
		],
		[
			"2010-05-10",
			87.24
		],
		[
			"2011-05-05",
			78.39
		],
		[
			"2012-06-15",
			76.61
		]
	],
	"110220365": [
		[
			"2013-06-26",
			10.67
		],
		[
			"2014-11-05",
			1.33
		],
		[
			"2015-11-06",
			1.33
		],
		[
			"2006-11-02",
			0.27
		],
		[
			"2007-06-01",
			0.22
		],
		[
			"2007-11-20",
			10.89
		],
		[
			"2008-07-01",
			9.61
		],
		[
			"2009-06-23",
			7.53
		],
		[
			"2010-05-10",
			11.96
		],
		[
			"2011-05-05",
			19.93
		],
		[
			"2012-06-15",
			25.24
		]
	],
	"110220390": [
		[
			"2013-07-26",
			76.61
		],
		[
			"2014-12-05",
			53.14
		],
		[
			"2015-09-10",
			46.06
		],
		[
			"2006-11-03",
			113.81
		],
		[
			"2007-07-10",
			113.81
		],
		[
			"2008-08-15",
			113.81
		],
		[
			"2009-09-07",
			78.39
		],
		[
			"2010-07-12",
			103.63
		],
		[
			"2011-07-15",
			100.53
		],
		[
			"2012-06-14",
			94.77
		]
	],
	"110220419": [
		[
			"2013-07-26",
			35.52
		],
		[
			"2014-12-08",
			59.34
		],
		[
			"2015-09-11",
			58.9
		],
		[
			"2006-10-24",
			10.05
		],
		[
			"2007-07-10",
			47.83
		],
		[
			"2008-08-15",
			46.94
		],
		[
			"2009-08-31",
			41.63
		],
		[
			"2010-07-12",
			42.07
		],
		[
			"2011-07-15",
			57.13
		],
		[
			"2012-06-20",
			59.79
		]
	],
	"110220791": [
		[
			"2013-06-24",
			223.2
		],
		[
			"2014-10-28",
			216.11
		],
		[
			"2015-12-07",
			178.47
		],
		[
			"2000-05-25",
			305.57
		],
		[
			"2000-10-12",
			248.89
		],
		[
			"2001-05-22",
			238.26
		],
		[
			"2001-10-30",
			251.1
		],
		[
			"2002-05-28",
			206.81
		],
		[
			"2003-05-08",
			214.79
		],
		[
			"2003-11-04",
			197.96
		],
		[
			"2004-05-17",
			263.5
		],
		[
			"2004-11-17",
			231.61
		],
		[
			"2005-04-27",
			280.33
		],
		[
			"2006-12-13",
			192.64
		],
		[
			"2007-05-29",
			196.63
		],
		[
			"2005-11-10",
			220.99
		],
		[
			"2002-09-16",
			197.96
		],
		[
			"2008-07-03",
			208.59
		],
		[
			"2009-06-29",
			263.06
		],
		[
			"2010-05-28",
			253.31
		],
		[
			"2011-05-10",
			172.27
		],
		[
			"2012-06-14",
			219.66
		]
	],
	"110220808": [
		[
			"2013-06-24",
			59.79
		],
		[
			"2014-10-28",
			30.42
		],
		[
			"2015-12-07",
			18.42
		],
		[
			"2006-10-24",
			12.53
		],
		[
			"2007-05-29",
			46.06
		],
		[
			"2008-07-03",
			50.93
		],
		[
			"2009-06-29",
			50.93
		],
		[
			"2010-05-28",
			50.04
		],
		[
			"2011-05-10",
			45.61
		],
		[
			"2012-06-14",
			31.89
		]
	],
	"110220870": [
		[
			"2013-06-19",
			42.56
		],
		[
			"2014-10-30",
			38.44
		],
		[
			"2015-11-24",
			61.56
		],
		[
			"2000-06-28",
			49.6
		],
		[
			"2000-10-19",
			44.73
		],
		[
			"2001-05-08",
			27.01
		],
		[
			"2001-10-30",
			30.34
		],
		[
			"2002-06-17",
			22.1
		],
		[
			"2003-09-12",
			40.48
		],
		[
			"2003-07-02",
			35.43
		],
		[
			"2004-10-25",
			36.23
		],
		[
			"2004-07-01",
			36.54
		],
		[
			"2005-04-15",
			27.72
		],
		[
			"2006-10-20",
			40.43
		],
		[
			"2007-05-14",
			46.5
		],
		[
			"2007-11-12",
			55.8
		],
		[
			"2008-06-25",
			43.75
		],
		[
			"2002-09-02",
			24.05
		],
		[
			"2005-10-06",
			36.05
		],
		[
			"2009-07-13",
			77.94
		],
		[
			"2010-06-09",
			69.97
		],
		[
			"2011-05-03",
			49.16
		],
		[
			"2012-07-20",
			54.47
		]
	],
	"110220882": [
		[
			"2013-06-26",
			1.42
		],
		[
			"2014-10-30",
			1.33
		],
		[
			"2015-11-06",
			1.33
		],
		[
			"2006-11-06",
			5.36
		],
		[
			"2007-05-31",
			0.27
		],
		[
			"2007-11-20",
			11.12
		],
		[
			"2008-06-25",
			0.27
		],
		[
			"2009-06-22",
			4.43
		],
		[
			"2010-05-21",
			4.43
		],
		[
			"2011-04-26",
			4.43
		],
		[
			"2012-07-20",
			1.33
		]
	],
	"110220924": [
		[
			"2013-08-07",
			9.92
		],
		[
			"2014-11-05",
			5.98
		],
		[
			"2015-10-27",
			3.52
		],
		[
			"2004-12-03",
			3.37
		],
		[
			"2005-04-15",
			1.99
		],
		[
			"2006-10-19",
			2.97
		],
		[
			"2007-05-11",
			2.35
		],
		[
			"2005-10-13",
			3.9
		],
		[
			"2008-06-23",
			3.14
		],
		[
			"2009-07-20",
			4.43
		],
		[
			"2010-06-10",
			4.43
		],
		[
			"2011-05-03",
			4.43
		],
		[
			"2012-07-20",
			7.97
		]
	],
	"110240029": [
		[
			"2013-08-27",
			1.33
		],
		[
			"2014-11-10",
			1.33
		],
		[
			"2015-06-16",
			1.33
		],
		[
			"2000-05-24",
			0.22
		],
		[
			"2000-11-20",
			1.02
		],
		[
			"2001-05-30",
			0.22
		],
		[
			"2001-11-14",
			0.22
		],
		[
			"2002-05-07",
			1.15
		],
		[
			"2003-05-09",
			1.11
		],
		[
			"2003-11-12",
			0.22
		],
		[
			"2004-05-26",
			0.27
		],
		[
			"2004-11-11",
			0.22
		],
		[
			"2005-10-24",
			0.22
		],
		[
			"2005-04-25",
			0.22
		],
		[
			"2006-11-08",
			0.27
		],
		[
			"2007-07-12",
			0.22
		],
		[
			"2008-07-31",
			0.22
		],
		[
			"2002-09-26",
			0.22
		],
		[
			"2009-09-01",
			4.43
		],
		[
			"2010-07-21",
			4.43
		],
		[
			"2011-10-10",
			4.43
		],
		[
			"2012-07-17",
			1.33
		]
	],
	"110240121": [
		[
			"2013-08-01",
			1.81
		],
		[
			"2014-10-31",
			1.33
		],
		[
			"2015-09-14",
			1.33
		],
		[
			"2006-10-23",
			2.04
		],
		[
			"2007-07-09",
			0.22
		],
		[
			"2008-08-06",
			0.22
		],
		[
			"2009-08-27",
			4.43
		],
		[
			"2010-07-07",
			4.43
		],
		[
			"2011-07-13",
			4.43
		],
		[
			"2012-07-17",
			1.33
		]
	],
	"110240133": [
		[
			"2013-06-19",
			8.55
		],
		[
			"2015-05-13",
			1.33
		],
		[
			"2000-05-26",
			24.05
		],
		[
			"2000-10-12",
			20.86
		],
		[
			"2001-11-14",
			12.05
		],
		[
			"2001-05-16",
			13.95
		],
		[
			"2002-05-28",
			7.84
		],
		[
			"2003-04-23",
			13.64
		],
		[
			"2003-11-04",
			10.36
		],
		[
			"2004-05-17",
			7
		],
		[
			"2004-12-07",
			0.22
		],
		[
			"2005-04-26",
			4.3
		],
		[
			"2006-10-25",
			11.96
		],
		[
			"2007-07-09",
			9.88
		],
		[
			"2005-11-11",
			13.29
		],
		[
			"2008-08-06",
			10.67
		],
		[
			"2002-09-27",
			14.97
		],
		[
			"2009-08-27",
			9.3
		],
		[
			"2010-07-07",
			18.16
		],
		[
			"2011-07-13",
			4.43
		],
		[
			"2012-07-17",
			20.37
		]
	],
	"110240145": [
		[
			"2013-06-24",
			30.16
		],
		[
			"2014-12-03",
			21.12
		],
		[
			"2015-09-16",
			21.08
		],
		[
			"2000-06-16",
			84.59
		],
		[
			"2000-10-19",
			43.75
		],
		[
			"2001-05-08",
			71.74
		],
		[
			"2001-11-09",
			55.8
		],
		[
			"2002-05-28",
			74.4
		],
		[
			"2003-09-12",
			73.07
		],
		[
			"2003-05-08",
			76.61
		],
		[
			"2004-06-28",
			73.96
		],
		[
			"2004-11-17",
			66.87
		],
		[
			"2005-04-27",
			80.6
		],
		[
			"2006-11-03",
			89.01
		],
		[
			"2007-07-09",
			81.93
		],
		[
			"2008-08-12",
			83.7
		],
		[
			"2002-09-02",
			73.96
		],
		[
			"2005-10-06",
			68.2
		],
		[
			"2009-08-31",
			111.6
		],
		[
			"2010-07-07",
			62.44
		],
		[
			"2011-10-11",
			39.41
		],
		[
			"2012-08-14",
			43.84
		]
	],
	"110240169": [
		[
			"2013-08-01",
			1.33
		],
		[
			"2014-12-05",
			1.36
		],
		[
			"2015-11-17",
			1.33
		],
		[
			"2007-07-04",
			0.31
		],
		[
			"2008-08-12",
			0.4
		],
		[
			"2009-09-07",
			4.43
		],
		[
			"2010-07-20",
			4.43
		],
		[
			"2011-10-11",
			4.43
		],
		[
			"2012-08-03",
			1.33
		]
	],
	"110240194": [
		[
			"2013-08-30",
			1.33
		],
		[
			"2014-12-02",
			1.33
		],
		[
			"2015-06-08",
			1.33
		],
		[
			"2000-10-12",
			0.66
		],
		[
			"2000-06-16",
			2.48
		],
		[
			"2001-05-23",
			4.34
		],
		[
			"2001-11-09",
			0.4
		],
		[
			"2002-05-28",
			3.59
		],
		[
			"2002-10-09",
			0.97
		],
		[
			"2003-05-08",
			3.23
		],
		[
			"2003-11-04",
			0.4
		],
		[
			"2004-06-02",
			6.24
		],
		[
			"2004-11-17",
			3.19
		],
		[
			"2005-04-27",
			9.39
		],
		[
			"2006-11-03",
			0.22
		],
		[
			"2007-05-30",
			2.17
		],
		[
			"2005-11-10",
			1.11
		],
		[
			"2008-07-04",
			1.9
		],
		[
			"2009-07-06",
			4.43
		],
		[
			"2010-07-20",
			4.43
		],
		[
			"2011-10-13",
			4.43
		],
		[
			"2012-08-03",
			1.77
		]
	],
	"110250035": [
		[
			"2013-08-13",
			1.95
		],
		[
			"2014-12-11",
			1.33
		],
		[
			"2015-11-20",
			2.76
		],
		[
			"2006-11-07",
			0.75
		],
		[
			"2007-07-30",
			0.8
		],
		[
			"2003-06-25",
			0.62
		],
		[
			"2003-12-01",
			0.84
		],
		[
			"2008-07-18",
			0.27
		],
		[
			"2009-07-31",
			4.43
		],
		[
			"2010-08-27",
			4.43
		],
		[
			"2011-10-20",
			4.43
		],
		[
			"2012-08-10",
			1.33
		]
	],
	"110250060": [
		[
			"2013-07-24",
			1.33
		],
		[
			"2015-11-18",
			1.33
		],
		[
			"2006-09-14",
			4.12
		],
		[
			"2007-07-27",
			5
		],
		[
			"2008-07-16",
			0.97
		],
		[
			"2009-07-29",
			4.43
		],
		[
			"2010-08-19",
			8.86
		],
		[
			"2011-10-17",
			4.43
		],
		[
			"2012-07-27",
			6.64
		]
	],
	"110250072": [
		[
			"2013-07-24",
			55.8
		],
		[
			"2014-12-15",
			40.08
		],
		[
			"2015-11-25",
			38.62
		],
		[
			"2006-10-09",
			100.97
		],
		[
			"2007-07-27",
			48.27
		],
		[
			"2007-11-23",
			43.93
		],
		[
			"2008-07-17",
			41.05
		],
		[
			"2009-07-29",
			49.16
		],
		[
			"2010-08-30",
			51.37
		],
		[
			"2011-10-17",
			47.39
		],
		[
			"2012-07-27",
			55.8
		]
	],
	"110250114": [
		[
			"2013-07-24",
			1.33
		],
		[
			"2015-11-25",
			1.33
		],
		[
			"2006-09-14",
			0.27
		],
		[
			"2007-08-01",
			1.82
		],
		[
			"2008-07-16",
			0.22
		],
		[
			"2009-08-05",
			4.43
		],
		[
			"2010-08-19",
			4.43
		],
		[
			"2011-10-19",
			4.43
		],
		[
			"2012-08-06",
			2.66
		]
	],
	"110250126": [
		[
			"2013-09-27",
			1.33
		],
		[
			"2015-11-26",
			1.33
		],
		[
			"2006-09-14",
			0.22
		],
		[
			"2007-08-01",
			0.31
		],
		[
			"2008-07-16",
			0.22
		],
		[
			"2009-07-29",
			4.43
		],
		[
			"2010-08-19",
			4.43
		],
		[
			"2011-10-17",
			4.43
		],
		[
			"2012-07-27",
			1.33
		]
	],
	"110250140": [
		[
			"2015-11-24",
			6.95
		],
		[
			"2006-09-14",
			15.23
		],
		[
			"2007-07-31",
			4.43
		],
		[
			"2008-07-17",
			2.48
		],
		[
			"2009-07-30",
			4.43
		],
		[
			"2010-08-24",
			4.43
		],
		[
			"2011-10-20",
			4.43
		],
		[
			"2012-08-06",
			7.53
		]
	],
	"110260314": [
		[
			"2013-08-26",
			1.33
		],
		[
			"2014-08-19",
			1.33
		],
		[
			"2015-08-27",
			1.33
		],
		[
			"2007-04-26",
			0.62
		],
		[
			"2006-08-15",
			1.82
		],
		[
			"2007-11-15",
			1.33
		],
		[
			"2008-05-07",
			0.22
		],
		[
			"2009-05-27",
			4.43
		],
		[
			"2010-05-12",
			4.43
		],
		[
			"2011-04-29",
			4.43
		],
		[
			"2012-05-29",
			1.33
		]
	],
	"110260340": [
		[
			"2013-08-26",
			1.33
		],
		[
			"2014-08-18",
			1.33
		],
		[
			"2015-08-26",
			1.33
		],
		[
			"2007-04-27",
			0.62
		],
		[
			"2006-08-15",
			3.72
		],
		[
			"2008-05-05",
			0.22
		],
		[
			"2009-05-27",
			44.73
		],
		[
			"2010-05-12",
			4.43
		],
		[
			"2011-04-29",
			4.43
		],
		[
			"2012-07-26",
			1.33
		]
	],
	"110280015": [
		[
			"2013-09-02",
			117.8
		],
		[
			"2014-08-25",
			113.81
		],
		[
			"2015-07-02",
			74.4
		],
		[
			"2003-11-25",
			93
		],
		[
			"2004-06-04",
			90.34
		],
		[
			"2004-11-18",
			91.67
		],
		[
			"2005-11-03",
			89.01
		],
		[
			"2005-06-23",
			92.56
		],
		[
			"2006-11-10",
			87.69
		],
		[
			"2007-07-11",
			104.07
		],
		[
			"2008-07-29",
			58.9
		],
		[
			"2009-09-01",
			81.49
		],
		[
			"2010-08-09",
			91.23
		],
		[
			"2011-07-11",
			104.51
		],
		[
			"2012-07-23",
			133.3
		]
	],
	"110280027": [
		[
			"2013-08-28",
			89.46
		],
		[
			"2014-11-13",
			85.03
		],
		[
			"2015-06-17",
			86.8
		],
		[
			"2003-11-25",
			85.03
		],
		[
			"2004-06-04",
			84.14
		],
		[
			"2004-11-18",
			80.16
		],
		[
			"2005-11-03",
			78.83
		],
		[
			"2005-06-24",
			81.93
		],
		[
			"2006-11-10",
			78.39
		],
		[
			"2007-07-11",
			85.47
		],
		[
			"2008-07-29",
			83.7
		],
		[
			"2009-10-07",
			89.9
		],
		[
			"2010-08-09",
			96.99
		],
		[
			"2011-07-11",
			94.33
		],
		[
			"2012-07-23",
			84.59
		]
	],
	"110290021": [
		[
			"2013-08-28",
			1.33
		],
		[
			"2015-07-14",
			1.33
		],
		[
			"2003-12-02",
			0.44
		],
		[
			"2004-06-08",
			2.39
		],
		[
			"2004-11-12",
			0.22
		],
		[
			"2005-11-08",
			0.22
		],
		[
			"2005-05-24",
			0.22
		],
		[
			"2006-08-22",
			0.22
		],
		[
			"2007-06-12",
			0.4
		],
		[
			"2008-11-06",
			0.4
		],
		[
			"2008-06-03",
			0.22
		],
		[
			"2009-05-18",
			4.43
		],
		[
			"2010-05-25",
			4.43
		],
		[
			"2011-05-04",
			4.43
		],
		[
			"2012-05-31",
			1.33
		]
	],
	"110290045": [
		[
			"2013-06-20",
			94.33
		],
		[
			"2014-10-23",
			93.89
		],
		[
			"2015-01-28",
			92.11
		],
		[
			"2004-06-04",
			67.31
		],
		[
			"2004-11-12",
			64.66
		],
		[
			"2005-11-08",
			67.31
		],
		[
			"2005-05-24",
			58.46
		],
		[
			"2006-11-14",
			74.84
		],
		[
			"2007-07-12",
			81.49
		],
		[
			"2009-08-12",
			77.5
		],
		[
			"2010-08-09",
			96.54
		],
		[
			"2011-07-08",
			89.46
		],
		[
			"2012-08-13",
			85.03
		]
	],
	"110310019": [
		[
			"2013-08-06",
			85.47
		],
		[
			"2015-11-10",
			86.8
		],
		[
			"2000-11-30",
			81.04
		],
		[
			"2000-07-12",
			54.03
		],
		[
			"2001-11-26",
			79.27
		],
		[
			"2001-08-23",
			76.17
		],
		[
			"2002-06-21",
			77.06
		],
		[
			"2003-11-06",
			46.5
		],
		[
			"2003-04-23",
			89.46
		],
		[
			"2005-07-11",
			83.26
		],
		[
			"2006-01-09",
			73.07
		],
		[
			"2006-12-14",
			36.23
		],
		[
			"2007-08-14",
			85.03
		],
		[
			"2008-08-05",
			58.46
		],
		[
			"2009-10-06",
			41.63
		],
		[
			"2010-08-24",
			60.67
		],
		[
			"2011-10-28",
			30.56
		],
		[
			"2012-08-30",
			73.96
		]
	],
	"110310317": [
		[
			"2013-08-01",
			3.43
		],
		[
			"2015-09-23",
			2.32
		],
		[
			"2000-07-12",
			2.7
		],
		[
			"2000-11-23",
			2.79
		],
		[
			"2001-06-20",
			3.63
		],
		[
			"2001-11-21",
			3.59
		],
		[
			"2002-06-20",
			5
		],
		[
			"2003-05-08",
			4.34
		],
		[
			"2003-12-10",
			2.7
		],
		[
			"2004-06-02",
			3.45
		],
		[
			"2004-12-08",
			2.66
		],
		[
			"2005-04-27",
			3.72
		],
		[
			"2006-11-03",
			2.83
		],
		[
			"2007-07-10",
			3.14
		],
		[
			"2005-11-10",
			2.21
		],
		[
			"2008-08-18",
			2.08
		],
		[
			"2002-10-10",
			4.25
		],
		[
			"2009-09-11",
			4.43
		],
		[
			"2010-07-23",
			4.43
		],
		[
			"2011-10-13",
			4.43
		],
		[
			"2012-08-24",
			3.1
		]
	],
	"110320062": [
		[
			"2013-06-25",
			1.33
		],
		[
			"2015-06-24",
			1.33
		],
		[
			"2000-06-16",
			0.44
		],
		[
			"2000-11-23",
			1.55
		],
		[
			"2001-05-28",
			0.22
		],
		[
			"2001-10-26",
			0.71
		],
		[
			"2002-05-29",
			1.24
		],
		[
			"2003-05-09",
			1.55
		],
		[
			"2003-12-10",
			4.12
		],
		[
			"2004-05-17",
			0.58
		],
		[
			"2004-11-23",
			0.27
		],
		[
			"2005-05-02",
			0.22
		],
		[
			"2006-09-04",
			0.22
		],
		[
			"2007-05-30",
			0.22
		],
		[
			"2005-11-21",
			0.22
		],
		[
			"2002-09-26",
			0.22
		],
		[
			"2008-07-04",
			0.22
		],
		[
			"2009-06-17",
			4.43
		],
		[
			"2010-07-19",
			4.43
		],
		[
			"2011-07-04",
			4.43
		],
		[
			"2012-08-14",
			1.33
		],
		[
			"2012-07-18",
			1.33
		]
	],
	"110320104": [
		[
			"2013-08-20",
			1.33
		],
		[
			"2015-06-25",
			1.33
		],
		[
			"2000-05-24",
			0.22
		],
		[
			"2000-11-20",
			1.06
		],
		[
			"2001-05-28",
			0.22
		],
		[
			"2001-10-26",
			0.71
		],
		[
			"2002-05-29",
			1.15
		],
		[
			"2003-05-09",
			1.06
		],
		[
			"2003-11-12",
			0.22
		],
		[
			"2004-05-26",
			0.22
		],
		[
			"2004-11-11",
			0.22
		],
		[
			"2005-10-24",
			0.27
		],
		[
			"2005-04-25",
			0.22
		],
		[
			"2006-09-04",
			0.22
		],
		[
			"2007-06-05",
			0.22
		],
		[
			"2002-09-26",
			0.22
		],
		[
			"2008-07-07",
			0.22
		],
		[
			"2009-06-17",
			4.43
		],
		[
			"2010-07-27",
			4.43
		],
		[
			"2011-06-20",
			4.43
		],
		[
			"2012-07-17",
			1.33
		]
	],
	"110340024": [
		[
			"2013-08-20",
			16.3
		],
		[
			"2014-11-28",
			8.06
		],
		[
			"2015-04-14",
			6.2
		],
		[
			"2006-09-05",
			1.9
		],
		[
			"2007-05-30",
			9.57
		],
		[
			"2008-07-04",
			17.49
		],
		[
			"2009-06-17",
			15.5
		],
		[
			"2010-07-29",
			14.61
		],
		[
			"2011-07-04",
			8.41
		],
		[
			"2012-07-18",
			8.41
		]
	],
	"110340036": [
		[
			"2013-08-19",
			1.33
		],
		[
			"2015-06-25",
			1.33
		],
		[
			"2006-11-08",
			0.22
		],
		[
			"2007-06-04",
			0.22
		],
		[
			"2008-07-07",
			0.22
		],
		[
			"2009-06-16",
			4.43
		],
		[
			"2010-07-27",
			4.43
		],
		[
			"2011-06-20",
			4.43
		],
		[
			"2012-08-15",
			1.33
		]
	],
	"113014016": [
		[
			"2013-07-22",
			1.33
		],
		[
			"2015-11-17",
			1.33
		],
		[
			"2006-11-20",
			1.2
		],
		[
			"2007-05-09",
			0.8
		],
		[
			"2007-11-19",
			0.97
		],
		[
			"2008-06-12",
			0.22
		],
		[
			"2009-07-10",
			4.43
		],
		[
			"2010-07-15",
			4.43
		],
		[
			"2011-05-30",
			4.43
		],
		[
			"2012-07-10",
			1.33
		]
	],
	"113409096": [
		[
			"2006-10-27",
			1.55
		],
		[
			"2007-04-18",
			1
		],
		[
			"2008-04-16",
			1
		],
		[
			"2010-04-21",
			1
		],
		[
			"2009-04-23",
			1
		],
		[
			"2011-04-27",
			1
		],
		[
			"2012-03-27",
			1
		],
		[
			"2013-04-19",
			1
		],
		[
			"2015-04-20",
			1
		],
		[
			"2014-04-07",
			1
		]
	],
	"113409102": [
		[
			"2006-11-06",
			2.44
		],
		[
			"2007-04-18",
			1
		],
		[
			"2008-04-16",
			1
		],
		[
			"2010-04-21",
			1
		],
		[
			"2009-04-23",
			1
		],
		[
			"2011-04-27",
			1
		],
		[
			"2012-03-27",
			1
		],
		[
			"2013-04-10",
			1
		],
		[
			"2015-04-16",
			1
		],
		[
			"2014-03-31",
			1
		]
	],
	"113409151": [
		[
			"2006-11-06",
			21.35
		],
		[
			"2007-04-25",
			26.41
		],
		[
			"2008-04-15",
			64.42
		],
		[
			"2011-04-18",
			38.01
		],
		[
			"2010-04-21",
			57.32
		],
		[
			"2009-04-23",
			59.62
		],
		[
			"2012-03-27",
			53.62
		],
		[
			"2013-04-19",
			30.71
		],
		[
			"2015-04-20",
			33.71
		]
	],
	"113409163": [
		[
			"2006-12-13",
			37.29
		],
		[
			"2007-04-25",
			27.91
		],
		[
			"2008-04-15",
			38.31
		],
		[
			"2011-04-18",
			40.32
		],
		[
			"2010-04-21",
			54.22
		],
		[
			"2009-04-23",
			45.72
		],
		[
			"2012-03-27",
			40.71
		],
		[
			"2013-04-19",
			39.61
		],
		[
			"2014-04-07",
			39.71
		],
		[
			"2015-04-20",
			39.41
		]
	],
	"113710185": [
		[
			"2013-08-27",
			22.85
		],
		[
			"2015-06-29",
			14.84
		],
		[
			"2006-11-09",
			29.76
		],
		[
			"2007-06-05",
			5.85
		],
		[
			"2008-07-09",
			7.35
		],
		[
			"2009-06-18",
			30.11
		],
		[
			"2010-07-30",
			22.59
		],
		[
			"2011-07-05",
			6.2
		],
		[
			"2012-07-11",
			24.36
		]
	],
	"118021035": [
		[
			"2000-05-16",
			1
		],
		[
			"2001-05-03",
			1
		],
		[
			"2001-08-28",
			1
		],
		[
			"2002-05-14",
			1
		],
		[
			"2002-10-09",
			1
		],
		[
			"2003-05-16",
			1
		],
		[
			"2003-10-15",
			1
		],
		[
			"2004-05-26",
			1
		],
		[
			"2004-11-09",
			1
		],
		[
			"2005-04-12",
			1
		],
		[
			"2005-10-25",
			1
		],
		[
			"2006-10-24",
			1
		],
		[
			"2007-03-26",
			1
		],
		[
			"2007-10-22",
			1
		],
		[
			"2008-03-25",
			1
		],
		[
			"2008-10-07",
			1.02
		],
		[
			"2010-04-20",
			1.99
		],
		[
			"2010-10-18",
			1.02
		],
		[
			"2011-04-04",
			1
		],
		[
			"2012-04-23",
			1
		],
		[
			"2011-10-06",
			1
		],
		[
			"2012-10-23",
			1
		],
		[
			"2009-10-02",
			1
		],
		[
			"2013-04-24",
			1
		],
		[
			"2013-10-08",
			2.5
		],
		[
			"2014-04-08",
			1
		],
		[
			"2014-10-07",
			1
		],
		[
			"2015-04-21",
			3
		],
		[
			"2015-09-29",
			1
		]
	],
	"118021047": [
		[
			"2000-05-16",
			1
		],
		[
			"2000-10-24",
			1
		],
		[
			"2001-05-03",
			1
		],
		[
			"2001-08-29",
			1
		],
		[
			"2002-05-15",
			1
		],
		[
			"2002-10-09",
			2
		],
		[
			"2003-05-15",
			1
		],
		[
			"2003-10-15",
			1
		],
		[
			"2004-05-26",
			1
		],
		[
			"2004-11-09",
			1
		],
		[
			"2005-04-13",
			1
		],
		[
			"2005-10-26",
			1
		],
		[
			"2006-10-24",
			4
		],
		[
			"2007-03-27",
			1.2
		],
		[
			"2007-10-23",
			1.5
		],
		[
			"2008-03-26",
			1.68
		],
		[
			"2008-10-07",
			1.59
		],
		[
			"2010-04-22",
			2.7
		],
		[
			"2010-10-19",
			1.99
		],
		[
			"2011-04-04",
			2
		],
		[
			"2011-10-06",
			2.4
		],
		[
			"2012-04-24",
			2.5
		],
		[
			"2012-10-23",
			2.4
		],
		[
			"2009-10-01",
			1.8
		],
		[
			"2013-04-25",
			2.5
		],
		[
			"2013-10-08",
			18.01
		],
		[
			"2014-04-08",
			1.8
		],
		[
			"2014-10-07",
			2.6
		],
		[
			"2015-04-21",
			3
		],
		[
			"2015-09-29",
			2.7
		]
	],
	"118052020": [
		[
			"2000-05-16",
			4
		],
		[
			"2000-10-24",
			6
		],
		[
			"2001-05-02",
			7
		],
		[
			"2001-08-28",
			6
		],
		[
			"2002-05-14",
			5
		],
		[
			"2002-10-09",
			5
		],
		[
			"2003-05-15",
			5
		],
		[
			"2003-10-14",
			5
		],
		[
			"2004-05-25",
			7
		],
		[
			"2004-11-09",
			10
		],
		[
			"2005-04-12",
			6
		],
		[
			"2005-10-26",
			7
		],
		[
			"2006-10-24",
			11
		],
		[
			"2007-03-26",
			8
		],
		[
			"2006-05-02",
			1.02
		],
		[
			"2007-10-23",
			10.98
		],
		[
			"2008-03-26",
			7.9
		],
		[
			"2008-10-07",
			8
		],
		[
			"2005-04-15",
			6
		],
		[
			"2004-05-21",
			7
		],
		[
			"2010-04-20",
			7.71
		],
		[
			"2010-10-20",
			8.02
		],
		[
			"2011-04-04",
			9
		],
		[
			"2011-10-06",
			11
		],
		[
			"2012-04-23",
			8.2
		],
		[
			"2012-10-23",
			8.1
		],
		[
			"2013-04-24",
			5.1
		],
		[
			"2013-10-08",
			8.1
		],
		[
			"2014-04-08",
			9.2
		],
		[
			"2014-10-07",
			8.7
		],
		[
			"2015-04-21",
			6.9
		],
		[
			"2015-09-30",
			7.2
		]
	],
	"118052056": [
		[
			"2000-05-16",
			41.01
		],
		[
			"2000-10-24",
			76.03
		],
		[
			"2001-08-28",
			79.03
		],
		[
			"2001-05-02",
			74.03
		],
		[
			"2002-05-14",
			80.03
		],
		[
			"2002-10-09",
			81.03
		],
		[
			"2003-05-15",
			70.02
		],
		[
			"2003-10-14",
			67.02
		],
		[
			"2004-05-25",
			78.03
		],
		[
			"2004-11-09",
			66.02
		],
		[
			"2005-04-12",
			64.02
		],
		[
			"2005-10-26",
			64.02
		],
		[
			"2006-10-24",
			60.02
		],
		[
			"2007-03-27",
			78.03
		],
		[
			"2004-05-21",
			78.03
		],
		[
			"2006-05-02",
			49.02
		],
		[
			"2007-10-23",
			78.03
		],
		[
			"2008-03-26",
			77.03
		],
		[
			"2008-10-08",
			82.03
		],
		[
			"2005-04-15",
			64.02
		],
		[
			"2010-04-20",
			80.33
		],
		[
			"2010-10-20",
			79.05
		],
		[
			"2011-04-05",
			71.03
		],
		[
			"2011-10-06",
			52.02
		],
		[
			"2012-04-23",
			77.03
		],
		[
			"2012-10-24",
			74.03
		],
		[
			"2013-04-24",
			73.03
		],
		[
			"2013-10-08",
			49.02
		],
		[
			"2014-04-08",
			50.02
		],
		[
			"2014-10-07",
			49.02
		],
		[
			"2015-04-21",
			49.55
		],
		[
			"2015-09-30",
			34.01
		]
	],
	"118054831": [
		[
			"2000-05-15",
			6
		],
		[
			"2000-10-24",
			9
		],
		[
			"2001-08-29",
			10
		],
		[
			"2001-05-02",
			9
		],
		[
			"2002-05-14",
			7
		],
		[
			"2002-10-09",
			8
		],
		[
			"2003-05-15",
			7
		],
		[
			"2003-10-14",
			7
		],
		[
			"2004-05-25",
			7
		],
		[
			"2004-11-09",
			10
		],
		[
			"2005-04-12",
			7
		],
		[
			"2005-10-27",
			7
		],
		[
			"2006-10-25",
			10
		],
		[
			"2007-03-26",
			7.5
		],
		[
			"2005-04-15",
			7
		],
		[
			"2004-05-21",
			7
		],
		[
			"2006-05-03",
			7
		],
		[
			"2008-03-25",
			8.1
		],
		[
			"2008-10-08",
			10
		],
		[
			"2010-04-22",
			9.79
		],
		[
			"2010-10-20",
			9.39
		],
		[
			"2011-04-05",
			9.2
		],
		[
			"2011-10-10",
			9.8
		],
		[
			"2012-10-24",
			9.8
		],
		[
			"2013-04-25",
			8.7
		],
		[
			"2013-10-08",
			9.7
		],
		[
			"2014-04-08",
			9.8
		],
		[
			"2014-10-07",
			9.7
		],
		[
			"2015-04-21",
			9.11
		],
		[
			"2015-09-30",
			7.7
		]
	],
	"118260042": [
		[
			"2000-04-19",
			76.03
		],
		[
			"2000-10-17",
			100.04
		],
		[
			"2001-04-19",
			72.03
		],
		[
			"2001-10-16",
			58.02
		],
		[
			"2002-04-25",
			43.02
		],
		[
			"2002-10-22",
			44.02
		],
		[
			"2003-04-15",
			58.02
		],
		[
			"2003-10-16",
			40.01
		],
		[
			"2004-04-22",
			79.03
		],
		[
			"2005-04-21",
			46.92
		],
		[
			"2006-05-15",
			37.01
		],
		[
			"2005-04-21",
			46.92
		],
		[
			"2006-05-15",
			37.01
		],
		[
			"2007-05-08",
			41.61
		],
		[
			"2008-04-10",
			46.52
		],
		[
			"2010-04-27",
			53.22
		],
		[
			"2009-04-22",
			42.21
		],
		[
			"2011-04-20",
			40.22
		],
		[
			"2012-03-28",
			42.12
		],
		[
			"2013-04-15",
			38.51
		],
		[
			"2014-04-08",
			39.51
		],
		[
			"2015-04-22",
			31.91
		]
	],
	"118262099": [
		[
			"2000-04-19",
			13
		],
		[
			"2000-10-17",
			14
		],
		[
			"2001-04-19",
			7.9
		],
		[
			"2001-10-16",
			10
		],
		[
			"2002-04-25",
			9.6
		],
		[
			"2002-10-22",
			12
		],
		[
			"2003-04-15",
			15.01
		],
		[
			"2003-10-16",
			12
		],
		[
			"2004-04-22",
			18.01
		],
		[
			"2004-10-24",
			16.21
		],
		[
			"2005-04-18",
			17.31
		],
		[
			"2005-11-09",
			18.71
		],
		[
			"2006-05-02",
			18.21
		],
		[
			"2006-05-02",
			18.21
		],
		[
			"2007-04-25",
			16.81
		],
		[
			"2008-04-08",
			11.5
		],
		[
			"2011-04-07",
			21.61
		],
		[
			"2010-04-19",
			19.81
		],
		[
			"2009-04-07",
			17.91
		],
		[
			"2004-10-27",
			16.21
		],
		[
			"2012-03-26",
			17.21
		],
		[
			"2013-04-22",
			13.8
		],
		[
			"2014-04-01",
			18.21
		],
		[
			"2015-04-22",
			16.81
		]
	],
	"118610247": [
		[
			"2000-04-17",
			28.01
		],
		[
			"2000-10-24",
			24.01
		],
		[
			"2001-05-14",
			42.01
		],
		[
			"2001-11-19",
			22.01
		],
		[
			"2002-10-18",
			32.01
		],
		[
			"2002-05-21",
			28.71
		],
		[
			"2003-04-14",
			34.91
		],
		[
			"2003-10-27",
			35.91
		],
		[
			"2004-05-10",
			26.21
		],
		[
			"2004-11-08",
			19.31
		],
		[
			"2005-04-20",
			28.81
		],
		[
			"2005-11-15",
			30.91
		],
		[
			"2006-04-24",
			36.01
		],
		[
			"2006-10-24",
			31.61
		],
		[
			"2007-05-07",
			70.12
		],
		[
			"2004-11-09",
			19.31
		],
		[
			"2008-04-08",
			32.91
		],
		[
			"2007-10-09",
			37.82
		],
		[
			"2009-04-15",
			41.01
		],
		[
			"2008-10-09",
			26.31
		],
		[
			"2009-10-15",
			7.31
		],
		[
			"2010-04-15",
			32.02
		],
		[
			"2010-10-19",
			12
		],
		[
			"2011-05-04",
			15.01
		],
		[
			"2011-11-03",
			11
		],
		[
			"2012-04-17",
			37.02
		],
		[
			"2012-10-17",
			25.01
		],
		[
			"2013-04-24",
			33.01
		],
		[
			"2013-10-07",
			23.01
		],
		[
			"2014-04-17",
			22.01
		],
		[
			"2015-04-16",
			30.01
		],
		[
			"2014-10-08",
			27.01
		],
		[
			"2015-10-21",
			24.01
		]
	],
	"118731026": [
		[
			"2008-04-23",
			24.51
		],
		[
			"2008-10-23",
			27.01
		],
		[
			"2006-02-14",
			24.01
		],
		[
			"2006-10-10",
			15.11
		],
		[
			"2006-04-05",
			23.61
		],
		[
			"2007-04-19",
			27.21
		],
		[
			"2007-10-24",
			23.61
		],
		[
			"2010-04-14",
			14
		],
		[
			"2010-10-28",
			26.01
		],
		[
			"2009-04-22",
			24.01
		],
		[
			"2009-10-15",
			25.01
		],
		[
			"2011-04-13",
			22.01
		],
		[
			"2011-10-05",
			24.01
		],
		[
			"2012-04-26",
			18.01
		],
		[
			"2012-10-24",
			26.01
		],
		[
			"2000-11-09",
			28.01
		],
		[
			"2000-04-06",
			19.01
		],
		[
			"2003-05-14",
			28.01
		],
		[
			"2001-11-27",
			4
		],
		[
			"2002-04-24",
			24.61
		],
		[
			"2001-04-10",
			22.01
		],
		[
			"2000-01-18",
			22.01
		],
		[
			"2015-10-07",
			21.01
		],
		[
			"2015-04-14",
			19.01
		],
		[
			"2014-10-09",
			23.01
		],
		[
			"2014-04-23",
			21.01
		],
		[
			"2005-04-21",
			22.41
		],
		[
			"2004-05-26",
			22.31
		],
		[
			"2003-11-20",
			25.01
		]
	],
	"118841038": [
		[
			"2003-04-08",
			1
		],
		[
			"2004-10-06",
			1
		],
		[
			"2007-04-18",
			1
		],
		[
			"2007-10-04",
			1
		],
		[
			"2010-04-07",
			1
		],
		[
			"2010-04-07",
			1
		],
		[
			"2008-05-21",
			1
		],
		[
			"2008-10-08",
			1
		],
		[
			"2009-06-17",
			1
		],
		[
			"2009-11-11",
			1
		],
		[
			"2010-10-05",
			1
		],
		[
			"2011-04-20",
			1
		],
		[
			"2011-10-25",
			1
		],
		[
			"2013-04-03",
			1
		],
		[
			"2012-05-22",
			1
		],
		[
			"2012-10-15",
			1
		],
		[
			"2013-10-10",
			1
		],
		[
			"2014-10-14",
			1
		],
		[
			"2014-04-29",
			1
		],
		[
			"2015-04-23",
			1
		],
		[
			"2015-10-27",
			1
		]
	],
	"119011049": [
		[
			"2014-11-10",
			1.33
		],
		[
			"2015-12-09",
			1.33
		],
		[
			"2000-07-11",
			0.22
		],
		[
			"2000-11-27",
			0.22
		],
		[
			"2001-06-28",
			1.06
		],
		[
			"2001-11-20",
			1.02
		],
		[
			"2002-06-11",
			1.37
		],
		[
			"2002-12-05",
			1.11
		],
		[
			"2003-04-10",
			1.46
		],
		[
			"2003-10-30",
			0.22
		],
		[
			"2004-06-03",
			0.22
		],
		[
			"2004-11-18",
			0.22
		],
		[
			"2005-06-21",
			0.4
		],
		[
			"2006-09-11",
			0.22
		],
		[
			"2007-09-03",
			0.22
		],
		[
			"2005-11-18",
			0.22
		],
		[
			"2008-07-30",
			0.22
		],
		[
			"2009-08-07",
			4.43
		],
		[
			"2010-09-03",
			4.43
		],
		[
			"2011-11-17",
			4.43
		],
		[
			"2012-06-29",
			1.33
		]
	],
	"129660024": [
		[
			"2008-05-21",
			19.01
		],
		[
			"2008-11-19",
			18.01
		],
		[
			"2009-08-11",
			18.01
		],
		[
			"2013-08-27",
			18.6
		],
		[
			"2014-07-23",
			16.61
		],
		[
			"2015-08-03",
			16.61
		],
		[
			"2000-10-25",
			18.16
		],
		[
			"2001-08-22",
			18.6
		],
		[
			"2002-09-25",
			17.71
		],
		[
			"2003-09-15",
			19.93
		],
		[
			"2004-05-28",
			18.6
		],
		[
			"2005-06-02",
			19.04
		],
		[
			"2005-07-20",
			18.6
		],
		[
			"2002-04-17",
			20.01
		],
		[
			"2002-07-17",
			20.01
		],
		[
			"2003-05-28",
			19.01
		],
		[
			"2003-11-26",
			19.01
		],
		[
			"2004-05-26",
			19.01
		],
		[
			"2005-05-25",
			21.01
		],
		[
			"2001-07-17",
			20.01
		],
		[
			"2001-10-17",
			19.01
		],
		[
			"2000-07-18",
			21.01
		],
		[
			"2001-01-17",
			20.01
		],
		[
			"2000-10-11",
			20.01
		],
		[
			"2000-04-03",
			21.01
		],
		[
			"2000-01-19",
			20.01
		],
		[
			"2006-08-23",
			18.16
		],
		[
			"2006-05-24",
			19.01
		],
		[
			"2006-10-02",
			19.01
		],
		[
			"2005-07-05",
			22.01
		],
		[
			"2005-11-22",
			18.01
		],
		[
			"2007-07-26",
			18.6
		],
		[
			"2008-06-18",
			18.6
		],
		[
			"2010-05-26",
			19.01
		],
		[
			"2011-05-04",
			19.01
		],
		[
			"2011-11-03",
			18.01
		],
		[
			"2012-05-30",
			19.01
		],
		[
			"2013-05-22",
			18.01
		],
		[
			"2013-11-13",
			18.01
		],
		[
			"2014-06-03",
			17.01
		],
		[
			"2014-11-13",
			16.01
		],
		[
			"2015-11-25",
			17.01
		],
		[
			"2009-07-30",
			19.04
		],
		[
			"2010-06-22",
			17.27
		],
		[
			"2011-05-09",
			18.6
		],
		[
			"2012-08-02",
			18.6
		]
	],
	"129660048": [
		[
			"2013-07-03",
			11.96
		],
		[
			"2014-07-23",
			17.89
		],
		[
			"2015-04-27",
			7.62
		],
		[
			"2002-08-27",
			2.21
		],
		[
			"2003-05-16",
			2.21
		],
		[
			"2004-03-16",
			6.2
		],
		[
			"2005-03-11",
			7.09
		],
		[
			"2006-08-02",
			3.99
		],
		[
			"2007-06-25",
			7.53
		],
		[
			"2008-06-12",
			6.2
		],
		[
			"2009-09-21",
			6.64
		],
		[
			"2010-06-23",
			7.97
		],
		[
			"2011-05-09",
			7.97
		],
		[
			"2012-08-02",
			8.86
		]
	],
	"129660050": [
		[
			"2008-05-07",
			16.01
		],
		[
			"2008-11-05",
			22.01
		],
		[
			"2009-05-12",
			22.01
		],
		[
			"2009-11-04",
			22.01
		],
		[
			"2013-07-03",
			21.7
		],
		[
			"2014-08-14",
			18.87
		],
		[
			"2015-07-08",
			20.95
		],
		[
			"2000-11-02",
			24.36
		],
		[
			"2001-08-22",
			24.36
		],
		[
			"2002-09-30",
			24.36
		],
		[
			"2003-09-15",
			24.8
		],
		[
			"2004-03-17",
			24.36
		],
		[
			"2005-05-02",
			24.8
		],
		[
			"2002-04-17",
			28.01
		],
		[
			"2002-11-20",
			24.01
		],
		[
			"2003-05-09",
			26.01
		],
		[
			"2003-11-24",
			23.01
		],
		[
			"2004-05-12",
			26.01
		],
		[
			"2004-11-24",
			25.01
		],
		[
			"2001-04-12",
			26.01
		],
		[
			"2000-11-16",
			26.01
		],
		[
			"2000-05-11",
			26.01
		],
		[
			"2006-08-03",
			22.59
		],
		[
			"2006-11-08",
			23.01
		],
		[
			"2006-05-04",
			25.01
		],
		[
			"2005-05-11",
			28.01
		],
		[
			"2005-11-17",
			24.01
		],
		[
			"2007-09-20",
			24.36
		],
		[
			"2008-07-02",
			25.69
		],
		[
			"2010-05-12",
			21.01
		],
		[
			"2010-11-10",
			22.01
		],
		[
			"2011-05-30",
			22.01
		],
		[
			"2012-01-25",
			22.01
		],
		[
			"2012-05-16",
			22.01
		],
		[
			"2012-11-07",
			21.01
		],
		[
			"2013-05-02",
			22.01
		],
		[
			"2013-11-06",
			22.01
		],
		[
			"2014-05-07",
			21.01
		],
		[
			"2014-11-05",
			22.01
		],
		[
			"2015-05-08",
			21.01
		],
		[
			"2015-11-11",
			21.01
		],
		[
			"2009-08-06",
			20.37
		],
		[
			"2010-06-23",
			23.91
		],
		[
			"2011-05-09",
			23.03
		],
		[
			"2012-08-02",
			22.14
		]
	],
	"129660073": [
		[
			"2013-07-01",
			6.51
		],
		[
			"2014-07-14",
			6.47
		],
		[
			"2015-04-21",
			6.95
		],
		[
			"2000-08-08",
			7.09
		],
		[
			"2001-09-06",
			6.2
		],
		[
			"2002-09-16",
			6.2
		],
		[
			"2003-11-26",
			7.09
		],
		[
			"2004-03-17",
			8.86
		],
		[
			"2005-06-02",
			8.86
		],
		[
			"2006-12-08",
			11.96
		],
		[
			"2007-06-25",
			12.4
		],
		[
			"2008-09-19",
			10.19
		],
		[
			"2009-08-17",
			8.86
		],
		[
			"2010-05-31",
			7.97
		],
		[
			"2011-09-06",
			7.53
		],
		[
			"2012-08-03",
			8.86
		]
	],
	"129660097": [
		[
			"2013-08-26",
			6.69
		],
		[
			"2014-09-29",
			5.93
		],
		[
			"2015-05-04",
			7.04
		],
		[
			"2000-12-05",
			7.09
		],
		[
			"2001-11-07",
			6.64
		],
		[
			"2002-08-29",
			6.64
		],
		[
			"2003-12-17",
			9.74
		],
		[
			"2004-05-27",
			8.86
		],
		[
			"2005-06-14",
			7.97
		],
		[
			"2006-07-14",
			7.09
		],
		[
			"2007-08-31",
			9.3
		],
		[
			"2008-07-23",
			5.76
		],
		[
			"2009-08-17",
			7.09
		],
		[
			"2010-07-06",
			6.64
		],
		[
			"2011-09-01",
			7.53
		],
		[
			"2012-08-01",
			7.53
		]
	],
	"129660103": [
		[
			"2013-07-02",
			11.03
		],
		[
			"2014-07-16",
			12.13
		],
		[
			"2015-05-11",
			9.26
		],
		[
			"2000-11-10",
			9.74
		],
		[
			"2001-09-20",
			10.63
		],
		[
			"2002-08-29",
			9.74
		],
		[
			"2003-09-18",
			7.53
		],
		[
			"2004-05-27",
			11.51
		],
		[
			"2005-04-04",
			12.4
		],
		[
			"2006-08-18",
			12.4
		],
		[
			"2007-07-18",
			11.96
		],
		[
			"2008-01-28",
			14.17
		],
		[
			"2009-08-11",
			11.96
		],
		[
			"2010-06-30",
			11.51
		],
		[
			"2011-09-01",
			13.29
		],
		[
			"2012-08-01",
			11.96
		]
	],
	"129660139": [
		[
			"2013-07-31",
			1.42
		],
		[
			"2014-07-14",
			1.33
		],
		[
			"2015-04-27",
			1.33
		],
		[
			"2000-10-16",
			2.21
		],
		[
			"2001-06-11",
			2.21
		],
		[
			"2002-09-16",
			2.21
		],
		[
			"2003-10-08",
			2.66
		],
		[
			"2004-03-17",
			2.21
		],
		[
			"2005-03-11",
			2.21
		],
		[
			"2006-07-14",
			2.21
		],
		[
			"2007-07-25",
			2.21
		],
		[
			"2008-06-23",
			2.21
		],
		[
			"2009-06-18",
			4.43
		],
		[
			"2010-05-31",
			4.43
		],
		[
			"2011-05-02",
			4.43
		],
		[
			"2012-07-30",
			1.33
		]
	],
	"129660176": [
		[
			"2014-10-27",
			21.26
		],
		[
			"2015-08-05",
			19.97
		],
		[
			"2000-09-27",
			17.71
		],
		[
			"2001-05-07",
			18.6
		],
		[
			"2001-11-02",
			20.81
		],
		[
			"2002-09-11",
			20.81
		],
		[
			"2003-09-24",
			19.93
		],
		[
			"2004-05-24",
			21.26
		],
		[
			"2004-10-14",
			20.37
		],
		[
			"2005-04-28",
			19.49
		],
		[
			"2005-09-23",
			19.93
		],
		[
			"2006-10-19",
			19.04
		],
		[
			"2007-09-20",
			16.83
		],
		[
			"2007-11-20",
			20.37
		],
		[
			"2008-05-05",
			17.27
		],
		[
			"2008-09-11",
			18.6
		],
		[
			"2006-05-16",
			19.04
		],
		[
			"2009-08-12",
			18.6
		],
		[
			"2010-06-24",
			18.6
		],
		[
			"2011-10-26",
			17.27
		]
	],
	"129660188": [
		[
			"2013-07-03",
			29.54
		],
		[
			"2014-07-23",
			28.12
		],
		[
			"2015-08-17",
			27.86
		],
		[
			"2000-10-25",
			26.57
		],
		[
			"2001-10-29",
			29.23
		],
		[
			"2002-09-25",
			26.13
		],
		[
			"2003-09-29",
			27.9
		],
		[
			"2004-10-07",
			30.11
		],
		[
			"2005-04-25",
			30.56
		],
		[
			"2006-09-15",
			27.9
		],
		[
			"2007-09-21",
			30.11
		],
		[
			"2008-07-02",
			29.23
		],
		[
			"2009-08-17",
			28.79
		],
		[
			"2010-06-23",
			28.79
		],
		[
			"2011-09-29",
			28.79
		]
	],
	"129660190": [
		[
			"2014-11-11",
			16.39
		],
		[
			"2015-07-20",
			18.73
		],
		[
			"2001-09-27",
			15.06
		],
		[
			"2004-10-18",
			16.83
		],
		[
			"2005-04-25",
			14.61
		],
		[
			"2006-09-20",
			16.39
		],
		[
			"2007-09-18",
			18.16
		],
		[
			"2008-07-14",
			15.06
		],
		[
			"2002-09-30",
			2.21
		],
		[
			"2009-08-06",
			18.6
		],
		[
			"2010-07-06",
			18.6
		],
		[
			"2011-09-07",
			12.84
		]
	],
	"129660206": [
		[
			"2014-08-27",
			15.72
		],
		[
			"2015-07-15",
			13.2
		],
		[
			"2000-09-26",
			36.31
		],
		[
			"2001-05-09",
			33.21
		],
		[
			"2001-11-07",
			32.33
		],
		[
			"2002-09-10",
			35.87
		],
		[
			"2003-09-25",
			33.66
		],
		[
			"2004-05-25",
			28.34
		],
		[
			"2004-10-11",
			26.13
		],
		[
			"2005-06-14",
			23.03
		],
		[
			"2005-09-22",
			24.36
		],
		[
			"2006-09-11",
			20.81
		],
		[
			"2006-10-19",
			22.59
		],
		[
			"2007-09-19",
			16.83
		],
		[
			"2007-10-17",
			17.27
		],
		[
			"2008-06-18",
			16.83
		],
		[
			"2008-09-12",
			18.16
		],
		[
			"2009-07-30",
			19.04
		],
		[
			"2010-06-22",
			16.83
		],
		[
			"2011-09-29",
			21.26
		]
	],
	"129660220": [
		[
			"2013-08-27",
			16.3
		],
		[
			"2014-08-28",
			12
		],
		[
			"2015-08-17",
			12.84
		],
		[
			"2000-09-26",
			11.07
		],
		[
			"2001-05-09",
			12.84
		],
		[
			"2001-11-02",
			11.96
		],
		[
			"2002-09-10",
			15.5
		],
		[
			"2003-09-22",
			15.94
		],
		[
			"2004-05-24",
			13.29
		],
		[
			"2004-10-26",
			12.4
		],
		[
			"2005-04-26",
			13.73
		],
		[
			"2005-09-19",
			13.29
		],
		[
			"2006-09-20",
			14.17
		],
		[
			"2007-08-21",
			13.73
		],
		[
			"2007-11-20",
			14.17
		],
		[
			"2008-05-05",
			14.61
		],
		[
			"2008-09-11",
			15.06
		],
		[
			"2006-05-16",
			14.17
		],
		[
			"2009-07-29",
			15.5
		],
		[
			"2010-05-20",
			13.29
		],
		[
			"2011-09-07",
			12.84
		]
	],
	"129660231": [
		[
			"2013-07-02",
			14.75
		],
		[
			"2014-07-16",
			19.13
		],
		[
			"2015-05-11",
			12.13
		],
		[
			"2006-09-05",
			11.51
		],
		[
			"2007-07-27",
			14.17
		],
		[
			"2008-07-23",
			8.86
		],
		[
			"2009-08-11",
			11.07
		],
		[
			"2010-06-30",
			9.3
		],
		[
			"2011-05-13",
			8.86
		],
		[
			"2012-08-03",
			14.17
		]
	],
	"129660255": [
		[
			"2013-07-02",
			9.65
		],
		[
			"2014-07-16",
			10.14
		],
		[
			"2015-05-11",
			8.24
		],
		[
			"2006-09-05",
			9.3
		],
		[
			"2007-07-27",
			9.3
		],
		[
			"2008-07-23",
			7.53
		],
		[
			"2009-08-11",
			8.41
		],
		[
			"2010-06-30",
			8.41
		],
		[
			"2011-05-13",
			7.09
		],
		[
			"2012-08-03",
			10.63
		]
	],
	"129660279": [
		[
			"2013-07-01",
			31.35
		],
		[
			"2014-11-13",
			28.17
		],
		[
			"2015-07-21",
			29.01
		],
		[
			"2000-12-05",
			34.1
		],
		[
			"2001-10-29",
			32.33
		],
		[
			"2002-09-11",
			32.77
		],
		[
			"2003-09-22",
			32.33
		],
		[
			"2004-10-07",
			32.33
		],
		[
			"2005-04-26",
			32.77
		],
		[
			"2006-09-15",
			31
		],
		[
			"2007-08-21",
			25.69
		],
		[
			"2008-07-22",
			29.67
		],
		[
			"2009-07-29",
			29.23
		],
		[
			"2010-05-20",
			28.34
		],
		[
			"2011-09-28",
			27.46
		]
	],
	"129660553": [
		[
			"2013-08-26",
			8.5
		],
		[
			"2014-09-29",
			8.24
		],
		[
			"2015-10-13",
			9.52
		],
		[
			"2006-09-05",
			8.86
		],
		[
			"2007-07-27",
			8.41
		],
		[
			"2008-06-12",
			7.97
		],
		[
			"2009-08-12",
			7.97
		],
		[
			"2010-06-24",
			8.86
		],
		[
			"2011-05-13",
			7.53
		],
		[
			"2012-08-01",
			8.41
		]
	],
	"129660577": [
		[
			"2013-08-27",
			18.11
		],
		[
			"2014-07-21",
			15.46
		],
		[
			"2015-10-14",
			16.96
		],
		[
			"2006-09-07",
			18.16
		],
		[
			"2007-05-03",
			15.5
		],
		[
			"2008-06-30",
			17.27
		],
		[
			"2009-08-19",
			16.83
		],
		[
			"2010-07-30",
			16.83
		],
		[
			"2011-09-01",
			11.96
		]
	],
	"129660589": [
		[
			"2013-07-31",
			1.33
		],
		[
			"2014-07-21",
			1.33
		],
		[
			"2015-04-21",
			1.33
		],
		[
			"2006-09-06",
			2.21
		],
		[
			"2007-07-25",
			2.21
		],
		[
			"2008-06-30",
			2.21
		],
		[
			"2009-06-18",
			4.43
		],
		[
			"2010-05-31",
			4.43
		],
		[
			"2011-05-02",
			4.43
		],
		[
			"2012-07-30",
			1.33
		]
	],
	"129660590": [
		[
			"2013-07-31",
			11.38
		],
		[
			"2014-07-21",
			10.14
		],
		[
			"2015-04-21",
			10.54
		],
		[
			"2006-09-06",
			9.74
		],
		[
			"2007-07-25",
			11.07
		],
		[
			"2008-06-26",
			10.63
		],
		[
			"2009-08-19",
			14.61
		],
		[
			"2010-07-30",
			11.07
		],
		[
			"2011-05-02",
			12.84
		],
		[
			"2012-07-30",
			13.73
		]
	],
	"129661004": [
		[
			"2013-08-26",
			13.37
		],
		[
			"2014-09-29",
			11.2
		],
		[
			"2015-07-08",
			11.2
		],
		[
			"2006-09-07",
			14.17
		],
		[
			"2007-06-27",
			15.5
		],
		[
			"2008-06-23",
			15.5
		],
		[
			"2009-06-18",
			15.94
		],
		[
			"2010-07-20",
			12.84
		],
		[
			"2011-05-09",
			15.5
		],
		[
			"2012-08-09",
			12.84
		]
	],
	"129700022": [
		[
			"2013-07-23",
			6.24
		],
		[
			"2014-03-13",
			1.33
		],
		[
			"2015-05-04",
			3.76
		],
		[
			"2000-10-18",
			3.99
		],
		[
			"2001-09-20",
			3.1
		],
		[
			"2003-09-18",
			3.99
		],
		[
			"2004-04-02",
			4.43
		],
		[
			"2005-06-28",
			4.87
		],
		[
			"2007-06-26",
			4.43
		],
		[
			"2008-06-10",
			5.76
		],
		[
			"2002-10-08",
			3.99
		],
		[
			"2006-08-01",
			3.1
		],
		[
			"2009-07-22",
			7.09
		],
		[
			"2010-07-01",
			7.53
		],
		[
			"2011-04-26",
			7.97
		],
		[
			"2012-07-18",
			4.43
		]
	],
	"129700034": [
		[
			"2007-04-16",
			17.01
		],
		[
			"2008-06-09",
			17.01
		],
		[
			"2009-01-26",
			16.01
		],
		[
			"2013-07-22",
			16.43
		],
		[
			"2014-03-10",
			17.63
		],
		[
			"2015-04-14",
			17.49
		],
		[
			"2000-11-08",
			14.17
		],
		[
			"2001-09-04",
			15.94
		],
		[
			"2002-09-26",
			15.06
		],
		[
			"2003-09-17",
			9.74
		],
		[
			"2004-09-24",
			9.3
		],
		[
			"2005-03-10",
			16.39
		],
		[
			"2005-08-22",
			13
		],
		[
			"2006-07-14",
			6.2
		],
		[
			"2006-08-24",
			13.29
		],
		[
			"2002-11-11",
			13
		],
		[
			"2000-08-15",
			18.01
		],
		[
			"2001-07-30",
			19.01
		],
		[
			"2007-08-23",
			11.51
		],
		[
			"2008-07-17",
			15.06
		],
		[
			"2009-09-18",
			13.73
		],
		[
			"2010-07-30",
			15.5
		],
		[
			"2011-08-18",
			14.17
		],
		[
			"2012-08-07",
			15.5
		]
	],
	"129700058": [
		[
			"2013-07-24",
			6.29
		],
		[
			"2014-03-11",
			5.85
		],
		[
			"2015-04-28",
			4.33
		],
		[
			"2000-11-08",
			6.64
		],
		[
			"2001-08-29",
			6.64
		],
		[
			"2002-10-01",
			7.09
		],
		[
			"2003-09-16",
			8.41
		],
		[
			"2004-03-29",
			9.3
		],
		[
			"2005-06-29",
			7.09
		],
		[
			"2006-08-21",
			11.51
		],
		[
			"2007-08-22",
			5.31
		],
		[
			"2008-04-28",
			7.53
		],
		[
			"2009-06-26",
			9.3
		],
		[
			"2010-07-12",
			5.76
		],
		[
			"2011-05-10",
			4.43
		],
		[
			"2012-07-16",
			2.21
		]
	],
	"129700071": [
		[
			"2013-07-25",
			3.83
		],
		[
			"2014-03-24",
			27.9
		],
		[
			"2015-04-13",
			22.59
		],
		[
			"2000-10-31",
			18.16
		],
		[
			"2001-10-31",
			19.49
		],
		[
			"2002-09-24",
			15.5
		],
		[
			"2003-09-16",
			18.16
		],
		[
			"2004-03-22",
			27.46
		],
		[
			"2005-06-30",
			13.73
		],
		[
			"2006-04-25",
			18.6
		],
		[
			"2007-08-22",
			24.8
		],
		[
			"2008-07-04",
			17.71
		],
		[
			"2009-09-17",
			4.87
		],
		[
			"2010-06-01",
			5.31
		],
		[
			"2011-04-28",
			4.87
		],
		[
			"2012-07-17",
			4.43
		]
	],
	"129700083": [
		[
			"2013-07-30",
			3.1
		],
		[
			"2014-03-05",
			3.61
		],
		[
			"2015-03-31",
			5.05
		],
		[
			"2000-11-08",
			5.76
		],
		[
			"2001-08-29",
			5.76
		],
		[
			"2002-10-01",
			5.76
		],
		[
			"2003-10-06",
			6.64
		],
		[
			"2004-04-01",
			7.09
		],
		[
			"2005-05-04",
			5.76
		],
		[
			"2006-08-04",
			5.76
		],
		[
			"2007-06-28",
			5.31
		],
		[
			"2008-06-11",
			3.99
		],
		[
			"2009-08-07",
			4.43
		],
		[
			"2010-07-02",
			4.43
		],
		[
			"2011-05-12",
			4.43
		],
		[
			"2012-07-18",
			5.31
		]
	],
	"129700125": [
		[
			"2013-07-16",
			13.73
		],
		[
			"2014-03-06",
			15.41
		],
		[
			"2015-04-15",
			14.48
		],
		[
			"2000-09-20",
			10.63
		],
		[
			"2001-09-04",
			12.4
		],
		[
			"2002-09-26",
			3.1
		],
		[
			"2003-05-19",
			7.53
		],
		[
			"2004-04-02",
			10.19
		],
		[
			"2005-03-10",
			12.4
		],
		[
			"2006-08-24",
			15.5
		],
		[
			"2007-07-24",
			13.73
		],
		[
			"2008-07-14",
			12.84
		],
		[
			"2009-09-21",
			13.73
		],
		[
			"2010-07-19",
			14.61
		],
		[
			"2011-05-11",
			14.17
		],
		[
			"2012-08-07",
			14.17
		]
	],
	"129700186": [
		[
			"2013-07-30",
			1.53
		],
		[
			"2014-03-11",
			2.9
		],
		[
			"2015-10-27",
			2.91
		],
		[
			"2001-10-31",
			2.66
		],
		[
			"2002-09-24",
			2.66
		],
		[
			"2003-11-26",
			2.66
		],
		[
			"2004-04-01",
			3.54
		],
		[
			"2005-07-06",
			2.66
		],
		[
			"2006-08-25",
			2.66
		],
		[
			"2007-06-28",
			8.41
		],
		[
			"2008-06-11",
			8.41
		],
		[
			"2010-07-02",
			4.43
		],
		[
			"2011-05-12",
			4.43
		],
		[
			"2012-08-07",
			3.1
		]
	],
	"129700198": [
		[
			"2013-07-16",
			9.3
		],
		[
			"2014-07-24",
			7.31
		],
		[
			"2015-07-08",
			6.91
		],
		[
			"2000-09-26",
			6.2
		],
		[
			"2001-05-07",
			6.64
		],
		[
			"2001-10-30",
			7.09
		],
		[
			"2002-09-10",
			6.2
		],
		[
			"2003-09-24",
			5.31
		],
		[
			"2004-03-29",
			6.64
		],
		[
			"2004-05-25",
			7.09
		],
		[
			"2005-06-21",
			10.19
		],
		[
			"2005-09-19",
			7.53
		],
		[
			"2006-04-27",
			9.3
		],
		[
			"2006-10-20",
			8.41
		],
		[
			"2007-06-05",
			8.86
		],
		[
			"2007-09-28",
			9.74
		],
		[
			"2008-04-03",
			9.74
		],
		[
			"2008-09-19",
			9.74
		],
		[
			"2009-09-18",
			11.96
		],
		[
			"2010-07-20",
			10.19
		],
		[
			"2011-09-06",
			13.29
		],
		[
			"2012-08-09",
			11.07
		]
	],
	"129700216": [
		[
			"2013-07-16",
			1.33
		],
		[
			"2014-07-24",
			1.33
		],
		[
			"2015-10-12",
			1.33
		],
		[
			"2000-12-06",
			2.21
		],
		[
			"2001-09-06",
			2.21
		],
		[
			"2002-10-01",
			2.21
		],
		[
			"2003-09-17",
			2.21
		],
		[
			"2004-03-24",
			2.21
		],
		[
			"2005-06-21",
			2.21
		],
		[
			"2006-10-20",
			2.21
		],
		[
			"2007-06-05",
			2.21
		],
		[
			"2008-09-19",
			2.21
		],
		[
			"2006-04-27",
			2.21
		],
		[
			"2009-09-18",
			4.43
		],
		[
			"2010-07-20",
			4.43
		],
		[
			"2011-09-06",
			4.43
		],
		[
			"2012-08-09",
			1.33
		]
	],
	"129700230": [
		[
			"2013-07-15",
			9.88
		],
		[
			"2014-03-05",
			10.45
		],
		[
			"2015-03-31",
			9.57
		],
		[
			"2001-08-29",
			8.41
		],
		[
			"2002-09-16",
			9.74
		],
		[
			"2003-05-19",
			10.19
		],
		[
			"2004-04-02",
			12.84
		],
		[
			"2005-06-28",
			12.84
		],
		[
			"2006-08-01",
			12.4
		],
		[
			"2007-06-26",
			15.94
		],
		[
			"2008-06-10",
			15.94
		],
		[
			"2009-07-22",
			14.61
		],
		[
			"2010-07-19",
			11.96
		],
		[
			"2011-04-26",
			12.4
		],
		[
			"2012-07-27",
			10.19
		]
	],
	"129700241": [
		[
			"2013-07-17",
			1.33
		],
		[
			"2014-03-04",
			1.33
		],
		[
			"2015-04-07",
			1.33
		],
		[
			"2000-10-31",
			2.21
		],
		[
			"2001-10-31",
			2.21
		],
		[
			"2002-09-24",
			2.21
		],
		[
			"2003-09-16",
			2.21
		],
		[
			"2004-06-01",
			2.21
		],
		[
			"2005-05-04",
			2.21
		],
		[
			"2006-08-04",
			2.21
		],
		[
			"2007-08-20",
			2.21
		],
		[
			"2008-07-18",
			2.21
		],
		[
			"2009-09-17",
			4.43
		],
		[
			"2010-06-01",
			4.43
		],
		[
			"2011-08-18",
			4.43
		],
		[
			"2012-07-27",
			1.33
		]
	],
	"129700289": [
		[
			"2013-07-29",
			10.1
		],
		[
			"2014-03-13",
			10.63
		],
		[
			"2015-04-15",
			9.39
		],
		[
			"2006-09-12",
			7.09
		],
		[
			"2007-05-15",
			8.41
		],
		[
			"2008-07-18",
			8.86
		],
		[
			"2009-06-19",
			11.07
		],
		[
			"2010-06-02",
			9.74
		],
		[
			"2011-04-27",
			10.63
		],
		[
			"2012-07-26",
			11.51
		]
	],
	"129700290": [
		[
			"2013-07-23",
			10.58
		],
		[
			"2014-03-05",
			11.2
		],
		[
			"2015-03-31",
			9.79
		],
		[
			"2006-09-14",
			8.86
		],
		[
			"2007-06-29",
			11.96
		],
		[
			"2008-06-10",
			12.4
		],
		[
			"2009-08-07",
			12.84
		],
		[
			"2010-07-01",
			12.4
		],
		[
			"2011-04-26",
			12.4
		],
		[
			"2012-07-18",
			11.96
		]
	],
	"129700307": [
		[
			"2013-07-22",
			1.33
		],
		[
			"2014-03-10",
			1.84
		],
		[
			"2015-04-14",
			2.79
		],
		[
			"2006-09-18",
			2.21
		],
		[
			"2007-06-05",
			3.99
		],
		[
			"2008-07-03",
			2.21
		],
		[
			"2009-06-19",
			4.43
		],
		[
			"2010-06-02",
			4.43
		],
		[
			"2011-04-27",
			4.43
		],
		[
			"2012-07-27",
			1.33
		]
	],
	"129700319": [
		[
			"2013-07-17",
			7.75
		],
		[
			"2014-03-04",
			6.16
		],
		[
			"2015-04-28",
			5.71
		],
		[
			"2006-09-14",
			7.09
		],
		[
			"2007-06-29",
			6.64
		],
		[
			"2008-07-04",
			8.86
		],
		[
			"2009-09-22",
			12.84
		],
		[
			"2010-07-23",
			7.97
		],
		[
			"2011-05-12",
			7.09
		],
		[
			"2012-09-18",
			7.09
		]
	],
	"129700320": [
		[
			"2013-11-05",
			6.16
		],
		[
			"2014-03-20",
			6.16
		],
		[
			"2015-04-07",
			3.72
		],
		[
			"2007-03-01",
			4.87
		],
		[
			"2009-11-24",
			6.64
		],
		[
			"2011-12-19",
			4.87
		],
		[
			"2012-07-17",
			2.21
		]
	],
	"129700514": [
		[
			"2013-07-23",
			11.56
		],
		[
			"2014-08-11",
			12.89
		],
		[
			"2015-08-26",
			10.41
		],
		[
			"2002-10-08",
			11.07
		],
		[
			"2003-05-19",
			12.4
		],
		[
			"2004-10-08",
			15.06
		],
		[
			"2005-10-19",
			14.17
		],
		[
			"2006-08-23",
			12.4
		],
		[
			"2007-08-20",
			11.96
		],
		[
			"2008-04-03",
			11.96
		],
		[
			"2009-07-22",
			13.73
		],
		[
			"2010-07-01",
			14.17
		],
		[
			"2011-08-18",
			8.86
		]
	],
	"129700710": [
		[
			"2013-07-15",
			9.08
		],
		[
			"2014-08-25",
			8.46
		],
		[
			"2014-03-06",
			14.22
		],
		[
			"2015-08-26",
			8.33
		],
		[
			"2001-09-04",
			10.19
		],
		[
			"2002-09-16",
			9.3
		],
		[
			"2003-05-19",
			9.3
		],
		[
			"2004-10-08",
			11.07
		],
		[
			"2005-03-10",
			15.06
		],
		[
			"2006-08-24",
			11.07
		],
		[
			"2007-07-24",
			11.07
		],
		[
			"2008-04-03",
			16.39
		],
		[
			"2009-09-21",
			11.51
		],
		[
			"2010-07-19",
			11.96
		],
		[
			"2011-04-27",
			16.39
		],
		[
			"2012-07-26",
			10.63
		]
	],
	"129700733": [
		[
			"2013-07-22",
			8.15
		],
		[
			"2014-03-10",
			8.77
		],
		[
			"2015-04-14",
			9.43
		],
		[
			"2004-03-24",
			10.19
		],
		[
			"2005-03-22",
			10.19
		],
		[
			"2006-09-11",
			8.41
		],
		[
			"2007-05-15",
			7.97
		],
		[
			"2008-07-03",
			7.97
		],
		[
			"2010-07-02",
			7.09
		],
		[
			"2011-05-11",
			7.53
		],
		[
			"2012-08-13",
			7.97
		]
	],
	"129700757": [
		[
			"2013-07-24",
			4.52
		],
		[
			"2014-03-24",
			5.8
		],
		[
			"2015-04-13",
			7.48
		],
		[
			"2004-03-22",
			6.2
		],
		[
			"2005-06-29",
			4.87
		],
		[
			"2006-04-25",
			7.09
		],
		[
			"2007-03-01",
			9.3
		],
		[
			"2008-05-20",
			7.53
		],
		[
			"2009-09-22",
			6.2
		],
		[
			"2010-07-12",
			4.43
		],
		[
			"2011-05-10",
			5.31
		],
		[
			"2012-08-13",
			5.76
		]
	],
	"129700770": [
		[
			"2013-07-25",
			3.74
		],
		[
			"2014-03-24",
			4.33
		],
		[
			"2015-04-13",
			5.54
		],
		[
			"2004-03-22",
			4.87
		],
		[
			"2005-06-30",
			3.99
		],
		[
			"2006-04-25",
			6.64
		],
		[
			"2007-09-28",
			4.87
		],
		[
			"2008-07-04",
			4.87
		],
		[
			"2009-09-17",
			4.43
		],
		[
			"2010-06-01",
			4.87
		],
		[
			"2011-04-28",
			4.87
		],
		[
			"2012-07-17",
			3.1
		]
	],
	"129700782": [
		[
			"2013-07-30",
			5.58
		],
		[
			"2014-10-07",
			5.4
		],
		[
			"2015-10-13",
			6.38
		],
		[
			"2007-07-23",
			7.09
		],
		[
			"2005-10-17",
			4.87
		],
		[
			"2008-03-18",
			6.2
		],
		[
			"2006-05-22",
			6.2
		],
		[
			"2009-07-20",
			6.2
		],
		[
			"2010-05-04",
			5.76
		],
		[
			"2011-08-11",
			7.53
		]
	],
	"129700812": [
		[
			"2013-07-18",
			9.83
		],
		[
			"2014-03-11",
			12.8
		],
		[
			"2015-04-15",
			14.17
		],
		[
			"2008-07-17",
			10.63
		],
		[
			"2009-06-19",
			13.73
		],
		[
			"2010-06-02",
			11.96
		],
		[
			"2011-05-11",
			10.63
		],
		[
			"2012-07-26",
			12.4
		]
	],
	"210404530": [
		[
			"2010-11-16",
			56.68
		],
		[
			"2011-03-15",
			58.9
		],
		[
			"2011-06-28",
			58.9
		],
		[
			"2011-07-27",
			59.78
		],
		[
			"2011-09-19",
			60.22
		],
		[
			"2011-11-09",
			58.01
		],
		[
			"2012-03-12",
			61.55
		],
		[
			"2012-05-29",
			58.01
		],
		[
			"2012-07-16",
			60.67
		],
		[
			"2012-08-27",
			60.67
		],
		[
			"2012-11-20",
			59.34
		],
		[
			"2013-03-25",
			62.44
		],
		[
			"2013-07-29",
			63.32
		],
		[
			"2013-09-09",
			65.54
		],
		[
			"2013-11-12",
			65.98
		],
		[
			"2014-04-07",
			62
		],
		[
			"2014-04-28",
			65.54
		],
		[
			"2014-06-16",
			62.44
		],
		[
			"2014-07-22",
			62.44
		],
		[
			"2014-11-17",
			63.32
		],
		[
			"2015-03-16",
			64.21
		],
		[
			"2015-06-08",
			66.86
		],
		[
			"2015-09-14",
			66.86
		],
		[
			"2015-11-03",
			69.08
		],
		[
			"2000-03-20",
			51.42
		],
		[
			"2000-11-14",
			48.71
		],
		[
			"2000-07-18",
			53.62
		],
		[
			"2000-11-07",
			49.62
		],
		[
			"2001-01-30",
			52.22
		],
		[
			"2001-03-12",
			52.72
		],
		[
			"2001-07-12",
			55.82
		],
		[
			"2001-11-12",
			54.42
		],
		[
			"2002-03-05",
			58.02
		],
		[
			"2003-03-10",
			54.42
		],
		[
			"2003-07-14",
			60.62
		],
		[
			"2003-11-24",
			55.82
		],
		[
			"2005-04-05",
			56.22
		],
		[
			"2004-03-02",
			56.22
		],
		[
			"2004-07-06",
			54.92
		],
		[
			"2004-11-22",
			57.12
		],
		[
			"2002-10-15",
			53.59
		],
		[
			"2005-07-05",
			55.82
		],
		[
			"2005-11-03",
			54.42
		],
		[
			"2006-03-13",
			54.92
		],
		[
			"2006-07-11",
			55.82
		],
		[
			"2007-03-12",
			56.72
		],
		[
			"2007-07-11",
			57.52
		],
		[
			"2007-11-12",
			53.62
		],
		[
			"2008-07-15",
			63.32
		],
		[
			"2008-11-10",
			61.12
		],
		[
			"2008-03-04",
			55.82
		],
		[
			"2009-03-17",
			53.62
		],
		[
			"2009-07-06",
			57.12
		],
		[
			"2009-11-16",
			56.22
		],
		[
			"2010-03-08",
			53.62
		],
		[
			"2010-07-13",
			55.8
		],
		[
			"2008-09-24",
			60.67
		]
	],
	"210404553": [
		[
			"2010-08-16",
			75.73
		],
		[
			"2010-09-22",
			73.07
		],
		[
			"2010-11-16",
			77.5
		],
		[
			"2011-03-15",
			81.48
		],
		[
			"2011-06-28",
			81.04
		],
		[
			"2011-07-27",
			76.61
		],
		[
			"2011-09-19",
			80.6
		],
		[
			"2011-11-09",
			88.57
		],
		[
			"2012-03-12",
			92.99
		],
		[
			"2012-05-29",
			91.66
		],
		[
			"2012-07-16",
			85.47
		],
		[
			"2012-08-27",
			83.7
		],
		[
			"2012-11-20",
			91.22
		],
		[
			"2013-03-25",
			94.32
		],
		[
			"2013-07-29",
			84.58
		],
		[
			"2013-09-09",
			87.68
		],
		[
			"2013-11-12",
			84.58
		],
		[
			"2014-04-07",
			92.55
		],
		[
			"2014-04-28",
			91.22
		],
		[
			"2014-06-16",
			87.68
		],
		[
			"2014-07-22",
			89.89
		],
		[
			"2014-11-17",
			83.25
		],
		[
			"2015-03-16",
			82.37
		],
		[
			"2015-06-08",
			86.35
		],
		[
			"2015-09-14",
			89.89
		],
		[
			"2015-11-03",
			87.68
		],
		[
			"2000-03-20",
			63.32
		],
		[
			"2000-11-07",
			61.52
		],
		[
			"2002-03-05",
			64.22
		],
		[
			"2003-11-24",
			57.52
		],
		[
			"2005-04-05",
			66.82
		],
		[
			"2004-03-02",
			58.92
		],
		[
			"2004-07-06",
			61.12
		],
		[
			"2004-11-22",
			64.62
		],
		[
			"2005-07-05",
			66.02
		],
		[
			"2005-11-03",
			65.52
		],
		[
			"2006-03-13",
			69.12
		],
		[
			"2006-07-11",
			65.12
		],
		[
			"2007-03-12",
			72.63
		],
		[
			"2007-07-11",
			71.33
		],
		[
			"2007-11-12",
			70.83
		],
		[
			"2008-07-15",
			77.53
		],
		[
			"2008-11-10",
			73.03
		],
		[
			"2008-03-04",
			74.43
		],
		[
			"2009-03-17",
			71.33
		],
		[
			"2009-07-06",
			69.52
		],
		[
			"2009-11-16",
			65.52
		],
		[
			"2010-03-08",
			66.82
		],
		[
			"2010-07-13",
			70.86
		],
		[
			"2008-09-24",
			74.4
		]
	],
	"210404711": [
		[
			"2010-11-15",
			78.83
		],
		[
			"2011-04-04",
			78.83
		],
		[
			"2011-07-19",
			79.71
		],
		[
			"2011-11-16",
			80.6
		],
		[
			"2012-04-10",
			81.93
		],
		[
			"2012-07-25",
			77.94
		],
		[
			"2012-11-12",
			79.27
		],
		[
			"2013-10-01",
			91.43
		],
		[
			"2013-07-16",
			82.37
		],
		[
			"2013-12-16",
			78.83
		],
		[
			"2014-04-01",
			82.37
		],
		[
			"2014-07-16",
			79.27
		],
		[
			"2014-12-15",
			79.71
		],
		[
			"2015-04-28",
			80.16
		],
		[
			"2015-08-03",
			81.93
		],
		[
			"2015-11-23",
			83.25
		],
		[
			"2001-10-11",
			73.07
		],
		[
			"2000-03-20",
			78.83
		],
		[
			"2000-04-11",
			79.27
		],
		[
			"2000-06-26",
			70.86
		],
		[
			"2000-07-10",
			85.03
		],
		[
			"2000-09-18",
			77.06
		],
		[
			"2000-11-13",
			78.83
		],
		[
			"2000-11-20",
			86.36
		],
		[
			"2001-01-22",
			81.93
		],
		[
			"2001-06-11",
			70.86
		],
		[
			"2001-09-17",
			71.74
		],
		[
			"2001-11-26",
			71.3
		],
		[
			"2002-01-21",
			73.07
		],
		[
			"2002-04-29",
			88.57
		],
		[
			"2002-06-10",
			72.63
		],
		[
			"2002-07-29",
			88.13
		],
		[
			"2003-03-24",
			75.73
		],
		[
			"2003-04-03",
			79.71
		],
		[
			"2003-05-19",
			80.6
		],
		[
			"2003-07-21",
			73.96
		],
		[
			"2005-04-06",
			78.43
		],
		[
			"2004-04-13",
			80.63
		],
		[
			"2004-07-05",
			81.03
		],
		[
			"2004-11-08",
			82.83
		],
		[
			"2005-07-04",
			78.43
		],
		[
			"2006-04-10",
			80.63
		],
		[
			"2006-07-17",
			79.73
		],
		[
			"2006-10-24",
			85.91
		],
		[
			"2007-04-23",
			83.23
		],
		[
			"2007-07-09",
			83.23
		],
		[
			"2007-05-14",
			83.26
		],
		[
			"2007-11-19",
			80.13
		],
		[
			"2008-07-02",
			87.23
		],
		[
			"2008-11-25",
			80.63
		],
		[
			"2008-04-02",
			79.23
		],
		[
			"2009-04-28",
			80.13
		],
		[
			"2009-07-01",
			80.63
		],
		[
			"2009-11-23",
			81.53
		],
		[
			"2010-06-01",
			80.63
		],
		[
			"2013-04-02",
			80.6
		],
		[
			"2013-05-06",
			80.33
		]
	],
	"215988711": [
		[
			"2010-10-08",
			73.93
		],
		[
			"2011-10-17",
			71.03
		],
		[
			"2012-10-09",
			53.42
		],
		[
			"2013-10-10",
			77.73
		],
		[
			"2014-10-09",
			80.53
		],
		[
			"2015-10-13",
			76.93
		],
		[
			"2003-07-28",
			76.13
		],
		[
			"2004-04-30",
			91.63
		],
		[
			"2005-05-04",
			84.13
		],
		[
			"2006-04-10",
			87.23
		]
	],
	"216000051": [
		[
			"2012-08-21",
			0.2
		],
		[
			"2013-08-05",
			0.2
		],
		[
			"2014-08-25",
			0.2
		],
		[
			"2015-08-31",
			0.89
		]
	],
	"218086015": [
		[
			"2012-02-29",
			2.5
		],
		[
			"2015-04-08",
			2.5
		],
		[
			"2015-10-19",
			0.7
		],
		[
			"2000-09-01",
			40.61
		],
		[
			"2000-06-30",
			47.82
		],
		[
			"2000-04-27",
			46.62
		],
		[
			"2000-02-25",
			43.02
		],
		[
			"2001-08-20",
			49.32
		],
		[
			"2001-02-05",
			49.22
		],
		[
			"2002-02-20",
			49.02
		],
		[
			"2003-08-25",
			50.22
		],
		[
			"2003-02-26",
			49.22
		],
		[
			"2004-02-05",
			66.32
		],
		[
			"2005-08-26",
			9
		],
		[
			"2005-07-04",
			52.52
		],
		[
			"2006-02-08",
			48.02
		],
		[
			"2006-08-21",
			27.31
		],
		[
			"2007-02-13",
			14.71
		]
	],
	"218129415": [
		[
			"2010-10-07",
			15.81
		],
		[
			"2011-10-13",
			15.71
		],
		[
			"2012-10-12",
			15.71
		],
		[
			"2013-10-14",
			17.71
		],
		[
			"2014-10-13",
			15.51
		],
		[
			"2015-10-15",
			16.71
		]
	],
	"218149517": [
		[
			"2010-04-20",
			0.5
		],
		[
			"2010-10-06",
			0.5
		],
		[
			"2011-04-07",
			0.5
		],
		[
			"2011-10-12",
			0.7
		],
		[
			"2012-04-13",
			0.5
		],
		[
			"2012-10-11",
			0.5
		],
		[
			"2013-04-15",
			0.5
		],
		[
			"2013-10-08",
			0.5
		],
		[
			"2014-04-30",
			0.5
		],
		[
			"2014-10-07",
			0.9
		],
		[
			"2015-04-08",
			0.5
		],
		[
			"2015-10-16",
			0.5
		],
		[
			"2004-09-29",
			0.5
		],
		[
			"2000-09-22",
			0.5
		],
		[
			"2000-03-10",
			0.5
		],
		[
			"2001-09-21",
			0.5
		],
		[
			"2001-03-13",
			0.5
		],
		[
			"2002-09-03",
			0.5
		],
		[
			"2002-03-20",
			0.5
		],
		[
			"2003-09-19",
			0.5
		],
		[
			"2003-03-21",
			0.5
		],
		[
			"2004-03-19",
			0.5
		],
		[
			"2005-03-18",
			0.9
		],
		[
			"2005-09-21",
			0.5
		],
		[
			"2006-03-13",
			0.5
		],
		[
			"2006-09-20",
			0.5
		],
		[
			"2007-03-21",
			0.5
		],
		[
			"2007-10-03",
			0.5
		],
		[
			"2008-04-09",
			0.5
		],
		[
			"2008-10-15",
			0.5
		],
		[
			"2009-04-15",
			0.5
		],
		[
			"2009-10-14",
			0.5
		]
	],
	"218175917": [
		[
			"2011-10-12",
			0.5
		],
		[
			"2013-10-08",
			1.1
		],
		[
			"2014-10-07",
			0.5
		],
		[
			"2015-10-16",
			0.5
		],
		[
			"2004-09-29",
			0.5
		],
		[
			"2000-09-22",
			0.5
		],
		[
			"2000-03-31",
			0.5
		],
		[
			"2001-09-21",
			0.5
		],
		[
			"2001-03-13",
			0.5
		],
		[
			"2001-01-26",
			0.5
		],
		[
			"2002-09-03",
			0.5
		],
		[
			"2003-09-19",
			0.5
		],
		[
			"2003-03-21",
			0.5
		],
		[
			"2004-03-19",
			0.5
		],
		[
			"2005-03-18",
			2.5
		],
		[
			"2005-09-21",
			0.5
		],
		[
			"2006-03-13",
			0.5
		],
		[
			"2006-09-20",
			0.5
		],
		[
			"2007-03-21",
			0.5
		],
		[
			"2007-10-03",
			0.5
		],
		[
			"2008-04-09",
			0.5
		]
	],
	"218209319": [
		[
			"2010-10-06",
			0.6
		],
		[
			"2011-06-08",
			0.2
		],
		[
			"2011-10-12",
			0.5
		],
		[
			"2012-08-14",
			0.2
		],
		[
			"2012-10-08",
			0.5
		],
		[
			"2013-10-24",
			0.2
		],
		[
			"2013-10-07",
			0.5
		],
		[
			"2014-09-09",
			0.2
		],
		[
			"2014-10-06",
			0.6
		],
		[
			"2015-10-14",
			0.5
		],
		[
			"2015-11-09",
			0.89
		],
		[
			"2003-07-29",
			0.2
		],
		[
			"2004-03-04",
			0.2
		],
		[
			"2005-03-21",
			0.2
		],
		[
			"2006-10-19",
			0.2
		],
		[
			"2007-02-01",
			0.2
		],
		[
			"2014-08-15",
			0.13
		],
		[
			"2007-11-08",
			0.2
		],
		[
			"2008-06-19",
			0.2
		],
		[
			"2008-11-21",
			0.2
		],
		[
			"2009-05-13",
			0.2
		]
	],
	"218218618": [
		[
			"2010-10-06",
			0.5
		],
		[
			"2011-07-27",
			0.2
		],
		[
			"2011-10-12",
			0.5
		],
		[
			"2012-08-30",
			0.2
		],
		[
			"2012-10-08",
			0.5
		],
		[
			"2013-10-07",
			1.2
		],
		[
			"2014-10-06",
			0.9
		],
		[
			"2015-10-14",
			0.5
		],
		[
			"2003-05-13",
			0.2
		],
		[
			"2003-11-06",
			0.2
		],
		[
			"2004-03-05",
			0.2
		],
		[
			"2004-10-05",
			0.2
		],
		[
			"2005-03-24",
			0.2
		],
		[
			"2005-09-13",
			0.2
		],
		[
			"2006-03-13",
			0.2
		],
		[
			"2006-10-26",
			0.2
		],
		[
			"2006-12-20",
			0.2
		],
		[
			"2007-01-30",
			0.2
		],
		[
			"2007-11-08",
			0.2
		],
		[
			"2008-06-19",
			0.2
		],
		[
			"2008-11-12",
			0.2
		],
		[
			"2009-05-29",
			0.2
		]
	],
	"218219210": [
		[
			"2012-08-13",
			26.75
		],
		[
			"2013-04-25",
			26.79
		],
		[
			"2014-07-07",
			26.66
		],
		[
			"2015-07-30",
			26.62
		],
		[
			"2003-02-19",
			30.31
		],
		[
			"2004-03-03",
			32.01
		],
		[
			"2005-02-17",
			30.91
		],
		[
			"2006-02-22",
			25.81
		],
		[
			"2007-02-12",
			21.81
		],
		[
			"2007-09-04",
			21.31
		],
		[
			"2008-06-23",
			25.11
		],
		[
			"2008-09-22",
			23.81
		],
		[
			"2009-04-24",
			23.21
		],
		[
			"2010-01-28",
			21.7
		]
	],
	"218413518": [
		[
			"2010-12-16",
			53.14
		],
		[
			"2011-10-17",
			53.32
		],
		[
			"2012-07-24",
			57.57
		],
		[
			"2012-10-09",
			84.73
		],
		[
			"2013-05-23",
			65.54
		],
		[
			"2013-10-10",
			63.02
		],
		[
			"2014-09-25",
			60.22
		],
		[
			"2014-10-09",
			59.32
		],
		[
			"2015-10-13",
			62.32
		],
		[
			"2015-12-01",
			62.88
		],
		[
			"2003-05-13",
			60.22
		],
		[
			"2004-03-16",
			65.12
		],
		[
			"2005-06-09",
			65.12
		],
		[
			"2006-03-16",
			58.42
		],
		[
			"2007-02-02",
			52.72
		],
		[
			"2007-10-05",
			50.52
		],
		[
			"2008-06-24",
			49.62
		],
		[
			"2008-11-05",
			51.42
		],
		[
			"2009-02-11",
			52.72
		]
	],
	"218639016": [
		[
			"2010-10-06",
			82.93
		],
		[
			"2011-05-30",
			75.73
		],
		[
			"2011-10-12",
			81.23
		],
		[
			"2012-10-08",
			82.23
		],
		[
			"2013-07-30",
			85.02
		],
		[
			"2013-10-07",
			82.33
		],
		[
			"2014-08-29",
			80.16
		],
		[
			"2014-10-06",
			81.83
		],
		[
			"2015-07-14",
			85.02
		],
		[
			"2015-10-14",
			84.63
		],
		[
			"2006-05-22",
			74.83
		],
		[
			"2007-03-07",
			75.73
		],
		[
			"2007-08-07",
			74.43
		],
		[
			"2007-10-16",
			73.93
		],
		[
			"2008-04-23",
			72.23
		],
		[
			"2008-08-21",
			79.23
		],
		[
			"2008-11-20",
			84.13
		],
		[
			"2009-05-29",
			83.73
		]
	],
	"218642817": [
		[
			"2010-10-07",
			24.11
		],
		[
			"2011-10-18",
			34.01
		],
		[
			"2012-10-08",
			15.41
		],
		[
			"2013-10-07",
			33.21
		],
		[
			"2014-10-14",
			8.8
		],
		[
			"2015-10-14",
			31.21
		],
		[
			"2000-05-31",
			34.61
		],
		[
			"2001-12-11",
			26.91
		],
		[
			"2002-05-22",
			22.41
		],
		[
			"2003-09-17",
			15.41
		],
		[
			"2004-11-15",
			24.21
		],
		[
			"2005-06-08",
			29.01
		],
		[
			"2008-11-18",
			33.51
		]
	],
	"218643615": [
		[
			"2010-10-07",
			11.3
		],
		[
			"2011-10-18",
			15.51
		],
		[
			"2012-10-08",
			6.1
		],
		[
			"2013-10-07",
			17.91
		],
		[
			"2014-10-14",
			23.21
		],
		[
			"2015-10-14",
			24.21
		],
		[
			"2000-09-27",
			21.61
		],
		[
			"2001-09-12",
			17.01
		],
		[
			"2002-09-26",
			34.21
		],
		[
			"2003-09-02",
			31.61
		],
		[
			"2005-09-23",
			16.21
		],
		[
			"2006-09-05",
			21.91
		],
		[
			"2007-10-04",
			15.61
		],
		[
			"2008-10-14",
			24.61
		],
		[
			"2009-10-15",
			25.31
		]
	],
	"218673917": [
		[
			"2010-10-07",
			26.11
		],
		[
			"2011-10-13",
			27.11
		],
		[
			"2012-03-08",
			28.03
		],
		[
			"2012-10-12",
			29.01
		],
		[
			"2013-04-29",
			27.5
		],
		[
			"2013-10-14",
			47.22
		],
		[
			"2014-10-13",
			28.21
		],
		[
			"2015-10-15",
			29.71
		],
		[
			"2006-08-03",
			23.81
		],
		[
			"2007-02-08",
			24.01
		],
		[
			"2009-04-29",
			25.31
		]
	],
	"218676414": [
		[
			"2000-05-15",
			0.2
		],
		[
			"2001-03-28",
			0.2
		],
		[
			"2001-08-30",
			0.2
		],
		[
			"2002-03-08",
			0.2
		],
		[
			"2002-08-29",
			0.2
		],
		[
			"2003-04-16",
			0.2
		],
		[
			"2003-08-20",
			0.2
		],
		[
			"2004-03-16",
			0.2
		],
		[
			"2004-09-30",
			0.2
		],
		[
			"2005-02-15",
			0.2
		],
		[
			"2005-07-20",
			0.2
		],
		[
			"2006-01-10",
			0.2
		],
		[
			"2006-08-07",
			0.2
		],
		[
			"2007-01-10",
			0.2
		],
		[
			"2007-11-22",
			0.2
		],
		[
			"2008-07-11",
			0.2
		],
		[
			"2008-09-15",
			0.2
		],
		[
			"2009-07-10",
			0.2
		],
		[
			"2010-03-11",
			0.2
		],
		[
			"2010-10-07",
			0.5
		],
		[
			"2011-10-13",
			0.5
		],
		[
			"2012-10-12",
			0.5
		],
		[
			"2013-10-14",
			0.5
		],
		[
			"2014-10-13",
			0.5
		],
		[
			"2015-10-15",
			0.5
		]
	],
	"218677315": [
		[
			"2010-04-09",
			11.3
		],
		[
			"2011-04-14",
			10.7
		],
		[
			"2011-10-18",
			8.5
		],
		[
			"2012-04-30",
			9.2
		],
		[
			"2012-10-08",
			14.61
		],
		[
			"2013-04-30",
			15.81
		],
		[
			"2013-10-07",
			16.31
		],
		[
			"2014-05-14",
			18.31
		],
		[
			"2014-10-14",
			13.3
		],
		[
			"2015-04-09",
			18.81
		],
		[
			"2015-10-14",
			21.81
		],
		[
			"2004-09-22",
			20.71
		],
		[
			"2005-03-04",
			22.91
		],
		[
			"2000-10-04",
			39.01
		],
		[
			"2000-02-28",
			40.01
		],
		[
			"2001-09-12",
			30.51
		],
		[
			"2001-03-02",
			33.91
		],
		[
			"2002-09-26",
			30.01
		],
		[
			"2002-03-06",
			30.81
		],
		[
			"2003-08-05",
			26.61
		],
		[
			"2003-03-12",
			29.71
		],
		[
			"2004-03-04",
			25.81
		],
		[
			"2005-09-19",
			21.21
		],
		[
			"2006-03-21",
			22.71
		],
		[
			"2006-09-29",
			21.11
		],
		[
			"2007-03-07",
			20.01
		],
		[
			"2007-10-04",
			15.31
		],
		[
			"2008-04-17",
			13.9
		],
		[
			"2008-10-14",
			14
		],
		[
			"2009-03-30",
			13.3
		],
		[
			"2009-10-15",
			13.9
		]
	],
	"219078117": [
		[
			"2012-03-08",
			29.49
		],
		[
			"2013-05-03",
			27.15
		],
		[
			"2014-04-08",
			37.24
		],
		[
			"2015-07-10",
			39.54
		],
		[
			"2000-01-14",
			43.32
		],
		[
			"2001-03-13",
			41.81
		],
		[
			"2001-09-20",
			40.21
		],
		[
			"2002-02-25",
			41.41
		],
		[
			"2002-09-17",
			39.01
		],
		[
			"2003-09-25",
			32.91
		],
		[
			"2004-03-09",
			31.31
		],
		[
			"2004-10-04",
			32.41
		],
		[
			"2005-03-08",
			30.71
		],
		[
			"2005-09-12",
			30.11
		],
		[
			"2006-02-14",
			32.81
		],
		[
			"2006-08-03",
			32.31
		],
		[
			"2007-02-12",
			33.11
		],
		[
			"2007-10-18",
			33.81
		],
		[
			"2008-07-10",
			38.81
		],
		[
			"2009-06-26",
			38.31
		],
		[
			"2010-02-04",
			37.15
		]
	],
	"219080215": [
		[
			"2014-05-06",
			72.63
		],
		[
			"2015-07-07",
			95.21
		],
		[
			"2000-01-17",
			66.42
		],
		[
			"2001-03-13",
			27.91
		],
		[
			"2001-09-20",
			7.1
		],
		[
			"2002-02-25",
			10.9
		],
		[
			"2002-09-09",
			92.13
		],
		[
			"2003-05-13",
			100.04
		],
		[
			"2003-09-29",
			98.74
		],
		[
			"2004-02-25",
			37.81
		],
		[
			"2004-10-15",
			21.81
		],
		[
			"2005-02-21",
			52.22
		],
		[
			"2005-08-29",
			55.32
		],
		[
			"2006-02-15",
			77.53
		],
		[
			"2006-08-02",
			66.82
		],
		[
			"2007-02-02",
			28.61
		],
		[
			"2007-10-18",
			69.12
		],
		[
			"2008-06-23",
			84.63
		],
		[
			"2008-09-15",
			92.13
		],
		[
			"2010-03-05",
			47.39
		]
	],
	"219278519": [
		[
			"2011-06-07",
			0.2
		],
		[
			"2012-08-16",
			0.2
		],
		[
			"2013-10-22",
			0.2
		],
		[
			"2014-09-09",
			0.2
		],
		[
			"2015-11-09",
			0.89
		],
		[
			"2003-03-10",
			0.2
		],
		[
			"2004-02-20",
			0.2
		],
		[
			"2005-03-22",
			0.2
		],
		[
			"2005-07-12",
			0.2
		],
		[
			"2005-08-23",
			0.2
		],
		[
			"2005-09-15",
			0.2
		],
		[
			"2005-10-27",
			0.2
		],
		[
			"2005-11-16",
			0.2
		],
		[
			"2005-12-14",
			0.2
		],
		[
			"2006-01-16",
			0.2
		],
		[
			"2006-02-15",
			0.2
		],
		[
			"2006-03-15",
			0.2
		],
		[
			"2006-04-12",
			0.2
		],
		[
			"2006-05-15",
			0.2
		],
		[
			"2006-06-13",
			0.2
		],
		[
			"2006-07-18",
			0.2
		],
		[
			"2006-08-16",
			0.2
		],
		[
			"2006-09-14",
			0.2
		],
		[
			"2006-10-24",
			0.2
		],
		[
			"2006-11-13",
			0.2
		],
		[
			"2006-12-15",
			0.2
		],
		[
			"2007-01-22",
			0.2
		],
		[
			"2007-02-01",
			1.9
		],
		[
			"2007-02-07",
			0.2
		],
		[
			"2007-02-13",
			0.2
		],
		[
			"2007-03-14",
			0.2
		],
		[
			"2007-04-23",
			0.2
		],
		[
			"2007-05-16",
			0.2
		],
		[
			"2007-06-21",
			0.2
		],
		[
			"2007-07-23",
			0.2
		],
		[
			"2007-08-22",
			0.2
		],
		[
			"2007-10-22",
			0.2
		],
		[
			"2007-11-13",
			0.2
		],
		[
			"2007-12-06",
			0.2
		],
		[
			"2008-01-14",
			0.2
		],
		[
			"2008-02-07",
			0.2
		],
		[
			"2008-03-17",
			0.2
		],
		[
			"2008-04-11",
			0.2
		],
		[
			"2008-05-07",
			0.2
		],
		[
			"2008-06-19",
			0.2
		],
		[
			"2008-07-14",
			0.2
		],
		[
			"2008-08-28",
			0.2
		],
		[
			"2008-09-15",
			0.2
		],
		[
			"2008-10-14",
			0.2
		],
		[
			"2008-11-17",
			0.2
		],
		[
			"2008-12-11",
			0.2
		],
		[
			"2009-01-13",
			0.2
		],
		[
			"2009-02-16",
			0.2
		],
		[
			"2009-03-16",
			0.2
		],
		[
			"2009-04-14",
			0.2
		],
		[
			"2009-05-18",
			0.2
		],
		[
			"2009-06-17",
			0.2
		],
		[
			"2009-07-17",
			0.2
		],
		[
			"2009-08-19",
			0.2
		],
		[
			"2009-09-21",
			0.2
		],
		[
			"2009-10-13",
			0.2
		]
	],
	"219282018": [
		[
			"2011-05-25",
			0.2
		],
		[
			"2012-08-30",
			0.2
		],
		[
			"2013-07-29",
			0.2
		],
		[
			"2014-08-28",
			0.2
		],
		[
			"2015-07-09",
			0.89
		],
		[
			"2003-05-07",
			0.2
		],
		[
			"2004-03-08",
			0.2
		],
		[
			"2005-06-01",
			0.2
		],
		[
			"2006-03-31",
			0.2
		],
		[
			"2007-02-05",
			0.2
		],
		[
			"2007-10-10",
			0.2
		],
		[
			"2008-04-24",
			0.2
		],
		[
			"2008-11-21",
			0.2
		],
		[
			"2009-05-11",
			0.2
		]
	],
	"219478314": [
		[
			"2012-03-14",
			44.29
		],
		[
			"2013-05-23",
			56.68
		],
		[
			"2014-09-23",
			52.26
		],
		[
			"2015-11-30",
			54.47
		],
		[
			"2006-01-25",
			27.31
		],
		[
			"2006-12-21",
			49.12
		],
		[
			"2007-02-28",
			40.21
		],
		[
			"2007-08-08",
			47.82
		],
		[
			"2008-06-16",
			47.82
		],
		[
			"2008-09-08",
			50.02
		],
		[
			"2009-02-12",
			33.71
		]
	],
	"219480618": [
		[
			"2011-01-06",
			49.6
		],
		[
			"2012-03-14",
			65.98
		],
		[
			"2013-05-23",
			65.54
		],
		[
			"2014-09-24",
			61.55
		],
		[
			"2015-12-09",
			59.34
		],
		[
			"2003-04-30",
			62.92
		],
		[
			"2003-08-29",
			62.92
		],
		[
			"2004-03-15",
			60.62
		],
		[
			"2004-10-05",
			62.02
		],
		[
			"2005-04-07",
			64.22
		],
		[
			"2005-08-29",
			66.42
		],
		[
			"2000-01-27",
			69.12
		],
		[
			"2000-08-15",
			74.83
		],
		[
			"2001-01-11",
			75.73
		],
		[
			"2001-07-24",
			75.73
		],
		[
			"2002-05-07",
			75.33
		],
		[
			"2002-10-28",
			69.92
		],
		[
			"2006-03-16",
			63.72
		],
		[
			"2006-09-20",
			66.02
		],
		[
			"2006-12-21",
			71.73
		],
		[
			"2007-01-25",
			66.02
		],
		[
			"2007-08-30",
			64.62
		],
		[
			"2008-06-04",
			64.62
		],
		[
			"2008-09-08",
			66.42
		],
		[
			"2009-02-12",
			64.22
		]
	],
	"219482410": [
		[
			"2010-05-04",
			2.21
		],
		[
			"2011-08-04",
			4.83
		],
		[
			"2013-08-27",
			12.04
		],
		[
			"2014-03-27",
			1.81
		],
		[
			"2015-08-19",
			9.78
		],
		[
			"2003-05-22",
			18.51
		],
		[
			"2004-03-25",
			16.71
		],
		[
			"2005-04-26",
			5.9
		],
		[
			"2006-05-31",
			7.7
		],
		[
			"2006-12-11",
			2.8
		],
		[
			"2007-01-29",
			3.5
		],
		[
			"2007-07-23",
			2
		],
		[
			"2008-05-27",
			1
		],
		[
			"2008-09-11",
			0.9
		],
		[
			"2009-02-27",
			0.2
		]
	],
	"219483218": [
		[
			"2012-07-26",
			164.74
		],
		[
			"2013-05-07",
			170.49
		],
		[
			"2014-10-07",
			177.57
		],
		[
			"2015-12-08",
			187.77
		],
		[
			"2003-05-06",
			169.16
		],
		[
			"2003-09-17",
			142.55
		],
		[
			"2004-03-15",
			150.55
		],
		[
			"2004-10-05",
			155.46
		],
		[
			"2005-03-31",
			157.66
		],
		[
			"2005-08-30",
			170.06
		],
		[
			"2006-03-17",
			170.46
		],
		[
			"2006-09-20",
			172.26
		],
		[
			"2007-01-25",
			158.56
		],
		[
			"2007-10-05",
			172.66
		],
		[
			"2008-06-24",
			64.22
		],
		[
			"2008-08-29",
			175.36
		],
		[
			"2009-02-12",
			171.86
		]
	],
	"219486219": [
		[
			"2010-10-21",
			72.19
		],
		[
			"2011-08-31",
			70.86
		],
		[
			"2013-06-05",
			81.48
		],
		[
			"2014-07-03",
			83.25
		],
		[
			"2015-03-26",
			78.83
		],
		[
			"2015-12-02",
			74.4
		],
		[
			"2001-11-13",
			54.42
		],
		[
			"2002-02-05",
			54.42
		],
		[
			"2003-07-28",
			53.12
		],
		[
			"2004-03-15",
			53.62
		],
		[
			"2005-05-19",
			53.62
		],
		[
			"2000-03-20",
			47.42
		],
		[
			"2000-04-20",
			50.92
		],
		[
			"2007-04-18",
			57.12
		],
		[
			"2007-08-28",
			56.72
		],
		[
			"2007-10-16",
			47.42
		],
		[
			"2008-07-03",
			59.82
		],
		[
			"2008-09-15",
			56.72
		],
		[
			"2009-03-17",
			54.42
		]
	],
	"219602013": [
		[
			"2010-08-04",
			2.3
		],
		[
			"2012-04-23",
			2.3
		],
		[
			"2013-04-29",
			5.44
		],
		[
			"2014-08-28",
			1.73
		],
		[
			"2015-10-19",
			0.89
		],
		[
			"2003-04-23",
			8.5
		],
		[
			"2003-08-28",
			2.6
		],
		[
			"2004-03-19",
			6.7
		],
		[
			"2004-11-18",
			3.9
		],
		[
			"2005-04-07",
			6.9
		],
		[
			"2005-09-21",
			3.3
		],
		[
			"2006-03-20",
			3.1
		],
		[
			"2006-09-12",
			3.5
		],
		[
			"2007-02-28",
			3.1
		],
		[
			"2007-11-07",
			2.3
		],
		[
			"2008-06-24",
			12.8
		],
		[
			"2008-10-09",
			2.4
		],
		[
			"2009-04-16",
			4.1
		]
	],
	"219602610": [
		[
			"2012-04-11",
			0.2
		],
		[
			"2013-04-30",
			0.2
		],
		[
			"2014-04-17",
			0.2
		],
		[
			"2015-06-25",
			0.89
		],
		[
			"2003-04-10",
			0.2
		],
		[
			"2003-09-15",
			0.2
		],
		[
			"2004-02-18",
			0.2
		],
		[
			"2004-10-11",
			0.2
		],
		[
			"2005-04-26",
			0.2
		],
		[
			"2005-08-30",
			0.2
		],
		[
			"2006-02-02",
			0.2
		],
		[
			"2006-07-21",
			0.2
		],
		[
			"2007-02-02",
			0.2
		],
		[
			"2007-09-04",
			0.2
		],
		[
			"2008-06-23",
			0.2
		],
		[
			"2008-09-26",
			0.2
		],
		[
			"2009-04-29",
			0.2
		],
		[
			"2010-02-08",
			0.2
		]
	],
	"219602712": [
		[
			"2011-09-12",
			199.72
		],
		[
			"2013-05-13",
			181.12
		],
		[
			"2014-06-05",
			167.84
		],
		[
			"2015-06-08",
			165.18
		],
		[
			"2003-02-11",
			131.55
		],
		[
			"2004-01-08",
			123.54
		],
		[
			"2005-07-13",
			142.55
		],
		[
			"2006-02-02",
			121.74
		],
		[
			"2007-01-23",
			123.14
		],
		[
			"2007-08-23",
			149.25
		],
		[
			"2008-05-15",
			165.66
		],
		[
			"2008-09-16",
			171.86
		],
		[
			"2009-04-07",
			168.26
		],
		[
			"2010-01-27",
			163.85
		]
	],
	"219602815": [
		[
			"2011-09-13",
			230.72
		],
		[
			"2013-05-13",
			235.14
		],
		[
			"2014-06-18",
			211.23
		],
		[
			"2015-06-08",
			182.89
		],
		[
			"2003-02-10",
			262.19
		],
		[
			"2004-01-09",
			251.99
		],
		[
			"2004-08-03",
			235.18
		],
		[
			"2005-01-18",
			212.08
		],
		[
			"2005-07-13",
			233.78
		],
		[
			"2006-01-31",
			240.49
		],
		[
			"2006-09-22",
			230.68
		],
		[
			"2007-01-23",
			217.88
		],
		[
			"2007-08-23",
			214.38
		],
		[
			"2000-04-14",
			212.58
		],
		[
			"2000-09-25",
			210.37
		],
		[
			"2001-07-12",
			236.48
		],
		[
			"2002-06-11",
			283.4
		],
		[
			"2008-05-15",
			200.57
		],
		[
			"2008-09-16",
			195.27
		],
		[
			"2009-04-07",
			169.16
		],
		[
			"2010-01-27",
			185.55
		]
	],
	"219602918": [
		[
			"2013-05-14",
			1.64
		],
		[
			"2014-06-05",
			0.2
		],
		[
			"2015-06-10",
			0.89
		],
		[
			"2003-02-10",
			1
		],
		[
			"2004-01-09",
			0.2
		],
		[
			"2004-08-03",
			0.2
		],
		[
			"2005-01-18",
			0.2
		],
		[
			"2005-07-12",
			0.2
		],
		[
			"2006-01-31",
			0.2
		],
		[
			"2007-01-23",
			0.2
		],
		[
			"2007-08-23",
			0.2
		],
		[
			"2008-11-04",
			0.2
		],
		[
			"2009-04-07",
			6.7
		],
		[
			"2010-01-27",
			1.86
		]
	],
	"219603017": [
		[
			"2011-09-13",
			7.13
		],
		[
			"2013-05-14",
			8.06
		],
		[
			"2014-06-18",
			8.72
		],
		[
			"2015-06-02",
			10.23
		],
		[
			"2003-02-10",
			26.31
		],
		[
			"2004-01-09",
			16.71
		],
		[
			"2004-08-03",
			25.61
		],
		[
			"2005-01-18",
			22.01
		],
		[
			"2005-07-12",
			20.91
		],
		[
			"2006-01-31",
			18.11
		],
		[
			"2007-01-29",
			13.6
		],
		[
			"2007-08-23",
			9.4
		],
		[
			"2008-06-05",
			11.9
		],
		[
			"2008-11-04",
			7.8
		],
		[
			"2009-04-07",
			12.1
		],
		[
			"2010-01-27",
			9.83
		]
	],
	"219606614": [
		[
			"2011-05-25",
			3.9
		],
		[
			"2012-08-27",
			1.64
		],
		[
			"2013-08-08",
			2.57
		],
		[
			"2014-08-26",
			0.89
		],
		[
			"2015-07-08",
			4.91
		],
		[
			"2000-05-05",
			6.2
		],
		[
			"2001-03-13",
			6
		],
		[
			"2002-05-07",
			9.2
		],
		[
			"2003-05-07",
			4.5
		],
		[
			"2004-05-12",
			5.8
		],
		[
			"2005-06-01",
			5.3
		],
		[
			"2007-10-10",
			2.7
		],
		[
			"2008-04-24",
			7.1
		],
		[
			"2008-11-20",
			4.7
		],
		[
			"2009-05-11",
			5.3
		]
	],
	"219671114": [
		[
			"2011-07-20",
			74.4
		],
		[
			"2012-08-28",
			92.55
		],
		[
			"2013-08-06",
			92.99
		],
		[
			"2014-08-05",
			91.66
		],
		[
			"2015-03-23",
			85.02
		],
		[
			"2015-11-25",
			81.93
		],
		[
			"2006-01-24",
			84.13
		],
		[
			"2006-09-25",
			79.73
		],
		[
			"2007-01-31",
			81.03
		],
		[
			"2007-07-31",
			81.53
		],
		[
			"2008-11-06",
			75.73
		],
		[
			"2009-04-23",
			79.73
		]
	],
	"219671813": [
		[
			"2011-01-10",
			3.81
		],
		[
			"2012-10-15",
			1.51
		],
		[
			"2013-08-20",
			11.2
		],
		[
			"2014-10-06",
			10.49
		],
		[
			"2015-08-17",
			13.94
		],
		[
			"2000-02-03",
			1.2
		],
		[
			"2000-07-18",
			2.6
		],
		[
			"2001-01-22",
			2
		],
		[
			"2001-08-06",
			0.2
		],
		[
			"2002-06-11",
			0.2
		],
		[
			"2002-10-30",
			0.2
		],
		[
			"2003-05-15",
			0.2
		],
		[
			"2003-10-23",
			0.2
		],
		[
			"2004-03-30",
			2.1
		],
		[
			"2004-10-12",
			0.2
		],
		[
			"2005-04-13",
			6.3
		],
		[
			"2005-09-27",
			0.2
		],
		[
			"2007-08-14",
			0.2
		],
		[
			"2008-05-26",
			0.2
		],
		[
			"2008-10-09",
			3.3
		],
		[
			"2009-04-14",
			5.9
		]
	],
	"219671916": [
		[
			"2012-12-18",
			66.42
		],
		[
			"2013-04-08",
			112.48
		],
		[
			"2014-09-22",
			100.09
		],
		[
			"2015-10-05",
			149.23
		],
		[
			"2000-04-13",
			74.83
		],
		[
			"2002-01-14",
			83.23
		],
		[
			"2003-06-17",
			85.03
		],
		[
			"2005-09-23",
			80.13
		],
		[
			"2006-04-20",
			74.43
		],
		[
			"2007-02-05",
			81.93
		],
		[
			"2007-11-07",
			79.23
		],
		[
			"2008-11-13",
			73.93
		],
		[
			"2009-04-17",
			71.33
		]
	],
	"219674310": [
		[
			"2012-08-09",
			0.2
		],
		[
			"2013-12-09",
			0.2
		],
		[
			"2014-07-31",
			1.15
		],
		[
			"2015-12-21",
			2.43
		],
		[
			"2000-03-22",
			11.5
		],
		[
			"2001-12-05",
			5.1
		],
		[
			"2002-07-12",
			6.3
		],
		[
			"2003-06-11",
			8.4
		],
		[
			"2004-04-16",
			3.8
		],
		[
			"2005-05-10",
			7
		],
		[
			"2007-09-21",
			1.9
		],
		[
			"2008-06-03",
			0.2
		],
		[
			"2008-09-29",
			0.2
		],
		[
			"2009-03-25",
			0.2
		]
	],
	"219675119": [
		[
			"2011-07-28",
			0.2
		],
		[
			"2013-04-04",
			0.2
		],
		[
			"2014-09-29",
			0.2
		],
		[
			"2015-12-15",
			0.89
		],
		[
			"2003-04-02",
			0.2
		],
		[
			"2005-09-26",
			0.2
		],
		[
			"2007-11-12",
			0.2
		],
		[
			"2008-07-07",
			0.2
		],
		[
			"2008-11-13",
			0.2
		],
		[
			"2009-05-28",
			0.2
		]
	],
	"219971614": [
		[
			"2010-05-31",
			86.8
		],
		[
			"2011-08-09",
			94.32
		],
		[
			"2012-07-17",
			82.81
		],
		[
			"2013-08-26",
			104.96
		],
		[
			"2014-05-12",
			108.94
		],
		[
			"2015-09-23",
			74.84
		],
		[
			"2003-05-20",
			65.12
		],
		[
			"2003-09-30",
			71.33
		],
		[
			"2004-03-30",
			79.73
		],
		[
			"2004-09-20",
			80.63
		],
		[
			"2005-04-19",
			81.93
		],
		[
			"2005-10-13",
			88.53
		],
		[
			"2006-05-11",
			90.33
		],
		[
			"2006-10-17",
			83.23
		],
		[
			"2006-12-11",
			76.13
		],
		[
			"2007-01-29",
			80.13
		],
		[
			"2007-09-24",
			85.43
		],
		[
			"2008-05-28",
			86.83
		],
		[
			"2008-09-09",
			84.13
		],
		[
			"2009-07-13",
			90.33
		]
	],
	"219971912": [
		[
			"2010-11-04",
			13.1
		],
		[
			"2011-07-26",
			13.5
		],
		[
			"2012-05-07",
			0.2
		],
		[
			"2013-06-13",
			13.24
		],
		[
			"2014-06-23",
			11.07
		],
		[
			"2015-11-26",
			11.11
		],
		[
			"2003-05-20",
			0.2
		],
		[
			"2003-10-22",
			4.3
		],
		[
			"2004-03-04",
			13.7
		],
		[
			"2004-08-23",
			9.2
		],
		[
			"2005-05-04",
			15.31
		],
		[
			"2005-09-21",
			12.9
		],
		[
			"2006-04-10",
			13.1
		],
		[
			"2006-10-06",
			13.9
		],
		[
			"2007-01-24",
			13.9
		],
		[
			"2007-09-20",
			11.4
		],
		[
			"2008-07-03",
			15.21
		],
		[
			"2009-03-16",
			14.81
		]
	],
	"219972011": [
		[
			"2011-08-08",
			139.94
		],
		[
			"2012-05-07",
			153.66
		],
		[
			"2013-05-27",
			132.85
		],
		[
			"2014-07-17",
			99.2
		],
		[
			"2015-12-09",
			125.32
		],
		[
			"2003-01-21",
			40.31
		],
		[
			"2003-09-08",
			110.24
		],
		[
			"2004-03-09",
			111.64
		],
		[
			"2004-08-23",
			91.23
		],
		[
			"2005-05-03",
			20.11
		],
		[
			"2005-09-20",
			19.71
		],
		[
			"2006-03-31",
			19.61
		],
		[
			"2006-10-09",
			33.51
		],
		[
			"2006-12-13",
			32.41
		],
		[
			"2007-01-23",
			32.71
		],
		[
			"2007-08-28",
			35.11
		],
		[
			"2008-07-03",
			37.61
		],
		[
			"2008-09-15",
			38.41
		],
		[
			"2009-03-17",
			73.93
		],
		[
			"2010-02-23",
			107.17
		]
	],
	"219972310": [
		[
			"2010-06-09",
			0.2
		],
		[
			"2011-08-16",
			0.2
		],
		[
			"2012-07-12",
			0.2
		],
		[
			"2014-05-15",
			0.2
		],
		[
			"2015-09-01",
			0.89
		],
		[
			"2003-06-05",
			0.2
		],
		[
			"2004-09-22",
			0.2
		],
		[
			"2005-06-02",
			0.2
		],
		[
			"2006-05-16",
			0.2
		],
		[
			"2006-12-11",
			0.2
		],
		[
			"2007-01-29",
			0.2
		],
		[
			"2008-05-28",
			0.2
		],
		[
			"2008-09-09",
			0.2
		],
		[
			"2009-03-26",
			0.2
		]
	],
	"219974214": [
		[
			"2010-06-07",
			69.96
		],
		[
			"2011-08-08",
			79.27
		],
		[
			"2012-07-11",
			85.91
		],
		[
			"2013-08-27",
			92.11
		],
		[
			"2014-05-14",
			91.66
		],
		[
			"2015-09-04",
			85.47
		],
		[
			"2000-05-08",
			66.82
		],
		[
			"2000-10-27",
			66.42
		],
		[
			"2001-04-02",
			65.52
		],
		[
			"2001-10-18",
			67.72
		],
		[
			"2002-06-19",
			66.02
		],
		[
			"2002-10-21",
			64.62
		],
		[
			"2003-05-19",
			61.12
		],
		[
			"2003-09-30",
			67.32
		],
		[
			"2004-03-29",
			62.92
		],
		[
			"2004-09-27",
			64.62
		],
		[
			"2005-04-19",
			59.82
		],
		[
			"2005-10-13",
			59.32
		],
		[
			"2008-05-28",
			59.32
		],
		[
			"2008-09-09",
			73.93
		],
		[
			"2009-04-15",
			66.42
		]
	],
	"219974317": [
		[
			"2010-10-26",
			22.54
		],
		[
			"2011-07-28",
			22.5
		],
		[
			"2012-05-14",
			23.6
		],
		[
			"2013-05-29",
			24.36
		],
		[
			"2014-06-24",
			22.41
		],
		[
			"2015-11-23",
			22.19
		],
		[
			"2000-03-16",
			23.01
		],
		[
			"2001-02-20",
			21.31
		],
		[
			"2002-02-04",
			23.11
		],
		[
			"2003-05-23",
			21.81
		],
		[
			"2004-01-23",
			21.81
		],
		[
			"2005-05-12",
			22.41
		],
		[
			"2007-09-20",
			20.61
		],
		[
			"2008-07-03",
			21.81
		],
		[
			"2009-03-17",
			21.81
		]
	],
	"219976417": [
		[
			"2011-08-10",
			15.37
		],
		[
			"2012-05-09",
			16.57
		],
		[
			"2013-06-13",
			29.63
		],
		[
			"2014-06-23",
			23.25
		],
		[
			"2015-12-08",
			17.41
		],
		[
			"2000-03-10",
			50.02
		],
		[
			"2000-09-08",
			42.82
		],
		[
			"2001-02-16",
			53.12
		],
		[
			"2001-11-08",
			34.91
		],
		[
			"2002-01-28",
			33.21
		],
		[
			"2002-07-23",
			56.22
		],
		[
			"2003-09-11",
			46.92
		],
		[
			"2003-12-10",
			37.71
		],
		[
			"2004-03-11",
			44.22
		],
		[
			"2004-11-02",
			43.82
		],
		[
			"2005-05-09",
			61.12
		],
		[
			"2005-09-21",
			48.32
		],
		[
			"2007-04-19",
			51.82
		],
		[
			"2007-08-28",
			46.52
		],
		[
			"2007-10-17",
			45.22
		],
		[
			"2009-03-16",
			24.91
		],
		[
			"2009-04-01",
			24.31
		],
		[
			"2009-10-06",
			18.12
		]
	],
	"278331427": [
		[
			"2010-10-05",
			0.5
		],
		[
			"2011-10-11",
			0.7
		],
		[
			"2012-10-09",
			0.5
		],
		[
			"2013-11-18",
			0.5
		],
		[
			"2014-10-17",
			0.5
		],
		[
			"2015-10-13",
			0.5
		],
		[
			"2000-12-01",
			0.5
		],
		[
			"2001-11-14",
			1.2
		],
		[
			"2006-11-10",
			0.5
		],
		[
			"2007-10-16",
			2.8
		],
		[
			"2008-10-17",
			0.5
		],
		[
			"2009-10-13",
			0.5
		]
	],
	"278345323": [
		[
			"2010-04-06",
			0.5
		],
		[
			"2010-11-03",
			0.5
		],
		[
			"2011-05-03",
			0.5
		],
		[
			"2011-12-21",
			0.5
		],
		[
			"2012-04-27",
			1.1
		],
		[
			"2012-10-22",
			0.5
		],
		[
			"2013-04-24",
			0.5
		],
		[
			"2013-11-27",
			0.5
		],
		[
			"2014-04-24",
			0.5
		],
		[
			"2014-10-22",
			0.5
		],
		[
			"2015-03-23",
			0.5
		],
		[
			"2015-10-27",
			0.5
		],
		[
			"2004-05-13",
			0.5
		],
		[
			"2000-12-06",
			0.5
		],
		[
			"2000-05-18",
			1
		],
		[
			"2001-11-13",
			0.5
		],
		[
			"2001-06-08",
			0.5
		],
		[
			"2002-11-18",
			2
		],
		[
			"2002-05-08",
			0.5
		],
		[
			"2003-11-04",
			0.5
		],
		[
			"2003-05-13",
			0.5
		],
		[
			"2004-10-25",
			0.5
		],
		[
			"2005-04-13",
			0.5
		],
		[
			"2005-10-06",
			0.5
		],
		[
			"2006-05-18",
			0.5
		],
		[
			"2006-10-25",
			2.4
		],
		[
			"2007-04-26",
			2.8
		],
		[
			"2007-10-09",
			0.5
		],
		[
			"2008-04-02",
			0.5
		],
		[
			"2008-10-28",
			0.5
		],
		[
			"2009-04-30",
			0.5
		],
		[
			"2009-11-09",
			0.5
		]
	],
	"278346613": [
		[
			"2010-04-09",
			0.6
		],
		[
			"2010-10-05",
			0.6
		],
		[
			"2011-05-16",
			0.5
		],
		[
			"2011-10-11",
			0.5
		],
		[
			"2012-04-16",
			0.6
		],
		[
			"2012-10-09",
			0.8
		],
		[
			"2013-04-11",
			3.6
		],
		[
			"2013-10-22",
			0.5
		],
		[
			"2014-04-25",
			1
		],
		[
			"2014-10-17",
			0.8
		],
		[
			"2015-04-01",
			0.8
		],
		[
			"2015-10-13",
			0.5
		],
		[
			"2004-01-05",
			0.5
		],
		[
			"2004-05-14",
			0.5
		],
		[
			"2004-12-17",
			0.5
		],
		[
			"2000-12-07",
			0.5
		],
		[
			"2001-11-19",
			0.5
		],
		[
			"2001-06-08",
			0.7
		],
		[
			"2002-11-22",
			0.5
		],
		[
			"2002-04-30",
			0.5
		],
		[
			"2003-05-23",
			0.5
		],
		[
			"2005-06-07",
			0.5
		],
		[
			"2005-11-22",
			0.5
		],
		[
			"2006-04-21",
			0.5
		],
		[
			"2006-11-14",
			0.5
		],
		[
			"2007-05-14",
			0.5
		],
		[
			"2007-10-16",
			0.5
		],
		[
			"2008-04-23",
			0.5
		],
		[
			"2008-10-17",
			0.5
		],
		[
			"2009-04-17",
			0.5
		],
		[
			"2009-10-13",
			0.5
		]
	],
	"278506616": [
		[
			"2011-10-10",
			0.5
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-10-09",
			0.5
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-15",
			0.5
		],
		[
			"2013-10-09",
			1.33
		],
		[
			"2014-10-08",
			1.33
		],
		[
			"2015-10-15",
			1.33
		],
		[
			"2009-10-16",
			2.21
		],
		[
			"2010-10-04",
			1.33
		],
		[
			"2011-10-10",
			0.44
		],
		[
			"2012-10-10",
			1.33
		]
	],
	"278534910": [
		[
			"2010-10-04",
			0.5
		],
		[
			"2011-10-10",
			0.5
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-10-09",
			0.5
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-15",
			0.5
		],
		[
			"2013-10-09",
			1.33
		],
		[
			"2014-10-08",
			1.33
		],
		[
			"2015-10-15",
			1.33
		],
		[
			"2000-10-24",
			0.5
		],
		[
			"2001-08-09",
			0.5
		],
		[
			"2002-09-19",
			0.5
		],
		[
			"2003-10-20",
			0.5
		],
		[
			"2004-08-10",
			0.5
		],
		[
			"2005-08-04",
			0.5
		],
		[
			"2006-07-28",
			0.5
		],
		[
			"2007-10-19",
			0.5
		],
		[
			"2008-10-13",
			0.5
		],
		[
			"2009-10-12",
			0.5
		],
		[
			"2009-10-16",
			2.21
		],
		[
			"2010-10-04",
			1.33
		],
		[
			"2011-10-10",
			0.66
		],
		[
			"2012-10-10",
			1.33
		]
	],
	"278536610": [
		[
			"2010-10-04",
			9
		],
		[
			"2011-10-10",
			1.8
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-10-09",
			1
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-15",
			0.5
		],
		[
			"2013-10-09",
			1.33
		],
		[
			"2014-10-08",
			3.54
		],
		[
			"2015-10-15",
			1.33
		],
		[
			"2000-10-24",
			0.8
		],
		[
			"2001-08-29",
			0.5
		],
		[
			"2009-10-16",
			2.21
		],
		[
			"2010-10-04",
			8.86
		],
		[
			"2011-10-10",
			1.28
		],
		[
			"2012-10-10",
			1.33
		]
	],
	"278540910": [
		[
			"2010-10-04",
			0.5
		],
		[
			"2011-10-10",
			0.5
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-10-10",
			0.5
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-12",
			2.3
		],
		[
			"2000-08-10",
			0.5
		],
		[
			"2001-08-10",
			5
		],
		[
			"2002-07-09",
			5
		],
		[
			"2003-08-06",
			1.6
		],
		[
			"2004-08-03",
			0.5
		],
		[
			"2005-08-01",
			0.5
		],
		[
			"2006-07-31",
			0.5
		],
		[
			"2007-10-15",
			0.5
		],
		[
			"2008-11-21",
			4.6
		],
		[
			"2009-09-12",
			0.5
		]
	],
	"278541010": [
		[
			"2010-10-04",
			0.5
		],
		[
			"2011-10-10",
			0.5
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-06-10",
			0.5
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-12",
			0.5
		],
		[
			"2000-08-10",
			0.5
		],
		[
			"2001-08-08",
			5
		],
		[
			"2002-08-06",
			5
		],
		[
			"2003-08-07",
			0.5
		],
		[
			"2004-08-03",
			0.5
		],
		[
			"2005-08-01",
			0.5
		],
		[
			"2006-07-31",
			0.5
		],
		[
			"2007-10-15",
			0.5
		],
		[
			"2008-11-05",
			0.2
		],
		[
			"2008-10-13",
			0.5
		],
		[
			"2009-09-12",
			0.5
		]
	],
	"278543418": [
		[
			"2010-10-04",
			0.5
		],
		[
			"2011-10-10",
			0.5
		],
		[
			"2012-10-10",
			0.5
		],
		[
			"2013-10-11",
			0.5
		],
		[
			"2014-10-08",
			0.5
		],
		[
			"2015-10-13",
			0.5
		],
		[
			"2000-10-09",
			1.4
		],
		[
			"2001-08-10",
			10
		],
		[
			"2002-07-22",
			5
		],
		[
			"2003-08-06",
			1.5
		],
		[
			"2004-08-04",
			0.5
		],
		[
			"2005-08-02",
			0.5
		],
		[
			"2006-08-01",
			0.5
		],
		[
			"2007-10-15",
			0.5
		],
		[
			"2008-11-05",
			0.2
		],
		[
			"2008-11-06",
			0.5
		]
	],
	"278766511": [
		[
			"2010-10-05",
			1.6
		],
		[
			"2011-10-11",
			1.2
		],
		[
			"2012-10-09",
			0.5
		],
		[
			"2013-11-12",
			0.9
		],
		[
			"2014-10-17",
			1.1
		],
		[
			"2015-10-13",
			1.7
		]
	],
	"279371810": [
		[
			"2010-07-22",
			57.13
		],
		[
			"2011-09-19",
			56.68
		],
		[
			"2012-03-13",
			55.36
		],
		[
			"2014-06-25",
			49.6
		],
		[
			"2015-06-05",
			53.14
		],
		[
			"2000-07-20",
			63.32
		],
		[
			"2001-02-09",
			71.73
		],
		[
			"2002-05-31",
			76.63
		],
		[
			"2003-01-31",
			66.02
		],
		[
			"2004-02-11",
			60.22
		],
		[
			"2005-03-21",
			65.12
		],
		[
			"2006-03-08",
			66.82
		],
		[
			"2007-09-07",
			68.22
		],
		[
			"2008-04-22",
			67.72
		],
		[
			"2008-06-16",
			69.12
		],
		[
			"2008-11-07",
			65.52
		]
	],
	"279375610": [
		[
			"2010-07-28",
			5.84
		],
		[
			"2011-09-20",
			9.74
		],
		[
			"2012-03-20",
			8.46
		],
		[
			"2013-05-13",
			8.94
		],
		[
			"2014-06-30",
			6.68
		],
		[
			"2015-06-19",
			7.22
		],
		[
			"2000-08-09",
			14.44
		],
		[
			"2001-07-23",
			21.88
		],
		[
			"2002-08-15",
			17.67
		],
		[
			"2003-09-22",
			11.16
		],
		[
			"2004-07-16",
			7.57
		],
		[
			"2005-08-04",
			12.18
		],
		[
			"2006-10-25",
			12.36
		],
		[
			"2007-09-07",
			12.1
		],
		[
			"2008-06-18",
			11.7
		],
		[
			"2008-11-07",
			9.9
		],
		[
			"2009-04-30",
			8.3
		],
		[
			"2010-06-08",
			6.51
		]
	],
	"279470617": [
		[
			"2010-12-16",
			108.5
		],
		[
			"2011-07-05",
			107.17
		],
		[
			"2012-07-19",
			86.35
		],
		[
			"2013-06-20",
			90.78
		],
		[
			"2014-05-22",
			93.44
		],
		[
			"2014-06-24",
			97.42
		],
		[
			"2015-06-23",
			113.37
		],
		[
			"2000-09-05",
			104.04
		],
		[
			"2001-10-01",
			124.44
		],
		[
			"2002-07-31",
			116.04
		],
		[
			"2003-09-29",
			86.33
		],
		[
			"2004-03-31",
			82.33
		],
		[
			"2005-05-03",
			99.24
		],
		[
			"2007-11-13",
			109.34
		],
		[
			"2008-05-29",
			139.45
		],
		[
			"2008-10-07",
			146.15
		],
		[
			"2009-04-16",
			139.45
		]
	],
	"279480015": [
		[
			"2012-07-24",
			69.52
		],
		[
			"2013-06-05",
			78.38
		],
		[
			"2014-10-07",
			74.4
		],
		[
			"2015-12-11",
			73.07
		],
		[
			"2003-05-13",
			67.32
		],
		[
			"2003-09-17",
			65.12
		],
		[
			"2004-03-16",
			64.62
		],
		[
			"2004-10-05",
			64.62
		],
		[
			"2005-04-07",
			62.42
		],
		[
			"2005-08-30",
			64.62
		],
		[
			"2006-03-14",
			62.02
		],
		[
			"2006-09-07",
			65.52
		],
		[
			"2006-12-13",
			62.42
		],
		[
			"2007-01-25",
			66.02
		],
		[
			"2008-06-24",
			64.22
		],
		[
			"2009-02-12",
			66.02
		]
	],
	"279483910": [
		[
			"2012-07-25",
			44.73
		],
		[
			"2013-12-19",
			42.29
		],
		[
			"2014-07-22",
			38.26
		],
		[
			"2015-12-16",
			37.81
		],
		[
			"2000-04-20",
			40.51
		],
		[
			"2000-10-17",
			25.11
		],
		[
			"2001-02-28",
			37.11
		],
		[
			"2001-11-27",
			47.42
		],
		[
			"2002-06-20",
			42.82
		],
		[
			"2002-10-18",
			41.41
		],
		[
			"2003-06-13",
			45.62
		],
		[
			"2003-11-07",
			49.62
		],
		[
			"2004-04-21",
			47.42
		],
		[
			"2004-11-04",
			45.62
		],
		[
			"2005-05-18",
			44.32
		],
		[
			"2005-11-23",
			47.42
		],
		[
			"2007-09-21",
			47.82
		],
		[
			"2008-06-03",
			49.62
		],
		[
			"2008-09-25",
			49.12
		],
		[
			"2009-03-23",
			41.01
		]
	],
	"288066613": [
		[
			"2012-11-16",
			37.77
		],
		[
			"2013-07-15",
			38.7
		],
		[
			"2014-03-20",
			33.61
		],
		[
			"2015-05-04",
			22.1
		],
		[
			"2007-12-05",
			29.01
		],
		[
			"2008-06-27",
			33.31
		],
		[
			"2010-01-26",
			35.34
		],
		[
			"2003-04-04",
			32.71
		],
		[
			"2003-08-27",
			35.51
		],
		[
			"2004-04-08",
			41.51
		],
		[
			"2004-09-08",
			42.42
		],
		[
			"2005-03-18",
			40.41
		],
		[
			"2005-09-14",
			37.31
		],
		[
			"2006-02-06",
			30.71
		],
		[
			"2006-09-25",
			28.11
		],
		[
			"2007-04-25",
			25.51
		]
	],
	"288067411": [
		[
			"2010-08-05",
			2.12
		],
		[
			"2011-02-09",
			1.77
		],
		[
			"2012-01-24",
			0.2
		],
		[
			"2013-03-04",
			0.2
		],
		[
			"2014-02-25",
			0.2
		],
		[
			"2015-01-26",
			0.89
		],
		[
			"2007-11-26",
			50.02
		],
		[
			"2008-07-08",
			38.61
		],
		[
			"2008-09-09",
			26.71
		],
		[
			"2009-07-29",
			9.2
		],
		[
			"2003-03-21",
			44.22
		],
		[
			"2003-07-30",
			34.21
		],
		[
			"2004-01-12",
			46.02
		],
		[
			"2004-07-30",
			54.92
		],
		[
			"2005-02-15",
			32.11
		],
		[
			"2005-06-22",
			27.31
		],
		[
			"2006-02-14",
			26.31
		],
		[
			"2006-09-21",
			24.01
		],
		[
			"2007-01-12",
			42.92
		]
	],
	"288193416": [
		[
			"2010-10-05",
			10.4
		],
		[
			"2011-10-11",
			10.6
		],
		[
			"2012-10-09",
			7.3
		],
		[
			"2013-10-08",
			9.6
		],
		[
			"2014-10-14",
			6.5
		],
		[
			"2015-10-16",
			13.1
		],
		[
			"2014-12-16",
			7.04
		],
		[
			"2000-03-28",
			15.41
		],
		[
			"2000-09-14",
			14.81
		],
		[
			"2001-02-20",
			12.6
		],
		[
			"2001-08-02",
			22.81
		],
		[
			"2002-01-09",
			17.11
		],
		[
			"2002-07-26",
			20.41
		],
		[
			"2003-02-05",
			21.01
		],
		[
			"2003-07-17",
			27.81
		],
		[
			"2004-02-04",
			22.51
		],
		[
			"2004-08-19",
			17.81
		],
		[
			"2005-03-03",
			15.01
		],
		[
			"2005-08-25",
			12.4
		],
		[
			"2006-03-09",
			9.4
		],
		[
			"2008-11-10",
			7.13
		]
	],
	"288194214": [
		[
			"2010-10-05",
			68.12
		],
		[
			"2011-10-11",
			22.01
		],
		[
			"2012-10-09",
			67.12
		],
		[
			"2013-10-08",
			65.52
		],
		[
			"2014-10-14",
			63.12
		],
		[
			"2015-10-16",
			72.03
		],
		[
			"2000-03-17",
			87.23
		],
		[
			"2001-08-22",
			67.72
		],
		[
			"2002-01-10",
			67.72
		],
		[
			"2003-03-11",
			69.12
		],
		[
			"2004-02-04",
			59.32
		],
		[
			"2005-08-03",
			64.62
		],
		[
			"2006-03-09",
			59.82
		],
		[
			"2008-11-10",
			60.67
		]
	],
	"288194317": [
		[
			"2010-10-05",
			23.81
		],
		[
			"2011-05-11",
			19.89
		],
		[
			"2011-10-11",
			50.92
		],
		[
			"2012-10-09",
			19.51
		],
		[
			"2013-04-16",
			12.31
		],
		[
			"2013-10-08",
			6.7
		],
		[
			"2014-03-13",
			8.46
		],
		[
			"2014-10-14",
			5.4
		],
		[
			"2015-06-22",
			7.17
		],
		[
			"2015-10-16",
			2.8
		],
		[
			"2008-04-18",
			17.51
		],
		[
			"2008-09-18",
			23.71
		],
		[
			"2009-03-18",
			13.4
		],
		[
			"2010-01-25",
			15.42
		],
		[
			"2003-01-17",
			24.21
		],
		[
			"2003-07-15",
			30.91
		],
		[
			"2004-02-16",
			28.51
		],
		[
			"2004-08-17",
			34.71
		],
		[
			"2005-02-21",
			24.81
		],
		[
			"2005-07-21",
			26.21
		],
		[
			"2006-02-13",
			22.51
		],
		[
			"2006-09-20",
			29.41
		],
		[
			"2007-01-16",
			27.51
		],
		[
			"2007-08-21",
			23.91
		],
		[
			"2008-11-10",
			24.49
		]
	],
	"289077217": [
		[
			"2012-04-16",
			54.91
		],
		[
			"2013-04-23",
			45.17
		],
		[
			"2014-07-03",
			36.97
		],
		[
			"2015-07-30",
			44.29
		],
		[
			"2008-06-23",
			52.22
		],
		[
			"2008-11-11",
			51.42
		],
		[
			"2009-04-29",
			47.42
		],
		[
			"2010-02-25",
			35.03
		],
		[
			"2003-03-07",
			38.21
		],
		[
			"2003-10-07",
			32.41
		],
		[
			"2004-02-26",
			28.31
		],
		[
			"2004-11-08",
			23.91
		],
		[
			"2005-06-01",
			29.21
		],
		[
			"2005-09-22",
			31.91
		],
		[
			"2006-02-16",
			38.11
		],
		[
			"2007-01-22",
			49.12
		],
		[
			"2007-09-05",
			51.42
		]
	],
	"289079512": [
		[
			"2011-08-04",
			36.84
		],
		[
			"2012-10-08",
			81.93
		],
		[
			"2013-06-18",
			84.14
		],
		[
			"2014-03-17",
			47.83
		],
		[
			"2015-04-30",
			54.03
		],
		[
			"2007-11-09",
			55.32
		],
		[
			"2008-09-08",
			37.81
		],
		[
			"2009-06-03",
			37.31
		],
		[
			"2009-06-05",
			37.11
		],
		[
			"2010-01-28",
			53.14
		],
		[
			"2000-03-14",
			46.02
		],
		[
			"2000-09-19",
			48.72
		],
		[
			"2001-05-16",
			46.92
		],
		[
			"2001-09-12",
			46.92
		],
		[
			"2001-10-23",
			46.52
		],
		[
			"2002-02-21",
			47.42
		],
		[
			"2002-09-10",
			48.72
		],
		[
			"2003-05-13",
			47.82
		],
		[
			"2005-04-11",
			43.92
		],
		[
			"2005-09-15",
			46.02
		],
		[
			"2006-02-20",
			45.62
		],
		[
			"2006-09-26",
			50.52
		],
		[
			"2007-01-12",
			54.92
		]
	],
	"289086516": [
		[
			"2010-07-27",
			104.07
		],
		[
			"2012-02-27",
			110.71
		],
		[
			"2013-04-09",
			111.6
		],
		[
			"2014-02-11",
			110.71
		],
		[
			"2015-02-26",
			112.48
		],
		[
			"2015-03-24",
			110.27
		],
		[
			"2015-11-16",
			112.92
		],
		[
			"2007-11-27",
			99.24
		],
		[
			"2008-05-21",
			110.74
		],
		[
			"2008-09-09",
			109.84
		],
		[
			"2009-07-22",
			108.04
		],
		[
			"2000-02-23",
			113.84
		],
		[
			"2000-08-23",
			130.65
		],
		[
			"2001-04-25",
			128.45
		],
		[
			"2001-10-23",
			137.25
		],
		[
			"2002-03-05",
			139.45
		],
		[
			"2002-08-27",
			134.65
		],
		[
			"2003-03-20",
			127.05
		],
		[
			"2003-07-30",
			111.64
		],
		[
			"2004-01-14",
			120.44
		],
		[
			"2004-07-29",
			126.64
		],
		[
			"2005-03-08",
			112.04
		],
		[
			"2005-07-26",
			121.74
		],
		[
			"2006-03-14",
			119.14
		],
		[
			"2006-09-05",
			116.94
		],
		[
			"2006-09-25",
			114.24
		],
		[
			"2007-01-12",
			118.24
		]
	],
	"289193515": [
		[
			"2012-10-16",
			18.38
		],
		[
			"2013-06-17",
			15.5
		],
		[
			"2014-03-17",
			10.05
		],
		[
			"2015-05-21",
			10.67
		],
		[
			"2007-11-09",
			20.61
		],
		[
			"2008-09-05",
			13.4
		],
		[
			"2009-06-03",
			14.31
		],
		[
			"2009-06-12",
			13.6
		],
		[
			"2000-01-14",
			66.42
		],
		[
			"2001-05-16",
			23.61
		],
		[
			"2001-09-19",
			63.72
		],
		[
			"2002-03-14",
			29.21
		],
		[
			"2002-09-10",
			40.11
		],
		[
			"2003-03-11",
			29.61
		],
		[
			"2003-07-16",
			57.12
		],
		[
			"2004-02-09",
			51.42
		],
		[
			"2004-09-03",
			21.61
		],
		[
			"2005-03-07",
			22.71
		],
		[
			"2005-08-19",
			32.71
		],
		[
			"2005-08-25",
			33.01
		],
		[
			"2006-03-08",
			37.21
		],
		[
			"2006-09-26",
			42.72
		],
		[
			"2006-12-06",
			44.72
		],
		[
			"2007-01-15",
			47.82
		]
	],
	"289194611": [
		[
			"2011-08-05",
			33.61
		],
		[
			"2012-10-16",
			28.34
		],
		[
			"2013-06-17",
			22.63
		],
		[
			"2014-03-17",
			27.1
		],
		[
			"2015-05-21",
			23.47
		],
		[
			"2007-10-23",
			26.51
		],
		[
			"2008-09-05",
			27.51
		],
		[
			"2009-05-29",
			32.91
		],
		[
			"2010-03-12",
			37.28
		],
		[
			"2000-03-20",
			35.91
		],
		[
			"2000-08-17",
			29.51
		],
		[
			"2001-05-17",
			29.41
		],
		[
			"2001-09-19",
			43.32
		],
		[
			"2002-03-14",
			34.41
		],
		[
			"2002-09-09",
			41.31
		],
		[
			"2003-02-05",
			36.91
		],
		[
			"2003-07-15",
			44.32
		],
		[
			"2004-02-09",
			37.51
		],
		[
			"2004-09-03",
			27.81
		],
		[
			"2005-03-07",
			24.11
		],
		[
			"2005-08-02",
			30.21
		],
		[
			"2006-03-08",
			28.31
		],
		[
			"2006-09-26",
			26.71
		],
		[
			"2007-01-15",
			29.11
		]
	],
	"289194714": [
		[
			"2010-04-29",
			27.15
		],
		[
			"2011-05-09",
			26.79
		],
		[
			"2012-11-14",
			32.5
		],
		[
			"2013-04-16",
			34.14
		],
		[
			"2014-03-06",
			31.71
		],
		[
			"2015-06-02",
			34.94
		],
		[
			"2007-10-23",
			23.51
		],
		[
			"2008-09-08",
			27.81
		],
		[
			"2009-05-25",
			26.41
		],
		[
			"2000-01-12",
			11.9
		],
		[
			"2000-07-11",
			28.41
		],
		[
			"2001-05-18",
			34.51
		],
		[
			"2001-09-26",
			49.62
		],
		[
			"2002-03-15",
			54.42
		],
		[
			"2002-09-10",
			31.71
		],
		[
			"2003-04-14",
			35.21
		],
		[
			"2003-08-21",
			32.31
		],
		[
			"2004-02-11",
			25.11
		],
		[
			"2004-09-06",
			26.51
		],
		[
			"2005-02-25",
			22.91
		],
		[
			"2005-07-26",
			20.51
		],
		[
			"2006-02-21",
			16.91
		],
		[
			"2006-09-28",
			19.61
		],
		[
			"2007-01-16",
			22.61
		]
	],
	"289194910": [
		[
			"2010-07-28",
			21.83
		],
		[
			"2013-06-24",
			28.87
		],
		[
			"2014-06-23",
			30.91
		],
		[
			"2015-05-18",
			29.32
		],
		[
			"2008-06-18",
			30.21
		],
		[
			"2008-11-12",
			26.21
		],
		[
			"2009-05-27",
			26.41
		],
		[
			"2000-02-11",
			32.51
		],
		[
			"2000-08-09",
			33.51
		],
		[
			"2001-02-08",
			30.41
		],
		[
			"2001-11-06",
			33.01
		],
		[
			"2002-05-22",
			32.41
		],
		[
			"2002-10-22",
			30.01
		],
		[
			"2003-03-18",
			27.51
		],
		[
			"2003-10-10",
			26.31
		],
		[
			"2004-03-16",
			25.41
		],
		[
			"2004-09-15",
			27.61
		],
		[
			"2005-03-23",
			25.51
		],
		[
			"2005-09-26",
			26.51
		],
		[
			"2006-03-07",
			24.11
		],
		[
			"2007-09-17",
			24.31
		]
	],
	"289195019": [
		[
			"2013-04-24",
			0.2
		],
		[
			"2014-07-03",
			0.2
		],
		[
			"2015-07-06",
			0.89
		],
		[
			"2007-09-05",
			0.2
		],
		[
			"2008-06-17",
			0.2
		],
		[
			"2008-11-11",
			0.2
		],
		[
			"2009-06-05",
			0.2
		]
	],
	"289195810": [
		[
			"2011-05-09",
			29.67
		],
		[
			"2012-11-14",
			34.63
		],
		[
			"2013-04-16",
			43.09
		],
		[
			"2014-03-17",
			33.39
		],
		[
			"2015-05-18",
			36.66
		],
		[
			"2008-04-18",
			50.92
		],
		[
			"2008-09-18",
			23.31
		],
		[
			"2009-03-18",
			59.32
		],
		[
			"2010-01-25",
			51.81
		],
		[
			"2000-01-06",
			58.42
		],
		[
			"2000-07-10",
			32.71
		],
		[
			"2001-01-03",
			49.12
		],
		[
			"2001-07-12",
			31.61
		],
		[
			"2002-01-25",
			53.12
		],
		[
			"2002-07-05",
			27.31
		],
		[
			"2003-01-30",
			49.62
		],
		[
			"2003-07-16",
			20.91
		],
		[
			"2004-03-12",
			37.21
		],
		[
			"2004-09-07",
			33.41
		],
		[
			"2005-02-22",
			49.62
		],
		[
			"2005-07-28",
			23.91
		],
		[
			"2006-02-16",
			35.51
		],
		[
			"2007-08-21",
			27.91
		]
	],
	"289196413": [
		[
			"2011-07-14",
			0.2
		],
		[
			"2013-04-17",
			0.2
		],
		[
			"2014-03-18",
			0.2
		],
		[
			"2015-05-18",
			0.89
		],
		[
			"2008-04-22",
			0.2
		],
		[
			"2008-09-19",
			0.2
		],
		[
			"2009-03-18",
			0.2
		],
		[
			"2002-04-09",
			0.2
		],
		[
			"2004-09-08",
			0.2
		],
		[
			"2005-07-27",
			0.2
		],
		[
			"2007-08-22",
			0.2
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/data/bullet-chart-history.json
// module id = 42
// module chunks = 0